/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 218);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(225);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Atom"]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["extras"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(253)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var CELL_STYLE=exports.CELL_STYLE=undefined;(function(CELL_STYLE){CELL_STYLE["TEXT"]="t";CELL_STYLE["HEADER"]="h";CELL_STYLE["SUBHEADER"]="sh";CELL_STYLE["COEFFICIENT"]="c";CELL_STYLE["COEFFICIENT_TEXT"]="ct";})(CELL_STYLE||(exports.CELL_STYLE=CELL_STYLE={}));var CELL_ALIGN=exports.CELL_ALIGN=undefined;(function(CELL_ALIGN){CELL_ALIGN["CENTER"]="c";CELL_ALIGN["LEFT"]="l";CELL_ALIGN["RIGHT"]="r";})(CELL_ALIGN||(exports.CELL_ALIGN=CELL_ALIGN={}));var COLUMN_WIDTH=exports.COLUMN_WIDTH=undefined;(function(COLUMN_WIDTH){COLUMN_WIDTH["MEDIUM"]="md";COLUMN_WIDTH["SMALL"]="sm";})(COLUMN_WIDTH||(exports.COLUMN_WIDTH=COLUMN_WIDTH={}));var SITE_TYPE=exports.SITE_TYPE=undefined;(function(SITE_TYPE){SITE_TYPE[SITE_TYPE["COM"]=0]="COM";SITE_TYPE[SITE_TYPE["CUPIS"]=1]="CUPIS";})(SITE_TYPE||(exports.SITE_TYPE=SITE_TYPE={}));var LOCK_STATE=exports.LOCK_STATE=undefined;(function(LOCK_STATE){LOCK_STATE[LOCK_STATE["UNBLOCKED"]=0]="UNBLOCKED";LOCK_STATE[LOCK_STATE["BLOCKED"]=1]="BLOCKED";})(LOCK_STATE||(exports.LOCK_STATE=LOCK_STATE={}));var STATE=exports.STATE=undefined;(function(STATE){STATE[STATE["ENABLED"]=1]="ENABLED";STATE[STATE["DISABLED"]=0]="DISABLED";})(STATE||(exports.STATE=STATE={}));var INFOGRAPHIC_INFO=exports.INFOGRAPHIC_INFO=undefined;(function(INFOGRAPHIC_INFO){INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["AVAILABLE"]=1]="AVAILABLE";INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["UNAVAILABLE"]=0]="UNAVAILABLE";})(INFOGRAPHIC_INFO||(exports.INFOGRAPHIC_INFO=INFOGRAPHIC_INFO={}));var CHANNEL_ACTION=exports.CHANNEL_ACTION=undefined;(function(CHANNEL_ACTION){CHANNEL_ACTION[CHANNEL_ACTION["SUBSCRIBE"]=0]="SUBSCRIBE";CHANNEL_ACTION[CHANNEL_ACTION["UNSUBSCRIBE"]=1]="UNSUBSCRIBE";})(CHANNEL_ACTION||(exports.CHANNEL_ACTION=CHANNEL_ACTION={}));/** Способ сортировки */var SORT_BY=exports.SORT_BY=undefined;(function(SORT_BY){/** По алфавиту */SORT_BY[SORT_BY["ALPHABET"]=1]="ALPHABET";/** По приоритету */SORT_BY[SORT_BY["PRIORITY"]=2]="PRIORITY";})(SORT_BY||(exports.SORT_BY=SORT_BY={}));var DATA_TYPE_CODE=exports.DATA_TYPE_CODE=undefined;(function(DATA_TYPE_CODE){/** Фиктивная информация о матче, код 1. Только для тестовых целей/отладки.*/DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_MATCH_INFO"]=1]="FALSE_MATCH_INFO";/** Фиктивная информация о балансе игрока, код 2. Только для тестовых целей/отладки.*/DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BALANCE_INFO"]=2]="FALSE_BALANCE_INFO";/** Фиктивная информация о рассчитанных ставках игрока, код 3. Только для тестовых целей/отладки. */DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BETS_INFO"]=3]="FALSE_BETS_INFO";/** Информация о матче, код 4.*/DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFO"]=4]="MATCH_INFO";/** Баланс интернет игрока, код 5.*/DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO"]=5]="BALANCE_INFO";/** Количество нерасчитанных ставок интернет игрока, код 6.*/DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT"]=6]="RAW_BETS_COUNT";/** Live-меню для сайта, полное, код 7.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_DATA"]=7]="LIVE_MENU_DATA";/** Live-меню для мобильной версии, упрощённое, код 8.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_MOBILE"]=8]="LIVE_MENU_MOBILE";/** Фильтр Live результатов, код 9.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS_FILTER"]=9]="LIVE_RESULTS_FILTER";/** Live результаты, код 10.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS"]=10]="LIVE_RESULTS";/** Табличная роспись Live матча для сайта, код 36 (см. Табличная роспись Live матча).*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE"]=36]="LIVE_OUTCOMES_TABLE";/** Табличная роспись Live матча для мобильной версии, код 12 (см. Табличная роспись Live матча).*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE_MOBILE"]=12]="LIVE_OUTCOMES_TABLE_MOBILE";/** Баланс ИРМ игрока, код 13.*/DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO_IRM"]=13]="BALANCE_INFO_IRM";/** Количество нерасчитанных ставок ИРМ игрока, код 14.*/DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT_IRM"]=14]="RAW_BETS_COUNT_IRM";/** Изменение данных интернет игрока, код 15. */DATA_TYPE_CODE[DATA_TYPE_CODE["UPDATING_INTERNET_PLAYER_DATA"]=15]="UPDATING_INTERNET_PLAYER_DATA";/** Live-матчи по спорту для мобильной версии, код 16 (см. MobileAppSportLiveMatches16.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT_MOBILE"]=16]="LIVE_MATCHES_BY_SPORT_MOBILE";/** Топ Live-матчи для мобильной версии, код 17 (см. MobileAppHotLiveMatches17.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP_MOBILE"]=17]="LIVE_MATCHES_BY_TOP_MOBILE";/** Live-матчи с видео для мобильной версии, код 18 (см. MobileAppLiveMatchesWithVideo18.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO_MOBILE"]=18]="LIVE_MATCHES_WITH_VIDEO_MOBILE";/** Live-матчи из избранного для мобильной версии, код 19 (см. MobileAppFavoriteLiveMatches19.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES_MOBILE"]=19]="LIVE_MATCHES_FAVORITES_MOBILE";/** Все Live-матчи для сайта, код 20 */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_ALL"]=20]="LIVE_MATCHES_ALL";/** Live-матчи по спорту для сайта, код 21 (см. WebSportLiveMatches21.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT"]=21]="LIVE_MATCHES_BY_SPORT";/** Live-матчи по чемпионату для сайта, код 22 (см. WebChampionshipLiveMatches22.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_CHAMPIONSHIP"]=22]="LIVE_MATCHES_BY_CHAMPIONSHIP";/** Топ Live-матчи для сайта, код 23 (см. WebHotLiveMatches23.ts) */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP"]=23]="LIVE_MATCHES_BY_TOP";/** Live-матчи с видео для сайта, код 24 (см. WebLiveMatchesWithVideo24.ts) */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO"]=24]="LIVE_MATCHES_WITH_VIDEO";/** Live-матчи из избранного для сайта, код 25 (см. WebFavoriteLiveMatches25.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES"]=25]="LIVE_MATCHES_FAVORITES";/** Табличная роспись Prematch матча для мобильной версии, код 27 (см. PrematchMatchMobileTableLine27.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LINE_OUTCOMES_TABLE_MOBILE"]=27]="LINE_OUTCOMES_TABLE_MOBILE";/** Один Live матч для сайта, код 38 (см. DesktopLiveMatchesSingleMatch38.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_SINGLE_MATCH"]=38]="LIVE_SINGLE_MATCH";/** Информация о ставках на продажу для интернет игрока, код 29 (см. InternetWagersForSell29.ts) */DATA_TYPE_CODE[DATA_TYPE_CODE["BETS_COUNT"]=29]="BETS_COUNT";/** Все prematch-матчи для сайта, код 31 (см. DesktopAllPrematchMatches31.ts)*/DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_ALL_MATCHES"]=31]="PREMATCH_ALL_MATCHES";/** Prematch-матчи по спорту для сайта, код 32 (см. DesktopSportPrematchMatches32.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_SPORT_MATCHES"]=32]="PREMATCH_SPORT_MATCHES";/** Информация об исходах для корзины для интернет игрока, код 65 (см. TerminalBetCartByBetType66.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART"]=65]="BET_CART";DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART_IRM"]=66]="BET_CART_IRM";DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART_FEATURES"]=67]="BET_CART_FEATURES";/** Табличная доп. роспись Prematch матча для сайта, код 37 (см. PrematchMatchDesktopTableLine37.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_MATCH_TABLE"]=37]="PREMATCH_MATCH_TABLE";//Один Prematch матч для сайта
DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_SINGLE_MATCH"]=39]="PREMATCH_SINGLE_MATCH";DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_MATCHES_MAIN_PAGE"]=40]="PREMATCH_MATCHES_MAIN_PAGE";/** Все популярные Prematch матчи для сайта, код 41 (см. DesktopAllPopularPrematchMatches41.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_ALL_POPULAR_MATCHES"]=41]="PREMATCH_ALL_POPULAR_MATCHES";/** Популярные Prematch матчи из одной группы популярного для сайта, код 43 (см. DesktopPopularGroupPrematchMatches43.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_POPULAR_GROUP"]=43]="PREMATCH_POPULAR_GROUP";/** Prematch-матчи по региону для сайта, код 50 (см. DesktopTournamentRegionPrematchMatches50.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_REGION_MATCHES"]=50]="PREMATCH_REGION_MATCHES";/** Prematch-матчи по доп. инфо турнира для сайта, код 52 */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_TOURNAMENTS_MATCHES"]=51]="PREMATCH_TOURNAMENTS_MATCHES";/** Prematch-матчи по доп. инфо турнира для сайта, код 52 */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_DOP_INFO"]=52]="PREMATCH_DOP_INFO";/** Prematch-матчи по доп. инфо региона для сайта */DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_REGION_DOP_INFO"]=53]="PREMATCH_REGION_DOP_INFO";/** Информация об инфографике 59 (см. InternetBetCart34.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFOGRAPHICS"]=59]="MATCH_INFOGRAPHICS";/** Информация о серверном времени (см. InternetBetCart34.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["SERVER_TIMESTAMP"]=60]="SERVER_TIMESTAMP";/** Лайв матч чемпионата мира по футболу десктоп 2022 (см. InternetBetCart34.ts). */// DEPRECATED WORLD_CHAMPIONSHIP = 62,
/** Евро 2024 таблицы итогов группового этапа. код 9. */DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_GROUP_STAGE_SUMMARY_TABLE"]=9]="EURO_2024_GROUP_STAGE_SUMMARY_TABLE";/** Евро 2024 таблицы итогов чемпионата. код 10. */DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_CHAMPIONSHIP_SUMMARY_TABLE"]=10]="EURO_2024_CHAMPIONSHIP_SUMMARY_TABLE";/** Евро 2024 сеткa группового этапа. код 62. */DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_GROUP_STAGE_GRID"]=62]="EURO_2024_GROUP_STAGE_GRID";/** Евро 2024 плейофф код 63. */DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_PLAYOFF"]=63]="EURO_2024_PLAYOFF";/* Счетчик ленты уведомлений */DATA_TYPE_CODE[DATA_TYPE_CODE["NOTIFICATION_COUNTER"]=61]="NOTIFICATION_COUNTER";/* Расширенный счет */DATA_TYPE_CODE[DATA_TYPE_CODE["EXTENDED_SCORE"]=68]="EXTENDED_SCORE";})(DATA_TYPE_CODE||(exports.DATA_TYPE_CODE=DATA_TYPE_CODE={}));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extras", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Atom", function() { return Atom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAtom", function() { return BaseAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStrict", function() { return useStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStrictModeEnabled", function() { return isStrictModeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asReference", function() { return asReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asFlat", function() { return asFlat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asStructure", function() { return asStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asMap", function() { return asMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModifierDescriptor", function() { return isModifierDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorunAsync", function() { return autorunAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whyRun", function() { return whyRun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /** @class */ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* harmony default export */ __webpack_exports__["default"] = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getQueryVariable=exports.isNumber=exports.getIdFromSlug=exports.dateTextFormat2=exports.dateTextFormat=exports.sprintf=exports.numberFormat=exports.isObject=exports.isJson=exports.getTime=exports.browser=exports.setStyle=exports.declOfNum=exports.replaceAll=exports.urlSlug=exports.slugify=undefined;var _arguments=arguments;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _dictStore=__webpack_require__(54);var _dictStore2=_interopRequireDefault(_dictStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var each=function each(object,callback){if(!isObject(object)&&typeof object.length!=='undefined'){for(var i=0,length=object.length;i<length;i++){var value=object[i];if(callback.call(value,i,value)===false)break;}}else{for(var name in object){if(!Object.prototype.hasOwnProperty.call(object,name))continue;if(callback.call(object[name],name,object[name])===false)break;}}return object;};var slugify=exports.slugify=function slugify(string){var a='àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';var b='aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';var p=new RegExp(a.split('').join('|'),'g');return string.toString().toLowerCase().replace(/\s+/g,'-')// Replace spaces with -
.replace(p,function(c){return b.charAt(a.indexOf(c));})// Replace special characters in a with b
.replace(/&/g,'-and-')// Replace & with ‘and’
.replace(/[^\w-]+/g,'')// Remove all non-word characters such as spaces or tabs
.replace(/--+/g,'-')// Replace multiple — with single -
.replace(/^-+/,'')// Trim — from start of text
.replace(/-+$/,'');// Trim — from end of text
};var urlSlug=exports.urlSlug=function urlSlug(id){var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if(!title)title='';return''+id+(title&&'_'+slugify(title));};var replaceAll=exports.replaceAll=function replaceAll(search,replace,str){while(str.search(search)!==-1){str=str.replace(search,replace);}return str;};var declOfNum=exports.declOfNum=function declOfNum(number,titles){var cases=[2,0,1,1,1,2];return titles[number%100>4&&number%100<20?2:cases[number%10<5?number%10:5]];};var setStyle=exports.setStyle=function setStyle(elem,name,value){elem=document.getElementById(elem);if(!elem)return;if((typeof name==='undefined'?'undefined':_typeof(name))=='object'){return each(name,function(k,v){setStyle(elem,k,v);});}if(name=='opacity'){if(browser.msie===true){if((value+'').length){if(value!==1){elem.style.filter='alpha(opacity='+value*100+')';}else{elem.style.filter='';}}else{elem.style.cssText=elem.style.cssText.replace(/filter\s*:[^;]*/gi,'');}elem.style.zoom=1;}elem.style.opacity=value;}else{try{var isN=typeof value=='number';if(isN&&/height|width/i.test(name)){value=Math.abs(value);}elem.style[name]=isN&&!/z-?index|font-?weight|opacity|zoom|line-?height/i.test(name)?value+'px':value;}catch(e){console.log('setStyle::error - ',[name,value]);}}};var browser=exports.browser=function browser(){var _ua=void 0;if(!window._ua){_ua=navigator.userAgent.toLowerCase();}return{version:(_ua.match(/.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([\d.]+)/)||[0,'0'])[1],opera:/opera/i.test(_ua)||/opr/i.test(_ua),msie:/msie/i.test(_ua)&&!/opera/i.test(_ua)||/trident\//i.test(_ua),msie6:/msie 6/i.test(_ua)&&!/opera/i.test(_ua),msie7:/msie 7/i.test(_ua)&&!/opera/i.test(_ua),msie8:/msie 8/i.test(_ua)&&!/opera/i.test(_ua),msie9:/msie 9/i.test(_ua)&&!/opera/i.test(_ua),mozilla:/firefox/i.test(_ua),chrome:/chrome/i.test(_ua),safari:!/chrome/i.test(_ua)&&/webkit|safari|khtml/i.test(_ua),iphone:/iphone/i.test(_ua),ipod:/ipod/i.test(_ua),iphone4:/iphone.*OS 4/i.test(_ua),ipod4:/ipod.*OS 4/i.test(_ua),ipad:/ipad/i.test(_ua),android:/android/i.test(_ua),bada:/bada/i.test(_ua),mobile:/iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(_ua),msie_mobile:/iemobile/i.test(_ua),safari_mobile:/iphone|ipod|ipad/i.test(_ua),opera_mobile:/opera mini|opera mobi/i.test(_ua),opera_mini:/opera mini/i.test(_ua),mac:/mac/i.test(_ua),windows:/windows/i.test(_ua),search_bot:/(yandex|google|stackrambler|aport|slurp|msnbot|bingbot|twitterbot|ia_archiver|facebookexternalhit)/i.test(_ua),da:/(da)/i.test(_ua)};};var getTime=exports.getTime=function getTime(){return Math.round(new Date().getTime()/1000);};var isJson=exports.isJson=function isJson(str){try{JSON.parse(str);}catch(e){return false;}return true;};var isObject=exports.isObject=function isObject(obj){return(typeof obj==='undefined'?'undefined':_typeof(obj))==="object"&&obj!==null;};var numberFormat=exports.numberFormat=function numberFormat(number,decimals,dec_point,thousands_sep){// * example 1: number_format(1234.56);
// * returns 1: '1,235'
// * example 2: number_format(1234.56, 2, ',', ' ');
// * returns 2: '1 234,56'
// * example 3: number_format(1234.5678, 2, '.', '');
// * returns 3: '1234.57'
var n=!isFinite(+number)?0:+number,prec=!isFinite(+decimals)?0:Math.abs(decimals),sep=typeof thousands_sep==='undefined'?'':thousands_sep,dec=typeof dec_point==='undefined'?'.':dec_point,s='',toFixedFix=function toFixedFix(n,prec){var k=Math.pow(10,prec);return''+Math.round(n*k)/k;};// Fix for IE parseFloat(0.55).toFixed(0) = 0;
s=(prec?toFixedFix(n,prec):''+Math.round(n)).split('.');if(s[0].length>3){s[0]=s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g,sep);}if((s[1]||'').length<prec){s[1]=s[1]||'';s[1]+=new Array(prec-s[1].length+1).join('0');}return s.join(dec);};var sprintf=exports.sprintf=function sprintf(){// Return a formatted string
var regex=/%%|%(\d+\$)?([\-+#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegEG])/g;var a=_arguments,i=0,format=a[i++];// pad()
var pad=function pad(str,len,chr,leftJustify){var padding=str.length>=len?'':new Array(1+len-str.length>>>0).join(chr);return leftJustify?str+padding:padding+str;};// justify()
var justify=function justify(value,prefix,leftJustify,minWidth,zeroPad){var diff=minWidth-value.length;if(diff>0){if(leftJustify||!zeroPad){value=pad(value,minWidth,' ',leftJustify);}else{value=value.slice(0,prefix.length)+pad('',diff,'0',true)+value.slice(prefix.length);}}return value;};// formatBaseX()
var formatBaseX=function formatBaseX(value,base,prefix,leftJustify,minWidth,precision,zeroPad){// Note: casts negative numbers to positive ones
var number=value>>>0;prefix=prefix&&number&&{'2':'0b','8':'0','16':'0x'}[base]||'';value=prefix+pad(number.toString(base),precision||0,'0',false);return justify(value,prefix,leftJustify,minWidth,zeroPad);};// formatString()
var formatString=function formatString(value,leftJustify,minWidth,precision,zeroPad){if(precision!==null){value=value.slice(0,precision);}return justify(value,'',leftJustify,minWidth,zeroPad);};// finalFormat()
var doFormat=function doFormat(substring,valueIndex,flags,minWidth,_,precision,type){if(substring==='%%'){return'%';}// parse flags
var leftJustify=false,positivePrefix='',zeroPad=false,prefixBaseX=false;for(var j=0;flags&&j<flags.length;j++){switch(flags.charAt(j)){case' ':positivePrefix=' ';break;case'+':positivePrefix='+';break;case'-':leftJustify=true;break;case'0':zeroPad=true;break;case'#':prefixBaseX=true;break;}}// parameters may be null, undefined, empty-string or real valued
// we want to ignore null, undefined and empty-string values
if(!minWidth){minWidth=0;}else if(minWidth==='*'){minWidth=+a[i++];}else if(minWidth.charAt(0)==='*'){minWidth=+a[minWidth.slice(1,-1)];}else{minWidth=+minWidth;}// Note: undocumented perl feature:
if(minWidth<0){minWidth=-minWidth;leftJustify=true;}if(!isFinite(minWidth)){throw new Error('sprintf: (minimum-)width must be finite');}if(!precision){precision='fFeE'.indexOf(type)>-1?6:type==='d'?0:void 0;}else if(precision==='*'){precision=+a[i++];}else if(precision.charAt(0)==='*'){precision=+a[precision.slice(1,-1)];}else{precision=+precision;}// grab value using valueIndex if required?
var value=valueIndex?a[valueIndex.slice(0,-1)]:a[i++],number,prefix;switch(type){case's':return formatString(String(value),leftJustify,minWidth,precision,zeroPad);case'c':return formatString(String.fromCharCode(+value),leftJustify,minWidth,precision,zeroPad);case'b':return formatBaseX(value,2,prefixBaseX,leftJustify,minWidth,precision,zeroPad);case'o':return formatBaseX(value,8,prefixBaseX,leftJustify,minWidth,precision,zeroPad);case'x':return formatBaseX(value,16,prefixBaseX,leftJustify,minWidth,precision,zeroPad);case'X':return formatBaseX(value,16,prefixBaseX,leftJustify,minWidth,precision,zeroPad).toUpperCase();case'u':return formatBaseX(value,10,prefixBaseX,leftJustify,minWidth,precision,zeroPad);case'i':case'd':{number=parseInt(+value,10);prefix=number<0?'-':positivePrefix;value=prefix+pad(String(Math.abs(number)),precision,'0',false);return justify(value,prefix,leftJustify,minWidth,zeroPad);}case'e':case'E':case'f':case'F':case'g':case'G':{number=+value;prefix=number<0?'-':positivePrefix;var method=['toExponential','toFixed','toPrecision']['efg'.indexOf(type.toLowerCase())];var textTransform=['toString','toUpperCase']['eEfFgG'.indexOf(type)%2];value=prefix+Math.abs(number)[method](precision);return justify(value,prefix,leftJustify,minWidth,zeroPad)[textTransform]();}default:return substring;}};return format.replace(regex,doFormat);};var dateTextFormat=exports.dateTextFormat=function dateTextFormat(date){var time=new Date(date),day=time.getDate(),month=time.getMonth()+1,minutes=time.getMinutes(),cur_date=new Date(),time_passed=(cur_date.getTime()-time.getTime())/1000,date_str=date,date_arr2=[],date_arr=[];minutes=minutes<10?'0'+minutes:minutes;if(isNaN(time.getTime())){}else if(time_passed<60){// 1 min
date_str=Math.floor(time_passed)+'|S_SEC|AGO';}else if(time_passed<3600){// 1 hour
date_str=Math.ceil(time_passed/60)+'|S_MIN|AGO';}else if(cur_date.getDate()-1===time.getDate()&&cur_date.getMonth()===time.getMonth()&&cur_date.getFullYear()===time.getFullYear()){// yesterday
date_str='S_YESTERDAY|IN|'+time.getHours()+':'+minutes;}else if(time_passed<86400){// 1 day
date_str=Math.ceil(time_passed/3600)+'|S_HOUR|AGO';}else if(time_passed<604800){// 7 days
date_str=Math.floor(time_passed/86400)+'|S_DAY|AGO';}else if(cur_date.getFullYear()===time.getFullYear()){date_str=day+'|S_MONTH'+month+'|IN|'+time.getHours()+':'+minutes;}else{date_str=time.getDate()+'|S_MONTH'+month+'|'+time.getFullYear();}if(date_str.length){date_arr=date_str.split('|');for(var i=0;i<date_arr.length;i++){date_arr2.push(_dictStore2.default.getLang(date_arr[i]));}return date_arr2.join(' ');}return date;};var dateTextFormat2=exports.dateTextFormat2=function dateTextFormat2(date){var time=new Date(date),day=time.getDate(),month=time.getMonth()+1,cur_date=new Date(),time_passed=(cur_date.getTime()-time.getTime())/1000,date_str=date,date_arr2=[],date_arr=[];if(isNaN(time.getTime())){}else if(time_passed<60){// 1 min
date_str=Math.floor(time_passed)+'|S_SEC|AGO';}else if(time_passed<3600){// 1 hour
date_str=Math.ceil(time_passed/60)+'|S_MIN|AGO';}else if(cur_date.getDate()-1===time.getDate()&&cur_date.getMonth()===time.getMonth()&&cur_date.getFullYear()===time.getFullYear()){// yesterday
date_str='S_YESTERDAY';}else if(cur_date.getDate()===time.getDate()&&cur_date.getMonth()===time.getMonth()&&cur_date.getFullYear()===time.getFullYear()){// yesterday
date_str='S_TODAY';}else if(cur_date.getFullYear()===time.getFullYear()){date_str=day+'|S_MONTH'+month;}else{date_str=time.getDate()+'|S_MONTH'+month+'|'+time.getFullYear();}if(date_str.length){date_arr=date_str.split('|');for(var i=0;i<date_arr.length;i++){date_arr2.push(_dictStore2.default.getLang(date_arr[i]));}return date_arr2.join(' ');}return date;};var getIdFromSlug=exports.getIdFromSlug=function getIdFromSlug(slug){if(!slug)return'';var id=slug.split('_')[0];return isNumber(id)?id:slug;};var isNumber=exports.isNumber=function isNumber(obj){return!Number.isNaN(Number(obj));};var getQueryVariable=exports.getQueryVariable=function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return false;};// export class dict {
//         this.reg_exp_ru = new RegExp('[[А-Яа-я]+');
//         var d = this;
//         window.dict = this;
//         window.getLang = function(key, replace) {
//             return d.get(key, replace);
//         }
//     };
//     z.fn.dict.prototype = {
//         constructor: z.fn.dict,
//         add : function (data) {
//             for(var i in data) {
//                 this[i] = data[i];
//             }
//         },
//         get : function(key, replace) {
//             var lang = '';
//             if (key === null || typeof key == 'string' && key.length == 0) {
//             }
//             else if (isset(this[key])) {
//                 lang = this[key];
//             }
//             else if (window.dict_data && window.dict_data[key]) {
//                 lang = window.dict_data[key];
//             }
//             else if (this.reg_exp_ru.test(key) === false) {
//                 lang = key.toString().toLowerCase().split('_').join(' ');
//                 if (lang.length) {
//                     lang = lang[0].toUpperCase() + lang.substr(1);
//                 }
//             } else {
//                 lang = key;
//             }
//             if (replace) {
//                 lang = this.replace(lang, replace);
//             }
//             return lang;
//         },
//         replace : function(text, opts) {
//             for(var i in opts) {
//                 text = text.replace('{' + i + '}', opts[i]);
//             }
//             return text;
//         }
//     };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _loadingSpinner=__webpack_require__(277);Object.defineProperty(exports,'default',{enumerable:true,get:function get(){return _interopRequireDefault(_loadingSpinner).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(59);var _regenerator2=_interopRequireDefault(_regenerator);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _axios=__webpack_require__(84);var _axios2=_interopRequireDefault(_axios);var _qs=__webpack_require__(96);var _qs2=_interopRequireDefault(_qs);var _common=__webpack_require__(6);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _mocData=__webpack_require__(626);var _mocData2=_interopRequireDefault(_mocData);var _uuid=__webpack_require__(627);var _getImprintHash=__webpack_require__(166);var _getImprintHash2=_interopRequireDefault(_getImprintHash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import superagentPromise from 'superagent-promise';
// import _superagent from 'superagent';
// import axiosCancel from 'axios-cancel';
// const superagent = superagentPromise(_superagent, global.Promise);
// axiosCancel(axios, {
//   debug: false // default
// });
var API_ROOT='';var terminalData={};if(false){API_ROOT='https://irm.dev.almara.org';// API_ROOT = 'http://pre.almara.org:8084';
// API_ROOT = 'http://1ng.almara.org:8083'
// API_ROOT = 'http://1ng.almara.org:8083'
// API_ROOT = process.env.APP_URL;
terminalData={session_id:process.env.TERMINAL.sess_id,terminal_id:process.env.TERMINAL.terminal_id,cashbox_id:process.env.TERMINAL.kass_id};}var handleErrors=function handleErrors(err){if(err&&err.response&&err.response.status===401){}return false;};var responseBody=function responseBody(res){if(res){if(res.data&&res.data.code=='TERMINAL'){_appStore2.default.clear('TERMINAL');}else if(res.data&&res.data.code=='ACCESS'){_appStore2.default.clear('ACCESS');}else{return res.data;}}return false;};// const tokenPlugin = req => {
//   if (commonStore.token) {
//     req.set('authorization', `Token ${commonStore.token}`);
//   }
// };
// const requests = {
//   del: url =>
//     superagent
//       .del(`${API_ROOT}${url}`)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   get: url =>
//     superagent
//       .get(`${API_ROOT}${url}`)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   put: (url, body) =>
//     superagent
//       .put(`${API_ROOT}${url}`, body)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   post: (url, body) =>
//     superagent
//       .post(`${API_ROOT}${url}`, body)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   stop: () =>
//     superagent
//       .end()
// };
var axiosClient=_axios2.default.create({withCredentials:true,headers:{'X-IRM-Version':1}});axiosClient.interceptors.request.use(function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(config){var imprint;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return _getImprintHash2.default.getInstance().imprint();case 3:imprint=_context.sent;config.headers['Imprinthash']=imprint;_context.next=10;break;case 7:_context.prev=7;_context.t0=_context['catch'](0);console.error('Failed to create imprintHash',_context.t0);case 10:return _context.abrupt('return',config);case 11:case'end':return _context.stop();}}},_callee,undefined,[[0,7]]);}));return function(_x){return _ref.apply(this,arguments);};}());var requests={// del: url =>
//   axios
//     .del(`${API_ROOT}${url}`)
//     // .use(tokenPlugin)
//     .end(handleErrors)
//     .then(responseBody),
get:function get(url,mode){return axiosClient.get(''+API_ROOT+url,{headers:{'X-Request-ID':(0,_uuid.v4)()}})// .use(tokenPlugin)
.catch(function(thrown){if(axiosClient.isCancel(thrown)){console.log('Request canceled',thrown.message);}else{handleErrors(thrown);}}).then(responseBody);},// put: (url, body) =>
//   axios
//     .put(`${API_ROOT}${url}`, body)
//     // .use(tokenPlugin)
//     .end(handleErrors)
//     .then(responseBody),
post:function post(url,body){return axiosClient.post(''+API_ROOT+url,_qs2.default.stringify(body),{headers:{'X-Request-ID':(0,_uuid.v4)()}})// .use(tokenPlugin)
.catch(handleErrors).then(responseBody);}// cancel: (mode) =>
//   axios.cancel()
};var terminal={login:function login(){return requests.get('/ajax/terminal/login?t');},check:function check(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:terminalData;return requests.get('/ajax/terminal/check?session_id='+data.session_id+'&terminal_id='+data.terminal_id+'&cashbox_id='+data.cashbox_id);},getMode:function getMode(data){return requests.get('/ajax/terminal/get_mode?cashbox_id='+data.cashbox_id);},getCurrency:function getCurrency(){return requests.get('/ajax/terminal/get_currency');}};var auth={login:function login(data){return requests.post('/ajax/login/auth',data);},loginCard:function loginCard(data){return requests.post('/ajax/login/card',data);},logout:function logout(hash){return requests.get('/ajax/login/logout?h='+hash);}};var data={get:function get(){return requests.get('/ajax/data/get');}};var html={get:function get(id){return requests.post('/ajax/html/get',id);}};var search={get:function get(str){return requests.get('/ajax/searchbox?str='+str);}};var checker={get:function get(){return requests.get('/terminal');}};var finance={getPayout:function getPayout(){return requests.get('/ajax/finance/payout_data');},createPayout:function createPayout(data){return requests.post('/ajax/finance/create_payout',data);},cancelPayout:function cancelPayout(data){return requests.post('/ajax/finance/cancel_payout',data);},checkPayout:function checkPayout(){return requests.get('/ajax/finance/check_payout');}};var user={get:function get(){return requests.get('/ajax/account/get');},getBalance:function getBalance(){return requests.get('/ajax/account/balance');},getAccountData:function getAccountData(){return requests.get('/ajax/account/get');},getHistoryData:function getHistoryData(){return requests.get('/ajax/account/history_data');},getHistory:function getHistory(data){return requests.post('/ajax/account/history',data);},setCancel:function setCancel(data){return requests.post('/ajax/payment/cancel',data);},getBetsData:function getBetsData(){return requests.get('/ajax/account/bets_data');},getBetsPeriodData:function getBetsPeriodData(){return requests.get('/ajax/account/bets_data_period');},getBets:function getBets(data){return requests.post('/ajax/account/bets_period',data);},savePass:function savePass(data){return requests.post('/ajax/account/change_psw',data);},setFastAmount:function setFastAmount(data){return requests.post('/ajax/fast_amount/set',data);},getCountBets:function getCountBets(){return requests.get('/ajax/account/count_bets');},//deprecated WEB-4944
sellBet:function sellBet(wagerId,amount){return requests.get('/ajax/sell_bet?wager_id='+wagerId+'&amount='+amount);}};var slides={getIrmBanners:function getIrmBanners(){return requests.get('/ajax/promo/get_irm_banners');}};var lineMenu={get:function get(_ref2){var _ref2$cashboxMode=_ref2.cashboxMode,cashboxMode=_ref2$cashboxMode===undefined?2:_ref2$cashboxMode;return requests.get('/ajax/line/get_menu'+(typeof cashboxMode!=='undefined'?'?cashbox_mode='+cashboxMode:''));}};var liveMenu={get:function get(_ref3){var _ref3$cashboxMode=_ref3.cashboxMode,cashboxMode=_ref3$cashboxMode===undefined?2:_ref3$cashboxMode;return requests.get('/ajax/live/favlist/'+(0,_common.getTime)()+(typeof cashboxMode!=='undefined'?'?cashbox_mode='+cashboxMode:''));},getFav:function getFav(){return requests.get('/ajax/live/getfav');},setFav:function setFav(data){return requests.post('/ajax/live/setfav',data);},getVideo:function getVideo(){return requests.get('/ajax/video/get_list');}};var lineResults={getFilter:function getFilter(){return requests.get('/ajax/results/get_data');},getResults:function getResults(data){return requests.get('/v1/matchesresults?'+_qs2.default.stringify(data));}};var liveResults={getFilter:function getFilter(){return requests.get('/ajax/results/get_data_live');},getResults:function getResults(data){return requests.post('/ajax/results/get_live?'+_qs2.default.stringify(data));}};var live={get:function get(ross,all,select,gid_ross,offset,length,timeline,cashboxMode){var games='';var gamesRoss='';var video=null;if(select.games&&select.games.length>0){games=select.games.join('-');}if(gid_ross.length>0){gamesRoss=_lodash2.default.intersectionWith(select.games,gid_ross,function(x,y){return x==y;}).join('-');}else{gamesRoss=gid_ross.join('-');}if(all){gamesRoss=gid_ross.join('-');}if(select.video){video=1;}var data={ross:ross,all:all,// lang_id,
// sort_mode,
// sport: sport || null,
// league: league || null,
onlyview:0,video:video||null,games:games||null,games_ross:gamesRoss||null,print_mode:'react',timezone:3,cashbox_mode:typeof cashboxMode!=='undefined'?cashboxMode:2};// return requests.get(`/ajax/live/react/${getTime()}?${Qs.stringify(data, { skipNulls: true })}`)
// requests.get(`/ajax/live/react/${getTime()}?${Qs.stringify(data, { skipNulls: true })}`).then(console.log)
return new Promise(function(resolve){resolve(_mocData2.default);});},getRoss:function getRoss(games){var showFromMain=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var gid='';if(games.length>0){gid=games.join('-');return requests.get('/ajax/live/react_ross/'+(0,_common.getTime)()+'?onlyview=0&gid='+gid+'&show_from_main='+showFromMain);}return false;},getData:function getData(){return requests.get('/ajax/live/get_data');},setData:function setData(data){return requests.post('/ajax/live/set_data',{live_data:data});},getSchedule:function getSchedule(){return requests.get('/ajax/live/get_schedule');},video:function video(gid,type){return requests.get('/ajax/video/get?gid='+gid+'&type='+type,{cancelable:true});}};/** @deprecated */var basket={get:function get(data,mode){return requests.post('/ajax/'+mode+'/load_bet',data);},set:function set(bet_data){return requests.post('/ajax/dobet',bet_data);},checkVip:function checkVip(data){return requests.post('/ajax/dobet/vipbet',{cards:data});},setOneClickAmount:function setOneClickAmount(amount){return requests.post('/ajax/oneclick/apply',{amount:amount});},getMax:function getMax(data){return requests.post('/ajax/line/get_max',data);}};var kafka={kafkaLog:function kafkaLog(log_data){return requests.post('/api/metrics/v1/log',log_data);}};var BasketAPI=function(){function BasketAPI(){var _ref4=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{is_mobile:false},is_mobile=_ref4.is_mobile;_classCallCheck(this,BasketAPI);this.mobile_data={info:is_mobile?1:0};}_createClass(BasketAPI,[{key:'getBet',value:function getBet(bets,mode){if(typeof bets==='string'||typeof bets==='number'){return requests.post('/ajax/'+mode+'/load_bet',_extends({bids:[bets]},this.mobile_data));}return requests.post('/ajax/'+mode+'/load_bet',_extends({bets:bets},this.mobile_data));}},{key:'getBets',value:function getBets(betIDs){var _this=this;var data=Object.entries(betIDs).map(function(_ref5){var _ref6=_slicedToArray(_ref5,2),mode=_ref6[0],bids=_ref6[1];return[mode,_extends({bids:bids},_this.mobile_data)];});return requests.post('/ajax/line/bet/load_bets',Object.fromEntries(data));}}]);return BasketAPI;}();var line={get:function get(ross,all,select,gid_ross,offset,length,timeline,cashboxMode){var games='';var league='';var sport='';var gamesRoss='';var popular_group='';if(select.games&&select.games.length>0){games=select.games.join('-');}if(!ross&&gid_ross.length>0){gamesRoss=_lodash2.default.intersection(select.games,gid_ross).join('-');}if(select.league&&select.league.length>0){league=select.league.join('-');}if(select.sport&&select.sport.length>0){sport=select.sport.join('-');}if(select.popular_group&&select.popular_group.length>0){popular_group=select.popular_group.join('-');}if(!games&&!league&&!sport)all=1;if(select.type==1){games='';}return requests.get('/ajax/line/react?all='+all+'&onlyview=0&timeline='+timeline+'&sport='+sport+'&league='+league+'&games='+games+'&ross='+ross+'&popular_group='+(popular_group?popular_group:'')+(gamesRoss?'&games_ross='+gamesRoss:'')+(offset>=0?'&offset='+offset:'')+(length?'&length='+length:'')+'&print_mode=react&timezone=3'+(typeof cashboxMode!=='undefined'?'&cashbox_mode='+cashboxMode:''));},getRoss:function getRoss(games){var showFromMain=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var gid='';if(games.length>0){gid=games.join('-');return requests.get('/ajax/line/react_ross/?onlyview=0&gid='+gid+'&show_from_main='+showFromMain);}return Promise.resolve({});},getData:function getData(){return requests.get('/ajax/line/get_data');},setData:function setData(data){return requests.post('/ajax/line/set_data',{line_data:data});}};var toto={getData:function getData(){return requests.get('/ajax/toto/get_data');},doBet:function doBet(data){return requests.post('/ajax/toto/dobet',data);},getBet:function getBet(id){return requests.post('/ajax/toto/get_bet',{id:id});},getResult:function getResult(id){return requests.get('/ajax/toto/get_result?id='+id);},getCards:function getCards(data){return requests.post('/ajax/toto/cards',data);},getPrevious:function getPrevious(){return requests.get('/ajax/toto/get_previous');},getCardsAll:function getCardsAll(data){return requests.post('/ajax/toto/get_cards_all',data);},getCardsPage:function getCardsPage(data){return requests.post('/ajax/toto/cards_all',data);}};exports.default={BasketAPI:BasketAPI,slides:slides,lineMenu:lineMenu,live:live,liveMenu:liveMenu,line:line,auth:auth,finance:finance,terminal:terminal,data:data,user:user,basket:basket,lineResults:lineResults,liveResults:liveResults,checker:checker,search:search,toto:toto,html:html,kafka:kafka};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(273);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(275);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(276);

var _HelmetConstants = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(55)(module)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BaseSocketConnector=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _WSS=__webpack_require__(311);var _XHR=__webpack_require__(312);var _base=__webpack_require__(4);var _lib=__webpack_require__(12);var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _Axios=__webpack_require__(146);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RECONNECT_INTERVAL_MS=3000;/**
 * @class
 * @abstract
 * Предназначен для подключения экземпляров {@link BaseSocketListener}
 *  - содержит общую информацию для подключения (тип данных, тип сайта, временная зона, язык)
 *  - управляет переподпиской упавших сокетов, очередностью их подключения
 */var BaseSocketConnector=exports.BaseSocketConnector=function(){function BaseSocketConnector(outcomeData){var SocketListenersPriority=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[_WSS.WSSocketListener,_XHR.XHRSocketListener];_classCallCheck(this,BaseSocketConnector);this.siteType=_base.SITE_TYPE.COM;this.socketListener=null;this.timezone=0;this.language=0;this.isConnectionSelfClosable=false;this.jwtProvider=null;this.timezone=(outcomeData===null||outcomeData===void 0?void 0:outcomeData.timezone)||this.timezone;this.siteType=(outcomeData===null||outcomeData===void 0?void 0:outcomeData.site)||this.siteType;this.language=(outcomeData===null||outcomeData===void 0?void 0:outcomeData.lng)||this.language;this.socketListenersQueue=new _lib.Queue(SocketListenersPriority);}/**
     * Установка источника для JWT
     * @param jwtProvider
     */_createClass(BaseSocketConnector,[{key:'setJwtProvider',value:function setJwtProvider(jwtProvider){this.jwtProvider=jwtProvider;}/**
     * Установка языка
     * @param language
     */},{key:'setLanguage',value:function setLanguage(language){this.language=language;}/**
     * Подписка на получение данных
     * @param cfg
     */},{key:'subscribe',value:function subscribe(cfg){var _this=this;var logger=_logger2.default.getInstance();if(!this.socketListener){this.createSocketListener(cfg.onerror);}if(!this.socketListener||!this.createMessage(cfg).d){this.resubscribe(cfg,RECONNECT_INTERVAL_MS);/** больше нет сокетов для подключения */cfg.onclose&&cfg.onclose();return;}var _onerror=function _onerror(e){cfg.onerror&&cfg.onerror(new Error(_this.constructor.name+': '+(e instanceof Error?e.message:e.type)));_this.unsubscribe(Object.assign({},cfg),'onerror').then(function(){// this.socketListenersQueue.next();
// this.createSocketListener(cfg.onerror);
// this.subscribe(cfg);
_this.resubscribe(cfg,RECONNECT_INTERVAL_MS);});};this.socketListener.subscribe(this.createMessage(cfg),{onmessage:function onmessage(msg){var _a;var response=JSON.parse(msg.data);if(response.t!==_this.dataTypeCode){return;}if(response.d&&Object.prototype.hasOwnProperty.call(response.d,"error")){cfg.onerror&&cfg.onerror(new Error((_a=response.d)===null||_a===void 0?void 0:_a.error));}else{cfg.onmessage&&cfg.onmessage(response.d);}},onopen:function onopen(e){logger.log(_this.constructor.name+': '+e.type);cfg.onopen&&cfg.onopen(e);},onclose:function onclose(e){logger.log(_this.constructor.name+': '+e.type);if(_this.isConnectionSelfClosable)return;_onerror(e);},onerror:function onerror(e){logger.error(new Error(this.constructor.name+': '+(e instanceof Error?e.message:e.type)));_onerror(e);}});}/**
     * Отписка от получения данных
     * @param cfg
     */},{key:'unsubscribe',value:function unsubscribe(_ref,target){var s_id=_ref.subscriptionID;clearTimeout(this.resubscribeTimeout);if(!target){_Axios.subscriptions.remove(this.dataTypeCode);}return this.socketListener?this.socketListener.unsubscribe({t:this.dataTypeCode,op:_base.CHANNEL_ACTION.UNSUBSCRIBE,s_id:s_id},target):Promise.resolve();}/**
     * Отложенная переподписка с приоритетного сокета
     * @param cfg
     * @param delay задержка в мс
     */},{key:'resubscribe',value:function resubscribe(cfg){var _this2=this;var delay=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.resubscribeTimeout=window.setTimeout(function(){var logger=_logger2.default.getInstance();_this2.socketListenersQueue.reset();_this2.createSocketListener(logger.error);logger.log('['+_this2.socketListener+'] \u041F\u043E\u043F\u044B\u0442\u043A\u0430 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435');_this2.subscribe(cfg);},delay);}},{key:'createMessage',value:function createMessage(cfg){return{d:this.getOutcomeData(cfg),t:this.dataTypeCode,op:_base.CHANNEL_ACTION.SUBSCRIBE,s_id:cfg.subscriptionID};}},{key:'createSocketListener',value:function createSocketListener(onerror){try{this.socketListener=this.socketListenersQueue.current||null;}catch(e){onerror&&onerror(e);this.socketListenersQueue.next();this.createSocketListener(onerror);}}},{key:'send',value:function send(s,target){var _a,_b;(_b=(_a=this===null||this===void 0?void 0:this.socketListener)===null||_a===void 0?void 0:_a.send)===null||_b===void 0?void 0:_b.call(_a,s,target);}}]);return BaseSocketConnector;}();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var objectFromEntries=exports.objectFromEntries=function objectFromEntries(entries){return entries.reduce(function(acc,el){acc[el[0]]=el[1];return acc;},{});};var objectEntries=exports.objectEntries=function objectEntries(o){var entries=[];for(var prop in o){entries.push([prop,o[prop]]);}return entries;};var objectValues=exports.objectValues=function objectValues(o){var entries=[];for(var prop in o){entries.push(o[prop]);}return entries;};/**
 * Очередь
 * @example
 * ```
 * const values: [number, number, number] = [1, 2, 3];
 * const list = new LinkedList(values);
 *
 * values.forEach((v, i) => {
 *    test(`${i}-й вызов next возвращает элемент ${v} из [${values}]`, () => {
 *       expect(list.current).toBe(v);
 *       list.next();
 *    });
 * });
 *
 * test('после последнего текущий элемент - null ', () => {
 *    expect(list.current).toBe(null);
 * });
   ```
 */var Queue=exports.Queue=function(){function Queue(data){_classCallCheck(this,Queue);this.data=data;this.cursor=0;}/**
     * Возращает текущий элемент или null
     * @returns {T|null}
     */_createClass(Queue,[{key:"next",/**
     * Перевести курсор на следующий элемент
     * @void
     */value:function next(){if(this.cursor===this.data.length){return;}this.cursor++;}/**
     * В начало очереди
     * @void
     * @example
     * ```
     * const values: [number, number, number] = [5, 6, 7];
     * const list = new Queue(values);
     *
     * for (let i = 0; i < 5; i++) { list.next(); }
     *
     * list.reset();
     *
     * values.forEach((v, i) => {
     *    test(`${i}-й вызов next возвращает элемент ${v} из [${values}]`, () => {
     *        expect(list.current).toBe(v);
     *        list.next();
     *    });
     * });
     * ```
     */},{key:"reset",value:function reset(){this.cursor=0;}},{key:"current",get:function get(){return this.data[this.cursor]||null;}}]);return Queue;}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// type 0 - error
// type 1 - success
var Message=(_dec=(0,_mobxReact.inject)('dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Message,_Component);function Message(){_classCallCheck(this,Message);return _possibleConstructorReturn(this,(Message.__proto__||Object.getPrototypeOf(Message)).apply(this,arguments));}_createClass(Message,[{key:'render',value:function render(){var _props=this.props,text=_props.text,onClose=_props.onClose,type=_props.type;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'result-container '+(type=='success'||type==1?'':'result-error')},_react2.default.createElement('div',{className:'result-close right',onClick:onClose}),_react2.default.createElement('div',{className:'result-text',dangerouslySetInnerHTML:{__html:getLang(text)}}));}}]);return Message;}(_react.Component))||_class)||_class);exports.default=Message;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _react = __webpack_require__(0);

var _loadScript = _interopRequireDefault(__webpack_require__(576));

var _deepmerge = _interopRequireDefault(__webpack_require__(577));

var _props = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge["default"])(defaultProps.config, props.config);

  var _iterator = _createForOfIteratorHelper(_props.DEPRECATED_CONFIG_PROPS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge["default"])(config, _defineProperty({}, key, props[p]));

        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = "ReactPlayer: %c".concat(p, " %cis deprecated, please use the config prop instead \u2013 ").concat(link);
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isObject(val) {
  return val !== null && _typeof(val) === 'object';
} // Deep comparison of two objects, but ignoring functions
// and React elements, for use in shouldComponentUpdate


function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }

  if ((0, _react.isValidElement)(a) && (0, _react.isValidElement)(b)) {
    return true;
  }

  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }

    return true;
  }

  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (var _i3 = 0, _Object$keys = Object.keys(a); _i3 < _Object$keys.length; _i3++) {
      var key = _Object$keys[_i3];

      if (!isEqual(a[key], b[key])) {
        return false;
      }
    }

    return true;
  }

  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(147);
var isBuffer = __webpack_require__(314);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(226);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var _default=function(){function _default(){_classCallCheck(this,_default);this.subscribers=new Set();}_createClass(_default,[{key:"notify",value:function notify(id,updated){this.subscribers.forEach(function(f){f(id,updated);});}},{key:"subscribe",value:function subscribe(f){this.subscribers.add(f);}},{key:"unsubscribe",value:function unsubscribe(f){this.subscribers.delete(f);}}]);return _default;}();exports.default=_default;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSinglePlayer;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(73);

var _utils = __webpack_require__(14);

var _Player = _interopRequireDefault(__webpack_require__(111));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SinglePlayer, _Component);

    var _super = _createSuper(SinglePlayer);

    function SinglePlayer() {
      var _this;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
        _this.player = player;
      });

      return _this;
    }

    _createClass(SinglePlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$config$file = this.config.file,
            forceVideo = _this$config$file.forceVideo,
            forceAudio = _this$config$file.forceAudio,
            forceHLS = _this$config$file.forceHLS,
            forceDASH = _this$config$file.forceDASH;
        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;

        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }

        var _this$props = this.props,
            style = _this$props.style,
            width = _this$props.width,
            height = _this$props.height,
            Wrapper = _this$props.wrapper;
        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          style: _objectSpread({}, style, {
            width: width,
            height: height
          })
        }, otherProps), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, this.props, {
          ref: this.ref,
          activePlayer: activePlayer,
          config: this.config
        })));
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _defineProperty(_class, "displayName", "".concat(activePlayer.displayName, "Player")), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "canPlay", activePlayer.canPlay), _temp;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(235)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(51);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				value = desc && 'get' in desc && !('originalValue' in desc.get) ? desc.get : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["a"] = (warning);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(179);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Footer=exports.ModalContainer=exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);__webpack_require__(279);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=(_temp=_class=function(_Component){_inherits(Modal,_Component);_createClass(Modal,[{key:'getChildContext',value:function getChildContext(){return{closeBox:this.props.onCloseModal};}}]);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.handleBoxDismiss=_this.handleBoxDismiss.bind(_this);_this.state={show:true,fixed:false};return _this;}_createClass(Modal,[{key:'componentDidMount',value:function componentDidMount(){this.setState({show:this.props.show,fixed:this.props.fixed});}},{key:'handleBoxDismiss',value:function handleBoxDismiss(){if(!this.state.fixed)this.props.onCloseModal();}},{key:'render',value:function render(){var styleModal=this.props.styleModal!==undefined?this.props.styleModal:{};return this.state.show?_react2.default.createElement('div',{className:'box__wrap'},_react2.default.createElement('div',{className:'box__over',onClick:this.handleBoxDismiss}),_react2.default.createElement('div',{className:'box__main',style:styleModal},this.props.title?_react2.default.createElement('div',{className:'box_header'},!this.state.fixed?_react2.default.createElement('div',{className:'box_header_close',onClick:this.handleBoxDismiss}):'',_react2.default.createElement('div',{className:'box_title'},this.props.title)):!this.state.fixed?_react2.default.createElement('div',{className:'box_header_close box_header_close_b',onClick:this.handleBoxDismiss}):'',_react2.default.createElement('div',{className:'box_body'},this.props.children),this.props.footer?_react2.default.createElement('div',{className:'box_controls_wrap'},_react2.default.createElement('div',{className:'box_controls clearfix'},this.props.closeButton?_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('button',{className:'flat_button box_close_button',onClick:this.handleBoxDismiss},'\u0417\u0430\u043A\u0440\u044B\u0442\u044C')):'',this.props.save?_react2.default.createElement(Footer,null):'')):'')):null;}}]);return Modal;}(_react.Component),_class.childContextTypes={closeBox:_propTypes2.default.func},_temp);exports.default=Modal;var ModalContainer=exports.ModalContainer=function(_Component2){_inherits(ModalContainer,_Component2);function ModalContainer(props){_classCallCheck(this,ModalContainer);var _this2=_possibleConstructorReturn(this,(ModalContainer.__proto__||Object.getPrototypeOf(ModalContainer)).call(this,props));_this2.el=document.createElement('div');_this2.modal=document.getElementById('modal-container');return _this2;}_createClass(ModalContainer,[{key:'componentDidMount',value:function componentDidMount(){this.modal.appendChild(this.el);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.modal.removeChild(this.el);}},{key:'render',value:function render(){return _reactDom2.default.createPortal(this.props.children,this.el);}}]);return ModalContainer;}(_react.Component);var Footer=exports.Footer=function(_Component3){_inherits(Footer,_Component3);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return this.props.children;}}]);return Footer;}(_react.Component);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _class2;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _reactOnclickoutside=__webpack_require__(82);var _reactOnclickoutside2=_interopRequireDefault(_reactOnclickoutside);var _reactTextMask=__webpack_require__(284);var _reactTextMask2=_interopRequireDefault(_reactTextMask);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputKeyboard=function(_Component){_inherits(InputKeyboard,_Component);function InputKeyboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InputKeyboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InputKeyboard.__proto__||Object.getPrototypeOf(InputKeyboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={showIcon:false,showKeyboard:false,left:0,top:0},_this.inputRef=_react2.default.createRef(),_this.input=_react2.default.createRef(),_this.handleFocus=function(){_this.setState({showIcon:true});},_this.handleCloseKeyboard=function(){_this.setState({showIcon:_this.props.forceShowIcon||false,showKeyboard:false});},_this.setPosition=function(){var node=void 0;if(_this.props.mode=='mask'){node=_this.input.current.inputElement.getBoundingClientRect();}else{node=_this.input.current.getBoundingClientRect();}var positionX=_this.props.positionX?_this.props.positionX:'left';var positionY=_this.props.positionY?_this.props.positionY:'bottom';var top=void 0,left=void 0;if(positionX=='left'){left=node.left-5-196;}else if(positionX=='right'){left=node.left+5+node.width;}if(positionY=='top'){top=node.top+window.pageYOffset;}else if(positionY=='bottom'){top=node.top+window.pageYOffset;}_this.setState({// showIcon: true,
top:top,left:left});},_this.handleFocus=function(){_this.setPosition();_this.setState({showIcon:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InputKeyboard,[{key:'componentDidUpdate',value:function componentDidUpdate(){// console.log('updateKeyboard');
// this.setPosition();
}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.forceShowIcon){this.handleFocus();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,positionX=_props.positionX,positionY=_props.positionY,_onChange=_props.onChange,mode=_props.mode,mask=_props.mask,other=_objectWithoutProperties(_props,['value','positionX','positionY','onChange','mode','mask']);var input=null;if(mode=='mask'){input=_react2.default.createElement(_reactTextMask2.default,_extends({},other,{mask:mask,guide:false,ref:this.input,value:value,onFocus:this.handleFocus,onChange:function onChange(e){return _onChange(e.target.value);}}));}else{input=_react2.default.createElement('input',_extends({},other,{ref:this.input,value:value,onFocus:this.handleFocus,onChange:function onChange(e){return _onChange(e.target.value);}}));}return _react2.default.createElement('span',{className:'ui-keyboard-container',ref:this.inputRef},this.state.showIcon?_react2.default.createElement(KeyboardContainer,null,_react2.default.createElement('div',{className:'ui-keyboard-icon-wrapper '+positionX,onClick:this.handleShowKeyboard,style:{top:this.state.top,left:this.state.left}},_react2.default.createElement(VirtualKeyboard,{positionY:positionY,positionX:positionX,onChange:_onChange,onClose:this.handleCloseKeyboard,value:value,inputRef:mode=='mask'?this.input.current.inputElement:this.input.current,caretPos:this.input.current.selectionStart,showKeyboard:this.state.showKeyboard,onShowKeyboard:function onShowKeyboard(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;return _this2.setState({showKeyboard:value});}}))):'',input);}}]);return InputKeyboard;}(_react.Component);exports.default=InputKeyboard;var KeyboardContainer=function(_Component2){_inherits(KeyboardContainer,_Component2);function KeyboardContainer(props){_classCallCheck(this,KeyboardContainer);var _this3=_possibleConstructorReturn(this,(KeyboardContainer.__proto__||Object.getPrototypeOf(KeyboardContainer)).call(this,props));_this3.el=document.createElement('div');_this3.modal=document.getElementById('keyboard');return _this3;}_createClass(KeyboardContainer,[{key:'componentDidMount',value:function componentDidMount(){this.modal.appendChild(this.el);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.modal.removeChild(this.el);}},{key:'render',value:function render(){return _reactDom2.default.createPortal(this.props.children,this.el);}}]);return KeyboardContainer;}(_react.Component);var VirtualKeyboard=(0,_reactOnclickoutside2.default)(_class2=function(_Component3){_inherits(VirtualKeyboard,_Component3);function VirtualKeyboard(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,VirtualKeyboard);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=VirtualKeyboard.__proto__||Object.getPrototypeOf(VirtualKeyboard)).call.apply(_ref2,[this].concat(args))),_this4),_this4.customLayout={'default':[[1,2,3],[4,5,6],[7,8,9],['.',0,'b']]},_this4.handleKeyboard=function(val){var str=String(_this4.props.value);// this.props.inputRef.focus();
var caret=_this4.props.inputRef.selectionStart;var split=['',''];if(val=='b'){split[0]=str.substring(0,caret);split[1]=str.substring(caret,str.length);str=split[0].substring(0,split[0].length-1);str=str+split[1];--caret;}else{var maxlength=parseInt(_this4.props.inputRef.getAttribute('maxlength'));if(maxlength&&str.length+1>maxlength){return false;}split[0]=str.substring(0,caret);split[1]=str.substring(caret,str.length);// t.data.input.value = split[0] + val + split[1];
++caret;str=split[0]+val+split[1];}_this4.props.onChange(str);_this4.props.inputRef.focus();setTimeout(function(){_this4.props.inputRef.setSelectionRange(caret,caret);},10);},_this4.handleClickIcon=function(){_this4.props.onShowKeyboard();_this4.props.inputRef.focus();},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(VirtualKeyboard,[{key:'componentDidMount',value:function componentDidMount(){var _this5=this;window.addEventListener("blur",function(){_this5.props.onClose();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this6=this;window.removeEventListener("blur",function(){_this6.props.onClose();});}},{key:'handleClickOutside',value:function handleClickOutside(evt){this.props.onShowKeyboard(false);if(evt.path&&evt.path[0]!=this.props.inputRef){this.props.onClose();};}},{key:'render',value:function render(){var _this7=this;var layout=this.props.type?this.props.type:'default';var _props2=this.props,showKeyboard=_props2.showKeyboard,positionX=_props2.positionX,positionY=_props2.positionY;var style=positionY=='top'?{top:'-156px'}:{};return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'ui-keyboard-wrapper'+(!showKeyboard?' hidden':''),style:style},_react2.default.createElement('div',{className:'ui-keyboard'},_react2.default.createElement('div',{className:'ui-keyboard-keyset'},this.customLayout[layout].map(function(el){return _react2.default.createElement(_react.Fragment,{key:el[0]},_react2.default.createElement(Buttons,{items:el,handleClick:_this7.handleKeyboard}),_react2.default.createElement('br',{className:'ui-keyboard-button-endrow'}));})))),_react2.default.createElement('span',{className:'ui-keyboard-icon-container '+positionX+(showKeyboard?' hidden':''),onClick:this.handleClickIcon},_react2.default.createElement('span',{className:'ui-keyboard-icon'})));}}]);return VirtualKeyboard;}(_react.Component))||_class2;var Buttons=function Buttons(_ref3){var items=_ref3.items,handleClick=_ref3.handleClick;var buttons=items.map(function(el){if(el=='b'){return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button ui-keyboard-bksp',title:'Backspace'},_react2.default.createElement('span',{className:'ui-keyboard-text'},'\u232B'));}else if(el=='a'){return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button ui-keyboard-accept'},_react2.default.createElement('span',{className:'ui-keyboard-text'},'\u2714'));}else{return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button'},_react2.default.createElement('span',{className:'ui-keyboard-text'},el));}});return buttons;};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SheetsRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createJss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createGenerateId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasCSSTOMSupport; });
/* unused harmony export sheets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toCssValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(159);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.2";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" /* default */] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* unused harmony default export */ var _unused_webpack_default_export = (index);



/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(244);

// https://ecma-international.org/ecma-262/6.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	return ES5Type(x);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LOG_LEVEL;(function(LOG_LEVEL){/** Не логгировать */LOG_LEVEL["OFF"]="OFF";/** Логи и ошибки */LOG_LEVEL["LOG"]="LOG";/** Только ошибки */LOG_LEVEL["ERROR"]="ERROR";})(LOG_LEVEL||(LOG_LEVEL={}));var DEBUG_COOKIE=new RegExp('debug=([A-Z]+)');/**
 * Logger в debug режиме
 * Уровень логирования выставляется кукой `debug`
 * Уровни логирования
 * ```
 *    'OFF' - Не логгировать
 *    'LOG' - Логи и ошибки
 *    'ERROR' - Только ошибки
 * ```
 * @example
 *     Logger.getInstance().error(e);
 */var Logger=function(){function Logger(){_classCallCheck(this,Logger);this.isEnable=typeof document!=='undefined'&&DEBUG_COOKIE.test(document.cookie);this.logLevel=typeof document!=='undefined'&&(DEBUG_COOKIE.exec(document.cookie)||[])[1]||LOG_LEVEL.OFF;}_createClass(Logger,[{key:"log",value:function log(data){if(this.logLevel===LOG_LEVEL.LOG){this.print(data,Logger.STYLE.LOG);}}},{key:"error",value:function error(e){if(this.logLevel===LOG_LEVEL.OFF){return;}this.print(e.toString(),Logger.STYLE.ERROR);}},{key:"print",value:function print(data,style){if(!this.isEnable){return;}console.info(Logger.TAG+" "+data,style);}}],[{key:"getInstance",value:function getInstance(){if(this.instance){return this.instance;}this.instance=new Logger();return this.instance;}}]);return Logger;}();exports.default=Logger;Logger.TAG='%c 🐞 [logger]';Logger.STYLE={LOG:'background: #222; color: #bada55; padding:3px;',ERROR:'background: #222; color: red; padding:3px;'};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)(module)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import './style.scss';
var FavouriteStar=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(FavouriteStar,_Component);function FavouriteStar(props){_classCallCheck(this,FavouriteStar);var _this=_possibleConstructorReturn(this,(FavouriteStar.__proto__||Object.getPrototypeOf(FavouriteStar)).call(this,props));_this.toggle=_this.toggle.bind(_this);return _this;}_createClass(FavouriteStar,[{key:'toggle',value:function toggle(e){if(this.props.disabled&&this.props.lineStore.menu.favourites.games.length>0){this.props.lineStore.menu.selectItem('fav',0);}else{this.props.lineStore.menu.toggleFav(this.props.id,this.props.type);}}},{key:'render',value:function render(){if(!this.props.lineStore.menu)return false;var on=false;var favourites=this.props.lineStore.menu.favourites;var id=Number(this.props.id);switch(this.props.type){case 0:on=favourites.games.length>0||favourites.popular.pop.length?true:false;break;case 1:on=favourites.sport.indexOf(id)!=-1?true:false;break;case 2:on=favourites.league.indexOf(id)!=-1?true:false;break;case 3:on=favourites.games.indexOf(id)!=-1?true:false;break;case 4:on=favourites.popular.pop.indexOf(id)!=-1?true:false;break;}return _react2.default.createElement('button',{href:'#',onClick:this.toggle,className:(0,_classnames2.default)(['favourites-star f-s-ico-fav',{'on':on}])},'\xA0');}}]);return FavouriteStar;}(_react.Component))||_class)||_class);exports.default=FavouriteStar;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(495),
    getValue = __webpack_require__(500);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AppStore=undefined;var _desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();// import routingStore from './routingStore';
var _mobx=__webpack_require__(5);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);var _store=__webpack_require__(118);var _store2=_interopRequireDefault(_store);var _lineStore=__webpack_require__(208);var _lineStore2=_interopRequireDefault(_lineStore);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SessionChecker=function(){function SessionChecker(store){var _this=this;_classCallCheck(this,SessionChecker);this.INTERVAL=60000;this.error_count=0;this.store=null;this.store=store;if(false){return;}(0,_mobx.autorun)(function(){if(_this.store.terminalAccess){setInterval(function(){_this.check();},_this.INTERVAL);}});}_createClass(SessionChecker,[{key:'check',value:function check(){var _this2=this;return _api2.default.checker.get().then((0,_mobx.action)(function(res){if(!res.access){_this2.store.clear('TERMINAL');}if(!res.access){_this2.error_count++;}if(_this2.error_count>10){_this2.store.clear('TERMINAL');}}));}}]);return SessionChecker;}();var AppStore=exports.AppStore=(_class2=function(){_createClass(AppStore,[{key:'loginTerminal',value:function loginTerminal(){var _this3=this;_api2.default.terminal.login().then((0,_mobx.action)(function(res){if(res.code=='OK'){if(res.result==1){_this3.terminalAccess=1;_this3.cardId=res.result.card;}else if(res.result==2){// this.setTerminalError(1, 'Не правильные параметры авторизации');
console.error('неправильные данные',res);}else{_this3.checkTerminal(res.result);}}else{console.error('неправильные данные',res);}})).catch((0,_mobx.action)(function(err){console.error('неправильные данные',err);}));}},{key:'checkTerminal',value:function checkTerminal(data){var _this4=this;console.log(data);return _api2.default.terminal.check(data).then((0,_mobx.action)(function(res){if(res.code=="OK"){_this4.terminalAccess=1;}else{console.error('неправильные данные',res);}})).catch((0,_mobx.action)(function(err){console.error('неправильные данные',err);}));}// app store
}]);// navLinks = [
// 	{ path: '/line' , name: 'Линия', access: 2},
// 	{ path: '/live' , name: 'Лайв', access: 2},
// 	{ path: '/results' , name: 'Результаты', access: 1, sub: [
// 			{ path: '/results/line' , name: 'Результаты', access: 1},
// 			{ path: '/results/live' , name: 'Результаты Live', access: 1},
// 		]
// 	},
// 	{ path: '/stats' , name: 'Статистика', access: 1},
// 	{ path: '/toto' , name: 'Тото', access: 1},
// 	{ path: '/account' , name: 'Личные данные', access: 1, sub: [
// 			{ path: '/account/bets' , name: 'Ваши ставки', access: 1},
// 			{ path: '/account/history' , name: 'История', access: 1},
// 		]
// 	},
// 	{ path: '/payout' , name: 'Выплата', access: 1},
// 	{ path: '/payout' , name: 'Выплата', access: 1},
// ];
function AppStore(){_classCallCheck(this,AppStore);this.sessionChecker=null;_initDefineProp(this,'appName',_descriptor,this);_initDefineProp(this,'lang',_descriptor2,this);_initDefineProp(this,'terminalAccess',_descriptor3,this);_initDefineProp(this,'slides',_descriptor4,this);_initDefineProp(this,'isLoading',_descriptor5,this);_initDefineProp(this,'cardReader',_descriptor6,this);_initDefineProp(this,'appLoading',_descriptor7,this);_initDefineProp(this,'financeData',_descriptor8,this);_initDefineProp(this,'currency',_descriptor9,this);_initDefineProp(this,'showTopMenu',_descriptor10,this);_initDefineProp(this,'history',_descriptor11,this);_initDefineProp(this,'cashboxMode',_descriptor12,this);_initDefineProp(this,'cashboxRules',_descriptor13,this);_initDefineProp(this,'cashboxId',_descriptor14,this);_initDefineProp(this,'currency_id',_descriptor15,this);_initDefineProp(this,'initData',_descriptor16,this);_initDefineProp(this,'error',_descriptor17,this);_initDefineProp(this,'isNotificationVisible',_descriptor18,this);this.timerRules=null;this.sessionChecker=new SessionChecker(this);this.igStore=_store2.default;this.lineStore=new _lineStore2.default(this);// autorun(() => {
// 	console.log(routingStore.location);
// })
}_createClass(AppStore,[{key:'setHistory',value:function setHistory(history){this.history=history;}// @computed get links() {
// 	return this.navLinks.filter( item => item.access === this.access || item.access === 2 )
// }
},{key:'initApp',value:function initApp(){this.getData();}},{key:'getData',value:function getData(){var _this5=this;var count=0;return _api2.default.data.get().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this5.terminalAccess=1;_this5.cardReader=res.card_reader;_this5.cashboxId=res.cashbox_id;_this5.initData.hideHomePage=res.hide_homepage;// lineStore.liveSetting = res.live_setting;
_this5.lineStore.liveRefreshInterval=res.live_refresh_interval;_this5.lineStore.liveRefreshOne=res.live_refresh_one;if(res.access){_jsCookie2.default.set('user_logged_in',1);_accountStore2.default.changePsw=res.change_psw;_accountStore2.default.access=1;_accountStore2.default.isCard=res.is_card;_accountStore2.default.logout_hash=res.logout_h;_accountStore2.default.accountSettings.oneClickBetAmount=res.oneclick?res.oneclick:0;_accountStore2.default.login=res.login?res.login:null;_accountStore2.default.hideRoutes=res.hide_routes;_accountStore2.default.init();_this5.currency_id=res.currency_id;}else{_jsCookie2.default.set('user_logged_in',0);}_this5.addFinanceData(res.finance_data);if(res.lang)_this5.lang=res.lang;if(res.fast_amount){_accountStore2.default.fastAmounts.amounts=res.fast_amount.data;_accountStore2.default.fastAmounts.limits=res.fast_amount.rules;}_this5.startCheckCashboxMode();}else{clearInterval(_this5.timerRules);if(false){return;}if(window.location.pathname!='/terminal/login'){window.location='/terminal/login';}}})).catch((0,_mobx.action)(function(err){if(count<5){_this5.getData();}else{_this5.error.status=1;_this5.error.text='SERVER_TEMPORARILY_DOWN';}})).finally((0,_mobx.action)(function(){_this5.appLoading=true;}));}},{key:'loadSlider',value:function loadSlider(){var _this6=this;return _api2.default.slides.getIrmBanners().then((0,_mobx.action)(function(result){if(result.code=='0'){_this6.slides=result.result;}}));// .catch(action(err => {
//   this.AppError = err.response && err.response.body && err.response.body.errors;
//   throw err;
// }))
// .finally(action(() => { this.isLoading = true; }));
}},{key:'toggleShowTopMenu',value:function toggleShowTopMenu(status){this.showTopMenu=status;}},{key:'addFinanceData',value:function addFinanceData(data){if(data){this.financeData=data;if(typeof this.currency_id=='undefined'){this.getCurrency();}else{this.currency=this.financeData[this.currency_id]?this.financeData[this.currency_id]:'undefined';}}}},{key:'getCurrency',value:function getCurrency(){var _this7=this;return _api2.default.terminal.getCurrency().then((0,_mobx.action)(function(data){if(data.code==='OK'){_this7.currency_id=data.result;if(_this7.financeData&&(!_this7.currency||_this7.currency.id!==_this7.currency_id)){_this7.currency=_this7.financeData[_this7.currency_id]?_this7.financeData[_this7.currency_id]:'undefined';}}}));}// @action enterPhone(phone) {
//    const number = parseInt(phone.replace(/\D+/g,""));
//    this.error.status = false;
//    if (number.toString().length > 0){
//      this.phone = number;
//    } else {
//      this.phone = '';
//    }
//  }
},{key:'clear',value:function clear(type){switch(type){case'TERMINAL':this.terminalAccess=0;this.access=0;this.logout_hash='';if(!"production"==='development'){window.location='/terminal/login';}break;case'ACCESS':_accountStore2.default.access=0;_accountStore2.default.logout_hash='';this.history.push('/');break;}}},{key:'startCheckCashboxMode',value:function startCheckCashboxMode(){var _this8=this;this.getCashboxMode();this.timerRules=setInterval(function(){_this8.getCashboxMode();},600000);}},{key:'getCashboxMode',value:function getCashboxMode(){var _this9=this;return _api2.default.terminal.getMode({cashbox_id:this.cashboxId}).then((0,_mobx.action)(function(data){if(data.code=='OK'){_this9.cashboxMode=data.result;}}));}},{key:'getRules',value:function getRules(){var _this10=this;// const id = this.cashboxMode == 2 ? 'cupis_rules' : 'com_rules';
if(this.cashboxMode!=2)return false;var id='cupis_rules';_api2.default.html.get({id:id}).then((0,_mobx.action)(function(data){if(data.code==0){_this10.cashboxRules=data.result[id];}}));}},{key:'clearRules',value:function clearRules(){this.cashboxRules='';}},{key:'setNotificationVisibility',value:function setNotificationVisibility(field,value){this.isNotificationVisible[field]=value;}}]);return AppStore;}(),(_applyDecoratedDescriptor(_class2.prototype,'loginTerminal',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'loginTerminal'),_class2.prototype),_descriptor=_applyDecoratedDescriptor(_class2.prototype,'appName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'ИРМ';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'lang',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'RU';}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'terminalAccess',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'slides',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'cardReader',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'appLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'financeData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'currency',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'showTopMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor11=_applyDecoratedDescriptor(_class2.prototype,'history',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor12=_applyDecoratedDescriptor(_class2.prototype,'cashboxMode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 2;}}),_descriptor13=_applyDecoratedDescriptor(_class2.prototype,'cashboxRules',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor14=_applyDecoratedDescriptor(_class2.prototype,'cashboxId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor15=_applyDecoratedDescriptor(_class2.prototype,'currency_id',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 2;}}),_descriptor16=_applyDecoratedDescriptor(_class2.prototype,'initData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{hideHomePage:0};}}),_descriptor17=_applyDecoratedDescriptor(_class2.prototype,'error',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:''};}}),_descriptor18=_applyDecoratedDescriptor(_class2.prototype,'isNotificationVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{movingStatistics:false};}}),_applyDecoratedDescriptor(_class2.prototype,'setHistory',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'setHistory'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'initApp',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'initApp'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'getData'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'loadSlider',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'loadSlider'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'toggleShowTopMenu',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'toggleShowTopMenu'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'addFinanceData',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'addFinanceData'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'getCurrency',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'getCurrency'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'clear'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'startCheckCashboxMode',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'startCheckCashboxMode'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'getCashboxMode',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'getCashboxMode'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'getRules',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'getRules'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'clearRules',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'clearRules'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'setNotificationVisibility',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'setNotificationVisibility'),_class2.prototype)),_class2);exports.default=new AppStore();

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(257);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _filterTimeLine=__webpack_require__(340);var _filterTimeLine2=_interopRequireDefault(_filterTimeLine);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _settings=__webpack_require__(341);var _settings2=_interopRequireDefault(_settings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnderHeader=(_dec=(0,_mobxReact.inject)('accountStore','lineStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(UnderHeader,_Component);function UnderHeader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UnderHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UnderHeader.__proto__||Object.getPrototypeOf(UnderHeader)).call.apply(_ref,[this].concat(args))),_this),_this.state={showSettings:false,showBets:false},_this.toggleAllLeague=function(){_this.props.lineStore.line.toggleAllLeagueShow();},_this.toggleSettings=function(){_this.setState({showSettings:!_this.state.showSettings});},_this.backToBets=function(){var lastAction=localStorage.getItem('lastAction');if(lastAction&&Number(lastAction)===1){_this.props.history.push('/line');}else{_this.props.history.push('/live');}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UnderHeader,[{key:'render',value:function render(){var type=this.props.type;var _props$history=this.props.history,goBack=_props$history.goBack,goForward=_props$history.goForward;var mode=this.props.lineStore.mode;var showTableItemsAll=this.props.lineStore.line.showTableItemsAll;var access=this.props.accountStore.access;var basketPosition=this.props.accountStore.accountSettings.basketPosition;var content={1:// for LINE / LIVE
_react2.default.createElement('div',{className:'under-header',style:{display:'inline-block',padding:'5px 10px 0 5px'}},_react2.default.createElement('a',{className:'control-panel-item line-come-back white-btn',onClick:goBack},_react2.default.createElement('span',{className:'control-panel-ico f-s-ico-arrow_left'}),_react2.default.createElement('span',{className:'control-panel-text'},'\u041D\u0430\u0437\u0430\u0434')),_react2.default.createElement('a',{className:'control-panel-item line-go-forward white-btn',onClick:goForward},_react2.default.createElement('span',{className:'control-panel-text'},'\u0412\u043F\u0435\u0440\u0435\u0434'),_react2.default.createElement('span',{className:'control-panel-ico f-s-ico-arrow_right_1'})),mode==='line'&&_react2.default.createElement(_filterTimeLine2.default,null),_react2.default.createElement('div',{className:'control-panel-right '+(basketPosition==='left'?'on-edge':'')},_react2.default.createElement('a',{className:'control-panel-item white-btn line-toggle-all',onClick:this.toggleAllLeague},_react2.default.createElement('span',{className:'control-panel-text'},showTableItemsAll?'Развернуть все':'Свернуть все')),access?_react2.default.createElement('a',{className:'control-panel-item account-settings-show white-btn',onClick:this.toggleSettings},_react2.default.createElement('span',{className:'control-panel-ico f-s-ico-settings'}),_react2.default.createElement('span',{className:'control-panel-text'},'\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438')):null),this.state.showSettings&&_react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{styleModal:{width:'600px'},show:this.state.showSettings,onCloseModal:this.toggleSettings,title:'\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430',footer:1,closeButton:1},_react2.default.createElement(_settings2.default,null)))),2:// for other pages
_react2.default.createElement('div',{className:'control-panel under-header',style:{display:'inline-block',padding:'5px 10px 0 5px'}},_react2.default.createElement('a',{className:'control-panel-item line-come-back white-btn',onClick:goBack},_react2.default.createElement('span',{className:'control-panel-ico f-s-ico-arrow_left'}),_react2.default.createElement('span',{className:'control-panel-text'},'\u041D\u0430\u0437\u0430\u0434')),_react2.default.createElement('a',{className:'control-panel-item line-go-forward white-btn',onClick:goForward},_react2.default.createElement('span',{className:'control-panel-text'},'\u0412\u043F\u0435\u0440\u0435\u0434'),_react2.default.createElement('span',{className:'control-panel-ico f-s-ico-arrow_right_1'})),_react2.default.createElement('a',{className:'control-panel-item back-to-bets white-btn',onClick:this.backToBets},_react2.default.createElement('span',{className:'control-panel-text'},'\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0441\u0442\u0430\u0432\u043A\u0430\u043C')))};return content[type];}}]);return UnderHeader;}(_react.Component))||_class)||_class)||_class);exports.default=UnderHeader;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Counter=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Counter,_Component);function Counter(props){_classCallCheck(this,Counter);var _this=_possibleConstructorReturn(this,(Counter.__proto__||Object.getPrototypeOf(Counter)).call(this,props));_this.counterRef=_react2.default.createRef();_this.state={timeOutId:null};return _this;}_createClass(Counter,[{key:'componentDidUpdate',value:function componentDidUpdate(nextProps){if(Number(nextProps.count)!==Number(this.props.count)){this.animate();}}},{key:'animate',value:function animate(){var _this2=this;if(this.state.timeOutId){clearTimeout(this.state.timeOutId);this.setState({timeOutId:null});}else if(this.counterRef.current){this.counterRef.current.classList.add('animate');}this.state.timeOutId=setTimeout(function(){if(_this2.counterRef.current){_this2.counterRef.current.classList.remove('animate');}clearTimeout(_this2.state.timeOutId);_this2.state.timeOutId=null;},2000);}},{key:'render',value:function render(){return _react2.default.createElement('div',{ref:this.counterRef,className:'favourites-sport-item-count'},this.props.count);}}]);return Counter;}(_react.Component))||_class)||_class);exports.default=Counter;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.accountStore=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_desc2,_value2,_class4,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();// import _ from 'lodash';
var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);var _account=__webpack_require__(634);var _account2=_interopRequireDefault(_account);var _history=__webpack_require__(635);var _history2=_interopRequireDefault(_history);var _betsPeriod=__webpack_require__(636);var _betsPeriod2=_interopRequireDefault(_betsPeriod);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AutoCloseForm=function(){function AutoCloseForm(store){var _this=this;_classCallCheck(this,AutoCloseForm);this.SECONDS=30;this.store=null;this.timer=null;this.seconds=-1;this.status=1;this.bodyNode=document.getElementsByTagName('body')[0];this.store=store;(0,_mobx.autorun)(function(){if(!_this.store.access&&_this.store.showLoginForm){_this.start();_this.bodyNode.addEventListener("mouseover",function(){_this.setSeconds();});_this.bodyNode.addEventListener("keydown",function(){_this.setSeconds();});}else{_this.stop();}});}// время выхода когда нет авктивности
_createClass(AutoCloseForm,[{key:'setSeconds',value:function setSeconds(){this.seconds=this.SECONDS;}},{key:'start',value:function start(){var _this2=this;this.setSeconds();this.timer=setInterval(function(){if(_this2.status)_this2.tick();},1000);}},{key:'tick',value:function tick(){this.seconds--;if(this.seconds==0){this.store.toggleLoginFormVisible();}}},{key:'stop',value:function stop(){clearInterval(this.timer);}}]);return AutoCloseForm;}();;var SEC=1000;var MIN=60*SEC;var InactiveTimer=function(){function InactiveTimer(timeout,onTimeOut){var _this3=this;_classCallCheck(this,InactiveTimer);this.time=timeout;var setTimer=function setTimer(){_this3.setTimer(onTimeOut);};document.addEventListener('mouseover',setTimer);document.addEventListener('keydown',setTimer);setTimer();}_createClass(InactiveTimer,[{key:'setTimer',value:function setTimer(onTimeOut){clearTimeout(this.timeout);this.timeout=setTimeout(onTimeOut,this.time);}}]);return InactiveTimer;}();var AutoLogout=(_class2=function(){// время выхода когда нет авктивности
function AutoLogout(store){var _this4=this;_classCallCheck(this,AutoLogout);this.COOKIE='logout_next_time';this.SECONDS=1200;this.store=null;this.timer=null;this.seconds=-1;this.status=1;_initDefineProp(this,'alertVisible',_descriptor,this);_initDefineProp(this,'timerVisible',_descriptor2,this);_initDefineProp(this,'countdownHtml',_descriptor3,this);this.bodyNode=document.getElementsByTagName('body')[0];this.store=store;(0,_mobx.autorun)(function(){/** Принудительное очищение корзины при неактивности */new InactiveTimer(60*MIN,function(){_this4.store.logout(null,{cleanup:true});});if(_this4.store.access&&!_this4.store.isCard){if(_this4.isNeedToLogout()){_jsCookie2.default.remove(_this4.COOKIE);_this4.store.logout();}_this4.start();_this4.bodyNode.addEventListener("mouseover",function(){_this4.setSeconds();});_this4.bodyNode.addEventListener("keydown",function(){_this4.setSeconds();});}else{_this4.stop();}});}_createClass(AutoLogout,[{key:'isNeedToLogout',value:function isNeedToLogout(){var c=_jsCookie2.default.get(this.COOKIE);return typeof c!=='undefined'&&c=='1';}},{key:'setSeconds',value:function setSeconds(){this.seconds=this.SECONDS;this.timerVisible.status=0;this.timerVisible.html='';}},{key:'start',value:function start(){var _this5=this;this.setSeconds();this.timer=setInterval(function(){if(_this5.status)_this5.tick();},1000);}},{key:'prepare',value:function prepare(x){return(x/100).toFixed(2).substr(2);}},{key:'countdown',value:function countdown(seconds){this.countdownHtml.seconds=seconds;this.countdownHtml.html=seconds==1?'SECONDS_OF1':seconds<5&&seconds>0?'SECONDS_OF4':'SECONDS_OF';}},{key:'hide',value:function hide(){this.countdownHtml.seconds=0;this.countdownHtml.html='';}},{key:'print',value:function print(min,sec){this.timerVisible.status=1;this.timerVisible.html='('+(min<10?'0'+min:min)+':'+this.prepare(sec)+')';}},{key:'tick',value:function tick(){var w=60;var sec=this.seconds%w;var min=(this.seconds-sec)/w;this.seconds--;if(this.seconds>=0){if(this.seconds<=30){this.print(min,sec);}if(this.seconds<=10){this.alertVisible=1;this.countdown(this.seconds);}else{this.alertVisible=0;this.hide();}}else{this.store.logout();}}},{key:'stop',value:function stop(){clearInterval(this.timer);}}]);return AutoLogout;}(),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'alertVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'timerVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,html:''};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'countdownHtml',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{seconds:0,html:''};}}),_applyDecoratedDescriptor(_class2.prototype,'stop',[_mobx.action],Object.getOwnPropertyDescriptor(_class2.prototype,'stop'),_class2.prototype)),_class2);;var accountStore=exports.accountStore=(_class4=function(){// данные о продаже активной продаваемой ставки 
function accountStore(){_classCallCheck(this,accountStore);_initDefineProp(this,'autoLogout',_descriptor4,this);_initDefineProp(this,'isCard',_descriptor5,this);_initDefineProp(this,'changePsw',_descriptor6,this);_initDefineProp(this,'AccountPage',_descriptor7,this);_initDefineProp(this,'BetsPage',_descriptor8,this);_initDefineProp(this,'HistoryPage',_descriptor9,this);_initDefineProp(this,'access',_descriptor10,this);_initDefineProp(this,'login',_descriptor11,this);_initDefineProp(this,'showLoginForm',_descriptor12,this);_initDefineProp(this,'lengthPhoneNumber',_descriptor13,this);_initDefineProp(this,'fastAmounts',_descriptor14,this);_initDefineProp(this,'auth',_descriptor15,this);_initDefineProp(this,'logout_hash',_descriptor16,this);_initDefineProp(this,'phoneMask',_descriptor17,this);_initDefineProp(this,'balance',_descriptor18,this);_initDefineProp(this,'countBets',_descriptor19,this);_initDefineProp(this,'result',_descriptor20,this);_initDefineProp(this,'disabledAuthForm',_descriptor21,this);_initDefineProp(this,'statusdAuthForm',_descriptor22,this);_initDefineProp(this,'isBetSellModalOpened',_descriptor23,this);_initDefineProp(this,'activeBetData',_descriptor24,this);_initDefineProp(this,'activeBetSellingData',_descriptor25,this);_initDefineProp(this,'betsSellingData',_descriptor26,this);_initDefineProp(this,'sellingStatus',_descriptor27,this);this.subscribeCountBetsTimer=null;this.subscribeBetsTimer=null;this.subscribeBetsAttempt=0;_initDefineProp(this,'accountSettings',_descriptor28,this);_initDefineProp(this,'hideRoutes',_descriptor29,this);this.autoCloseForm=null;_initDefineProp(this,'updateCountBets',_descriptor30,this);_initDefineProp(this,'updateBets',_descriptor31,this);_initDefineProp(this,'updatePrice',_descriptor32,this);_initDefineProp(this,'waitFastForm',_descriptor33,this);this.AccountPage=new _account2.default(this);this.autoLogout=new AutoLogout(this);this.autoCloseForm=new AutoCloseForm(this);this.BetsPage=new _betsPeriod2.default(this);}// данные с wss о всех ставках на продажу
// данные активной продаваемой ставки
_createClass(accountStore,[{key:'hideBalance',value:function hideBalance(){if(this.accountSettings.showHeaderBalance===1){this.accountSettings.showHeaderBalance=0;}else this.accountSettings.showHeaderBalance=1;}},{key:'init',value:function init(){if(this.access){var ls=JSON.parse(localStorage.getItem('account_settings'));if(ls&&ls.login==this.login){this.accountSettings=ls.settings;}else{localStorage.clear();this.saveSettings();}this.subscribeCountBets();this.subscribeBets();}}},{key:'subscribeCountBets',value:function subscribeCountBets(){var _this6=this;clearTimeout(this.subscribeCountBetsTimer);if(_appStore2.default.igStore.ws&&_appStore2.default.igStore.ws.readyState===WebSocket.OPEN){_appStore2.default.igStore.ws.send(JSON.stringify({t:14,d:_jsCookie2.default.get('jwt'),op:0}));}else{_appStore2.default.igStore.getSocket();this.subscribeCountBetsTimer=setTimeout(function(){return _this6.subscribeCountBets();},1000);}}},{key:'unsubscribeCountBets',value:function unsubscribeCountBets(){if(_appStore2.default.igStore.ws&&_appStore2.default.igStore.ws.readyState!==WebSocket.CLOSED){_appStore2.default.igStore.ws.send(JSON.stringify({t:14,op:1}));}}},{key:'subscribeBets',value:function subscribeBets(){var _this7=this;clearTimeout(this.subscribeBetsTimer);if(_appStore2.default.igStore.ws&&_appStore2.default.igStore.ws.readyState===WebSocket.OPEN){_appStore2.default.igStore.ws.send(JSON.stringify({t:28,d:_jsCookie2.default.get('jwt'),op:0}));}else{if(this.subscribeBetsAttempt<5){this.subscribeBetsAttempt++;_appStore2.default.igStore.getSocket();this.subscribeBetsTimer=setTimeout(function(){return _this7.subscribeBets();},1000);}else{this.subscribeBetsAttempt=0;}}}},{key:'unsubscribeBets',value:function unsubscribeBets(){if(_appStore2.default.igStore.ws&&_appStore2.default.igStore.ws.readyState!==WebSocket.CLOSED){_appStore2.default.igStore.ws.send(JSON.stringify({t:28,op:1}));this.activeBetSellingData={};this.resetSelling();}}},{key:'openBetSellModal',value:function openBetSellModal(value){this.isBetSellModalOpened=value;}},{key:'setBetSellData',value:function setBetSellData(data,sellingData){this.activeBetData=data;this.activeBetSellingData=sellingData;}},{key:'resetSelling',value:function resetSelling(){this.sellingStatus={step:1,success:false,wait:false,isBlockedSell:false};this.clearResult();}},{key:'sellBet',value:function sellBet(wagerId,amount){var _this8=this;this.sellingStatus.wait=true;return _api2.default.user.sellBet(wagerId,amount).then((0,_mobx.action)(function(res){if(res.code==='OK'){if(res.result.is_sold){_this8.sellingStatus={step:2,success:true,wait:false,isBlockedSell:false};}else{switch(res.result.key){case'cashout__amount_changed':_this8.updatePrice(wagerId);break;case'cashout__not_allowed':_this8.sellingStatus={step:1,success:false,isBlockedSell:true};break;default:_this8.sellingStatus={step:1,success:false,isBlockedSell:false};break;}_this8.sellingStatus.wait=false;}_this8.setResult(res.result.message);}})).catch((0,_mobx.action)(function(){_this8.setResult('SERVER_TEMPORARILY_DOWN');}));}},{key:'saveSettings',value:function saveSettings(){if(this.access&&this.login){localStorage.setItem('account_settings',JSON.stringify({login:this.login,settings:this.accountSettings}));}}},{key:'closeForm',value:function closeForm(){this.phoneMask='(999) 999-99-99';this.lengthPhoneNumber=10;this.auth={cardID:'',phone:'',password:'',phone_prefix:'+7'};this.clearAuthError();}},{key:'toggleLoginFormVisible',value:function toggleLoginFormVisible(){this.showLoginForm=false;this.closeForm();}},{key:'inputAuth',value:function inputAuth(val,type){var number=val.replace(/\D+/g,"");this.statusdAuthForm.status=0;switch(type){case'phone':if(number.toString().length>0){this.auth.phone=number;}else{this.auth.phone='';}break;case'password':if(number.toString().length>0){this.auth.password=number;}else{this.auth.password='';}break;}}},{key:'setPrefix',value:function setPrefix(prefix){this.auth.phone_prefix=prefix;if(prefix==="+38"){this.correctPhone();this.phoneMask='(999) 999-99-9';this.lengthPhoneNumber=9;}else if(prefix==="+375"){this.correctPhone();this.phoneMask='(99) 999-99-99';this.lengthPhoneNumber=9;}else if(prefix==="+373"){this.correctPhone();this.phoneMask='(99) 99-99-99';this.lengthPhoneNumber=8;}else{this.phoneMask='(999) 999-99-99';this.lengthPhoneNumber=10;}}},{key:'correctPhone',value:function correctPhone(){if(this.auth.phone.toString().length>8){this.auth.phone=parseInt(this.auth.phone.toString().slice(0,-1));}}},{key:'setCardId',value:function setCardId(cardID){this.auth.cardID=cardID;}},{key:'toggleLoginForm',value:function toggleLoginForm(x){if(typeof x==='undefined'){this.showLoginForm=!this.showLoginForm;}else{this.showLoginForm=x;}}},{key:'sentLogin',value:function sentLogin(){var _this9=this;this.statusdAuthForm.disabled=1;this.clearAuthError();this.statusdAuthForm.wait=1;var data={phone:this.auth.phone,password:this.auth.password,phone_prefix:this.auth.phone_prefix};return _api2.default.auth.login(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_jsCookie2.default.set('user_logged_in',1);_this9.access=1;_this9.login=res.result.login;_this9.logout_hash=res.result.logout_hash;_this9.showLoginForm=false;_this9.changePsw=res.result.change_psw;_this9.hideRoutes=res.result.hide_routes;if(res.result.one_click_sum)_this9.accountSettings.oneClickBetAmount=res.result.one_click_sum;if(res.result.fast_amount){_this9.fastAmounts.amounts=res.result.fast_amount.data;_this9.fastAmounts.limits=res.result.fast_amount.rules;}var game=_appStore2.default.igStore.game;_appStore2.default.igStore.close();if(game){_appStore2.default.igStore.setGame(game,null);}// this.saveSettings();
// window.location = '/live';
_appStore2.default.initApp();_this9.init();if(!_this9.changePsw){_appStore2.default.history.push('/live');}}else if(res.code=='ERROR'){if(parseInt(res.result.attempts)>=0){_this9.statusdAuthForm.attempts=res.result.attempts;}else{_this9.statusdAuthForm.attempts='~';}_this9.setAuthError(res.text?res.text:'Сервер недоступен');}})).catch((0,_mobx.action)(function(err){_this9.setAuthError('Сервер недоступен');}));// .finally(action(() => { this.statusdAuthForm.disabled = 0; }));
}},{key:'cardLogin',value:function cardLogin(){var _this10=this;this.clearAuthError();this.statusdAuthForm.wait=1;this.statusdAuthForm.disabled=1;var data={card_id:this.auth.cardID,password:this.auth.password};return _api2.default.auth.loginCard(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_jsCookie2.default.set('user_logged_in',1);_this10.access=1;_this10.login=res.result.login;_this10.logout_hash=res.result.logout_hash;// window.location = '/live';
_this10.isCard=1;_this10.changePsw=res.result.change_psw;_this10.init();if(!_this10.changePsw){_appStore2.default.history.push('/live');}// this.saveSettings();
}else if(res.code=='ERROR'){if(parseInt(res.result.attempts)>=0){_this10.statusdAuthForm.attempts=res.result.attempts;}else{_this10.statusdAuthForm.attempts='~';}_this10.setAuthError(res.text?res.text:'INCORRECT_PASSWORD');}})).catch((0,_mobx.action)(function(err){_this10.setAuthError('SERVER_TEMPORARILY_DOWN');}));// .finally(action(() => { this.statusdAuthForm.disabled = 0; }));
}},{key:'setAuthError',value:function setAuthError(text){this.statusdAuthForm.status=1;this.statusdAuthForm.text=text;this.statusdAuthForm.wait=0;this.statusdAuthForm.disabled=0;}},{key:'clearAuthError',value:function clearAuthError(){this.statusdAuthForm.status=0;this.statusdAuthForm.text='';this.statusdAuthForm.disabled=0;this.statusdAuthForm.wait=0;}},{key:'logout',value:function logout(card){var _this11=this;var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{cleanup:false},cleanup=_ref.cleanup;/** Чистим корзину, только если был авторизован, либо принудительно */(this.access||cleanup)&&_appStore2.default.lineStore.basket.newClearBasketAfterBet();return _api2.default.auth.logout(this.logout_hash).then((0,_mobx.action)(function(res){if(res.code=='OK'){_jsCookie2.default.set('user_logged_in',0);// localStorage.removeItem(`account_settings_${this.login}`);
_this11.access=0;_this11.isCard=0;_this11.logout_hash='';_appStore2.default.igStore.handleLogout();_this11.unsubscribeCountBets();_this11.unsubscribeBets();// localStorage.clear();
if(!card)window.location='/';}})).catch((0,_mobx.action)(function(err){}));}},{key:'toggleAccountSettings',value:function toggleAccountSettings(k,v){this.accountSettings[k]=v;this.saveSettings();}// @computed get basketModifier(){
// 	// this.accountSettings.clearBasketAfterBet =
// 	basketStore.setData();
// }
},{key:'initPage',value:function initPage(type){if(type=='account'){this.AccountPage.init();}else if(type=='history'){this.HistoryPage=new _history2.default(this);}else if(type=='bets'){// this.BetsPage = new BetsPage(this);
this.BetsPage.init();}}},{key:'clear',value:function clear(type){if(type){this[type].clear=null;}else{// this.AccountPage = null;
this.HistoryPage=null;this.BetsPage.despose();}}},{key:'getBalance',value:function getBalance(){var _this12=this;return _api2.default.user.getBalance().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this12.balance=res.result.balance;}}));}},{key:'setFastAmount',value:function setFastAmount(amounts,callback){var _this13=this;if(!this.access){this.setResult('AUTH_ERROR');return false;}this.clearResult();if(amounts.every(function(el,index){return _this13.fastAmounts.amounts[index]===el;})){this.setResult('NO_CHANGES');return false;}this.waitFastForm=true;_api2.default.user.setFastAmount({data:amounts}).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this13.fastAmounts.amounts=res.result;callback();}else{_this13.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this13.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this13.waitFastForm=false;}));}},{key:'setResult',value:function setResult(text,type){this.result.status=1;this.result.text=text;this.result.type=type?type:0;}},{key:'clearResult',value:function clearResult(){this.result.status=0;this.result.text='';this.result.type=0;}},{key:'showChangePass',get:function get(){return _appStore2.default.terminalAccess&&this.access&&this.changePsw;}},{key:'getHideRoutes',get:function get(){return this.hideRoutes||[];}}]);return accountStore;}(),(_descriptor4=_applyDecoratedDescriptor(_class4.prototype,'autoLogout',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class4.prototype,'isCard',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class4.prototype,'changePsw',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class4.prototype,'AccountPage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor8=_applyDecoratedDescriptor(_class4.prototype,'BetsPage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class4.prototype,'HistoryPage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor10=_applyDecoratedDescriptor(_class4.prototype,'access',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor11=_applyDecoratedDescriptor(_class4.prototype,'login',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor12=_applyDecoratedDescriptor(_class4.prototype,'showLoginForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class4.prototype,'lengthPhoneNumber',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 10;}}),_descriptor14=_applyDecoratedDescriptor(_class4.prototype,'fastAmounts',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{amounts:[100,500,1000],limits:{max:999999,min:50}};}}),_descriptor15=_applyDecoratedDescriptor(_class4.prototype,'auth',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{cardID:'',phone:'',password:'',phone_prefix:'+7'};}}),_descriptor16=_applyDecoratedDescriptor(_class4.prototype,'logout_hash',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor17=_applyDecoratedDescriptor(_class4.prototype,'phoneMask',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'(999) 999-99-99';}}),_descriptor18=_applyDecoratedDescriptor(_class4.prototype,'balance',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor19=_applyDecoratedDescriptor(_class4.prototype,'countBets',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor20=_applyDecoratedDescriptor(_class4.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_descriptor21=_applyDecoratedDescriptor(_class4.prototype,'disabledAuthForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor22=_applyDecoratedDescriptor(_class4.prototype,'statusdAuthForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{attempts:'~',error:'',status:0,disabled:0,wait:0};}}),_descriptor23=_applyDecoratedDescriptor(_class4.prototype,'isBetSellModalOpened',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor24=_applyDecoratedDescriptor(_class4.prototype,'activeBetData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor25=_applyDecoratedDescriptor(_class4.prototype,'activeBetSellingData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor26=_applyDecoratedDescriptor(_class4.prototype,'betsSellingData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor27=_applyDecoratedDescriptor(_class4.prototype,'sellingStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{// статус продажи ставки
step:1,success:false,wait:false,isBlockedSell:false};}}),_descriptor28=_applyDecoratedDescriptor(_class4.prototype,'accountSettings',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{clearBasketAfterBet:0,loadRossLive:0,highlightChangesLive:1,colorizeSport:1,basketAgreeCf:0,showHeaderBalance:1,oneClickBet:0,oneClickBetAmount:0,showPopup:1,showBetPopup:0,// linePrintMode : 1,
gamesNumber:1,basketPosition:'right',// TODO КОСТЫЛЬ: 1 - значит подсказка была показана
is_basket_tooltip_visible:1,tooltip_union_stat_match:0};}}),_descriptor29=_applyDecoratedDescriptor(_class4.prototype,'hideRoutes',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class4.prototype,'hideBalance',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'hideBalance'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'init'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'subscribeCountBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'subscribeCountBets'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'unsubscribeCountBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'unsubscribeCountBets'),_class4.prototype),_descriptor30=_applyDecoratedDescriptor(_class4.prototype,'updateCountBets',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(count){if(!!count){_this14.countBets=count;}else{_this14.countBets=0;}};}}),_applyDecoratedDescriptor(_class4.prototype,'subscribeBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'subscribeBets'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'unsubscribeBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'unsubscribeBets'),_class4.prototype),_descriptor31=_applyDecoratedDescriptor(_class4.prototype,'updateBets',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(bets){if(bets.diff===false){_this15.betsSellingData=bets;}else{_this15.betsSellingData=_extends({},_this15.betsSellingData,bets);}};}}),_applyDecoratedDescriptor(_class4.prototype,'openBetSellModal',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'openBetSellModal'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'setBetSellData',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setBetSellData'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'resetSelling',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'resetSelling'),_class4.prototype),_descriptor32=_applyDecoratedDescriptor(_class4.prototype,'updatePrice',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(wagerId){_this16.activeBetSellingData=_extends({},_this16.activeBetSellingData,{price:_this16.betsSellingData[wagerId].price});};}}),_applyDecoratedDescriptor(_class4.prototype,'sellBet',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'sellBet'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'saveSettings',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'saveSettings'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'closeForm',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'closeForm'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'inputAuth',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'inputAuth'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'setPrefix',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setPrefix'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'correctPhone',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'correctPhone'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'setCardId',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setCardId'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'toggleLoginForm',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'toggleLoginForm'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'sentLogin',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'sentLogin'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'cardLogin',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'cardLogin'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'showChangePass',[_mobx.computed],Object.getOwnPropertyDescriptor(_class4.prototype,'showChangePass'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'setAuthError',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setAuthError'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'clearAuthError',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'clearAuthError'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'logout',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'logout'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'toggleAccountSettings',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'toggleAccountSettings'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'initPage',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'initPage'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'clear'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'getBalance',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'getBalance'),_class4.prototype),_descriptor33=_applyDecoratedDescriptor(_class4.prototype,'waitFastForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class4.prototype,'setFastAmount',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setFastAmount'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'setResult'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'clearResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class4.prototype,'clearResult'),_class4.prototype),_applyDecoratedDescriptor(_class4.prototype,'getHideRoutes',[_mobx.computed],Object.getOwnPropertyDescriptor(_class4.prototype,'getHideRoutes'),_class4.prototype)),_class4);exports.default=new accountStore();

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(109),
    overRest = __webpack_require__(657),
    setToString = __webpack_require__(659);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(51);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var project=JSON.parse(String("{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}"));var config={APP_URL:"",API_URL:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).API_URL,FOLDER:project.folder,IS_SERVER:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).IS_SERVER,APP_NAME:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).APP_NAME||project.appName,BASE_URL:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).BASE_URL,VERSION:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).VERSION,LOCALE_PREFIX:project.localePrefix||'',GTM:project.GTM,USE_CDN:project.useCDN,CDN_FOLDER:project.cdnFolder||'',IS_PROD:"production"==='production',TYPE:project.type||'com',LIVE_WSS_DISABLED:!!project.LIVE_WSS_DISABLED,WSS_PROXY_URL:project.WSS_PROXY_URL,IS_DEV:"production"==='development',IS_TEST:Object({"NODE_ENV":"production","PUBLIC_URL":"","APP_URL":"","TERMINAL":undefined,"PROJECT":"{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}","REACT_APP_DECORATORS":"true","REACT_APP_BABEL_STAGE_0":"true"}).BUILD_ENV==='test',IS_MOBILE:project.isMobile||false};var setConfig=exports.setConfig=function setConfig(key,val){config[key]=val;};var getConfig=exports.getConfig=function getConfig(key){return config[key]||'';};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    getRawTag = __webpack_require__(496),
    objectToString = __webpack_require__(497);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(230);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DictStore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var DictStore=exports.DictStore=(_class=function(){function DictStore(){_classCallCheck(this,DictStore);_initDefineProp(this,'lang',_descriptor,this);_initDefineProp(this,'dict',_descriptor2,this);this.data={};}// reg_exp_ru = new RegExp('[[А-Яа-я]+');
_createClass(DictStore,[{key:'add',value:function add(data){for(var i in data){this.dict[i]=data[i];}}},{key:'getLang',value:function getLang(key,replace){var lang='';if(!key){return key;}else if(this&&this.dict&&this.dict[key]){lang=this.dict[key];}else if(window.dict_data&&window.dict_data[key]){lang=window.dict_data[key];}else if(new RegExp('[[А-Яа-я]+').test(key)===false){lang=key.toString().toLowerCase().split('_').join(' ');if(lang.length){lang=lang[0].toUpperCase()+lang.substr(1);}}else{lang=key;}if(replace){lang=this.replace(lang,replace);}return lang;}},{key:'replace',value:function replace(text,opts){for(var i in opts){text=(0,_common.replaceAll)('{'+i+'}',opts[i],text);//text = text.replace('{' + i + '}', opts[i]);
}return text;}},{key:'addDict',value:function addDict(data){if(!data){return;}if(data.dict){for(var i in data.dict){if(!this.data[i]){this.data[i]={};}for(var j in data.dict[i]){this.data[i][j]=data.dict[i][j];}}}}},{key:'getBy',value:function getBy(subject,key){if(this.data){if(this.data[subject]){if(this.data[subject][key]){return this.data[subject][key];}}}return'';}}]);return DictStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'lang',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'getLang',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getLang'),_class.prototype)),_class);exports.default=new DictStore();

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _FavoriteStar=__webpack_require__(369);Object.defineProperty(exports,'FavoriteStar',{enumerable:true,get:function get(){return _FavoriteStar.FavoriteStar;}});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JssContext", function() { return JssContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JssProvider", function() { return JssProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJsx", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUseStyles", function() { return createUseStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jss", function() { return defaultJss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsx", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "styled", function() { return configureStyled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStyles", function() { return createWithStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_theming__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_4_theming__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTheming", function() { return __WEBPACK_IMPORTED_MODULE_4_theming__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useTheme", function() { return __WEBPACK_IMPORTED_MODULE_4_theming__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_4_theming__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_is_in_browser__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jss__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SheetsRegistry", function() { return __WEBPACK_IMPORTED_MODULE_7_jss__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createGenerateId", function() { return __WEBPACK_IMPORTED_MODULE_7_jss__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jss_preset_default__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shallow_equal__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emotion_is_prop_valid__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_css_jss__ = __webpack_require__(404);















var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var memoize = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (Array.isArray(lastArgs) && args.length === lastArgs.length) {
      var isSame = true;

      for (var i = 0; i < args.length; i++) {
        if (args[i] !== lastArgs[i]) {
          isSame = false;
        }
      }

      if (isSame) {
        return lastResult;
      }
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

var mergeClasses = function mergeClasses(baseClasses, additionalClasses) {
  var combinedClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  for (var name in additionalClasses) {
    combinedClasses[name] = name in combinedClasses ? combinedClasses[name] + " " + additionalClasses[name] : additionalClasses[name];
  }

  return combinedClasses;
};

/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * We start at [Number.MIN_SAFE_INTEGER] to always insert sheets from react-jss first before any
 * sheet which might be inserted manually by the user.
 */
var index = Number.MIN_SAFE_INTEGER || -1e9;

var getSheetIndex = function getSheetIndex() {
  return index++;
};

var JssContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])({
  classNamePrefix: '',
  disableStylesGeneration: false,
  isSSR: !__WEBPACK_IMPORTED_MODULE_5_is_in_browser__["a" /* default */]
});

var defaultManagers = new Map();
var getManager = function getManager(context, managerId) {
  // If `managers` map is present in the context, we use it in order to
  // let JssProvider reset them when new response has to render server-side.
  var managers = context.managers;

  if (managers) {
    if (!managers[managerId]) {
      managers[managerId] = new __WEBPACK_IMPORTED_MODULE_7_jss__["b" /* SheetsManager */]();
    }

    return managers[managerId];
  }

  var manager = defaultManagers.get(managerId);

  if (!manager) {
    manager = new __WEBPACK_IMPORTED_MODULE_7_jss__["b" /* SheetsManager */]();
    defaultManagers.set(managerId, manager);
  }

  return manager;
};
var manageSheet = function manageSheet(options) {
  var sheet = options.sheet,
      context = options.context,
      index = options.index,
      theme = options.theme;

  if (!sheet) {
    return;
  }

  var manager = getManager(context, index);
  manager.manage(theme);

  if (context.registry) {
    context.registry.add(sheet);
  }
};
var unmanageSheet = function unmanageSheet(options) {
  if (!options.sheet) {
    return;
  }

  var manager = getManager(options.context, options.index);
  manager.unmanage(options.theme);
};

var defaultJss = Object(__WEBPACK_IMPORTED_MODULE_7_jss__["d" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_8_jss_preset_default__["a" /* default */])());

var sheetsMeta = new WeakMap();
var getMeta = function getMeta(sheet) {
  return sheetsMeta.get(sheet);
};
var addMeta = function addMeta(sheet, meta) {
  sheetsMeta.set(sheet, meta);
};

var getStyles = function getStyles(options) {
  var styles = options.styles;

  if (typeof styles !== 'function') {
    return styles;
  }

   false ? warning(styles.length !== 0, "[JSS] <" + (options.name || 'Hook') + " />'s styles function doesn't rely on the \"theme\" argument. We recommend declaring styles as an object instead.") : void 0;
  return styles(options.theme);
};

function getSheetOptions(options, link) {
  var minify;

  if (options.context.id && options.context.id.minify != null) {
    minify = options.context.id.minify;
  }

  var classNamePrefix = options.context.classNamePrefix || '';

  if (options.name && !minify) {
    classNamePrefix += options.name.replace(/\s/g, '-') + "-";
  }

  var meta = '';
  if (options.name) meta = options.name + ", ";
  meta += typeof options.styles === 'function' ? 'Themed' : 'Unthemed';
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options.sheetOptions, {
    index: options.index,
    meta: meta,
    classNamePrefix: classNamePrefix,
    link: link,
    generateId: options.sheetOptions && options.sheetOptions.generateId ? options.sheetOptions.generateId : options.context.generateId
  });
}

var createStyleSheet = function createStyleSheet(options) {
  if (options.context.disableStylesGeneration) {
    return undefined;
  }

  var manager = getManager(options.context, options.index);
  var existingSheet = manager.get(options.theme);

  if (existingSheet) {
    return existingSheet;
  }

  var jss = options.context.jss || defaultJss;
  var styles = getStyles(options);
  var dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_7_jss__["g" /* getDynamicStyles */])(styles);
  var sheet = jss.createStyleSheet(styles, getSheetOptions(options, dynamicStyles !== null));
  addMeta(sheet, {
    dynamicStyles: dynamicStyles,
    styles: styles
  });
  manager.add(options.theme, sheet);
  return sheet;
};
var removeDynamicRules = function removeDynamicRules(sheet, rules) {
  // Loop over each dynamic rule and remove the dynamic rule
  // We can't just remove the whole sheet as this has all of the rules for every component instance
  for (var key in rules) {
    sheet.deleteRule(rules[key]);
  }
};
var updateDynamicRules = function updateDynamicRules(data, sheet, rules) {
  // Loop over each dynamic rule and update it
  // We can't just update the whole sheet as this has all of the rules for every component instance
  for (var key in rules) {
    sheet.updateOne(rules[key], data);
  }
};
var addDynamicRules = function addDynamicRules(sheet, data) {
  var meta = getMeta(sheet);

  if (!meta) {
    return undefined;
  }

  var rules = {}; // Loop over each dynamic rule and add it to the stylesheet

  for (var key in meta.dynamicStyles) {
    var initialRuleCount = sheet.rules.index.length;
    var originalRule = sheet.addRule(key, meta.dynamicStyles[key]); // Loop through all created rules, fixes updating dynamic rules

    for (var i = initialRuleCount; i < sheet.rules.index.length; i++) {
      var rule = sheet.rules.index[i];
      sheet.updateOne(rule, data); // If it's the original rule, we need to add it by the correct key so the hook and hoc
      // can correctly concat the dynamic class with the static one

      rules[originalRule === rule ? key : rule.key] = rule;
    }
  }

  return rules;
};

var getSheetClasses = function getSheetClasses(sheet, dynamicRules) {
  if (!dynamicRules) {
    return sheet.classes;
  }

  var meta = getMeta(sheet);

  if (!meta) {
    return sheet.classes;
  }

  var classes = {};

  for (var key in meta.styles) {
    classes[key] = sheet.classes[key];

    if (key in dynamicRules) {
      classes[key] += " " + sheet.classes[dynamicRules[key].key];
    }
  }

  return classes;
};

function getUseInsertionEffect(isSSR) {
  return isSSR ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useInsertionEffect || // React 18+ (https://github.com/reactwg/react-18/discussions/110)
  __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
}

var noTheme = {};

var createUseStyles = function createUseStyles(styles, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$index = _options.index,
      index = _options$index === void 0 ? getSheetIndex() : _options$index,
      theming = _options.theming,
      name = _options.name,
      sheetOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_options, ["index", "theming", "name"]);

  var ThemeContext$1 = theming && theming.context || __WEBPACK_IMPORTED_MODULE_4_theming__["a" /* ThemeContext */];

  var useTheme = function useTheme(theme) {
    if (typeof styles === 'function') {
      return theme || Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(ThemeContext$1) || noTheme;
    }

    return noTheme;
  };

  var emptyObject = {};
  return function useStyles(data) {
    var isFirstMount = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(true);
    var context = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(JssContext);
    var theme = useTheme(data && data.theme);

    var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
      var newSheet = createStyleSheet({
        context: context,
        styles: styles,
        name: name,
        theme: theme,
        index: index,
        sheetOptions: sheetOptions
      });

      if (newSheet && context.isSSR) {
        // manage immediately during SSRs. browsers will manage the sheet through useInsertionEffect below
        manageSheet({
          index: index,
          context: context,
          sheet: newSheet,
          theme: theme
        });
      }

      return [newSheet, newSheet ? addDynamicRules(newSheet, data) : null];
    }, [context, theme]),
        sheet = _useMemo[0],
        dynamicRules = _useMemo[1];

    getUseInsertionEffect(context.isSSR)(function () {
      // We only need to update the rules on a subsequent update and not in the first mount
      if (sheet && dynamicRules && !isFirstMount.current) {
        updateDynamicRules(data, sheet, dynamicRules);
      }
    }, [data]);
    getUseInsertionEffect(context.isSSR)(function () {
      if (sheet) {
        manageSheet({
          index: index,
          context: context,
          sheet: sheet,
          theme: theme
        });
      }

      return function () {
        if (sheet) {
          unmanageSheet({
            index: index,
            context: context,
            sheet: sheet,
            theme: theme
          }); // when sheet changes, remove related dynamic rules

          if (dynamicRules) {
            removeDynamicRules(sheet, dynamicRules);
          }
        }
      };
    }, [sheet]);
    var classes = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
      return sheet && dynamicRules ? getSheetClasses(sheet, dynamicRules) : emptyObject;
    }, [sheet, dynamicRules]);
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useDebugValue"])(classes);
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useDebugValue"])(theme === noTheme ? 'No theme' : theme);
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      isFirstMount.current = false;
    });
    return classes;
  };
};

var NoRenderer = function NoRenderer(props) {
  return props.children || null;
};
/**
 * HOC creator function that wrapps the user component.
 *
 * `withStyles(styles, [options])(Component)`
 */


var createWithStyles = function createWithStyles(styles, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$index = _options.index,
      index = _options$index === void 0 ? getSheetIndex() : _options$index,
      theming = _options.theming,
      injectTheme = _options.injectTheme,
      sheetOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_options, ["index", "theming", "injectTheme"]);

  var ThemeContext$1 = theming ? theming.context : __WEBPACK_IMPORTED_MODULE_4_theming__["a" /* ThemeContext */];
  return function (InnerComponent) {
    if (InnerComponent === void 0) {
      InnerComponent = NoRenderer;
    }

    var displayName = getDisplayName(InnerComponent);
    var mergeClassesProp = memoize(function (sheetClasses, classesProp) {
      return classesProp ? mergeClasses(sheetClasses, classesProp) : sheetClasses;
    });
    var hookOptions = Object.assign(sheetOptions, {
      theming: theming,
      index: index,
      name: displayName
    });
    var useStyles = createUseStyles(styles, hookOptions);
    var WithStyles = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
      var theme = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(ThemeContext$1);

      var newProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

      if (injectTheme && newProps.theme == null) {
        newProps.theme = theme;
      }

      var sheetClasses = useStyles(newProps);
      var classes = mergeClassesProp(sheetClasses, props.classes);
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(InnerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, newProps, {
        classes: classes,
        ref: ref
      }));
    });
    WithStyles.displayName = "WithStyles(" + displayName + ")";
    WithStyles.defaultProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, InnerComponent.defaultProps);
    WithStyles.InnerComponent = InnerComponent;
    return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithStyles, InnerComponent);
  };
};

var initialContext = {};
function JssProvider(props) {
  var managersRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])({});
  var prevContextRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();
  var registryRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);

  var createContext = function createContext(parentContext, prevContext) {
    if (prevContext === void 0) {
      prevContext = initialContext;
    }

    var registry = props.registry,
        classNamePrefix = props.classNamePrefix,
        jss = props.jss,
        generateId = props.generateId,
        disableStylesGeneration = props.disableStylesGeneration,
        media = props.media,
        id = props.id,
        isSSR = props.isSSR;

    var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parentContext);

    if (registry) {
      context.registry = registry; // This way we identify a new request on the server, because user will create
      // a new Registry instance for each.

      if (registry !== registryRef.current) {
        // We reset managers because we have to regenerate all sheets for the new request.
        managersRef.current = {};
        registryRef.current = registry;
      }
    }

    context.managers = managersRef.current;

    if (id !== undefined) {
      context.id = id;
    }

    if (generateId !== undefined) {
      context.generateId = generateId;
    } else if (!context.generateId || !prevContext || context.id !== prevContext.id) {
      context.generateId = Object(__WEBPACK_IMPORTED_MODULE_7_jss__["e" /* createGenerateId */])(context.id);
    }

    if (classNamePrefix) {
      context.classNamePrefix = (context.classNamePrefix || '') + classNamePrefix;
    }

    if (media !== undefined) {
      context.media = media;
    }

    if (jss) {
      context.jss = jss;
    }

    if (disableStylesGeneration !== undefined) {
      context.disableStylesGeneration = disableStylesGeneration;
    }

    if (isSSR !== undefined) {
      context.isSSR = isSSR;
    }

    if (prevContext && Object(__WEBPACK_IMPORTED_MODULE_9_shallow_equal__["a" /* shallowEqualObjects */])(prevContext, context)) {
      return prevContext;
    }

    return context;
  };

  var renderProvider = function renderProvider(parentContext) {
    var children = props.children;
    var context = createContext(parentContext, prevContextRef.current);
    prevContextRef.current = context;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(JssContext.Provider, {
      value: context
    }, children);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(JssContext.Consumer, null, renderProvider);
}

var parseStyles = function parseStyles(args) {
  var dynamicStyles = [];
  var staticStyle;
  var labels = []; // Not using ...rest to optimize perf.

  for (var key in args) {
    var style = args[key];
    if (!style) continue;

    if (typeof style === 'function') {
      dynamicStyles.push(style);
    } else {
      if (!staticStyle) staticStyle = {};
      Object.assign(staticStyle, style);
      var _staticStyle = staticStyle,
          _label = _staticStyle.label;

      if (_label) {
        if (labels.indexOf(_label) === -1) labels.push(_label);
      }
    }
  }

  var styles = {};
  var label = labels.length === 0 ? 'sc' : labels.join('-');

  if (staticStyle) {
    // Label should not leak to the core.
    if ('label' in staticStyle) delete staticStyle.label;
    styles[label] = staticStyle;
  } // When there is only one function rule, we don't need to wrap it.


  if (dynamicStyles.length === 1) {
    styles.scd = dynamicStyles[0];
  } // We create a new function rule which will call all other function rules
  // and merge the styles they return.


  if (dynamicStyles.length > 1) {
    styles.scd = function (props) {
      var merged = {};

      for (var i = 0; i < dynamicStyles.length; i++) {
        var dynamicStyle = dynamicStyles[i](props);
        if (dynamicStyle) Object.assign(merged, dynamicStyle);
      }

      return merged;
    };
  }

  return {
    styles: styles,
    label: label
  };
};

var shouldForwardPropSymbol = Symbol('react-jss-styled');

var getShouldForwardProp = function getShouldForwardProp(tagOrComponent, options) {
  var shouldForwardProp = options.shouldForwardProp;
  var childShouldForwardProp = tagOrComponent[shouldForwardPropSymbol];
  var finalShouldForwardProp = shouldForwardProp || childShouldForwardProp;

  if (shouldForwardProp && childShouldForwardProp) {
    finalShouldForwardProp = function finalShouldForwardProp(prop) {
      return childShouldForwardProp(prop) && shouldForwardProp(prop);
    };
  }

  return finalShouldForwardProp;
};

var getChildProps = function getChildProps(props, shouldForwardProp, isTag) {
  var childProps = {};

  for (var prop in props) {
    if (shouldForwardProp) {
      if (shouldForwardProp(prop) === true) {
        childProps[prop] = props[prop];
      }

      continue;
    } // We don't want to pass non-dom props to the DOM.


    if (isTag) {
      if (Object(__WEBPACK_IMPORTED_MODULE_10__emotion_is_prop_valid__["a" /* default */])(prop)) {
        childProps[prop] = props[prop];
      }

      continue;
    }

    childProps[prop] = props[prop];
  }

  return childProps;
}; // eslint-disable-next-line no-unused-vars


var configureStyled = function configureStyled(tagOrComponent, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      theming = _options.theming;
  var isTag = typeof tagOrComponent === 'string';
  var ThemeContext$1 = theming ? theming.context : __WEBPACK_IMPORTED_MODULE_4_theming__["a" /* ThemeContext */];
  var shouldForwardProp = getShouldForwardProp(tagOrComponent, options);

  var _options2 = options,
      _ = _options2.shouldForwardProp,
      hookOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_options2, ["shouldForwardProp"]);

  return function createStyledComponent() {
    // eslint-disable-next-line prefer-rest-params
    var _parseStyles = parseStyles(arguments),
        styles = _parseStyles.styles,
        label = _parseStyles.label;

    var useStyles = createUseStyles(styles, hookOptions);

    var Styled = function Styled(props) {
      var as = props.as,
          className = props.className;
      var theme = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(ThemeContext$1);
      var propsWithTheme = Object.assign({
        theme: theme
      }, props);
      var classes = useStyles(propsWithTheme);
      var childProps = getChildProps(props, shouldForwardProp, isTag);
      var classNames = ((classes[label] || classes.sc || '') + " " + (classes.scd || '')).trim();
      childProps.className = className ? className + " " + classNames : classNames;

      if (!isTag && shouldForwardProp) {
        tagOrComponent[shouldForwardPropSymbol] = shouldForwardProp;
      }

      if (isTag && as) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(as, childProps);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(tagOrComponent, childProps);
    };

    return Styled;
  };
};

/* eslint-disable prefer-rest-params, prefer-spread */
var create = function create(css) {
  if (css === void 0) {
    css = __WEBPACK_IMPORTED_MODULE_11_css_jss__["a" /* default */];
  }

  return function createElement$1(type, props) {
    var args = arguments;

    if (props && props.css) {
      var className = css(props.css);
      var newProps = Object.assign({}, props);
      newProps.className = props.className ? props.className + " " + className : className;
      delete newProps.css;
      args[1] = newProps;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"].apply(undefined, args);
  };
};
var jsx = create();

/* harmony default export */ __webpack_exports__["default"] = (createWithStyles);



/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sendLogKafka=exports.Events=undefined;var _kafka=__webpack_require__(94);var _KafkaLogger=__webpack_require__(409);exports.Events=_kafka.Events;var sendLogKafka=exports.sendLogKafka=function sendLogKafka(eventName,detail){_KafkaLogger.KafkaLogger.getInstance().sendLog(eventName,detail);};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(417);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AllMobileCategories=exports.ALL_CATEGORY_ID=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.createAllCategoryState=createAllCategoryState;var _lib=__webpack_require__(12);var _Base=__webpack_require__(434);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ALL_CATEGORY_ID=exports.ALL_CATEGORY_ID='ALL';/**
 * Категории с доп. категоией ВСЕ
 */var AllMobileCategories=exports.AllMobileCategories=function(_BaseMobileCategories){_inherits(AllMobileCategories,_BaseMobileCategories);function AllMobileCategories(){_classCallCheck(this,AllMobileCategories);return _possibleConstructorReturn(this,(AllMobileCategories.__proto__||Object.getPrototypeOf(AllMobileCategories)).apply(this,arguments));}_createClass(AllMobileCategories,[{key:'update',/**
     * Обновление фильтра таблицы доп.росписи
     * приходит полностью новое состояние, отсутсвующие категории удаляются
     * @example
     * ```
     *    categories.update(matchID, {
     *       [categoryID]: { isSelected: !categoryTab.isSelected }
     *    });
     * ```
     */value:function update(matchID){var sportID=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.sportID[matchID];var config=arguments[2];var categoriesLabels=arguments[3];var newStates=arguments[4];var selected=arguments[5];if(newStates===null||categoriesLabels===null){this.clearGame(matchID);this.notify(matchID);return;}if(!newStates){return;}var prevStates=this.getData(matchID);if(!prevStates){var categoryAllState=createAllCategoryState(newStates,!selected||selected.length===0);var categories=_defineProperty({},ALL_CATEGORY_ID,categoryAllState);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(newStates)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var categoryID=_step.value;categories[categoryID]=Object.assign(Object.assign({},newStates[categoryID]),config);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(categoriesLabels){categoriesLabels.forEach(function(_ref){var id=_ref.id,txt=_ref.txt;categories[id].label=txt;});this.order.set(matchID,[ALL_CATEGORY_ID].concat(categoriesLabels.map(function(_ref2){var id=_ref2.id;return id;})));}this.sportID[matchID]=sportID;this.data.set(matchID,categories);this.selectedCategories.set(matchID,new Set());this.select(matchID,selected||[],true);this.notify(matchID);return;}// обновляем существующие категории
(0,_lib.objectEntries)(newStates).forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),categoryID=_ref4[0],newState=_ref4[1];prevStates[categoryID]=Object.assign(prevStates[categoryID]||{},newState,config);});prevStates[ALL_CATEGORY_ID]=createAllCategoryState(newStates,prevStates[ALL_CATEGORY_ID]&&prevStates[ALL_CATEGORY_ID].isSelected);if(categoriesLabels){categoriesLabels.forEach(function(_ref5){var id=_ref5.id,txt=_ref5.txt;prevStates[id].label=txt;});this.order.set(matchID,[ALL_CATEGORY_ID].concat(categoriesLabels.map(function(_ref6){var id=_ref6.id;return id;})));}var updatedCategories=Object.keys(newStates).concat(ALL_CATEGORY_ID);var toDelete=Object.keys(prevStates).filter(function(categoryID){return updatedCategories.indexOf(categoryID)===-1;});this.deleteCategories(matchID,toDelete);this.notify(matchID);}},{key:'select',value:function select(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.has(matchID)&&this.selectedCategories.get(matchID).values()||[]);var isSelected=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!this.selectedCategories.has(matchID)){return;}var selectedCategories=this.selectedCategories.get(matchID);if(categoryIDs.indexOf(ALL_CATEGORY_ID)!==-1){this.unselectCategories(matchID);return;}if(!isSelected){this.unselectCategories(matchID,categoryIDs);return;}var unselectCategories=(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:false}];}));selectedCategories.clear();categoryIDs[0]&&selectedCategories.add(categoryIDs[0]);var newStates=Object.assign(Object.assign(_defineProperty({},ALL_CATEGORY_ID,{isSelected:selectedCategories.size===0}),unselectCategories),_defineProperty({},categoryIDs[0],{isSelected:true}));this.selectTables(matchID);this.assignStates(matchID,newStates);}},{key:'unselectCategories',value:function unselectCategories(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.has(matchID)&&this.selectedCategories.get(matchID).values()||[]);var selectedCategories=this.selectedCategories.get(matchID);categoryIDs.forEach(function(c){selectedCategories.delete(c);});var noCategoriesSelected=selectedCategories.size===0;var newStates=Object.assign(// очередность важна, isSelected:true должны быть в конце
!noCategoriesSelected&&_defineProperty({},ALL_CATEGORY_ID,{isSelected:false}),(0,_lib.objectFromEntries)(categoryIDs.map(function(categoryID){return[categoryID,{isSelected:false}];})),(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:true}];})),noCategoriesSelected&&_defineProperty({},ALL_CATEGORY_ID,{isSelected:true}));this.assignStates(matchID,newStates);this.selectTables(matchID);}}]);return AllMobileCategories;}(_Base.BaseMobileCategories);function createAllCategoryState(data){var isSelected=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var tables=(0,_lib.objectValues)(data).reduce(function(tables,state){return tables.concat(state.tables||[]);},[]);return{tables:tables,isSelected:isSelected,isFavoriteDisabled:true};}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(42);

var _LocaleUtils = __webpack_require__(61);

var _classNames = __webpack_require__(63);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(522),
    listCacheDelete = __webpack_require__(523),
    listCacheGet = __webpack_require__(524),
    listCacheHas = __webpack_require__(525),
    listCacheSet = __webpack_require__(526);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(185);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(540);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105),
    setCacheAdd = __webpack_require__(545),
    setCacheHas = __webpack_require__(546);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(108);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object,
      preload: bool
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      preload: bool
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;
var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  light: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      preload: false
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.13.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onBufferEnd: function onBufferEnd() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};
exports.defaultProps = defaultProps;
var DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];
exports.DEPRECATED_CONFIG_PROPS = DEPRECATED_CONFIG_PROPS;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(103),
    isObjectLike = __webpack_require__(43);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(70),
    arrayIncludes = __webpack_require__(119),
    arrayIncludesWith = __webpack_require__(120),
    cacheHas = __webpack_require__(71),
    createSet = __webpack_require__(667),
    setToArray = __webpack_require__(106);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.prototype.finally` requires a global `Promise` be available.');
	}
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(47);

var predicates = {
	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

module.exports = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(52);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _trackHelper = __webpack_require__(139);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helpers = {
  initialize: function initialize(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);

    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });

      this.autoPlay(); // once we're set up, trigger the initial autoplay.
    });
  },
  update: function update(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);
    // This method has mostly same code as initialize method.
    // Refactor it
    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    // pause slider if autoplay is set to false
    if (!props.autoplay) {
      this.pause();
    } else {
      this.autoPlay();
    }

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });
    });
  },
  getWidth: function getWidth(elem) {
    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
  },
  getHeight: function getHeight(elem) {
    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
  },

  adaptHeight: function adaptHeight() {
    if (this.props.adaptiveHeight) {
      var selector = '[data-index="' + this.state.currentSlide + '"]';
      if (this.list) {
        var slickList = _reactDom2.default.findDOMNode(this.list);
        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
      }
    }
  },
  canGoNext: function canGoNext(opts) {
    var canGo = true;
    if (!opts.infinite) {
      if (opts.centerMode) {
        // check if current slide is last slide
        if (opts.currentSlide >= opts.slideCount - 1) {
          canGo = false;
        }
      } else {
        // check if all slides are shown in slider
        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
          canGo = false;
        }
      }
    }
    return canGo;
  },
  slideHandler: function slideHandler(index) {
    var _this = this;

    // Functionality of animateSlide and postSlide is merged into this function
    // console.log('slideHandler', index);
    var targetSlide, currentSlide;
    var targetLeft, currentLeft;
    var callback;

    if (this.props.waitForAnimate && this.state.animating) {
      return;
    }

    if (this.props.fade) {
      currentSlide = this.state.currentSlide;

      // Don't change slide if it's not infite and current slide is the first or last slide.
      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
        return;
      }

      //  Shifting targetSlide back into the range
      if (index < 0) {
        targetSlide = index + this.state.slideCount;
      } else if (index >= this.state.slideCount) {
        targetSlide = index - this.state.slideCount;
      } else {
        targetSlide = index;
      }

      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
        });
      }

      callback = function callback() {
        _this.setState({
          animating: false
        });
        if (_this.props.afterChange) {
          _this.props.afterChange(targetSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: targetSlide
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });

      if (this.props.beforeChange) {
        this.props.beforeChange(this.state.currentSlide, targetSlide);
      }

      this.autoPlay();
      return;
    }

    targetSlide = index;
    if (targetSlide < 0) {
      if (this.props.infinite === false) {
        currentSlide = 0;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
      } else {
        currentSlide = this.state.slideCount + targetSlide;
      }
    } else if (targetSlide >= this.state.slideCount) {
      if (this.props.infinite === false) {
        currentSlide = this.state.slideCount - this.props.slidesToShow;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = 0;
      } else {
        currentSlide = targetSlide - this.state.slideCount;
      }
    } else {
      currentSlide = targetSlide;
    }

    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: targetSlide,
      trackRef: this.track
    }, this.props, this.state));

    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    if (this.props.infinite === false) {
      targetLeft = currentLeft;
    }

    if (this.props.beforeChange) {
      this.props.beforeChange(this.state.currentSlide, currentSlide);
    }

    if (this.props.lazyLoad) {
      var loaded = true;
      var slidesToLoad = [];
      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
        if (!loaded) {
          slidesToLoad.push(i);
        }
      }
      if (!loaded) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
        });
      }
    }

    // Slide Transition happens here.
    // animated transition happens to target Slide and
    // non - animated transition happens to current Slide
    // If CSS transitions are false, directly go the current slide.

    if (this.props.useCSS === false) {

      this.setState({
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      }, function () {
        if (this.props.afterChange) {
          this.props.afterChange(currentSlide);
        }
      });
    } else {

      var nextStateChanges = {
        animating: false,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
        swipeLeft: null
      };

      callback = function callback() {
        _this.setState(nextStateChanges);
        if (_this.props.afterChange) {
          _this.props.afterChange(currentSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });
    }

    this.autoPlay();
  },
  swipeDirection: function swipeDirection(touchObject) {
    var xDist, yDist, r, swipeAngle;

    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return this.props.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return this.props.rtl === false ? 'right' : 'left';
    }
    if (this.props.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }

    return 'vertical';
  },
  play: function play() {
    var nextIndex;

    if (!this.state.mounted) {
      return false;
    }

    if (this.props.rtl) {
      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
    } else {
      if (this.canGoNext(_extends({}, this.props, this.state))) {
        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
      } else {
        return false;
      }
    }

    this.slideHandler(nextIndex);
  },
  autoPlay: function autoPlay() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
    }
    if (this.props.autoplay) {
      this.setState({
        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
      });
    }
  },
  pause: function pause() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
      this.setState({
        autoPlayTimer: null
      });
    }
  }
};

exports.default = helpers;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(313);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(16);
var normalizeHeaderName = __webpack_require__(317);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(148);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(148);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(316)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _liveMenu=__webpack_require__(343);Object.defineProperty(exports,'default',{enumerable:true,get:function get(){return _interopRequireDefault(_liveMenu).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(352);




function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CONSTANT = {
  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true, opts);
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY

      this.showTooltip({
        currentTarget: hasTarget && event.detail.target
      }, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute('currentItem');
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute('data-event');
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === 'function') {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute('data-tip') || null;
  var forId = e.target.getAttribute('data-for') || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(' ').forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName('body')[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, 'data-event');
    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(' ').forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(' ').forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffsetX = _calculateOffset.extraOffsetX,
      extraOffsetY = _calculateOffset.extraOffsetY;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offsetX = defaultOffset[place].l;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offsetX = defaultOffset[place].r;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offsetY = defaultOffset[place].t;
    return mouseY + offsetY + extraOffsetY;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offsetY = defaultOffset[place].b;
    return mouseY + offsetY + extraOffsetY;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ['top', 'bottom', 'left', 'right'];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset = function calculateOffset(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }

  for (var key in offset) {
    if (key === 'top') {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffsetX: extraOffsetX,
    extraOffsetY: extraOffsetY
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block

    if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

function generateUUID() {
  return 't' + Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
}

var baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";

/**
 * Default pop-up style values (text color, background color).
 */
var defaultColors = {
  dark: {
    text: '#fff',
    background: '#222',
    border: 'transparent',
    arrow: '#222'
  },
  success: {
    text: '#fff',
    background: '#8DC572',
    border: 'transparent',
    arrow: '#8DC572'
  },
  warning: {
    text: '#fff',
    background: '#F0AD4E',
    border: 'transparent',
    arrow: '#F0AD4E'
  },
  error: {
    text: '#fff',
    background: '#BE6464',
    border: 'transparent',
    arrow: '#BE6464'
  },
  info: {
    text: '#fff',
    background: '#337AB7',
    border: 'transparent',
    arrow: '#337AB7'
  },
  light: {
    text: '#222',
    background: '#fff',
    border: 'transparent',
    arrow: '#fff'
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}

/**
 * Generates the specific tooltip style for use on render.
 */

function generateTooltipStyle(uuid, customColors, type, hasBorder) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */

function generateStyle(uuid, colors) {
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}

function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);

  if (textColor) {
    colors.text = textColor;
  }

  if (backgroundColor) {
    colors.background = backgroundColor;
  }

  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === 'light' ? 'black' : 'white';
    }
  }

  if (arrowColor) {
    colors.arrow = arrowColor;
  }

  return colors;
}

var _class, _class2, _temp;

var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  _createClass(ReactTooltip, null, [{
    key: "propTypes",
    get: function get() {
      return {
        uuid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
        place: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        effect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        multiline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        border: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        textColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        borderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        arrowColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        insecure: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        "class": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        html: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        delayHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        delayUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        delayShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        eventOff: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        isCapture: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        globalEventOff: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        getContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
        afterShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        afterHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        overridePosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        disable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        scrollHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        resizeHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        wrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        bodyMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        possibleCustomEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        possibleCustomEventsOff: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        clickable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
      };
    }
  }]);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck(this, ReactTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || 'top',
      // Direction of tooltip
      desiredPlace: props.place || 'top',
      type: 'dark',
      // Color theme of tooltip
      effect: 'float',
      // float or fixed
      show: false,
      border: false,
      customColors: {},
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || '',
      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;
      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method

      this.injectStyles(); // Inject styles for each DOM root having tooltip.
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /* Look for the closest DOM root having tooltip and inject styles. */

  }, {
    key: "injectStyles",
    value: function injectStyles() {
      var id = this.props.id;
      var targetArray = this.getTargetArray(id);
      var domRoots = [];
      targetArray.forEach(function (target) {
        var parentNode = target.parentNode;

        while (parentNode.parentNode && !parentNode.host) {
          parentNode = parentNode.parentNode;
        }

        var head = parentNode.querySelector('head');
        domRoots.push(head || parentNode);
      });

      if (domRoots.length) {
        var style = document.createElement('style');
        style.textContent = baseCss;
        style.setAttribute('data-react-tooltip', 'true');
        domRoots.filter(function (item, idx, src) {
          return src.indexOf(item) === idx;
        }).forEach(function (domRoot) {
          // Prevent styles duplication.
          if (!domRoot.querySelector('style[data-react-tooltip]')) {
            domRoot.appendChild(style);
          }
        });
      }
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(':hover');
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray = [];
      var selector;

      if (!id) {
        selector = '[data-tip]:not([data-for])';
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
      } // Scan document for shadow DOM elements


      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
        return element.shadowRoot;
      }).forEach(function (element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);

          if (effect === 'float') {
            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute('data-type') || self.props.type || 'dark',
          customColors: {
            text: target.getAttribute('data-text-color') || self.props.textColor || null,
            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
          },
          effect: effect,
          offset: offset,
          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
          currentTarget: target
        }, function () {
          if (scrollHide) {
            self.addScrollListener(self.state.currentTarget);
          }

          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      } // if the tooltip is empty, disable the tooltip


      if (this.isEmptyTip(placeholder) || disable) {
        return;
      }

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) {
              afterShow(e);
            }
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener(_this6.state.currentTarget);

          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }
    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;

      return Boolean(Object.keys(this.state.customColors).find(function (color) {
        return color !== 'border' && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors['border']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + ( // dark, success, warning, error, info, light, custom
      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');

      if (html) {
        var htmlContent = "".concat(content, "\n<style>").concat(style, "</style>");
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          }
        }), content);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: 'div',
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

/* harmony default export */ __webpack_exports__["default"] = (ReactTooltip);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

/* harmony default export */ __webpack_exports__["a"] = (bytesToUuid);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _line=__webpack_require__(361);var _line2=_interopRequireDefault(_line);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _lineMessage=__webpack_require__(461);var _lineMessage2=_interopRequireDefault(_lineMessage);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const getLeagueKeys = memoizee((league) => _.keysIn(league));
var Error=function Error(_ref){var text=_ref.text;return _react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:text}});};var LineContainer=(_dec=(0,_mobxReact.inject)('lineStore','accountStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LineContainer,_Component);function LineContainer(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,LineContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=LineContainer.__proto__||Object.getPrototypeOf(LineContainer)).call.apply(_ref2,[this].concat(args))),_this),_this.handlerClose=function(){_this.props.lineStore.line.clearResult();},_this.lineContainer=_react2.default.createRef(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LineContainer,[{key:'componentDidMount',value:function componentDidMount(){// this.props.lineStore.route.setUrl(this.props.match.params);
// console.log(this.props.match);
}},{key:'componentDidUpdate',value:function componentDidUpdate(){// this.props.lineStore.route.getUrl2(this.props.match.params);
// console.log(this.props.match);
}},{key:'render',value:function render(){if(!this.props.lineStore.line.mode)return false;var _props$lineStore$line=this.props.lineStore.line,isLoading=_props$lineStore$line.isLoading,result=_props$lineStore$line.result,lineMessage=_props$lineStore$line.lineMessage;var basketPosition=this.props.accountStore.accountSettings.basketPosition;var shortMenu=this.props.lineStore.shortMenu;var wssData=this.props.lineStore.matchesList.getData();return _react2.default.createElement('div',{ref:this.lineContainer,className:'line-central-column l-c-c-c-s '+(basketPosition=='right'?'line-central-column-short-right':'')+' '+(shortMenu&&basketPosition=='right'?'line-central-column-short-left':''),id:'line-central-column'},isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):result.status&&!wssData?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handlerClose}):lineMessage.title&&lineMessage.text?_react2.default.createElement(_lineMessage2.default,{title:lineMessage.title,text:lineMessage.text}):_react2.default.createElement(_line2.default,null));}}]);return LineContainer;}(_react.Component))||_class)||_class)||_class);exports.default=LineContainer;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ategories=__webpack_require__(367);Object.defineProperty(exports,'Categories',{enumerable:true,get:function get(){return _ategories.Categories;}});var _Tables=__webpack_require__(371);Object.defineProperty(exports,'Tables',{enumerable:true,get:function get(){return _Tables.Tables;}});var _Description=__webpack_require__(408);Object.defineProperty(exports,'Description',{enumerable:true,get:function get(){return _Description.Description;}});var _HeadTable=__webpack_require__(422);Object.defineProperty(exports,'HeadTable',{enumerable:true,get:function get(){return _interopRequireDefault(_HeadTable).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Td=exports.HightlightCoefTd=exports.highlightCoefChanges=exports.LIGHT=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LIGHT=exports.LIGHT=undefined;(function(LIGHT){LIGHT["GREEN"]="b-green";LIGHT["RED"]="b-orange";LIGHT["NONE"]="";})(LIGHT||(exports.LIGHT=LIGHT={}));var highlightCoefChanges=exports.highlightCoefChanges=function highlightCoefChanges(CoefTD){var highlightedCoefChanges=function highlightedCoefChanges(props){var coef=props.coef,disabled=props.disabled,cell=props.cell,highlightChanges=props.highlightChanges,isCoefChoosen=props.isCoefChoosen,typeCoef=props.typeCoef;var newCoef=typeCoef||'';var _React$useState=_react2.default.useState(newCoef),_React$useState2=_slicedToArray(_React$useState,2),prevCoef=_React$useState2[0],setCoef=_React$useState2[1];var _React$useState3=_react2.default.useState(LIGHT.NONE),_React$useState4=_slicedToArray(_React$useState3,2),light=_React$useState4[0],setLight=_React$useState4[1];var timeoutID=void 0;var turnOffLight=function turnOffLight(){timeoutID=setTimeout(function(){setLight(LIGHT.NONE);},2500);};_react2.default.useEffect(function(){if(highlightChanges&&prevCoef!==newCoef){setLight(newCoef>prevCoef?LIGHT.GREEN:LIGHT.RED);turnOffLight();}setCoef(newCoef);return function(){timeoutID&&clearTimeout(timeoutID);};},[coef.cf,highlightChanges]);var isChoosen=isCoefChoosen(cell.bet,coef.oddKey);var isDisabled=disabled||coef.bl===_base.LOCK_STATE.BLOCKED;var cf=newCoef;var cfID=coef.oddKey;return _react2.default.createElement(CoefTD,_extends({},props,{light:light,isDisabled:isDisabled,isChoosen:isChoosen,cf:cf,cfID:cfID,cell:cell}));};return highlightedCoefChanges;};var CoefTdComponent=function CoefTdComponent(props){var onClick=(0,_react.useCallback)(function(){props.cfID&&props.onClick(props.cfID);},[props.cfID]);return _react2.default.createElement('td',{className:props.cell.st+' '+(props.cell.additionalClassName||'')+' '+props.light,rowSpan:props.cell.rs,colSpan:props.cell.cs,style:props.style},props.isDisabled?_react2.default.createElement('span',{className:'g-b-b'},' ',props.cf,' '):_react2.default.createElement('a',{className:'g-b '+(props.isChoosen?'g-b-s':''),onClick:onClick},props.cf));};var CoefTd=_react2.default.memo(CoefTdComponent);var HightlightCoefTd=highlightCoefChanges(CoefTd);var TdComponent=function TdComponent(props){return _react2.default.createElement('td',{className:props.cell.st+' '+(props.cell.additionalClassName||''),rowSpan:props.cell.rs,colSpan:props.cell.cs,style:props.style},props.cell.txt);};var Td=_react2.default.memo(TdComponent);exports.HightlightCoefTd=HightlightCoefTd;exports.Td=Td;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LineContext=exports.ThemeContext=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactJss=__webpack_require__(57);var _theme=__webpack_require__(405);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ThemeContext=exports.ThemeContext=(0,_reactJss.createTheming)(_react2.default.createContext({theme:_theme.Theme.Light}));var LineContext=exports.LineContext=_react2.default.createContext({coefType:1,appName:''});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var Topics=exports.Topics=undefined;(function(Topics){Topics["baseIdentityActions"]="base_identity_actions";Topics["payments"]="payments";Topics["navigation"]="navigation";Topics["wagers"]="wagers";Topics["other"]="other";})(Topics||(exports.Topics=Topics={}));var Types=exports.Types=undefined;(function(Types){Types["launch"]="launch";Types["registration"]="registration";Types["authorization"]="authorization";Types["deposit"]="deposit";Types["payout"]="payout";Types["bk"]="bk";Types["casino"]="casino";Types["toto"]="toto";Types["payments"]="payments";Types["wagers"]="wagers";Types["promo"]="promo";Types["common"]="common";Types["accountChange"]="account_change";Types["settings"]="settings";Types["identification"]="identification";Types["Euro24"]="Euro24";})(Types||(exports.Types=Types={}));var Events=exports.Events=undefined;(function(Events){Events["historyAllMoved"]="history_all_moved";Events["casinoMoved"]="casino_moved";Events["betgamesMoved"]="betgames_moved";Events["liveCasinoMoved"]="live_casino_moved";Events["totoMoved"]="toto_moved";Events["topMoved"]="top_moved";Events["allBetsMoved"]="all_bets_moved";Events["applicationMoved"]="application_moved";Events["applicationDownload"]="application_download";Events["lineMoved"]="line_moved";Events["liveTabMoved"]="live_tab_moved";Events["casinoGameMoved"]="casino_game_moved";Events["payoutPageShow"]="payout_page_show";Events["payoutPageChoice"]="payout_page_choice";Events["depositPageShow"]="deposit_page_show";Events["depositPageChoice"]="deposit_page_choice";Events["depositInputAmount"]="deposit_input_amount";Events["payoutInputAmount"]="payout_input_amount";Events["searchDone"]="search_done";Events["promoCurrentMoved"]="promo_current_moved";Events["promoActionSelect"]="promo_action_select";Events["promoMyCurrentMoved"]="promo_my_current_moved";Events["promoActionStepSelect"]="promo_action_step_select";Events["questClickParticipate"]="quest_click_participate";Events["rulesMoved"]="rules_moved";Events["howMoved"]="how_moved";Events["accessMoved"]="access_moved";Events["technicalSupportContacted"]="technical_support_contacted";Events["feedbackMoved"]="feedback_moved";Events["feedbackRating"]="feedback_rating";Events["affiliateProgramMoved"]="affiliate_program_moved";Events["onlineChatSupportMoved"]="online_chat_support_moved";Events["onlineChatSupportRating"]="online_chat_support_rating";Events["clickBanner"]="click_banner";Events["clickBannerBasket"]="click_banner_basket";Events["regStart"]="reg_start";Events["enteredCharInReg"]="entered_char_in_reg";Events["regStep2"]="reg_step2";Events["regStep3"]="reg_step3";Events["clickForgotPassword"]="click_forgot_password";Events["viewPopUp"]="view_pop_up";Events["eventViewed"]="event_viewed";Events["favoUrites"]="favoUrites";Events["favouritesLiveMoved"]="favourites_live_moved";Events["favouritesLineMoved"]="favourites_line_moved";Events["scheduleTabMoved"]="schedule_tab_moved";Events["sportTypeFiltered"]="sport_type_filtered";Events["timeFiltered"]="time_filtered";Events["exodusFiltered"]="exodus_filtered";Events["infographicsViewed"]="infographics_viewed";Events["textographicViewed"]="textographic_viewed";Events["matchCenterViewed"]="matchcenter_viewed";Events["videoViewed"]="video_viewed";Events["openVideoFullScreen"]="open_video_full_screen";Events["statisticViewed"]="statistic_viewed";Events["resultsLineMoved"]="results_line_moved";Events["resultsLiveMoved"]="results_live_moved";Events["statsMoved"]="stats_moved";Events["enteredPhone"]="entered_phone";Events["enteredEmail"]="entered_email";Events["choseCountry"]="chose_country";Events["choseCurrency"]="chose_currency";Events["enteredPassword"]="entered_password";Events["enteredRepeatPassword"]="entered_repeat_password";Events["authorizationDone"]="authorization_done";Events["smsCodeEntered"]="sms_code_entered";Events["selectPhoneVerificationMethod"]="select_phone_verification_method";Events["enteredCharInVerificationMethod"]="entered_char_in_verification_method";Events["flashCallRequest"]="flash_call_request";Events["flashCallCodeEntered"]="flash_call_code_entered";Events["flashCallCodeRepeat"]="flash_call_code_repeat";Events["registrationDone"]="registration_done";Events["authStart"]="auth_start";Events["historyDepositMoved"]="historydeposit_moved";Events["historyPayoutMoved"]="historypayout_moved";Events["historyPeriodSelect"]="history_period_select";Events["basketMoved"]="basket_moved";Events["unassignedMoved"]="unassigned_moved";Events["tvgamesMoved"]="tvgames_moved";Events["eventAdd"]="event_add";Events["wagerDone"]="wager_done";Events["clickSaleBet"]="click_sale_bet";Events["confirmSaleBet"]="confirm_sale_bet";Events["eventDeleted"]="event_deleted";Events["basketCleared"]="basket_cleared";Events["identificationStart"]="identification_start";Events["identificationTypeSelection"]="identification_type_selection";Events["identificationNameInput"]="identification_name_input";Events["identificationLastnameInput"]="identification_lastname_input";Events["identificationMiddlenameInput"]="identification_middlename_input";Events["identificationDateOfBirthInput"]="identification_date_of_birth_input";Events["identificationPassportInput"]="identification_passport_input";Events["identificationDocumentInput"]="identification_document_input";Events["identificationButtonEnter"]="identification_button_enter";Events["newsMoved"]="news_moved";Events["newsCategorySelection"]="news_category_selection";Events["newsOpened"]="news_opened";Events["newsButtonClick"]="news_button_click";Events["betTypeSelect"]="bet_type_select";// выше логируемые события на проде, и проверенные в карте событий https://confluence.almara.org/pages/viewpage.action?pageId=200638677
Events["sessionStart"]="session_start";Events["application"]="application";Events["gotoRofit"]="goto_rofit";Events["promoEnter"]="promo_enter";Events["regButtonEnter"]="reg_button_enter";Events["smsCodeRepeat"]="sms_code_repeat";Events["backStep"]="back_step";Events["pinCodeError"]="pin_code_error";Events["logout"]="logout";Events["depositInit"]="deposit_init";Events["payoutInit"]="payout_init";Events["totoDone"]="toto_done";Events["casinoWagerDone"]="casino_wager_done";Events["favoritesEventAdded"]="favorites_event_added";Events["totoResultMoved"]="toto_result_moved";Events["viewModal"]="view_modal";Events["clickModal"]="click_modal";Events["viewModalV2"]="view_modal_v2";Events["clickModalV2"]="click_modal_v2";Events["clickRulesLanding"]="click_rules_landing";Events["viewLanding"]="view_landing";Events["moved404"]="404_moved";Events["tabClosed"]="tab_closed";Events["promoMoved"]="promo_moved";Events["moreMoved"]="more_moved";Events["twainSportMoved"]="twainsport_moved";Events["storiesAction"]="stories_action";Events["storiesButtonClick"]="stories_button_click";Events["viewStoriesV2"]="view_stories_v2";Events["clickStoriesV2"]="click_stories_v2";Events["accountEmailMoved"]="account_email_moved";Events["accountPhoneMoved"]="account_phone_moved";Events["accountPasswordMoved"]="account_password_moved";Events["accountEmailConfirmed"]="account_email_confirmed";Events["accountPhoneConfirmed"]="account_phone_confirmed";Events["basketClearChanged"]="basket_clear_changed";Events["balanceClearChanged"]="balance_clear_changed";Events["fastWagerBasketChanged"]="fast_wager_basket_changed";Events["eventsNumberChanged"]="events_number_changed";Events["sortingChanged"]="sorting_changed";Events["coefficientAgreementChanged"]="coefficient_agreement_changed";Events["emailRegularChanged"]="email_regular_changed";Events["emailImportantChanged"]="email_important_changed";Events["smsImportantChanged"]="sms_important_changed";Events["languageNotificationChanged"]="language_notification_changed";Events["oneClickBetChanged"]="one_click_bet_changed";Events["saveAlerts"]="save_alerts";Events["timezoneChanged"]="timezone_changed";Events["languageChanged"]="language_changed";Events["nightTheme"]="night_theme";Events["typeOfCoefficient"]="type_of_coefficient";Events["tableWorldCup"]="table_world_cup";Events["searchCasino"]="search_casino";Events["cancelSearchCasino"]="cancel_search_casino";Events["favouritesCasinoMoved"]="favourites_casino_moved";Events["favouritesCasino"]="favourites_casino";Events["casinoGroupSelect"]="casino_group_select";Events["casinoCategorySelect"]="casino_category_select";Events["casinoProviderSelect"]="casino_provider_select";Events["clickCasinoBanner"]="click_casino_banner";Events["pageEntered"]="page_entered";Events["Euro24_move"]="Euro24_move";Events["Euro24_tab_move"]="Euro24_tab_move";Events["PL_event_lenta"]="PL_event_lenta";Events["PL_event_banner"]="PL_event_banner";Events["PL_event_promo"]="PL_event_promo";Events["PL_event_story"]="PL_event_story";Events["PL_event_lk"]="PL_event_lk";})(Events||(exports.Events=Events={}));

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__esDecorate"] = __esDecorate;
/* harmony export (immutable) */ __webpack_exports__["__runInitializers"] = __runInitializers;
/* harmony export (immutable) */ __webpack_exports__["__propKey"] = __propKey;
/* harmony export (immutable) */ __webpack_exports__["__setFunctionName"] = __setFunctionName;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__createBinding", function() { return __createBinding; });
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__spreadArray"] = __spreadArray;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldIn"] = __classPrivateFieldIn;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(419);
var parse = __webpack_require__(420);
var formats = __webpack_require__(165);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(42);

var _Helpers = __webpack_require__(64);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(508),
    baseKeys = __webpack_require__(514),
    isArrayLike = __webpack_require__(103);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(510),
    isObjectLike = __webpack_require__(43);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(178),
    isLength = __webpack_require__(102);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(532),
    mapCacheDelete = __webpack_require__(539),
    mapCacheGet = __webpack_require__(541),
    mapCacheHas = __webpack_require__(542),
    mapCacheSet = __webpack_require__(543);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(108);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    isObjectLike = __webpack_require__(43);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.YouTube = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    return {
      listType: 'playlist',
      list: playlistId
    };
  }

  return {};
}

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (_ref) {
      var data = _ref.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');

        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist

        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var _config$youtube = config.youtube,
          playerVars = _config$youtube.playerVars,
          embedOptions = _config$youtube.embedOptions;
      var id = url && url.match(MATCH_URL)[1];

      if (isReady) {
        if (MATCH_PLAYLIST.test(url)) {
          this.player.loadPlaylist(parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), {}, playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        }, embedOptions));
      }, _onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports.YouTube = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(YouTube);

exports["default"] = _default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(73);

var _utils = __webpack_require__(14);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (player) {
        _this.player = player;
      }
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady) {
        this.player.stop();
      }

      if (this.player.disablePIP) {
        this.player.disablePIP();
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // Invoke player methods based on changed props
      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer;

      if (!(0, _utils.isEqual)(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", _props.propTypes);

_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SoundCloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, _this2.props.onPause);

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports.SoundCloud = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(SoundCloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(SoundCloud);

exports["default"] = _default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Vimeo = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, _this2.props.config.vimeo.playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports.Vimeo = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "forceLoad", true);

_defineProperty(Vimeo, "canPlay", function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }

  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Vimeo);

exports["default"] = _default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DailyMotion = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports.DailyMotion = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(DailyMotion, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(DailyMotion);

exports["default"] = _default;

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["boundMethod"] = boundMethod;
/* harmony export (immutable) */ __webpack_exports__["boundClass"] = boundClass;
/* harmony export (immutable) */ __webpack_exports__["default"] = autobind;
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.


  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      // eslint-disable-next-line no-prototype-builtins
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function get() {
          return boundFn;
        },
        set: function set(value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function set(value) {
      fn = value;
    }
  };
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */

function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys; // Use Reflect if exists

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided

    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}
function autobind() {
  if (arguments.length === 1) {
    return boundClass.apply(void 0, arguments);
  }

  return boundMethod.apply(void 0, arguments);
}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Direction = void 0;
var Direction = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL'
};
exports.Direction = Direction;

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

/* harmony default export */ __webpack_exports__["a"] = (bytesToUuid);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _mobx=__webpack_require__(5);var _ig=__webpack_require__(637);var _ig2=_interopRequireDefault(_ig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var IgStore=(_class=function(_Ig){_inherits(IgStore,_Ig);function IgStore(store){_classCallCheck(this,IgStore);var _this=_possibleConstructorReturn(this,(IgStore.__proto__||Object.getPrototypeOf(IgStore)).call(this,store));_initDefineProp(_this,'tab',_descriptor,_this);_initDefineProp(_this,'reveal',_descriptor2,_this);_initDefineProp(_this,'wide',_descriptor3,_this);_initDefineProp(_this,'toggleWide',_descriptor4,_this);_initDefineProp(_this,'toggleDetachVideo',_descriptor5,_this);_initDefineProp(_this,'toggleVideoList',_descriptor6,_this);_initDefineProp(_this,'toggleReveal',_descriptor7,_this);(0,_mobx.autorun)(function(){if(_this.game&&!_this.tabs.length){_this.close();}});return _this;}_createClass(IgStore,[{key:'reset',value:function reset(){_get(IgStore.prototype.__proto__||Object.getPrototypeOf(IgStore.prototype),'reset',this).call(this);this.reveal=false;}},{key:'close',value:function close(){_get(IgStore.prototype.__proto__||Object.getPrototypeOf(IgStore.prototype),'close',this).call(this);this.tab=null;this.wide=false;}},{key:'setTab',value:function setTab(tab){this.tab=tab;}},{key:'setGame',value:function setGame(game,tab){if(!(game&&game.video_type||game.stats))return;if(this.game&&this.game.id===game.id){if(tab&&tab!==this.tab){this.tab=tab;}return;}_get(IgStore.prototype.__proto__||Object.getPrototypeOf(IgStore.prototype),'setGame',this).call(this,game);if(!tab){tab=this.tabs.find(function(t){return t.show;})?this.tabs.find(function(t){return t.show;}).name:null;}this.tab=tab;}},{key:'onLoadVideo',value:function onLoadVideo(_ref){var gid=_ref.gid,silent=_ref.silent,res=_ref.res;if(res.code===2&&!silent){this.store.accountStore.toggleLoginForm(true,'PLEASE_AUTH_TO_VIEW_THE_BROADCAST');}else{_get(IgStore.prototype.__proto__||Object.getPrototypeOf(IgStore.prototype),'onLoadVideo',this).call(this,{gid:gid,silent:silent,res:res});}}},{key:'tabs',get:function get(){var _game=this.game,video_type=_game.video_type,stats=_game.stats;return[{name:'video',ico:'f-s-ico-video',show:video_type&&video_type[0]},{name:'events',ico:'f-s-ico-text_live',show:stats},{name:'stats',ico:'f-s-ico-stat',show:stats}].filter(function(t){return t.show;});}}]);return IgStore;}(_ig2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'reveal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'wide',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'reset',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'close',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'close'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTab',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setTab'),_class.prototype),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'toggleWide',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.wide=!_this2.wide;};}}),_applyDecoratedDescriptor(_class.prototype,'setGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setGame'),_class.prototype),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'toggleDetachVideo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){_this3.video.detached=!_this3.video.detached;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'toggleVideoList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.video.showList=!_this4.video.showList;};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'toggleReveal',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.reveal=!_this5.reveal;};}}),_applyDecoratedDescriptor(_class.prototype,'tabs',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'tabs'),_class.prototype)),_class);exports.default=new IgStore();

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(212);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(188),
    isFlattenable = __webpack_require__(666);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(221);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(231);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(76);

requirePromise();

var IsCallable = __webpack_require__(126);
var SpeciesConstructor = __webpack_require__(234);
var Type = __webpack_require__(30);

var promiseResolve = function PromiseResolve(C, value) {
	return new C(function (resolve) {
		resolve(value);
	});
};

var OriginalPromise = Promise;

var createThenFinally = function CreateThenFinally(C, onFinally) {
	return function (value) {
		var result = onFinally();
		var promise = promiseResolve(C, result);
		var valueThunk = function () {
			return value;
		};
		return promise.then(valueThunk);
	};
};

var createCatchFinally = function CreateCatchFinally(C, onFinally) {
	return function (reason) {
		var result = onFinally();
		var promise = promiseResolve(C, result);
		var thrower = function () {
			throw reason;
		};
		return promise.then(thrower);
	};
};

var promiseFinally = function finally_(onFinally) {
	/* eslint no-invalid-this: 0 */

	var promise = this;

	if (Type(promise) !== 'Object') {
		throw new TypeError('receiver is not an Object');
	}

	var C = SpeciesConstructor(promise, OriginalPromise); // may throw

	var thenFinally = onFinally;
	var catchFinally = onFinally;
	if (IsCallable(onFinally)) {
		thenFinally = createThenFinally(C, onFinally);
		catchFinally = createCatchFinally(C, onFinally);
	}

	return promise.then(thenFinally, catchFinally);
};

if (Object.getOwnPropertyDescriptor) {
	var descriptor = Object.getOwnPropertyDescriptor(promiseFinally, 'name');
	if (descriptor && descriptor.configurable) {
		Object.defineProperty(promiseFinally, 'name', { configurable: true, value: 'finally' });
	}
}

module.exports = promiseFinally;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/5.1/#sec-9.11

module.exports = __webpack_require__(233);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(76);

var implementation = __webpack_require__(125);

module.exports = function getPolyfill() {
	requirePromise();
	return typeof Promise.prototype['finally'] === 'function' ? Promise.prototype['finally'] : implementation;
};


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(52);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(258)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(80);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(80);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customLayout={'login':[[1,2,3,4,5,'b'],[6,7,8,9,0,'a']],'default':[[1,2,3,4,5,'.'],[6,7,8,9,0,'b']]};var VirtualKeyboard=function(_Component){_inherits(VirtualKeyboard,_Component);function VirtualKeyboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VirtualKeyboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VirtualKeyboard.__proto__||Object.getPrototypeOf(VirtualKeyboard)).call.apply(_ref,[this].concat(args))),_this),_this.handleKeyboard=function(val){_this.props.onChange(val);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VirtualKeyboard,[{key:'render',value:function render(){var _this2=this;var layout=this.props.type?this.props.type:'default';return _react2.default.createElement('div',{className:'ui-keyboard',role:'textbox'},_react2.default.createElement('div',{className:'ui-keyboard-keyset'},customLayout[layout].map(function(el){return _react2.default.createElement(_react.Fragment,{key:el[0]},_react2.default.createElement(Buttons,{items:el,handleClick:_this2.handleKeyboard}),_react2.default.createElement('br',{className:'ui-keyboard-button-endrow'}));})));}}]);return VirtualKeyboard;}(_react.Component);exports.default=VirtualKeyboard;var Buttons=function Buttons(_ref2){var items=_ref2.items,handleClick=_ref2.handleClick;var buttons=items.map(function(el){if(el=='b'){return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button ui-keyboard-bksp',title:'Backspace'},_react2.default.createElement('span',{className:'ui-keyboard-text'},'\u232B'));}else if(el=='a'){return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button ui-keyboard-accept'},_react2.default.createElement('span',{className:'ui-keyboard-text'},'\u2714'));}else{return _react2.default.createElement('div',{onClick:function onClick(){return handleClick(el);},key:el,tabIndex:'-1',className:'ui-keyboard-button'},_react2.default.createElement('span',{className:'ui-keyboard-text'},el));}});return buttons;};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing', spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);

  var trackWidth, trackHeight;

  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    if (spec.variableWidth) {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    } else if (spec.centerMode) {
      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
    } else {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    }
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
  };

  if (trackWidth) {
    (0, _objectAssign2.default)(style, { width: trackWidth });
  }

  if (trackHeight) {
    (0, _objectAssign2.default)(style, { height: trackHeight });
  }

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + 'px';
    } else {
      style.marginTop = spec.left + 'px';
    }
  }

  return style;
};

var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
};

var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);

  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (spec.fade) {
    return 0;
  }

  if (spec.infinite) {
    if (spec.slideCount >= spec.slidesToShow) {
      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
    }
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        if (spec.slideIndex > spec.slideCount) {
          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
        } else {
          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
        }
      }
    }
  } else {

    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
        slideOffset = slidesToOffset * spec.slideWidth;
      }
    }
  }

  if (spec.centerMode) {
    if (spec.infinite) {
      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    } else {
      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    }
  }

  if (!spec.vertical) {
    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
  } else {
    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
  }

  if (spec.variableWidth === true) {
    var targetSlideIndex;
    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
    } else {
      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
    }
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (spec.centerMode === true) {
      if (spec.infinite === false) {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
      } else {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
      }

      if (targetSlide) {
        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
      }
    }
  }

  return targetLeft;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
    className: '',
    accessibility: true,
    adaptiveHeight: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'ease',
    customPaging: function customPaging(i) {
        return _react2.default.createElement(
            'button',
            null,
            i + 1
        );
    },
    dots: false,
    dotsClass: 'slick-dots',
    draggable: true,
    easing: 'linear',
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: false,
    pauseOnHover: true,
    responsive: null,
    rtl: false,
    slide: 'div',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    swipe: true,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    afterChange: null,
    beforeChange: null,
    edgeEvent: null,
    init: null,
    swipeEvent: null,
    // nextArrow, prevArrow are react componets
    nextArrow: null,
    prevArrow: null
};

module.exports = defaultProps;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Menu=__webpack_require__(309);Object.defineProperty(exports,'Menu',{enumerable:true,get:function get(){return _Menu.ResultsSportFilter;}});var _Tables=__webpack_require__(334);Object.defineProperty(exports,'Tables',{enumerable:true,get:function get(){return _Tables.ResultSportsTables;}});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsMenu=exports.OTHER_SPORTS_ID=exports.ALL_SPORTS_ID=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _base=__webpack_require__(4);var _Menu=__webpack_require__(310);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ALL_SPORTS_ID=exports.ALL_SPORTS_ID='all';var allSportsItem={hasMatches:true,id:ALL_SPORTS_ID,name:'ALL'};var OTHER_SPORTS_ID=exports.OTHER_SPORTS_ID='other';var otherSportsItem={hasMatches:true,id:OTHER_SPORTS_ID,name:'OTHER'};/** Т.к результаты singleton, используем константный ID */var subscriptionID=0;var ResultsMenu=exports.ResultsMenu=function(_Subscribtion){_inherits(ResultsMenu,_Subscribtion);function ResultsMenu(_ref){var siteType=_ref.siteType,lng=_ref.lng;_classCallCheck(this,ResultsMenu);var _this=_possibleConstructorReturn(this,(ResultsMenu.__proto__||Object.getPrototypeOf(ResultsMenu)).call(this));_this.selected=new Set();_this.data={hasMatches:false,topSports:[],otherSportsHasMatches:false};_this.update=_this.update.bind(_this);_this.select=_this.select.bind(_this);_this.isSelected=_this.isSelected.bind(_this);_this.wsListener=new _Menu.ResultsLiveMenuListener({site:siteType||_base.SITE_TYPE.COM,lng:lng});return _this;}_createClass(ResultsMenu,[{key:'getData',value:function getData(){if(!this.data.hasMatches){return null;}return this.data;}},{key:'getSelected',value:function getSelected(){return Array.from(this.selected.values());}},{key:'clear',value:function clear(){this.data={hasMatches:false,topSports:[],otherSportsHasMatches:false};this.selected.clear();}},{key:'select',value:function select(sportID,isSelected){if(sportID===ALL_SPORTS_ID){this.selected=new Set(isSelected?[ALL_SPORTS_ID]:[]);this.notify();return;}this.selected.delete(ALL_SPORTS_ID);isSelected?this.selected.add(sportID):this.selected.delete(sportID);this.notify();}},{key:'isSelected',value:function isSelected(sportID){return this.selected.has(sportID);}//#region WS
/**
    * Подписка на обновления таблицы live доп.исходов через WS
    */},{key:'listenWS',value:function listenWS(){var _this2=this;var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},callback=_ref2.callback,errback=_ref2.errback;var logger=_logger2.default.getInstance();var onerror=function onerror(e){logger.error(e);_this2.stopListenWS();errback&&errback(e);};var onopen=function onopen(){// logger.log('[ResultsMenu] Соединение открыто');
callback&&callback();};var onmessage=this.update;this.wsListener.subscribe({subscriptionID:subscriptionID,onmessage:onmessage,onerror:onerror,onopen:onopen});}},{key:'update',value:function update(data){this.data.hasMatches=data.hasMatches;this.data.otherSportsHasMatches=data.otherSportsHasMatches;this.data.topSports=[allSportsItem].concat(data.topSports).concat(data.otherSportsHasMatches?[otherSportsItem]:[]);this.notify();}},{key:'stopListenWS',value:function stopListenWS(){// this.wsListener.unsubscribe({ subscriptionID });
}}]);return ResultsMenu;}(_Subscribtion3.default);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BaseSocketListener=exports.CONNECTION_TIMEOUT_MS=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _BaseSocket=__webpack_require__(145);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var IS_SERVER=typeof document==='undefined';var SEC=1000;var CONNECTION_TIMEOUT_MS=exports.CONNECTION_TIMEOUT_MS=5*SEC;/**
 * @class
 * @static Все члены статик, потому что singleton, (должно быть только одно сокет подключение)
 * @abstract
 * Отвечает за работу с сокетами ({@link WebSocket}, {@link AxiosSocket}):
 *  - восстанавление соединения
 *  - подписка/отписка от сокета
 *  - сохранение обработчиков при пересоздании сокета
 */var BaseSocketListener=exports.BaseSocketListener=function(){function BaseSocketListener(){_classCallCheck(this,BaseSocketListener);throw new Error('Класс BaseSocketListener должен быть singleton, все методы статические, он не должен иметь экземпляров');}//#region API
_createClass(BaseSocketListener,null,[{key:'subscribe',value:function subscribe(msg){var _this=this;var handlers=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var target=arguments[2];this.handlers[msg.t]=handlers;this.internalHandlers.visibilitychange=function(){/**
             * На мобильных устройствах фоновые подключения часто закрываются
             * Если страница снова стала видимой и нет подключения, то немедленно переподписываемся
             */if(!IS_SERVER&&!document.hidden&&_this.state!==_BaseSocket.CONNECTION_STATE.OPEN){_this.subscribe(msg,handlers);}};return this.send(JSON.stringify(msg),target).catch(function(e){_this.removeHandlers();handlers.onerror&&handlers.onerror(e);});}},{key:'unsubscribe',value:function unsubscribe(cfg,target){if(this.state!==_BaseSocket.CONNECTION_STATE.OPEN){return Promise.resolve();}return this.subscribe(cfg,{},target).then(function(){//this.removeHandlers();
});}//#endregion
},{key:'createSocket',value:function createSocket(){throw new Error('Статический метод createSocket должен быть переопределен в дочерних классах');}},{key:'send',value:function send(message,target){var _this2=this;this.messages.add(message);return this.restoreConnection().then(function(){if(_this2.state!==_BaseSocket.CONNECTION_STATE.OPEN){throw new Error('['+_this2+'] \u0421\u043E\u043A\u0435\u0442 \u043D\u0435 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043B \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435');}_this2.messages.forEach(function(m){var _a;(_a=_this2.socket)===null||_a===void 0?void 0:_a.send(m,target);});_this2.messages.clear();});}},{key:'restoreConnection',value:function restoreConnection(){var _this3=this;return new Promise(function(resolve,reject){try{// соединение без подписок закрывается через 10 сек
if(!_this3.socket||_this3.state===_BaseSocket.CONNECTION_STATE.CLOSED){_this3.socket=_this3.createSocket();if(/debug/.test(document.cookie)){window['debug:websocket']=_this3.socket;}}_this3.setHandlers(resolve,reject);}catch(e){reject(e);return;}setTimeout(function(){if(_this3.state===_BaseSocket.CONNECTION_STATE.OPEN||_this3.state===_BaseSocket.CONNECTION_STATE.CLOSED){return;}reject(new Error('['+_this3+'] \u0418\u0441\u0442\u0435\u043A timeout \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F'));},CONNECTION_TIMEOUT_MS);});}},{key:'setHandlers',value:function setHandlers(onopen,onerror){var _this4=this;var _a,_b;if(!IS_SERVER&&this.internalHandlers.visibilitychange){document.addEventListener('visibilitychange',this.internalHandlers.visibilitychange);}if(!this.socket){return;}this.socket.onmessage=function(msg){var _a;var data=JSON.parse(msg.data);var handlers=_this4.handlers[data.t];(_a=handlers===null||handlers===void 0?void 0:handlers.onmessage)===null||_a===void 0?void 0:_a.call(handlers,msg);};var forEachHandler=function forEachHandler(f){(0,_lib.objectValues)(_this4.handlers).filter(function(f){return!!f;}).forEach(f);};this.socket.onclose=function(closeEvent){var e=new CloseEvent(_this4+': \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u043E: '+closeEvent);forEachHandler(function(handlers){var _a;(_a=handlers===null||handlers===void 0?void 0:handlers.onclose)===null||_a===void 0?void 0:_a.call(handlers,e);});};this.socket.onerror=function(e){var error=new Event(_this4+': \u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F: '+JSON.stringify(e));forEachHandler(function(handlers){var _a;(_a=handlers===null||handlers===void 0?void 0:handlers.onerror)===null||_a===void 0?void 0:_a.call(handlers,error);});onerror(error);};this.socket.onopen=function(){var event=new Event(_this4+': \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u043E');forEachHandler(function(handlers){var _a;(_a=handlers===null||handlers===void 0?void 0:handlers.onopen)===null||_a===void 0?void 0:_a.call(handlers,event);});onopen();};this.state===_BaseSocket.CONNECTION_STATE.CLOSED&&((_b=(_a=this.socket).onclose)===null||_b===void 0?void 0:_b.call(_a,new CloseEvent('')));this.state===_BaseSocket.CONNECTION_STATE.OPEN&&this.socket.onopen(new Event(''));}},{key:'removeHandlers',value:function removeHandlers(){if(!IS_SERVER&&this.internalHandlers.visibilitychange){document.removeEventListener('visibilitychange',this.internalHandlers.visibilitychange);}if(!this.socket){return;}// this.socket.onmessage = void 0;
// this.socket.onclose = void 0;
// this.socket.onerror = void 0;
// this.socket.onopen = void 0;
}},{key:'state',get:function get(){if(!this.socket){return _BaseSocket.CONNECTION_STATE.CLOSED;}return this.socket.readyState;}}]);return BaseSocketListener;}();BaseSocketListener.handlers={};BaseSocketListener.internalHandlers={};BaseSocketListener.messages=new Set([]);BaseSocketListener.socket=null;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * @class BaseSocket
 * @implements {ISocket}
 * @abstract
 * Необходим для создания собственных реализаций сокета
 * (например обмен по xhr с помощью axios- AxiosSocket)
 * Все экземпляры дочерних классаов должны реализовывать интерфейс {@link ISocket},
 * чтобы быть совместимыми с нативным {@link WebSocket}
 */var BaseSocket=exports.BaseSocket=function(){function BaseSocket(){_classCallCheck(this,BaseSocket);this.onclose=function(_e){return void 0;};this.onerror=function(_e){return void 0;};this.onmessage=function(_e){return void 0;};this.onopen=function(_e){return void 0;};}_createClass(BaseSocket,[{key:'send',value:function send(_s){throw new Error('Невозможно создать экземпляр абстрактного класса');}},{key:'readyState',get:function get(){throw new Error('Нет состояния подключения у BaseSocket');}}]);return BaseSocket;}();var CONNECTION_STATE=exports.CONNECTION_STATE=undefined;(function(CONNECTION_STATE){CONNECTION_STATE[CONNECTION_STATE["CONNECTING"]=0]="CONNECTING";CONNECTION_STATE[CONNECTION_STATE["CLOSED"]=3]="CLOSED";CONNECTION_STATE[CONNECTION_STATE["CLOSING"]=2]="CLOSING";CONNECTION_STATE[CONNECTION_STATE["OPEN"]=1]="OPEN";})(CONNECTION_STATE||(exports.CONNECTION_STATE=CONNECTION_STATE={}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AxiosSocket=exports.subscriptions=undefined;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _axios=__webpack_require__(84);var _axios2=_interopRequireDefault(_axios);var _BaseSocket2=__webpack_require__(145);var _base=__webpack_require__(4);var _time=__webpack_require__(332);var _SubscriptionsStore=__webpack_require__(333);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getQueryStringForArray=function getQueryStringForArray(paramName,array){return array.reduce(function(prev,curr,index,array){var isLast=index===array.length-1;return''+prev+paramName+'='+curr+(!isLast?'&':'');},'');};// Backend requires array to be passed as ?odds=2620840482&odds=2620840840
// instead of ?odds[]=2620840482&odds[]=2620840840
var getCustomRequestParts=function getCustomRequestParts(params){var newParams={};var queryString='';for(var i=0;i<Object.keys(params).length;i++){var param=Object.keys(params)[i];var value=params[param];if(Array.isArray(value)){queryString+=getQueryStringForArray(param,value);}else{newParams[param]=value;}}queryString=queryString.length?'?'+queryString:'';return{queryString:queryString,newParams:newParams};};var subscriptions=exports.subscriptions=new _SubscriptionsStore.SubscriptionsStore();var matchesSubscriptionTypes=[// Live-матчи с видео
_base.DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO_MOBILE,_base.DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO,// Live-матчи из избранного
_base.DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES_MOBILE,_base.DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES,// Топ Live-матчи
_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP_MOBILE,_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP,// Live-матчи по чемпионату (для сайта)
_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_CHAMPIONSHIP,// Live-матчи по спорту
_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT_MOBILE,_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT,// Все Live-матчи для сайта
_base.DATA_TYPE_CODE.LIVE_MATCHES_ALL];var handleMatchesTypes=function handleMatchesTypes(t){if(!matchesSubscriptionTypes.includes(t))return;matchesSubscriptionTypes.forEach(function(t){subscriptions.remove(t);});};/**
 * @name AxiosSocket
 * @class
 * @implements {ISocket}
 * Реализует интерфейс веб-сокета по протоколу xhr
 */var AxiosSocket=exports.AxiosSocket=function(_BaseSocket){_inherits(AxiosSocket,_BaseSocket);function AxiosSocket(url){_classCallCheck(this,AxiosSocket);var _this=_possibleConstructorReturn(this,(AxiosSocket.__proto__||Object.getPrototypeOf(AxiosSocket)).call(this));_this.url=url;_this.state=_BaseSocket2.CONNECTION_STATE.OPEN;return _this;}_createClass(AxiosSocket,[{key:'loop',value:function loop(){var _this2=this;if(this.updateIntervalID){return;}this.updateIntervalID=window.setInterval(function(){subscriptions.getAll().forEach(function(message){return _this2.handleMessage(message);});},_time.ONE_SECOND_MS);}},{key:'handleMessage',value:function handleMessage(params){var _this3=this;// it should not send d as params if d is not an object (e.g. params.d is a string with jwt)
var requestParamsObj={};var query='';if(_typeof(params.d)==='object'){var _getCustomRequestPart=getCustomRequestParts(params.d),queryString=_getCustomRequestPart.queryString,newParams=_getCustomRequestPart.newParams;requestParamsObj={params:newParams};query=queryString;}_axios2.default.get(''+this.url+params.t+query,Object.assign({},requestParamsObj)).then(function(r){_this3.state=_BaseSocket2.CONNECTION_STATE.OPEN;if(r.statusText!=='OK'){throw new Error(String(r.data));}_this3.onmessage&&_this3.onmessage(new MessageEvent('message',{data:JSON.stringify(r.data)}));}).catch(function(e){// subscriptions.remove(params.t)
// this.close();
throw e;}).catch(this.onerror);}},{key:'send',value:function send(s,target){var params=JSON.parse(s);this.state=_BaseSocket2.CONNECTION_STATE.OPEN;if(params.op===_base.CHANNEL_ACTION.SUBSCRIBE){handleMatchesTypes(params.t);subscriptions.upsert(params);}if(!target&&params.op===_base.CHANNEL_ACTION.UNSUBSCRIBE){subscriptions.remove(params.t);}this.loop();}},{key:'dispatchEvent',value:function dispatchEvent(e){this.close();this.onerror(e);}},{key:'close',value:function close(){this.state=_BaseSocket2.CONNECTION_STATE.CLOSED;clearInterval(this.updateIntervalID);}},{key:'readyState',get:function get(){return this.state;}}]);return AxiosSocket;}(_BaseSocket2.BaseSocket);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var settle = __webpack_require__(318);
var buildURL = __webpack_require__(320);
var parseHeaders = __webpack_require__(321);
var isURLSameOrigin = __webpack_require__(322);
var createError = __webpack_require__(149);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(323);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(324);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(319);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var baseClassName=function baseClassName(notification){return'notification-'+notification;};var MovingStatistics=(_dec=(0,_mobxReact.inject)('appStore','dictStore','lineStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(MovingStatistics,_Component);function MovingStatistics(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MovingStatistics);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MovingStatistics.__proto__||Object.getPrototypeOf(MovingStatistics)).call.apply(_ref,[this].concat(args))),_this),_this.closeNotification=function(){_this.props.appStore.setNotificationVisibility('movingStatistics',false);},_this.redirectToMainMatch=function(){_this.closeNotification();var _this$props=_this.props,match=_this$props.match,history=_this$props.history;var active=_this.props.lineStore.basket.mode;var dictionary=_this.props.lineStore.menu.dict.eng;var sportId=(0,_common.getIdFromSlug)(match.params.sport);var pathnameSport=/^[0-9]*$/.test(sportId)?sportId:(0,_common.urlSlug)(sportId,dictionary&&dictionary.sport[sportId]);var gameId=(0,_common.getIdFromSlug)(match.params.games);var game=_this.props.lineStore['line'].lineGames.get(Number(gameId));var mainGameId=game&&game.parent_game_id;var mainLeagueId=game&&game.parent_league_id;var pathnameLeague=(0,_common.urlSlug)(mainLeagueId,dictionary&&dictionary.league[mainLeagueId]||mainLeagueId);if(mainLeagueId&&mainGameId){history.push('/'+active+'/'+pathnameSport+'/'+pathnameLeague+'/'+mainGameId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MovingStatistics,[{key:'render',value:function render(){if(this.props.redirect){this.redirectToMainMatch();}if(!(this.props.appStore.isNotificationVisible&&this.props.appStore.isNotificationVisible.movingStatistics)){return null;}var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:baseClassName('moving-stats')},_react2.default.createElement('button',{type:'button',onClick:this.closeNotification,className:baseClassName('moving-stats-close')}),_react2.default.createElement('div',{className:baseClassName('moving-stats-top')},_react2.default.createElement('img',{className:baseClassName('moving-stats-top-icon'),src:'/assets/img/warningMovingStatistics.png',alt:''}),_react2.default.createElement('div',{className:baseClassName('moving-stats-top-title')},getLang('BET_STATISTICS_MOVE'))),_react2.default.createElement('div',{className:baseClassName('moving-stats-content')},_react2.default.createElement('p',null,getLang('ALL_STATISTICS_GROUP_BREAK')),_react2.default.createElement('p',null,getLang('CURRENT_STATISTIC_FORMAT_WILL_OFF'))),_react2.default.createElement('button',{type:'button',className:baseClassName('moving-stats-button'),onClick:this.redirectToMainMatch},getLang('MOVE_ON')));}}]);return MovingStatistics;}(_react.Component))||_class)||_class)||_class);exports.default=MovingStatistics;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);var _liveMenuLeague=__webpack_require__(344);var _liveMenuLeague2=_interopRequireDefault(_liveMenuLeague);var _liveMenuOther=__webpack_require__(345);var _liveMenuOther2=_interopRequireDefault(_liveMenuOther);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuSport=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_Component){_inherits(LiveMenuSport,_Component);function LiveMenuSport(props){_classCallCheck(this,LiveMenuSport);var _this=_possibleConstructorReturn(this,(LiveMenuSport.__proto__||Object.getPrototypeOf(LiveMenuSport)).call(this,props));_this.selectItem=function(evt){// this.props.routingStore.push(`/${this.props.lineStore.menu.mode}/${this.props.id}`);
_this.props.history.push('/'+_this.props.lineStore.menu.mode+'/'+_this.props.id);// this.props.history.push(this.props.id, this.props.type);
_this.toggle();evt.preventDefault();};_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(_this.props.id,_this.props.type);};return _this;}_createClass(LiveMenuSport,[{key:'getChildContext',value:function getChildContext(){return{sportId:this.props.id};}},{key:'getCount',value:function getCount(){var arrLeague=this.props.lineStore.menu.sport.get(this.props.id).league;var count=0;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=arrLeague[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var id=_step.value;if(this.props.lineStore.menu.league.has(id)){count+=this.props.lineStore.menu.league.get(id).games.length;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return count;}},{key:'render',value:function render(){var _props=this.props,id=_props.id,type=_props.type;if(id==='other'){return _react2.default.createElement(_liveMenuOther2.default,null);}var _props$lineStore$menu=this.props.lineStore.menu,sport=_props$lineStore$menu.sport,selected=_props$lineStore$menu.selected,isOpen=_props$lineStore$menu.isOpen;var data=sport.get(id);var select=selected.sport.includes(id);var isOpenedSport=isOpen.sport.includes(id);if(!data){return null;}return _react2.default.createElement('a',{className:(0,_classnames2.default)(['favourites-sport-item',{'favourites-item_active':select}])},_react2.default.createElement(_favouriteStar2.default,{type:type,id:id}),_react2.default.createElement('button',{className:'favourites-sport-item-toggle f-i-t '+(isOpenedSport?'f-i-t-a':''),onClick:this.toggle},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('button',{className:(0,_classnames2.default)(['favourites-item-load f-i-l','f-s-i-a-'+id]),onClick:this.selectItem},_react2.default.createElement('span',{className:'line-sport-menu-item-ico f-s-ico-'+id}),_react2.default.createElement(_liveMenuCounter2.default,{count:this.getCount()}),_react2.default.createElement('div',{className:'favourites-item-load-label'},data.name)),isOpenedSport&&_react2.default.createElement('div',{className:'favourites-league-wrapper'},data.league.map(function(o){return _react2.default.createElement(_liveMenuLeague2.default,{parentIsOpen:isOpenedSport,id:o,key:o,type:2});})));}}]);return LiveMenuSport;}(_react.Component),_class2.childContextTypes={sportId:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},_temp))||_class)||_class)||_class);exports.default=LiveMenuSport;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRouterDom=__webpack_require__(2);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuGame=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_Component){_inherits(LiveMenuGame,_Component);function LiveMenuGame(props){_classCallCheck(this,LiveMenuGame);var _this=_possibleConstructorReturn(this,(LiveMenuGame.__proto__||Object.getPrototypeOf(LiveMenuGame)).call(this,props));_this.selectItem=function(evt){var _this$props$lineStore=_this.props.lineStore.menu.games.get(_this.props.id),lid=_this$props$lineStore.lid,sid=_this$props$lineStore.sid;_this.props.history.push('/'+_this.props.lineStore.mode+'/'+sid+'/'+lid+'/'+_this.props.id);// this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
evt.preventDefault();};_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(_this.props.id,_this.props.type);};return _this;}_createClass(LiveMenuGame,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,games=_props$lineStore$menu.games,selected=_props$lineStore$menu.selected;var id=this.props.id;var data=games.get(id);var isSelected=selected.games.includes(id);var name=data.c1+' '+(data.c2?'- '+data.c2:'');// const name = ``
if(!data){return null;}var classNames=(0,_classnames2.default)(['favourites-league-item','favourites-game-item',{'favourites-menu-item_active':isSelected}]);return _react2.default.createElement('div',{className:classNames},_react2.default.createElement(_favouriteStar2.default,{type:this.props.type,id:this.props.id}),_react2.default.createElement('button',{title:name,onClick:this.selectItem,className:'league-item-a game-item-a'},name));}}]);return LiveMenuGame;}(_react.Component),_class2.contextTypes={sportId:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),leagueId:_propTypes2.default.number},_temp))||_class)||_class)||_class);exports.default=LiveMenuGame;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__ = __webpack_require__(88);


function uuidToBytes(uuid) {
  // Note: We assume we're being passed a valid uuid string
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = new Array(str.length);

  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  var generateUUID = function generateUUID(value, namespace, buf, offset) {
    var off = buf && offset || 0;
    if (typeof value == 'string') value = stringToBytes(value);
    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3

    var bytes = hashfunc(namespace.concat(value));
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      for (var idx = 0; idx < 16; ++idx) {
        buf[off + idx] = bytes[idx];
      }
    }

    return buf || Object(__WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__["a" /* default */])(bytes);
  }; // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name;
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TBody=exports.Row=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Td=__webpack_require__(91);var _AppContexts=__webpack_require__(92);var _insertCoefByType=__webpack_require__(164);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RowComponent=function RowComponent(props){var _useContext=(0,_react.useContext)(_AppContexts.LineContext),coefType=_useContext.coefType,appName=_useContext.appName;return _react2.default.createElement(_react.Fragment,null,props.tr.map(function(cell,i,row){return cell.bet&&props.getCoef(cell.bet)?_react2.default.createElement(_Td.HightlightCoefTd,{disabled:!!props.disabled,key:props.getCoef(cell.bet).odd+'_'+i,highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,style:props.getColumnStyle?props.getColumnStyle(i,row):{},coef:props.getCoef(cell.bet),onClick:props.onCoefChoose,typeCoef:(0,_insertCoefByType.insertCoefByType)(Number(props.getCoef(cell.bet).cf),coefType,appName),cell:cell}):_react2.default.createElement(_Td.Td,{key:(cell.txt||cell.st)+'_'+i,style:props.getColumnStyle?props.getColumnStyle(i,row):{},cell:props.decorateCell?props.decorateCell(cell,i):cell});}));};var Row=exports.Row=_react2.default.memo(RowComponent);var TBodyComponent=function TBodyComponent(props){return _react2.default.createElement(_react.Fragment,null,props.rows.map(function(tr,i){return _react2.default.createElement('tr',{key:i,className:props.className},_react2.default.createElement(Row,_extends({tr:tr},props)));}));};var TBody=exports.TBody=_react2.default.memo(TBodyComponent);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(373);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createTheming; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_display_name__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_display_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_display_name__);






function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function isObject(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}

function createThemeProvider(context) {
  var ThemeProvider =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(ThemeProvider, _React$Component);

    function ThemeProvider() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cachedTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastOuterTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderProvider", function (outerTheme) {
        var children = _this.props.children;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(context.Provider, {
          value: _this.getTheme(outerTheme)
        }, children);
      });

      return _this;
    }

    var _proto = ThemeProvider.prototype;

    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    _proto.getTheme = function getTheme(outerTheme) {
      if (this.props.theme !== this.lastTheme || outerTheme !== this.lastOuterTheme || !this.cachedTheme) {
        this.lastOuterTheme = outerTheme;
        this.lastTheme = this.props.theme;

        if (typeof this.lastTheme === 'function') {
          var theme = this.props.theme;
          this.cachedTheme = theme(outerTheme);
           false ? warning(isObject(this.cachedTheme), '[ThemeProvider] Please return an object from your theme function') : void 0;
        } else {
          var _theme = this.props.theme;
           false ? warning(isObject(_theme), '[ThemeProvider] Please make your theme prop a plain object') : void 0;
          this.cachedTheme = outerTheme ? _extends({}, outerTheme, _theme) : _theme;
        }
      }

      return this.cachedTheme;
    };

    _proto.render = function render() {
      var children = this.props.children;

      if (!children) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(context.Consumer, null, this.renderProvider);
    };

    return ThemeProvider;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  if (false) {
    ThemeProvider.propTypes = {
      // eslint-disable-next-line react/require-default-props
      children: PropTypes.node,
      theme: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]).isRequired
    };
  }

  return ThemeProvider;
}

function createWithTheme(context) {
  return function hoc(Component) {
    var withTheme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(context.Consumer, null, function (theme) {
         false ? warning(isObject(theme), '[theming] Please use withTheme only with the ThemeProvider') : void 0;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({
          theme: theme,
          ref: ref
        }, props));
      });
    });

    if (false) {
      withTheme.displayName = "WithTheme(" + getDisplayName(Component) + ")";
    }

    __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(withTheme, Component);
    return withTheme;
  };
}

function createUseTheme(context) {
  var useTheme = function useTheme() {
    var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(context);
     false ? warning(isObject(theme), '[theming] Please use useTheme only with the ThemeProvider') : void 0;
    return theme;
  };

  return useTheme;
}

function createTheming(context) {
  return {
    context: context,
    withTheme: createWithTheme(context),
    useTheme: createUseTheme(context),
    ThemeProvider: createThemeProvider(context)
  };
}

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();

var _createTheming = createTheming(ThemeContext),
    withTheme = _createTheming.withTheme,
    ThemeProvider = _createTheming.ThemeProvider,
    useTheme = _createTheming.useTheme;




/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_rule_value_observable__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_template__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_global__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_extend__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_nested__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_compose__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jss_plugin_camel_case__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jss_plugin_default_unit__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jss_plugin_expand__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jss_plugin_vendor_prefixer__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jss_plugin_props_sort__ = __webpack_require__(400);













var create = function create(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_rule_value_observable__["a" /* default */])(options.observable), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_template__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_extend__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_compose__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_7_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_8_jss_plugin_default_unit__["a" /* default */])(options.defaultUnit), Object(__WEBPACK_IMPORTED_MODULE_9_jss_plugin_expand__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_10_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_11_jss_plugin_props_sort__["a" /* default */])()]
  };
};

/* harmony default export */ __webpack_exports__["a"] = (create);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.insertCoefByType=exports.COEF_TYPES=exports.WHITE_LIST_PROJECTS=undefined;var _calcFunctions=__webpack_require__(406);var WHITE_LIST_PROJECTS=exports.WHITE_LIST_PROJECTS=['zenitbet','mobile_com','desktop','mobile_new'];var COEF_TYPES=exports.COEF_TYPES={1:'EUROPEAN',2:'AMERICAN',3:'HONGKONG',4:'INDONESIAN',5:'MALASYIAN'};var COEF_CALCULATE={'AMERICAN':_calcFunctions.americanTypeCf,'HONGKONG':_calcFunctions.hongKongTypeCf,'INDONESIAN':_calcFunctions.indonesianTypeCf,'MALASYIAN':_calcFunctions.malaysianTypeCf};/**
 * Функция приводит к разным типам входящий коэффициент
   @param {cf}: кэф, европейского типа.
   @param {type}: id типа кэфа, согласно COEF_TYPES
   @param {appName}: имя проекта
   @param {notConvertCf}: флаг игнорирование преобразования кэфов
 **/var insertCoefByType=exports.insertCoefByType=function insertCoefByType(cf,type,appName){var notConvertCf=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(cf===undefined){return' ';}if(!WHITE_LIST_PROJECTS.includes(appName)||notConvertCf){return numberFormatter(cf,2,',',' ');}if(type===1)return String(numberFormatter(cf,2,',',' '));if(type===2)return String(COEF_CALCULATE[COEF_TYPES[type]](cf));return String(numberFormatter(COEF_CALCULATE[COEF_TYPES[type]](cf),2,',',' '));};var numberFormatter=function numberFormatter(number,decimals,dec_point,thousands_sep){// * example 1: number_format(1234.56);
// * returns 1: '1,235'
// * example 2: number_format(1234.56, 2, ',', ' ');
// * returns 2: '1 234,56'
// * example 3: number_format(1234.5678, 2, '.', '');
// * returns 3: '1234.57'
var n=!isFinite(+number)?0:+number;var prec=!isFinite(+decimals)?0:Math.abs(decimals);var sep=typeof thousands_sep==='undefined'?'':thousands_sep;var dec=typeof dec_point==='undefined'?'.':dec_point;//let s = '';
var toFixedFix=function toFixedFix(n,prec){var k=Math.pow(10,prec);return''+Math.round(n*k)/k;};// Fix for IE parseFloat(0.55).toFixed(0) = 0;
var s=(prec?toFixedFix(n,prec):''+Math.round(n)).split('.');if(s[0].length>3){s[0]=s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g,sep);}if((s[1]||'').length<prec){s[1]=s[1]||'';s[1]+=new Array(prec-s[1].length+1).join('0');}return s.join(dec);};exports.default=insertCoefByType;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var util = __webpack_require__(97);

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = util.assign(
    {
        'default': Format.RFC3986,
        formatters: {
            RFC1738: function (value) {
                return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function (value) {
                return String(value);
            }
        }
    },
    Format
);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _fingerprintjs=__webpack_require__(421);var _fingerprintjs2=_interopRequireDefault(_fingerprintjs);var _config=__webpack_require__(48);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ImprintHash=function(){function ImprintHash(){var _this=this;_classCallCheck(this,ImprintHash);this.getImprintHash=function(){return _this.imprintHash;};this.imprint=function(){return!(0,_config.getConfig)('IS_SERVER')&&new Promise(function(resolve){var fpPromise=_fingerprintjs2.default.load();fpPromise.then(function(fp){return fp.get();}).then(function(result){_jsCookie2.default.set('imprint',result.visitorId,{secure:true,sameSite:'lax'});resolve(_this.imprintHash=result.visitorId);});});};}_createClass(ImprintHash,null,[{key:'getInstance',value:function getInstance(){if(this.instance){return this.instance;}this.instance=new ImprintHash();return this.instance;}}]);return ImprintHash;}();exports.default=ImprintHash;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CategoriesTypes=exports.statisticCategoryID=exports.matchCategoryID=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var matchCategoryID=exports.matchCategoryID='MATCH';var statisticCategoryID=exports.statisticCategoryID='STATISTICS';var CategoriesTypes=exports.CategoriesTypes=function(_Subscribtion){_inherits(CategoriesTypes,_Subscribtion);function CategoriesTypes(){_classCallCheck(this,CategoriesTypes);var _this=_possibleConstructorReturn(this,(CategoriesTypes.__proto__||Object.getPrototypeOf(CategoriesTypes)).apply(this,arguments));_this.data=new Map();return _this;}_createClass(CategoriesTypes,[{key:'select',value:function select(matchID,categoryID){var data=this.data.get(Number(matchID));if(!data){throw new Error('Попытка выбрать тип категории незарегистрированного матча');}var selectedType=data[categoryID];(0,_lib.objectValues)(data).filter(function(staticType){return staticType.popular===selectedType.popular;}).forEach(function(staticType){staticType.isSelected=false;});selectedType.isSelected=true;this.notify(matchID);}},{key:'getPopular',value:function getPopular(matchID){return this.getData(matchID).filter(function(type){return type.popular===_base.STATE.ENABLED;});}},{key:'getSelected',value:function getSelected(matchID){return this.getData(matchID).find(function(state){return state.isSelected;})||null;}},{key:'getNotPopular',value:function getNotPopular(matchID){return this.getData(matchID).filter(function(type){return type.popular===_base.STATE.DISABLED;}).map(function(state){return[state.name,Object.assign(Object.assign({},state),{matchID:state.matchId})];});}},{key:'getData',value:function getData(matchID){if(!this.data.has(Number(matchID))){return[];}return(0,_lib.objectValues)(this.data.get(Number(matchID))||{});}},{key:'update',value:function update(matchID,staticTypes){if(staticTypes.length===0){return;}var matchState={matchId:matchID,name:matchCategoryID,isSelected:true,isDisabled:staticTypes.every(function(state){return state.isDisabled;}),popular:_base.STATE.ENABLED};var statisticState={matchId:matchID,name:statisticCategoryID,popular:_base.STATE.ENABLED,isDisabled:staticTypes.every(function(state){return state.isDisabled||state.popular===_base.STATE.ENABLED;})};var data=[matchState].concat(_toConsumableArray(staticTypes),[statisticState]).reduce(function(state,staticType){return Object.assign(state,_defineProperty({},staticType.name,staticType));},{});var notPopluarCategory=staticTypes.find(function(_ref){var popular=_ref.popular;return popular===_base.STATE.DISABLED;});if(notPopluarCategory){notPopluarCategory.isSelected=true;}this.data.set(matchID,data);this.notify(matchID);}},{key:'disable',value:function disable(matchID,states){var data=this.getData(matchID);data.filter(function(state){return state.matchId in states;}).forEach(function(state){state.isDisabled=states[state.matchId];});}}]);return CategoriesTypes;}(_Subscribtion3.default);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Match=exports.sportsIds=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _AppContexts=__webpack_require__(92);var _TBody=__webpack_require__(436);var _base=__webpack_require__(4);var _kafka=__webpack_require__(58);var _Timer=__webpack_require__(438);var _Timer2=_interopRequireDefault(_Timer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var sportsInfographic={26:'Soccer',27:'IceHockey',28:'Basketball',33:'Tennis',41:'Volleyball',134:'TableTennis',235:'Badminton',337:'BeachVolleyball',542:'ShortHockey',32:'Handball',177:'Futsal'};var sportsIds=exports.sportsIds={26:'Football',27:'IceHockey',28:'BasketBall',32:'Handball',33:'Tennis',46:'BeachFootball',41:'Volleyball',315:'Waterpolo',134:'TableTennis',173:'HockeyWhithBoll',177:'Futsal',235:'Badminton',337:'BeachVolleyball',// 562: 'CyberHockey',
// 564: 'CyberBasketBall',
// 571: 'CyberVolleyball',
635:'ShortHockey',702:'BasketBall3v3'// 560: 'CyberFootball',
};var Match=exports.Match=(0,_reactRouterDom.withRouter)(function(props){var _a,_b,_c,_d,_e,_f,_g,_h,_j,_k,_l,_m,_o,_p,_q,_r,_s,_t;var isDarkTheme=(0,_react.useMemo)(function(){return _AppContexts.ThemeContext.useTheme().theme==='Dark';},[]);var getCoef=function getCoef(betID){return props.matchData&&props.matchData.odds[betID]||{};};//#region favorite
var _useState=(0,_react.useState)(props.handlers.isFavoriteMatch(props.matchID)),_useState2=_slicedToArray(_useState,2),isFavorite=_useState2[0],favorite=_useState2[1];(0,_react.useEffect)(function(){favorite(props.handlers.isFavoriteMatch(props.matchID));},[props.handlers.isFavoriteMatch(props.matchID)]);var favoriteMatch=(0,_react.useCallback)(function(e){e.stopPropagation();if(!isFavorite){(0,_kafka.sendLogKafka)(_kafka.Events.favoUrites,{eventId:props.matchID});}props.handlers.favoriteMatch(props.matchID,!isFavorite);favorite(props.handlers.isFavoriteMatch(props.matchID));},[props.matchID,isFavorite]);//#endregion
var onVideoClick=(0,_react.useCallback)(function(e){e.stopPropagation();props.handlers.onVideoClick({id:Number(props.matchID),stats:props.matchData.hasMatchInfo,hasInfographics:props.matchData.hasInfographics,sid:Number(props.sportID),c1:props.matchData.team1,c2:props.matchData.team2,score:props.matchData.score,video_type:props.matchData.video||[]});props.history.push(props.url+'?active=video');},[props.matchID,props.matchData.hasMatchInfo]);var onInfographicsClick=function onInfographicsClick(e){e.stopPropagation();(0,_kafka.sendLogKafka)(_kafka.Events.matchCenterViewed,{eventId:props===null||props===void 0?void 0:props.matchID});props.history.push(props.url+'?active=stats');props.handlers.onInfographicsClick({id:Number(props.matchID),stats:props.matchData.hasMatchInfo,hasInfographics:props.matchData.hasInfographics,sid:Number(props.sportID),c1:props.matchData.team1,c2:props.matchData.team2,score:props.matchData.score,video_type:props.matchData.video||[]});};var isCoefChoosen=function isCoefChoosen(betID,oddID){return props.handlers.isCoefChoosen(props.matchID,betID,oddID);};var onCoefChoose=function onCoefChoose(oddID){props.handlers.onCoefChoose(oddID,props.matchID);};var oddsCount=typeof props.matchData.oddsCnt==='number'?props.matchData.oddsCnt:props.matchData.oddsCnt[props.width];var hasMatchData=oddsCount!==0||props.matchData.hasMatchInfo||props.matchData.video;var sportName=sportsIds===null||sportsIds===void 0?void 0:sportsIds[props.sportID];var sScoreData=sportName&&((_a=props.matchData.sScore)===null||_a===void 0?void 0:_a.sScoreData);var isFootballBased=sportName==='Football'||sportName==='Futsal'||sportName==='BeachFootball'||sportName==='CyberFootball';var isIceHockeyBased=sportName==='IceHockey'||sportName==='Waterpolo'||sportName==='HockeyWhithBoll'||sportName==='ShortHockey'||sportName==='CyberHockey'||sportName==='Handball';var isBasketBallBased=sportName==='BasketBall'||sportName==='BasketBall3v3'||sportName==='CyberBasketBall';var isTennis=sportName==='Tennis';var isTwoDvsBased=sportName==='Volleyball'||sportName==='TableTennis'||sportName==='Badminton'||sportName==='BeachVolleyball'||sportName==='CyberVolleyball';var sScoreMain=(_b=sScoreData===null||sScoreData===void 0?void 0:sScoreData.scs)===null||_b===void 0?void 0:_b.filter(function(item){if(isFootballBased){return item.et===1;}if(isIceHockeyBased){return item.et===1;}if(isBasketBallBased){return item.et===101;}if(isTennis){return item.et===100||item.et===99;}if(isTwoDvsBased){return item.et===101||item.et===99;}return null;});var sScoreStatistic=(_c=sScoreData===null||sScoreData===void 0?void 0:sScoreData.scs)===null||_c===void 0?void 0:_c.filter(function(item){if((sportsIds===null||sportsIds===void 0?void 0:sportsIds[props.sportID])==='Football'){return item.et===4;}if((sportsIds===null||sportsIds===void 0?void 0:sportsIds[props.sportID])==='Tennis'){return item.et===101;}return null;});var dontShowCurrentTime=isFootballBased;var sScoreStatisticViewConstructor=function sScoreStatisticViewConstructor(team){var _a,_b,_c,_d,_e,_f,_g,_h,_j,_k,_l,_m;var teamNumber=team===1?'t1':'t2';if(!((_c=(_b=(_a=sScoreStatistic===null||sScoreStatistic===void 0?void 0:sScoreStatistic[0])===null||_a===void 0?void 0:_a.scv)===null||_b===void 0?void 0:_b.cur)===null||_c===void 0?void 0:_c[teamNumber])){return null;}if((sportsIds===null||sportsIds===void 0?void 0:sportsIds[props.sportID])==='Football'){if(((_f=(_e=(_d=sScoreStatistic===null||sScoreStatistic===void 0?void 0:sScoreStatistic[0])===null||_d===void 0?void 0:_d.scv)===null||_e===void 0?void 0:_e.cur)===null||_f===void 0?void 0:_f[teamNumber])==='0'){return null;}return _react2.default.createElement('div',{style:{borderRadius:'2px',background:'#E92934',minWidth:'8px',width:'12px',padding:'2px',color:'#FFFFFF'}},(_j=(_h=(_g=sScoreStatistic===null||sScoreStatistic===void 0?void 0:sScoreStatistic[0])===null||_g===void 0?void 0:_g.scv)===null||_h===void 0?void 0:_h.cur)===null||_j===void 0?void 0:_j[teamNumber]);}if((sportsIds===null||sportsIds===void 0?void 0:sportsIds[props.sportID])==='Tennis'){return _react2.default.createElement('div',{style:{borderRadius:'2px',color:isDarkTheme?'#D1D1D1':'#747474',background:isDarkTheme?'rgba(255, 255, 255, 0.1)':'rgba(0, 0, 0, 0.1)'}},(_m=(_l=(_k=sScoreStatistic===null||sScoreStatistic===void 0?void 0:sScoreStatistic[0])===null||_k===void 0?void 0:_k.scv)===null||_l===void 0?void 0:_l.cur)===null||_m===void 0?void 0:_m[teamNumber]);}return null;};_react2.default.createElement('div',{style:{borderRadius:'2px',background:'rgba(0, 0, 0, 0.1)'}},(_f=(_e=(_d=sScoreStatistic===null||sScoreStatistic===void 0?void 0:sScoreStatistic[0])===null||_d===void 0?void 0:_d.scv)===null||_e===void 0?void 0:_e.cur)===null||_f===void 0?void 0:_f.t1);return _react2.default.createElement('div',{className:'live__item__game'},_react2.default.createElement('div',{className:'live__item__game-info-live emprty',onClick:hasMatchData?function(){(0,_kafka.sendLogKafka)(_kafka.Events.eventViewed,{eventId:props.matchID});props.history.push(props.url);}:void 0},_react2.default.createElement('div',{className:'live__item__game__header'},sScoreData?_react2.default.createElement('span',{className:'live__item__game__header__state'},sScoreData===null||sScoreData===void 0?void 0:sScoreData.sd):'',(sScoreData===null||sScoreData===void 0?void 0:sScoreData.fpss)?_react2.default.createElement('div',{className:'live__item__game__body__fpss'},sScoreData===null||sScoreData===void 0?void 0:sScoreData.fpss):'',!sScoreData?_react2.default.createElement('div',{className:'live__item__game__body__fpss'},props.matchData.score):'',_react2.default.createElement(_Timer2.default,{t:sScoreData===null||sScoreData===void 0?void 0:sScoreData.t,deltaTimeMs:props.deltaTimeMs}),_react2.default.createElement(VideoChannels,{video:props.matchData.video,url:props.url,onClick:onVideoClick}),_react2.default.createElement(Infographics,{hasMatchInfo:props.matchData.hasMatchInfo===_base.STATE.ENABLED,hasInfographics:props.matchData.hasInfographics===_base.STATE.ENABLED,url:props.url,onClick:onInfographicsClick,sportId:props.sportID}),_react2.default.createElement(Toggle,{count:oddsCount,url:props.url}),_react2.default.createElement('div',{className:'live__item__game__fav'},_react2.default.createElement('div',{onClick:favoriteMatch},_react2.default.createElement('i',{style:{fontSize:'16px'},className:''+(isFavorite?'f-s-ico-star_selected':'f-s-ico-star')})))),_react2.default.createElement('div',{className:'live__item__game__body'},_react2.default.createElement('div',{className:'live__item__game__body__teamInfo'},_react2.default.createElement('div',{className:'live__item__game__body__teamInfo__teamName'},props.matchData.team1),_react2.default.createElement('div',{className:'live__item__game__body__teamInfo__sScore'},(sScoreData===null||sScoreData===void 0?void 0:sScoreData.s)===1?_react2.default.createElement('div',{className:'sportTextColor-'+props.sportID},'\u25CE'):'',sScoreStatisticViewConstructor(1),sScoreMain&&(sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain.length)>1&&!dontShowCurrentTime?_react2.default.createElement('div',{style:{color:'#5580E3'}},(_j=(_h=(_g=sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain[(sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain.length)-1])===null||_g===void 0?void 0:_g.scv)===null||_h===void 0?void 0:_h.cur)===null||_j===void 0?void 0:_j.t1):'',_react2.default.createElement('div',null,(_m=(_l=(_k=sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain[0])===null||_k===void 0?void 0:_k.scv)===null||_l===void 0?void 0:_l.cur)===null||_m===void 0?void 0:_m.t1))),_react2.default.createElement('div',{className:'live__item__game__body__teamInfo'},_react2.default.createElement('div',{className:'live__item__game__body__teamInfo__teamName'},props.matchData.team2),_react2.default.createElement('div',{className:'live__item__game__body__teamInfo__sScore'},(sScoreData===null||sScoreData===void 0?void 0:sScoreData.s)===2?_react2.default.createElement('div',{className:'sportTextColor-'+props.sportID},'\u25CE'):'',sScoreStatisticViewConstructor(2),sScoreMain&&(sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain.length)>1&&!dontShowCurrentTime?_react2.default.createElement('div',{style:{color:'#5580E3'}},(_q=(_p=(_o=sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain[(sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain.length)-1])===null||_o===void 0?void 0:_o.scv)===null||_p===void 0?void 0:_p.cur)===null||_q===void 0?void 0:_q.t2):'',_react2.default.createElement('div',null,(_t=(_s=(_r=sScoreMain===null||sScoreMain===void 0?void 0:sScoreMain[0])===null||_r===void 0?void 0:_r.scv)===null||_s===void 0?void 0:_s.cur)===null||_t===void 0?void 0:_t.t2))))),props.matchData.mainTable?_react2.default.createElement(_TBody.TBody,{highlightChanges:props.highlightChanges,isCoefChoosen:isCoefChoosen,onCoefChoose:onCoefChoose,matchID:props.matchID,disabled:props.matchData.bl===_base.LOCK_STATE.BLOCKED,getCoef:getCoef,rows:props.matchData.mainTable}):_react2.default.createElement('div',{style:{height:'8px'}}));});var Toggle=_react2.default.memo(function(props){return _react2.default.createElement('div',{className:'live__item__game-ross'},props.count!==0&&_react2.default.createElement('a',null,'+'+props.count));});var Infographics=_react2.default.memo(function(props){if(props.hasInfographics&&sportsInfographic[props===null||props===void 0?void 0:props.sportId]||props.hasMatchInfo){return _react2.default.createElement('div',{className:'g-tv fl_r'},_react2.default.createElement('span',{style:{fontSize:'18px'},className:'f-s-ico-infographics',onClick:props.onClick}));}return null;});var VideoChannels=_react2.default.memo(function(props){if(!props.video){return null;}return _react2.default.createElement(_react.Fragment,null,props.video.map(function(linkType){return _react2.default.createElement('div',{className:'live__item__game__video',key:linkType},_react2.default.createElement('div',{style:{display:'flex',alignItems:'center',height:'16px'},className:'g-tv'},_react2.default.createElement('a',{style:{fontSize:'20px'},className:'item-ico-video f-s-ico-icon_live_tv item-ico-video-type-'+linkType,onClick:props.onClick})));}));});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getInstance=exports.MatchesList=undefined;var _Base=__webpack_require__(439);exports.MatchesList=_Base.MatchesListBase;var instance=void 0;var lastConfg='';var getInstance=exports.getInstance=function getInstance(cfg){if(instance){if(JSON.stringify(cfg)===lastConfg){return instance;}lastConfg=JSON.stringify(cfg);instance.reinit(cfg);return instance;}if(cfg.isMobile){instance=new _Base.MatchesListBase(cfg);return instance;}instance=new _Base.MatchesListBase(cfg);return instance;};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocalStorage=exports.LocalStorage=function(){function LocalStorage(){_classCallCheck(this,LocalStorage);}_createClass(LocalStorage,null,[{key:'store',value:function store(key,data){if(typeof window==='undefined'||typeof localStorage==='undefined'){return;}localStorage.setItem(key,JSON.stringify(data));}},{key:'restore',value:function restore(key){if(typeof window==='undefined'||typeof localStorage==='undefined'){return;}var data=localStorage.getItem(key);if(!data){return;}try{return JSON.parse(data);}catch(_e){return;}}}]);return LocalStorage;}();

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _basket=__webpack_require__(463);var _basket2=_interopRequireDefault(_basket);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketContainer=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(BasketContainer,_Component);function BasketContainer(){_classCallCheck(this,BasketContainer);return _possibleConstructorReturn(this,(BasketContainer.__proto__||Object.getPrototypeOf(BasketContainer)).apply(this,arguments));}_createClass(BasketContainer,[{key:'render',value:function render(){if(!this.props.lineStore.basket.mode)return false;var isLoading=this.props.lineStore.basket.isLoading;return isLoading?_react2.default.createElement('div',{className:'line-right-column-basket-cont b-l'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_basket2.default,null);}}]);return BasketContainer;}(_react.Component))||_class)||_class);exports.default=BasketContainer;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _reactTooltip=__webpack_require__(87);var _reactTooltip2=_interopRequireDefault(_reactTooltip);var _betsPeriod=__webpack_require__(173);var _BetsSellingModal=__webpack_require__(174);var _BetsSellingModal2=_interopRequireDefault(_BetsSellingModal);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);var _lodash=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Settings=(_dec=(0,_mobxReact.inject)('accountStore','lineStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Settings,_Component);function Settings(props){_classCallCheck(this,Settings);var _this=_possibleConstructorReturn(this,(Settings.__proto__||Object.getPrototypeOf(Settings)).call(this,props));_this.onClickOutside=function(e){if(_this.basketTooltipRef===e.target){return;}_this.hideTooltip();};_this.toggleAllLeague=function(){_this.props.lineStore.line.toggleAllLeagueShow();};_this.toggleSettings=function(){_this.setState({showSettings:!_this.state.showSettings});};_this.toggleMenu=function(){_this.props.lineStore.setShortMenu();};_this.toggleBasket=function(){_this.props.lineStore.basket.setShowBasket();};_this.state={showSettings:false,showBets:false};_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(Settings,[{key:'displayTooltip',value:function displayTooltip(){if(this.props.lineStore.basket.odds.size!==0){this.hideTooltip();return;}var accountSettings=this.props.accountStore.settings||{is_basket_tooltip_visible:1};// TODO КОСТЫЛЬ: 1 - значит подсказка была показана
if(accountSettings.is_basket_tooltip_visible===1){return;}_reactTooltip2.default.show(this.basketTooltipRef);}},{key:'componentDidMount',value:function componentDidMount(){this.displayTooltip();document.addEventListener('mousedown',this.onClickOutside);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.displayTooltip();}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.onClickOutside);}},{key:'hideTooltip',value:function hideTooltip(){this.props.accountStore.toggleAccountSettings('is_basket_tooltip_visible',1);_reactTooltip2.default.hide(this.basketTooltipRef);document.removeEventListener('mousedown',this.onClickOutside);}},{key:'render',value:function render(){var _this2=this;if(!this.props.lineStore.line)return false;var shortMenu=this.props.lineStore.shortMenu;var getLang=this.props.dictStore.getLang;var _props$accountStore=this.props.accountStore,accountSettings=_props$accountStore.accountSettings,isBetSellModalOpened=_props$accountStore.isBetSellModalOpened;var basketData=this.props.lineStore.basket.basketData;var oddsIds=(0,_lodash.get)(basketData,'oddsIds');var toogleBasket=this.props.lineStore.basket.toogleBasket;return _react2.default.createElement('div',{className:'control-panel'},_react2.default.createElement(_reactTooltip2.default,{clickable:true}),accountSettings.basketPosition=='right'?_react2.default.createElement('div',{className:'basket-right-cp fl_r ','data-tip':getLang('FRONT_TOOLTIP_UNION_BASKET_NEWBASKET'),ref:function ref(_ref){return _this2.basketTooltipRef=_ref;},'data-multiline':'true','data-event-off':'none','data-event':'none','data-place':'left','data-type':'light','data-border-color':'black','data-effect':'solid'},toogleBasket.showArrow?_react2.default.createElement('div',{className:'basket-bets-lurk '+(!toogleBasket.showBasket?'b-b-l':''),onClick:this.toggleBasket},_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'})):'',_react2.default.createElement('div',{className:'basket-bets-count-item active basket-bets-count-item-border'},_react2.default.createElement('span',{className:'fl_l'},getLang('BASKET')),oddsIds.size?_react2.default.createElement('span',{className:'fl_r basket-count-bet'},oddsIds.size):''),_react2.default.createElement(Count,null),isBetSellModalOpened?_react2.default.createElement(_BetsSellingModal2.default,null):null):'',_react2.default.createElement('div',{className:'control-panel-layer'},_react2.default.createElement('a',{className:'control-panel-item line-left-menu-toggle '+(shortMenu&&accountSettings.basketPosition=='right'?'line-left-menu-toggle-short':''),title:'\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u043C\u0435\u043D\u044E',onClick:this.toggleMenu},_react2.default.createElement('span',{className:'control-panel-ico control-panel-ico-menu f-s-ico-menu'}),_react2.default.createElement('span',{className:'control-panel-ico control-panel-ico-toggle f-s-ico-arrow_left'}),_react2.default.createElement('span',{className:'control-panel-text'},'\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u043C\u0435\u043D\u044E')),_react2.default.createElement(_underHeader2.default,{type:1}),_react2.default.createElement('div',{className:'clearfix'})));}}]);return Settings;}(_react.Component))||_class)||_class)||_class);exports.default=Settings;var Count=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Count,_Component2);function Count(){var _ref2;var _temp,_this3,_ret;_classCallCheck(this,Count);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref2=Count.__proto__||Object.getPrototypeOf(Count)).call.apply(_ref2,[this].concat(args))),_this3),_this3.state={showBets:false},_this3.toggleBets=function(){if(_this3.props.accountStore.access){_this3.setState({showBets:!_this3.state.showBets});}else{_this3.props.accountStore.toggleLoginForm(1);}},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(Count,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var countBets=this.props.accountStore.countBets;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{onClick:this.toggleBets,className:'basket-bets-count-item'},_react2.default.createElement('span',{className:'fl_l'},getLang('BETS')),_react2.default.createElement('span',{className:'fl_r basket-count-bet'},countBets?countBets:'')),this.state.showBets?_react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{styleModal:{width:'800px'},show:this.state.showBets,onCloseModal:this.toggleBets,title:getLang('IRM_BETS_STATUS_2')//footer={0}
//closeButton={1}
},_react2.default.createElement(_betsPeriod.BetsPopup,null))):null);}}]);return Count;}(_react.Component))||_class3)||_class3);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BetSellingButton=exports.List=exports.default=exports.BetsPopup=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5,_dec4,_class7,_dec5,_class9;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _reactDayPicker=__webpack_require__(473);var _reactDayPicker2=_interopRequireDefault(_reactDayPicker);var _moment=__webpack_require__(481);var _moment2=_interopRequireDefault(_moment);var _moment3=__webpack_require__(34);var _moment4=_interopRequireDefault(_moment3);__webpack_require__(483);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _common=__webpack_require__(6);var _BetsSellingModal=__webpack_require__(174);var _BetsSellingModal2=_interopRequireDefault(_BetsSellingModal);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Line from './line';
// const getLeagueKeys = memoizee((league) => _.keysIn(league));
var BetsPopup=exports.BetsPopup=(_dec=(0,_mobxReact.inject)('accountStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(BetsPopup,_Component);function BetsPopup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BetsPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BetsPopup.__proto__||Object.getPrototypeOf(BetsPopup)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseError=function(){_this.props.accountStore.BetsPage.clear();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BetsPopup,[{key:'componentDidMount',value:function componentDidMount(){// this.props.accountStore.initPage('bets');
this.props.accountStore.BetsPage.selectStatus(2);this.props.accountStore.BetsPage.loadData();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.BetsPage.despose();}},{key:'render',value:function render(){if(!this.props.accountStore.BetsPage)return false;var _props$accountStore$B=this.props.accountStore.BetsPage,wait=_props$accountStore$B.wait,result=_props$accountStore$B.result;var getLang=this.props.dictStore.getLang;return wait?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,result.status?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handleCloseError}):'',_react2.default.createElement(List,null));}}]);return BetsPopup;}(_react.Component))||_class)||_class);var Bets=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Bets,_Component2);function Bets(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,Bets);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=Bets.__proto__||Object.getPrototypeOf(Bets)).call.apply(_ref2,[this].concat(args))),_this2),_this2.handleCloseError=function(){_this2.props.accountStore.BetsPage.clear();},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(Bets,[{key:'componentDidMount',value:function componentDidMount(){this.props.accountStore.initPage('bets');}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.BetsPage.despose();}},{key:'render',value:function render(){if(!this.props.accountStore.BetsPage)return false;var _props$accountStore=this.props.accountStore,isBetSellModalOpened=_props$accountStore.isBetSellModalOpened,_props$accountStore$B2=_props$accountStore.BetsPage,isLoading=_props$accountStore$B2.isLoading,result=_props$accountStore$B2.result;return isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,isBetSellModalOpened?_react2.default.createElement(_BetsSellingModal2.default,null):null,_react2.default.createElement('div',{className:'blue_line'},_react2.default.createElement(_underHeader2.default,{type:2})),_react2.default.createElement(Filter,null),result.status?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handleCloseError}):'',_react2.default.createElement(List,null));}}]);return Bets;}(_react.Component))||_class3)||_class3);exports.default=Bets;var Filter=(_dec3=(0,_mobxReact.inject)('accountStore','dictStore'),(0,_reactRouterDom.withRouter)(_class5=_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(Filter,_Component3);function Filter(){var _ref3;var _temp3,_this3,_ret3;_classCallCheck(this,Filter);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this3=_possibleConstructorReturn(this,(_ref3=Filter.__proto__||Object.getPrototypeOf(Filter)).call.apply(_ref3,[this].concat(args))),_this3),_this3.state={from:undefined,to:undefined,open:0,show:false},_this3.DatepickerRef=_react2.default.createRef(),_this3.handleClick=function(){_this3.props.accountStore.BetsPage.loadData();},_this3.handleDayClick=function(day){var date=new Date();date.setDate(date.getDate()+1);if(_this3.props.accountStore.BetsPage.offset.getTime()>day.getTime()){_this3.setState({show:true});}else if(day.getTime()<date.getTime()){var range=_reactDayPicker.DateUtils.addDayToRange(day,_this3.props.accountStore.BetsPage.date);if(range.from&&range.to){_this3.props.accountStore.BetsPage.selectDate(range);_this3.setState({show:false});}}},_this3.selectStatus=function(e){_this3.props.accountStore.BetsPage.selectStatus(e.target.value);},_this3.openDatepicker=function(){_this3.setState({open:1});},_this3.handleClickOutside=function(e){if(!e.composedPath().includes(_this3.DatepickerRef.current)){_this3.setState({open:0});}},_temp3),_possibleConstructorReturn(_this3,_ret3);}_createClass(Filter,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.handleClickOutside,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.handleClickOutside,false);}},{key:'render',value:function render(){var _props$accountStore$B3=this.props.accountStore.BetsPage,filter=_props$accountStore$B3.filter,wait=_props$accountStore$B3.wait,status=_props$accountStore$B3.status,date=_props$accountStore$B3.date,offset=_props$accountStore$B3.offset;var getLang=this.props.dictStore.getLang;var _state=this.state,open=_state.open,show=_state.show;var modifiers={start:date.from,end:date.to};var value=(0,_moment4.default)(date.from).format("DD/MM/YYYY")+' - '+(0,_moment4.default)(date.to).format("DD/MM/YYYY");var disabledDays={after:new Date()};var goBack=this.props.history.goBack;if(!filter)return false;return _react2.default.createElement('div',{className:'account-bets-menu clearfix'},_react2.default.createElement('div',{className:'row clearfix'},_react2.default.createElement('div',{className:'row-item account-bets-date-cont',ref:this.DatepickerRef},_react2.default.createElement('div',{id:'account-bets-date-overlay',className:'account-bets-date-overlay hidden'}),_react2.default.createElement('label',{htmlFor:'account-bets-date',className:'hidden'}),_react2.default.createElement('input',{type:'text',className:'account-bets-date-cont account-datepicker-input',disabled:status==2?true:false,readOnly:1,onFocus:this.openDatepicker,value:value}),open?_react2.default.createElement('div',{className:'date-range-picker'},_react2.default.createElement(_reactDayPicker2.default,{className:'Selectable',localeUtils:_moment2.default,locale:'ru',fromMonth:offset,toMonth:new Date(),selectedDays:[date.from,{from:date.from,to:date.to}],modifiers:modifiers,numberOfMonths:1,onDayClick:this.handleDayClick,fixedWeeks:true,disabledDays:disabledDays}),show?_react2.default.createElement('div',{className:'account-bets-archive-note note'},getLang('IRM_ACCOUNT_BETS_ARCHIVE_NOTE')):''):''),_react2.default.createElement('div',{className:'row-item'},_react2.default.createElement('label',{htmlFor:'account-bets-status',className:'hidden'}),_react2.default.createElement('select',{id:'account-bets-status',className:'account-bets-select account-bets-status',onChange:this.selectStatus,disabled:wait},filter.status.map(function(el){return _react2.default.createElement('option',{key:el,value:el,selected:el==status},getLang('IRM_BETS_STATUS_'+el));}))),_react2.default.createElement('div',{className:'row-item buttons'},_react2.default.createElement('button',{type:'submit',className:'flat_button '+(wait?'wait':''),onClick:this.handleClick},getLang('SHOW')))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:''},_react2.default.createElement('a',{className:'link',to:'#',onClick:function onClick(){return goBack();}},getLang('BACK_TO_BETS')))));}}]);return Filter;}(_react.Component))||_class5)||_class5)||_class5);var List=exports.List=(_dec4=(0,_mobxReact.inject)('accountStore','dictStore'),_dec4(_class7=(0,_mobxReact.observer)(_class7=function(_Component4){_inherits(List,_Component4);function List(){var _ref4;var _temp4,_this4,_ret4;_classCallCheck(this,List);for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return _ret4=(_temp4=(_this4=_possibleConstructorReturn(this,(_ref4=List.__proto__||Object.getPrototypeOf(List)).call.apply(_ref4,[this].concat(args))),_this4),_this4.handleCancel=function(id){_this4.props.accountStore.BetsPage.cancel(id);},_temp4),_possibleConstructorReturn(_this4,_ret4);}_createClass(List,[{key:'render',value:function render(){var _props$accountStore$B4=this.props.accountStore.BetsPage,bets=_props$accountStore$B4.bets,error=_props$accountStore$B4.error,result=_props$accountStore$B4.result;var getLang=this.props.dictStore.getLang;if(!bets||!bets.length)return _react2.default.createElement('div',{className:'account-bets-no-bets'},'\u0421\u0442\u0430\u0432\u043E\u043A \u043D\u0435\u0442');return _react2.default.createElement('div',{className:'account-bets-cont'},bets.map(function(item){return item.type==9?_react2.default.createElement(Toto,{key:item,data:item}):_react2.default.createElement(Line,{key:item,data:item});}));}}]);return List;}(_react.Component))||_class7)||_class7);var status={0:'RESULT_EXPECTED',1:'FOR_PAYMENT',2:'FOR_PAYMENT',3:'BET_REJECTED',4:'BET_UNDER_CONSIDERATION'};var bet_type={0:'BET_SINGLE',1:'BET_EXPRESS',2:'BET_SYSTEM',3:'BET_CHAIN'};var game_status={0:'<span style="color:#000000;">H</span>',// not played yet
1:'<span style="color:#0163b7;">+</span>',// guessed
2:'<span style="color:#ff0000;">-</span>',// not guessed
3:'<span style="color:#bbbb00;">B</span>',// money returned
4:'<span style="color:#000099;">+</span>',// guessed
5:'<span style="color:#FF9900;">- B</span>',// loss_refund
6:'<span style="color:#0066FF;">+ B</span>',// win_refund
9:'<span style="color:#000000;">H</span>'// not played yet
};var Line=(0,_mobxReact.inject)('dictStore','appStore','accountStore')((0,_mobxReact.observer)(function(_ref5){var appStore=_ref5.appStore,dictStore=_ref5.dictStore,accountStore=_ref5.accountStore,data=_ref5.data;var sellingData=accountStore.betsSellingData[data.wager_id];return _react2.default.createElement('div',{className:'account-bets-item'},_react2.default.createElement('div',{className:'account-bets-bet-header'},_react2.default.createElement('div',{className:'account-bets-bet-number fl_r'},dictStore.getLang('BET')+' #'+data.number),_react2.default.createElement('div',{className:'account-bets-bet-status-'+data.status},_react2.default.createElement('span',{className:'account-bets-bet-name'},_react2.default.createElement('a',{className:'promo-1-rules-open'},data.free_bet?dictStore.getLang('FREE_BET')+' :':''),dictStore.getLang(bet_type[data.type]),data.type===2?' '+data.system:''),_react2.default.createElement('b',null,dictStore.getLang('FOR_AMOUNT')),_react2.default.createElement('span',{className:'account-bets-bet-amount'},_react2.default.createElement('b',null,(0,_common.numberFormat)(data.amount_set,2,',',' '))),_react2.default.createElement('span',{className:'account-bets-bet-currency'},appStore.currency.name),_react2.default.createElement('span',{className:'account-bets-bet-result'},_react2.default.createElement('b',null,dictStore.getLang(status[data.status]),': '),data.status===1||data.status===2?' '+(0,_common.numberFormat)(data.amount_win,2,',',' ')+' '+appStore.currency.name:''))),_react2.default.createElement('div',{className:'account-bets-bet-body'},_react2.default.createElement('table',{className:'account-bets-bet-games'},_react2.default.createElement('tbody',null,data.games.map(function(game){return _react2.default.createElement(_react.Fragment,null,0+''+0!==game.sid+''+game.lid?_react2.default.createElement('tr',{className:'account-bets-bet-sport'},_react2.default.createElement('td',{colSpan:'6'},game.sport_name,'. ',game.league_name)):'',_react2.default.createElement('tr',{className:'account-bets-bet-game'},_react2.default.createElement('td',{className:'account-bets-bet-game-date'},game.date),_react2.default.createElement('td',{className:'account-bets-bet-game-event'},game.event,_react2.default.createElement('div',{className:'account-bets-bet-game-score'},game.live_score?_react2.default.createElement('div',{className:'account-bets-bet-game-score-live fl_r'},'live'):'',game.score)),_react2.default.createElement('td',{colSpan:'2',className:'account-bets-bet-game-event-mobile'},game.event,_react2.default.createElement('br',null),_react2.default.createElement('span',{className:'account-bets-bet-game-score'},game.score)),_react2.default.createElement('td',{className:'account-bets-bet-game-name-cont'},_react2.default.createElement('div',{className:'account-bets-bet-game-name',title:game.name},game.name)),_react2.default.createElement('td',{className:'account-bets-bet-game-cf'},(0,_common.numberFormat)(game.cf,2,',',' ')),_react2.default.createElement('td',{className:'account-bets-bet-game-status'},_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:game_status[game.status]}}),game.comment?_react2.default.createElement('div',{className:'info'},_react2.default.createElement('div',{className:'info-text-wrapper'},_react2.default.createElement('div',{className:'info-text'},game.comment))):'')),_react2.default.createElement('tr',{className:'account-bets-bet-game-mobile'},_react2.default.createElement('td',{colSpan:'2'},_react2.default.createElement('div',{className:'fl_r account-bets-bet-game-cf'},(0,_common.numberFormat)(game.cf,2,',',' ')),_react2.default.createElement('div',{className:'account-bets-bet-game-name',title:game.name},game.name)),_react2.default.createElement('td',{className:'account-bets-bet-game-status',dangerouslySetInnerHTML:{__html:game_status[game.status]}})));}),_react2.default.createElement('tr',{className:'account-bets-bet-data'},_react2.default.createElement('td',{colSpan:'6'},_react2.default.createElement('div',{className:'fl_r account-bets-bet-total-cf'},data.type===1?'K='+(0,_common.numberFormat)(data.total_cf,2,',',' '):''),_react2.default.createElement('div',{className:'account-bets-bet-date',title:dictStore.getLang('BET_TIME')+': '+data.date},data.date))))),sellingData?_react2.default.createElement(BetSellingButton,{data:data,sellingData:sellingData}):null,data.is_sold&&_react2.default.createElement('div',{style:{display:'flex',justifyContent:'flex-end'}},_react2.default.createElement('div',{className:'sale-bet sale-bet-blocked'},dictStore.getLang('IS_SOLD')))));}));var BetSellingButton=exports.BetSellingButton=(_dec5=(0,_mobxReact.inject)('accountStore','dictStore'),_dec5(_class9=(0,_mobxReact.observer)(_class9=function(_Component5){_inherits(BetSellingButton,_Component5);function BetSellingButton(){var _ref6;var _temp5,_this5,_ret5;_classCallCheck(this,BetSellingButton);for(var _len5=arguments.length,args=Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}return _ret5=(_temp5=(_this5=_possibleConstructorReturn(this,(_ref6=BetSellingButton.__proto__||Object.getPrototypeOf(BetSellingButton)).call.apply(_ref6,[this].concat(args))),_this5),_this5.openModal=function(){var _this5$props=_this5.props,data=_this5$props.data,sellingData=_this5$props.sellingData;_this5.props.accountStore.openBetSellModal(true);_this5.props.accountStore.setBetSellData(data,sellingData);},_temp5),_possibleConstructorReturn(_this5,_ret5);}_createClass(BetSellingButton,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var sellingData=this.props.sellingData;return _react2.default.createElement('div',{style:{display:'flex',justifyContent:'flex-end'},onClick:!sellingData.bl&&this.openModal},_react2.default.createElement('div',{className:'sale-bet '+(sellingData.bl?'sale-bet-blocked':'')},getLang('SELL_FOR'),'\xA0',_react2.default.createElement('b',null,sellingData.price),'\u20BD'));}}]);return BetSellingButton;}(_react.Component))||_class9)||_class9);var Toto=(0,_mobxReact.inject)('dictStore','appStore')((0,_mobxReact.observer)(function(_ref7){var dictStore=_ref7.dictStore,appStore=_ref7.appStore,data=_ref7.data;return _react2.default.createElement('div',{className:'account-bets-item'},_react2.default.createElement('div',{className:'account-bets-bet-header'},_react2.default.createElement('div',{className:'account-bets-toto-number fl_r'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/bet/'+data.id},dictStore.getLang('CARD'),' ',data.number)),_react2.default.createElement('b',null,_react2.default.createElement('span',{className:'account-bets-bet-name'},appStore.cashboxMode===2?dictStore.getLang('SUPER_EXPRESS'):dictStore.getLang('TOTO')),dictStore.getLang('FOR_AMOUNT'),_react2.default.createElement('span',{className:'account-bets-bet-amount'},_react2.default.createElement('b',null,(0,_common.numberFormat)(data.amount_set,2,',',' '))),_react2.default.createElement('span',{className:'account-bets-bet-currency'},appStore.currency.name),_react2.default.createElement('span',{className:'account-bets-bet-result'},dictStore.getLang(status[data.status]),data.status>0?' - '+(0,_common.numberFormat)(data.amount_win,2,',',' ')+' '+appStore.currency.name:''))),_react2.default.createElement('div',{className:'account-bets-bet-body'},_react2.default.createElement('div',{className:'account-bets-toto-data'},_react2.default.createElement('span',{className:'account-bets-bet-toto-name'},data.name)),_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'account-bets-bet-date',title:dictStore.getLang('BET_TIME')+': '+data.date_text},data.date_text))));}));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);__webpack_require__(484);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetsSellingModal=(_dec=(0,_mobxReact.inject)('accountStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(BetsSellingModal,_Component);function BetsSellingModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BetsSellingModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BetsSellingModal.__proto__||Object.getPrototypeOf(BetsSellingModal)).call.apply(_ref,[this].concat(args))),_this),_this.onCloseModal=function(){_this.props.accountStore.openBetSellModal(false);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BetsSellingModal,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.resetSelling();}},{key:'render',value:function render(){var _props$accountStore$s=this.props.accountStore.sellingStatus,step=_props$accountStore$s.step,wait=_props$accountStore$s.wait;return _react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{show:true,onCloseModal:this.onCloseModal,styleModal:step===2?{width:'290px',height:'150px'}:{width:'376px'}},wait?_react2.default.createElement(_loadingSpinner2.default,null):_react2.default.createElement(_react.Fragment,null,step===1?_react2.default.createElement(BetsSellingModalStep1,{onCloseModal:this.onCloseModal}):null,step===2?_react2.default.createElement(BetsSellingModalStep2,null):null)));}}]);return BetsSellingModal;}(_react.Component))||_class)||_class);exports.default=BetsSellingModal;var BetsSellingModalStep1=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore','appStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(BetsSellingModalStep1,_Component2);function BetsSellingModalStep1(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,BetsSellingModalStep1);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=BetsSellingModalStep1.__proto__||Object.getPrototypeOf(BetsSellingModalStep1)).call.apply(_ref2,[this].concat(args))),_this2),_this2.sellBet=function(){var _this2$props$accountS=_this2.props.accountStore,activeBetData=_this2$props$accountS.activeBetData,activeBetSellingData=_this2$props$accountS.activeBetSellingData;_this2.props.accountStore.sellBet(activeBetData.wager_id,activeBetSellingData.price);},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(BetsSellingModalStep1,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$accountStore=this.props.accountStore,activeBetData=_props$accountStore.activeBetData,activeBetSellingData=_props$accountStore.activeBetSellingData,sellingStatus=_props$accountStore.sellingStatus,result=_props$accountStore.result;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'bet-sale-modal__body'},_react2.default.createElement('div',{className:'type'},_react2.default.createElement('p',{className:'basket-bets-item-name fl_l'},getLang('BET_SINGLE'),' ','#'+activeBetData.number)),_react2.default.createElement('div',{className:'question question_big'},getLang('SELL_BET')),_react2.default.createElement('div',{className:'question'},activeBetData.games[0].event),_react2.default.createElement('div',{className:'question question_big question_sum'},'\u0437\u0430 ',activeBetSellingData.price,' \u20BD?'),_react2.default.createElement('div',{className:'data'},getLang('BET_AMOUNT'),' ',(0,_common.numberFormat)(activeBetData.amount_set,2,'.',' '),' ',this.props.appStore.currency.name),_react2.default.createElement('div',{className:'data'},getLang('COEFFICIENT'),' ',(0,_common.numberFormat)(!activeBetData.games[0].cf||activeBetData.games[0].cf==0?'':activeBetData.games[0].cf,2,',',' ')),!sellingStatus.success&&_react2.default.createElement('div',{className:'result-message result-message_error'},result.text)),_react2.default.createElement('div',{className:'bet-sale-modal__buttons'},_react2.default.createElement('button',{type:'button',tabIndex:'2',className:'flat_button flat_button_2',onClick:this.props.onCloseModal},getLang('CANCEL1')),!sellingStatus.isBlockedSell&&_react2.default.createElement('button',{type:'button',tabIndex:'2',className:'flat_button flat_button_1',onClick:this.sellBet},getLang('SELL'))));}}]);return BetsSellingModalStep1;}(_react.Component))||_class3)||_class3);var BetsSellingModalStep2=(_dec3=(0,_mobxReact.inject)('accountStore','dictStore'),_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(BetsSellingModalStep2,_Component3);function BetsSellingModalStep2(){_classCallCheck(this,BetsSellingModalStep2);return _possibleConstructorReturn(this,(BetsSellingModalStep2.__proto__||Object.getPrototypeOf(BetsSellingModalStep2)).apply(this,arguments));}_createClass(BetsSellingModalStep2,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var result=this.props.accountStore.result;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'bet-sale-modal__body'},_react2.default.createElement('div',{className:'question question_big'},getLang('READY')),_react2.default.createElement('div',{className:'logo_success'}),_react2.default.createElement('div',{className:'result-message'},result.text)));}}]);return BetsSellingModalStep2;}(_react.Component))||_class5)||_class5);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollTop=function(_PureComponent){_inherits(ScrollTop,_PureComponent);function ScrollTop(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollTop);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollTop.__proto__||Object.getPrototypeOf(ScrollTop)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){document.getElementById('line-central-column').scrollTop=0;document.getElementById('divmain').scrollTop=0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ScrollTop,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'line-left-menu-up line-up',title:'\u041D\u0430\u0432\u0435\u0440\u0445'},_react2.default.createElement('button',{className:'line-left-menu-up-btn',onClick:this.handleClick},_react2.default.createElement('span',{className:'line-sport-menu-item-ico line-left-menu-up-ico'},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('div',{className:'line-left-menu-up-text'},' \u041D\u0430\u0432\u0435\u0440\u0445')));}}]);return ScrollTop;}(_react.PureComponent);exports.default=ScrollTop;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBox=(_dec=(0,_mobxReact.inject)('searchStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(SearchBox,_Component);function SearchBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchBox.__proto__||Object.getPrototypeOf(SearchBox)).call.apply(_ref,[this].concat(args))),_this),_this.searchInput=_react2.default.createRef(),_this.handleInput=function(e){_this.props.searchStore.changeInput(e.target.value);},_this.handleClickOutside=function(e){var domNode=document.getElementById('search-box');if(e.path&&!e.path.includes(domNode)){_this.props.searchStore.changeResultShowState(false);}},_this.handleKeyDown=function(e){var _this$props$searchSto=_this.props.searchStore,data=_this$props$searchSto.data,keyIndex=_this$props$searchSto.keyIndex;if(!data.length)return;// arrow up/down button should select next/previous list element
if(e.keyCode===38&&keyIndex>0){_this.props.searchStore.changeKeyIndex(keyIndex-1);document.getElementById('search-item-'+(keyIndex-1)).focus();}else if(e.keyCode===40&&keyIndex<data.length-1){_this.props.searchStore.changeKeyIndex(keyIndex+1);document.getElementById('search-item-'+(keyIndex+1)).focus();}else if(e.keyCode!==9&&e.keyCode!==16&&e.keyCode!==13){_this.searchInput.current.focus();}},_this.handleClear=function(){_this.props.searchStore.changeInput('');_this.searchInput.current.focus();},_this.handleFocus=function(){if(_this.props.searchStore.data.length){_this.props.searchStore.changeResultShowState(true);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchBox,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.handleClickOutside,false);document.removeEventListener('keydown',this.handleKeyDown,false);}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.handleClickOutside,false);document.addEventListener('keydown',this.handleKeyDown,false);}},{key:'render',value:function render(){var _props$searchStore=this.props.searchStore,resultShow=_props$searchStore.resultShow,data=_props$searchStore.data,loading=_props$searchStore.loading,showClear=_props$searchStore.showClear,str=_props$searchStore.str;return _react2.default.createElement('div',{className:'line-left-menu-search',id:'search-box'},_react2.default.createElement('div',{className:'search-box-wrapper'+(loading?' line-search-loader':'')+(showClear?' fill':'')},_react2.default.createElement('div',{className:'input-wrapper'},_react2.default.createElement('input',{className:'input',type:'text',ref:this.searchInput,placeholder:'\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043B\u0438\u0433\u0438 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B',onChange:this.handleInput,onFocus:this.handleFocus,value:str}),_react2.default.createElement('div',{className:'preloader'},_react2.default.createElement('div',{className:'cursor'})),_react2.default.createElement('button',{className:'clear',onClick:this.handleClear},'\u2716'),_react2.default.createElement('span',{className:'line-left-menu-search-icon f-s-ico-search'})),resultShow?_react2.default.createElement(ResultSearch,{data:data}):''));}}]);return SearchBox;}(_react.Component))||_class)||_class);exports.default=SearchBox;var ResultSearch=(_dec2=(0,_mobxReact.inject)('searchStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(ResultSearch,_Component2);function ResultSearch(){_classCallCheck(this,ResultSearch);return _possibleConstructorReturn(this,(ResultSearch.__proto__||Object.getPrototypeOf(ResultSearch)).apply(this,arguments));}_createClass(ResultSearch,[{key:'componentDidMount',value:function componentDidMount(){document.getElementById('search-item-'+this.props.searchStore.keyIndex).focus();}},{key:'render',value:function render(){var data=this.props.data;var _props$searchStore2=this.props.searchStore,showCurse=_props$searchStore2.showCurse,more=_props$searchStore2.more,keyIndex=_props$searchStore2.keyIndex;return _react2.default.createElement('div',{className:'search-result'},_react2.default.createElement('div',{className:'search-result-items'},data.map(function(item,idx){return _react2.default.createElement(Item,{key:item.id,item:item,index:keyIndex,id:idx});})),more?_react2.default.createElement('div',{className:'load-more'},_react2.default.createElement('span',null,'\u041D\u0430\u0439\u0434\u0435\u043D\u043E \u0435\u0449\u0451 ',more,' ',(0,_common.declOfNum)(more,['событие','события','событий']),'. \u0423\u0442\u043E\u0447\u043D\u0438\u0442\u0435 \u043F\u043E\u0438\u0441\u043A')):'',showCurse?_react2.default.createElement('div',{className:'load-more'},_react2.default.createElement('span',null,'\u041C\u044B \u0432\u0430\u0441 \u043B\u044E\u0431\u0438\u043C. \u0423\u0442\u043E\u0447\u043D\u0438\u0442\u0435 \u043F\u043E\u0438\u0441\u043A')):'');}}]);return ResultSearch;}(_react.Component))||_class3)||_class3);var Item=(_dec3=(0,_mobxReact.inject)('searchStore'),(0,_reactRouterDom.withRouter)(_class4=_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Item,_Component3);function Item(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,Item);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=Item.__proto__||Object.getPrototypeOf(Item)).call.apply(_ref2,[this].concat(args))),_this3),_this3.handleClick=function(url){_this3.props.history.push(url);_this3.props.searchStore.changeInput('');},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(Item,[{key:'render',value:function render(){var _this4=this;var _props=this.props,item=_props.item,index=_props.index,id=_props.id;var name=item.name.substr(0,item.cursor.begin)+'<span className="cursor">'+item.name.substr(item.cursor.begin,item.cursor.length)+'</span>'+item.name.substr(item.cursor.end,item.name.length-item.cursor.end);var url='/'+(item.live?'live':'line')+'/'+item.sid+'/'+(item.type==4&&item.lid?item.lid+'/':'')+item.id;var preName=null;if(item.live&&item.type===4){preName=_react2.default.createElement('span',{className:'live f-s-ico-live'});}else if(item.date&&item.type===4){preName=_react2.default.createElement('span',{className:'date'},item.date);}return _react2.default.createElement('a',{id:'search-item-'+id,href:'#',className:'item'+(item.type==4?' game':'')+(index==id?' selected':''),onClick:function onClick(){return _this4.handleClick(url);}},!item.live?_react2.default.createElement('span',{className:'icon-sport f-s-ico-'+item.sid}):'',preName,_react2.default.createElement('span',{className:'name',dangerouslySetInnerHTML:{__html:name}}));}}]);return Item;}(_react.Component))||_class4)||_class4)||_class4);

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    isObject = __webpack_require__(99);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 180 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(25),
    stubFalse = __webpack_require__(511);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)(module)))

/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(512),
    baseUnary = __webpack_require__(65),
    nodeUtil = __webpack_require__(513);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66),
    stackClear = __webpack_require__(527),
    stackDelete = __webpack_require__(528),
    stackGet = __webpack_require__(529),
    stackHas = __webpack_require__(530),
    stackSet = __webpack_require__(531);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(544),
    isObjectLike = __webpack_require__(43);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(70),
    arraySome = __webpack_require__(547),
    cacheHas = __webpack_require__(71);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(194),
    toKey = __webpack_require__(72);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isKey = __webpack_require__(107),
    stringToPath = __webpack_require__(563),
    toString = __webpack_require__(566);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Facebook = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.facebook.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: _this2.props.config.facebook.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

exports.Facebook = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Facebook, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Facebook);

exports["default"] = _default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Streamable = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports.Streamable = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Streamable);

exports["default"] = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Wistia = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "getID",
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props5 = this.props,
          playing = _this$props5.playing,
          muted = _this$props5.muted,
          controls = _this$props5.controls,
          _onReady = _this$props5.onReady,
          config = _this$props5.config,
          onError = _this$props5.onError;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.getID(url),
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.getID(this.props.url);
      var className = "wistia_embed wistia_async_".concat(id);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports.Wistia = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Wistia, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Wistia);

exports["default"] = _default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Twitch = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.twitch.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;
      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports.Twitch = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
});

_defineProperty(Twitch, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Twitch);

exports["default"] = _default;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Mixcloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_objectSpread({}, config.mixcloud.options, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports.Mixcloud = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Mixcloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Mixcloud);

exports["default"] = _default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FilePlayer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(14);

var _singlePlayer = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }

        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function supportsWebKitPresentationMode(video) {
  if (!video) video = document.createElement('video'); // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function

  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && !/iPhone|iPod/.test(navigator.userAgent);
}

function canEnablePIP(url) {
  return canPlay(url) && (!!document.pictureInPictureEnabled || supportsWebKitPresentationMode()) && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && supportsWebKitPresentationMode(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners(this.player);

      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer);
        this.addListeners(this.player);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var playsinline = this.props.playsinline;
      player.addEventListener('canplay', this.onReady);
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }

      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config$fi = this.props.config.file,
          hlsVersion = _this$props$config$fi.hlsVersion,
          dashVersion = _this$props$config$fi.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          _this2.hls.loadSource(url);

          _this2.hls.attachMedia(_this2.player);
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);

      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playing = _this$props10.playing,
          loop = _this$props10.loop,
          controls = _this$props10.controls,
          muted = _this$props10.muted,
          config = _this$props10.config,
          width = _this$props10.width,
          height = _this$props10.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.file.attributes), url instanceof Array && url.map(this.renderSourceElement), config.file.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports.FilePlayer = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", canPlay);

_defineProperty(FilePlayer, "canEnablePIP", canEnablePIP);

var _default = (0, _singlePlayer["default"])(FilePlayer);

exports["default"] = _default;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;

/**
 * Do absolutely nothing
 */
var noop = function noop() {};

exports.noop = noop;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(592);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_mobxReact.inject)('igStore')((0,_mobxReact.observer)(function(_ref){var igStore=_ref.igStore,height=_ref.height;var reveal=igStore.reveal,tab=igStore.tab,toggleReveal=igStore.toggleReveal,game=igStore.game;if(!/events|stats/.test(tab))return null;if(height<130)return _react2.default.createElement('div',{className:'ig-reveal s-c-'+game.sid});return _react2.default.createElement('button',{className:'ig-reveal s-c-'+game.sid+(reveal?' ig-reveal--active':''),onClick:toggleReveal},_react2.default.createElement('i',{className:'f-s-ico-arrow_buttom_1'}));}));

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventHeader=(_dec=(0,_mobxReact.inject)('igStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(EventHeader,_Component);function EventHeader(){_classCallCheck(this,EventHeader);return _possibleConstructorReturn(this,(EventHeader.__proto__||Object.getPrototypeOf(EventHeader)).apply(this,arguments));}_createClass(EventHeader,[{key:'render',value:function render(){var _props$igStore=this.props.igStore,game=_props$igStore.game,reInit=_props$igStore.reInit;var sid=game.sid;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'ig-event-header s-c-'+sid},_react2.default.createElement('div',{className:'ig-teams'},_react2.default.createElement('div',{className:'ig-team'},_react2.default.createElement('div',{className:'ig-team-shield'}),_react2.default.createElement('div',{className:'ig-team-text ig-team-text--locked'})),_react2.default.createElement('div',{className:'ig-team'},_react2.default.createElement('div',{className:'ig-team-shield'}),_react2.default.createElement('div',{className:'ig-team-text ig-team-text--locked'})))),_react2.default.createElement('div',{className:'ig-item-wrapper'},_react2.default.createElement('div',{className:'ig-error'},_react2.default.createElement('span',{className:'ig-error__text'},getLang('CONNECTION_FAILED')),_react2.default.createElement('button',{className:'flat_button flat_button_w',onClick:reInit},getLang('RETRY')))));}}]);return EventHeader;}(_react.Component))||_class)||_class);exports.default=EventHeader;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__ = __webpack_require__(117);


function uuidToBytes(uuid) {
  // Note: We assume we're being passed a valid uuid string
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = new Array(str.length);

  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  var generateUUID = function generateUUID(value, namespace, buf, offset) {
    var off = buf && offset || 0;
    if (typeof value == 'string') value = stringToBytes(value);
    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3

    var bytes = hashfunc(namespace.concat(value));
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      for (var idx = 0; idx < 16; ++idx) {
        buf[off + idx] = bytes[idx];
      }
    }

    return buf || Object(__WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__["a" /* default */])(bytes);
  }; // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name;
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.lineStore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_desc2,_value2,_class3,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13;var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _pathToRegexp=__webpack_require__(638);var _pathToRegexp2=_interopRequireDefault(_pathToRegexp);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);var _routingStore=__webpack_require__(209);var _routingStore2=_interopRequireDefault(_routingStore);var _basket=__webpack_require__(640);var _basket2=_interopRequireDefault(_basket);var _line=__webpack_require__(653);var _line2=_interopRequireDefault(_line);var _menu=__webpack_require__(663);var _menu2=_interopRequireDefault(_menu);var _schedule=__webpack_require__(678);var _schedule2=_interopRequireDefault(_schedule);var _store=__webpack_require__(118);var _store2=_interopRequireDefault(_store);var _MatchesList=__webpack_require__(169);var MatchesList=_interopRequireWildcard(_MatchesList);var _base=__webpack_require__(214);var _config=__webpack_require__(217);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var parseUrl=(_class=function(){function parseUrl(store){var _this=this;_classCallCheck(this,parseUrl);this.store=null;this.route=null;this.afterUrl={};_initDefineProp(this,'params',_descriptor,this);this.mode='';this.run=null;this.store=store;(0,_mobx.when)(function(){return _this.store.line.status;},function(){return _this.init();});}_createClass(parseUrl,[{key:'init',value:function init(){var _this2=this;if(this.run)this.run();this.run=(0,_mobx.autorun)(function(){_this2.getUrl2(_this2.params);});}},{key:'despose',value:function despose(){this.afterUrl={};}},{key:'setUrl',value:function setUrl(params){if(!_lodash2.default.isEqual(_mobx2.default.toJS(this.params),params))this.params=params;// this.getUrl2(this.params);
}},{key:'getUrl2',value:function getUrl2(params){this.mode=this.store.mode;if(!params){return;}var param1=params.sport?params.sport.split('-'):[];var firstParam=param1[0];if(!firstParam&&this.mode==='line'){//       const sport = this.store.menu.sport.keys().map(Number)
// ;      this.store.menu.selectItem({
//         sport,
//         league: [],
//         games: [],
//       }, 1);
this.store.menu.selectItem('pop',4);}else if(firstParam==='other'&&this.mode==='line'){this.store.menu.selectOther();}else if(firstParam==='popular'&&this.mode==='line'){var id=params.league?params.league.split('-'):'';if(id){if(this.afterUrl==='popular/'+id)return false;this.store.menu.selectItem(id,5);this.afterUrl='popular/'+id;}else{if(this.afterUrl==='popular')return false;this.store.menu.selectItem('pop',4);}return;}else if(firstParam==='video'&&this.mode==='live'){this.store.menu.selectItem('video',6);}else if(firstParam==='schedule'&&this.mode==='live'){if(this.afterUrl===firstParam)return false;this.store.toggleSchedule(true);this.afterUrl=param1[0];return;}else if(firstParam==='favourites'){if(this.store.menu.favourites.games.length||this.store.menu.favourites.popular.pop.length){this.store.menu.selectItem('fav',0);}else{// window.location = `/${this.mode}`;
_appStore2.default.history.push('/'+this.mode);}}else{var type=1;var league=params.league?params.league.split('-'):[];var games=params.games?params.games.split('-'):[];// const ross = params.ross ? 1 : 0;
if(param1.length&&league.length&&games.length){type=3;}else if(param1.length&&league.length){type=2;}param1=param1.map(function(i){return Number(i);});league=league.map(function(i){return Number(i);});games=games.map(function(i){return Number(i);});if(this.mode==='line'&&this.afterUrl&&this.afterUrl.sport===params.sport&&this.afterUrl.league===params.league&&this.afterUrl.games===params.games)return;this.afterUrl=params;this.store.menu.selectItem({sport:param1,league:league,games:games},type,1);}}},{key:'getUrl',value:function getUrl(location){// console.log(location)
var re=(0,_pathToRegexp2.default)('/:sport?/:league?/:games?/:ross?');var path=re.exec(location.pathname);var mode=path[1];this.mode=mode;var param1=path[2]?path[2].split('-'):[];if(param1[0]=='schedule'){// console.log(param1[0]);
if(this.afterUrl==param1[0])return false;this.store.toggleSchedule(true);this.afterUrl=param1[0];return;}else if(param1=='favourites'){if(this.store.menu.favourites.games.length){this.store.menu.selectItem('fav',0);}else{this.route.push('/'+mode);}}else{// console.log(this.afterUrl);
var type=1;var league=path[3]?path[3].split('-'):[];var games=path[4]?path[4].split('-'):[];var ross=path[5]?1:0;if(param1.length&&league.length&&games.length){type=3;}else if(param1.length&&league.length){type=2;}param1=param1.map(function(i){return Number(i);});league=league.map(function(i){return Number(i);});games=games.map(function(i){return Number(i);});if(mode=='line'&&this.afterUrl&&this.afterUrl.sport==path[2]&&this.afterUrl.league==path[3]&&this.afterUrl.games==path[4])return;this.afterUrl={sport:path[2],league:path[3],games:path[4]};this.store.menu.selectItem({sport:param1,league:league,games:games},type,1);}}}]);return parseUrl;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'params',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'setUrl',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setUrl'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getUrl2',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getUrl2'),_class.prototype)),_class);var lineStore=exports.lineStore=(_class3=function(){function lineStore(appStore){var _this3=this;_classCallCheck(this,lineStore);_initDefineProp(this,'col',_descriptor2,this);_initDefineProp(this,'mode',_descriptor3,this);_initDefineProp(this,'line',_descriptor4,this);_initDefineProp(this,'menu',_descriptor5,this);_initDefineProp(this,'schedule',_descriptor6,this);_initDefineProp(this,'scheduleActive',_descriptor7,this);_initDefineProp(this,'basket',_descriptor8,this);_initDefineProp(this,'isLoading',_descriptor9,this);_initDefineProp(this,'shortMenu',_descriptor10,this);_initDefineProp(this,'route',_descriptor11,this);_initDefineProp(this,'liveRefreshInterval',_descriptor12,this);_initDefineProp(this,'liveRefreshOne',_descriptor13,this);this.HIDE_WIDTH=600;this.sideEffect=function(){localStorage.setItem('lastAction',_this3.mode==='line'?'1':'0');};this.line=new _line2.default(this,_accountStore2.default,appStore);this.menu=new _menu2.default(this,_accountStore2.default);this.basket=new _basket2.default(this,_accountStore2.default,appStore);this.route=new parseUrl(this,_routingStore2.default);// const withStatsMatches = /^(zenitbet|desktop|mobile_new|mobile_com)$/.test(getConfig('APP_NAME'));
/** Хранилище live матчей */this.matchesList=MatchesList.getInstance({width:window.innerWidth<this.HIDE_WIDTH?_base.COLUMN_WIDTH.SMALL:_base.COLUMN_WIDTH.MEDIUM,getSocket:_store2.default.getSocket,webSocketURL:_store2.default.url,withStatsMatches:true,site:_config.SITE_TYPE.IRM_CUPIS,isMobile:false,timezone:3,lng:1049});this.subscribeMathesList();}// @observable liveSetting = {
// 	refresh: 3000,
// 	resresh_one: 3000
// };
_createClass(lineStore,[{key:'subscribeMathesList',value:function subscribeMathesList(){var _this4=this;var favouritesStore=this.line.store.menu;this.matchesList.matches.onFavorite(favouritesStore.favoriteMatch);this.matchesList.championships.onFavorite(function(championshipID,matchIDs,isFavourite){favouritesStore.favoriteChampionship(championshipID,isFavourite);matchIDs.forEach(function(matchID){_this4.matchesList.matches.favoriteMatch(matchID,isFavourite);});});}},{key:'init',value:function init(mode,params){this.clear();this.mode=mode;this.line=new _line2.default(this,_accountStore2.default,_appStore2.default);// setTimeout(() => {
if(this.mode){var siteType=_config.SITE_TYPE.IRM_CUPIS;if(siteType!==_config.SITE_TYPE.IRM_CUPIS){this.matchesList=MatchesList.getInstance({width:window.innerWidth<this.HIDE_WIDTH?_base.COLUMN_WIDTH.SMALL:_base.COLUMN_WIDTH.MEDIUM,getSocket:_store2.default.getSocket,webSocketURL:_store2.default.url,withStatsMatches:true,isMobile:false,timezone:3,lng:1049,siteType:siteType});}this.menu.init();this.basket.init();// this.route.init();
this.isLoading=false;if(this.mode=='live'){this.schedule=new _schedule2.default(this);}this.getShortMenu();}// }, 1000);
}},{key:'init2',value:function init2(){this.line.init();this.route.init();// this.toggleSchedule(1); // только для разработки
}},{key:'toggleSchedule',value:function toggleSchedule(status){// if (this.scheduleActive && status) return;
if(this.mode=='live'){if(status){this.scheduleActive=true;this.schedule.init();this.menu.clearSelected();clearInterval(this.line.refreshTimer);}else{this.scheduleActive=false;}}}},{key:'getShortMenu',value:function getShortMenu(){var ls=JSON.parse(localStorage.getItem('left_menu_toggle_'+this.mode));if(ls&&_accountStore2.default.accountSettings.basketPosition=='right'){this.shortMenu=ls;}else{this.shortMenu=false;localStorage.setItem('left_menu_toggle_'+this.mode,false);}}},{key:'setShortMenu',value:function setShortMenu(){if(_accountStore2.default.accountSettings.basketPosition=='right'){this.shortMenu=!this.shortMenu;localStorage.setItem('left_menu_toggle_'+this.mode,this.shortMenu);}}},{key:'clear',value:function clear(){if(this.mode=='live')this.schedule.despose();this.mode='';this.line.despose();this.menu.despose();// не чистим корзину при переключении режима
// this.basket.despose();
this.isLoading=true;this.route.despose();if(this.route.run)this.route.run();}},{key:'clearnterval',// @action calcHeigth() {
// 	const x = document.querySelector('#wrapper-scroll-menu');
// 	const y = document.querySelector('#line-left-column');
// 	console.log(x.offsetHeight , y.offsetHeight );
// }
value:function clearnterval(){clearInterval(this.line.refreshTimer);clearInterval(this.menu.refreshTimer);clearInterval(this.menu.refreshVideoTimer);}// TODO разобраться что это и зачем
}]);return lineStore;}(),(_descriptor2=_applyDecoratedDescriptor(_class3.prototype,'col',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 3;}}),_descriptor3=_applyDecoratedDescriptor(_class3.prototype,'mode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor4=_applyDecoratedDescriptor(_class3.prototype,'line',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class3.prototype,'menu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class3.prototype,'schedule',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class3.prototype,'scheduleActive',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class3.prototype,'basket',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class3.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor10=_applyDecoratedDescriptor(_class3.prototype,'shortMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class3.prototype,'route',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor12=_applyDecoratedDescriptor(_class3.prototype,'liveRefreshInterval',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 3000;}}),_descriptor13=_applyDecoratedDescriptor(_class3.prototype,'liveRefreshOne',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 3000;}}),_applyDecoratedDescriptor(_class3.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'init'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'init2',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'init2'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'toggleSchedule',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'toggleSchedule'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'getShortMenu',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'getShortMenu'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'setShortMenu',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'setShortMenu'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'clear'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'clearnterval',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'clearnterval'),_class3.prototype)),_class3);exports.default=lineStore;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _mobxReactRouter=__webpack_require__(639);exports.default=new _mobxReactRouter.RouterStore();

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(44),
    baseIntersection = __webpack_require__(211),
    baseRest = __webpack_require__(46),
    castArrayLikeObject = __webpack_require__(213);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(70),
    arrayIncludes = __webpack_require__(119),
    arrayIncludesWith = __webpack_require__(120),
    arrayMap = __webpack_require__(44),
    baseUnary = __webpack_require__(65),
    cacheHas = __webpack_require__(71);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(654),
    baseIsNaN = __webpack_require__(655),
    strictIndexOf = __webpack_require__(656);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(74);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var CELL_STYLE=exports.CELL_STYLE=undefined;(function(CELL_STYLE){CELL_STYLE["TEXT"]="t";CELL_STYLE["HEADER"]="h";CELL_STYLE["SUBHEADER"]="sh";CELL_STYLE["COEFFICIENT"]="c";CELL_STYLE["COEFFICIENT_TEXT"]="ct";})(CELL_STYLE||(exports.CELL_STYLE=CELL_STYLE={}));var CELL_ALIGN=exports.CELL_ALIGN=undefined;(function(CELL_ALIGN){CELL_ALIGN["CENTER"]="c";CELL_ALIGN["LEFT"]="l";CELL_ALIGN["RIGHT"]="r";})(CELL_ALIGN||(exports.CELL_ALIGN=CELL_ALIGN={}));var COLUMN_WIDTH=exports.COLUMN_WIDTH=undefined;(function(COLUMN_WIDTH){COLUMN_WIDTH["MEDIUM"]="md";COLUMN_WIDTH["SMALL"]="sm";})(COLUMN_WIDTH||(exports.COLUMN_WIDTH=COLUMN_WIDTH={}));var SITE_TYPE=exports.SITE_TYPE=undefined;(function(SITE_TYPE){SITE_TYPE[SITE_TYPE["COM"]=0]="COM";SITE_TYPE[SITE_TYPE["CUPIS"]=1]="CUPIS";})(SITE_TYPE||(exports.SITE_TYPE=SITE_TYPE={}));var LOCK_STATE=exports.LOCK_STATE=undefined;(function(LOCK_STATE){LOCK_STATE[LOCK_STATE["UNBLOCKED"]=0]="UNBLOCKED";LOCK_STATE[LOCK_STATE["BLOCKED"]=1]="BLOCKED";})(LOCK_STATE||(exports.LOCK_STATE=LOCK_STATE={}));var STATE=exports.STATE=undefined;(function(STATE){STATE[STATE["ENABLED"]=1]="ENABLED";STATE[STATE["DISABLED"]=0]="DISABLED";})(STATE||(exports.STATE=STATE={}));var INFOGRAPHIC_INFO=exports.INFOGRAPHIC_INFO=undefined;(function(INFOGRAPHIC_INFO){INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["AVAILABLE"]=1]="AVAILABLE";INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["UNAVAILABLE"]=0]="UNAVAILABLE";})(INFOGRAPHIC_INFO||(exports.INFOGRAPHIC_INFO=INFOGRAPHIC_INFO={}));var CHANNEL_ACTION=exports.CHANNEL_ACTION=undefined;(function(CHANNEL_ACTION){CHANNEL_ACTION[CHANNEL_ACTION["SUBSCRIBE"]=0]="SUBSCRIBE";CHANNEL_ACTION[CHANNEL_ACTION["UNSUBSCRIBE"]=1]="UNSUBSCRIBE";})(CHANNEL_ACTION||(exports.CHANNEL_ACTION=CHANNEL_ACTION={}));/** Способ сортировки */var SORT_BY=exports.SORT_BY=undefined;(function(SORT_BY){/** По алфавиту */SORT_BY[SORT_BY["ALPHABET"]=1]="ALPHABET";/** По приоритету */SORT_BY[SORT_BY["PRIORITY"]=2]="PRIORITY";})(SORT_BY||(exports.SORT_BY=SORT_BY={}));var DATA_TYPE_CODE=exports.DATA_TYPE_CODE=undefined;(function(DATA_TYPE_CODE){/** Фиктивная информация о матче, код 1. Только для тестовых целей/отладки.*/DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_MATCH_INFO"]=1]="FALSE_MATCH_INFO";/** Фиктивная информация о балансе игрока, код 2. Только для тестовых целей/отладки.*/DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BALANCE_INFO"]=2]="FALSE_BALANCE_INFO";/** Фиктивная информация о рассчитанных ставках игрока, код 3. Только для тестовых целей/отладки. */DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BETS_INFO"]=3]="FALSE_BETS_INFO";/** Информация о матче, код 4.*/DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFO"]=4]="MATCH_INFO";/** Баланс интернет игрока, код 5.*/DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO"]=5]="BALANCE_INFO";/** Количество нерасчитанных ставок интернет игрока, код 6.*/DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT"]=6]="RAW_BETS_COUNT";/** Live-меню для сайта, полное, код 7.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_DATA"]=7]="LIVE_MENU_DATA";/** Live-меню для мобильной версии, упрощённое, код 8.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_MOBILE"]=8]="LIVE_MENU_MOBILE";/** Фильтр Live результатов, код 9.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS_FILTER"]=9]="LIVE_RESULTS_FILTER";/** Live результаты, код 10.*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS"]=10]="LIVE_RESULTS";/** Табличная роспись Live матча для сайта, код 11 (см. Табличная роспись Live матча).*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE"]=11]="LIVE_OUTCOMES_TABLE";/** Табличная роспись Live матча для мобильной версии, код 12 (см. Табличная роспись Live матча).*/DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE_MOBILE"]=12]="LIVE_OUTCOMES_TABLE_MOBILE";/** Баланс ИРМ игрока, код 13.*/DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO_IRM"]=13]="BALANCE_INFO_IRM";/** Количество нерасчитанных ставок ИРМ игрока, код 14.*/DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT_IRM"]=14]="RAW_BETS_COUNT_IRM";/** Live-матчи по спорту для мобильной версии, код 16 (см. MobileAppSportLiveMatches16.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT_MOBILE"]=16]="LIVE_MATCHES_BY_SPORT_MOBILE";/** Топ Live-матчи для мобильной версии, код 17 (см. MobileAppHotLiveMatches17.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP_MOBILE"]=17]="LIVE_MATCHES_BY_TOP_MOBILE";/** Live-матчи с видео для мобильной версии, код 18 (см. MobileAppLiveMatchesWithVideo18.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO_MOBILE"]=18]="LIVE_MATCHES_WITH_VIDEO_MOBILE";/** Live-матчи из избранного для мобильной версии, код 19 (см. MobileAppFavoriteLiveMatches19.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES_MOBILE"]=19]="LIVE_MATCHES_FAVORITES_MOBILE";/** Все Live-матчи для сайта, код 20 */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_ALL"]=20]="LIVE_MATCHES_ALL";/** Live-матчи по спорту для сайта, код 21 (см. WebSportLiveMatches21.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT"]=21]="LIVE_MATCHES_BY_SPORT";/** Live-матчи по чемпионату для сайта, код 22 (см. WebChampionshipLiveMatches22.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_CHAMPIONSHIP"]=22]="LIVE_MATCHES_BY_CHAMPIONSHIP";/** Топ Live-матчи для сайта, код 23 (см. WebHotLiveMatches23.ts) */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP"]=23]="LIVE_MATCHES_BY_TOP";/** Live-матчи с видео для сайта, код 24 (см. WebLiveMatchesWithVideo24.ts) */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO"]=24]="LIVE_MATCHES_WITH_VIDEO";/** Live-матчи из избранного для сайта, код 25 (см. WebFavoriteLiveMatches25.ts). */DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES"]=25]="LIVE_MATCHES_FAVORITES";})(DATA_TYPE_CODE||(exports.DATA_TYPE_CODE=DATA_TYPE_CODE={}));

/***/ }),
/* 215 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(669);

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SITE_TYPE=exports.SITE_TYPE={IRM_CUPIS:2};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
module.exports = __webpack_require__(224);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(220).enable();
  window.Promise = __webpack_require__(222);
}

// fetch() polyfill for making API calls.
__webpack_require__(223);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(17);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(122);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(122);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _promisePrototype=__webpack_require__(229);var _promisePrototype2=_interopRequireDefault(_promisePrototype);var _reactRouter=__webpack_require__(78);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);__webpack_require__(271);var _App=__webpack_require__(272);var _App2=_interopRequireDefault(_App);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);var _lineStore=__webpack_require__(208);var _lineStore2=_interopRequireDefault(_lineStore);var _dictStore=__webpack_require__(54);var _dictStore2=_interopRequireDefault(_dictStore);var _resultStore=__webpack_require__(679);var _resultStore2=_interopRequireDefault(_resultStore);var _financeStore=__webpack_require__(685);var _financeStore2=_interopRequireDefault(_financeStore);var _routingStore=__webpack_require__(209);var _routingStore2=_interopRequireDefault(_routingStore);var _searchStore=__webpack_require__(686);var _searchStore2=_interopRequireDefault(_searchStore);var _totoStore=__webpack_require__(687);var _totoStore2=_interopRequireDefault(_totoStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// const browserHistory = createBrowserHistory();
// const routingStore = new RouterStore();
// import { useStrict } from 'mobx';
// import createBrowserHistory from 'history/createBrowserHistory';
var stores={appStore:_appStore2.default,accountStore:_accountStore2.default,lineStore:_appStore2.default.lineStore,dictStore:_dictStore2.default,resultStore:_resultStore2.default,financeStore:_financeStore2.default,routingStore:_routingStore2.default,searchStore:_searchStore2.default,totoStore:_totoStore2.default,igStore:_appStore2.default.igStore};// include store
// import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
// import './assets/lib/normalize.scss';
window.getLang=stores.dictStore.getLang;// console.log(browserHistory);
// const history = syncHistoryWithStore(browserHistory, routingStore);
// For easier debugging
// window._____APP_STATE_____ = stores;
_promisePrototype2.default.shim();// useStrict(true);
_reactDom2.default.render(_react2.default.createElement(_mobxReact.Provider,stores,_react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement(_reactRouter.Route,{component:_App2.default}))),document.getElementById('sm'));

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(17),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(17),r=__webpack_require__(227);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(228);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(51);
var define = __webpack_require__(123);

var implementation = __webpack_require__(125);
var getPolyfill = __webpack_require__(127);
var shim = __webpack_require__(252);

var bound = bind.call(Function.call, getPolyfill());

define(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(124);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(232);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(124); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = reflectApply
	? function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var IsConstructor = __webpack_require__(237);
var Type = __webpack_require__(30);

// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor

module.exports = function SpeciesConstructor(O, defaultConstructor) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	var C = O.constructor;
	if (typeof C === 'undefined') {
		return defaultConstructor;
	}
	if (Type(C) !== 'Object') {
		throw new $TypeError('O.constructor is not an Object');
	}
	var S = $species ? C[$species] : void 0;
	if (S == null) {
		return defaultConstructor;
	}
	if (IsConstructor(S)) {
		return S;
	}
	throw new $TypeError('no constructor found');
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(236);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = __webpack_require__(238);
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://www.ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(239);
var DefineOwnProperty = __webpack_require__(240);

var FromPropertyDescriptor = __webpack_require__(243);
var IsAccessorDescriptor = __webpack_require__(245);
var IsDataDescriptor = __webpack_require__(246);
var IsPropertyKey = __webpack_require__(247);
var SameValue = __webpack_require__(248);
var ToPropertyDescriptor = __webpack_require__(250);
var Type = __webpack_require__(30);

// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var has = __webpack_require__(47);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

var callBound = __webpack_require__(241);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(23);

var callBind = __webpack_require__(242);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(51);

var GetIntrinsic = __webpack_require__(23);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind() {
	return $reflectApply(bind, $call, arguments);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(77);

var Type = __webpack_require__(30);

// https://www.ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://www.ecma-international.org/ecma-262/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(47);

var assertRecord = __webpack_require__(77);

var Type = __webpack_require__(30);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(47);

var assertRecord = __webpack_require__(77);

var Type = __webpack_require__(30);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://www.ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(249);

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(47);

var GetIntrinsic = __webpack_require__(23);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(30);
var ToBoolean = __webpack_require__(251);
var IsCallable = __webpack_require__(126);

// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (has(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (has(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (has(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (has(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (has(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (has(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(76);

var getPolyfill = __webpack_require__(127);
var define = __webpack_require__(123);

module.exports = function shimPromiseFinally() {
	requirePromise();

	var polyfill = getPolyfill();
	define(Promise.prototype, { 'finally': polyfill }, {
		'finally': function testFinally() {
			return Promise.prototype['finally'] !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(254);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(128);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(129);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(130);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(133);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(79);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(53);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(134);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _reactRouterDom=__webpack_require__(2);var _header=__webpack_require__(278);var _header2=_interopRequireDefault(_header);var _home=__webpack_require__(285);var _home2=_interopRequireDefault(_home);var _notfound=__webpack_require__(305);var _notfound2=_interopRequireDefault(_notfound);var _results=__webpack_require__(306);var _results2=_interopRequireDefault(_results);var _line=__webpack_require__(342);var _line2=_interopRequireDefault(_line);var _live=__webpack_require__(485);var _live2=_interopRequireDefault(_live);var _stats=__webpack_require__(598);var _stats2=_interopRequireDefault(_stats);var _toto=__webpack_require__(599);var _toto2=_interopRequireDefault(_toto);var _bet=__webpack_require__(602);var _bet2=_interopRequireDefault(_bet);var _result=__webpack_require__(604);var _result2=_interopRequireDefault(_result);var _cards=__webpack_require__(606);var _cards2=_interopRequireDefault(_cards);var _previous=__webpack_require__(608);var _previous2=_interopRequireDefault(_previous);var _cardsall=__webpack_require__(610);var _cardsall2=_interopRequireDefault(_cardsall);var _account=__webpack_require__(612);var _account2=_interopRequireDefault(_account);var _bets=__webpack_require__(614);var _bets2=_interopRequireDefault(_bets);var _history=__webpack_require__(615);var _history2=_interopRequireDefault(_history);var _payout=__webpack_require__(617);var _payout2=_interopRequireDefault(_payout);var _card=__webpack_require__(619);var _card2=_interopRequireDefault(_card);var _login=__webpack_require__(621);var _login2=_interopRequireDefault(_login);var _logout=__webpack_require__(622);var _logout2=_interopRequireDefault(_logout);var _rules=__webpack_require__(624);var _rules2=_interopRequireDefault(_rules);var _ErrorPage=__webpack_require__(625);var _ErrorPage2=_interopRequireDefault(_ErrorPage);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import LineL from './routes/lineL';
var NoTerminalAccess=function NoTerminalAccess(){var reloadCounter=localStorage.getItem('reload');if(!reloadCounter){localStorage.setItem('reload',1);window.location.reload();}if(reloadCounter){localStorage.setItem('reload',reloadCounter<10?Number(reloadCounter)+1:1);setTimeout(function(){window.location.reload();},reloadCounter*1000);}return _react2.default.createElement('div',{className:'no-terminal-access'},_react2.default.createElement('span',null,'\u0412\u044B\u0437\u043E\u0432\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430'));};var LoadApp=function LoadApp(_ref){var error=_ref.error;return error.status?_react2.default.createElement('div',{className:'load-app__error'},error.text):_react2.default.createElement('div',{className:'load-app'},_react2.default.createElement(_loadingSpinner2.default,null));};var Terminal=(_dec=(0,_mobxReact.inject)('appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Terminal,_Component);function Terminal(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Terminal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Terminal.__proto__||Object.getPrototypeOf(Terminal)).call.apply(_ref2,[this].concat(args))),_this),_this.handleClick=function(){_this.props.appStore.checkTerminal();},_temp),_possibleConstructorReturn(_this,_ret);}// componentWillMount() {
//   this.props.lineStore.reset();
// }
_createClass(Terminal,[{key:'render',value:function render(){if(!this.props.appStore.terminalAccess){return _react2.default.createElement('div',{className:'terminal-status',onClick:this.handleClick},'\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430');}else{return'';}}}]);return Terminal;}(_react.Component))||_class)||_class);var App=(_dec2=(0,_mobxReact.inject)('appStore'),(0,_reactRouterDom.withRouter)(_class3=_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(App,_Component2);function App(){var _ref3;var _temp2,_this2,_ret2;_classCallCheck(this,App);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref3=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref3,[this].concat(args))),_this2),_this2.state={error:false},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){localStorage.setItem('lastAction',0);//refresh last action
this.props.appStore.initApp();}},{key:'componentDidCatch',value:function componentDidCatch(error,info){console.log(error,info);this.setState({error:true});}},{key:'render',value:function render(){if(this.state.error)return _react2.default.createElement(_ErrorPage2.default,null);var _props$appStore=this.props.appStore,terminalAccess=_props$appStore.terminalAccess,appLoading=_props$appStore.appLoading,error=_props$appStore.error,cashboxMode=_props$appStore.cashboxMode;return appLoading?_react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement('div',{className:'page-layout'}, false?_react2.default.createElement(Terminal,null):'',_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C'),_react2.default.createElement('meta',{name:'viewport',content:'width=device-width, initial-scale=1'})),_react2.default.createElement(_header2.default,null),_react2.default.createElement('div',{className:'main'},terminalAccess||"production"==='development'?_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:'/',exact:true,component:_home2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/line/:sport?/:league?/:games?/:ross?',component:_line2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/live/:sport?/:league?/:games?/:ross?',component:_live2.default}),_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/login/card',component:_card2.default}),_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/results',component:_results2.default}),_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/stats',component:_stats2.default}),cashboxMode?_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/rules',component:_rules2.default}):null,_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/login',component:_login2.default}),_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/toto',component:_toto2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/toto/bet/:betId?',component:_bet2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/toto/result/:resultId?',component:_result2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/toto/cards/:cardId?/:vc?',component:_cards2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/toto/cardsall/:cardId?/:page?',component:_cardsall2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/toto/previous',component:_previous2.default}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/logout/delayed',component:_logout2.default}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/toto',component:_toto2.default}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/account',component:_account2.default}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/account/bets',component:_bets2.default,type:'bets'}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/account/history',component:_history2.default,type:'history'}),_react2.default.createElement(PrivateRoute,{exact:true,path:'/payout',component:_payout2.default,type:'payout'}),_react2.default.createElement(_reactRouterDom.Route,{component:_notfound2.default})):_react2.default.createElement(NoTerminalAccess,null)))):_react2.default.createElement(LoadApp,{error:error});}}]);return App;}(_react.Component))||_class3)||_class3)||_class3);exports.default=App;var PrivateRoute=(0,_mobxReact.inject)('accountStore')((0,_mobxReact.observer)(function(_ref4){var Component=_ref4.component,accountStore=_ref4.accountStore,type=_ref4.type,rest=_objectWithoutProperties(_ref4,['component','accountStore','type']);return _react2.default.createElement(_reactRouterDom.Route,_extends({},rest,{render:function render(props){return accountStore.access&&!accountStore.getHideRoutes.includes(type)?_react2.default.createElement(Component,props):_react2.default.createElement(_reactRouterDom.Redirect,{to:{pathname:'/live',state:{from:props.location}}});}}));}));

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(274));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var style={borderRadius:'50%',width:'40px',height:'40px',margin:'90px auto',position:'relative',borderTop:'3px solid rgba(0, 0, 0, 0.1)',borderRight:'3px solid rgba(0, 0, 0, 0.1)',borderBottom:'3px solid rgba(0, 0, 0, 0.1)',borderLeft:'3px solid #818a91',transform:'translateZ(0)',animation:'loading-spinner 0.5s infinite linear'};var LoadingSpinner=function LoadingSpinner(){return _react2.default.createElement('div',{className:'loading-spinner',style:style},_react2.default.createElement('style',null,'\n        @keyframes loading-spinner {\n          0% { transform : rotate(0deg); }\n          100% { transform : rotate(360deg); }\n        }\n      '));};exports.default=LoadingSpinner;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _common=__webpack_require__(6);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _logo=__webpack_require__(280);var _logo2=_interopRequireDefault(_logo);var _loginForm=__webpack_require__(281);var _loginForm2=_interopRequireDefault(_loginForm);var _logoutTimer=__webpack_require__(282);var _logoutTimer2=_interopRequireDefault(_logoutTimer);var _changePassModal=__webpack_require__(283);var _changePassModal2=_interopRequireDefault(_changePassModal);var _reactOnclickoutside=__webpack_require__(82);var _reactOnclickoutside2=_interopRequireDefault(_reactOnclickoutside);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Balance=(_dec=(0,_mobxReact.inject)('appStore','accountStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Balance,_Component);function Balance(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Balance);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Balance.__proto__||Object.getPrototypeOf(Balance)).call.apply(_ref,[this].concat(args))),_this),_this.timer=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Balance,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.accountStore.getBalance();this.timer=setInterval(function(){_this2.props.accountStore.getBalance();},6000);}},{key:'render',value:function render(){var _props$accountStore=this.props.accountStore,balance=_props$accountStore.balance,accountSettings=_props$accountStore.accountSettings;var name=this.props.appStore.currency.name;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('span',{className:'icon-card f-s-ico-balanse'}),_react2.default.createElement('span',{className:'header-account-menu__balance '},_react2.default.createElement('b',{className:''},accountSettings.showHeaderBalance?(0,_common.numberFormat)(balance,2,',',' ')+' '+name:'***')));}}]);return Balance;}(_react.Component))||_class)||_class)||_class);var Header=(_dec2=(0,_mobxReact.inject)('accountStore','appStore','routingStore'),(0,_reactRouterDom.withRouter)(_class3=_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Header,_Component2);function Header(props){_classCallCheck(this,Header);var _this3=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this3.toggleLoginModal=function(){_this3.props.accountStore.toggleLoginForm();};_this3.togglePassModal=function(){_this3.setState({forgout_pass_modal_show:!_this3.state.forgout_pass_modal_show?true:false});};_this3.logout=function(){_this3.props.accountStore.logout();};_this3.hideBalance=function(){_this3.props.accountStore.hideBalance();};_this3.showMore=function(){_this3.setState({moreItems:!_this3.state.moreItems});};_this3.state={forgout_pass_modal_show:false,moreItems:false};return _this3;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){var _this4=this;this.props.appStore.setHistory(this.props.history);if(typeof window.btOnRoute==='function'){window.btOnRoute=window.btOnRoute;}else{window.btOnRoute=function(route){return route;};}if(typeof window.btGoTo==='function'){window.btGoTo=window.btGoTo;}else{window.btGoTo=function(route){_this4.props.history.push(route);};}window.BT={goTo:function goTo(route){_this4.props.history.push(route);},onRoute:function onRoute(route){return route;}};window.btOnRoute(this.props.location.pathname);// TODO удалить после выкладки на прод новой оболочки
if(window.__BTApp){window.BT.onRoute=window.__BTApp.onRoute;}else{window.BT.onRoute=function(){};};window.BT.onRoute(this.props.location.pathname);}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(typeof window.BT.onRoute==='function')window.BT.onRoute(this.props.location.pathname);if(typeof window.btOnRoute==='function')window.btOnRoute(this.props.location.pathname);}},{key:'render',value:function render(){var _props$appStore=this.props.appStore,terminalAccess=_props$appStore.terminalAccess,links=_props$appStore.links,showTopMenu=_props$appStore.showTopMenu,cashboxMode=_props$appStore.cashboxMode,currency_id=_props$appStore.currency_id;var _props$accountStore2=this.props.accountStore,access=_props$accountStore2.access,showLoginForm=_props$accountStore2.showLoginForm,autoLogout=_props$accountStore2.autoLogout,isCard=_props$accountStore2.isCard,changePsw=_props$accountStore2.changePsw,showChangePass=_props$accountStore2.showChangePass,getHideRoutes=_props$accountStore2.getHideRoutes,countBets=_props$accountStore2.countBets;var showHeaderBalance=this.props.accountStore.accountSettings.showHeaderBalance;var pathname=this.props.location.pathname;return _react2.default.createElement('header',{className:'header'},_react2.default.createElement('div',null,terminalAccess?_react2.default.createElement(_reactRouterDom.Link,{to:'/',className:'header__logo'}):_react2.default.createElement('span',{to:'/',className:'header__logo'})),_react2.default.createElement('div',{className:'header__block'},showTopMenu&&terminalAccess?_react2.default.createElement('div',{className:'header__top'},_react2.default.createElement('div',{className:'header-counts'},_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item '+(pathname==='/line'?'active_item':''),to:'/line'},'\u041B\u0438\u043D\u0438\u044F'),_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item '+(pathname==='/live'?'active_item':''),to:'/live'},'Live'),_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item '+(pathname==='/results'?'active_item':'')+' results',to:'/results'},'\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B'),currency_id===2?_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item '+(pathname==='/toto'?'active_item':''),to:'/toto'},cashboxMode===2?'Cуперэкспресс':'Zenit-тото'):'',_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item '+(pathname==='/stats'?'active_item':''),to:'/stats'},'\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430'),cashboxMode==2?_react2.default.createElement(_reactRouterDom.Link,{className:'header-counts__item header-counts__item_rules '+(pathname==='/rules'?'active_item':''),to:'/rules'},'\u041F\u0440\u0430\u0432\u0438\u043B\u0430'):'',_react2.default.createElement('div',{className:'header-more header-drop',onClick:this.showMore},_react2.default.createElement('span',null,'\u0415\u0429\u0415 ',_react2.default.createElement('div',{style:{position:'absolute',right:'0'}},_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),this.state.moreItems?_react2.default.createElement('div',{className:'header-drop__sub'},_react2.default.createElement('span',{className:'header-drop__sub-arrow'}),_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/line'},'\u041B\u0438\u043D\u0438\u044F'),_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/live'},'Live'),_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item results',to:'/results'},'\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B'),currency_id===2?_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item ',to:'/toto'},cashboxMode===2?'Суперэкспресс':'Zenit-тото'):'',_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item ',to:'/stats'},'\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430'),!getHideRoutes.includes('rules')||cashboxMode==2?_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/rules'},'\u041F\u0440\u0430\u0432\u0438\u043B\u0430'):''):null)),terminalAccess?access?_react2.default.createElement('div',{className:'header-account-menu clearfix'},_react2.default.createElement(Balance,null),_react2.default.createElement('span',{className:!!showHeaderBalance?'show-balance':'hide-balance',onClick:this.hideBalance}),!getHideRoutes.includes('bets')?_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_reactRouterDom.NavLink,{to:'/account/bets',className:'header-counts__item-bets'},_react2.default.createElement('span',null,'\u0421\u0442\u0430\u0432\u043A\u0438'),countBets?_react2.default.createElement('span',{className:'bets-counter'},countBets):null)):null,_react2.default.createElement(Account,{hideRoutes:getHideRoutes}),!isCard?_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('a',{href:'#',className:'header-counts__item--logout',onClick:this.logout},'\u0412\u044B\u0445\u043E\u0434',autoLogout&&autoLogout.timerVisible.status?_react2.default.createElement('span',null,' ',autoLogout.timerVisible.html,' '):''),_react2.default.createElement(_logoutTimer2.default,null)):''):_react2.default.createElement('div',{className:'header-login'},_react2.default.createElement('div',{className:'header-login__grp'},_react2.default.createElement('button',{href:'#',target:'_parent',className:'header-login-registration',onClick:this.togglePassModal},'\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?'),_react2.default.createElement('button',{className:'header-login__btn_sign',tabIndex:'3',onClick:this.toggleLoginModal},'\u0412\u043E\u0439\u0442\u0438 \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430'))):null,terminalAccess&&!access&&showLoginForm?_react2.default.createElement(_loginForm2.default,{show:showLoginForm,onCloseModal:this.toggleLoginModal}):null,terminalAccess&&!access&&this.state.forgout_pass_modal_show?_react2.default.createElement(_modal2.default,{styleModal:{width:'300px'},show:this.state.forgout_pass_modal_show,onCloseModal:this.togglePassModal},_react2.default.createElement('div',{className:'forgout_pass_message'},_react2.default.createElement('div',{className:'forgout_pass__icon f-s-ico-info'}),'\u0414\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u043A\u0430\u0441\u0441\u0438\u0440\u0443')):null):''),showChangePass?_react2.default.createElement(_modal2.default,{styleModal:{width:'700px'},show:changePsw,fixed:1,title:'\u0421\u041C\u0415\u041D\u0410 \u041F\u0410\u0420\u041E\u041B\u042F'},_react2.default.createElement(_changePassModal2.default,null)):null);}}]);return Header;}(_react.Component))||_class3)||_class3)||_class3);exports.default=Header;var Account=(0,_reactOnclickoutside2.default)(_class5=function(_Component3){_inherits(Account,_Component3);function Account(){var _ref2;var _temp2,_this5,_ret2;_classCallCheck(this,Account);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this5=_possibleConstructorReturn(this,(_ref2=Account.__proto__||Object.getPrototypeOf(Account)).call.apply(_ref2,[this].concat(args))),_this5),_this5.state={showDrop:false},_this5.toogleDrop=function(){_this5.setState({showDrop:!_this5.state.showDrop});},_temp2),_possibleConstructorReturn(_this5,_ret2);}_createClass(Account,[{key:'handleClickOutside',value:function handleClickOutside(evt){this.setState({showDrop:false});}},{key:'render',value:function render(){var hideRoutes=this.props.hideRoutes;return _react2.default.createElement('div',{className:'account-dropdown-menu header-drop dropdown',onClick:this.toogleDrop},_react2.default.createElement('span',null,'\u0421\u0447\u0435\u0442 ',_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('div',{className:'header-drop__sub dropdowns'+(this.state.showDrop?'':' hidden')},_react2.default.createElement('span',{className:'header-drop__sub-arrow'}),_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/account'},'\u0412\u0430\u0448\u0438 \u0434\u0430\u043D\u043D\u044B\u0435'),!hideRoutes.includes('history')?_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/account/history'},'\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0447\u0435\u0442\u0430'):'',!hideRoutes.includes('payout')?_react2.default.createElement(_reactRouterDom.Link,{className:'header-drop__item',to:'/payout'},'\u0412\u044B\u043F\u043B\u0430\u0442\u0430'):''));}}]);return Account;}(_react.Component))||_class5;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;// import InputMask from 'react-input-mask';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _keyboard=__webpack_require__(138);var _keyboard2=_interopRequireDefault(_keyboard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import $ from 'jquery';
// import keyboard from 'virtual-keyboard/dist/js/jquery.keyboard.js';
// import { NumericKeyboard } from 'numeric-keyboard';
var Message=function Message(_ref){var text=_ref.text;return _react2.default.createElement('div',{className:'result-message error'},_react2.default.createElement('div',{className:'finance-modal-undefined',dangerouslySetInnerHTML:{__html:text}}));};var LoginForm=(_dec=(0,_mobxReact.inject)('accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LoginForm,_Component);function LoginForm(props){_classCallCheck(this,LoginForm);var _this=_possibleConstructorReturn(this,(LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call(this,props));_this.phone=_react2.default.createRef();_this.password=_react2.default.createRef();_this.handleChange=function(e,inputName){_this.props.accountStore.inputAuth(e,inputName);};_this.status=null;_this.inputEl=null;_this.handleSubmit=function(e){e.preventDefault();_this.handleFocus(null,1);if(_this.props.accountStore.auth.phone.toString().length<8){_this.props.accountStore.setAuthError('Неверный номер телефона');_this.phone.current.focus();return false;}else if(_this.props.accountStore.auth.password.toString().length<4){_this.props.accountStore.setAuthError('Длина пароля должна содержать не менее 4 символов');_this.password.current.focus();return false;}_this.props.accountStore.sentLogin();};_this.selectCode=function(e){_this.props.accountStore.setPrefix(e.target.value);};_this.handleKeyboard=function(val){if(!_this.inputEl)return false;_this.inputEl.focus();if(val=='b'){_this.inputEl.value=_this.inputEl.value.slice(0,-1);_this.props.accountStore.inputAuth(_this.inputEl.value,_this.status);}else if(val=='a'){if(_this.status=='phone'){_this.password.current.focus();}else{_this.props.accountStore.sentLogin();_this.handleFocus(null,1);}}else{if(_this.inputEl.maxLength>_this.inputEl.value.length){_this.inputEl.value=_this.inputEl.value+String(val);_this.props.accountStore.inputAuth(_this.inputEl.value,_this.status);}}};_this.handleFocus=function(type,st){if(st){_this.status=null;_this.inputEl=null;}else{_this.status=type;_this.inputEl=_this[type].current;}};return _this;}_createClass(LoginForm,[{key:'componentDidMount',value:function componentDidMount(){this.phone.current.focus();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.closeForm();}},{key:'render',value:function render(){var _this2=this;var _props$accountStore=this.props.accountStore,auth=_props$accountStore.auth,statusdAuthForm=_props$accountStore.statusdAuthForm,phoneMask=_props$accountStore.phoneMask,lengthPhoneNumber=_props$accountStore.lengthPhoneNumber;return _react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{show:this.props.show,onCloseModal:this.props.onCloseModal,title:'\u0412\u0425\u041E\u0414 \u041F\u041E \u041D\u041E\u041C\u0415\u0420\u0423 \u0422\u0415\u041B\u0415\u0424\u041E\u041D\u0410'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('form',{className:'login-form',onSubmit:this.handleSubmit},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'login-form_gr clearfix'},_react2.default.createElement('div',{className:'input-group'},_react2.default.createElement('span',{className:'input-group-addon login-form_prefix_cont'},_react2.default.createElement('select',{value:auth.phone_prefix,name:'phone_prefix',className:'input-group-addon login-form_prefix_select',tabIndex:'1',onChange:this.selectCode,disabled:statusdAuthForm.disabled},_react2.default.createElement('option',{value:'+7'},'+7'),_react2.default.createElement('option',{value:'+38'},'+38'),_react2.default.createElement('option',{value:'+375'},'+375'),_react2.default.createElement('option',{value:'+373'},'+373'))),_react2.default.createElement('div',null,_react2.default.createElement('input',{ref:this.phone,className:'form-control login-form_phone',onChange:function onChange(e){return _this2.handleChange(e.target.value,'phone');},placeholder:'\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430',autoComplete:'off',tabIndex:'2',type:'text',maxLength:lengthPhoneNumber,disabled:statusdAuthForm.disabled,value:auth.phone,onFocus:function onFocus(){return _this2.handleFocus('phone');}// onBlur={() => this.handleFocus('phone', 1)}
})),_react2.default.createElement('span',{className:'input-group-addon login-form_attemp',title:'\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A'},statusdAuthForm.attempts))),_react2.default.createElement('div',{className:'login-form_gr clearfix'},_react2.default.createElement('input',{type:'password',name:'password',className:'form-control',pattern:'[0-9]{0,6}',maxLength:'6',placeholder:'\u041F\u0430\u0440\u043E\u043B\u044C',tabIndex:'3',ref:this.password,value:auth.password,onChange:function onChange(e){return _this2.handleChange(e.target.value,'password');},disabled:statusdAuthForm.disabled,onFocus:function onFocus(){return _this2.handleFocus('password');}// onBlur={() => this.handleFocus('password', 1)}
}))),_react2.default.createElement(_keyboard2.default,{type:'login',onChange:this.handleKeyboard}),_react2.default.createElement('div',{className:'login-form-button-wrp '+(statusdAuthForm.status?'login-form_error':'')},_react2.default.createElement('button',{className:'flat_button login-form_login '+(statusdAuthForm.wait?'wait':''),tabIndex:'4',type:'submit',disabled:statusdAuthForm.wait},'\u0412\u041E\u0419\u0422\u0418'),statusdAuthForm.status?_react2.default.createElement(Message,{text:statusdAuthForm.text}):'')))));}}]);return LoginForm;}(_react.Component))||_class)||_class);exports.default=LoginForm;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Footer=exports.LogoutContainer=exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logout=(_dec=(0,_mobxReact.inject)('dictStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Logout,_Component);function Logout(){_classCallCheck(this,Logout);return _possibleConstructorReturn(this,(Logout.__proto__||Object.getPrototypeOf(Logout)).apply(this,arguments));}_createClass(Logout,[{key:'render',value:function render(){if(!this.props.accountStore.autoLogout)return null;var _props$accountStore$a=this.props.accountStore.autoLogout,seconds=_props$accountStore$a.seconds,alertVisible=_props$accountStore$a.alertVisible,countdownHtml=_props$accountStore$a.countdownHtml;var getLang=this.props.dictStore.getLang;if(alertVisible){return _react2.default.createElement(LogoutContainer,null,_react2.default.createElement('div',{className:'logout-timer'},_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:getLang('AUTO_LOGOUT_NOTE')+' '}}),' '+countdownHtml.seconds+' '+getLang(countdownHtml.html)));}return false;}}]);return Logout;}(_react.Component))||_class)||_class);exports.default=Logout;var LogoutContainer=exports.LogoutContainer=function(_Component2){_inherits(LogoutContainer,_Component2);function LogoutContainer(props){_classCallCheck(this,LogoutContainer);var _this2=_possibleConstructorReturn(this,(LogoutContainer.__proto__||Object.getPrototypeOf(LogoutContainer)).call(this,props));_this2.el=document.createElement('div');_this2.modal=document.getElementById('logout-timer');return _this2;}_createClass(LogoutContainer,[{key:'componentDidMount',value:function componentDidMount(){this.modal.appendChild(this.el);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.modal.removeChild(this.el);}},{key:'render',value:function render(){return _reactDom2.default.createPortal(this.props.children,this.el);}}]);return LogoutContainer;}(_react.Component);var Footer=exports.Footer=function(_Component3){_inherits(Footer,_Component3);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return this.props.children;}}]);return Footer;}(_react.Component);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PASSWORD=[1,2,3];var LABELS={1:'CURRENT_PASSWORD',2:'NEW_PASSWORD',3:'REPEAT_NEW_PASSWORD'};var ChangePassModal=(_dec=(0,_mobxReact.inject)('accountStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ChangePassModal,_Component);function ChangePassModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangePassModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangePassModal.__proto__||Object.getPrototypeOf(ChangePassModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(e){e.preventDefault();if(_this.props.accountStore.AccountPage.password.pass1.toString().length<3){_this.props.accountStore.AccountPage.setError('INCORRECT_CURRENT_PASSWORD');document.getElementById('inputPassword1').focus();}else if(_this.props.accountStore.AccountPage.password.pass2.toString().length<3){_this.props.accountStore.AccountPage.setError('INCORRECT_NEW_PASSWORD');document.getElementById('inputPassword2').focus();}else if(_this.props.accountStore.AccountPage.password.pass2!=_this.props.accountStore.AccountPage.password.pass3){_this.props.accountStore.AccountPage.setError('NEW_PASSWORDS_NOT_MATCH');document.getElementById('inputPassword3').focus();}else{_this.props.accountStore.AccountPage.savePass();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangePassModal,[{key:'render',value:function render(){var _props$accountStore$A=this.props.accountStore.AccountPage,password=_props$accountStore$A.password,result=_props$accountStore$A.result,wait=_props$accountStore$A.wait;var getLang=this.props.dictStore.getLang;return result.success?_react2.default.createElement('div',{className:'change-pass_success change-pass_success_modal'},getLang(result.success)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'account-security-data'},_react2.default.createElement('form',{role:'form',onSubmit:this.handleSubmit},PASSWORD.map(function(id){return _react2.default.createElement(InputPass,{id:id,key:id,password:password['pass'+id]});}),_react2.default.createElement('div',{className:'row row-h-space clearfix'},_react2.default.createElement('div',{className:'row-label'},' '),_react2.default.createElement('div',{className:'row-data row-data-button'},_react2.default.createElement('button',{type:'submit',className:'flat_button fl_r '+(wait?'wait':'')},getLang('SAVE')),result.error?_react2.default.createElement('span',{className:'change-pass change-pass_error fl_l'},getLang(result.error)):null)),_react2.default.createElement('div',{className:'row row-h-space'},_react2.default.createElement('div',{className:'row-label'},' '),_react2.default.createElement('div',{className:'row-data'},_react2.default.createElement('div',{className:'note',dangerouslySetInnerHTML:{__html:getLang('IRM_PASSWORD_DESCRIPTION')}}))))));}}]);return ChangePassModal;}(_react.Component))||_class)||_class);exports.default=ChangePassModal;var InputPass=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(InputPass,_Component2);function InputPass(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,InputPass);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=InputPass.__proto__||Object.getPrototypeOf(InputPass)).call.apply(_ref2,[this].concat(args))),_this2),_this2.inputPassword=function(value){_this2.props.accountStore.AccountPage.inputPass(value,_this2.props.id);},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(InputPass,[{key:'render',value:function render(){var _props=this.props,id=_props.id,password=_props.password;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},_react2.default.createElement('label',{htmlFor:'inputPassword'+id},getLang(LABELS[id]),':')),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement(_keyboardInput2.default,{onChange:this.inputPassword,value:password,type:'password',className:'form-control',maxLength:'6',id:'inputPassword'+id,autoComplete:'off',positionX:'right',positionY:'bottom'})));}}]);return InputPass;}(_react.Component))||_class3)||_class3);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _homeSlider=__webpack_require__(286);var _homeSlider2=_interopRequireDefault(_homeSlider);var _banner=__webpack_require__(304);var _banner2=_interopRequireDefault(_banner);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=(_dec=(0,_mobxReact.inject)('appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Home,_Component);function Home(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Home);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Home.__proto__||Object.getPrototypeOf(Home)).call.apply(_ref,[this].concat(args))),_this),_this.state={isShowBanner:true},_this.hideBanner=function(){_this.setState({isShowBanner:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Home,[{key:'render',value:function render(){var _props$appStore=this.props.appStore,cardReader=_props$appStore.cardReader,hideHomePage=_props$appStore.initData.hideHomePage;if(hideHomePage)return _react2.default.createElement(_reactRouterDom.Redirect,{to:'/live'});return _react2.default.createElement('div',{className:'home'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C')),this.state.isShowBanner?_react2.default.createElement(_banner2.default,{hideBanner:this.hideBanner}):null,_react2.default.createElement('div',{className:'left_col'},_react2.default.createElement(_homeSlider2.default,null)),_react2.default.createElement('div',{className:'right_col'},_react2.default.createElement('div',{className:'right_col__head'},_react2.default.createElement('div',{className:'benefit'},_react2.default.createElement('span',{className:'benefit__img'},_react2.default.createElement('img',{src:'/assets/img/home/men_1.svg',alt:'',className:'img benefit__img_1'})),_react2.default.createElement('span',{className:'benefit_text'},'\u041F\u0440\u043E\u0439\u0434\u0438\u0442\u0435',_react2.default.createElement('br',null),' \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E',_react2.default.createElement('br',null),' \u0432 \u043A\u0430\u0441\u0441\u0435')),_react2.default.createElement('div',{className:'benefit'},_react2.default.createElement('span',{className:'benefit__img'},_react2.default.createElement('img',{src:'/assets/img/home/card_2.svg',alt:'',className:'img benefit__img_2'})),_react2.default.createElement('span',{className:'benefit_text'},'\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435',_react2.default.createElement('br',null),' \u043A\u043B\u0443\u0431\u043D\u0443\u044E \u043A\u0430\u0440\u0442\u0443')),_react2.default.createElement('div',{className:'benefit'},_react2.default.createElement('span',{className:'benefit__img'},_react2.default.createElement('img',{src:'/assets/img/home/wallet_3.svg',alt:'',className:'img benefit__img_3'})),_react2.default.createElement('span',{className:'benefit_text'},'\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435',_react2.default.createElement('br',null),' \u0438\u0433\u0440\u043E\u0432\u043E\u0439 \u0441\u0447\u0435\u0442')),_react2.default.createElement('div',{className:'benefit'},_react2.default.createElement('span',{className:'benefit__img'},_react2.default.createElement('img',{src:'/assets/img/home/user_id_4.svg',alt:'',className:'img benefit__img_4'})),_react2.default.createElement('span',{className:'benefit_text'},'\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435',_react2.default.createElement('br',null),' \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u0430\u0440\u0442\u044B'))),cardReader?_react2.default.createElement('div',{className:'right_col__foot'},_react2.default.createElement('div',{className:'benefit'},_react2.default.createElement('span',{className:'benefit__img'},_react2.default.createElement('img',{src:'/assets/img/home/nfc.svg',alt:'',className:'img benefit__img_5'})),_react2.default.createElement('span',{className:'benefit_text'},'\u041F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443',_react2.default.createElement('br',null),' \u043A \u0441\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0449\u0435\u043C\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443.'))):''));}}]);return Home;}(_react.Component))||_class)||_class);exports.default=Home;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSlick=__webpack_require__(287);var _reactSlick2=_interopRequireDefault(_reactSlick);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeSlider=(_dec=(0,_mobxReact.inject)('appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(HomeSlider,_Component);function HomeSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HomeSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HomeSlider.__proto__||Object.getPrototypeOf(HomeSlider)).call.apply(_ref,[this].concat(args))),_this),_this.container=_react2.default.createRef(),_this.state={scale:1},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HomeSlider,[{key:'componentDidMount',value:function componentDidMount(){this.props.appStore.loadSlider();var height=this.container.current.offsetHeight;var scale=+(height/1080).toFixed(2);this.setState({scale:scale<1?scale:1});}},{key:'render',value:function render(){var settings={infinite:true,arrows:false,dots:true,slidesToShow:1,slidesToScroll:1,autoplay:true,autoplaySpeed:4000};var slides=this.props.appStore.slides;// const slides = typeof this.props.appStore.slides.length > 0 ? 1 : 0;
return _react2.default.createElement('div',{className:'home-slider',style:{fontSize:this.state.scale*100},ref:this.container},slides?_react2.default.createElement(_reactSlick2.default,settings,slides.map(function(image){var img=typeof image.images_url==='string'?JSON.parse(image.images_url).webp:image.images_url?image.images_url.webp:image.img;return _react2.default.createElement('div',{key:image.id,className:'home-slider__slide-wrap'},_react2.default.createElement('div',{className:'home-slider__slide-image',style:{backgroundImage:'url('+img+')'}}),_react2.default.createElement(TextOverlay,{data:image.locales,settings:image.extended_settings}));})):'');}}]);return HomeSlider;}(_react.Component))||_class)||_class);var TextOverlay=function TextOverlay(_ref2){var data=_ref2.data,settings=_ref2.settings;if(!data)return null;return _react2.default.createElement('div',{className:'home-slider-slide-over',style:{'--color':settings.text_color}},_react2.default.createElement('div',{className:'home-slider-slide-over-hc'},data.highlighted&&_react2.default.createElement('span',{className:'home-slider-slide-over-hc-t'},data.highlighted)),_react2.default.createElement('span',{className:'home-slider-slide-over-l2'},data.heading_h2),_react2.default.createElement('span',{className:'home-slider-slide-over-l1'},data.heading_h1),_react2.default.createElement('span',{className:'home-slider-slide-over-l2'},data.heading_h3));};exports.default=HomeSlider;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(288);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(289);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _json2mq = __webpack_require__(297);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(140);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _canUseDom = __webpack_require__(299);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = _canUseDom2.default && __webpack_require__(300);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
    return _this;
  }

  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
    this.innerSlider = ref;
  };

  Slider.prototype.media = function media(query, handler) {
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        var bQuery;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
        }
        _canUseDom2.default && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      _canUseDom2.default && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.slickPrev = function slickPrev() {
    this.innerSlider.slickPrev();
  };

  Slider.prototype.slickNext = function slickNext() {
    this.innerSlider.slickNext();
  };

  Slider.prototype.slickGoTo = function slickGoTo(slide) {
    this.innerSlider.slickGoTo(slide);
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
    } else {
      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
    }

    var children = this.props.children;
    if (!Array.isArray(children)) {
      children = [children];
    }

    // Children may contain false or null, so we should filter them
    children = children.filter(function (child) {
      return !!child;
    });

    if (settings === 'unslick') {
      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' unslicked' },
        children
      );
    } else {
      return _react2.default.createElement(
        _innerSlider.InnerSlider,
        _extends({ ref: this.innerSliderRefHandler }, settings),
        children
      );
    }
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _eventHandlers = __webpack_require__(290);

var _eventHandlers2 = _interopRequireDefault(_eventHandlers);

var _helpers = __webpack_require__(83);

var _helpers2 = _interopRequireDefault(_helpers);

var _initialState = __webpack_require__(291);

var _initialState2 = _interopRequireDefault(_initialState);

var _defaultProps = __webpack_require__(140);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _createReactClass = __webpack_require__(292);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _track = __webpack_require__(294);

var _dots = __webpack_require__(295);

var _arrows = __webpack_require__(296);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
  displayName: 'InnerSlider',

  mixins: [_helpers2.default, _eventHandlers2.default],
  list: null,
  track: null,
  listRefHandler: function listRefHandler(ref) {
    this.list = ref;
  },
  trackRefHandler: function trackRefHandler(ref) {
    this.track = ref;
  },
  getInitialState: function getInitialState() {
    return _extends({}, _initialState2.default, {
      currentSlide: this.props.initialSlide
    });
  },
  getDefaultProps: function getDefaultProps() {
    return _defaultProps2.default;
  },
  componentWillMount: function componentWillMount() {
    if (this.props.init) {
      this.props.init();
    }
    this.setState({
      mounted: true
    });
    var lazyLoadedList = [];
    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
        lazyLoadedList.push(i);
      }
    }

    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
      this.setState({
        lazyLoadedList: lazyLoadedList
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // Hack for autoplay -- Inspect Later
    this.initialize(this.props);
    this.adaptHeight();

    // To support server-side rendering
    if (!window) {
      return;
    }
    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }
    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }
    if (this.state.autoPlayTimer) {
      clearInterval(this.state.autoPlayTimer);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.slickGoTo != nextProps.slickGoTo) {
      if (false) {
        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
      }
      this.changeSlide({
        message: 'index',
        index: nextProps.slickGoTo,
        currentSlide: this.state.currentSlide
      });
    } else if (this.state.currentSlide >= nextProps.children.length) {
      this.update(nextProps);
      this.changeSlide({
        message: 'index',
        index: nextProps.children.length - nextProps.slidesToShow,
        currentSlide: this.state.currentSlide
      });
    } else {
      this.update(nextProps);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.adaptHeight();
  },
  onWindowResized: function onWindowResized() {
    this.update(this.props);
    // animating state should be cleared while resizing, otherwise autoplay stops working
    this.setState({
      animating: false
    });
    clearTimeout(this.animationEndCallback);
    delete this.animationEndCallback;
  },
  slickPrev: function slickPrev() {
    this.changeSlide({ message: 'previous' });
  },
  slickNext: function slickNext() {
    this.changeSlide({ message: 'next' });
  },
  slickGoTo: function slickGoTo(slide) {
    slide = Number(slide);
    !isNaN(slide) && this.changeSlide({
      message: 'index',
      index: slide,
      currentSlide: this.state.currentSlide
    });
  },
  render: function render() {
    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
      'slick-vertical': this.props.vertical
    });

    var trackProps = {
      fade: this.props.fade,
      cssEase: this.props.cssEase,
      speed: this.props.speed,
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
      currentSlide: this.state.currentSlide,
      lazyLoad: this.props.lazyLoad,
      lazyLoadedList: this.state.lazyLoadedList,
      rtl: this.props.rtl,
      slideWidth: this.state.slideWidth,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: this.props.slidesToScroll,
      slideCount: this.state.slideCount,
      trackStyle: this.state.trackStyle,
      variableWidth: this.props.variableWidth
    };

    var dots;

    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
      var dotProps = {
        dotsClass: this.props.dotsClass,
        slideCount: this.state.slideCount,
        slidesToShow: this.props.slidesToShow,
        currentSlide: this.state.currentSlide,
        slidesToScroll: this.props.slidesToScroll,
        clickHandler: this.changeSlide,
        children: this.props.children,
        customPaging: this.props.customPaging
      };

      dots = _react2.default.createElement(_dots.Dots, dotProps);
    }

    var prevArrow, nextArrow;

    var arrowProps = {
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      currentSlide: this.state.currentSlide,
      slideCount: this.state.slideCount,
      slidesToShow: this.props.slidesToShow,
      prevArrow: this.props.prevArrow,
      nextArrow: this.props.nextArrow,
      clickHandler: this.changeSlide
    };

    if (this.props.arrows) {
      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
    }

    var verticalHeightStyle = null;

    if (this.props.vertical) {
      verticalHeightStyle = {
        height: this.state.listHeight
      };
    }

    var centerPaddingStyle = null;

    if (this.props.vertical === false) {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.props.centerPadding
        };
      }
    } else {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: this.props.centerPadding + ' 0px'
        };
      }
    }

    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);

    return _react2.default.createElement(
      'div',
      {
        className: className,
        onMouseEnter: this.onInnerSliderEnter,
        onMouseLeave: this.onInnerSliderLeave,
        onMouseOver: this.onInnerSliderOver
      },
      prevArrow,
      _react2.default.createElement(
        'div',
        {
          ref: this.listRefHandler,
          className: 'slick-list',
          style: listStyle,
          onMouseDown: this.swipeStart,
          onMouseMove: this.state.dragging ? this.swipeMove : null,
          onMouseUp: this.swipeEnd,
          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
          onTouchStart: this.swipeStart,
          onTouchMove: this.state.dragging ? this.swipeMove : null,
          onTouchEnd: this.swipeEnd,
          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
          onKeyDown: this.props.accessibility ? this.keyHandler : null },
        _react2.default.createElement(
          _track.Track,
          _extends({ ref: this.trackRefHandler }, trackProps),
          this.props.children
        )
      ),
      nextArrow,
      dots
    );
  }
});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _trackHelper = __webpack_require__(139);

var _helpers = __webpack_require__(83);

var _helpers2 = _interopRequireDefault(_helpers);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventHandlers = {
  // Event handler for previous and next
  changeSlide: function changeSlide(options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var _props = this.props,
        slidesToScroll = _props.slidesToScroll,
        slidesToShow = _props.slidesToShow;
    var _state = this.state,
        slideCount = _state.slideCount,
        currentSlide = _state.currentSlide;

    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

    if (options.message === 'previous') {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;
      if (this.props.lazyLoad) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
    } else if (options.message === 'next') {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;
      if (this.props.lazyLoad) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
    } else if (options.message === 'dots' || options.message === 'children') {
      // Click on dots
      targetSlide = options.index * options.slidesToScroll;
      if (targetSlide === options.currentSlide) {
        return;
      }
    } else if (options.message === 'index') {
      targetSlide = Number(options.index);
      if (targetSlide === options.currentSlide) {
        return;
      }
    }

    this.slideHandler(targetSlide);
  },

  // Accessiblity handler for previous and next
  keyHandler: function keyHandler(e) {
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (e.keyCode === 37 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'next' : 'previous'
        });
      } else if (e.keyCode === 39 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'previous' : 'next'
        });
      }
    }
  },
  // Focus on selecting a slide (click handler on track)
  selectHandler: function selectHandler(options) {
    this.changeSlide(options);
  },
  swipeStart: function swipeStart(e) {
    var touches, posX, posY;

    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
      return;
    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
      return;
    }
    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    });
  },
  swipeMove: function swipeMove(e) {
    if (!this.state.dragging) {
      e.preventDefault();
      return;
    }
    if (this.state.scrolling) {
      return;
    }
    if (this.state.animating) {
      e.preventDefault();
      return;
    }
    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
      e.preventDefault();
    }
    var swipeLeft;
    var curLeft, positionOffset;
    var touchObject = this.state.touchObject;

    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: this.state.currentSlide,
      trackRef: this.track
    }, this.props, this.state));
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
      this.setState({
        scrolling: true
      });
      return;
    }

    if (this.props.verticalSwiping) {
      touchObject.swipeLength = verticalSwipeLength;
    }

    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);

    if (this.props.verticalSwiping) {
      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    }

    var currentSlide = this.state.currentSlide;
    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
    var swipeDirection = this.swipeDirection(this.state.touchObject);
    var touchSwipeLength = touchObject.swipeLength;

    if (this.props.infinite === false) {
      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;

        if (this.state.edgeDragged === false && this.props.edgeEvent) {
          this.props.edgeEvent(swipeDirection);
          this.setState({ edgeDragged: true });
        }
      }
    }

    if (this.state.swiped === false && this.props.swipeEvent) {
      this.props.swipeEvent(swipeDirection);
      this.setState({ swiped: true });
    }

    if (!this.props.vertical) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
    }

    if (this.props.verticalSwiping) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    }

    this.setState({
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
    });

    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return;
    }
    if (touchObject.swipeLength > 4) {
      this.setState({
        swiping: true
      });
      e.preventDefault();
    }
  },
  getNavigableIndexes: function getNavigableIndexes() {
    var max = void 0;
    var breakPoint = 0;
    var counter = 0;
    var indexes = [];

    if (!this.props.infinite) {
      max = this.state.slideCount;
    } else {
      breakPoint = this.props.slidesToShow * -1;
      counter = this.props.slidesToShow * -1;
      max = this.state.slideCount * 2;
    }

    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + this.props.slidesToScroll;

      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
    }

    return indexes;
  },
  checkNavigable: function checkNavigable(index) {
    var navigables = this.getNavigableIndexes();
    var prevNavigable = 0;

    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }

        prevNavigable = navigables[n];
      }
    }

    return index;
  },
  getSlideCount: function getSlideCount() {
    var _this = this;

    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;

    if (this.props.swipeToSlide) {
      var swipedSlide = void 0;

      var slickList = _reactDom2.default.findDOMNode(this.list);

      var slides = slickList.querySelectorAll('.slick-slide');

      Array.from(slides).every(function (slide) {
        if (!_this.props.vertical) {
          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        } else {
          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        }

        return true;
      });

      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;

      return slidesTraversed;
    } else {
      return this.props.slidesToScroll;
    }
  },

  swipeEnd: function swipeEnd(e) {
    if (!this.state.dragging) {
      if (this.props.swipe) {
        e.preventDefault();
      }
      return;
    }
    var touchObject = this.state.touchObject;
    var minSwipe = this.state.listWidth / this.props.touchThreshold;
    var swipeDirection = this.swipeDirection(touchObject);

    if (this.props.verticalSwiping) {
      minSwipe = this.state.listHeight / this.props.touchThreshold;
    }

    var wasScrolling = this.state.scrolling;
    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      edgeDragged: false,
      scrolling: false,
      swiping: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    });
    if (wasScrolling) {
      return;
    }

    // Fix for #13
    if (!touchObject.swipeLength) {
      return;
    }
    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();

      var slideCount = void 0,
          newSlide = void 0;

      switch (swipeDirection) {

        case 'left':
        case 'down':
          newSlide = this.state.currentSlide + this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          newSlide = this.state.currentSlide - this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 1;
          break;

        default:
          slideCount = this.state.currentSlide;

      }

      this.slideHandler(slideCount);
    } else {
      // Adjust the track back to it's original position.
      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));

      this.setState({
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      });
    }
  },
  onInnerSliderEnter: function onInnerSliderEnter(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderOver: function onInnerSliderOver(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderLeave: function onInnerSliderLeave(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.autoPlay();
    }
  }
};

exports.default = EventHandlers;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var initialState = {
    animating: false,
    dragging: false,
    autoPlayTimer: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    listWidth: null,
    listHeight: null,
    scrolling: false,
    // loadIndex: 0,
    slideCount: null,
    slideWidth: null,
    slideHeight: null,
    swiping: false,
    // sliding: false,
    // slideOffset: 0,
    swipeLeft: null,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },

    lazyLoadedList: [],

    // added for react
    initialized: false,
    edgeDragged: false,
    swiped: false, // used by swipeEvent. differentites between touch and swipe.
    trackStyle: {},
    trackWidth: 0

    // Removed
    // transformsEnabled: false,
    // $nextArrow: null,
    // $prevArrow: null,
    // $dots: null,
    // $list: null,
    // $slideTrack: null,
    // $slides: null,
};

module.exports = initialState;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(293);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(17);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return (0, _classnames2.default)({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';
    style.left = -spec.index * spec.slideWidth;
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  // key could be a zero
  return child.key === null || child.key === undefined ? fallbackKey : child.key;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var count = _react2.default.Children.count(spec.children);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: 'children',
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
      child = elem;
    } else {
      child = _react2.default.createElement('div', null);
    }
    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
    var slideClass = child.props.className || '';

    var onClick = function onClick(e) {
      child.props && child.props.onClick && child.props.onClick(e);
      if (spec.focusOnSelect) {
        spec.focusOnSelect(childOnClickOptions);
      }
    };

    slides.push(_react2.default.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
      tabIndex: '-1',
      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
      onClick: onClick
    }));

    // variableWidth doesn't wrap properly.
    if (spec.infinite && spec.fade === false) {
      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;

      if (index >= count - infiniteCount) {
        key = -(count - index);
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'precloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }

      if (index < infiniteCount) {
        key = count + index;
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'postcloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides.call(this, this.props);
    return _react2.default.createElement(
      'div',
      { className: 'slick-track', style: this.props.trackStyle },
      slides
    );
  };

  return Track;
}(_react2.default.Component);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;
  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  return dots;
};

var Dots = exports.Dots = function (_React$Component) {
  _inherits(Dots, _React$Component);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {

      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);

      return _react2.default.createElement(
        'li',
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.createElement(
      'ul',
      { className: this.props.dotsClass, style: { display: 'block' } },
      dots
    );
  };

  return Dots;
}(_react2.default.Component);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(83);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$Component) {
  _inherits(PrevArrow, _React$Component);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses['slick-disabled'] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: '0',
      'data-role': 'none',
      className: (0, _classnames2.default)(prevClasses),
      style: { display: 'block' },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        'button',
        _extends({ key: '0', type: 'button' }, prevArrowProps),
        ' Previous'
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.Component);

var NextArrow = exports.NextArrow = function (_React$Component2) {
  _inherits(NextArrow, _React$Component2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
    var nextHandler = this.clickHandler.bind(this, { message: 'next' });

    if (!_helpers2.default.canGoNext(this.props)) {
      nextClasses['slick-disabled'] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: '1',
      'data-role': 'none',
      className: (0, _classnames2.default)(nextClasses),
      style: { display: 'block' },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        'button',
        _extends({ key: '1', type: 'button' }, nextArrowProps),
        ' Next'
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.Component);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(298);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(301);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(302);
var Util = __webpack_require__(141);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(303);
var each = __webpack_require__(141).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Banner=(_dec=(0,_mobxReact.inject)('appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Banner,_Component);function Banner(){_classCallCheck(this,Banner);return _possibleConstructorReturn(this,(Banner.__proto__||Object.getPrototypeOf(Banner)).apply(this,arguments));}_createClass(Banner,[{key:'goToNewVersion',value:function goToNewVersion(){_jsCookie2.default.set("is_new",1);window.location.reload();}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'banner'},_react2.default.createElement('div',{className:'banner-wrapper'},_react2.default.createElement('div',{className:'banner-content'},_react2.default.createElement('h2',{className:'banner-title'},'\u041E\u0446\u0435\u043D\u0438 \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438!'),_react2.default.createElement('div',{className:'banner-card'},_react2.default.createElement('div',{className:'banner-card--info'},_react2.default.createElement('div',{className:'banner-card--title'},'\u0423\u0434\u043E\u0431\u0441\u0442\u0432\u043E'),_react2.default.createElement('div',{className:'banner-card--subtitle'},'\u0421\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u0441\u0430\u0439\u0442\u0430,  \u0432\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F Live-\u0441\u043E\u0431\u044B\u0442\u0438\u0439, \u0442\u0435\u043C\u043D\u0430\u044F \u0438\u043B\u0438 \u0441\u0432\u0435\u0442\u043B\u0430\u044F \u0442\u0435\u043C\u044B')),_react2.default.createElement('div',{className:'banner-card--info'},_react2.default.createElement('div',{className:'banner-card--title'},'\u0418\u0433\u0440\u044B 24/7'),_react2.default.createElement('div',{className:'banner-card--subtitle'},'\u041A\u043E\u0433\u0434\u0430 \u043D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0441\u043F\u043E\u0440\u0442\u0438\u0432\u044B\u0445 \u0441\u043E\u0431\u044B\u0442\u0438\u0439')),_react2.default.createElement('div',{className:'banner-card--info'},_react2.default.createElement('div',{className:'banner-card--title'},'\u0418\u043D\u0444\u043E\u0433\u0440\u0430\u0444\u0438\u043A\u0430'),_react2.default.createElement('div',{className:'banner-card--subtitle'},'\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0430\u044F \u0432\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F LIVE-\u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0441 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u043E\u0439'))),_react2.default.createElement('div',{className:'banner-image'}),_react2.default.createElement('button',{className:'banner-button',type:'button',onClick:this.goToNewVersion},'\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043D\u043E\u0432\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E')),_react2.default.createElement('div',{className:'banner-close',onClick:function onClick(){return _this2.props.hideBanner();}})),_react2.default.createElement('div',{className:'banner-overlay',onClick:function onClick(){return _this2.props.hideBanner();}}));}}]);return Banner;}(_react.Component))||_class)||_class);exports.default=Banner;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var NotFound=function NotFound(){return _react2.default.createElement('div',{className:'cont404'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C-\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430')),_react2.default.createElement('p',null,'\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u044B \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430.'),_react2.default.createElement('p',null,'\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0432\u044B \u043E\u0448\u0438\u0431\u043B\u0438\u0441\u044C \u0432 \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0430\u0434\u0440\u0435\u0441\u0430.'),_react2.default.createElement(_reactRouterDom.Link,{to:'/'},'\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430'));};exports.default=NotFound;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _results=__webpack_require__(307);var _results2=_interopRequireDefault(_results);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(_ref){var match=_ref.match;return _react2.default.createElement('div',{className:'results-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C-\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B')),_react2.default.createElement(_results2.default,{mode:'line'}));};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _results=__webpack_require__(308);var _results2=_interopRequireDefault(_results);var _filter=__webpack_require__(337);var _filter2=_interopRequireDefault(_filter);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResultContainer=(_dec=(0,_mobxReact.inject)('resultStore','appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ResultContainer,_Component);function ResultContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResultContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResultContainer.__proto__||Object.getPrototypeOf(ResultContainer)).call.apply(_ref,[this].concat(args))),_this),_this.onupdate=function(){_this.setState({upd:Date.now()});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResultContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.resultStore.init(this.props.mode);var liveResults=this.props.resultStore.liveResults;liveResults.menu.subscribe(this.onupdate);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var liveResults=this.props.resultStore.liveResults;liveResults.menu.unsubscribe(this.onupdate);}},{key:'render',// componentWillUnmount() {
//   this.props.resultStore.reset();
// }
value:function render(){var cashboxId=this.props.appStore.cashboxId;this.props.resultStore.setCashboxModeId(cashboxId);var isLoading=this.props.resultStore.isLoading;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'blue_line overflow'},_react2.default.createElement(_underHeader2.default,{type:2})),!isLoading?_react2.default.createElement('div',{className:'result-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_filter2.default,null),_react2.default.createElement(_results2.default,null)));}}]);return ResultContainer;}(_react.Component))||_class)||_class);exports.default=ResultContainer;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _mobx=__webpack_require__(5);var _ResultsLive=__webpack_require__(142);var ResultsLive=_interopRequireWildcard(_ResultsLive);var _reactRouterDom=__webpack_require__(2);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Result=(_dec=(0,_mobxReact.inject)('resultStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Result,_Component);function Result(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Result);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Result.__proto__||Object.getPrototypeOf(Result)).call.apply(_ref,[this].concat(args))),_this),_this.onupdate=function(){_this.setState({upd:Date.now()});},_this.handleCloseError=function(){_this.props.resultStore.clearError();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Result,[{key:'componentDidMount',value:function componentDidMount(){var liveResults=this.props.resultStore.liveResults;liveResults.tables.subscribe(this.onupdate);liveResults.menu.subscribe(this.onupdate);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var liveResults=this.props.resultStore.liveResults;liveResults.tables.unsubscribe(this.onupdate);liveResults.menu.unsubscribe(this.onupdate);}},{key:'getXHRdata',value:function getXHRdata(){var _this2=this;var sport=Object.values((0,_mobx.toJS)(this.props.resultStore.results.sport||{}));return sport.map(function(_ref2){var id=_ref2.id,league=_ref2.league,sport_name=_ref2.sport_name;return{id:id,championships:league.map(function(championshipID){var _props$resultStore$re=_this2.props.resultStore.results.league.get(championshipID),league_name=_props$resultStore$re.league_name,games=_props$resultStore$re.games;return{id:championshipID,/** Название спорта вместе с чемпионатом */text:sport_name+'.'+league_name,matches:games.map(function(matchID){var _props$resultStore$re2=_this2.props.resultStore.results.games.get(matchID),name=_props$resultStore$re2.name,score=_props$resultStore$re2.score,date=_props$resultStore$re2.date;var _name$split=name.split(' - '),_name$split2=_slicedToArray(_name$split,2),team1=_name$split2[0],team2=_name$split2[1];return{id:matchID,time:date,score:score,team1:team1,team2:team2};})};})};});}},{key:'render',value:function render(){var liveResults=this.props.resultStore.liveResults;var wssData=liveResults.tables.getData();var isAnySportSelected=liveResults.menu.getSelected().length!==0;var _props$resultStore=this.props.resultStore,mode=_props$resultStore.mode,result=_props$resultStore.result;var getLang=this.props.dictStore.getLang;var isLiveMode=mode==='live';var results=this.props.resultStore.results;var isLoading=results.isLoading,noResultSport=results.noResultSport;if(isLoading){return _react2.default.createElement(_loadingSpinner2.default,null);}if(!isAnySportSelected){return _react2.default.createElement(_message2.default,{type:'result-error',text:"SELECT_SPORT",onClose:this.handleCloseError});}if(!isLiveMode&&result.status){return _react2.default.createElement(_message2.default,{type:result.type,text:result.text,onClose:this.handleCloseError});}var xhrData=this.getXHRdata();if(isAnySportSelected&&!wssData&&xhrData.length===0||noResultSport&&noResultSport.length!==0){return _react2.default.createElement(_message2.default,{type:1,text:'NO_RESULTS',onClose:this.handleCloseError});;}// const onClick = (sportID, championshipID, matchID) => {
//   this.props.history.push(`/${mode}/${sportID}/${championshipID}/${matchID}`);
// };
var mainScore=this.props.resultStore.menu.mainScore;var getInfo=function getInfo(matchID){if(!results.games.has(matchID)){return{};}var _ref3=results.games.get(matchID)||{},dopBets=_ref3.dopBets,refund=_ref3.refund;return{additionalBets:!mainScore&&(0,_mobx.toJS)(dopBets),cancel:results.cancel[matchID],refund:refund};};return _react2.default.createElement(ResultsLive.Tables,{toLocale:getLang,getInfo:getInfo,sports:isLiveMode&&wssData||xhrData// onClick={isLiveMode ? onClick : void 0}
});}}]);return Result;}(_react.Component))||_class)||_class)||_class);exports.default=Result;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsSportFilter=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Menu=__webpack_require__(143);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ResultsSportFilter=exports.ResultsSportFilter=function ResultsSportFilter(props){return _react2.default.createElement('div',{className:'results-sport clearfix'},_react2.default.createElement('ul',{className:'sport-list clearfix'},props.data.topSports.map(function(sport){return{isSelected:props.isSelected(sport.id),name:props.toLocale(sport.name),hasMatches:sport.hasMatches,select:props.select,id:sport.id};}).map(function(props){return _react2.default.createElement(MenuItem,_extends({},props,{key:'filter_item_'+props.id}));})));};var MenuItem=_react2.default.memo(function(props){return _react2.default.createElement('li',null,_react2.default.createElement('button',{className:''+(props.isSelected&&props.hasMatches?'on':'')+(!props.hasMatches?'disabled':''),onClick:(0,_react.useCallback)(function(){props.select(props.id,!props.isSelected);},[props.id,props.isSelected]),disabled:!props.hasMatches},props.id!==_Menu.ALL_SPORTS_ID&&_react2.default.createElement('span',{className:'f-s-ico-'+props.id}),props.name));});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsLiveMenuListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResultsLiveMenuListener=exports.ResultsLiveMenuListener=function(_BaseSocketConnector){_inherits(ResultsLiveMenuListener,_BaseSocketConnector);function ResultsLiveMenuListener(){_classCallCheck(this,ResultsLiveMenuListener);var _this=_possibleConstructorReturn(this,(ResultsLiveMenuListener.__proto__||Object.getPrototypeOf(ResultsLiveMenuListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_RESULTS_FILTER;return _this;}_createClass(ResultsLiveMenuListener,[{key:'getOutcomeData',value:function getOutcomeData(){return{site:this.siteType,lng:this.language};}}]);return ResultsLiveMenuListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WSSocketListener=undefined;var _BaseSocketListener2=__webpack_require__(144);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WS_KEY='debug:websocket';var WS_URL=typeof window==='undefined'?'':(window.location.protocol==='https:'?'wss':'ws')+'://'+window.location.host+'/wss';var WSSocketListener=exports.WSSocketListener=function(_BaseSocketListener){_inherits(WSSocketListener,_BaseSocketListener);function WSSocketListener(){_classCallCheck(this,WSSocketListener);return _possibleConstructorReturn(this,(WSSocketListener.__proto__||Object.getPrototypeOf(WSSocketListener)).apply(this,arguments));}return WSSocketListener;}(_BaseSocketListener2.BaseSocketListener);WSSocketListener.createSocket=function(){return new WebSocket(localStorage.getItem(WS_KEY)||WS_URL);};WSSocketListener.toString=function(){return'WSSocketListener';};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.XHRSocketListener=undefined;var _BaseSocketListener2=__webpack_require__(144);var _Axios=__webpack_require__(146);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var XHR_URL='/wss/xhr/';var XHRSocketListener=exports.XHRSocketListener=function(_BaseSocketListener){_inherits(XHRSocketListener,_BaseSocketListener);function XHRSocketListener(){_classCallCheck(this,XHRSocketListener);return _possibleConstructorReturn(this,(XHRSocketListener.__proto__||Object.getPrototypeOf(XHRSocketListener)).apply(this,arguments));}return XHRSocketListener;}(_BaseSocketListener2.BaseSocketListener);XHRSocketListener.createSocket=function(){return new _Axios.AxiosSocket(XHR_URL);};XHRSocketListener.toString=function(){return'XHRSocketListener';};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var bind = __webpack_require__(147);
var Axios = __webpack_require__(315);
var defaults = __webpack_require__(85);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(151);
axios.CancelToken = __webpack_require__(330);
axios.isCancel = __webpack_require__(150);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(331);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(85);
var utils = __webpack_require__(16);
var InterceptorManager = __webpack_require__(325);
var dispatchRequest = __webpack_require__(326);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(149);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var transformData = __webpack_require__(327);
var isCancel = __webpack_require__(150);
var defaults = __webpack_require__(85);
var isAbsoluteURL = __webpack_require__(328);
var combineURLs = __webpack_require__(329);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(151);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var ONE_SECOND_MS=exports.ONE_SECOND_MS=1000;var ONE_MINUTE_MS=exports.ONE_MINUTE_MS=60*ONE_SECOND_MS;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SubscriptionsStore=exports.SubscriptionsStore=function(){function SubscriptionsStore(){_classCallCheck(this,SubscriptionsStore);this.elements={};}_createClass(SubscriptionsStore,[{key:"upsert",value:function upsert(element){this.elements[element.t]=element;}},{key:"remove",value:function remove(t){delete this.elements[t];}},{key:"clear",value:function clear(){var _this=this;Object.keys(this.elements).forEach(function(key){return delete _this.elements[key];});}},{key:"getAll",value:function getAll(){return Object.values(this.elements);}},{key:"isEmpty",get:function get(){return Object.keys(this.elements).length===0;}}]);return SubscriptionsStore;}();

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultSportsTables=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Championship=__webpack_require__(335);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ResultSportsTables=exports.ResultSportsTables=function ResultSportsTables(props){return _react2.default.createElement('div',null,props.sports.map(function(sport){return sport.championships.map(function(cfg){return _react2.default.createElement(_Championship.ChampionShip,_extends({},cfg,{sportID:sport.id,key:'championship_'+cfg.id,toLocale:props.toLocale,onClick:props.onClick,getInfo:props.getInfo,foldable:props.foldable}));});}));};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChampionShip=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Match=__webpack_require__(336);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ChampionShip=exports.ChampionShip=function ChampionShip(props){return _react2.default.createElement('table',{className:'l-t'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{className:'l-td l-td-s-'+props.sportID+' l-s-r-'+props.sportID,colSpan:3},_react2.default.createElement('div',{className:'l-d'},_react2.default.createElement('div',{className:'l-s-c-i f-s-ico-'+props.sportID}),_react2.default.createElement('span',{className:'l-t-i-n'},' ',props.toLocale(props.text)||props.enName,' ')))),props.matches.map(function(match){return _react2.default.createElement(_Match.Match,_extends({},match,{key:'match_'+match.id,championshipID:props.id,foldable:props.foldable,toLocale:props.toLocale,sportID:props.sportID,onClick:props.onClick,getInfo:props.getInfo}));})));};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Match=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Match=exports.Match=function Match(props){var _useState=(0,_react.useState)(!!props.foldable),_useState2=_slicedToArray(_useState,2),isFolded=_useState2[0],fold=_useState2[1];var _props$getInfo=props.getInfo(props.id),additionalBets=_props$getInfo.additionalBets,refund=_props$getInfo.refund,cancel=_props$getInfo.cancel;var onclick=(0,_react.useCallback)(function(){props.onClick&&props.onClick(props.sportID,props.championshipID,props.id);},[props.sportID,props.championshipID,props.id]);return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('tr',{className:'g-tr',onClick:props.foldable?function(){fold(!isFolded);}:void 0},_react2.default.createElement('td',{className:'g-d-date'},_react2.default.createElement('div',{className:'g-date'},props.time)),_react2.default.createElement('td',{className:'results-index-game-cmd g-d-players'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('b',{className:'g-d'+(props.onClick?' g-d-s':''),onClick:onclick},''+props.toLocale(props.team1)+(props.toLocale(props.team2)?' - '+props.toLocale(props.team2):'')))),_react2.default.createElement('td',{className:'g-d-score'},(props.score||'')+' '+(cancel||''),!!props.foldable&&_react2.default.createElement('p',{className:'dop-bets-count'},!!additionalBets&&''+(isFolded?'+':'-')+additionalBets.length))),!!additionalBets&&(!!props.foldable&&!isFolded||!props.foldable)&&_react2.default.createElement('tr',{className:'g-a-tr'},_react2.default.createElement('td',{className:'dopbets'}),_react2.default.createElement('td',{className:'g-a-td',colSpan:19},_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'g-a-l'},additionalBets.map(function(bet){return _react2.default.createElement('div',{key:bet},bet);}))))),!!refund&&_react2.default.createElement('tr',{className:'g-a-tr'},_react2.default.createElement('td',{className:'g-a-td',colSpan:20},_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'g-a-l'},_react2.default.createElement('div',null,refund))))));};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _moment=__webpack_require__(34);var _moment2=_interopRequireDefault(_moment);var _reactBootstrapDaterangepicker=__webpack_require__(338);var _reactBootstrapDaterangepicker2=_interopRequireDefault(_reactBootstrapDaterangepicker);var _ResultsLive=__webpack_require__(142);var ResultsLive=_interopRequireWildcard(_ResultsLive);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectDate=(_dec=(0,_mobxReact.inject)('resultStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(SelectDate,_Component);function SelectDate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectDate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectDate.__proto__||Object.getPrototypeOf(SelectDate)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectDate=function(id){_this.props.resultStore.menu.setDate(id);},_this.handleSelectDay=function(e,picker){_this.props.resultStore.menu.setDate(3,picker.startDate);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectDate,[{key:'render',value:function render(){var _this2=this;var getLang=this.props.dictStore.getLang;var resultDate=this.props.resultStore.menu.resultDate;return this.props.data.map(function(el,idx){return idx==3?_react2.default.createElement(_reactBootstrapDaterangepicker2.default,{key:idx,singleDatePicker:true,maxDate:(0,_moment2.default)(),locale:{format:'YYYY-MM-DD',weekdaysShort:['ВС','ПН','ВТ','СР','ЧТ','ПТ','СБ']},onApply:_this2.handleSelectDay},_react2.default.createElement('button',{className:'results-index-type datapicker '+(resultDate==idx?'on':'')},_react2.default.createElement('span',{className:' f-s-ico-calendar'}))):_react2.default.createElement('button',{key:idx,className:'results-index-date '+(resultDate==idx?'on':''),onClick:function onClick(){return _this2.handleSelectDate(idx);}},getLang(el));});}}]);return SelectDate;}(_react.Component))||_class)||_class);var SelectSport=(_dec2=(0,_mobxReact.inject)('resultStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(SelectSport,_Component2);function SelectSport(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,SelectSport);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=SelectSport.__proto__||Object.getPrototypeOf(SelectSport)).call.apply(_ref2,[this].concat(args))),_this3),_this3.onupdate=function(){_this3.setState({upd:Date.now()});},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(SelectSport,[{key:'componentDidMount',value:function componentDidMount(){var liveResults=this.props.resultStore.liveResults;liveResults.menu.subscribe(this.onupdate);if(this.props.resultStore.mode!=='live'){return;}liveResults.listenWS();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var liveResults=this.props.resultStore.liveResults;liveResults.menu.unsubscribe(this.onupdate);liveResults.stopListenWS();liveResults.clear();this.props.resultStore.results.clear();this.props.resultStore.menu.clear();}},{key:'getXHRdata',value:function getXHRdata(){var _this4=this;var all={hasMatches:true,name:'ALL',id:'all'};return{/** Есть ли матчи вообще. Определяет доступность кнопки «Все». */hasMatches:this.props.data.length!==0,/** Данные по топ-спортам. */topSports:[all].concat(this.props.data.map(function(id){return{hasMatches:!_this4.props.resultStore.menu.getDisabled(id),name:_this4.props.resultStore.menu.getDict(id),id:id};})),/** Есть ли матчи по остальным видам спорта. Определяет доступность кнопки «Остальные». */otherSportsHasMatches:this.props.data.includes('other')};}},{key:'loadSelected',value:function loadSelected(){var isLiveMode=this.props.resultStore.mode==='live';if(!isLiveMode){return;}var liveResults=this.props.resultStore.liveResults;var selected=liveResults.menu.getSelected();if(selected.length===0){return;}liveResults.tables.listenWS({all:selected.includes('all'),others:selected.includes('other'),sportIds:selected.filter(function(id){return id!=='all'&&id!=='other';})});}},{key:'render',value:function render(){var _this5=this;var getLang=this.props.dictStore.getLang;var liveResults=this.props.resultStore.liveResults;var wssData=liveResults.menu.getData();var isLiveMode=this.props.resultStore.mode==='live';var onSelect=function onSelect(sportID,isSelected){sportID==='all'?_this5.props.resultStore.menu.selectAll():_this5.props.resultStore.menu.selectSport(sportID);liveResults.menu.select(sportID,isSelected);if(!isLiveMode){return;}liveResults.tables.stopListenWS();liveResults.tables.clear();_this5.loadSelected();};if(isLiveMode&&wssData){return _react2.default.createElement(ResultsLive.Menu,{isSelected:liveResults.menu.isSelected,select:onSelect,toLocale:getLang,data:wssData});}return _react2.default.createElement(ResultsLive.Menu,{isSelected:liveResults.menu.isSelected,select:onSelect,toLocale:getLang,data:this.getXHRdata()});}}]);return SelectSport;}(_react.Component))||_class3)||_class3);var Filter=(_dec3=(0,_mobxReact.inject)('resultStore','dictStore'),_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(Filter,_Component3);function Filter(){var _ref3;var _temp3,_this6,_ret3;_classCallCheck(this,Filter);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this6=_possibleConstructorReturn(this,(_ref3=Filter.__proto__||Object.getPrototypeOf(Filter)).call.apply(_ref3,[this].concat(args))),_this6),_this6.handleSelectType=function(type){_this6.props.resultStore.menu.setType(type);},_this6.handleSelectMainScore=function(){_this6.props.resultStore.menu.setMainScore();},_temp3),_possibleConstructorReturn(_this6,_ret3);}_createClass(Filter,[{key:'render',value:function render(){var _this7=this;var _props$resultStore$me=this.props.resultStore.menu,menu=_props$resultStore$me.menu,filter=_props$resultStore$me.filter,type=_props$resultStore$me.type,resultDate=_props$resultStore$me.resultDate,mainScore=_props$resultStore$me.mainScore,store=_props$resultStore$me.store,label=_props$resultStore$me.label;var error=this.props.resultStore.error;var getLang=this.props.dictStore.getLang;if(!this.props.resultStore.menu||!store)return false;if(store.mode=='line'&&filter){return _react2.default.createElement('div',{className:'results-index-menu'},_react2.default.createElement('div',{className:''},_react2.default.createElement('div',{className:'results-index-info clearfix'},_react2.default.createElement('h1',{className:'results-h1 fl_l'},getLang('RESULTS'),'  ',_react2.default.createElement('span',null,' ',getLang(label))),_react2.default.createElement('div',{className:'results-date-info fl_r'},_react2.default.createElement('div',{className:'results-index-menu-item '},_react2.default.createElement('button',{className:'results-index-type results-main-score '+(mainScore?'on':''),onClick:this.handleSelectMainScore},getLang('MAIN_SCORE'))),_react2.default.createElement('div',{className:'results-index-menu-item '},filter.type.map(function(el,idx){return _react2.default.createElement('button',{key:idx,className:'results-index-type '+(type==idx?'on':''),onClick:function onClick(){return _this7.handleSelectType(idx);}},getLang(el));})),_react2.default.createElement('div',{className:'results-index-menu-item'},_react2.default.createElement(SelectDate,{data:filter.date})))),_react2.default.createElement(SelectSport,{data:menu.order})));}else if(store.mode=='live'){return _react2.default.createElement('div',{className:'results-index-menu'},_react2.default.createElement('div',{className:''},_react2.default.createElement('div',{className:'results-index-info clearfix'},_react2.default.createElement('h1',{className:'results-h1 fl_l'},getLang('RESULTS'))),_react2.default.createElement(SelectSport,{data:menu.order})));}else{return false;}}}]);return Filter;}(_react.Component))||_class5)||_class5);exports.default=Filter;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var $ = _interopDefault(__webpack_require__(152));
var PropTypes = _interopDefault(__webpack_require__(3));
__webpack_require__(339);

/* generated by gulpfile.js */

var getOptions = (function () {
  return ['<input>', 'alwaysShowCalendars', 'applyClass', 'autoApply', 'autoUpdateInput', 'buttonClasses', 'cancelClass', 'dateLimit', 'drops', 'endDate', 'isCustomDate', 'isInvalidDate', 'linkedCalendars', 'locale', 'maxDate', 'minDate', 'opens', 'parentEl', 'ranges', 'showCustomRangeLabel', 'showDropdowns', 'showISOWeekNumbers', 'showWeekNumbers', 'singleDatePicker', 'startDate', 'template', 'timePicker', 'timePicker24Hour', 'timePickerIncrement', 'timePickerSeconds'];
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var DateRangePicker = function (_Component) {
  inherits(DateRangePicker, _Component);

  function DateRangePicker(props) {
    classCallCheck(this, DateRangePicker);

    var _this = possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

    _this.$picker = null;
    _this.options = getOptions();
    return _this;
  }

  createClass(DateRangePicker, [{
    key: 'makeEventHandler',
    value: function makeEventHandler(eventType) {
      var _this2 = this;

      var onEvent = this.props.onEvent;

      return function (event, picker) {
        if (typeof onEvent === 'function') {
          onEvent(event, picker);
        }
        if (typeof _this2.props[eventType] === 'function') {
          _this2.props[eventType](event, picker);
        }
      };
    }
  }, {
    key: 'getOptionsFromProps',
    value: function getOptionsFromProps(props) {
      var options;
      props = props || this.props;
      this.options.forEach(function (option) {
        if (props.hasOwnProperty(option)) {
          options = options || {};
          options[option] = props[option];
        }
      });
      return options || {};
    }
  }, {
    key: 'setOptionsFromProps',
    value: function setOptionsFromProps(currentOptions) {
      var _this3 = this;

      var keys = Object.keys(currentOptions);
      if (this.$picker) {
        if (currentOptions) {
          keys.forEach(function (key) {
            if (key === 'startDate') {
              _this3.$picker.data('daterangepicker').setStartDate(currentOptions[key]);
            } else if (key === 'endDate') {
              _this3.$picker.data('daterangepicker').setEndDate(currentOptions[key]);
            } else if (key === 'locale') {
              $.extend(_this3.$picker.data('daterangepicker')[key], currentOptions[key]);
            } else {
              _this3.$picker.data('daterangepicker')[key] = currentOptions[key];
            }
          });
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.$picker) {
        var currentOptions = this.getOptionsFromProps();
        var nextOptions = this.getOptionsFromProps(nextProps);
        var changedOptions = {};
        this.options.forEach(function (option) {
          if (currentOptions[option] !== nextOptions[option]) {
            changedOptions[option] = nextOptions[option];
          }
        });
        this.setOptionsFromProps(changedOptions);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initializeDateRangePicker();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDateRangePicker();
    }
  }, {
    key: 'removeDateRangePicker',
    value: function removeDateRangePicker() {
      if (this.$picker && this.$picker.data('daterangepicker')) {
        this.$picker.data('daterangepicker').remove();
      }
    }
  }, {
    key: 'initializeDateRangePicker',
    value: function initializeDateRangePicker() {
      var _this4 = this;

      // initialize
      this.$picker.daterangepicker(this.getOptionsFromProps());
      // attach event listeners
      ['Show', 'Hide', 'ShowCalendar', 'HideCalendar', 'Apply', 'Cancel'].forEach(function (event) {
        var lcase = event.toLowerCase();
        _this4.$picker.on(lcase + '.daterangepicker', _this4.makeEventHandler('on' + event));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          children = _props.children,
          containerStyles = _props.containerStyles,
          containerClass = _props.containerClass;

      return React__default.createElement(
        'div',
        {
          ref: function ref(picker) {
            _this5.$picker = $(picker);
          },
          className: containerClass,
          style: containerStyles
        },
        children
      );
    }
  }]);
  return DateRangePicker;
}(React.Component);

DateRangePicker.defaultProps = {
  containerClass: 'react-bootstrap-daterangepicker-container',
  containerStyles: {
    display: 'inline-block'
  }
};

DateRangePicker.propTypes = {
  '<input>': PropTypes.any,
  alwaysShowCalendars: PropTypes.bool,
  applyClass: PropTypes.string,
  autoApply: PropTypes.bool,
  autoUpdateInput: PropTypes.bool,
  buttonClasses: PropTypes.array,
  cancelClass: PropTypes.string,
  containerClass: PropTypes.string,
  containerStyles: PropTypes.object,
  dateLimit: PropTypes.object,
  drops: PropTypes.oneOf(['down', 'up']),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isCustomDate: PropTypes.func,
  isInvalidDate: PropTypes.func,
  linkedCalendars: PropTypes.bool,
  locale: PropTypes.object,
  maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  onEvent: PropTypes.func,
  onHide: PropTypes.func,
  onHideCalendar: PropTypes.func,
  onShow: PropTypes.func,
  onShowCalendar: PropTypes.func,
  opens: PropTypes.oneOf(['left', 'right', 'center']),
  parentEl: PropTypes.any,
  ranges: PropTypes.object,
  showCustomRangeLabel: PropTypes.bool,
  showDropdowns: PropTypes.bool,
  showISOWeekNumbers: PropTypes.bool,
  showWeekNumbers: PropTypes.bool,
  singleDatePicker: PropTypes.bool,
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  template: PropTypes.any,
  timePicker: PropTypes.bool,
  timePickerIncrement: PropTypes.number,
  timePicker24Hour: PropTypes.bool,
  timePickerSeconds: PropTypes.bool
};

exports.DateRangePicker = DateRangePicker;
exports.default = DateRangePicker;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
* @version: 2.1.30
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2017 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/
// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
    if (true) {
        // AMD. Make globaly available as well
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(152)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (moment, jquery) {
            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
            return factory(moment, jquery);
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
        module.exports = factory(moment, jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root.moment, root.jQuery);
    }
}(this, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {

        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.dateLimit = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};

        this.opens = 'right';
        if (this.element.hasClass('pull-right'))
            this.opens = 'left';

        this.drops = 'down';
        if (this.element.hasClass('dropup'))
            this.drops = 'up';

        this.buttonClasses = 'btn btn-sm';
        this.applyClass = 'btn-success';
        this.cancelClass = 'btn-default';

        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        this.callback = function() { };

        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};

        //custom options from user
        if (typeof options !== 'object' || options === null)
            options = {};

        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);

        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $))
            options.template = '<div class="daterangepicker dropdown-menu">' +
                '<div class="calendar left">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="calendar right">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="ranges">' +
                    '<div class="range_inputs">' +
                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                        '<button class="cancelBtn" type="button"></button>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);

        //
        // handle all the possible options overriding defaults
        //

        if (typeof options.locale === 'object') {

            if (typeof options.locale.direction === 'string')
                this.locale.direction = options.locale.direction;

            if (typeof options.locale.format === 'string')
                this.locale.format = options.locale.format;

            if (typeof options.locale.separator === 'string')
                this.locale.separator = options.locale.separator;

            if (typeof options.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

            if (typeof options.locale.monthNames === 'object')
              this.locale.monthNames = options.locale.monthNames.slice();

            if (typeof options.locale.firstDay === 'number')
              this.locale.firstDay = options.locale.firstDay;

            if (typeof options.locale.applyLabel === 'string')
              this.locale.applyLabel = options.locale.applyLabel;

            if (typeof options.locale.cancelLabel === 'string')
              this.locale.cancelLabel = options.locale.cancelLabel;

            if (typeof options.locale.weekLabel === 'string')
              this.locale.weekLabel = options.locale.weekLabel;

            if (typeof options.locale.customRangeLabel === 'string'){
                //Support unicode chars in the custom range name.
                var elem = document.createElement('textarea');
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);

        if (typeof options.startDate === 'string')
            this.startDate = moment(options.startDate, this.locale.format);

        if (typeof options.endDate === 'string')
            this.endDate = moment(options.endDate, this.locale.format);

        if (typeof options.minDate === 'string')
            this.minDate = moment(options.minDate, this.locale.format);

        if (typeof options.maxDate === 'string')
            this.maxDate = moment(options.maxDate, this.locale.format);

        if (typeof options.startDate === 'object')
            this.startDate = moment(options.startDate);

        if (typeof options.endDate === 'object')
            this.endDate = moment(options.endDate);

        if (typeof options.minDate === 'object')
            this.minDate = moment(options.minDate);

        if (typeof options.maxDate === 'object')
            this.maxDate = moment(options.maxDate);

        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();

        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();

        if (typeof options.applyClass === 'string')
            this.applyClass = options.applyClass;

        if (typeof options.cancelClass === 'string')
            this.cancelClass = options.cancelClass;

        if (typeof options.dateLimit === 'object')
            this.dateLimit = options.dateLimit;

        if (typeof options.opens === 'string')
            this.opens = options.opens;

        if (typeof options.drops === 'string')
            this.drops = options.drops;

        if (typeof options.showWeekNumbers === 'boolean')
            this.showWeekNumbers = options.showWeekNumbers;

        if (typeof options.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = options.showISOWeekNumbers;

        if (typeof options.buttonClasses === 'string')
            this.buttonClasses = options.buttonClasses;

        if (typeof options.buttonClasses === 'object')
            this.buttonClasses = options.buttonClasses.join(' ');

        if (typeof options.showDropdowns === 'boolean')
            this.showDropdowns = options.showDropdowns;

        if (typeof options.showCustomRangeLabel === 'boolean')
            this.showCustomRangeLabel = options.showCustomRangeLabel;

        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }

        if (typeof options.timePicker === 'boolean')
            this.timePicker = options.timePicker;

        if (typeof options.timePickerSeconds === 'boolean')
            this.timePickerSeconds = options.timePickerSeconds;

        if (typeof options.timePickerIncrement === 'number')
            this.timePickerIncrement = options.timePickerIncrement;

        if (typeof options.timePicker24Hour === 'boolean')
            this.timePicker24Hour = options.timePicker24Hour;

        if (typeof options.autoApply === 'boolean')
            this.autoApply = options.autoApply;

        if (typeof options.autoUpdateInput === 'boolean')
            this.autoUpdateInput = options.autoUpdateInput;

        if (typeof options.linkedCalendars === 'boolean')
            this.linkedCalendars = options.linkedCalendars;

        if (typeof options.isInvalidDate === 'function')
            this.isInvalidDate = options.isInvalidDate;

        if (typeof options.isCustomDate === 'function')
            this.isCustomDate = options.isCustomDate;

        if (typeof options.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = options.alwaysShowCalendars;

        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }

        var start, end, range;

        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is('input[type=text]')) {
                var val = $(this.element).val(),
                    split = val.split(this.locale.separator);

                start = end = null;

                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }

        if (typeof options.ranges === 'object') {
            for (range in options.ranges) {

                if (typeof options.ranges[range][0] === 'string')
                    start = moment(options.ranges[range][0], this.locale.format);
                else
                    start = moment(options.ranges[range][0]);

                if (typeof options.ranges[range][1] === 'string')
                    end = moment(options.ranges[range][1], this.locale.format);
                else
                    end = moment(options.ranges[range][1]);

                // If the start or end date exceed those allowed by the minDate or dateLimit
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();

                var maxDate = this.maxDate;
                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
                    maxDate = start.clone().add(this.dateLimit);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();

                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day')) 
                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                    continue;

                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;

                this.ranges[rangeHtml] = [start, end];
            }

            var list = '<ul>';
            for (range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            if (this.showCustomRangeLabel) {
                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            }
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }

        if (typeof cb === 'function') {
            this.callback = cb;
        }

        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }

        //can't be used together for now
        if (this.timePicker && this.autoApply)
            this.autoApply = false;

        if (this.autoApply && typeof options.ranges !== 'object') {
            this.container.find('.ranges').hide();
        } else if (this.autoApply) {
            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
        }

        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.calendar.left').addClass('single');
            this.container.find('.calendar.left').show();
            this.container.find('.calendar.right').hide();
            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
            if (this.timePicker) {
                this.container.find('.ranges ul').hide();
            } else {
                this.container.find('.ranges').hide();
            }
        }

        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }

        this.container.addClass('opens' + this.opens);

        //swap the position of the predefined ranges if opens right
        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
        }

        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyClass.length)
            this.container.find('.applyBtn').addClass(this.applyClass);
        if (this.cancelClass.length)
            this.container.find('.cancelBtn').addClass(this.cancelClass);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);

        //
        // event listeners
        //

        this.container.find('.calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this))
            .on('keydown.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsKeydown, this));

        this.container.find('.ranges')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
            });
        } else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
        }

        //
        // if attached to a text input, set the initial value
        //

        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.element.trigger('change');
        } else if (this.element.is('input') && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format));
            this.element.trigger('change');
        }

    };

    DateRangePicker.prototype = {

        constructor: DateRangePicker,

        setStartDate: function(startDate) {
            if (typeof startDate === 'string')
                this.startDate = moment(startDate, this.locale.format);

            if (typeof startDate === 'object')
                this.startDate = moment(startDate);

            if (!this.timePicker)
                this.startDate = this.startDate.startOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        setEndDate: function(endDate) {
            if (typeof endDate === 'string')
                this.endDate = moment(endDate, this.locale.format);

            if (typeof endDate === 'object')
                this.endDate = moment(endDate);

            if (!this.timePicker)
                this.endDate = this.endDate.add(1,'d').startOf('day').subtract(1,'second');

            if (this.timePicker && this.timePickerIncrement)
                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.endDate.isBefore(this.startDate))
                this.endDate = this.startDate.clone();

            if (this.maxDate && this.endDate.isAfter(this.maxDate))
                this.endDate = this.maxDate.clone();

            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
                this.endDate = this.startDate.clone().add(this.dateLimit);

            this.previousRightTime = this.endDate.clone();

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        isInvalidDate: function() {
            return false;
        },

        isCustomDate: function() {
            return false;
        },

        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) {
                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
                } else {
                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
                }
            }
            if (this.endDate) {
                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
                this.container.find('input[name="daterangepicker_start"]').addClass('active');
            } else {
                this.container.find('input[name="daterangepicker_end"]').addClass('active');
                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
            }
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },

        updateMonthsInView: function() {
            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    &&
                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    ) {
                    return;
                }

                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                } else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }

            } else {
                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                    this.leftCalendar.month = this.startDate.clone().date(2);
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
              this.rightCalendar.month = this.maxDate.clone().date(2);
              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },

        updateCalendars: function() {

            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }

            this.renderCalendar('left');
            this.renderCalendar('right');

            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;

            this.calculateChosenLabel();
        },

        renderCalendar: function(side) {

            //
            // Build the matrix of dates that will populate the calendar
            //

            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([year, month]).daysInMonth();
            var firstDay = moment([year, month, 1]);
            var lastDay = moment([year, month, daysInMonth]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
            var dayOfWeek = firstDay.day();

            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;

            for (var i = 0; i < 6; i++) {
                calendar[i] = [];
            }

            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth)
                startDay -= 7;

            if (dayOfWeek == this.locale.firstDay)
                startDay = daysInLastMonth - 6;

            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

            var col, row;
            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);

                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                    calendar[row][col] = this.minDate.clone();
                }

                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                    calendar[row][col] = this.maxDate.clone();
                }

            }

            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') {
                this.leftCalendar.calendar = calendar;
            } else {
                this.rightCalendar.calendar = calendar;
            }

            //
            // Display the calendar
            //

            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';

            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th></th>';

            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
                var minYear = (minDate && minDate.year()) || (currentYear - 50);
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;

                var monthHtml = '<select class="monthselect">';
                for (var m = 0; m < 12; m++) {
                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            ">" + this.locale.monthNames[m] + "</option>";
                    } else {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                    }
                }
                monthHtml += "</select>";

                var yearHtml = '<select class="yearselect">';
                for (var y = minYear; y <= maxYear; y++) {
                    yearHtml += '<option value="' + y + '"' +
                        (y === currentYear ? ' selected="selected"' : '') +
                        '>' + y + '</option>';
                }
                yearHtml += '</select>';

                dateHtml = monthHtml + yearHtml;
            }

            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            html += '</tr>';
            html += '<tr>';

            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th class="week">' + this.locale.weekLabel + '</th>';

            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });

            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            //adjust maxDate to reflect the dateLimit setting in order to
            //grey out end dates beyond the dateLimit
            if (this.endDate == null && this.dateLimit) {
                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) {
                    maxDate = maxLimit;
                }
            }

            for (var row = 0; row < 6; row++) {
                html += '<tr>';

                // add week number
                if (this.showWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                for (var col = 0; col < 7; col++) {

                    var classes = [];

                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day"))
                        classes.push('today');

                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5)
                        classes.push('weekend');

                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month())
                        classes.push('off');

                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col]))
                        classes.push('off', 'disabled');

                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                        classes.push('active', 'start-date');

                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                        classes.push('active', 'end-date');

                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                        classes.push('in-range');

                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string')
                            classes.push(isCustom);
                        else
                            Array.prototype.push.apply(classes, isCustom);
                    }

                    var cname = '', disabled = false;
                    for (var i = 0; i < classes.length; i++) {
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled')
                            disabled = true;
                    }
                    if (!disabled)
                        cname += 'available';

                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

                }
                html += '</tr>';
            }

            html += '</tbody>';
            html += '</table>';

            this.container.find('.calendar.' + side + ' .calendar-table').html(html);

        },

        renderTimePicker: function(side) {

            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;

            var html, selected, minDate, maxDate = this.maxDate;

            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
                maxDate = this.startDate.clone().add(this.dateLimit);

            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;

                //Preserve the time already selected
                var timeSelector = this.container.find('.calendar.right .calendar-time div');
                if (timeSelector.html() != '') {

                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());

                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12)
                            selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12)
                            selected.hour(0);
                    }

                }

                if (selected.isBefore(this.startDate))
                    selected = this.startDate.clone();

                if (maxDate && selected.isAfter(maxDate))
                    selected = maxDate.clone();

            }

            //
            // hours
            //

            html = '<select class="hourselect">';

            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;

            for (var i = start; i <= end; i++) {
                var i_in_24 = i;
                if (!this.timePicker24Hour)
                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate))
                    disabled = true;

                if (i_in_24 == selected.hour() && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                } else {
                    html += '<option value="' + i + '">' + i + '</option>';
                }
            }

            html += '</select> ';

            //
            // minutes
            //

            html += ': <select class="minuteselect">';

            for (var i = 0; i < 60; i += this.timePickerIncrement) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);

                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate))
                    disabled = true;

                if (selected.minute() == i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                } else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }

            html += '</select> ';

            //
            // seconds
            //

            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';

                for (var i = 0; i < 60; i++) {
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);

                    var disabled = false;
                    if (minDate && time.isBefore(minDate))
                        disabled = true;
                    if (maxDate && time.isAfter(maxDate))
                        disabled = true;

                    if (selected.second() == i && !disabled) {
                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    } else if (disabled) {
                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    } else {
                        html += '<option value="' + i + '">' + padded + '</option>';
                    }
                }

                html += '</select> ';
            }

            //
            // AM/PM
            //

            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';

                var am_html = '';
                var pm_html = '';

                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                    am_html = ' disabled="disabled" class="disabled"';

                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                    pm_html = ' disabled="disabled" class="disabled"';

                if (selected.hour() >= 12) {
                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                } else {
                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                }

                html += '</select>';
            }

            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);

        },

        updateFormInputs: function() {

            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
            if (this.endDate)
                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));

            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
                this.container.find('button.applyBtn').removeAttr('disabled');
            } else {
                this.container.find('button.applyBtn').attr('disabled', 'disabled');
            }

        },

        move: function() {
            var parentOffset = { top: 0, left: 0 },
                containerTop;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }

            if (this.drops == 'up')
                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
            else
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');

            if (this.opens == 'left') {
                this.container.css({
                    top: containerTop,
                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
                    left: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else if (this.opens == 'center') {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                            - this.container.outerWidth() / 2,
                    right: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left,
                    right: 'auto'
                });
                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
                    this.container.css({
                        left: 'auto',
                        right: 0
                    });
                }
            }
        },

        show: function(e) {
            if (this.isShowing) return;

            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

            // Bind global datepicker mousedown for hiding and
            $(document)
              .on('mousedown.daterangepicker', this._outsideClickProxy)
              // also support mobile devices
              .on('touchend.daterangepicker', this._outsideClickProxy)
              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
              // and also close when focus changes to outside the picker (eg. tabbing between controls)
              .on('focusin.daterangepicker', this._outsideClickProxy);

            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();

            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },

        hide: function(e) {
            if (!this.isShowing) return;

            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }

            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
                this.callback(this.startDate, this.endDate, this.chosenLabel);

            //if picker is attached to a text input, update it
            this.updateElement();

            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },

        toggle: function(e) {
            if (this.isShowing) {
                this.hide();
            } else {
                this.show();
            }
        },

        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (
                // ie modal dialog fix
                e.type == "focusin" ||
                target.closest(this.element).length ||
                target.closest(this.container).length ||
                target.closest('.calendar-table').length
                ) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },

        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },

        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },

        hoverRange: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            var label = e.target.getAttribute('data-range-key');

            if (label == this.locale.customRangeLabel) {
                this.updateView();
            } else {
                var dates = this.ranges[label];
                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
            }

        },

        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) {
                this.showCalendars();
            } else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];

                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }

                if (!this.alwaysShowCalendars)
                    this.hideCalendars();
                this.clickApply();
            }
        },

        clickPrev: function(e) {
            var cal = $(e.target).parents('.calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars)
                    this.rightCalendar.month.subtract(1, 'month');
            } else {
                this.rightCalendar.month.subtract(1, 'month');
            }
            this.updateCalendars();
        },

        clickNext: function(e) {
            var cal = $(e.target).parents('.calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.add(1, 'month');
            } else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars)
                    this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },

        hoverDate: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
            //    return;

            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            //have the text inputs above calendars reflect the date being hovered over
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
            }

            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) {
                this.container.find('.calendar tbody td').each(function(index, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.calendar');
                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }

                });
            }

        },

        clickDate: function(e) {

            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //

            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) {
                //special case: clicking the same date for start/end,
                //but the time of the end date is before the start date
                this.setEndDate(this.startDate.clone());
            } else { // picking end
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                  this.calculateChosenLabel();
                  this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker)
                    this.clickApply();
            }

            this.updateView();

            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();

        },

        calculateChosenLabel: function () {
            var customRange = true;
            var i = 0;
            for (var range in this.ranges) {
              if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD hh:mm:ss" : "YYYY-MM-DD hh:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                        break;
                    }
                } else {
                    //ignore times when comparing dates if time picker is not enabled
                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                        break;
                    }
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
                } else {
                    this.chosenLabel = null;
                }
                this.showCalendars();
            }
        },

        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },

        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },

        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
                leftOrRight = isLeft ? 'left' : 'right',
                cal = this.container.find('.calendar.'+leftOrRight);

            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();

            if (!isLeft) {
                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }

            if (this.minDate) {
                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }

            if (this.maxDate) {
                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }

            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },

        timeChanged: function(e) {

            var cal = $(e.target).closest('.calendar'),
                isLeft = cal.hasClass('left');

            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12)
                    hour += 12;
                if (ampm === 'AM' && hour === 12)
                    hour = 0;
            }

            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) {
                    this.endDate = this.startDate.clone();
                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                    this.setEndDate(start.clone());
                }
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }

            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();

            //update the form inputs above the calendars with the new time
            this.updateFormInputs();

            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');

        },

        formInputsChanged: function(e) {
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);

            if (start.isValid() && end.isValid()) {

                if (isRight && end.isBefore(start))
                    start = end.clone();

                this.setStartDate(start);
                this.setEndDate(end);

                if (isRight) {
                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
                } else {
                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
                }

            }

            this.updateView();
        },

        formInputsFocused: function(e) {

            // Highlight the focused input
            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
            $(e.target).addClass('active');

            // Set the state such that if the user goes back to using a mouse, 
            // the calendars are aware we're selecting the end of the range, not
            // the start. This allows someone to edit the end of a date range without
            // re-selecting the beginning, by clicking on the end date input then
            // using the calendar.
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            if (isRight) {
                this.endDate = null;
                this.setStartDate(this.startDate.clone());
                this.updateView();
            }

        },

        formInputsBlurred: function(e) {

            // this function has one purpose right now: if you tab from the first
            // text input to the second in the UI, the endDate is nulled so that
            // you can click another, but if you tab out without clicking anything
            // or changing the input value, the old endDate should be retained

            if (!this.endDate) {
                var val = this.container.find('input[name="daterangepicker_end"]').val();
                var end = moment(val, this.locale.format);
                if (end.isValid()) {
                    this.setEndDate(end);
                    this.updateView();
                }
            }

        },

        formInputsKeydown: function(e) {
            // This function ensures that if the 'enter' key was pressed in the input, then the calendars
            // are updated with the startDate and endDate.
            // This behaviour is automatic in Chrome/Firefox/Edge but not in IE 11 hence why this exists.
            // Other browsers and versions of IE are untested and the behaviour is unknown.
            if (e.keyCode === 13) {
                // Prevent the calendar from being updated twice on Chrome/Firefox/Edge
                e.preventDefault(); 
                this.formInputsChanged(e);
            }
        },


        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;

            var dateString = this.element.val().split(this.locale.separator),
                start = null,
                end = null;

            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }

            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }

            if (!start.isValid() || !end.isValid()) return;

            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },

        keydown: function(e) {
            //hide on tab or enter
            if ((e.keyCode === 9) || (e.keyCode === 13)) {
                this.hide();
            }

            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();

                this.hide();
            }
        },

        updateElement: function() {
            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
                this.element.trigger('change');
            } else if (this.element.is('input') && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format));
                this.element.trigger('change');
            }
        },

        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }

    };

    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };

    return DateRangePicker;

}));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterTimeLine=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(FilterTimeLine,_Component);function FilterTimeLine(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterTimeLine);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterTimeLine.__proto__||Object.getPrototypeOf(FilterTimeLine)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false},_this.handleClear=function(e){_this.props.lineStore.line.filterLine(0);},_this.handleClick=function(value){_this.props.lineStore.line.filterLine(value);_this.hideItems();},_this.showItems=function(){_this.setState({show:true});},_this.hideItems=function(){_this.setState({show:false});},_this.handleClickOutside=function(e){var items=document.querySelector('.time-select-list-items');if(items&&!items.contains(e.target)){_this.hideItems();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterTimeLine,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}},{key:'render',value:function render(){var _this2=this;var _props$lineStore$line=this.props.lineStore.line,timeLineFilter=_props$lineStore$line.timeLineFilter,timeLine=_props$lineStore$line.timeLine;var getLang=this.props.dictStore.getLang;var show=this.state.show;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('span',{className:'control-panel-item time-select'},timeLineFilter.map(function(el){return _react2.default.createElement('div',{className:'white-btn timeline-item '+(el.val==timeLine?'selected':''),onClick:function onClick(){return _this2.handleClick(el.val);},key:el.val},getLang(el.label));})),_react2.default.createElement('div',{className:'time-line-filter-select time-select-list white-btn',onClick:this.handleChange},_react2.default.createElement('div',{className:'time-select-list-current',onClick:this.showItems},timeLineFilter.map(function(item){return item.val==timeLine?getLang(item.label):null;}),'  ',_react2.default.createElement('span',{className:' icon f-s-ico-arrow_buttom_1'})),show?_react2.default.createElement('div',{className:'time-select-list-items'},timeLineFilter.map(function(el){return _react2.default.createElement('div',{className:'white-btn time-select-list-item '+(el.val==timeLine?'selected':''),onClick:function onClick(){return _this2.handleClick(el.val);},key:el.val},getLang(el.label));})):null));}}]);return FilterTimeLine;}(_react.Component))||_class)||_class);exports.default=FilterTimeLine;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Settings=(_dec=(0,_mobxReact.inject)('accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Settings,_Component);function Settings(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Settings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Settings.__proto__||Object.getPrototypeOf(Settings)).call.apply(_ref,[this].concat(args))),_this),_this.state={position:[['left','Слева'],['right','Справа']],agreeCf:['Никогда','Всегда','При повышении']},_this.handleClick=function(k,v){_this.props.accountStore.toggleAccountSettings(k,v);},_this.handleSelect=function(k,e){_this.props.accountStore.toggleAccountSettings(k,e.target.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Settings,[{key:'render',value:function render(){var _this2=this;var _props$accountStore$a=this.props.accountStore.accountSettings,clearBasketAfterBet=_props$accountStore$a.clearBasketAfterBet,loadRossLive=_props$accountStore$a.loadRossLive,highlightChangesLive=_props$accountStore$a.highlightChangesLive,colorizeSport=_props$accountStore$a.colorizeSport,showHeaderBalance=_props$accountStore$a.showHeaderBalance,gamesNumber=_props$accountStore$a.gamesNumber,basketPosition=_props$accountStore$a.basketPosition,basketAgreeCf=_props$accountStore$a.basketAgreeCf;return _react2.default.createElement('div',{className:'box-account-settings'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'checkbox '+(clearBasketAfterBet?'on':''),onClick:function onClick(){return _this2.handleClick('clearBasketAfterBet',!clearBasketAfterBet);}},_react2.default.createElement('span',null),'\u041E\u0447\u0438\u0449\u0430\u0442\u044C \u043A\u043E\u0440\u0437\u0438\u043D\u0443 \u043F\u043E\u0441\u043B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438'))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'checkbox '+(loadRossLive?'on':''),onClick:function onClick(){return _this2.handleClick('loadRossLive',!loadRossLive);}},_react2.default.createElement('span',null),'\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C \u0440\u043E\u0441\u043F\u0438\u0441\u0438'))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'checkbox '+(highlightChangesLive?'on':''),onClick:function onClick(){return _this2.handleClick('highlightChangesLive',!highlightChangesLive);}},_react2.default.createElement('span',null),'\u041F\u043E\u0434\u0441\u0432\u0435\u0447\u0438\u0432\u0430\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F'))),_react2.default.createElement('div',{className:'row hidden'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'box-highlight-changes-live-help-gif'}))),_react2.default.createElement('div',{className:'row hidden'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'box-colorize-sport-help-gif'}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'checkbox '+(!showHeaderBalance?'on':''),onClick:function onClick(){return _this2.handleClick('showHeaderBalance',!showHeaderBalance);}},_react2.default.createElement('span',null),'\u0421\u043A\u0440\u044B\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441'))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'}),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('div',{className:'checkbox '+(gamesNumber?'on':''),onClick:function onClick(){return _this2.handleClick('gamesNumber',!gamesNumber);}},_react2.default.createElement('span',null),'\u041D\u043E\u043C\u0435\u0440\u0430 \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0432 \u041B\u0438\u043D\u0438\u0438'))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},_react2.default.createElement('label',{htmlFor:'as-basket-position'},'\u041A\u043E\u0440\u0437\u0438\u043D\u0430 \u0432 \u041B\u0438\u043D\u0438\u0438')),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('select',{id:'as-basket-position',onChange:function onChange(e){return _this2.handleSelect('basketPosition',e);}},this.state.position.map(function(el){return _react2.default.createElement('option',{key:el[0],value:el[0],selected:basketPosition==el[0]},el[1]);})))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},_react2.default.createElement('label',{htmlFor:'as-basket-agree-cf'},'\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u0442\u044C\u0441\u044F \u0441 \u0438\u0437\u043C. \u043A\u0444.')),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('select',{id:'as-basket-agree-cf',onChange:function onChange(e){return _this2.handleSelect('basketAgreeCf',e);}},this.state.agreeCf.map(function(el,idx){return _react2.default.createElement('option',{key:el,value:idx,selected:basketAgreeCf==idx},el);})))));}}]);return Settings;}(_react.Component))||_class)||_class);exports.default=Settings;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;// import ResizeDetector from 'react-resize-detector';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _movingStatistics=__webpack_require__(153);var _movingStatistics2=_interopRequireDefault(_movingStatistics);var _liveMenu=__webpack_require__(86);var _liveMenu2=_interopRequireDefault(_liveMenu);var _line=__webpack_require__(89);var _line2=_interopRequireDefault(_line);var _basket=__webpack_require__(171);var _basket2=_interopRequireDefault(_basket);var _settingsLine=__webpack_require__(172);var _settingsLine2=_interopRequireDefault(_settingsLine);var _scrollTopButton=__webpack_require__(175);var _scrollTopButton2=_interopRequireDefault(_scrollTopButton);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _searchBox=__webpack_require__(176);var _searchBox2=_interopRequireDefault(_searchBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Line=(_dec=(0,_mobxReact.inject)('accountStore','lineStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Line,_Component);function Line(){_classCallCheck(this,Line);return _possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments));}_createClass(Line,[{key:'componentDidMount',value:function componentDidMount(){this.props.lineStore.init('line');}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.lineStore.route.setUrl(this.props.match.params);}// onResize = () => {
// 	this.props.lineStore.calcHeigth();
// }
},{key:'render',value:function render(){var basketPosition=this.props.accountStore.accountSettings.basketPosition;var _props$lineStore=this.props.lineStore,isLoading=_props$lineStore.isLoading,basket=_props$lineStore.basket,shortMenu=_props$lineStore.shortMenu;return _react2.default.createElement('div',{className:'line line-view'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u043B\u0438\u043D\u0438\u044F')),isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_settingsLine2.default,null),_react2.default.createElement(_searchBox2.default,null),_react2.default.createElement('div',{className:'line-left-column '+(shortMenu&&basketPosition=='right'?'line-left-column-short':''),id:'line-left-column'},basketPosition=='left'?_react2.default.createElement('div',{className:'line-left-column-basket-cont'},_react2.default.createElement(_basket2.default,null)):'',(basket.toogleBasket.showArrow||basketPosition=='left')&&!shortMenu&&_react2.default.createElement(_movingStatistics2.default,null),_react2.default.createElement(_liveMenu2.default,null),_react2.default.createElement(_scrollTopButton2.default,null)),_react2.default.createElement(_line2.default,null),basketPosition=='right'?_react2.default.createElement('div',{className:'line-right-column line-right-column-border'+(basket.toogleBasket.showBasket?' open':'')},_react2.default.createElement(_basket2.default,null),!basket.toogleBasket.showArrow&&_react2.default.createElement(_movingStatistics2.default,null)):''));}}]);return Line;}(_react.Component))||_class)||_class)||_class);exports.default=Line;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _liveMenuSport=__webpack_require__(154);var _liveMenuSport2=_interopRequireDefault(_liveMenuSport);var _liveMenuFavourites=__webpack_require__(346);var _liveMenuFavourites2=_interopRequireDefault(_liveMenuFavourites);var _liveMenuPopular=__webpack_require__(347);var _liveMenuPopular2=_interopRequireDefault(_liveMenuPopular);var _schedule=__webpack_require__(359);var _schedule2=_interopRequireDefault(_schedule);var _withVideo=__webpack_require__(360);var _withVideo2=_interopRequireDefault(_withVideo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenu=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LiveMenu,_Component);function LiveMenu(){_classCallCheck(this,LiveMenu);return _possibleConstructorReturn(this,(LiveMenu.__proto__||Object.getPrototypeOf(LiveMenu)).apply(this,arguments));}_createClass(LiveMenu,[{key:'render',value:function render(){if(!this.props.lineStore.menu.mode){return null;}var _props$lineStore$menu=this.props.lineStore.menu,isLoadMenu=_props$lineStore$menu.isLoadMenu,sportOrder=_props$lineStore$menu.sportOrder,mode=_props$lineStore$menu.mode;if(isLoadMenu){return _react2.default.createElement('div',{className:'favourites-loader-wrap'},_react2.default.createElement(_loadingSpinner2.default,null));}return _react2.default.createElement('div',{className:'line-left-column-left-menu-cont'},_react2.default.createElement('div',{className:'line-left-menu-cont'},_react2.default.createElement(_liveMenuFavourites2.default,null),_react2.default.createElement('div',{id:'wrapper-scroll-menu',className:'not-favourites-wrapper'},mode==='line'&&_react2.default.createElement(_liveMenuPopular2.default,null),mode==='live'&&_react2.default.createElement(_withVideo2.default,{mode:mode}),sportOrder.map(function(id){return _react2.default.createElement(_liveMenuSport2.default,{key:id,id:id,type:1});}),mode==='live'&&_react2.default.createElement(_schedule2.default,null))));}}]);return LiveMenu;}(_react.Component))||_class)||_class);exports.default=LiveMenu;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _liveMenuGame=__webpack_require__(155);var _liveMenuGame2=_interopRequireDefault(_liveMenuGame);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuLeague=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_Component){_inherits(LiveMenuLeague,_Component);_createClass(LiveMenuLeague,[{key:'getChildContext',value:function getChildContext(){return{leagueId:this.props.id};}}]);function LiveMenuLeague(props){_classCallCheck(this,LiveMenuLeague);var _this=_possibleConstructorReturn(this,(LiveMenuLeague.__proto__||Object.getPrototypeOf(LiveMenuLeague)).call(this,props));_this.selectItem=function(evt){_this.props.history.push('/'+_this.props.lineStore.menu.mode+'/'+_this.context.sportId+'/'+_this.props.id);// this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
evt.preventDefault();};_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(_this.props.id,_this.props.type);};return _this;}_createClass(LiveMenuLeague,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,league=_props$lineStore$menu.league,selected=_props$lineStore$menu.selected,isOpen=_props$lineStore$menu.isOpen;var id=this.props.id;var data=league.get(id);var isSelected=selected.league.includes(id);var isOpenedLeague=isOpen.league.includes(id);if(!data){return null;}var wClass=(0,_classnames2.default)(['favourites-league-item',{'favourites-menu-item_active':isSelected}]);return _react2.default.createElement('div',{className:wClass,onClick:this.toggle},_react2.default.createElement(_favouriteStar2.default,{type:this.props.type,id:this.props.id}),_react2.default.createElement('button',{className:'favourites-item-toggle f-i-t '+(isOpenedLeague?'f-i-t-a':'')},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('button',{title:data.name,onClick:this.selectItem,className:'league-item-a'},_react2.default.createElement('div',{className:'favourites-item-load-label'},data.name)),isOpenedLeague&&_react2.default.createElement('div',{className:'favourites-game-wrapper'},data.games.map(function(o){return _react2.default.createElement(_liveMenuGame2.default,{key:o,id:o,type:3});})));}}]);return LiveMenuLeague;}(_react.Component),_class2.contextTypes={sportId:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},_class2.childContextTypes={leagueId:_propTypes2.default.number},_temp))||_class)||_class)||_class);exports.default=LiveMenuLeague;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _liveMenuSport=__webpack_require__(154);var _liveMenuSport2=_interopRequireDefault(_liveMenuSport);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuOther=(_dec=(0,_mobxReact.inject)('lineStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LiveMenuOther,_Component);function LiveMenuOther(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LiveMenuOther);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LiveMenuOther.__proto__||Object.getPrototypeOf(LiveMenuOther)).call.apply(_ref,[this].concat(args))),_this),_this.getCount=function(){var count=0;_this.props.lineStore.menu.other.forEach(function(i){var arrLeague=_this.props.lineStore.menu.sport.get(i).league;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=arrLeague[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var id=_step.value;if(_this.props.lineStore.menu.league.has(id)){count+=_this.props.lineStore.menu.league.get(id).games.length;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}});return count;},_this.selectItem=function(){_this.props.history.push('/'+_this.props.lineStore.mode+'/other');},_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(null,5);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LiveMenuOther,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,other=_props$lineStore$menu.other,isOpen=_props$lineStore$menu.isOpen;if(!other||other&&other.length===0){return null;}var isOpenedOther=isOpen.other;return _react2.default.createElement('div',{className:'favourites-other-sport-item',title:'\u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435'},_react2.default.createElement('button',{className:'favourites-sport-item-toggle '+(isOpenedOther?'f-i-t-a':''),onClick:this.toggle},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('button',{className:'favourites-item-load favourites-other-sport-item-toggle f-i-l s-g-other',onClick:this.selectItem},_react2.default.createElement('span',{className:'line-sport-menu-item-ico f-s-ico-other'}),_react2.default.createElement(_liveMenuCounter2.default,{count:this.getCount()}),_react2.default.createElement('div',{className:'favourites-item-load-label'},'\u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435')),isOpenedOther&&_react2.default.createElement('div',{className:'line-other-menu-item-sport-list'},other.map(function(id){return _react2.default.createElement(_liveMenuSport2.default,{key:id,id:id,type:1});})));}}]);return LiveMenuOther;}(_react.Component))||_class)||_class)||_class);exports.default=LiveMenuOther;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);var _liveMenuGame=__webpack_require__(155);var _liveMenuGame2=_interopRequireDefault(_liveMenuGame);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuFavourites=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LiveMenuFavourites,_Component);function LiveMenuFavourites(props){_classCallCheck(this,LiveMenuFavourites);var _this=_possibleConstructorReturn(this,(LiveMenuFavourites.__proto__||Object.getPrototypeOf(LiveMenuFavourites)).call(this,props));_this.selectItem=function(){if(_this.props.lineStore.matchesList.matches.hasFavorite()||_this.props.lineStore.menu.favourites.games.length>0||_this.props.lineStore.menu.favourites.popular.pop.length>0){// this.props.lineStore.menu.selectItem('fav', 0);
_this.props.history.push('/'+_this.props.lineStore.mode+'/favourites');}};_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(null,0);};return _this;}_createClass(LiveMenuFavourites,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,favourites=_props$lineStore$menu.favourites,isOpen=_props$lineStore$menu.isOpen,selected=_props$lineStore$menu.selected,mode=_props$lineStore$menu.mode,countFav=_props$lineStore$menu.countFav;var shortMenu=this.props.lineStore.shortMenu;var classNames=(0,_classnames2.default)(['favourites-sport-item',{'favourites-menu-item_active':selected.fav},{'on':!isOpen.favourites}]);return _react2.default.createElement('div',{className:'favourites-menu-cont'},_react2.default.createElement('div',{className:classNames},_react2.default.createElement(_favouriteStar2.default,{type:0,id:'fav',disabled:shortMenu}),Boolean(favourites.games.length)&&mode==='live'&&_react2.default.createElement('button',{className:'favourites-sport-item-toggle '+(!isOpen?'f-i-t-a':''),onClick:this.toggle},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('button',{className:'favourites-sport-item-a',onClick:this.selectItem},_react2.default.createElement(_liveMenuCounter2.default,{count:countFav}),_react2.default.createElement('div',{className:'favourites-item-load-label'},'\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435')),isOpen.favourites&&mode==='live'&&_react2.default.createElement('div',{className:'favourites-league-wrapper'},favourites.games.map(function(o){return _react2.default.createElement(_liveMenuGame2.default,{id:o,key:o,type:3});}))));}}]);return LiveMenuFavourites;}(_react.Component))||_class)||_class)||_class);exports.default=LiveMenuFavourites;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);var _liveMenuItemPopular=__webpack_require__(348);var _liveMenuItemPopular2=_interopRequireDefault(_liveMenuItemPopular);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuPopular=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LiveMenuPopular,_Component);function LiveMenuPopular(props){_classCallCheck(this,LiveMenuPopular);var _this=_possibleConstructorReturn(this,(LiveMenuPopular.__proto__||Object.getPrototypeOf(LiveMenuPopular)).call(this,props));_this.selectItem=function(){if(_this.props.lineStore.menu.popular.order.length>0){// this.props.lineStore.menu.selectItem('pop', 4);
_this.props.history.push('/'+_this.props.lineStore.mode+'/popular');}};_this.toggle=function(){_this.props.lineStore.menu.toggleOpenItem(null,4);};return _this;}_createClass(LiveMenuPopular,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,popular=_props$lineStore$menu.popular,isOpen=_props$lineStore$menu.isOpen;var isOpened=isOpen.popular;return _react2.default.createElement('div',{className:'line-left-column-popular-cont'},_react2.default.createElement('div',{className:'line-popular-cont'},_react2.default.createElement('div',{className:'favourites-sport-item'},Boolean(popular.count)&&_react2.default.createElement('button',{className:'favourites-sport-item-toggle '+(isOpened?'f-i-t-a':''),onClick:this.toggle},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'}))),_react2.default.createElement('button',{className:'favourites-item-load line-popular-load s-g-popular',onClick:this.selectItem},_react2.default.createElement('span',{className:'line-sport-menu-item-ico f-s-ico-popular'}),_react2.default.createElement(_liveMenuCounter2.default,{count:popular.count}),_react2.default.createElement('div',{className:'favourites-item-load-label'},'\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0435')),isOpened&&_react2.default.createElement('div',{className:'line-popular-data'},popular.order.map(function(o){return _react2.default.createElement(_liveMenuItemPopular2.default,{key:o,id:o,type:5});})))));}}]);return LiveMenuPopular;}(_react.Component))||_class)||_class)||_class);exports.default=LiveMenuPopular;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _IconSport=__webpack_require__(349);var _IconSport2=_interopRequireDefault(_IconSport);var _MarginInfo=__webpack_require__(351);var _MarginInfo2=_interopRequireDefault(_MarginInfo);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveMenuItemPopular=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(LiveMenuItemPopular,_Component);function LiveMenuItemPopular(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LiveMenuItemPopular);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LiveMenuItemPopular.__proto__||Object.getPrototypeOf(LiveMenuItemPopular)).call.apply(_ref,[this].concat(args))),_this),_this.selectItem=function(evt){// const {sport_id, league} = this.props.lineStore.menu.popular.items[this.props.id];
_this.props.history.push('/'+_this.props.lineStore.menu.mode+'/popular/'+_this.props.id);// this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
evt.preventDefault();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LiveMenuItemPopular,[{key:'render',value:function render(){var _props$lineStore$menu=this.props.lineStore.menu.popular.items[this.props.id],sport=_props$lineStore$menu.sport,id=_props$lineStore$menu.id,games_count=_props$lineStore$menu.games_count,increased_odds=_props$lineStore$menu.increased_odds;var dict=this.props.lineStore.menu.dict;var label='popular'in dict&&id in dict.popular?dict.popular[id]:'';return _react2.default.createElement('div',{className:'line-popular-group-item'},_react2.default.createElement(_favouriteStar2.default,{type:4,id:id}),increased_odds?_react2.default.createElement('button',{title:label,className:'line-popular-item-load l-p-i-l',onClick:this.selectItem},_react2.default.createElement(_IconSport2.default,{sportId:'margin'}),_react2.default.createElement('div',{className:'favourites-item-load-label'},label),_react2.default.createElement(_MarginInfo2.default,null),_react2.default.createElement(_liveMenuCounter2.default,{count:games_count})):_react2.default.createElement('button',{title:label,className:'line-popular-item-load l-p-i-l',onClick:this.selectItem},_react2.default.createElement(_IconSport2.default,{sportId:sport[0]}),_react2.default.createElement('div',{className:'favourites-item-load-label'},label),_react2.default.createElement(_liveMenuCounter2.default,{count:games_count})));}}]);return LiveMenuItemPopular;}(_react.Component))||_class)||_class)||_class);exports.default=LiveMenuItemPopular;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(350);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(_ref){var sportId=_ref.sportId;return _react2.default.createElement('span',{className:'line-sport-menu-item-ico f-s-ico-'+sportId+' LiveMenu-IconSport'});};

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactTooltip=__webpack_require__(87);var _reactTooltip2=_interopRequireDefault(_reactTooltip);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_mobxReact.inject)('dictStore')((0,_mobxReact.observer)(function(_ref){var getLang=_ref.dictStore.getLang;return _react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement('div',{className:'margin-info','data-for':'tooltip_margin','data-tip':'','data-event':'mouseenter click'},_react2.default.createElement('span',{className:'f-s-ico-info'})),_react2.default.createElement(_reactTooltip2.default,{globalEventOff:'click',eventOff:'mouseleave',place:'right',type:'dark',effect:'solid',id:'tooltip_margin'},_react2.default.createElement('span',null,getLang('EVENTS_WITH_MAXIMUM_COEFFICIENTS_WITHOUT_BOOKMAKER_PROFIT'))));}));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__(353);
/* unused harmony reexport v1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__(354);
/* unused harmony reexport v3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__(357);
/* unused harmony reexport v5 */





/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__(88);

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(b);
}

/* unused harmony default export */ var _unused_webpack_default_export = (v1);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(355);


var v3 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v3);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var i;
  var x;
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  var hex;

  for (i = 0; i < length32; i += 8) {
    x = input[i >> 5] >>> i % 32 & 0xff;
    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__(88);



function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(358);


var v5 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v5);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var i = 0; i < N; i++) {
    M[i] = new Array(16);

    for (var j = 0; j < 16; j++) {
      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var i = 0; i < N; i++) {
    var W = new Array(80);

    for (var t = 0; t < 16; t++) {
      W[t] = M[i][t];
    }

    for (var t = 16; t < 80; t++) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var t = 0; t < 80; t++) {
      var s = Math.floor(t / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Schedule=(_dec=(0,_mobxReact.inject)('lineStore','routingStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Schedule,_Component);function Schedule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Schedule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Schedule.__proto__||Object.getPrototypeOf(Schedule)).call.apply(_ref,[this].concat(args))),_this),_this.selectItem=function(){_this.props.history.push('/'+_this.props.lineStore.menu.mode+'/schedule');// this.props.lineStore.toggleSchedule(true);
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Schedule,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'live-schedule-show-cont'});}}]);return Schedule;}(_react.Component))||_class)||_class)||_class);exports.default=Schedule;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _liveMenuCounter=__webpack_require__(41);var _liveMenuCounter2=_interopRequireDefault(_liveMenuCounter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WithVideo=(_dec=(0,_mobxReact.inject)('lineStore','dictStore','appStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(WithVideo,_Component);function WithVideo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WithVideo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WithVideo.__proto__||Object.getPrototypeOf(WithVideo)).call.apply(_ref,[this].concat(args))),_this),_this.selectItem=function(){if(_this.props.lineStore.menu.video.games.length>0){_this.props.history.push('/'+_this.props.mode+'/video');}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WithVideo,[{key:'render',// toggle = () => {
//   this.props.lineStore.menu[this.props.mode].toggleOpenItem(null, 6);
// };
value:function render(){var _props$lineStore$menu=this.props.lineStore.menu,video=_props$lineStore$menu.video,selected=_props$lineStore$menu.selected;var isSelected=selected.video;var getLang=this.props.dictStore.getLang;if(!video.count)return false;return _react2.default.createElement('div',{className:'line-left-column-popular-cont'+(isSelected?' line-left-column-popular-cont_active':'')},_react2.default.createElement('div',{className:'line-popular-cont'},_react2.default.createElement('div',{className:'favourites-sport-item '+(isSelected?'favourites-item_active':'')},_react2.default.createElement('div',{className:'line-popular-cont__inner'},_react2.default.createElement('button',{className:'favourites-item-load line-popular-load s-g-popular',onClick:this.selectItem},_react2.default.createElement('span',{className:'line-sport-menu-item-ico f-s-ico-video'}),_react2.default.createElement(_liveMenuCounter2.default,{count:video.count}),_react2.default.createElement('div',{className:'favourites-item-load-label'},getLang('ONLY_WITH_VIDEO')))))));}}]);return WithVideo;}(_react.Component))||_class)||_class)||_class);exports.default=WithVideo;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _lineSegment=__webpack_require__(362);var _lineSegment2=_interopRequireDefault(_lineSegment);var _reactInfiniteScroller=__webpack_require__(426);var _reactInfiniteScroller2=_interopRequireDefault(_reactInfiniteScroller);var _List=__webpack_require__(428);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Line=(_dec=(0,_mobxReact.inject)('lineStore','igStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Line,_Component);function Line(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Line);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Line.__proto__||Object.getPrototypeOf(Line)).call.apply(_ref,[this].concat(args))),_this),_this.update=function(){_this.setState({upd:Date.now()});},_this.onVideoClick=function(data){_this.props.igStore.setGame(data,'video');},_this.onInfographicsClick=function(data){_this.props.igStore.setGame(data,'events');},_this.isVideoPlaying=function(matchID){return _this.props.igStore.video.playing&&_this.props.igStore.video.gid===matchID;},_this.isCoefChoosen=function(matchID,betID,oddID){var isCfChoosen=_this.props.lineStore.basket.basketData.oddsIds.has(oddID);return isCfChoosen;},_this.renderSegment=function(){var lineStore=_this.props.lineStore;if(lineStore.matchesList.getData()&&_this.props.lineStore.line.mode==='live'){var basket=_this.props.lineStore.basket;return _react2.default.createElement(_List.MatchesList,{matchesListStore:lineStore.matchesList,toLocale:window.getLang,mode:_this.props.lineStore.line.mode,matchHandlers:{onInfographicsClick:_this.onInfographicsClick,isVideoPlaying:_this.isVideoPlaying,isCoefChoosen:_this.isCoefChoosen,onCoefChoose:basket.newAddOdd.bind(basket),onVideoClick:_this.onVideoClick},matchCommonProps:{outcomes:lineStore.matchesList.outcomes,columnCount:lineStore.line.colCount,width:lineStore.matchesList.width,displayGamesNumber:true,highlightChanges:true,isIrm:true}});}var _this$props$lineStore=_this.props.lineStore.line,lineSport=_this$props$lineStore.lineSport,mode=_this$props$lineStore.mode;return lineSport.map(function(item){return _react2.default.createElement(_lineSegment2.default,{key:item.id,id:item.id,name:item.name,league:item.league,mode:mode,ref:function ref(LineSegment){_this['segment_'+item.id]=LineSegment;}});});},_this.loadMore=function(pages){_this.props.lineStore.line.loadMore();},_this.setupVisibleSegmentsCaption=function(){// console.log(this.lineContainer.current.offsetHeight , 'container');
// console.log('scroll');
//   var scrollCtrl = this.refs['lineContainer'];
//   var scrollHtml = DOM.findDOMNode(scrollCtrl);
//   var codes = this.segmentCodes();
//   for (var i = 0; i < codes.length; i++) {
//       var segmentCtrl = this.refs['segment' + codes[i]];
//       var segmentHtml = DOM.findDOMNode(segmentCtrl);
//       var segmentTopVisual = segmentHtml.offsetTop - scrollHtml.scrollTop;
//       if (segmentTopVisual >= -5) {
//           if (this.oldTopSegmentId != codes[i]) {
//               var oldCtrl = this.refs['segment' + this.oldTopSegmentId];
//               var oldHtml = DOM.findDOMNode(oldCtrl);
//               if (oldHtml)
//                   oldHtml.classList.remove('_type_force_captions');
//               segmentHtml.classList.add('_type_force_captions');
//               this.oldTopSegmentId = codes[i];
//           }
//           break;
//       }
//   }
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Line,[{key:'componentDidMount',value:function componentDidMount(){this.props.lineStore.matchesList.subscribe(this.update);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.lineStore.matchesList.unsubscribe(this.update);}},{key:'componentDidUpdate',value:function componentDidUpdate(){// this.props.lineStore.line.setDivmainScroll();
}},{key:'render',// onLineScroll = (e) => {
//     this.setupVisibleSegmentsCaption();
// };
value:function render(){var _props$lineStore$line=this.props.lineStore.line,lineSport=_props$lineStore$line.lineSport,isLoading=_props$lineStore$line.isLoading,mode=_props$lineStore$line.mode,hasMore=_props$lineStore$line.hasMore;// const {basketPosition} = this.props.accountStore.accountSettings;
var noData=lineSport.length===0&&this.props.lineStore.matchesList.getData()===null;var isWSSLoading=this.props.lineStore.matchesList.isLoading;if(isWSSLoading){return _react2.default.createElement(_loadingSpinner2.default,null);}return _react2.default.createElement(_react.Fragment,null,mode==='live'?_react2.default.createElement(Header,null):null,noData&&!isLoading&&!isWSSLoading&&_react2.default.createElement('div',{className:'divmain'},_react2.default.createElement('div',{className:'no-events'},'\u041D\u0435\u0442 \u0441\u043E\u0431\u044B\u0442\u0438\u0439')),!noData&&mode==='line'&&_react2.default.createElement(_reactInfiniteScroller2.default,{threshold:500,pageStart:0,loadMore:this.loadMore,hasMore:hasMore,loader:_react2.default.createElement('div',{className:'load-page-line-link',key:0},'\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 ...'),useWindow:false},_react2.default.createElement('div',{className:mode=='live'?'divmain':'',id:'divmain'},this.renderSegment())),!noData&&mode==='live'&&_react2.default.createElement('div',{className:mode=='live'?'divmain':'',id:'divmain'},' ',this.renderSegment(),' '));}}]);return Line;}(_react.Component))||_class)||_class);exports.default=Line;var Header=function Header(){return _react2.default.createElement('div',{className:'divmain-head',id:'divmain-head'},_react2.default.createElement('table',{className:'l-t'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',{className:'h-tr'},_react2.default.createElement('th',{className:'g-descr-td',colSpan:'4'},'\u0421\u043E\u0431\u044B\u0442\u0438\u0435'),_react2.default.createElement('th',{className:'cf'},'\u041F1'),_react2.default.createElement('th',{className:'cf'},'\u0425'),_react2.default.createElement('th',{className:'cf'},'\u041F2'),_react2.default.createElement('th',{className:'cf'},'1\u0425'),_react2.default.createElement('th',{className:'cf'},'12'),_react2.default.createElement('th',{className:'cf'},'\u04252'),_react2.default.createElement('th',{className:'cf'},'\u04241'),_react2.default.createElement('th',{className:'cf'},'\u041A1'),_react2.default.createElement('th',{className:'cf'},'\u04242'),_react2.default.createElement('th',{className:'cf'},'\u041A2'),_react2.default.createElement('th',{className:'cf'},'\u041C\u0435\u043D'),_react2.default.createElement('th',{className:'cf'},'\u0422\u043E\u0442'),_react2.default.createElement('th',{className:'cf'},'\u0411\u043E\u043B'),_react2.default.createElement('th',{className:'cf'},'\u0420\u043E\u0441')))));};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lineTable=__webpack_require__(363);var _lineTable2=_interopRequireDefault(_lineTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LineSegment=function LineSegment(props){return _react2.default.createElement(_react.Fragment,null,props.league.map(function(item){return _react2.default.createElement(_lineTable2.default,{key:item,sportName:props.name,id:item});}));};// import { inject, observer } from 'mobx-react';
exports.default=LineSegment;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _dec,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _lineTableEvent=__webpack_require__(364);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineTableItem=function(_Component){_inherits(LineTableItem,_Component);function LineTableItem(){_classCallCheck(this,LineTableItem);return _possibleConstructorReturn(this,(LineTableItem.__proto__||Object.getPrototypeOf(LineTableItem)).apply(this,arguments));}_createClass(LineTableItem,[{key:'render',// shouldComponentUpdate(nextProps) {
//   return (this.props.games.length != nextProps.games.length);
// }
value:function render(){var _this2=this;return this.props.games.map(function(item,id){return _react2.default.createElement(_lineTableEvent.LineTableEvent,{key:id,id:item,idx:id,lg:_this2.props.games.length});});}}]);return LineTableItem;}(_react.Component);var LeagueHead=function(_Component2){_inherits(LeagueHead,_Component2);function LeagueHead(){_classCallCheck(this,LeagueHead);return _possibleConstructorReturn(this,(LeagueHead.__proto__||Object.getPrototypeOf(LeagueHead)).apply(this,arguments));}_createClass(LeagueHead,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(this.props.status!=nextProps.status||this.props.r!=nextProps.r){return true;}return false;}},{key:'render',value:function render(){var _props=this.props,mode=_props.mode,status=_props.status,r=_props.r,toogleShow=_props.toogleShow,toogleShowItems=_props.toogleShowItems,name=_props.name;return _react2.default.createElement('tr',{className:'l-tr l-t-tr-1'},_react2.default.createElement('th',{className:'l-td l-td-s-'+this.props.sportID+' l-s-r-'+this.props.sportID,colSpan:20},_react2.default.createElement('div',{className:'l-td-line'},_react2.default.createElement(_favouriteStar2.default,{type:2,id:this.props.id}),_react2.default.createElement('div',{className:'l-d l-d-line'},!status&&!!r&&mode=='line'&&_react2.default.createElement('div',{className:'l-t-a-i',onClick:toogleShow,title:'\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0440\u043E\u0441\u043F\u0438\u0441\u0438'},_react2.default.createElement('div',{className:'l-t-a-i-i'},_react2.default.createElement('span',{className:'f-s-ico-lines_open'}))),_react2.default.createElement('div',{className:'l-t-i-i '+(status?'l-t-i-i-a':''),onClick:toogleShowItems},_react2.default.createElement('div',{className:'l-t-i-i-i'},_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'})))),_react2.default.createElement('a',{className:'l-th-name'},' ',this.props.sportName+'. '+name,' '))));}}]);return LeagueHead;}(_react.Component);var LineTable=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component3){_inherits(LineTable,_Component3);function LineTable(props){_classCallCheck(this,LineTable);var _this4=_possibleConstructorReturn(this,(LineTable.__proto__||Object.getPrototypeOf(LineTable)).call(this,props));_this4.handleShowItems=function(){_this4.props.lineStore.line.toogleShowTableItems(_this4.props.id);};_this4.handleShowDop=function(evt){evt.stopPropagation();_this4.props.lineStore.line.toogleShowDop(_this4.props.id,0);};return _this4;}_createClass(LineTable,[{key:'render',value:function render(){var _this5=this;var _props2=this.props,id=_props2.id,style=_props2.style,lineStore=_props2.lineStore;if(!this.props.lineStore.line.lineLeague.has(id))return null;var _lineStore$line$lineL=lineStore.line.lineLeague.get(id),name=_lineStore$line$lineL.name,r=_lineStore$line$lineL.r,show=_lineStore$line$lineL.show,games=_lineStore$line$lineL.games,sid=_lineStore$line$lineL.sid;return _react2.default.createElement('table',{className:'l-t',id:'segment_'+id,style:style},_react2.default.createElement('tbody',null,_react2.default.createElement(LeagueHead,{toogleShow:this.handleShowDop,id:id,sportID:sid,sportName:this.props.sportName,toogleShowItems:function toogleShowItems(){return _this5.handleShowItems();},name:name,r:r,status:show,mode:this.props.lineStore.line.mode}),!show?_react2.default.createElement(LineTableItem,{games:games}):null));}}]);return LineTable;}(_react.Component))||_class)||_class);exports.default=LineTable;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FirstLineDop=exports.LineTableEvent=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class4,_dec4,_class7,_dec5,_class9;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(5);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _lineTableDop=__webpack_require__(365);var _lineTableDop2=_interopRequireDefault(_lineTableDop);var _favouriteStar=__webpack_require__(35);var _favouriteStar2=_interopRequireDefault(_favouriteStar);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NumberGames=(_dec=(0,_mobxReact.inject)('accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(NumberGames,_Component);function NumberGames(){_classCallCheck(this,NumberGames);return _possibleConstructorReturn(this,(NumberGames.__proto__||Object.getPrototypeOf(NumberGames)).apply(this,arguments));}_createClass(NumberGames,[{key:'render',value:function render(){if(!this.props.accountStore.accountSettings.gamesNumber&&this.props.mode)return null;return _react2.default.createElement('div',{className:'g-n',dangerouslySetInnerHTML:{__html:'#'+this.props.number}});}}]);return NumberGames;}(_react.Component))||_class)||_class);var Toogle=(_dec2=(0,_mobxReact.inject)('accountStore','lineStore','dictStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(Toogle,_Component2);function Toogle(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,Toogle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=Toogle.__proto__||Object.getPrototypeOf(Toogle)).call.apply(_ref,[this].concat(args))),_this2),_this2.state={showTooltip:_this2.props.showTooltip},_this2.tooltipRef=_react2.default.createRef(),_this2.handleClickOutside=function(e){if(e.path&&!e.path.includes(_this2.tooltipRef.current)){_this2.handleClose();}},_this2.handleClose=function(){document.removeEventListener('click',_this2.handleClickOutside,false);_this2.setState({showTooltip:false});},_this2.rossToogle=function(){_this2.props.lineStore.line.toogleShowDop(_this2.props.id,1);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(Toogle,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.showTooltip){document.addEventListener('click',this.handleClickOutside,false);this.props.accountStore.toggleAccountSettings('tooltip_union_stat_match',1);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.showTooltip&&document.removeEventListener('click',this.handleClickOutside,false);}},{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$lineStore$line=this.props.lineStore.line.lineGames.get(this.props.id),sr=_props$lineStore$line.sr,ross=_props$lineStore$line.ross,ross_stats_count=_props$lineStore$line.ross_stats_count;var rossForView=Number(ross)+Number(ross_stats_count);if(rossForView===0||Number.isNaN(rossForView)){return null;}return _react2.default.createElement(_react2.default.Fragment,null,this.state.showTooltip&&_react2.default.createElement('div',{className:'tooltip_union_stat_match',ref:this.tooltipRef},_react2.default.createElement('div',{className:'tooltip_union_stat_match_title'},getLang('ALL_BETS_IN_A_PLACE')),_react2.default.createElement('div',{className:'tooltip_union_stat_match_content'},getLang('WE_GROUP_BET_WITH_STATISTICS')),_react2.default.createElement('div',{className:'rectangle'}),_react2.default.createElement('div',{className:'close',onClick:this.handleClose})),_react2.default.createElement('span',{className:'g-t-a',onClick:this.rossToogle},(sr?'-':'+')+rossForView));}}]);return Toogle;}(_react.Component))||_class2)||_class2);var Score=function Score(_ref2){var text=_ref2.text;return text?_react2.default.createElement('div',{className:'g-score',dangerouslySetInnerHTML:{__html:text}}):null;};var Bet=(_dec3=(0,_mobxReact.inject)('lineStore','accountStore'),_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Bet,_Component3);function Bet(){var _ref3;var _temp2,_this3,_ret2;_classCallCheck(this,Bet);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref3=Bet.__proto__||Object.getPrototypeOf(Bet)).call.apply(_ref3,[this].concat(args))),_this3),_this3.animate=function(a){if(_this3.cell){_this3.cell.classList.add(a);setTimeout(function(){if(_this3.cell)_this3.cell.classList.remove('b-green','b-orange');},2500);}},_this3.doBet=function(){var mode=_this3.props.lineStore.line.mode;if(mode==='line'){localStorage.setItem('lastAction',1);}else{localStorage.setItem('lastAction',0);}_this3.props.lineStore.basket.newAddOdd(_this3.props.oddKey,_this3.props.gid);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(Bet,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.type=='cf'&&prevProps.cf&&this.props.accountStore.accountSettings.highlightChangesLive&&this.props.lineStore.mode=='live'){if(prevProps.cf!=this.props.cf){prevProps.cf<this.props.cf?this.animate('b-green'):this.animate('b-orange');}}}},{key:'render',value:function render(){var _this4=this;var _props=this.props,type=_props.type,cf=_props.cf,status=_props.status,gid=_props.gid,id=_props.id,oddKey=_props.oddKey;var select=0;// if(this.props.lineStore.basket.odds.has(gid))  console.log(this.props.lineStore.basket.odds.get(gid).id, id);
if(this.props.lineStore.basket.basketData.oddsIds.has(oddKey)){select=1;};if(type=='cf'){return!status?_react2.default.createElement('td',{className:type,ref:function ref(el){_this4.cell=el;}},_react2.default.createElement('a',{className:'g-b '+(select?'g-b-s':''),onClick:this.doBet,dangerouslySetInnerHTML:{__html:(0,_common.numberFormat)(cf,2,',',' ')}})):_react2.default.createElement('td',{className:type},_react2.default.createElement('span',{className:'g-b-b',dangerouslySetInnerHTML:{__html:(0,_common.numberFormat)(cf,2,',',' ')}}));}else{return _react2.default.createElement('td',{className:'cf',dangerouslySetInnerHTML:{__html:cf}});}}}]);return Bet;}(_react.Component))||_class4)||_class4);var DopItems=function DopItems(_ref4){var id=_ref4.id;return[_react2.default.createElement(FirstLineDop,{key:'FirstLineDop_'+id,id:id}),_react2.default.createElement(_lineTableDop2.default,{key:'TableDop_'+id,id:id})];};var HeaderItem=function HeaderItem(_ref5){var item=_ref5.item;return _react2.default.createElement('th',{className:'line-table__col'},_react2.default.createElement('div',{className:'line-table__col-inner'},item.n));};var Header=function(_Component4){_inherits(Header,_Component4);function Header(){var _ref6;var _temp3,_this5,_ret3;_classCallCheck(this,Header);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this5=_possibleConstructorReturn(this,(_ref6=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref6,[this].concat(args))),_this5),_this5.renderTh=function(){return _this5.props.header.map(function(item){return _react2.default.createElement(HeaderItem,{key:item.n,item:item});});},_temp3),_possibleConstructorReturn(_this5,_ret3);}_createClass(Header,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return this.props.header&&nextProps.header&&this.props.header.join('')!=nextProps.header.join('');}},{key:'render',value:function render(){return this.props.header?_react2.default.createElement('tr',{className:'l-t-h-tr-1 h-tr '},_react2.default.createElement('th',null,'\u0421\u043E\u0431\u044B\u0442\u0438\u0435'),this.renderTh(),_react2.default.createElement('th',{className:'l-t-a-td'})):null;}}]);return Header;}(_react.Component);var LoaderRoss=function LoaderRoss(){return _react2.default.createElement('tr',null,_react2.default.createElement('td',{colSpan:'21'},_react2.default.createElement('div',{className:'loader-ross'})));};var LineTableEvent=exports.LineTableEvent=(_dec4=(0,_mobxReact.inject)('accountStore','appStore','lineStore','igStore'),(0,_reactRouterDom.withRouter)(_class7=_dec4(_class7=(0,_mobxReact.observer)(_class7=function(_Component5){_inherits(LineTableEvent,_Component5);function LineTableEvent(){var _ref7;var _temp4,_this6,_ret4;_classCallCheck(this,LineTableEvent);for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return _ret4=(_temp4=(_this6=_possibleConstructorReturn(this,(_ref7=LineTableEvent.__proto__||Object.getPrototypeOf(LineTableEvent)).call.apply(_ref7,[this].concat(args))),_this6),_this6.renderBets=function(){var bets=_this6.props.lineStore.line.lineGames.get(_this6.props.id).f_l;return bets.map(function(item,idx){return _react2.default.createElement(Bet,{oddKey:item.oddKey,id:item.id,key:item.id+'_'+idx,cf:item.h,gid:_this6.props.id,type:item.t,status:item.st});});},_this6.handleSelect=function(){var mode=_this6.props.lineStore.line.mode;if(mode==='line'){localStorage.setItem('lastAction',1);}else{localStorage.setItem('lastAction',0);}_this6.props.history.push('/'+_this6.props.lineStore.line.mode+'/'+_this6.props.lineStore.line.lineGames.get(_this6.props.id).sid+'/'+_this6.props.lineStore.line.lineGames.get(_this6.props.id).lid+'/'+_this6.props.id);// this.props.lineStore.line.selectGame(this.props.id);
},_temp4),_possibleConstructorReturn(_this6,_ret4);}_createClass(LineTableEvent,[{key:'componentDidMount',value:function componentDidMount(){var _props$lineStore$line2=this.props.lineStore.line.selected,type=_props$lineStore$line2.type,games=_props$lineStore$line2.games;if(type===3){var game=this.props.lineStore.line.lineGames.get(this.props.id);this.props.igStore.setGame((0,_mobx.toJS)(game),null);}var gameId=(0,_common.getIdFromSlug)(this.props.match.params.games);var Match=this.props.lineStore.line.lineGames.get(Number(gameId));var isStatisticMatch=Match&&Match.parent_game_id;if(games.length===1&&isStatisticMatch){this.props.appStore.setNotificationVisibility('movingStatistics',true);}}},{key:'render',value:function render(){var _this7=this;var _props$lineStore$line3=this.props.lineStore.line.lineGames.get(this.props.id),id=_props$lineStore$line3.id,date=_props$lineStore$line3.date,c1=_props$lineStore$line3.c1,c2=_props$lineStore$line3.c2,ross=_props$lineStore$line3.ross,number=_props$lineStore$line3.number,lid=_props$lineStore$line3.lid,score=_props$lineStore$line3.score,sr=_props$lineStore$line3.sr,info=_props$lineStore$line3.info,hd=_props$lineStore$line3.hd,tv=_props$lineStore$line3.tv,video_type=_props$lineStore$line3.video_type,video=_props$lineStore$line3.video,stats=_props$lineStore$line3.stats;var _ref8=this.props.igStore.game||{},openTabGameScore=_ref8.score,openTabGameId=_ref8.id;// Если игра есть в WS, открыта текстовая трансляция игры и id игр из трансляции и лаива совпадают, то в лаиве показываем score из текстовой трансляции
var isGameNotWsAndIdExistAndEqual=openTabGameId===id;var preparedScore=isGameNotWsAndIdExistAndEqual?openTabGameScore:score;var count=this.props.lineStore.line.countSelectGames;var game=(0,_mobx.toJS)(this.props.lineStore.line.lineGames.get(this.props.id));var header=count==1?hd:this.props.lineStore.line.lineGames.get(this.props.lineStore.line.lineLeague.get(lid).games[0]).hd;var mode=this.props.lineStore.line.mode=='line';var loadedDop=this.props.lineStore.line.lineGamesDetails.has(this.props.id);var loadingRoss=this.props.lineStore.line.loadingRoss.find(function(v){return v==_this7.props.id;});var is_video=video_type&&video_type.length&&video_type[0];var videoPlaying=this.props.igStore.video.playing&&this.props.igStore.video.gid===id;return _react2.default.createElement(_react.Fragment,null,mode&&header&&(count==1||this.props.idx==0)?_react2.default.createElement(Header,{header:header}):null,_react2.default.createElement('tr',{className:'g-tr'},_react2.default.createElement('td',{className:'g-d-td'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement(NumberGames,{number:number,mode:mode}),_react2.default.createElement('div',{className:'g-f'},!mode?_react2.default.createElement(_favouriteStar2.default,{type:3,id:this.props.id}):''),_react2.default.createElement('div',{className:'g-date'},date),_react2.default.createElement('b',{className:'g-d '+(parseInt(ross)!==0?'g-d-s':''),onClick:parseInt(ross)?this.handleSelect:function(){}},_react2.default.createElement('span',null,c1,' ',c2?' - '+c2:'')),info?_react2.default.createElement('div',{className:'g-info'},info):'',tv?_react2.default.createElement(Tv,{data:tv}):'',is_video?video_type.map(function(type){return _react2.default.createElement('div',{key:''+type,className:'g-tv fl_r'},_react2.default.createElement('span',{className:'item-ico-video'+(videoPlaying?' item-ico-video-playing':'')+' item-ico-video-type-'+video[0].type,onClick:function onClick(){return _this7.props.igStore.setGame(game,'video');}}));}):null,stats?_react2.default.createElement('div',{className:'g-tv fl_r'},_react2.default.createElement('span',{className:'f-s-ico-infographics',onClick:function onClick(){return _this7.props.igStore.setGame(game,'events');}})):'',_react2.default.createElement(Score,{text:preparedScore}))),this.renderBets(),_react2.default.createElement('td',{className:'g-t-a-td'},parseInt(ross)?_react2.default.createElement(Toogle,{id:id,showTooltip:game.showTooltip&&this.props.accountStore.accountSettings.tooltip_union_stat_match===0}):null)),sr&&!loadingRoss?_react2.default.createElement(DopItems,{key:'dopItem_'+lid+'_'+this.props.id,id:this.props.id}):null,loadingRoss?_react2.default.createElement(LoaderRoss,null):null,mode&&sr&&this.props.idx+1!=this.props.lg&&loadedDop?_react2.default.createElement(Header,{header:header}):null);}}]);return LineTableEvent;}(_react.Component))||_class7)||_class7)||_class7);var FirstLineDop=exports.FirstLineDop=(_dec5=(0,_mobxReact.inject)('lineStore'),_dec5(_class9=(0,_mobxReact.observer)(_class9=function(_Component6){_inherits(FirstLineDop,_Component6);function FirstLineDop(){var _ref9;var _temp5,_this8,_ret5;_classCallCheck(this,FirstLineDop);for(var _len5=arguments.length,args=Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}return _ret5=(_temp5=(_this8=_possibleConstructorReturn(this,(_ref9=FirstLineDop.__proto__||Object.getPrototypeOf(FirstLineDop)).call.apply(_ref9,[this].concat(args))),_this8),_this8.renderBets=function(idx){var bets=_this8.props.lineStore.line.firstLine.get(_this8.props.id)[idx];return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('td',null,bets[0].h),bets.slice(1).map(function(item){return _react2.default.createElement(Bet,{oddKey:item.oddKey,key:item.id,cf:item.h,type:item.t,id:item.id,status:item.st,gid:_this8.props.id});}),_react2.default.createElement('td',null));},_this8.renderRow=function(){var result=[];var rows=_this8.props.lineStore.line.firstLine.get(_this8.props.id);rows.map(function(item,idx){result.push(_react2.default.createElement('tr',{className:'g-tr',key:idx},_this8.renderBets(idx)));});return result;},_temp5),_possibleConstructorReturn(_this8,_ret5);}_createClass(FirstLineDop,[{key:'render',value:function render(){var lineStore=this.props.lineStore.line;var firstBet=lineStore.firstLine.get(this.props.id);return firstBet?this.renderRow():null;}}]);return FirstLineDop;}(_react.Component))||_class9)||_class9);var Tv=function Tv(_ref10){var data=_ref10.data;return _react2.default.createElement('div',{className:'g-tv fl_r'},_react2.default.createElement('span',{className:'f-s-ico-tv'}),_react2.default.createElement('div',{className:'channels'},data.map(function(el,idx){return _react2.default.createElement('span',{key:el,className:'channel'},el);})));};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2,_dec2,_class3,_dec3,_class4,_dec4,_class5,_dec5,_class6,_dec6,_class7;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _mobx=__webpack_require__(5);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _lineTableFilter=__webpack_require__(366);var _lineTableFilter2=_interopRequireDefault(_lineTableFilter);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameId=_react2.default.createContext(0);var Td=(_dec=(0,_mobxReact.inject)('lineStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp2=_class2=function(_Component){_inherits(Td,_Component);function Td(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Td);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Td.__proto__||Object.getPrototypeOf(Td)).call.apply(_ref,[this].concat(args))),_this),_this.animate=function(a){if(_this.cell){// this.cell.classList.remove('b-green', 'b-orange');
_this.cell.classList.add(a);setTimeout(function(){if(_this.cell){_this.cell.classList.remove('b-green','b-orange');}},2500);}},_this.doBet=function(){var mode=_this.props.lineStore.line.mode;if(mode==='line'){localStorage.setItem('lastAction',1);}else{localStorage.setItem('lastAction',0);}_this.props.lineStore.basket.newAddOdd(_this.props.oddKey,_this.props.gid);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Td,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.type=='cf'&&prevProps.cf&&this.props.accountStore.accountSettings.highlightChangesLive&&this.props.lineStore.mode=='live'){if(prevProps.cf!=this.props.cf){prevProps.cf<this.props.cf?this.animate('b-green'):this.animate('b-orange');}}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,cf=_props.cf,status=_props.status,rws=_props.rws,id=_props.id,gid=_props.gid,width=_props.width,oddKey=_props.oddKey;var select=0;if(this.props.lineStore.basket.basketData.oddsIds.has(oddKey)){select=1;};if(type=='cf'){return!status?_react2.default.createElement('td',{style:{width:width+'%'},className:type,ref:function ref(el){_this2.cell=el;}},_react2.default.createElement('a',{className:'g-b '+(select?'g-b-s':''),onClick:this.doBet,dangerouslySetInnerHTML:{__html:(0,_common.numberFormat)(cf,2,',',' ')}})):_react2.default.createElement('td',{style:{width:width+'%'},className:type},_react2.default.createElement('span',{className:'g-b-b',dangerouslySetInnerHTML:{__html:(0,_common.numberFormat)(cf,2,',',' ')}}));}else{return _react2.default.createElement('td',{style:{width:width+'%'},rowSpan:rws,dangerouslySetInnerHTML:{__html:cf}});}}}]);return Td;}(_react.Component),_class2.contextTypes={gid:_propTypes2.default.number},_temp2))||_class)||_class);;var Tr=function Tr(_ref2){var data=_ref2.data;return _react2.default.createElement('tr',null,data.map(function(item,id){return _react2.default.createElement(GameId.Consumer,null,function(value){return _react2.default.createElement(Td,{oddKey:item.oddKey,key:item.id,id:item.id,rws:item.rws,type:item.t,cf:item.h,status:item.st,gid:value,width:item.w});});}));};var Tbody=function Tbody(_ref3){var data=_ref3.data;return _react2.default.createElement('tbody',null,data.ch.map(function(item,id){return _react2.default.createElement(Tr,{key:id,data:item.ch});}));};var Th=function Th(_ref4){var cls=_ref4.cls,h=_ref4.h,align=_ref4.align,width=_ref4.width;var clN='';if(align==='center'){clN='g-t-v-th-a-c';}else if(align==='right'){clN='g-t-v-th-a-r';}else if(align==='left'){clN='g-t-v-th-a-l';}return _react2.default.createElement('th',{className:clN,colSpan:cls,style:{width:width+'%'},title:h},h);};var Thead=function Thead(_ref5){var data=_ref5.data,id=_ref5.id;return _react2.default.createElement('thead',null,_react2.default.createElement('tr',null,data.map(function(item,idx){return _react2.default.createElement(Th,{key:''+id+item.h,cls:item.cls,h:item.h,width:item.w,align:item.align});})));};var Table=function Table(_ref6){var data=_ref6.data,show=_ref6.show,id=_ref6.id,gid=_ref6.gid;return _react2.default.createElement('div',{className:'g-t-v-d '+(!show?'hidden':''),id:'table_'+id},_react2.default.createElement('table',{className:'g-t-v'},data.ch.map(function(el){return el.header?_react2.default.createElement(Thead,{data:el.ch,key:'table_head_'+id+'_'+gid,id:id}):_react2.default.createElement(Tbody,{data:el,key:'table_body_'+id+'_'+gid});})));};var Tables=(_dec2=(0,_mobxReact.inject)('lineStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Tables,_Component2);function Tables(){_classCallCheck(this,Tables);return _possibleConstructorReturn(this,(Tables.__proto__||Object.getPrototypeOf(Tables)).apply(this,arguments));}_createClass(Tables,[{key:'render',value:function render(){var _props$lineStore=this.props.lineStore,mode=_props$lineStore.mode,line=_props$lineStore.line;var filterTables=line.filterTables,hideTables=line.hideTables,favTables=line.favTables,lineGames=line.lineGames;var show=1;var filter=filterTables.get(this.props.id);if(filter){if(filter.fav_select){var _lineGames$get=lineGames.get(this.props.id),sid=_lineGames$get.sid;show=favTables.get(sid).tids.indexOf(this.props.tid)!==-1?1:0;}else if((filter.filter[0]||{}).select!=1){var data=(0,_mobx.toJS)(filter.filter);var tidsArray=[];for(var i in data){if(data[i].select&&data[i].tids&&data[i].tids.length>0&&Array.isArray(data[i].tids)){tidsArray=tidsArray.concat(data[i].tids);}}if(!tidsArray.includes(this.props.tid)){show=0;}}}return _react2.default.createElement(GameId.Provider,{value:this.props.id},_react2.default.createElement(Table,{data:this.props.item.ch[0],show:show,id:this.props.item.data.id,gid:this.props.id}));}}]);return Tables;}(_react.Component))||_class3)||_class3);var TableDop=(_dec3=(0,_mobxReact.inject)('lineStore'),_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(TableDop,_Component3);function TableDop(){_classCallCheck(this,TableDop);return _possibleConstructorReturn(this,(TableDop.__proto__||Object.getPrototypeOf(TableDop)).apply(this,arguments));}_createClass(TableDop,[{key:'render',value:function render(){var lineStore=this.props.lineStore.line;var gameID=this.props.id;var statisticalGameID=lineStore.getActiveStatisticalCategoryID(gameID);var isStatisticalCategoryTablesLoading=lineStore.statisticalCategoriesLoading.includes(gameID);var hasStatistic=!!(lineStore.lineGames.get(gameID)||{}).statistical_ids;var other=lineStore.lineGamesOther.get(this.props.id);return _react2.default.createElement('tr',{className:'g-a-tr'},_react2.default.createElement('td',{colSpan:'21'},_react2.default.createElement(_lineTableFilter2.default,{id:gameID}),hasStatistic&&isStatisticalCategoryTablesLoading?null:_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(ColumnTables,{gid:statisticalGameID,count:lineStore.colCount}),other?_react2.default.createElement(Add,{data:other}):'')));}}]);return TableDop;}(_react.Component))||_class4)||_class4);exports.default=TableDop;var ColumnTables=(_dec4=(0,_mobxReact.inject)('lineStore','accountStore'),_dec4(_class5=(0,_mobxReact.observer)(_class5=function(_Component4){_inherits(ColumnTables,_Component4);function ColumnTables(){_classCallCheck(this,ColumnTables);return _possibleConstructorReturn(this,(ColumnTables.__proto__||Object.getPrototypeOf(ColumnTables)).apply(this,arguments));}_createClass(ColumnTables,[{key:'render',value:function render(){var lineStore=this.props.lineStore.line;/**
     * Если таблицы доп.исходов получили по ws,
     * возвращаем их, иначе - старый компонент
     */var _props2=this.props,count=_props2.count,gid=_props2.gid;var data=lineStore.lineGamesDetails.get(gid);if(!data){return null;}return data.order.map(function(item){return _react2.default.createElement('div',{className:'g-r-d-col g-r-d-col-'+count},item.map(function(id){return data.data[id]?_react2.default.createElement(Tables,{key:id+'_'+gid,id:gid,item:data.data[id],tid:id}):'';}));});}}]);return ColumnTables;}(_react.Component))||_class5)||_class5);var Add=(_dec5=(0,_mobxReact.inject)('dictStore'),_dec5(_class6=(0,_mobxReact.observer)(_class6=function(_Component5){_inherits(Add,_Component5);function Add(){_classCallCheck(this,Add);return _possibleConstructorReturn(this,(Add.__proto__||Object.getPrototypeOf(Add)).apply(this,arguments));}_createClass(Add,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var data=this.props.data;return _react2.default.createElement('div',{className:'g-a-other'},_react2.default.createElement('b',null,getLang('ADDITIONAL_BETS')),': ',' ',data.map(function(el){return _react2.default.createElement(Bet,{cf:el.cf,key:el.id,name:el.name,id:el.id,gid:el.gid,oddKey:el.oddKey});}));}}]);return Add;}(_react.Component))||_class6)||_class6);var Bet=(_dec6=(0,_mobxReact.inject)('lineStore','accountStore'),_dec6(_class7=(0,_mobxReact.observer)(_class7=function(_Component6){_inherits(Bet,_Component6);function Bet(){var _ref7;var _temp3,_this7,_ret2;_classCallCheck(this,Bet);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp3=(_this7=_possibleConstructorReturn(this,(_ref7=Bet.__proto__||Object.getPrototypeOf(Bet)).call.apply(_ref7,[this].concat(args))),_this7),_this7.animate=function(a){if(_this7.cell){_this7.cell.classList.add(a);setTimeout(function(){if(_this7.cell)_this7.cell.classList.remove('b-green','b-orange');},2500);}},_this7.doBet=function(){_this7.props.lineStore.basket.newAddOdd(_this7.props.oddKey,_this7.props.gid);},_temp3),_possibleConstructorReturn(_this7,_ret2);}_createClass(Bet,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.cf&&this.props.accountStore.accountSettings.highlightChangesLive&&this.props.lineStore.mode=='live'){if(prevProps.cf!=this.props.cf){prevProps.cf<this.props.cf?this.animate('b-green'):this.animate('b-orange');}}}},{key:'render',value:function render(){var _props3=this.props,name=_props3.name,cf=_props3.cf,gid=_props3.gid,id=_props3.id,oddKey=_props3.oddKey;var select=0;if(this.props.lineStore.basket.basketData.oddsIds.has(oddKey)){select=1;}return _react2.default.createElement(_react.Fragment,null,name,' -  ',_react2.default.createElement('a',{className:'g-b '+(select?'g-b-s':''),onClick:this.doBet,dangerouslySetInnerHTML:{__html:(0,_common.numberFormat)(cf,2,',',' ')}}),';',' ');}}]);return Bet;}(_react.Component))||_class7)||_class7);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _dec,_class,_dec2,_class3;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Outcomes=__webpack_require__(90);var Outcomes=_interopRequireWildcard(_Outcomes);var _additionalCategories=__webpack_require__(423);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=function(_PureComponent){_inherits(Item,_PureComponent);function Item(){_classCallCheck(this,Item);return _possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).apply(this,arguments));}_createClass(Item,[{key:'render',value:function render(){var _props=this.props,check=_props.check,name=_props.name,onClick=_props.onClick,count=_props.count;return _react2.default.createElement('div',{className:'g-a-c-i '+(check?'g-a-c-i-s':null)+' '+(count?'':'g-a-c-i-nh'),onClick:onClick},_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:name}}),count?_react2.default.createElement('span',{className:'g-a-c-i-t-c'},count):null);}}]);return Item;}(_react.PureComponent);var Filters=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Filters,_Component);function Filters(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,Filters);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=Filters.__proto__||Object.getPrototypeOf(Filters)).call.apply(_ref,[this].concat(args))),_this2),_this2.handleClick=function(id){_this2.props.lineStore.line.setfilterTable(_this2.props.statisticalGameID,id);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(Filters,[{key:'render',value:function render(){var _this3=this;var _props2=this.props,id=_props2.id,statisticalGameID=_props2.statisticalGameID,hasStatisticalCategories=_props2.hasStatisticalCategories,isActiveSecondaryStatisticalCategories=_props2.isActiveSecondaryStatisticalCategories;var _ref2=this.props.lineStore.line.filterTables.get(statisticalGameID)||{},filter=_ref2.filter,order=_ref2.order;if(!filter){return null;}var result=[];order.forEach(function(item){var _filter$item=filter[item],name=_filter$item.name,count=_filter$item.count,select=_filter$item.select;result.push(_react2.default.createElement(Item,{key:item,count:count,name:name,check:select,id:item,onClick:function onClick(){return _this3.handleClick(item);}}));});return _react2.default.createElement('div',{className:'g-a-c-cont'},hasStatisticalCategories&&_react2.default.createElement(_additionalCategories.PrimaryStatisticalCategories,{gameID:id}),this.props.lineStore.line.statisticalCategoriesLoading.includes(id)?_react2.default.createElement('div',{className:'loader-ross'}):isActiveSecondaryStatisticalCategories?_react2.default.createElement(_additionalCategories.SecondaryStatisticalCategories,{gameID:id}):result,_react2.default.createElement('div',{className:'g-a-t-c'}));}}]);return Filters;}(_react.Component))||_class)||_class);var TableDopFilter=(_dec2=(0,_mobxReact.inject)('lineStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(TableDopFilter,_Component2);function TableDopFilter(){var _ref3;var _temp2,_this4,_ret2;_classCallCheck(this,TableDopFilter);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref3=TableDopFilter.__proto__||Object.getPrototypeOf(TableDopFilter)).call.apply(_ref3,[this].concat(args))),_this4),_this4.handleUpdate=function(updatedGameID){var lineStore=_this4.props.lineStore.line;var statisticalCategoryID=lineStore.getActiveStatisticalCategoryID(_this4.props.id);if(updatedGameID&&updatedGameID!==''+statisticalCategoryID){return;}_this4.setState({upd:''+Date.now()});},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(TableDopFilter,[{key:'render',value:function render(){var lineStore=this.props.lineStore.line;var statisticalCategories=lineStore.statisticalCategories.get(this.props.id)||[];var statisticalGameID=lineStore.getActiveStatisticalCategoryID(this.props.id);var isActiveSecondaryCategories=(statisticalCategories.find(function(_ref4){var categories=_ref4.categories;return typeof categories!=='undefined';})||{}).isActive||false;return _react2.default.createElement(Filters,{id:this.props.id,statisticalGameID:statisticalGameID,hasStatisticalCategories:statisticalCategories.length>0,isActiveSecondaryStatisticalCategories:isActiveSecondaryCategories});}}]);return TableDopFilter;}(_react.Component))||_class3)||_class3);exports.default=TableDopFilter;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Categories=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Filter=__webpack_require__(368);var _Type=__webpack_require__(370);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Categories=exports.Categories=function Categories(props){return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_Type.CategoriesType,{sportID:props.sportID,statTypesData:props.statTypesData,onStatTypeSelect:props.onStatTypeSelect,toLocale:props.toLocale}),_react2.default.createElement(_Filter.CategoriesFilter,{categoriesData:props.categoriesData,onFoldAllTables:props.onFoldAllTables,isAllUnfolded:props.isAllUnfolded,onFavorite:props.onFavorite,onSelect:props.onSelect,toLocale:props.toLocale,sportID:props.sportID,matchID:props.matchID,width:props.width}));};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CategoriesFilter=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _UI=__webpack_require__(56);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Фильтр категории таблицы доп росписи
 */var CategoriesFilter=exports.CategoriesFilter=function CategoriesFilter(props){return _react2.default.createElement('div',{className:'g-a-c-cont clearfix'},props.categoriesData.map(function(_ref){var _ref2=_slicedToArray(_ref,2),categoryID=_ref2[0],state=_ref2[1];return _react2.default.createElement('div',{key:'category_'+categoryID,className:'g-a-c-i noselect '+(state.isSelected?'g-a-c-i-s':'')+' '+(state.isDisabled?'disabled':'')+' ',onClick:function onClick(){!state.isDisabled&&props.onSelect(state.matchId,[categoryID],!state.isSelected);}},props.onFavorite&&_react2.default.createElement(_UI.FavoriteStar,{isFavorite:!!state.isFavorite,onClick:function onClick(e){e.stopPropagation();props.onFavorite&&props.onFavorite([categoryID],!state.isFavorite);}}),_react2.default.createElement('span',null,props.toLocale(state.label||categoryID)),typeof state[props.width]!=='undefined'&&_react2.default.createElement('span',{className:'g-a-c-i-t-c'},state[props.width]));}),props.onFoldAllTables&&_react2.default.createElement('a',{className:'toogle-tables fl_r',onClick:function onClick(){props.onFoldAllTables&&props.onFoldAllTables(!props.isAllUnfolded);}},_react2.default.createElement('span',{className:'control-panel-text'},props.toLocale(props.isAllUnfolded?'COLLAPSE_ALL':'EXPAND_ALL'))));};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FavoriteStar=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FavoriteStar=exports.FavoriteStar=function FavoriteStar(_ref){var isFavorite=_ref.isFavorite,onClick=_ref.onClick;return _react2.default.createElement('a',{className:'f-s-ico-fav favourites-star'+(isFavorite?' on':''),onClick:onClick});};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CategoriesType=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CategoriesType=exports.CategoriesType=function CategoriesType(props){if(props.statTypesData.length===0){return null;}return _react2.default.createElement('div',{className:'line-base-filter'},_react2.default.createElement('div',{className:'line-base-filter-items'},props.statTypesData.map(function(state){return _react2.default.createElement('div',{key:state.name,onClick:function onClick(){!state.isDisabled&&props.onStatTypeSelect(state.matchId,state.name);},className:'line-base-filter-item '+(state.isSelected?'line-base-filter-item_active':'')+' '+(state.isDisabled?'disabled':'')},props.toLocale(state.name),!!state.count&&_react2.default.createElement('div',{className:'line-base-filter-item-count'},state.count));})));};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Tables=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lib=__webpack_require__(12);var _TBody=__webpack_require__(158);var _THead=__webpack_require__(407);var _UI=__webpack_require__(56);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}/**
 * Компонент таблицы доп росписи
 */var Tables=exports.Tables=function Tables(props){if(!props.data){return null;}var columns=(0,_lib.objectEntries)(props.data&&props.data.tables||{}).filter(function(_ref){var _ref2=_slicedToArray(_ref,2),table=_ref2[1];return table.isSelected&&table.isVisible;}).reduce(function(columns,table,index){var columnNumber=index%props.columnCount;columns[columnNumber]=columns[columnNumber].concat([table]);return columns;},Array.from({length:props.columnCount}).map(function(){return[];}));var getCoef=function getCoef(betID){return props.data&&props.data.coefs[betID]||{};};var getColumnStyle=(0,_react.useCallback)(function(columnWidths){return function(i){var row=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];if(row.length===columnWidths.length){return{width:columnWidths[i]+'%'};}/** В заголовках таблиц некоторые ячейки объединены, поэтому необходимо пересчитать пропорции */var proportions=row.map(function(_ref3){var cs=_ref3.cs;return cs||1;});if(proportions.every(function(p){return p===1;})){return{};}var width=Array.from(columnWidths);var headerWidth=proportions.map(function(v){return width.splice(0,v).reduce(function(p,c){return p+c;});});return{width:headerWidth[i]+'%'};};},[]);return _react2.default.createElement(_react.Fragment,null,columns.map(function(data,i){return _react2.default.createElement('div',{key:'column_'+i,className:'g-r-d-col g-r-d-col-'+props.columnCount},data.map(function(_ref4){var _ref5=_slicedToArray(_ref4,2),tableID=_ref5[0],_ref5$=_ref5[1],rows=_ref5$.rows,columnWidths=_ref5$.columnWidths,isFolded=_ref5$.isFolded,isFavorite=_ref5$.isFavorite;var _rows=_toArray(rows),header=_rows[0],content_rows=_rows.slice(1);return _react2.default.createElement('div',{className:'g-t-v-d',key:'table_'+tableID},props.onFavorite&&_react2.default.createElement('span',{className:'g-t-fav',onClick:function onClick(){props.onFavorite&&props.onFavorite(tableID,!isFavorite);}},_react2.default.createElement(_UI.FavoriteStar,{isFavorite:isFavorite})),_react2.default.createElement('span',{className:'g-t-ar '+(isFolded?'open':''),onClick:function onClick(){props.onFold(tableID,isFolded);}},_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'})),_react2.default.createElement('table',{className:'g-t-v'},_react2.default.createElement('thead',null,_react2.default.createElement(_THead.THead,{getColumnStyle:getColumnStyle(columnWidths),rows:header})),!isFolded&&_react2.default.createElement('tbody',null,_react2.default.createElement(_TBody.TBody,{highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,onCoefChoose:props.onCoefChoose,disabled:props.data!==null&&props.data.isDisabled,getColumnStyle:getColumnStyle(columnWidths),rows:content_rows,getCoef:getCoef}))));}));}));};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(160);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(160);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(29);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["f" /* createRule */])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(29);



var isObservable = function isObservable(value) {
  return value && value[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] && value === value[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]]();
};

var observablePlugin = function observablePlugin(updateOptions) {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (!isObservable(decl)) return null;
      var style$ = decl;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["f" /* createRule */])(name, {}, options); // TODO
      // Call `stream.subscribe()` returns a subscription, which should be explicitly
      // unsubscribed from when we know this sheet is no longer needed.

      style$.subscribe(function (style) {
        for (var prop in style) {
          rule.prop(prop, style[prop], updateOptions);
        }
      });
      return rule;
    },
    onProcessRule: function onProcessRule(rule) {
      if (rule && rule.type !== 'style') return;
      var styleRule = rule;
      var style = styleRule.style;

      var _loop = function _loop(prop) {
        var value = style[prop];
        if (!isObservable(value)) return "continue";
        delete style[prop];
        value.subscribe({
          next: function next(nextValue) {
            styleRule.prop(prop, nextValue, updateOptions);
          }
        });
      };

      for (var prop in style) {
        var _ret = _loop(prop);

        if (_ret === "continue") continue;
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (observablePlugin);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(383);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19), __webpack_require__(382)(module)))

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(24);


var semiWithNl = /;\n/;
/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */

var parse = function parse(cssText) {
  var style = {};
  var split = cssText.split(semiWithNl);

  for (var i = 0; i < split.length; i++) {
    var decl = (split[i] || '').trim();
    if (!decl) continue;
    var colonIndex = decl.indexOf(':');

    if (colonIndex === -1) {
       false ? warning(false, "[JSS] Malformed CSS string \"" + decl + "\"") : void 0;
      continue;
    }

    var prop = decl.substr(0, colonIndex).trim();
    var value = decl.substr(colonIndex + 1).trim();
    style[prop] = value;
  }

  return style;
};

var onProcessRule = function onProcessRule(rule) {
  if (typeof rule.style === 'string') {
    rule.style = parse(rule.style);
  }
};

function templatePlugin() {
  return {
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (templatePlugin);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(29);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" /* RuleList */](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(24);



var isObject = function isObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj);
};

var valueNs = "extendCurrValue" + Date.now();

function mergeExtend(style, rule, sheet, newStyle) {
  var extendType = typeof style.extend; // Extend using a rule name.

  if (extendType === 'string') {
    if (!sheet) return;
    var refRule = sheet.getRule(style.extend);
    if (!refRule) return;

    if (refRule === rule) {
       false ? warning(false, "[JSS] A rule tries to extend itself \n" + rule.toString()) : void 0;
      return;
    }

    var parent = refRule.options.parent;

    if (parent) {
      var originalStyle = parent.rules.raw[style.extend];
      extend(originalStyle, rule, sheet, newStyle);
    }

    return;
  } // Extend using an array.


  if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      var singleExtend = style.extend[index];
      var singleStyle = typeof singleExtend === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, {
        extend: singleExtend
      }) : style.extend[index];
      extend(singleStyle, rule, sheet, newStyle);
    }

    return;
  } // Extend is a style object.


  for (var prop in style.extend) {
    if (prop === 'extend') {
      extend(style.extend.extend, rule, sheet, newStyle);
      continue;
    }

    if (isObject(style.extend[prop])) {
      if (!(prop in newStyle)) newStyle[prop] = {};
      extend(style.extend[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    newStyle[prop] = style.extend[prop];
  }
}

function mergeRest(style, rule, sheet, newStyle) {
  // Copy base style.
  for (var prop in style) {
    if (prop === 'extend') continue;

    if (isObject(newStyle[prop]) && isObject(style[prop])) {
      extend(style[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    if (isObject(style[prop])) {
      newStyle[prop] = extend(style[prop], rule, sheet);
      continue;
    }

    newStyle[prop] = style[prop];
  }
}
/**
 * Recursively extend styles.
 */


function extend(style, rule, sheet, newStyle) {
  if (newStyle === void 0) {
    newStyle = {};
  }

  mergeExtend(style, rule, sheet, newStyle);
  mergeRest(style, rule, sheet, newStyle);
  return newStyle;
}
/**
 * Handle `extend` property.
 */


function jssExtend() {
  function onProcessStyle(style, rule, sheet) {
    if ('extend' in style) return extend(style, rule, sheet);
    return style;
  }

  function onChangeValue(value, prop, rule) {
    if (prop !== 'extend') return value; // Value is empty, remove properties set previously.

    if (value == null || value === false) {
      for (var key in rule[valueNs]) {
        rule.prop(key, null);
      }

      rule[valueNs] = null;
      return null;
    }

    if (typeof value === 'object') {
      for (var _key in value) {
        rule.prop(_key, value[_key]);
      }

      rule[valueNs] = value;
    } // Make sure we don't set the value in the core.


    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssExtend);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(24);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(24);


/**
 * Set selector.
 *
 * @param original rule
 * @param className class string
 * @return flag indicating function was successfull or not
 */

function registerClass(rule, className) {
  // Skip falsy values
  if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`

  if (Array.isArray(className)) {
    for (var index = 0; index < className.length; index++) {
      var isSetted = registerClass(rule, className[index]);
      if (!isSetted) return false;
    }

    return true;
  } // Support space separated class names `{composes: 'foo bar'}`


  if (className.indexOf(' ') > -1) {
    return registerClass(rule, className.split(' '));
  }

  var parent = rule.options.parent; // It is a ref to a local rule.

  if (className[0] === '$') {
    var refRule = parent.getRule(className.substr(1));

    if (!refRule) {
       false ? warning(false, "[JSS] Referenced rule is not defined. \n" + rule.toString()) : void 0;
      return false;
    }

    if (refRule === rule) {
       false ? warning(false, "[JSS] Cyclic composition detected. \n" + rule.toString()) : void 0;
      return false;
    }

    parent.classes[rule.key] += " " + parent.classes[refRule.key];
    return true;
  }

  parent.classes[rule.key] += " " + className;
  return true;
}
/**
 * Convert compose property to additional class, remove property from original styles.
 */


function jssCompose() {
  function onProcessStyle(style, rule) {
    if (!('composes' in style)) return style;
    registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.

    delete style.composes;
    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssCompose);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(390);


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(29);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["h" /* hasCSSTOMSupport */] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["h" /* hasCSSTOMSupport */] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["h" /* hasCSSTOMSupport */] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'border-image': true,
  'border-width': true,
  'border-style': true,
  'border-color': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true
  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */

};
var propArrayInObj = {
  position: true,
  // background-position
  size: true // background-size

  /**
   * A scheme for parsing and building correct styles from passed objects.
   */

};
var propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null,
    // Needed for avoiding comilation issues with jss-plugin-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-plugin-camel-case

  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */

};
var customPropObj = {
  border: {
    radius: 'border-radius',
    image: 'border-image',
    width: 'border-width',
    style: 'border-style',
    color: 'border-color'
  },
  'border-bottom': {
    width: 'border-bottom-width',
    style: 'border-bottom-style',
    color: 'border-bottom-color'
  },
  'border-top': {
    width: 'border-top-width',
    style: 'border-top-style',
    color: 'border-top-color'
  },
  'border-left': {
    width: 'border-left-width',
    style: 'border-left-style',
    color: 'border-left-color'
  },
  'border-right': {
    width: 'border-right-width',
    style: 'border-right-style',
    color: 'border-right-color'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height',
    // Needed to avoid compilation issues with jss-plugin-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  },
  grid: {
    'template-columns': 'grid-template-columns',
    templateColumns: 'grid-template-columns',
    'template-rows': 'grid-template-rows',
    templateRows: 'grid-template-rows',
    'template-areas': 'grid-template-areas',
    templateAreas: 'grid-template-areas',
    template: 'grid-template',
    'auto-columns': 'grid-auto-columns',
    autoColumns: 'grid-auto-columns',
    'auto-rows': 'grid-auto-rows',
    autoRows: 'grid-auto-rows',
    'auto-flow': 'grid-auto-flow',
    autoFlow: 'grid-auto-flow',
    row: 'grid-row',
    column: 'grid-column',
    'row-start': 'grid-row-start',
    rowStart: 'grid-row-start',
    'row-end': 'grid-row-end',
    rowEnd: 'grid-row-end',
    'column-start': 'grid-column-start',
    columnStart: 'grid-column-start',
    'column-end': 'grid-column-end',
    columnEnd: 'grid-column-end',
    area: 'grid-area',
    gap: 'grid-gap',
    'row-gap': 'grid-row-gap',
    rowGap: 'grid-row-gap',
    'column-gap': 'grid-column-gap',
    columnGap: 'grid-column-gap'
  }
};

/* eslint-disable no-use-before-define */
/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */

function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToArray(item, prop, rule, false, true);
  });
}
/**
 * Convert array to nested array, if needed
 */


function processArray(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value;
  if (value.length === 0) return [];
  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme, rule);

  if (typeof value[0] === 'object') {
    return mapValuesByProp(value, prop, rule);
  }

  return [value];
}
/**
 * Convert object to array.
 */


function objectToArray(value, prop, rule, isFallback, isInArray) {
  if (!(propObj[prop] || customPropObj[prop])) return [];
  var result = []; // Check if exists any non-standard property

  if (customPropObj[prop]) {
    // eslint-disable-next-line no-param-reassign
    value = customPropsToStyle(value, rule, customPropObj[prop], isFallback);
  } // Pass throught all standart props


  if (Object.keys(value).length) {
    for (var baseProp in propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
        } else result.push(value[baseProp]);

        continue;
      } // Add default value from props config.


      if (propObj[prop][baseProp] != null) {
        result.push(propObj[prop][baseProp]);
      }
    }
  }

  if (!result.length || isInArray) return result;
  return [result];
}
/**
 * Convert custom properties values to styles adding them to rule directly
 */


function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one

    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var _styleDetector;

      var appendedValue = styleDetector((_styleDetector = {}, _styleDetector[propName] = value[prop], _styleDetector), rule)[propName]; // Add style directly in rule

      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    } // Delete converted property to avoid double converting


    delete value[prop];
  }

  return value;
}
/**
 * Detect if a style needs to be converted.
 */


function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (Array.isArray(value)) {
      // Check double arrays to avoid recursion.
      if (!Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style.fallbacks.length; index++) {
            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
          }

          continue;
        }

        style[prop] = processArray(value, prop, propArray, rule); // Avoid creating properties with empty values

        if (!style[prop].length) delete style[prop];
      }
    } else if (typeof value === 'object') {
      if (prop === 'fallbacks') {
        style.fallbacks = styleDetector(style.fallbacks, rule, true);
        continue;
      }

      style[prop] = objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values

      if (!style[prop].length) delete style[prop];
    } // Maybe a computed value resulting in an empty string
    else if (style[prop] === '') delete style[prop];
  }

  return style;
}
/**
 * Adds possibility to write expanded styles.
 */


function jssExpand() {
  function onProcessStyle(style, rule) {
    if (!style || rule.type !== 'style') return style;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }

      return style;
    }

    return styleDetector(style, rule);
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssExpand);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(29);



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["i" /* toCssValue */])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["i" /* toCssValue */])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(395);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__ = __webpack_require__(399);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(163);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(arr);
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(163);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(o, minLen);
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shallowEqualArrays */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shallowEqualObjects; });
function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}




/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(403);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_preset_default__ = __webpack_require__(162);



// Since we are in a single sheet mode, user shouldn't care about this.

var MAX_RULES_PER_SHEET = 10000;
var defaultJss = Object(__WEBPACK_IMPORTED_MODULE_0_jss__["d" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_1_jss_preset_default__["a" /* default */])());

var createCss = function createCss(jss) {
  if (jss === void 0) {
    jss = defaultJss;
  }

  var cache = new Map();
  var ruleIndex = 0;
  var sheet;

  var getSheet = function getSheet() {
    if (!sheet || sheet.rules.index.length > MAX_RULES_PER_SHEET) {
      sheet = jss.createStyleSheet().attach();
    }

    return sheet;
  };

  function css() {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments; // We can avoid the need for stringification with a babel plugin,
    // which could generate a hash at build time and add it to the object.

    var argsStr = JSON.stringify(args);
    var cached = cache.get(argsStr);
    if (cached) return cached.className;
    var flatArgs = []; // Flatten arguments which can be
    // - style objects
    // - array of style objects
    // - arrays of style objects

    for (var argIndex in args) {
      var arg = args[argIndex];

      if (!Array.isArray(arg)) {
        flatArgs.push(arg);
        continue;
      }

      for (var innerArgIndex = 0; innerArgIndex < arg.length; innerArgIndex++) {
        flatArgs.push(arg[innerArgIndex]);
      }
    }

    var mergedStyle = {};
    var labels = [];

    for (var i = 0; i < flatArgs.length; i++) {
      var style = flatArgs[i];
      if (!style) continue;
      var styleObject = style; // It can be a class name that css() has previously generated.

      if (typeof style === 'string') {
        // eslint-disable-next-line no-shadow
        var _cached = cache.get(style);

        if (_cached) {
          // eslint-disable-next-line prefer-spread
          if (_cached.labels.length) labels.push.apply(labels, _cached.labels);
          styleObject = _cached.style;
        }
      }

      if (styleObject.label && labels.indexOf(styleObject.label) === -1) labels.push(styleObject.label);
      Object.assign(mergedStyle, styleObject);
    }

    delete mergedStyle.label;
    var label = labels.length === 0 ? 'css' : labels.join('-');
    var key = label + "-" + ruleIndex++;
    getSheet().addRule(key, mergedStyle);
    var className = getSheet().classes[key];
    var cacheValue = {
      style: mergedStyle,
      labels: labels,
      className: className
    };
    cache.set(argsStr, cacheValue);
    cache.set(className, cacheValue);
    return className;
  } // For testing only.


  css.getSheet = getSheet;
  return css;
};

var css = createCss();

/* harmony default export */ __webpack_exports__["a"] = (css);



/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ThemeStyles;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Theme=exports.Theme=undefined;(function(Theme){Theme["Light"]="Light";Theme["Dark"]="Dark";})(Theme||(exports.Theme=Theme={}));var LightTheme={ChamptionshipHeader:{color:'#2D2D2D',backgroundColor:'#E0E5EB'}};var DarkTheme={ChamptionshipHeader:{color:'#FFFFFF',backgroundColor:'#2f2f2f'}};var ThemeStyles=exports.ThemeStyles=(_ThemeStyles={},_defineProperty(_ThemeStyles,Theme.Dark,DarkTheme),_defineProperty(_ThemeStyles,Theme.Light,LightTheme),_ThemeStyles);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var numberFormatter=function numberFormatter(v){return v>0?"+"+v:String(v);};// Возвращает кэф Американского типа
var americanTypeCf=exports.americanTypeCf=function americanTypeCf(cf){if(cf>=2)return numberFormatter(Math.round(cf*100-100));// if(cf >=1 && cf < 2)
return numberFormatter(Math.round(100/(1-cf)));};var hongKongTypeCf=exports.hongKongTypeCf=function hongKongTypeCf(cf){if(cf>=1)return cf-1;return cf;};var indonesianTypeCf=exports.indonesianTypeCf=function indonesianTypeCf(cf){if(cf>=2||cf===1)return cf-1;// if (cf > 1 && cf < 2)
return 1/(1-cf);};var malaysianTypeCf=exports.malaysianTypeCf=function malaysianTypeCf(cf){if(cf>=1&&cf<2)return cf-1;// if(cf >= 2)
return 1/(1-cf);};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.THead=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var THead=exports.THead=_react2.default.memo(function(props){return _react2.default.createElement('tr',null,props.rows.map(function(cell,i,row){return _react2.default.createElement('th',{key:cell.txt+'_'+i,className:'g-t-v-th-a-c align-'+(cell.al||_base.CELL_ALIGN.LEFT)+' '+(i===0?'padding-l':''),style:props.getColumnStyle(i,row),rowSpan:cell.rs,colSpan:cell.cs,title:cell.txt},cell.txt);}));});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Description=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactJss=__webpack_require__(57);var _reactRouterDom=__webpack_require__(2);var _kafka=__webpack_require__(58);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var useStyles=(0,_reactJss.createUseStyles)({leftPadding:{paddingLeft:'5px'},leftAlign:{textAlign:'left'},inherit:{color:'inherit'},flexGrow:{flexGrow:1},gray:{color:'#999'},red:{color:'red'},flex:{display:'flex'}},{name:'Description'});// import Timer from '../Timer';
var Description=exports.Description=function Description(props){if(!props.description){return null;}var classes=useStyles();return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:classes.leftPadding+' '+classes.gray},props.displayGamesNumber&&props.description.num!==0&&_react2.default.createElement('div',{style:{color:'rgba(0, 0, 0, 0.7)',fontWeight:'500'},className:'g-n'},'#'+(props.description.num||'')),props.description.time),_react2.default.createElement('div',{className:classes.leftPadding+' '+classes.flexGrow+' '+classes.leftAlign},_react2.default.createElement('p',null,_react2.default.createElement(_reactRouterDom.Link,{to:props.url,className:classes.inherit,title:props.description.team1+' '+(props.description.team2&&' - '+props.description.team2),onClick:function onClick(){return(0,_kafka.sendLogKafka)(_kafka.Events.eventViewed,{eventId:props.matchId,sourceScreen:'live'});}},_react2.default.createElement('span',null,' ',props.description.team1),props.inline?' - ':_react2.default.createElement('br',null),_react2.default.createElement('span',null,' ',props.description.team2))),_react2.default.createElement('b',{className:classes.red},' ',props.description.score,' ')));};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.KafkaLogger=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _kafka=__webpack_require__(94);var _SearchEvent=__webpack_require__(410);var _clientAxios=__webpack_require__(416);var _clientAxios2=_interopRequireDefault(_clientAxios);var _getImprintHash=__webpack_require__(166);var _getImprintHash2=_interopRequireDefault(_getImprintHash);var _config=__webpack_require__(48);var _qs=__webpack_require__(96);var _qs2=_interopRequireDefault(_qs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
  В режиме разработки, логи на стенд не отправляются.
  Если нужно отследить логирование, нужно задать куку debug : 'LOG'.
 */var KafkaLogger=exports.KafkaLogger=function(){function KafkaLogger(){var _this=this;_classCallCheck(this,KafkaLogger);this.pageNotFound=null;this.additionalData={};this.baseUrl=(0,_config.getConfig)('IS_TEST')||(0,_config.getConfig)('IS_DEV')||(0,_config.getConfig)('TYPE')==='cupis'||this.isIrmProject()?(0,_config.getConfig)('API_URL'):'https://statscollect.com';this.KafkaRequests=new _clientAxios2.default(this.baseUrl);this.KafkaImprintHash=_getImprintHash2.default.getInstance();this.setAdditionalData=function(){var additionalData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};additionalData.imprintHash=_this.KafkaImprintHash.getImprintHash();for(var key in additionalData){if(additionalData[key]){_this.additionalData[key]=additionalData[key];}else{delete _this.additionalData[key];}}};this.setPageNotFound=function(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.pageNotFound=page;};this.getPageNotFound=function(){return _this.pageNotFound;};this.listenerBrowserTabClose=function(){if((0,_config.getConfig)('IS_SERVER')){return;}var sendCloseLogs=function sendCloseLogs(){var detail={sourceScreen:window.is404?'404':window.location.pathname};_this.sendLogUseBeaconApi(_kafka.Events.tabClosed,detail);};document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden'){sendCloseLogs();}});window.addEventListener('pagehide',sendCloseLogs);};this.sendLog=function(eventName,detail){if(_this.pageNotFound&&eventName===_kafka.Events.topMoved){detail.sourceScreen=_this.pageNotFound;}var data=(0,_SearchEvent.searchEvent)(eventName,detail,_this.additionalData);if(!data){return;}_this.KafkaRequests.post('/ajax/kafka/log',data);};this.sendLogUseBeaconApi=function(eventName,detail){if(_this.pageNotFound&&eventName===_kafka.Events.topMoved){detail.sourceScreen=_this.pageNotFound;}var data=(0,_SearchEvent.searchEvent)(eventName,detail,_this.additionalData);if(!data){return false;}var stringifyData=_qs2.default.stringify(data);var blob=new Blob([stringifyData],{type:"application/x-www-form-urlencoded"});var result=navigator.sendBeacon(_this.baseUrl+'/ajax/kafka/log',blob);return result;};this.listenerBrowserTabClose();}_createClass(KafkaLogger,[{key:'isIrmProject',value:function isIrmProject(){var _a;try{if(false)return false;var projectConfig=JSON.parse(String("{\"main\":{\"appName\":\"IRM\",\"version\":\"\",\"folder\":\"zenitbet\",\"GTM\":\"GTM-5BSJV7F\",\"useCDN\":1,\"cdnFolder\":\"/com\",\"type\":\"com\",\"d_version\":2}}"));return((_a=projectConfig===null||projectConfig===void 0?void 0:projectConfig.main)===null||_a===void 0?void 0:_a.appName)==='IRM';}catch(error){console.error('Error parsing process.env.PROJECT:',error);return false;}}}],[{key:'getInstance',value:function getInstance(){if(this.instance){return this.instance;}this.instance=new KafkaLogger();return this.instance;}}]);return KafkaLogger;}();

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.searchEvent=undefined;var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _KafkaEventsMap=__webpack_require__(411);var _config=__webpack_require__(48);var _getTime=__webpack_require__(413);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var searchEvent=exports.searchEvent=function searchEvent(event,detail,additionalData){var info={};var error=false;Object.keys(_KafkaEventsMap.EventsMap).find(function(topic){return Object.keys(_KafkaEventsMap.EventsMap[topic]).find(function(eventType){return Object.keys(_KafkaEventsMap.EventsMap[topic][eventType]).find(function(eventCode){var isEventCodeFound=eventCode===event;if(isEventCodeFound){var activeProjectsList=_KafkaEventsMap.EventsMap[topic][eventType][eventCode];if(!activeProjectsList.includes((0,_config.getConfig)('APP_NAME'))){error=true;return false;}var timezone=(0,_getTime.getTimeZone)();info={topic:topic,action:Object.assign({eventType:eventType,eventCode:eventCode,timezone:timezone},detail&&{detail:detail}),additional_data:additionalData};}return isEventCodeFound;});});});if(error){_logger2.default.getInstance().error(new Error('[Kafka] eventCode '+event+' not included for the project '+(0,_config.getConfig)('APP_NAME').toString()));return null;}if(Object.keys(info).length==0){_logger2.default.getInstance().error(new Error('[Kafka] eventCode '+event+' is undefined'));return null;}_logger2.default.getInstance().log('[Kafka] '+JSON.stringify(info));return info;};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EventsMap=undefined;var _Types$registration,_Types$authorization,_Types$identification,_Topics$baseIdentityA,_Types$deposit,_Types$payout,_Topics$payments,_Types$common,_Types$bk,_Types$casino,_Types$payments,_Types$wagers,_Types$promo,_Types$Euro,_Topics$navigation,_Types$bk2,_Types$settings,_EventsMap;var _kafka=__webpack_require__(94);var _projects=__webpack_require__(412);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Первый уровень - Топик {
 *      второй - Тип события {
 *          третий - событие {
 *                  четвертый - событие активено для ['zenitbet', 'mobile_com', 'desktop', 'mobile_new', 'zenitbet_classic']
 *          }
 *      }
 * }
 */var defaultSettings=Object.keys(_projects.Projects);// ['zenitbet', 'mobile_com', 'desktop', 'mobile_new', 'zenitbet_classic', 'cupis', 'mobile'];
var withoutClassic=defaultSettings.filter(function(projectName){return projectName!=='zenitbet_classic';});var mobileProjects=defaultSettings.filter(function(projectName){return['mobile','mobile_com','mobile_new'].includes(projectName);});var cupisProjects=defaultSettings.filter(function(projectName){return['mobile','cupis'].includes(projectName);});var EventsMap=exports.EventsMap=(_EventsMap={},_defineProperty(_EventsMap,_kafka.Topics.baseIdentityActions,(_Topics$baseIdentityA={},_defineProperty(_Topics$baseIdentityA,_kafka.Types.launch,_defineProperty({},_kafka.Events.sessionStart,[_projects.Projects.zenitbet,_projects.Projects.mobile_com,_projects.Projects.desktop,_projects.Projects.mobile_new])),_defineProperty(_Topics$baseIdentityA,_kafka.Types.registration,(_Types$registration={},_defineProperty(_Types$registration,_kafka.Events.gotoRofit,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.regStart,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.enteredCharInReg,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.regStep2,[_projects.Projects.mobile_com,_projects.Projects.cupis,_projects.Projects.mobile]),_defineProperty(_Types$registration,_kafka.Events.regStep3,[_projects.Projects.mobile_com]),_defineProperty(_Types$registration,_kafka.Events.promoEnter,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.regButtonEnter,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.smsCodeEntered,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.smsCodeRepeat,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.selectPhoneVerificationMethod,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.enteredCharInVerificationMethod,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.flashCallRequest,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.flashCallCodeEntered,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.flashCallCodeRepeat,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.backStep,defaultSettings),_defineProperty(_Types$registration,_kafka.Events.registrationDone,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.enteredPhone,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.enteredEmail,[_projects.Projects.desktop,_projects.Projects.mobile_new]),_defineProperty(_Types$registration,_kafka.Events.choseCountry,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.choseCurrency,[_projects.Projects.desktop,_projects.Projects.mobile_new,_projects.Projects.zenitbet,_projects.Projects.mobile_com]),_defineProperty(_Types$registration,_kafka.Events.enteredPassword,withoutClassic),_defineProperty(_Types$registration,_kafka.Events.enteredRepeatPassword,[_projects.Projects.zenitbet,_projects.Projects.mobile_com,_projects.Projects.desktop,_projects.Projects.mobile_new]),_Types$registration)),_defineProperty(_Topics$baseIdentityA,_kafka.Types.authorization,(_Types$authorization={},_defineProperty(_Types$authorization,_kafka.Events.authStart,withoutClassic),_defineProperty(_Types$authorization,_kafka.Events.authorizationDone,withoutClassic),_defineProperty(_Types$authorization,_kafka.Events.logout,defaultSettings),_defineProperty(_Types$authorization,_kafka.Events.clickForgotPassword,defaultSettings),_Types$authorization)),_defineProperty(_Topics$baseIdentityA,_kafka.Types.identification,(_Types$identification={},_defineProperty(_Types$identification,_kafka.Events.identificationStart,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationButtonEnter,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationDateOfBirthInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationDocumentInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationLastnameInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationMiddlenameInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationNameInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationPassportInput,cupisProjects),_defineProperty(_Types$identification,_kafka.Events.identificationTypeSelection,cupisProjects),_Types$identification)),_Topics$baseIdentityA)),_defineProperty(_EventsMap,_kafka.Topics.payments,(_Topics$payments={},_defineProperty(_Topics$payments,_kafka.Types.deposit,(_Types$deposit={},_defineProperty(_Types$deposit,_kafka.Events.depositPageShow,defaultSettings),_defineProperty(_Types$deposit,_kafka.Events.depositInit,defaultSettings),_defineProperty(_Types$deposit,_kafka.Events.depositPageChoice,defaultSettings),_defineProperty(_Types$deposit,_kafka.Events.depositInputAmount,defaultSettings),_Types$deposit)),_defineProperty(_Topics$payments,_kafka.Types.payout,(_Types$payout={},_defineProperty(_Types$payout,_kafka.Events.payoutPageShow,defaultSettings),_defineProperty(_Types$payout,_kafka.Events.payoutPageChoice,defaultSettings),_defineProperty(_Types$payout,_kafka.Events.payoutInputAmount,defaultSettings),_Types$payout)),_Topics$payments)),_defineProperty(_EventsMap,_kafka.Topics.navigation,(_Topics$navigation={},_defineProperty(_Topics$navigation,_kafka.Types.common,(_Types$common={},_defineProperty(_Types$common,_kafka.Events.storiesAction,defaultSettings),_defineProperty(_Types$common,_kafka.Events.storiesButtonClick,defaultSettings),_defineProperty(_Types$common,_kafka.Events.viewStoriesV2,defaultSettings),_defineProperty(_Types$common,_kafka.Events.clickStoriesV2,defaultSettings),_defineProperty(_Types$common,_kafka.Events.moved404,defaultSettings),_defineProperty(_Types$common,_kafka.Events.topMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.tabClosed,defaultSettings),_defineProperty(_Types$common,_kafka.Events.moreMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.searchDone,defaultSettings),_defineProperty(_Types$common,_kafka.Events.promoCurrentMoved,withoutClassic),_defineProperty(_Types$common,_kafka.Events.promoActionSelect,defaultSettings),_defineProperty(_Types$common,_kafka.Events.promoMyCurrentMoved,withoutClassic),_defineProperty(_Types$common,_kafka.Events.promoActionStepSelect,withoutClassic),_defineProperty(_Types$common,_kafka.Events.questClickParticipate,withoutClassic),_defineProperty(_Types$common,_kafka.Events.rulesMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.howMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.accessMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.technicalSupportContacted,defaultSettings),_defineProperty(_Types$common,_kafka.Events.feedbackMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.feedbackRating,defaultSettings),_defineProperty(_Types$common,_kafka.Events.onlineChatSupportMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.onlineChatSupportRating,defaultSettings),_defineProperty(_Types$common,_kafka.Events.affiliateProgramMoved,defaultSettings),_defineProperty(_Types$common,_kafka.Events.applicationMoved,withoutClassic),_defineProperty(_Types$common,_kafka.Events.applicationDownload,withoutClassic),_defineProperty(_Types$common,_kafka.Events.newsMoved,withoutClassic),_defineProperty(_Types$common,_kafka.Events.newsCategorySelection,withoutClassic),_defineProperty(_Types$common,_kafka.Events.newsOpened,withoutClassic),_defineProperty(_Types$common,_kafka.Events.newsButtonClick,withoutClassic),_defineProperty(_Types$common,_kafka.Events.tableWorldCup,withoutClassic),_defineProperty(_Types$common,_kafka.Events.pageEntered,defaultSettings),_Types$common)),_defineProperty(_Topics$navigation,_kafka.Types.bk,(_Types$bk={},_defineProperty(_Types$bk,_kafka.Events.liveTabMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.lineMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.eventViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.favoUrites,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.favouritesLiveMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.favouritesLineMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.scheduleTabMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.sportTypeFiltered,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.timeFiltered,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.exodusFiltered,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.infographicsViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.textographicViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.matchCenterViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.videoViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.openVideoFullScreen,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.statisticViewed,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.resultsLineMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.resultsLiveMoved,defaultSettings),_defineProperty(_Types$bk,_kafka.Events.statsMoved,[_projects.Projects.zenitbet,_projects.Projects.desktop,_projects.Projects.cupis]),_Types$bk)),_defineProperty(_Topics$navigation,_kafka.Types.casino,(_Types$casino={},_defineProperty(_Types$casino,_kafka.Events.casinoMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.twainSportMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.betgamesMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.liveCasinoMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.casinoGameMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.tvgamesMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.clickCasinoBanner,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.searchCasino,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.cancelSearchCasino,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.favouritesCasinoMoved,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.favouritesCasino,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.casinoGroupSelect,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.casinoCategorySelect,defaultSettings),_defineProperty(_Types$casino,_kafka.Events.casinoProviderSelect,defaultSettings),_Types$casino)),_defineProperty(_Topics$navigation,_kafka.Types.toto,_defineProperty({},_kafka.Events.totoMoved,defaultSettings)),_defineProperty(_Topics$navigation,_kafka.Types.payments,(_Types$payments={},_defineProperty(_Types$payments,_kafka.Events.historyAllMoved,defaultSettings),_defineProperty(_Types$payments,_kafka.Events.historyAllMoved,defaultSettings),_defineProperty(_Types$payments,_kafka.Events.historyDepositMoved,mobileProjects),_defineProperty(_Types$payments,_kafka.Events.historyPayoutMoved,mobileProjects),_defineProperty(_Types$payments,_kafka.Events.historyPeriodSelect,defaultSettings),_Types$payments)),_defineProperty(_Topics$navigation,_kafka.Types.wagers,(_Types$wagers={},_defineProperty(_Types$wagers,_kafka.Events.allBetsMoved,defaultSettings),_defineProperty(_Types$wagers,_kafka.Events.basketMoved,mobileProjects),_defineProperty(_Types$wagers,_kafka.Events.unassignedMoved,defaultSettings),_defineProperty(_Types$wagers,_kafka.Events.betTypeSelect,defaultSettings),_Types$wagers)),_defineProperty(_Topics$navigation,_kafka.Types.promo,(_Types$promo={},_defineProperty(_Types$promo,_kafka.Events.clickModal,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.viewModal,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.clickModalV2,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.viewModalV2,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.clickBannerBasket,[_projects.Projects.desktop,_projects.Projects.zenitbet]),_defineProperty(_Types$promo,_kafka.Events.clickBanner,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.viewPopUp,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.PL_event_banner,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.PL_event_lenta,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.PL_event_lk,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.PL_event_promo,defaultSettings),_defineProperty(_Types$promo,_kafka.Events.PL_event_story,defaultSettings),_Types$promo)),_defineProperty(_Topics$navigation,_kafka.Types.Euro24,(_Types$Euro={},_defineProperty(_Types$Euro,_kafka.Events.Euro24_move,defaultSettings),_defineProperty(_Types$Euro,_kafka.Events.Euro24_tab_move,defaultSettings),_Types$Euro)),_Topics$navigation)),_defineProperty(_EventsMap,_kafka.Topics.wagers,_defineProperty({},_kafka.Types.bk,(_Types$bk2={},_defineProperty(_Types$bk2,_kafka.Events.eventAdd,defaultSettings),_defineProperty(_Types$bk2,_kafka.Events.clickSaleBet,defaultSettings),_defineProperty(_Types$bk2,_kafka.Events.confirmSaleBet,defaultSettings),_defineProperty(_Types$bk2,_kafka.Events.wagerDone,defaultSettings),_defineProperty(_Types$bk2,_kafka.Events.eventDeleted,defaultSettings),_defineProperty(_Types$bk2,_kafka.Events.basketCleared,defaultSettings),_Types$bk2))),_defineProperty(_EventsMap,_kafka.Topics.other,_defineProperty({},_kafka.Types.settings,(_Types$settings={},_defineProperty(_Types$settings,_kafka.Events.nightTheme,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.basketClearChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.balanceClearChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.sortingChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.coefficientAgreementChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.emailRegularChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.emailImportantChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.smsImportantChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.eventsNumberChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.timezoneChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.fastWagerBasketChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.languageNotificationChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.languageChanged,defaultSettings),_defineProperty(_Types$settings,_kafka.Events.oneClickBetChanged,[_projects.Projects.zenitbet,_projects.Projects.desktop]),_Types$settings))),_EventsMap);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var Projects=exports.Projects=undefined;(function(Projects){Projects["zenitbet"]="zenitbet";Projects["mobile_com"]="mobile_com";Projects["desktop"]="desktop";Projects["mobile_new"]="mobile_new";Projects["zenitbet_classic"]="zenitbet_classic";Projects["cupis"]="cupis";Projects["mobile"]="mobile";})(Projects||(exports.Projects=Projects={}));

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getTimeZone=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _dayjs=__webpack_require__(414);var _dayjs2=_interopRequireDefault(_dayjs);var _utc=__webpack_require__(415);var _utc2=_interopRequireDefault(_utc);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_dayjs2.default.extend(_utc2.default);var getTimeZone=exports.getTimeZone=function getTimeZone(){var _timezone=(0,_dayjs2.default)().utcOffset()/60;var _String$split=String(_timezone).split('.'),_String$split2=_slicedToArray(_String$split,2),hour=_String$split2[0],minute=_String$split2[1];var _minute=minute?String(Number(minute)/100*60):'00';var timezone=''+(Number(hour)>=0&&Number(hour)<10?'+0':Number(hour)>=10?'+':'')+hour+':'+_minute;return timezone;};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_utc=i()}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t)};var o=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else o.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s;if(0===u)return this.utc(f);var r=this.clone();if(f)return r.$offset=u,r.$u=!1,r;var o=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();return(r=this.local().add(u+o,t)).$offset=u,r.$x.$localOffset=o,r};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _regenerator=__webpack_require__(59);var _regenerator2=_interopRequireDefault(_regenerator);var _tslib=__webpack_require__(95);var _axios=__webpack_require__(84);var _axios2=_interopRequireDefault(_axios);var _qs=__webpack_require__(96);var _qs2=_interopRequireDefault(_qs);var _config=__webpack_require__(48);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ClientAxios=function ClientAxios(){var _this=this;var baseUrl=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(0,_config.getConfig)('API_URL');_classCallCheck(this,ClientAxios);this.handleErrors=function(err){if(_axios2.default.isCancel(err)){console.log('Request canceled',err.message);throw'CANCELLED';}if(!(0,_config.getConfig)('IS_SERVER')&&window.setErrorRequest)window.setErrorRequest(err.request.status);return err.request.status;};this.responseBody=function(res){if(res&&typeof res!=='number'&&res.data){return res.data;}return false;};this.post=function(url,body){return(0,_tslib.__awaiter)(_this,void 0,void 0,/*#__PURE__*/_regenerator2.default.mark(function _callee(){var _o;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_o={withCredentials:true,headers:{'Content-Type':'application/x-www-form-urlencoded'}};_context.next=3;return this.client.post(url,_qs2.default.stringify(body),_o).catch(this.handleErrors).then(this.responseBody);case 3:return _context.abrupt('return',_context.sent);case 4:case'end':return _context.stop();}}},_callee,this);}));};this.client=_axios2.default.create({baseURL:baseUrl,withCredentials:true,headers:{'Content-Type':'application/x-www-form-urlencoded'}});};exports.default=ClientAxios;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(418);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(97);
var formats = __webpack_require__(165);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        }).join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(97);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj; // eslint-disable-line no-param-reassign
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentsToDebugString", function() { return componentsToDebugString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFullscreenElement", function() { return getFullscreenElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScreenFrame", function() { return getScreenFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashComponents", function() { return hashComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAndroid", function() { return isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isChromium", function() { return isChromium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDesktopSafari", function() { return isDesktopSafari; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEdgeHTML", function() { return isEdgeHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGecko", function() { return isGecko; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTrident", function() { return isTrident; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWebKit", function() { return isWebKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSources", function() { return loadSources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "murmurX64Hash128", function() { return murmurX64Hash128; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareForSources", function() { return prepareForSources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sources", function() { return sources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(95);
/**
 * FingerprintJS v3.3.3 - Copyright (c) FingerprintJS, Inc, 2022 (https://fingerprintjs.com)
 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
 *
 * This software contains code from open-source projects:
 * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
 */



var version = "3.3.3";

function wait(durationMs, resolveWith) {
    return new Promise(function (resolve) { return setTimeout(resolve, durationMs, resolveWith); });
}
function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
    if (deadlineTimeout === void 0) { deadlineTimeout = Infinity; }
    var requestIdleCallback = window.requestIdleCallback;
    if (requestIdleCallback) {
        // The function `requestIdleCallback` loses the binding to `window` here.
        // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
        // Therefore, an error can occur. `call(window,` prevents the error.
        return new Promise(function (resolve) { return requestIdleCallback.call(window, function () { return resolve(); }, { timeout: deadlineTimeout }); });
    }
    else {
        return wait(Math.min(fallbackTimeout, deadlineTimeout));
    }
}
function isPromise(value) {
    return value && typeof value.then === 'function';
}
/**
 * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
 * Catches errors in both cases.
 *
 * If just you run a code like this:
 * ```
 * console.time('Action duration')
 * await action()
 * console.timeEnd('Action duration')
 * ```
 * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
 * returns the control back to the code.
 */
function awaitIfAsync(action, callback) {
    try {
        var returnedValue = action();
        if (isPromise(returnedValue)) {
            returnedValue.then(function (result) { return callback(true, result); }, function (error) { return callback(false, error); });
        }
        else {
            callback(true, returnedValue);
        }
    }
    catch (error) {
        callback(false, error);
    }
}
/**
 * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
 * (e.g. completing a network request, rendering the page) won't be able to happen.
 * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
 */
function forEachWithBreaks(items, callback, loopReleaseInterval) {
    if (loopReleaseInterval === void 0) { loopReleaseInterval = 16; }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var lastLoopReleaseTime, i, now;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lastLoopReleaseTime = Date.now();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < items.length)) return [3 /*break*/, 4];
                    callback(items[i], i);
                    now = Date.now();
                    if (!(now >= lastLoopReleaseTime + loopReleaseInterval)) return [3 /*break*/, 3];
                    lastLoopReleaseTime = now;
                    // Allows asynchronous actions and microtasks to happen
                    return [4 /*yield*/, wait(0)];
                case 2:
                    // Allows asynchronous actions and microtasks to happen
                    _a.sent();
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}

/*
 * Taken from https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
 */
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// added together as a 64bit int (as an array of two 32bit ints).
//
function x64Add(m, n) {
    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
    var o = [0, 0, 0, 0];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
}
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// multiplied together as a 64bit int (as an array of two 32bit ints).
//
function x64Multiply(m, n) {
    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
    var o = [0, 0, 0, 0];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
}
//
// Given a 64bit int (as an array of two 32bit ints) and an int
// representing a number of bit positions, returns the 64bit int (as an
// array of two 32bit ints) rotated left by that number of positions.
//
function x64Rotl(m, n) {
    n %= 64;
    if (n === 32) {
        return [m[1], m[0]];
    }
    else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))];
    }
    else {
        n -= 32;
        return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))];
    }
}
//
// Given a 64bit int (as an array of two 32bit ints) and an int
// representing a number of bit positions, returns the 64bit int (as an
// array of two 32bit ints) shifted left by that number of positions.
//
function x64LeftShift(m, n) {
    n %= 64;
    if (n === 0) {
        return m;
    }
    else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n];
    }
    else {
        return [m[1] << (n - 32), 0];
    }
}
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// xored together as a 64bit int (as an array of two 32bit ints).
//
function x64Xor(m, n) {
    return [m[0] ^ n[0], m[1] ^ n[1]];
}
//
// Given a block, returns murmurHash3's final x64 mix of that block.
// (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
// only place where we need to right shift 64bit ints.)
//
function x64Fmix(h) {
    h = x64Xor(h, [0, h[0] >>> 1]);
    h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
    h = x64Xor(h, [0, h[0] >>> 1]);
    h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
    h = x64Xor(h, [0, h[0] >>> 1]);
    return h;
}
//
// Given a string and an optional seed as an int, returns a 128 bit
// hash using the x64 flavor of MurmurHash3, as an unsigned hex.
//
function x64hash128(key, seed) {
    key = key || '';
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [0, seed];
    var h2 = [0, seed];
    var k1 = [0, 0];
    var k2 = [0, 0];
    var c1 = [0x87c37b91, 0x114253d5];
    var c2 = [0x4cf5ad43, 0x2745937f];
    var i;
    for (i = 0; i < bytes; i = i + 16) {
        k1 = [
            (key.charCodeAt(i + 4) & 0xff) |
                ((key.charCodeAt(i + 5) & 0xff) << 8) |
                ((key.charCodeAt(i + 6) & 0xff) << 16) |
                ((key.charCodeAt(i + 7) & 0xff) << 24),
            (key.charCodeAt(i) & 0xff) |
                ((key.charCodeAt(i + 1) & 0xff) << 8) |
                ((key.charCodeAt(i + 2) & 0xff) << 16) |
                ((key.charCodeAt(i + 3) & 0xff) << 24),
        ];
        k2 = [
            (key.charCodeAt(i + 12) & 0xff) |
                ((key.charCodeAt(i + 13) & 0xff) << 8) |
                ((key.charCodeAt(i + 14) & 0xff) << 16) |
                ((key.charCodeAt(i + 15) & 0xff) << 24),
            (key.charCodeAt(i + 8) & 0xff) |
                ((key.charCodeAt(i + 9) & 0xff) << 8) |
                ((key.charCodeAt(i + 10) & 0xff) << 16) |
                ((key.charCodeAt(i + 11) & 0xff) << 24),
        ];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
    }
    k1 = [0, 0];
    k2 = [0, 0];
    switch (remainder) {
        case 15:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough
        case 14:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough
        case 13:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough
        case 12:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough
        case 11:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough
        case 10:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough
        case 9:
            k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
            k2 = x64Multiply(k2, c2);
            k2 = x64Rotl(k2, 33);
            k2 = x64Multiply(k2, c1);
            h2 = x64Xor(h2, k2);
        // fallthrough
        case 8:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough
        case 7:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough
        case 6:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough
        case 5:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough
        case 4:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough
        case 3:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough
        case 2:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough
        case 1:
            k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
            k1 = x64Multiply(k1, c1);
            k1 = x64Rotl(k1, 31);
            k1 = x64Multiply(k1, c2);
            h1 = x64Xor(h1, k1);
        // fallthrough
    }
    h1 = x64Xor(h1, [0, key.length]);
    h2 = x64Xor(h2, [0, key.length]);
    h1 = x64Add(h1, h2);
    h2 = x64Add(h2, h1);
    h1 = x64Fmix(h1);
    h2 = x64Fmix(h2);
    h1 = x64Add(h1, h2);
    h2 = x64Add(h2, h1);
    return (('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8));
}

/**
 * Converts an error object to a plain object that can be used with `JSON.stringify`.
 * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
 */
function errorToObject(error) {
    var _a;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ name: error.name, message: error.message, stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split('\n') }, error);
}

/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */
/**
 * Does the same as Array.prototype.includes but has better typing
 */
function includes(haystack, needle) {
    for (var i = 0, l = haystack.length; i < l; ++i) {
        if (haystack[i] === needle) {
            return true;
        }
    }
    return false;
}
/**
 * Like `!includes()` but with proper typing
 */
function excludes(haystack, needle) {
    return !includes(haystack, needle);
}
/**
 * Be careful, NaN can return
 */
function toInt(value) {
    return parseInt(value);
}
/**
 * Be careful, NaN can return
 */
function toFloat(value) {
    return parseFloat(value);
}
function replaceNaN(value, replacement) {
    return typeof value === 'number' && isNaN(value) ? replacement : value;
}
function countTruthy(values) {
    return values.reduce(function (sum, value) { return sum + (value ? 1 : 0); }, 0);
}
function round(value, base) {
    if (base === void 0) { base = 1; }
    if (Math.abs(base) >= 1) {
        return Math.round(value / base) * base;
    }
    else {
        // Sometimes when a number is multiplied by a small number, precision is lost,
        // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
        var counterBase = 1 / base;
        return Math.round(value * counterBase) / counterBase;
    }
}
/**
 * Parses a CSS selector into tag name with HTML attributes.
 * Only single element selector are supported (without operators like space, +, >, etc).
 *
 * Multiple values can be returned for each attribute. You decide how to handle them.
 */
function parseSimpleCssSelector(selector) {
    var _a, _b;
    var errorMessage = "Unexpected syntax '" + selector + "'";
    var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    var tag = tagMatch[1] || undefined;
    var attributes = {};
    var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    var addAttribute = function (name, value) {
        attributes[name] = attributes[name] || [];
        attributes[name].push(value);
    };
    for (;;) {
        var match = partsRegex.exec(tagMatch[2]);
        if (!match) {
            break;
        }
        var part = match[0];
        switch (part[0]) {
            case '.':
                addAttribute('class', part.slice(1));
                break;
            case '#':
                addAttribute('id', part.slice(1));
                break;
            case '[': {
                var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                if (attributeMatch) {
                    addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : '');
                }
                else {
                    throw new Error(errorMessage);
                }
                break;
            }
            default:
                throw new Error(errorMessage);
        }
    }
    return [tag, attributes];
}

function ensureErrorWithMessage(error) {
    return error && typeof error === 'object' && 'message' in error ? error : { message: error };
}
/**
 * Loads the given entropy source. Returns a function that gets an entropy component from the source.
 *
 * The result is returned synchronously to prevent `loadSources` from
 * waiting for one source to load before getting the components from the other sources.
 */
function loadSource(source, sourceOptions) {
    var isFinalResultLoaded = function (loadResult) {
        return typeof loadResult !== 'function';
    };
    var sourceLoadPromise = new Promise(function (resolveLoad) {
        var loadStartTime = Date.now();
        // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
        // correctly (other microtasks won't affect the duration).
        awaitIfAsync(source.bind(null, sourceOptions), function () {
            var loadArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                loadArgs[_i] = arguments[_i];
            }
            var loadDuration = Date.now() - loadStartTime;
            // Source loading failed
            if (!loadArgs[0]) {
                return resolveLoad(function () { return ({ error: ensureErrorWithMessage(loadArgs[1]), duration: loadDuration }); });
            }
            var loadResult = loadArgs[1];
            // Source loaded with the final result
            if (isFinalResultLoaded(loadResult)) {
                return resolveLoad(function () { return ({ value: loadResult, duration: loadDuration }); });
            }
            // Source loaded with "get" stage
            resolveLoad(function () {
                return new Promise(function (resolveGet) {
                    var getStartTime = Date.now();
                    awaitIfAsync(loadResult, function () {
                        var getArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            getArgs[_i] = arguments[_i];
                        }
                        var duration = loadDuration + Date.now() - getStartTime;
                        // Source getting failed
                        if (!getArgs[0]) {
                            return resolveGet({ error: ensureErrorWithMessage(getArgs[1]), duration: duration });
                        }
                        // Source getting succeeded
                        resolveGet({ value: getArgs[1], duration: duration });
                    });
                });
            });
        });
    });
    return function getComponent() {
        return sourceLoadPromise.then(function (finalizeSource) { return finalizeSource(); });
    };
}
/**
 * Loads the given entropy sources. Returns a function that collects the entropy components.
 *
 * The result is returned synchronously in order to allow start getting the components
 * before the sources are loaded completely.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function loadSources(sources, sourceOptions, excludeSources) {
    var includedSources = Object.keys(sources).filter(function (sourceKey) { return excludes(excludeSources, sourceKey); });
    var sourceGetters = Array(includedSources.length);
    // Using `forEachWithBreaks` allows asynchronous sources to complete between synchronous sources
    // and measure the duration correctly
    forEachWithBreaks(includedSources, function (sourceKey, index) {
        sourceGetters[index] = loadSource(sources[sourceKey], sourceOptions);
    });
    return function getComponents() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var components, _i, includedSources_1, sourceKey, componentPromises, _loop_1, state_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        components = {};
                        for (_i = 0, includedSources_1 = includedSources; _i < includedSources_1.length; _i++) {
                            sourceKey = includedSources_1[_i];
                            components[sourceKey] = undefined;
                        }
                        componentPromises = Array(includedSources.length);
                        _loop_1 = function () {
                            var hasAllComponentPromises;
                            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        hasAllComponentPromises = true;
                                        return [4 /*yield*/, forEachWithBreaks(includedSources, function (sourceKey, index) {
                                                if (!componentPromises[index]) {
                                                    // `sourceGetters` may be incomplete at this point of execution because `forEachWithBreaks` is asynchronous
                                                    if (sourceGetters[index]) {
                                                        componentPromises[index] = sourceGetters[index]().then(function (component) { return (components[sourceKey] = component); });
                                                    }
                                                    else {
                                                        hasAllComponentPromises = false;
                                                    }
                                                }
                                            })];
                                    case 1:
                                        _a.sent();
                                        if (hasAllComponentPromises) {
                                            return [2 /*return*/, "break"];
                                        }
                                        return [4 /*yield*/, wait(1)]; // Lets the source load loop continue
                                    case 2:
                                        _a.sent(); // Lets the source load loop continue
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _a.label = 1;
                    case 1: return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break")
                            return [3 /*break*/, 4];
                        _a.label = 3;
                    case 3: return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, Promise.all(componentPromises)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, components];
                }
            });
        });
    };
}

/*
 * Functions to help with features that vary through browsers
 */
/**
 * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isTrident() {
    var w = window;
    var n = navigator;
    // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
    return (countTruthy([
        'MSCSSMatrix' in w,
        'msSetImmediate' in w,
        'msIndexedDB' in w,
        'msMaxTouchPoints' in n,
        'msPointerEnabled' in n,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isEdgeHTML() {
    // Based on research in October 2020
    var w = window;
    var n = navigator;
    return (countTruthy(['msWriteProfilerMark' in w, 'MSStream' in w, 'msLaunchUri' in n, 'msSaveBlob' in n]) >= 3 &&
        !isTrident());
}
/**
 * Checks whether the browser is based on Chromium without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isChromium() {
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    var w = window;
    var n = navigator;
    return (countTruthy([
        'webkitPersistentStorage' in n,
        'webkitTemporaryStorage' in n,
        n.vendor.indexOf('Google') === 0,
        'webkitResolveLocalFileSystemURL' in w,
        'BatteryManager' in w,
        'webkitMediaStream' in w,
        'webkitSpeechGrammar' in w,
    ]) >= 5);
}
/**
 * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
 * All iOS browsers use WebKit (the Safari engine).
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isWebKit() {
    // Based on research in September 2020
    var w = window;
    var n = navigator;
    return (countTruthy([
        'ApplePayError' in w,
        'CSSPrimitiveValue' in w,
        'Counter' in w,
        n.vendor.indexOf('Apple') === 0,
        'getStorageUpdates' in n,
        'WebKitMediaKeys' in w,
    ]) >= 4);
}
/**
 * Checks whether the WebKit browser is a desktop Safari.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isDesktopSafari() {
    var w = window;
    return (countTruthy([
        'safari' in w,
        !('DeviceMotionEvent' in w),
        !('ongestureend' in w),
        !('standalone' in navigator),
    ]) >= 3);
}
/**
 * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isGecko() {
    var _a, _b;
    var w = window;
    // Based on research in September 2020
    return (countTruthy([
        'buildID' in navigator,
        'MozAppearance' in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
        'onmozfullscreenchange' in w,
        'mozInnerScreenX' in w,
        'CSSMozDocumentRule' in w,
        'CanvasCaptureMediaStream' in w,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */
function isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
    var w = window;
    return (countTruthy([
        !('MediaSettingsRange' in w),
        'RTCEncodedAudioFrame' in w,
        '' + w.Intl === '[object Intl]',
        '' + w.Reflect === '[object Reflect]',
    ]) >= 3);
}
/**
 * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @link https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
 */
function isWebKit606OrNewer() {
    // Checked in Safari 9–14
    var w = window;
    return (countTruthy([
        'DOMRectList' in w,
        'RTCPeerConnectionIceEvent' in w,
        'SVGGeometryElement' in w,
        'ontransitioncancel' in w,
    ]) >= 3);
}
/**
 * Checks whether the device is an iPad.
 * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
 */
function isIPad() {
    // Checked on:
    // Safari on iPadOS (both mobile and desktop modes): 8, 11, 12, 13, 14
    // Chrome on iPadOS (both mobile and desktop modes): 11, 12, 13, 14
    // Safari on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
    // Chrome on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
    // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
    if (navigator.platform === 'iPad') {
        return true;
    }
    var s = screen;
    var screenRatio = s.width / s.height;
    return (countTruthy([
        'MediaSource' in window,
        !!Element.prototype.webkitRequestFullscreen,
        // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
        screenRatio > 0.65 && screenRatio < 1.53,
    ]) >= 2);
}
/**
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getFullscreenElement() {
    var d = document;
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function exitFullscreen() {
    var d = document;
    // `call` is required because the function throws an error without a proper "this" context
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
/**
 * Checks whether the device runs on Android without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isAndroid() {
    var isItChromium = isChromium();
    var isItGecko = isGecko();
    // Only 2 browser engines are presented on Android.
    // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
    if (!isItChromium && !isItGecko) {
        return false;
    }
    var w = window;
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    return (countTruthy([
        'onorientationchange' in w,
        'orientation' in w,
        isItChromium && !('SharedWorker' in w),
        isItGecko && /android/i.test(navigator.appVersion),
    ]) >= 2);
}

/**
 * A deep description: https://fingerprintjs.com/blog/audio-fingerprinting/
 * Inspired by and based on https://github.com/cozylife/audio-fingerprint
 */
function getAudioFingerprint() {
    var w = window;
    var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
    if (!AudioContext) {
        return -2 /* NotSupported */;
    }
    // In some browsers, audio context always stays suspended unless the context is started in response to a user action
    // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
    // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
    // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
    if (doesCurrentBrowserSuspendAudioContext()) {
        return -1 /* KnownToSuspend */;
    }
    var hashFromIndex = 4500;
    var hashToIndex = 5000;
    var context = new AudioContext(1, hashToIndex, 44100);
    var oscillator = context.createOscillator();
    oscillator.type = 'triangle';
    oscillator.frequency.value = 10000;
    var compressor = context.createDynamicsCompressor();
    compressor.threshold.value = -50;
    compressor.knee.value = 40;
    compressor.ratio.value = 12;
    compressor.attack.value = 0;
    compressor.release.value = 0.25;
    oscillator.connect(compressor);
    compressor.connect(context.destination);
    oscillator.start(0);
    var _a = startRenderingAudio(context), renderPromise = _a[0], finishRendering = _a[1];
    var fingerprintPromise = renderPromise.then(function (buffer) { return getHash(buffer.getChannelData(0).subarray(hashFromIndex)); }, function (error) {
        if (error.name === "timeout" /* Timeout */ || error.name === "suspended" /* Suspended */) {
            return -3 /* Timeout */;
        }
        throw error;
    });
    // Suppresses the console error message in case when the fingerprint fails before requested
    fingerprintPromise.catch(function () { return undefined; });
    return function () {
        finishRendering();
        return fingerprintPromise;
    };
}
/**
 * Checks if the current browser is known to always suspend audio context
 */
function doesCurrentBrowserSuspendAudioContext() {
    return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
}
/**
 * Starts rendering the audio context.
 * When the returned function is called, the render process starts finishing.
 */
function startRenderingAudio(context) {
    var renderTryMaxCount = 3;
    var renderRetryDelay = 500;
    var runningMaxAwaitTime = 500;
    var runningSufficientTime = 5000;
    var finalize = function () { return undefined; };
    var resultPromise = new Promise(function (resolve, reject) {
        var isFinalized = false;
        var renderTryCount = 0;
        var startedRunningAt = 0;
        context.oncomplete = function (event) { return resolve(event.renderedBuffer); };
        var startRunningTimeout = function () {
            setTimeout(function () { return reject(makeInnerError("timeout" /* Timeout */)); }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
        };
        var tryRender = function () {
            try {
                context.startRendering();
                switch (context.state) {
                    case 'running':
                        startedRunningAt = Date.now();
                        if (isFinalized) {
                            startRunningTimeout();
                        }
                        break;
                    // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                    // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                    // background on iPhone. Retries usually help in this case.
                    case 'suspended':
                        // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                        // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                        // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                        // can be suspended when `document.hidden === false` and start running after a retry.
                        if (!document.hidden) {
                            renderTryCount++;
                        }
                        if (isFinalized && renderTryCount >= renderTryMaxCount) {
                            reject(makeInnerError("suspended" /* Suspended */));
                        }
                        else {
                            setTimeout(tryRender, renderRetryDelay);
                        }
                        break;
                }
            }
            catch (error) {
                reject(error);
            }
        };
        tryRender();
        finalize = function () {
            if (!isFinalized) {
                isFinalized = true;
                if (startedRunningAt > 0) {
                    startRunningTimeout();
                }
            }
        };
    });
    return [resultPromise, finalize];
}
function getHash(signal) {
    var hash = 0;
    for (var i = 0; i < signal.length; ++i) {
        hash += Math.abs(signal[i]);
    }
    return hash;
}
function makeInnerError(name) {
    var error = new Error(name);
    error.name = name;
    return error;
}

/**
 * Creates and keeps an invisible iframe while the given function runs.
 * The given function is called when the iframe is loaded and has a body.
 * The iframe allows to measure DOM sizes inside itself.
 *
 * Notice: passing an initial HTML code doesn't work in IE.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function withIframe(action, initialHtml, domPollInterval) {
    var _a, _b, _c;
    if (domPollInterval === void 0) { domPollInterval = 50; }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var d, iframe;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    d = document;
                    _d.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 1];
                case 3:
                    iframe = d.createElement('iframe');
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, , 10, 11]);
                    return [4 /*yield*/, new Promise(function (_resolve, _reject) {
                            var isComplete = false;
                            var resolve = function () {
                                isComplete = true;
                                _resolve();
                            };
                            var reject = function (error) {
                                isComplete = true;
                                _reject(error);
                            };
                            iframe.onload = resolve;
                            iframe.onerror = reject;
                            var style = iframe.style;
                            style.setProperty('display', 'block', 'important'); // Required for browsers to calculate the layout
                            style.position = 'absolute';
                            style.top = '0';
                            style.left = '0';
                            style.visibility = 'hidden';
                            if (initialHtml && 'srcdoc' in iframe) {
                                iframe.srcdoc = initialHtml;
                            }
                            else {
                                iframe.src = 'about:blank';
                            }
                            d.body.appendChild(iframe);
                            // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
                            // This code checks for the loading state manually.
                            // See https://github.com/fingerprintjs/fingerprintjs/issues/645
                            var checkReadyState = function () {
                                var _a, _b;
                                // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                                // So an infinite setTimeout loop can happen without this check.
                                // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                                if (isComplete) {
                                    return;
                                }
                                // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                                // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                                if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === 'complete') {
                                    resolve();
                                }
                                else {
                                    setTimeout(checkReadyState, 10);
                                }
                            };
                            checkReadyState();
                        })];
                case 5:
                    _d.sent();
                    _d.label = 6;
                case 6:
                    if (!!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body)) return [3 /*break*/, 8];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 7:
                    _d.sent();
                    return [3 /*break*/, 6];
                case 8: return [4 /*yield*/, action(iframe, iframe.contentWindow)];
                case 9: return [2 /*return*/, _d.sent()];
                case 10:
                    (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    });
}
/**
 * Creates a DOM element that matches the given selector.
 * Only single element selector are supported (without operators like space, +, >, etc).
 */
function selectorToElement(selector) {
    var _a = parseSimpleCssSelector(selector), tag = _a[0], attributes = _a[1];
    var element = document.createElement(tag !== null && tag !== void 0 ? tag : 'div');
    for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
        var name_1 = _b[_i];
        var value = attributes[name_1].join(' ');
        // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
        // https://github.com/fingerprintjs/fingerprintjs/issues/733
        if (name_1 === 'style') {
            addStyleString(element.style, value);
        }
        else {
            element.setAttribute(name_1, value);
        }
    }
    return element;
}
/**
 * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
 */
function addStyleString(style, source) {
    // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
    // Even though the browsers ignore this standard, we don't use `cssText` just in case.
    for (var _i = 0, _a = source.split(';'); _i < _a.length; _i++) {
        var property = _a[_i];
        var match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
        if (match) {
            var name_2 = match[1], value = match[2], priority = match[4];
            style.setProperty(name_2, value, priority || ''); // The last argument can't be undefined in IE11
        }
    }
}

// We use m or w because these two characters take up the maximum width.
// And we use a LLi so that the same matching fonts can get separated.
var testString = 'mmMwWLliI0O&1';
// We test using 48px font size, we may use any size. I guess larger the better.
var textSize = '48px';
// A font will be compared against all the three default fonts.
// And if for any default fonts it doesn't match, then that font is available.
var baseFonts = ['monospace', 'sans-serif', 'serif'];
var fontList = [
    // This is android-specific font from "Roboto" family
    'sans-serif-thin',
    'ARNO PRO',
    'Agency FB',
    'Arabic Typesetting',
    'Arial Unicode MS',
    'AvantGarde Bk BT',
    'BankGothic Md BT',
    'Batang',
    'Bitstream Vera Sans Mono',
    'Calibri',
    'Century',
    'Century Gothic',
    'Clarendon',
    'EUROSTILE',
    'Franklin Gothic',
    'Futura Bk BT',
    'Futura Md BT',
    'GOTHAM',
    'Gill Sans',
    'HELV',
    'Haettenschweiler',
    'Helvetica Neue',
    'Humanst521 BT',
    'Leelawadee',
    'Letter Gothic',
    'Levenim MT',
    'Lucida Bright',
    'Lucida Sans',
    'Menlo',
    'MS Mincho',
    'MS Outlook',
    'MS Reference Specialty',
    'MS UI Gothic',
    'MT Extra',
    'MYRIAD PRO',
    'Marlett',
    'Meiryo UI',
    'Microsoft Uighur',
    'Minion Pro',
    'Monotype Corsiva',
    'PMingLiU',
    'Pristina',
    'SCRIPTINA',
    'Segoe UI Light',
    'Serifa',
    'SimHei',
    'Small Fonts',
    'Staccato222 BT',
    'TRAJAN PRO',
    'Univers CE 55 Medium',
    'Vrinda',
    'ZWAdobeF',
];
// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
function getFonts() {
    // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
    // https://github.com/fingerprintjs/fingerprintjs/issues/592
    // https://github.com/fingerprintjs/fingerprintjs/issues/628
    return withIframe(function (_, _a) {
        var document = _a.document;
        var holder = document.body;
        holder.style.fontSize = textSize;
        // div to load spans for the default fonts and the fonts to detect
        var spansContainer = document.createElement('div');
        var defaultWidth = {};
        var defaultHeight = {};
        // creates a span where the fonts will be loaded
        var createSpan = function (fontFamily) {
            var span = document.createElement('span');
            var style = span.style;
            style.position = 'absolute';
            style.top = '0';
            style.left = '0';
            style.fontFamily = fontFamily;
            span.textContent = testString;
            spansContainer.appendChild(span);
            return span;
        };
        // creates a span and load the font to detect and a base font for fallback
        var createSpanWithFonts = function (fontToDetect, baseFont) {
            return createSpan("'" + fontToDetect + "'," + baseFont);
        };
        // creates spans for the base fonts and adds them to baseFontsDiv
        var initializeBaseFontsSpans = function () {
            return baseFonts.map(createSpan);
        };
        // creates spans for the fonts to detect and adds them to fontsDiv
        var initializeFontsSpans = function () {
            // Stores {fontName : [spans for that font]}
            var spans = {};
            var _loop_1 = function (font) {
                spans[font] = baseFonts.map(function (baseFont) { return createSpanWithFonts(font, baseFont); });
            };
            for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
                var font = fontList_1[_i];
                _loop_1(font);
            }
            return spans;
        };
        // checks if a font is available
        var isFontAvailable = function (fontSpans) {
            return baseFonts.some(function (baseFont, baseFontIndex) {
                return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
                    fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
            });
        };
        // create spans for base fonts
        var baseFontsSpans = initializeBaseFontsSpans();
        // create spans for fonts to detect
        var fontsSpans = initializeFontsSpans();
        // add all the spans to the DOM
        holder.appendChild(spansContainer);
        // get the default width for the three base fonts
        for (var index = 0; index < baseFonts.length; index++) {
            defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
            defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
        }
        // check available fonts
        return fontList.filter(function (font) { return isFontAvailable(fontsSpans[font]); });
    });
}

function getPlugins() {
    var rawPlugins = navigator.plugins;
    if (!rawPlugins) {
        return undefined;
    }
    var plugins = [];
    // Safari 10 doesn't support iterating navigator.plugins with for...of
    for (var i = 0; i < rawPlugins.length; ++i) {
        var plugin = rawPlugins[i];
        if (!plugin) {
            continue;
        }
        var mimeTypes = [];
        for (var j = 0; j < plugin.length; ++j) {
            var mimeType = plugin[j];
            mimeTypes.push({
                type: mimeType.type,
                suffixes: mimeType.suffixes,
            });
        }
        plugins.push({
            name: plugin.name,
            description: plugin.description,
            mimeTypes: mimeTypes,
        });
    }
    return plugins;
}

// https://www.browserleaks.com/canvas#how-does-it-work
function getCanvasFingerprint() {
    var _a = makeCanvasContext(), canvas = _a[0], context = _a[1];
    if (!isSupported(canvas, context)) {
        return { winding: false, geometry: '', text: '' };
    }
    return {
        winding: doesSupportWinding(context),
        geometry: makeGeometryImage(canvas, context),
        // Text is unstable:
        // https://github.com/fingerprintjs/fingerprintjs/issues/583
        // https://github.com/fingerprintjs/fingerprintjs/issues/103
        // Therefore it's extracted into a separate image.
        text: makeTextImage(canvas, context),
    };
}
function makeCanvasContext() {
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return [canvas, canvas.getContext('2d')];
}
function isSupported(canvas, context) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, 'evenodd');
}
function makeTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = 'alphabetic';
    context.fillStyle = '#f60';
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = '#069';
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    var printedText = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835) /* 😃 */;
    context.fillText(printedText, 2, 15);
    context.fillStyle = 'rgba(102, 204, 0, 0.2)';
    context.font = '18pt Arial';
    context.fillText(printedText, 4, 45);
    return save(canvas);
}
function makeGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = 'multiply';
    for (var _i = 0, _a = [
        ['#f2f', 40, 40],
        ['#2ff', 80, 40],
        ['#ff2', 60, 80],
    ]; _i < _a.length; _i++) {
        var _b = _a[_i], color = _b[0], x = _b[1], y = _b[2];
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = '#f9c';
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill('evenodd');
    return save(canvas);
}
function save(canvas) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return canvas.toDataURL();
}

/**
 * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
 * of a touch screen with a JS, without actually subscribing to a touch event.
 *
 * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
 * @see https://github.com/Modernizr/Modernizr/issues/548
 */
function getTouchSupport() {
    var n = navigator;
    var maxTouchPoints = 0;
    var touchEvent;
    if (n.maxTouchPoints !== undefined) {
        maxTouchPoints = toInt(n.maxTouchPoints);
    }
    else if (n.msMaxTouchPoints !== undefined) {
        maxTouchPoints = n.msMaxTouchPoints;
    }
    try {
        document.createEvent('TouchEvent');
        touchEvent = true;
    }
    catch (_a) {
        touchEvent = false;
    }
    var touchStart = 'ontouchstart' in window;
    return {
        maxTouchPoints: maxTouchPoints,
        touchEvent: touchEvent,
        touchStart: touchStart,
    };
}

function getOsCpu() {
    return navigator.oscpu;
}

function getLanguages() {
    var n = navigator;
    var result = [];
    var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
        result.push([language]);
    }
    if (Array.isArray(n.languages)) {
        // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
        // the value of `navigator.language`. Therefore the value is ignored in this browser.
        if (!(isChromium() && isChromium86OrNewer())) {
            result.push(n.languages);
        }
    }
    else if (typeof n.languages === 'string') {
        var languages = n.languages;
        if (languages) {
            result.push(languages.split(','));
        }
    }
    return result;
}

function getColorDepth() {
    return window.screen.colorDepth;
}

function getDeviceMemory() {
    // `navigator.deviceMemory` is a string containing a number in some unidentified cases
    return replaceNaN(toFloat(navigator.deviceMemory), undefined);
}

function getScreenResolution() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    // Some browsers even return  screen resolution as not numbers.
    var parseDimension = function (value) { return replaceNaN(toInt(value), null); };
    var dimensions = [parseDimension(s.width), parseDimension(s.height)];
    dimensions.sort().reverse();
    return dimensions;
}

var screenFrameCheckInterval = 2500;
var roundingPrecision = 10;
// The type is readonly to protect from unwanted mutations
var screenFrameBackup;
var screenFrameSizeTimeoutId;
/**
 * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
 * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
 *
 * This trick is required to mitigate the fact that the screen frame turns null in some cases.
 * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
 */
function watchScreenFrame() {
    if (screenFrameSizeTimeoutId !== undefined) {
        return;
    }
    var checkScreenFrame = function () {
        var frameSize = getCurrentScreenFrame();
        if (isFrameSizeNull(frameSize)) {
            screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
        }
        else {
            screenFrameBackup = frameSize;
            screenFrameSizeTimeoutId = undefined;
        }
    };
    checkScreenFrame();
}
function getScreenFrame() {
    var _this = this;
    watchScreenFrame();
    return function () { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
        var frameSize;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    frameSize = getCurrentScreenFrame();
                    if (!isFrameSizeNull(frameSize)) return [3 /*break*/, 2];
                    if (screenFrameBackup) {
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spreadArrays"])(screenFrameBackup)];
                    }
                    if (!getFullscreenElement()) return [3 /*break*/, 2];
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    return [4 /*yield*/, exitFullscreen()];
                case 1:
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    _a.sent();
                    frameSize = getCurrentScreenFrame();
                    _a.label = 2;
                case 2:
                    if (!isFrameSizeNull(frameSize)) {
                        screenFrameBackup = frameSize;
                    }
                    return [2 /*return*/, frameSize];
            }
        });
    }); };
}
/**
 * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
 * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
 */
function getRoundedScreenFrame() {
    var _this = this;
    var screenFrameGetter = getScreenFrame();
    return function () { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
        var frameSize, processSize;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, screenFrameGetter()];
                case 1:
                    frameSize = _a.sent();
                    processSize = function (sideSize) { return (sideSize === null ? null : round(sideSize, roundingPrecision)); };
                    // It might look like I don't know about `for` and `map`.
                    // In fact, such code is used to avoid TypeScript issues without using `as`.
                    return [2 /*return*/, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
            }
        });
    }); };
}
function getCurrentScreenFrame() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    //
    // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
    // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
    return [
        replaceNaN(toFloat(s.availTop), null),
        replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
        replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
        replaceNaN(toFloat(s.availLeft), null),
    ];
}
function isFrameSizeNull(frameSize) {
    for (var i = 0; i < 4; ++i) {
        if (frameSize[i]) {
            return false;
        }
    }
    return true;
}

function getHardwareConcurrency() {
    // sometimes hardware concurrency is a string
    return replaceNaN(toInt(navigator.hardwareConcurrency), undefined);
}

function getTimezone() {
    var _a;
    var DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
        var timezone = new DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) {
            return timezone;
        }
    }
    // For browsers that don't support timezone names
    // The minus is intentional because the JS offset is opposite to the real offset
    var offset = -getTimezoneOffset();
    return "UTC" + (offset >= 0 ? '+' : '') + Math.abs(offset);
}
function getTimezoneOffset() {
    var currentYear = new Date().getFullYear();
    // The timezone offset may change over time due to daylight saving time (DST) shifts.
    // The non-DST timezone offset is used as the result timezone offset.
    // Since the DST season differs in the northern and the southern hemispheres,
    // both January and July timezones offsets are considered.
    return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}

function getSessionStorage() {
    try {
        return !!window.sessionStorage;
    }
    catch (error) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
function getLocalStorage() {
    try {
        return !!window.localStorage;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getIndexedDB() {
    // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
    // visitor identifier in normal and private modes.
    if (isTrident() || isEdgeHTML()) {
        return undefined;
    }
    try {
        return !!window.indexedDB;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getOpenDatabase() {
    return !!window.openDatabase;
}

function getCpuClass() {
    return navigator.cpuClass;
}

function getPlatform() {
    // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
    var platform = navigator.platform;
    // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
    // iPad uses desktop mode by default since iOS 13
    // The value is 'MacIntel' on M1 Macs
    // The value is 'iPhone' on iPod Touch
    if (platform === 'MacIntel') {
        if (isWebKit() && !isDesktopSafari()) {
            return isIPad() ? 'iPad' : 'iPhone';
        }
    }
    return platform;
}

function getVendor() {
    return navigator.vendor || '';
}

/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */
function getVendorFlavors() {
    var flavors = [];
    for (var _i = 0, _a = [
        // Blink and some browsers on iOS
        'chrome',
        // Safari on macOS
        'safari',
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        '__crWeb',
        '__gCrWeb',
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        'yandex',
        // Yandex Browser on iOS (checked in 21.2 on 14)
        '__yb',
        '__ybro',
        // Firefox on iOS (checked in 32 on 14)
        '__firefox__',
        // Edge on iOS (checked in 46 on 14)
        '__edgeTrackingPreventionStatistics',
        'webkit',
        // Opera Touch on iOS (checked in 2.6 on 14)
        'oprt',
        // Samsung Internet on Android (checked in 11.1)
        'samsungAr',
        // UC Browser on Android (checked in 12.10 and 13.0)
        'ucweb',
        'UCShellJava',
        // Puffin on Android (checked in 9.0)
        'puffinDevice',
    ]; _i < _a.length; _i++) {
        var key = _a[_i];
        var value = window[key];
        if (value && typeof value === 'object') {
            flavors.push(key);
        }
    }
    return flavors.sort();
}

/**
 * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
 * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
 * site-specific exceptions. Don't rely on it.
 *
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
 */
function areCookiesEnabled() {
    var d = document;
    // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
    // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
    // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
    // with site-specific exceptions. Don't rely on it.
    // try..catch because some in situations `document.cookie` is exposed but throws a
    // SecurityError if you try to access it; e.g. documents created from data URIs
    // or in sandboxed iframes (depending on flags/context)
    try {
        // Create cookie
        d.cookie = 'cookietest=1; SameSite=Strict;';
        var result = d.cookie.indexOf('cookietest=') !== -1;
        // Delete cookie
        d.cookie = 'cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return result;
    }
    catch (e) {
        return false;
    }
}

/**
 * Only single element selector are supported (no operators like space, +, >, etc).
 * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
 * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
 *
 * See docs/content_blockers.md to learn how to make the list
 */
var filters = {
    abpIndo: [
        '#Iklan-Melayang',
        '#Kolom-Iklan-728',
        '#SidebarIklan-wrapper',
        'a[title="7naga poker" i]',
        '[title="ALIENBOLA" i]',
    ],
    abpvn: [
        '#quangcaomb',
        '.iosAdsiosAds-layout',
        '.quangcao',
        '[href^="https://r88.vn/"]',
        '[href^="https://zbet.vn/"]',
    ],
    adBlockFinland: [
        '.mainostila',
        '.sponsorit',
        '.ylamainos',
        'a[href*="/clickthrgh.asp?"]',
        'a[href^="https://app.readpeak.com/ads"]',
    ],
    adBlockPersian: [
        '#navbar_notice_50',
        'a[href^="http://g1.v.fwmrm.net/ad/"]',
        '.kadr',
        'TABLE[width="140px"]',
        '#divAgahi',
    ],
    adBlockWarningRemoval: ['#adblock-honeypot', '.adblocker-root', '.wp_adblock_detect'],
    adGuardAnnoyances: ['amp-embed[type="zen"]', '.hs-sosyal', '#cookieconsentdiv', 'div[class^="app_gdpr"]', '.as-oil'],
    adGuardBase: ['#ad-after', '#ad-p3', '.BetterJsPopOverlay', '#ad_300X250', '#bannerfloat22'],
    adGuardChinese: [
        // Disabled because not reproducible. Will be replaced during the next filter update.
        // '#piao_div_0[style*="width:140px;"]',
        'a[href*=".ttz5.cn"]',
        'a[href*=".yabovip2027.com/"]',
        '.tm3all2h4b',
        '.cc5278_banner_ad',
    ],
    adGuardFrench: [
        '.zonepub',
        '[class*="_adLeaderboard"]',
        '[id^="block-xiti_oas-"]',
        'a[href^="http://ptapjmp.com/"]',
        'a[href^="https://go.alvexo.com/"]',
    ],
    adGuardGerman: [
        '.banneritemwerbung_head_1',
        '.boxstartwerbung',
        '.werbung3',
        'a[href^="http://www.eis.de/index.phtml?refid="]',
        'a[href^="https://www.tipico.com/?affiliateId="]',
    ],
    adGuardJapanese: [
        '#kauli_yad_1',
        '#ad-giftext',
        '#adsSPRBlock',
        'a[href^="http://ad2.trafficgate.net/"]',
        'a[href^="http://www.rssad.jp/"]',
    ],
    adGuardMobile: ['amp-auto-ads', '#mgid_iframe', '.amp_ad', 'amp-embed[type="24smi"]', '#mgid_iframe1'],
    adGuardRussian: [
        'a[href^="https://ya-distrib.ru/r/"]',
        'a[href^="https://ad.letmeads.com/"]',
        '.reclama',
        'div[id^="smi2adblock"]',
        'div[id^="AdFox_banner_"]',
    ],
    adGuardSocial: [
        'a[href^="//www.stumbleupon.com/submit?url="]',
        'a[href^="//telegram.me/share/url?"]',
        '.etsy-tweet',
        '#inlineShare',
        '.popup-social',
    ],
    adGuardSpanishPortuguese: [
        '#barraPublicidade',
        '#Publicidade',
        '#publiEspecial',
        '#queTooltip',
        '[href^="http://ads.glispa.com/"]',
    ],
    adGuardTrackingProtection: [
        'amp-embed[type="taboola"]',
        '#qoo-counter',
        'a[href^="http://click.hotlog.ru/"]',
        'a[href^="http://hitcounter.ru/top/stat.php"]',
        'a[href^="http://top.mail.ru/jump"]',
    ],
    adGuardTurkish: [
        '#backkapat',
        '#reklami',
        'a[href^="http://adserv.ontek.com.tr/"]',
        'a[href^="http://izlenzi.com/campaign/"]',
        'a[href^="http://www.installads.net/"]',
    ],
    bulgarian: ['td#freenet_table_ads', '#adbody', '#ea_intext_div', '.lapni-pop-over', '#xenium_hot_offers'],
    easyList: ['#AD_banner_bottom', '#Ads_google_02', '#N-ad-article-rightRail-1', '#ad-fullbanner2', '#ad-zone-2'],
    easyListChina: [
        'a[href*=".wensixuetang.com/"]',
        'A[href*="/hth107.com/"]',
        '.appguide-wrap[onclick*="bcebos.com"]',
        '.frontpageAdvM',
        '#taotaole',
    ],
    easyListCookie: ['#adtoniq-msg-bar', '#CoockiesPage', '#CookieModal_cookiemodal', '#DO_CC_PANEL', '#ShowCookie'],
    easyListCzechSlovak: ['#onlajny-stickers', '#reklamni-box', '.reklama-megaboard', '.sklik', '[id^="sklikReklama"]'],
    easyListDutch: [
        '#advertentie',
        '#vipAdmarktBannerBlock',
        '.adstekst',
        'a[href^="https://xltube.nl/click/"]',
        '#semilo-lrectangle',
    ],
    easyListGermany: [
        'a[href^="http://www.hw-area.com/?dp="]',
        'a[href^="https://ads.sunmaker.com/tracking.php?"]',
        '.werbung-skyscraper2',
        '.bannergroup_werbung',
        '.ads_rechts',
    ],
    easyListItaly: [
        '.box_adv_annunci',
        '.sb-box-pubbliredazionale',
        'a[href^="http://affiliazioniads.snai.it/"]',
        'a[href^="https://adserver.html.it/"]',
        'a[href^="https://affiliazioniads.snai.it/"]',
    ],
    easyListLithuania: [
        '.reklamos_tarpas',
        '.reklamos_nuorodos',
        'img[alt="Reklaminis skydelis"]',
        'img[alt="Dedikuoti.lt serveriai"]',
        'img[alt="Hostingas Serveriai.lt"]',
    ],
    estonian: ['A[href*="http://pay4results24.eu"]'],
    fanboyAnnoyances: [
        '#feedback-tab',
        '#taboola-below-article',
        '.feedburnerFeedBlock',
        '.widget-feedburner-counter',
        '[title="Subscribe to our blog"]',
    ],
    fanboyAntiFacebook: ['.util-bar-module-firefly-visible'],
    fanboyEnhancedTrackers: [
        '.open.pushModal',
        '#issuem-leaky-paywall-articles-zero-remaining-nag',
        '#sovrn_container',
        'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
        '.BlockNag__Card',
    ],
    fanboySocial: [
        '.td-tags-and-social-wrapper-box',
        '.twitterContainer',
        '.youtube-social',
        'a[title^="Like us on Facebook"]',
        'img[alt^="Share on Digg"]',
    ],
    frellwitSwedish: [
        'a[href*="casinopro.se"][target="_blank"]',
        'a[href*="doktor-se.onelink.me"]',
        'article.category-samarbete',
        'div.holidAds',
        'ul.adsmodern',
    ],
    greekAdBlock: [
        'A[href*="adman.otenet.gr/click?"]',
        'A[href*="http://axiabanners.exodus.gr/"]',
        'A[href*="http://interactive.forthnet.gr/click?"]',
        'DIV.agores300',
        'TABLE.advright',
    ],
    hungarian: [
        'A[href*="ad.eval.hu"]',
        'A[href*="ad.netmedia.hu"]',
        'A[href*="daserver.ultraweb.hu"]',
        '#cemp_doboz',
        '.optimonk-iframe-container',
    ],
    iDontCareAboutCookies: [
        '.alert-info[data-block-track*="CookieNotice"]',
        '.ModuleTemplateCookieIndicator',
        '.o--cookies--container',
        '.cookie-msg-info-container',
        '#cookies-policy-sticky',
    ],
    icelandicAbp: ['A[href^="/framework/resources/forms/ads.aspx"]'],
    latvian: [
        'a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
        'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]',
    ],
    listKr: [
        'a[href*="//kingtoon.slnk.kr"]',
        'a[href*="//playdsb.com/kr"]',
        'div.logly-lift-adz',
        'div[data-widget_id="ml6EJ074"]',
        'ins.daum_ddn_area',
    ],
    listeAr: [
        '.geminiLB1Ad',
        '.right-and-left-sponsers',
        'a[href*=".aflam.info"]',
        'a[href*="booraq.org"]',
        'a[href*="dubizzle.com/ar/?utm_source="]',
    ],
    listeFr: [
        'a[href^="http://promo.vador.com/"]',
        '#adcontainer_recherche',
        'a[href*="weborama.fr/fcgi-bin/"]',
        '.site-pub-interstitiel',
        'div[id^="crt-"][data-criteo-id]',
    ],
    officialPolish: [
        '#ceneo-placeholder-ceneo-12',
        '[href^="https://aff.sendhub.pl/"]',
        'a[href^="http://advmanager.techfun.pl/redirect/"]',
        'a[href^="http://www.trizer.pl/?utm_source"]',
        'div#skapiec_ad',
    ],
    ro: [
        'a[href^="//afftrk.altex.ro/Counter/Click"]',
        'a[href^="/magazin/"]',
        'a[href^="https://blackfridaysales.ro/trk/shop/"]',
        'a[href^="https://event.2performant.com/events/click"]',
        'a[href^="https://l.profitshare.ro/"]',
    ],
    ruAd: [
        'a[href*="//febrare.ru/"]',
        'a[href*="//utimg.ru/"]',
        'a[href*="://chikidiki.ru"]',
        '#pgeldiz',
        '.yandex-rtb-block',
    ],
    thaiAds: ['a[href*=macau-uta-popup]', '#ads-google-middle_rectangle-group', '.ads300s', '.bumq', '.img-kosana'],
    webAnnoyancesUltralist: [
        '#mod-social-share-2',
        '#social-tools',
        '.ctpl-fullbanner',
        '.zergnet-recommend',
        '.yt.btn-link.btn-md.btn',
    ],
};
/**
 * The order of the returned array means nothing (it's always sorted alphabetically).
 *
 * Notice that the source is slightly unstable.
 * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
 * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
 * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
 * If you are a website owner, don't make your visitors want to disable content blockers.
 */
function getDomBlockers(_a) {
    var debug = (_a === void 0 ? {} : _a).debug;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var filterNames, allSelectors, blockedSelectors, activeBlockers;
        var _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!isApplicable()) {
                        return [2 /*return*/, undefined];
                    }
                    filterNames = Object.keys(filters);
                    allSelectors = (_b = []).concat.apply(_b, filterNames.map(function (filterName) { return filters[filterName]; }));
                    return [4 /*yield*/, getBlockedSelectors(allSelectors)];
                case 1:
                    blockedSelectors = _c.sent();
                    if (debug) {
                        printDebug(blockedSelectors);
                    }
                    activeBlockers = filterNames.filter(function (filterName) {
                        var selectors = filters[filterName];
                        var blockedCount = countTruthy(selectors.map(function (selector) { return blockedSelectors[selector]; }));
                        return blockedCount > selectors.length * 0.6;
                    });
                    activeBlockers.sort();
                    return [2 /*return*/, activeBlockers];
            }
        });
    });
}
function isApplicable() {
    // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
    return isWebKit() || isAndroid();
}
function getBlockedSelectors(selectors) {
    var _a;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var d, root, elements, blockedSelectors, i, element, holder, i;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    d = document;
                    root = d.createElement('div');
                    elements = new Array(selectors.length);
                    blockedSelectors = {} // Set() isn't used just in case somebody need older browser support
                    ;
                    forceShow(root);
                    // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
                    // browser will alternate tree modification and layout reading, that is very slow.
                    for (i = 0; i < selectors.length; ++i) {
                        element = selectorToElement(selectors[i]);
                        holder = d.createElement('div') // Protects from unwanted effects of `+` and `~` selectors of filters
                        ;
                        forceShow(holder);
                        holder.appendChild(element);
                        root.appendChild(holder);
                        elements[i] = element;
                    }
                    _b.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(50)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 1];
                case 3:
                    d.body.appendChild(root);
                    try {
                        // Then check which of the elements are blocked
                        for (i = 0; i < selectors.length; ++i) {
                            if (!elements[i].offsetParent) {
                                blockedSelectors[selectors[i]] = true;
                            }
                        }
                    }
                    finally {
                        // Then remove the elements
                        (_a = root.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(root);
                    }
                    return [2 /*return*/, blockedSelectors];
            }
        });
    });
}
function forceShow(element) {
    element.style.setProperty('display', 'block', 'important');
}
function printDebug(blockedSelectors) {
    var message = 'DOM blockers debug:\n```';
    for (var _i = 0, _a = Object.keys(filters); _i < _a.length; _i++) {
        var filterName = _a[_i];
        message += "\n" + filterName + ":";
        for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
            var selector = _c[_b];
            message += "\n  " + selector + " " + (blockedSelectors[selector] ? '🚫' : '➡️');
        }
    }
    // console.log is ok here because it's under a debug clause
    // eslint-disable-next-line no-console
    console.log(message + "\n```");
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */
function getColorGamut() {
    // rec2020 includes p3 and p3 includes srgb
    for (var _i = 0, _a = ['rec2020', 'p3', 'srgb']; _i < _a.length; _i++) {
        var gamut = _a[_i];
        if (matchMedia("(color-gamut: " + gamut + ")").matches) {
            return gamut;
        }
    }
    return undefined;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
 */
function areColorsInverted() {
    if (doesMatch('inverted')) {
        return true;
    }
    if (doesMatch('none')) {
        return false;
    }
    return undefined;
}
function doesMatch(value) {
    return matchMedia("(inverted-colors: " + value + ")").matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
 */
function areColorsForced() {
    if (doesMatch$1('active')) {
        return true;
    }
    if (doesMatch$1('none')) {
        return false;
    }
    return undefined;
}
function doesMatch$1(value) {
    return matchMedia("(forced-colors: " + value + ")").matches;
}

var maxValueToCheck = 100;
/**
 * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
 * If the display is not monochrome, the returned value will be 0.
 * If the browser doesn't support this feature, the returned value will be undefined.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
 */
function getMonochromeDepth() {
    if (!matchMedia('(min-monochrome: 0)').matches) {
        // The media feature isn't supported by the browser
        return undefined;
    }
    // A variation of binary search algorithm can be used here.
    // But since expected values are very small (≤10), there is no sense in adding the complexity.
    for (var i = 0; i <= maxValueToCheck; ++i) {
        if (matchMedia("(max-monochrome: " + i + ")").matches) {
            return i;
        }
    }
    throw new Error('Too high value');
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
 */
function getContrastPreference() {
    if (doesMatch$2('no-preference')) {
        return 0 /* None */;
    }
    // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
    // Need to check it when all browsers implement the feature.
    if (doesMatch$2('high') || doesMatch$2('more')) {
        return 1 /* More */;
    }
    if (doesMatch$2('low') || doesMatch$2('less')) {
        return -1 /* Less */;
    }
    if (doesMatch$2('forced')) {
        return 10 /* ForcedColors */;
    }
    return undefined;
}
function doesMatch$2(value) {
    return matchMedia("(prefers-contrast: " + value + ")").matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
function isMotionReduced() {
    if (doesMatch$3('reduce')) {
        return true;
    }
    if (doesMatch$3('no-preference')) {
        return false;
    }
    return undefined;
}
function doesMatch$3(value) {
    return matchMedia("(prefers-reduced-motion: " + value + ")").matches;
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
 */
function isHDR() {
    if (doesMatch$4('high')) {
        return true;
    }
    if (doesMatch$4('standard')) {
        return false;
    }
    return undefined;
}
function doesMatch$4(value) {
    return matchMedia("(dynamic-range: " + value + ")").matches;
}

var M = Math; // To reduce the minified code size
var fallbackFn = function () { return 0; };
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */
function getMathFingerprint() {
    // Native operations
    var acos = M.acos || fallbackFn;
    var acosh = M.acosh || fallbackFn;
    var asin = M.asin || fallbackFn;
    var asinh = M.asinh || fallbackFn;
    var atanh = M.atanh || fallbackFn;
    var atan = M.atan || fallbackFn;
    var sin = M.sin || fallbackFn;
    var sinh = M.sinh || fallbackFn;
    var cos = M.cos || fallbackFn;
    var cosh = M.cosh || fallbackFn;
    var tan = M.tan || fallbackFn;
    var tanh = M.tanh || fallbackFn;
    var exp = M.exp || fallbackFn;
    var expm1 = M.expm1 || fallbackFn;
    var log1p = M.log1p || fallbackFn;
    // Operation polyfills
    var powPI = function (value) { return M.pow(M.PI, value); };
    var acoshPf = function (value) { return M.log(value + M.sqrt(value * value - 1)); };
    var asinhPf = function (value) { return M.log(value + M.sqrt(value * value + 1)); };
    var atanhPf = function (value) { return M.log((1 + value) / (1 - value)) / 2; };
    var sinhPf = function (value) { return M.exp(value) - 1 / M.exp(value) / 2; };
    var coshPf = function (value) { return (M.exp(value) + 1 / M.exp(value)) / 2; };
    var expm1Pf = function (value) { return M.exp(value) - 1; };
    var tanhPf = function (value) { return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1); };
    var log1pPf = function (value) { return M.log(1 + value); };
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1e300),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1e300),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100),
    };
}

/**
 * We use m or w because these two characters take up the maximum width.
 * Also there are a couple of ligatures.
 */
var defaultText = 'mmMwWLliI0fiflO&1';
/**
 * Settings of text blocks to measure. The keys are random but persistent words.
 */
var presets = {
    /**
     * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
     * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
     */
    default: [],
    /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
    apple: [{ font: '-apple-system-body' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    serif: [{ fontFamily: 'serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    sans: [{ fontFamily: 'sans-serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    mono: [{ fontFamily: 'monospace' }],
    /**
     * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
     * The height can be 0 in Chrome on a retina display.
     */
    min: [{ fontSize: '1px' }],
    /** Tells one OS from another in desktop Chrome. */
    system: [{ fontFamily: 'system-ui' }],
};
/**
 * The result is a dictionary of the width of the text samples.
 * Heights aren't included because they give no extra entropy and are unstable.
 *
 * The result is very stable in IE 11, Edge 18 and Safari 14.
 * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
 * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
 * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
 */
function getFontPreferences() {
    return withNaturalFonts(function (document, container) {
        var elements = {};
        var sizes = {};
        // First create all elements to measure. If the DOM steps below are done in a single cycle,
        // browser will alternate tree modification and layout reading, that is very slow.
        for (var _i = 0, _a = Object.keys(presets); _i < _a.length; _i++) {
            var key = _a[_i];
            var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
            var element = document.createElement('span');
            element.textContent = text;
            element.style.whiteSpace = 'nowrap';
            for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
                var name_1 = _f[_e];
                var value = style[name_1];
                if (value !== undefined) {
                    element.style[name_1] = value;
                }
            }
            elements[key] = element;
            container.appendChild(document.createElement('br'));
            container.appendChild(element);
        }
        // Then measure the created elements
        for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
            var key = _h[_g];
            sizes[key] = elements[key].getBoundingClientRect().width;
        }
        return sizes;
    });
}
/**
 * Creates a DOM environment that provides the most natural font available, including Android OS font.
 * Measurements of the elements are zoom-independent.
 * Don't put a content to measure inside an absolutely positioned element.
 */
function withNaturalFonts(action, containerWidthPx) {
    if (containerWidthPx === void 0) { containerWidthPx = 4000; }
    /*
     * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
     * - The iframe mustn't have a `display: none;` style;
     * - The text mustn't be positioned absolutely;
     * - The text block must be wide enough.
     *   2560px on some devices in portrait orientation for the biggest font size option (32px);
     * - There must be much enough text to form a few lines (I don't know the exact numbers);
     * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
     *
     * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
     * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
     *   The only way to set it is to use the `srcdoc` attribute of the iframe;
     * - The iframe content must get loaded before adding extra content with JavaScript;
     *
     * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
     *
     * Observations on how page zoom affects the measurements:
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
     * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
     * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
     * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - iOS Safari 14.0: offsetWidth = 100% reliable;
     * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
     * - Chrome 87: offsetWidth = 1px fluctuation;
     * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
     * - Firefox 48, 51: offsetWidth = 10% fluctuation;
     * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
     *   fluctuation;
     * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
     * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
     *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
     *   fluctuate;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
     * - IE 11, Edge 18: offsetWidth = 100% reliable;
     * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
     */
    return withIframe(function (_, iframeWindow) {
        var iframeDocument = iframeWindow.document;
        var iframeBody = iframeDocument.body;
        var bodyStyle = iframeBody.style;
        bodyStyle.width = containerWidthPx + "px";
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = 'none';
        // See the big comment above
        if (isChromium()) {
            iframeBody.style.zoom = "" + 1 / iframeWindow.devicePixelRatio;
        }
        else if (isWebKit()) {
            iframeBody.style.zoom = 'reset';
        }
        // See the big comment above
        var linesOfText = iframeDocument.createElement('div');
        linesOfText.textContent = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spreadArrays"])(Array((containerWidthPx / 20) << 0)).map(function () { return 'word'; }).join(' ');
        iframeBody.appendChild(linesOfText);
        return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}

/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 */
var sources = {
    // READ FIRST:
    // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
    // to learn how entropy source works and how to make your own.
    // The sources run in this exact order.
    // The asynchronous sources are at the start to run in parallel with other sources.
    fonts: getFonts,
    domBlockers: getDomBlockers,
    fontPreferences: getFontPreferences,
    audio: getAudioFingerprint,
    screenFrame: getRoundedScreenFrame,
    osCpu: getOsCpu,
    languages: getLanguages,
    colorDepth: getColorDepth,
    deviceMemory: getDeviceMemory,
    screenResolution: getScreenResolution,
    hardwareConcurrency: getHardwareConcurrency,
    timezone: getTimezone,
    sessionStorage: getSessionStorage,
    localStorage: getLocalStorage,
    indexedDB: getIndexedDB,
    openDatabase: getOpenDatabase,
    cpuClass: getCpuClass,
    platform: getPlatform,
    plugins: getPlugins,
    canvas: getCanvasFingerprint,
    touchSupport: getTouchSupport,
    vendor: getVendor,
    vendorFlavors: getVendorFlavors,
    cookiesEnabled: areCookiesEnabled,
    colorGamut: getColorGamut,
    invertedColors: areColorsInverted,
    forcedColors: areColorsForced,
    monochrome: getMonochromeDepth,
    contrast: getContrastPreference,
    reducedMotion: isMotionReduced,
    hdr: isHDR,
    math: getMathFingerprint,
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */
function loadBuiltinSources(options) {
    return loadSources(sources, options, []);
}

var commentTemplate = '$ if upgrade to Pro: https://fpjs.dev/pro';
function getConfidence(components) {
    var openConfidenceScore = getOpenConfidenceScore(components);
    var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
    return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "" + proConfidenceScore) };
}
function getOpenConfidenceScore(components) {
    // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
    // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
    // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
    if (isAndroid()) {
        return 0.4;
    }
    // Safari (mobile and desktop)
    if (isWebKit()) {
        return isDesktopSafari() ? 0.5 : 0.3;
    }
    var platform = components.platform.value || '';
    // Windows
    if (/^Win/.test(platform)) {
        // The score is greater than on macOS because of the higher variety of devices running Windows.
        // Chrome provides more entropy than Firefox according too
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.6;
    }
    // macOS
    if (/^Mac/.test(platform)) {
        // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
        // Chrome is more popular than Safari and Safari is more popular than Firefox according to
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.5;
    }
    // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
    return 0.7;
}
function deriveProConfidenceScore(openConfidenceScore) {
    return round(0.99 + 0.01 * openConfidenceScore, 0.0001);
}

function componentsToCanonicalString(components) {
    var result = '';
    for (var _i = 0, _a = Object.keys(components).sort(); _i < _a.length; _i++) {
        var componentKey = _a[_i];
        var component = components[componentKey];
        var value = component.error ? 'error' : JSON.stringify(component.value);
        result += "" + (result ? '|' : '') + componentKey.replace(/([:|\\])/g, '\\$1') + ":" + value;
    }
    return result;
}
function componentsToDebugString(components) {
    return JSON.stringify(components, function (_key, value) {
        if (value instanceof Error) {
            return errorToObject(value);
        }
        return value;
    }, 2);
}
function hashComponents(components) {
    return x64hash128(componentsToCanonicalString(components));
}
/**
 * Makes a GetResult implementation that calculates the visitor id hash on demand.
 * Designed for optimisation.
 */
function makeLazyGetResult(components) {
    var visitorIdCache;
    // This function runs very fast, so there is no need to make it lazy
    var confidence = getConfidence(components);
    // A plain class isn't used because its getters and setters aren't enumerable.
    return {
        get visitorId() {
            if (visitorIdCache === undefined) {
                visitorIdCache = hashComponents(this.components);
            }
            return visitorIdCache;
        },
        set visitorId(visitorId) {
            visitorIdCache = visitorId;
        },
        confidence: confidence,
        components: components,
        version: version,
    };
}
/**
 * A delay is required to ensure consistent entropy components.
 * See https://github.com/fingerprintjs/fingerprintjs/issues/254
 * and https://github.com/fingerprintjs/fingerprintjs/issues/307
 * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
 */
function prepareForSources(delayFallback) {
    if (delayFallback === void 0) { delayFallback = 50; }
    // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
    return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
/**
 * The function isn't exported from the index file to not allow to call it without `load()`.
 * The hiding gives more freedom for future non-breaking updates.
 *
 * A factory function is used instead of a class to shorten the attribute names in the minified code.
 * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
 */
function makeAgent(getComponents, debug) {
    var creationTime = Date.now();
    return {
        get: function (options) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
                var startTime, components, result;
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startTime = Date.now();
                            return [4 /*yield*/, getComponents()];
                        case 1:
                            components = _a.sent();
                            result = makeLazyGetResult(components);
                            if (debug || (options === null || options === void 0 ? void 0 : options.debug)) {
                                // console.log is ok here because it's under a debug clause
                                // eslint-disable-next-line no-console
                                console.log("Copy the text below to get the debug data:\n\n```\nversion: " + result.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (startTime - creationTime) + "\nvisitorId: " + result.visitorId + "\ncomponents: " + componentsToDebugString(components) + "\n```");
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        },
    };
}
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */
function monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) {
        return;
    }
    try {
        var request = new XMLHttpRequest();
        request.open('get', "https://m1.openfpcdn.io/fingerprintjs/v" + version + "/npm-monitoring", true);
        request.send();
    }
    catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
/**
 * Builds an instance of Agent and waits a delay required for a proper operation.
 */
function load(_a) {
    var _b = _a === void 0 ? {} : _a, delayFallback = _b.delayFallback, debug = _b.debug, _c = _b.monitoring, monitoring = _c === void 0 ? true : _c;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var getComponents;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (monitoring) {
                        monitor();
                    }
                    return [4 /*yield*/, prepareForSources(delayFallback)];
                case 1:
                    _d.sent();
                    getComponents = loadBuiltinSources({ debug: debug });
                    return [2 /*return*/, makeAgent(getComponents, debug)];
            }
        });
    });
}

// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
var index = { load: load, hashComponents: hashComponents, componentsToDebugString: componentsToDebugString };
// The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
/** Not documented, out of Semantic Versioning, usage is at your own risk */
var murmurX64Hash128 = x64hash128;

/* harmony default export */ __webpack_exports__["default"] = (index);



/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TBody=__webpack_require__(158);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainLine=function MainLine(props){return _react2.default.createElement(_TBody.Row,_extends({},props,{tr:props.mainLine}));};var Body=function Body(props){return _react2.default.createElement(_TBody.TBody,_extends({},props,{rows:props.mainTable.map(function(row){return addOffset(row,props.rowOffest);})}));};exports.default={MainLine:MainLine,Body:Body};function addOffset(row,length){if(!length){return row;}return Array.from({length:length}).map(function(){return{st:_base.CELL_STYLE.TEXT};}).concat(row);}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _PrimaryStatisticalCategories=__webpack_require__(424);Object.defineProperty(exports,'PrimaryStatisticalCategories',{enumerable:true,get:function get(){return _interopRequireDefault(_PrimaryStatisticalCategories).default;}});var _SecondaryStatisticalCategories=__webpack_require__(425);Object.defineProperty(exports,'SecondaryStatisticalCategories',{enumerable:true,get:function get(){return _interopRequireDefault(_SecondaryStatisticalCategories).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var className='line-base-filter';var PrimaryStatisticalCategories=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PrimaryStatisticalCategories,_Component);function PrimaryStatisticalCategories(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrimaryStatisticalCategories);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrimaryStatisticalCategories.__proto__||Object.getPrototypeOf(PrimaryStatisticalCategories)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(categoryID){var _this$props=_this.props,lineStore=_this$props.lineStore,gameID=_this$props.gameID;lineStore.line.selectPrimaryStatisticalCategory(gameID,categoryID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrimaryStatisticalCategories,[{key:'render',value:function render(){var _this2=this;var _props=this.props,gameID=_props.gameID,getLang=_props.dictStore.getLang;var primaryCategories=this.props.lineStore.line.statisticalCategories.get(gameID);return _react2.default.createElement('div',{className:className},_react2.default.createElement('div',{className:className+'-items'},primaryCategories.map(function(_ref2){var id=_ref2.id,name=_ref2.name,isActive=_ref2.isActive,count=_ref2.count,isLocaleKey=_ref2.isLocaleKey;return _react2.default.createElement('div',{key:id,onClick:function onClick(){return _this2.handleClick(id);},className:(0,_classnames2.default)(className+'-item',_defineProperty({},className+'-item_active',isActive))},isLocaleKey?getLang(name):name,!!count&&_react2.default.createElement('div',{className:className+'-item-count'},count));})));}}]);return PrimaryStatisticalCategories;}(_react.Component))||_class)||_class);exports.default=PrimaryStatisticalCategories;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecondaryStatisticalCategories=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(SecondaryStatisticalCategories,_Component);function SecondaryStatisticalCategories(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecondaryStatisticalCategories);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecondaryStatisticalCategories.__proto__||Object.getPrototypeOf(SecondaryStatisticalCategories)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(categoryID){_this.props.lineStore.line.selectSecondaryStatisticalCategory(_this.props.gameID,categoryID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SecondaryStatisticalCategories,[{key:'render',value:function render(){var _this2=this;var _props=this.props,gameID=_props.gameID,getLang=_props.dictStore.getLang;var lineStore=this.props.lineStore.line;var statisticalCategories=lineStore.statisticalCategories.get(gameID);var secondaryCategories=lineStore.getSecondaryStatisticalCategories(statisticalCategories);return secondaryCategories.map(function(_ref2){var id=_ref2.id,name=_ref2.name,isActive=_ref2.isActive,count=_ref2.count,isLocaleKey=_ref2.isLocaleKey;if(count===0){return null;}return _react2.default.createElement('div',{className:(0,_classnames2.default)('g-a-c-i',{'g-a-c-i-s':isActive}),onClick:function onClick(){return _this2.handleSelect(id);}},_react2.default.createElement('span',null,isLocaleKey?getLang(name):name,!!count&&_react2.default.createElement('span',{className:'g-a-c-i-t-c'},count)));});}}]);return SecondaryStatisticalCategories;}(_react.Component))||_class)||_class);exports.default=SecondaryStatisticalCategories;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(427)


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MatchesList=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Sport=__webpack_require__(429);var _MatchesList=__webpack_require__(169);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/** Представление списка матчей */var MatchesList=exports.MatchesList=function MatchesList(props){var data=props.matchesListStore.getData(props.matchesFilter);var _useState=(0,_react.useState)(),_useState2=_slicedToArray(_useState,2),update=_useState2[1];(0,_react.useEffect)(function(){var updState=function updState(){update(Date.now());};props.matchesListStore.subscribe(updState);return function(){props.matchesListStore.unsubscribe(updState);};},[]);if(!data){return _react2.default.createElement('div',{className:'result-no-events'},props.toLocale('NO_EVENTS'));}var handlers=Object.assign(Object.assign({},props.matchesListStore.matches),props.matchHandlers);return _react2.default.createElement(_react.Fragment,null,' ',(data.sortedSportIds||[]).map(function(sportID){var _a;var sport={sportID:sportID,enSport:(_a=data.sports[sportID])===null||_a===void 0?void 0:_a.enSport};var getChampionshipURL=props.useSLUG?function(championship){return _MatchesList.MatchesList.getChampionshipURL(props.mode,sport,championship);}:function(championship){return _MatchesList.MatchesList.getChampionshipURL(props.mode,{sportID:sportID,enSport:''},{championshipID:championship.championshipID,enChampionship:''});};var getMatchURL=props.useSLUG?function(championship,match){return _MatchesList.MatchesList.getMatchURL(props.mode,sport,championship,match);}:function(championship,match){return _MatchesList.MatchesList.getMatchURL(props.mode,{sportID:sportID,enSport:''},{championshipID:championship.championshipID,enChampionship:''},{matchID:match.matchID,teams:{enTeam1:'',enTeam2:''}});};return _react2.default.createElement(_Sport.Sport,{championshipsHandlers:props.matchesListStore.championships,matchHandlers:handlers,getChampionshipURL:getChampionshipURL,getMatchURL:getMatchURL,championships:data.championships,sport:data.sports[sportID],matchCommonProps:props.matchCommonProps,matches:data.matches,toLocale:props.toLocale,sportID:sportID,key:sportID});}),' ');};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Sport=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Championship=__webpack_require__(430);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Sport=exports.Sport=function Sport(props){return _react2.default.createElement(_react.Fragment,null,' ',props.sport.sortedChampionshipIds.map(function(championshipID){var championship={enChampionship:props.championships[championshipID].enChampionship,championshipID:championshipID};var getMatchURL=function getMatchURL(match){return props.getMatchURL(championship,match);};return _react2.default.createElement(_Championship.Champtionship,_extends({},props,{url:props.getChampionshipURL(championship),getMatchURL:getMatchURL,championship:props.championships[championshipID],championshipID:championshipID,key:championshipID}));}),' ');};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Champtionship=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Header=__webpack_require__(431);var _Match=__webpack_require__(432);var _reactRouter=__webpack_require__(78);var _Match2=__webpack_require__(168);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Champtionship=exports.Champtionship=(0,_reactRouter.withRouter)(function(props){var _a,_b,_c;var _useState=(0,_react.useState)(props.championshipsHandlers.isFavoriteChampionship(props.championshipID)),_useState2=_slicedToArray(_useState,2),isFavorite=_useState2[0],favorite=_useState2[1];var isFoldedProp=props.championshipsHandlers.isFoldedChampionship(props.championshipID);var _useState3=(0,_react.useState)(isFoldedProp),_useState4=_slicedToArray(_useState3,2),isFolded=_useState4[0],fold=_useState4[1];var isIrm=(_a=props.matchCommonProps)===null||_a===void 0?void 0:_a.isIrm;(0,_react.useEffect)(function(){fold(isFoldedProp);},[props.championshipID,isFoldedProp]);var onFavorite=(0,_react.useCallback)(function(){props.championshipsHandlers.favoriteChampionship(props.championshipID,!isFavorite);favorite(props.championshipsHandlers.isFavoriteChampionship(props.championshipID));},[props.championshipID,isFavorite]);var foldChampionship=(0,_react.useCallback)(function(){props.championshipsHandlers.foldChampionship(props.championshipID,!isFolded);fold(props.championshipsHandlers.isFoldedChampionship(props.championshipID));},[props.championshipID,isFolded]);var isSingleMatch=props.match.params.games;var sScore=(_c=(_b=props.matches)===null||_b===void 0?void 0:_b[isSingleMatch===null||isSingleMatch===void 0?void 0:isSingleMatch.split('_')[0]])===null||_c===void 0?void 0:_c.sScore;return _react2.default.createElement('table',{className:'l-t',id:'championship_'+props.championshipID},_react2.default.createElement('tbody',null,!isSingleMatch||!sScore||!(_Match2.sportsIds===null||_Match2.sportsIds===void 0?void 0:_Match2.sportsIds[props.sportID])||isIrm?_react2.default.createElement(_Header.ChamptionshipHeader,{url:props.url,sportID:props.sportID,title:props.toLocale(props.championship.sportChampionship),isFavorite:isFavorite,isFolded:isFolded,onFavorite:onFavorite,fold:foldChampionship}):'',!isFolded&&props.championship.sortedMatchIds.map(function(matchID){return _react2.default.createElement(_Match.Match,_extends({url:props.getMatchURL({matchID:matchID,teams:{enTeam1:props.matches[matchID].enTeam1,enTeam2:props.matches[matchID].enTeam2}})},props.matchCommonProps,{key:matchID,sportID:props.sportID,toLocale:props.toLocale,handlers:props.matchHandlers,matchID:matchID,matchData:props.matches[matchID]}));})));});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChamptionshipHeader=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _UI=__webpack_require__(56);var _reactRouterDom=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ChamptionshipHeader=exports.ChamptionshipHeader=_react2.default.memo(function(props){return _react2.default.createElement('tr',{className:'l-tr l-t-tr-'+props.sportID},_react2.default.createElement('th',{className:'l-td l-td-s-'+props.sportID+' l-s-r-'+props.sportID,colSpan:20},_react2.default.createElement('div',{className:'l-td-line'},_react2.default.createElement(_UI.FavoriteStar,{isFavorite:props.isFavorite,onClick:props.onFavorite}),_react2.default.createElement('div',{className:'l-d l-d-line',onClick:props.fold},_react2.default.createElement('div',{className:'l-t-i-i '+(props.isFolded?'l-t-i-i-a':'')},_react2.default.createElement('div',{className:'l-t-i-i-i'},_react2.default.createElement('span',{className:'f-s-ico-arrow_buttom_1'})))),_react2.default.createElement(_reactRouterDom.Link,{className:'l-th-name',to:props.url},props.title))));});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Match=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactJss=__webpack_require__(57);var _Outcomes=__webpack_require__(90);var OutcomesView=_interopRequireWildcard(_Outcomes);var _UI=__webpack_require__(56);var _base=__webpack_require__(4);var _TableOutcomes=__webpack_require__(433);var _kafka=__webpack_require__(58);var _reactRouter=__webpack_require__(78);var _Match=__webpack_require__(168);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getMatchIdFromSlug=function getMatchIdFromSlug(slug){var _a;return(_a=(slug||'').match(/\d+/))===null||_a===void 0?void 0:_a[0];};var useStyles=(0,_reactJss.createUseStyles)({matchTitle:{display:'flex',position:'relative'},translations:{// position: 'absolute',
right:'0',top:'0',display:'block',// paddingLeft: '3px',
backgroundColor:'#f9f9f9'},structureScoreContainer:{display:'flex',marginRight:'4px'},structureScoreItem:{display:'flex',flexDirection:'column',justifyContent:'flex-end',margin:'4px 4px'},structureScoreItemBlock:{display:'flex',justifyContent:'center',color:'#747474'},structureScoreItemHeader:{display:'flex',justifyContent:'center',color:'#9898af'}},{name:'Match'});var sportsInfographic={26:'Soccer',27:'IceHockey',28:'Basketball',33:'Tennis',41:'Volleyball',134:'TableTennis',235:'Badminton',337:'BeachVolleyball',635:'ShortHockey',32:'Handball',177:'Futsal'};var Match=exports.Match=(0,_reactRouter.withRouter)(function(props){var _a,_b,_c,_d,_e,_f;//#region fold
var subscriptionID=Number(props.matchID);var _useState=(0,_react.useState)(!props.handlers.isUnfoldedMatch(props.matchID)),_useState2=_slicedToArray(_useState,2),isFolded=_useState2[0],fold=_useState2[1];var isIrm=props===null||props===void 0?void 0:props.isIrm;var toggleMatch=function toggleMatch(){props.handlers.foldMatch(props.matchID,!isFolded);fold(!props.handlers.isUnfoldedMatch(props.matchID));};var openMatch=function openMatch(matchID){props.handlers.foldMatch(matchID,true);fold(true);props.handlers.foldMatch(matchID,false);fold(false);};(0,_react.useEffect)(function(){var _a,_b;// reinit additional table outcomes
if(getMatchIdFromSlug((_b=(_a=props===null||props===void 0?void 0:props.match)===null||_a===void 0?void 0:_a.params)===null||_b===void 0?void 0:_b.games)===String(props.matchID)){openMatch(props.matchID);}},[(_b=(_a=props===null||props===void 0?void 0:props.match)===null||_a===void 0?void 0:_a.params)===null||_b===void 0?void 0:_b.games,props.matchID]);var subscribeOutcomes=function subscribeOutcomes(){return props.outcomes.listenWS(subscriptionID);};var unsubscribeOutcomes=function unsubscribeOutcomes(){return props.outcomes.stopListenWS(subscriptionID);};(0,_react.useEffect)(function(){fold(!props.handlers.isUnfoldedMatch(props.matchID));},[props.handlers.isUnfoldedMatch(props.matchID)]);(0,_react.useEffect)(function(){isFolded?unsubscribeOutcomes():subscribeOutcomes();},[isFolded]);//#endregion
//#region favorite
var _useState3=(0,_react.useState)(props.handlers.isFavoriteMatch(props.matchID)),_useState4=_slicedToArray(_useState3,2),isFavorite=_useState4[0],favorite=_useState4[1];(0,_react.useEffect)(function(){favorite(props.handlers.isFavoriteMatch(props.matchID));},[props.handlers.isFavoriteMatch(props.matchID)]);var favoriteMatch=(0,_react.useCallback)(function(){if(!isFavorite){(0,_kafka.sendLogKafka)(_kafka.Events.favoUrites,{eventId:props.matchID});}props.handlers.favoriteMatch(props.matchID,!isFavorite);favorite(props.handlers.isFavoriteMatch(props.matchID));},[props.matchID,isFavorite]);//#endregion
var onVideoClick=(0,_react.useCallback)(function(){props.handlers.onVideoClick({id:Number(props.matchID),stats:props.matchData.hasMatchInfo,hasInfographics:props.matchData.hasInfographics,sid:Number(props.sportID),c1:props.matchData.team1,c2:props.matchData.team2,score:props.matchData.score,video_type:props.matchData.video||[]});},[props.matchID,props.matchData.hasMatchInfo]);var onInfographicsClick=function onInfographicsClick(){props.handlers.onInfographicsClick({stats:props.matchData.hasMatchInfo,hasInfographics:props.matchData.hasInfographics,score:props.matchData.score,sid:Number(props.sportID),id:Number(props.matchID),c1:props.matchData.team1,c2:props.matchData.team2});(0,_kafka.sendLogKafka)(_kafka.Events.matchCenterViewed,{eventId:props===null||props===void 0?void 0:props.matchID});};var isDisabled=props.matchData.bl===_base.LOCK_STATE.BLOCKED;var isCoefChoosen=function isCoefChoosen(betID,oddID){return props.handlers.isCoefChoosen(props.matchID,betID,oddID);};var onCoefChoose=function onCoefChoose(oddID){props.handlers.onCoefChoose(oddID,props.matchID);};var classes=useStyles();var isSingleMatch=props.match.params.games;// const structureScore = props.matchData?.sScore?.sScoreData?.scs.map((item, i) => {
//    return (
//       <div className={classes.structureScoreItem}>
//          {i > 0 ? <div className={classes.structureScoreItemHeader}>{item?.d}</div> : ''}
//          <div style={i === 0 ? {color: '#131313', fontWeight: '500'} : {}} className={classes.structureScoreItemBlock}>{item?.scv?.cur?.t1}</div>
//          <div style={i === 0 ? {color: '#131313', fontWeight: '500'} : {}} className={classes.structureScoreItemBlock}>{item?.scv?.cur?.t2}</div>
//       </div>
//    )
// })
var debuggingMode=localStorage.getItem('debug_mode');var _ref=((_d=(_c=props.matchData)===null||_c===void 0?void 0:_c.sScore)===null||_d===void 0?void 0:_d.sScoreData)||{},um=_ref.um;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('tr',{className:'g-tr'},_react2.default.createElement('td',{className:'g-d-td'},!isSingleMatch||!um||um==2&&!debuggingMode||!(_Match.sportsIds===null||_Match.sportsIds===void 0?void 0:_Match.sportsIds[props.sportID])||isIrm?_react2.default.createElement('div',{className:classes.matchTitle},_react2.default.createElement('div',null,_react2.default.createElement(_UI.FavoriteStar,{isFavorite:isFavorite,onClick:favoriteMatch})),_react2.default.createElement(OutcomesView.Description,{description:props.matchData,url:props.url,inline:props.inlineDescription,matchId:props.matchID,displayGamesNumber:props.displayGamesNumber,deltaTimeMs:props.deltaTimeMs}),_react2.default.createElement('div',{className:classes.structureScoreContainer}),_react2.default.createElement('div',{className:classes.translations},_react2.default.createElement('div',{className:'translations'},_react2.default.createElement(TV,{data:props.matchData.tv}),_react2.default.createElement(VideoChannels,{isVideoPlaying:props.handlers.isVideoPlaying(props.matchID),video:props.matchData.video,onClick:onVideoClick}),_react2.default.createElement(Infographics,{hasMatchInfo:props.matchData.hasMatchInfo===_base.STATE.ENABLED,hasInfographics:props.matchData.hasInfographics===_base.STATE.ENABLED,sportId:props.sportID,onClick:onInfographicsClick})))):_react2.default.createElement('div',{style:{textAlign:'center'}},(_f=(_e=props.matchData)===null||_e===void 0?void 0:_e.mainLineDescription)===null||_f===void 0?void 0:_f.txt)),_react2.default.createElement(OutcomesView.HeadTable.MainLine,{getCoef:function getCoef(betID){return props.matchData.odds[betID];},mainLine:props.matchData.mainLine||[],disabled:isDisabled,highlightChanges:props.highlightChanges,isCoefChoosen:isCoefChoosen,onCoefChoose:onCoefChoose,className:'g-tr'}),_react2.default.createElement('td',{className:'g-t-a-td'},props.matchData.oddsCnt&&_react2.default.createElement(Toggle,{isFolded:isFolded,count:props.matchData.oddsCnt[props.width],onClick:toggleMatch}))),!isFolded&&props.matchData.oddsCnt&&_react2.default.createElement(_TableOutcomes.AdditionalTableOutcomes,_extends({},props,{isCoefChoosen:isCoefChoosen,onCoefChoose:onCoefChoose})));});var Toggle=_react2.default.memo(function(props){if(props.count===0){return null;}return _react2.default.createElement('span',{className:'g-t-a',onClick:props.onClick},''+(props.isFolded?'+':'-')+props.count);});var TV=_react2.default.memo(function(props){if(!props.data){return null;}return _react2.default.createElement('div',{className:'g-tv fl_r'},_react2.default.createElement('span',{className:'f-s-ico-tv'}),_react2.default.createElement('div',{className:'channels'},_react2.default.createElement('span',{className:'channel'},' ',props.data,' ')));});var Infographics=_react2.default.memo(function(props){if(props.hasInfographics&&sportsInfographic[props===null||props===void 0?void 0:props.sportId]||props.hasMatchInfo){return _react2.default.createElement('div',{className:'g-tv fl_r'},_react2.default.createElement('span',{className:'f-s-ico-infographics',onClick:props.onClick}));}return null;});var VideoChannels=_react2.default.memo(function(props){if(!props.video){return null;}return _react2.default.createElement(_react.Fragment,null,props.video.map(function(linkType){return _react2.default.createElement('div',{key:''+linkType,className:'g-tv fl_r'},_react2.default.createElement('span',{className:'item-ico-video'+(props.isVideoPlaying?' item-ico-video-playing':'')+' item-ico-video-type-'+linkType,onClick:props.onClick}));}));});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AdditionalTableOutcomes=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _All=__webpack_require__(60);var _Outcomes=__webpack_require__(90);var OutcomesView=_interopRequireWildcard(_Outcomes);var _Types=__webpack_require__(167);var _base=__webpack_require__(4);var _InlineOutcomes=__webpack_require__(435);var _lib=__webpack_require__(12);var _kafka=__webpack_require__(58);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AdditionalTableOutcomes=exports.AdditionalTableOutcomes=function AdditionalTableOutcomes(props){var _useState=(0,_react.useState)(0),_useState2=_slicedToArray(_useState,2),version=_useState2[0],updateVersion=_useState2[1];var headData=props.outcomes.headTable.getData(props.matchID);(0,_react.useEffect)(function(){var upd=function upd(){updateVersion(Date.now());};props.outcomes.statistical_categories.subscribe(upd);props.outcomes.statistical_tables.subscribe(upd);props.outcomes.statistic_types.subscribe(upd);props.outcomes.categories.subscribe(upd);props.outcomes.tables.subscribe(upd);return function(){props.outcomes.statistical_categories.unsubscribe(upd);props.outcomes.statistical_tables.unsubscribe(upd);props.outcomes.statistic_types.unsubscribe(upd);props.outcomes.categories.unsubscribe(upd);props.outcomes.tables.unsubscribe(upd);};},[]);var categories=props.outcomes.categories;var categoriesOrder=categories.order.get(props.matchID);var categoriesData=categories.getData(props.matchID);var selectedStatType=props.outcomes.statistic_types.getSelected(props.matchID)||{name:_Types.matchCategoryID,matchId:props.matchID};var _useState3=(0,_react.useState)(selectedStatType.name),_useState4=_slicedToArray(_useState3,2),selectedStatTypeID=_useState4[0],selectStatType=_useState4[1];var _useState5=(0,_react.useState)(selectedStatType.matchId),_useState6=_slicedToArray(_useState5,2),selectedMatchID=_useState6[0],selectMatchID=_useState6[1];/** Выбран статистический матч */var isStatisticalMatch=selectedMatchID!==props.matchID;/** Выбран тип исходы основного матча */var isMatchTypeSelected=selectedStatTypeID===_Types.matchCategoryID;/** Выбрана тип статистика */var isStatisticTypeSelected=selectedStatTypeID===_Types.statisticCategoryID;/** Фильтр основных исходов матча */var matchFilter=categoriesData&&(categoriesOrder||[]).map(function(categoryID){return[categoryID,Object.assign({matchId:props.matchID},categoriesData[categoryID])];})||[];/** Фильтр популярных стат. матчей */var getPopularStatFilter=function getPopularStatFilter(statMatchID){var categoriesData2=props.outcomes.statistical_categories.getData(statMatchID);return(0,_lib.objectEntries)(categoriesData2||{}).map(function(_ref){var _ref2=_slicedToArray(_ref,2),categoryID=_ref2[0],category=_ref2[1];return[categoryID,Object.assign({matchId:statMatchID},category)];});};/** Фильтр типа Статистика */var notPopularFilter=props.outcomes.statistic_types.getNotPopular(props.matchID);var _useState7=(0,_react.useState)(matchFilter),_useState8=_slicedToArray(_useState7,2),categoriesFilterData=_useState8[0],setCategoriesFilterData=_useState8[1];(0,_react.useEffect)(function(){if(isMatchTypeSelected||categoriesFilterData.length===0){setCategoriesFilterData(matchFilter);return;}if(isStatisticTypeSelected){setCategoriesFilterData(notPopularFilter);return;}var popularFilter=getPopularStatFilter(selectedMatchID);/** Выбраны популярные стат. матчи */setCategoriesFilterData(popularFilter);},[version]);(0,_react.useEffect)(function(){if(isMatchTypeSelected){return;}if(isStatisticTypeSelected){if(notPopularFilter.length!==0){var _ref3=notPopularFilter.find(function(_ref5){var _ref6=_slicedToArray(_ref5,2),state=_ref6[1];return state.isSelected;})||notPopularFilter[0],_ref4=_slicedToArray(_ref3,2),state=_ref4[1];selectMatchID(state.matchId);props.outcomes.statistical_categories.select(state.matchId,[_All.ALL_CATEGORY_ID]);}return;}var popularFilter=getPopularStatFilter(selectedMatchID);if(popularFilter.length!==0){var _ref7=popularFilter.find(function(_ref9){var _ref10=_slicedToArray(_ref9,2),state=_ref10[1];return state.isSelected;})||popularFilter[1],_ref8=_slicedToArray(_ref7,2),popularCategoryID=_ref8[0],_state=_ref8[1];props.outcomes.statistical_categories.select(_state.matchId,[popularCategoryID]);}},[selectedStatTypeID]);var onCategoryFavorite=(0,_react.useCallback)(function(categoryIDs,isFavorite){var categories=isStatisticalMatch?props.outcomes.statistical_categories:props.outcomes.categories;categories.favorite(selectedMatchID,categoryIDs,isFavorite);},[isStatisticalMatch,selectedMatchID]);var onCategoryFilterSelect=(0,_react.useCallback)(function(matchID,categoryIDs,isSelected){if(isSelected){(0,_kafka.sendLogKafka)(_kafka.Events.exodusFiltered,{typeId:categoryIDs[0]});}selectMatchID(matchID);if(matchID===props.matchID){categories.select(matchID,categoryIDs,isSelected);return;}if(isStatisticTypeSelected){props.outcomes.statistic_types.select(props.matchID,categoryIDs[0]);props.outcomes.statistical_categories.select(matchID,[_All.ALL_CATEGORY_ID]);return;}/** Выбор фильра популярного статистики */props.outcomes.statistical_categories.select(matchID,categoryIDs,isSelected);},[props.matchID,isStatisticTypeSelected]);var onFoldAllTables=(0,_react.useCallback)(function(){var tables=isStatisticalMatch?props.outcomes.statistical_tables:props.outcomes.tables;var isAllUnfolded=tables.isAllUnfolded(selectedMatchID);tables.fold(selectedMatchID,void 0,isAllUnfolded);},[selectedMatchID,isStatisticalMatch]);var onFavoriteTable=(0,_react.useCallback)(function(tableID,isFavorite){var categories=isStatisticalMatch?props.outcomes.statistical_categories:props.outcomes.categories;var tables=isStatisticalMatch?props.outcomes.statistical_tables:props.outcomes.tables;tables.favorite(selectedMatchID,[tableID],isFavorite);categories.favorite(selectedMatchID);},[selectedMatchID,isStatisticalMatch]);var onFoldTable=(0,_react.useCallback)(function(tableID,isFolded){var tables=isStatisticalMatch?props.outcomes.statistical_tables:props.outcomes.tables;tables.fold(selectedMatchID,[tableID],!isFolded);},[selectedMatchID,isStatisticalMatch]);var onStatTypeSelect=(0,_react.useCallback)(function(matchID,categoryID){props.outcomes.statistic_types.select(props.matchID,categoryID);selectMatchID(matchID);selectStatType(categoryID);},[props.matchID]);var tables=isStatisticalMatch?props.outcomes.statistical_tables:props.outcomes.tables;var isAllUnfolded=tables.isAllUnfolded(selectedMatchID);var tablesData=tables.getData(selectedMatchID);/** Данные основного матча */var matchTableData=props.outcomes.tables.getData(props.matchID);if(!tablesData||!headData||!matchTableData){return null;}return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement(OutcomesView.HeadTable.Body,{getCoef:function getCoef(betID){return matchTableData.coefs[betID];},highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,onCoefChoose:props.onCoefChoose,disabled:props.matchData.bl===_base.LOCK_STATE.BLOCKED,mainTable:headData.headTable,className:'g-tr'}),(tablesData.additionalOdds&&tablesData.additionalOdds.length!==0||Object.keys(tablesData.tables).length!==0)&&_react2.default.createElement('tr',{className:'g-a-tr'},_react2.default.createElement('td',{colSpan:100},categoriesData&&categoriesOrder&&_react2.default.createElement(OutcomesView.Categories,{categoriesData:categoriesFilterData,statTypesData:props.outcomes.statistic_types.getPopular(props.matchID),onStatTypeSelect:onStatTypeSelect,onFoldAllTables:onFoldAllTables,onFavorite:!isStatisticTypeSelected?onCategoryFavorite:void 0,isAllUnfolded:isAllUnfolded,onSelect:onCategoryFilterSelect,toLocale:props.toLocale,sportID:props.sportID,matchID:props.matchID,width:props.width}),tablesData&&_react2.default.createElement(OutcomesView.Tables,{data:tablesData,onFavorite:!isStatisticTypeSelected?onFavoriteTable:void 0,highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,onCoefChoose:props.onCoefChoose,columnCount:props.columnCount,onFold:onFoldTable}),tablesData.additionalOdds&&_react2.default.createElement(_InlineOutcomes.InlineOutcomes,_extends({},props,{additionalOdds:tablesData.additionalOdds,disabled:matchTableData.isDisabled,getCoef:function getCoef(betID){return matchTableData.coefs[betID];},isCoefChoosen:props.isCoefChoosen,onCoefChoose:props.onCoefChoose})))));};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BaseMobileCategories=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseMobileCategories=exports.BaseMobileCategories=function(_Subscribtion){_inherits(BaseMobileCategories,_Subscribtion);function BaseMobileCategories(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_base.COLUMN_WIDTH.MEDIUM;var onTablesSelect=arguments[1];_classCallCheck(this,BaseMobileCategories);var _this=_possibleConstructorReturn(this,(BaseMobileCategories.__proto__||Object.getPrototypeOf(BaseMobileCategories)).call(this));_this.width=width;_this.onTablesSelect=onTablesSelect;/**
         * по WS приходит другой формат, поэтому временно
         * храним данные filterTables в отдельном свойстве
         */_this.data=new Map();_this.order=new Map();/** Категории, выбранные пользователем */_this.selectedCategories=new Map();/**
         * Хранилище соответствия спорта-матча чтобы держать в избранном таблицы разных матчей одного спорта
         */_this.sportID={};_this.select=_this.select.bind(_this);return _this;}_createClass(BaseMobileCategories,[{key:'getSportID',value:function getSportID(matchID){return this.sportID[matchID];}},{key:'getData',value:function getData(matchID){return this.data.get(matchID)||null;}},{key:'deleteCategories',value:function deleteCategories(matchID,categoryIDs){if(categoryIDs.length===0){return;}var selectedCategories=this.selectedCategories.get(matchID);var data=this.getData(matchID);if(!data){throw new Error('No data for '+matchID);}categoryIDs.forEach(function(categoryID){selectedCategories.delete(categoryID);delete data[categoryID];});this.select(matchID);}/**
     * Выбрать категорию
     * @param matchID
     * @param categoryIDs
     * @param isSelected
     */},{key:'select',value:function select(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.has(matchID)&&this.selectedCategories.get(matchID).values()||[]);var isSelected=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!this.selectedCategories.has(matchID)){return;}var selectedCategories=this.selectedCategories.get(matchID);if(!isSelected){this.unselectCategories(matchID,categoryIDs);return;}if(categoryIDs.every(function(categoryID){return selectedCategories.has(categoryID);})){return;}var unselectCategories=(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:false}];}));selectedCategories.clear();categoryIDs[0]&&selectedCategories.add(categoryIDs[0]);var newStates=Object.assign(Object.assign({},unselectCategories),_defineProperty({},categoryIDs[0],{isSelected:true}));this.selectTables(matchID);this.assignStates(matchID,newStates);}},{key:'unselectCategories',value:function unselectCategories(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.has(matchID)&&this.selectedCategories.get(matchID).values()||[]);var selectedCategories=this.selectedCategories.get(matchID);categoryIDs.forEach(function(c){selectedCategories.delete(c);});var newStates=Object.assign(// очередность важна, isSelected:true должны быть в конце
(0,_lib.objectFromEntries)(categoryIDs.map(function(categoryID){return[categoryID,{isSelected:false}];})),(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:true}];})));this.assignStates(matchID,newStates);this.selectTables(matchID);}/** Выбирает все таблицы выбранных категорий */},{key:'selectTables',value:function selectTables(matchID){var categories=this.getData(matchID);if(!categories){throw new Error('Попытка выбрать несуществующую категорию!');}var selectedCategories=this.selectedCategories.get(matchID);var noCategoriesSelected=selectedCategories.size===0;if(noCategoriesSelected){this.onTablesSelect(matchID,[],true);return;}this.onTablesSelect(matchID,[],false);var selectedTables=Array.from(selectedCategories.values()||[]).map(function(categoryID){var _a;return((_a=categories[categoryID])===null||_a===void 0?void 0:_a.tables)||[];}).reduce(function(allTables,tables){return allTables.concat(tables);},[]);this.onTablesSelect(matchID,selectedTables,true);}/**
     * в отличие от update здесь состояния могут изменяться частично
     * @param matchID
     * @param newStates
     */},{key:'assignStates',value:function assignStates(matchID,newStates){var categories=this.getData(matchID);if(!categories){throw new Error('Попытка выбрать категории несуществующего события '+matchID);}(0,_lib.objectEntries)(newStates).filter(function(_ref){var _ref2=_slicedToArray(_ref,1),categoryID=_ref2[0];return categoryID in categories;}).forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),categoryID=_ref4[0],newState=_ref4[1];Object.assign(categories[categoryID]||{},newState);});this.notify(matchID);}},{key:'clear',value:function clear(){this.data.clear();this.selectedCategories.clear();this.notify();}},{key:'clearGame',value:function clearGame(matchID){this.data.set(matchID,{});this.order.delete(matchID);this.notify(matchID);}},{key:'deleteGame',value:function deleteGame(matchID){this.data.delete(matchID);this.selectedCategories.delete(matchID);this.notify(matchID);}}]);return BaseMobileCategories;}(_Subscribtion3.default);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InlineOutcomes=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Td=__webpack_require__(91);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InlineOutcomes=exports.InlineOutcomes=function InlineOutcomes(props){if(!props.additionalOdds||props.additionalOdds.length===0){return null;}return _react2.default.createElement('div',{className:'g-a-other'},_react2.default.createElement('b',null,props.toLocale('ADDITIONAL_BETS')),props.additionalOdds.filter(function(cell){return!!cell.bet;}).map(function(cell,i){return cell.bet?_react2.default.createElement(HightlightCoef,{key:props.getCoef(cell.bet).odd+'_'+i,highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,coef:props.getCoef(cell.bet),onClick:props.onCoefChoose,disabled:!!props.disabled,cell:cell,style:{}}):null;}));};var InlineCoef=function InlineCoef(props){return _react2.default.createElement(_react.Fragment,null,props.cell.txt,' - \xA0',_react2.default.createElement('a',{className:'g-b '+(props.isChoosen?'g-b-s':''),onClick:function onClick(){props.cfID&&props.onClick(props.cfID);}},props.cf),';',' ');};var HightlightCoef=_react2.default.memo((0,_Td.highlightCoefChanges)(InlineCoef));

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.isSubheaderRow=exports.SubHeader=exports.TBody=exports.Row=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(4);var _Td=__webpack_require__(437);var _AppContexts=__webpack_require__(92);var _insertCoefByType=__webpack_require__(164);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Row=exports.Row=_react2.default.memo(function(props){var row=props.tr.reduce(function(row,cell,i){row[Math.floor(i/2)]=Object.assign(Object.assign({},row[Math.floor(i/2)]),cell);return row;},[]).filter(function(_ref){var st=_ref.st;return st===_base.CELL_STYLE.COEFFICIENT;});var _useContext=(0,_react.useContext)(_AppContexts.LineContext),coefType=_useContext.coefType,appName=_useContext.appName;return _react2.default.createElement('div',{className:'live__item__game-bets'},row.filter(function(cell){return!!cell.bet;}).map(function(cell,i,row){return cell.bet&&props.getCoef(cell.bet)?_react2.default.createElement(_Td.HightlightCoefTd,{disabled:!!props.disabled,key:(cell.bet||cell.txt)+'_'+i,highlightChanges:props.highlightChanges,isCoefChoosen:props.isCoefChoosen,style:props.getColumnStyle?props.getColumnStyle(i,row):{},coef:props.getCoef(cell.bet),typeCoef:(0,_insertCoefByType.insertCoefByType)(Number(props.getCoef(cell.bet).cf),coefType,appName),onClick:props.onCoefChoose,cell:cell,matchID:props.matchID}):_react2.default.createElement(_Td.Td,{cell:cell,cf:'',key:cell.txt+'_'+i});}));});var TBody=exports.TBody=_react2.default.memo(function(props){return _react2.default.createElement('div',{className:'g-t-b'},props.rows.map(function(tr,i){return _react2.default.createElement(Row,_extends({tr:tr},props,{key:i}));}));});var SubHeader=exports.SubHeader=_react2.default.memo(function(props){var headers=props.row.filter(isSubheaderCell);if(headers.length===0){return null;}return _react2.default.createElement('div',{className:'g-t-h-sm'},headers.map(function(cell){return _react2.default.createElement('div',{className:'g-t-pl',title:cell.txt,key:cell.txt},cell.txt);}));});var isSubheaderCell=function isSubheaderCell(_ref2){var st=_ref2.st;return st===_base.CELL_STYLE.SUBHEADER||st===_base.CELL_STYLE.HEADER;};var isSubheaderRow=exports.isSubheaderRow=function isSubheaderRow(row){return row.some(isSubheaderCell);};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Td=exports.HightlightCoefTd=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Td=__webpack_require__(91);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CoefTd=_react2.default.memo(function(props){if(props.isDisabled){return _react2.default.createElement(Td,{cell:props.cell,cf:props.cf});}return _react2.default.createElement('div',{className:'live__item__game-bet '+(props.isChoosen?'selected':'unselected')+' '+props.cell.st+' '+(props.cell.additionalClassName||'')+' '+props.light,onClick:function onClick(){props.cfID&&props.onClick(props.cfID,props.matchID);}},_react2.default.createElement('span',{className:'live__item__game-bets-odd'},props.cell.txt),_react2.default.createElement('span',{className:'live__item-bet'},props.cf));});var Td=_react2.default.memo(function(props){return _react2.default.createElement('div',{className:'live__item__game-bet disabled'},_react2.default.createElement('span',{className:'live__item__game-bets-odd'},props.cell.txt),_react2.default.createElement('span',{className:'live__item-bet'},props.cf));});var HightlightCoefTd=(0,_Td.highlightCoefChanges)(CoefTd);exports.HightlightCoefTd=HightlightCoefTd;exports.Td=Td;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactJss=__webpack_require__(57);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var useStyles=(0,_reactJss.createUseStyles)({'@keyframes blinker':{'50%':{opacity:'0.5'},'100%':{opacity:'1'}},timerContainer:{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'},mainTimer:{fontSize:'12px',padding:'0px 2px',borderRadius:'0px 0px 4px 4px',fontWeight:'500',display:'flex',alignItems:'center'},blink:{animationName:'blinker',animationIterationCount:'infinite',animationTimingFunction:'cubic-bezier(1, 2, 0, 1)',animationDuration:'1.5s'}},{name:'Timer'});var Timer=function Timer(_ref){var t=_ref.t,deltaTimeMs=_ref.deltaTimeMs;if(!t)return null;var _ref2=t||{},value=_ref2.v,_ref2$acTm=_ref2.acTm,activatedTime=_ref2$acTm===undefined?0:_ref2$acTm,counterClockWise=_ref2.ccw,stateTimer=_ref2.st;var startTimeFormulaIfPaused=value*1000;var startTimeFormulaIfActive=value*1000+(Date.now()-activatedTime)*(counterClockWise?-1:1);var _useState=(0,_react.useState)(activatedTime?startTimeFormulaIfActive:startTimeFormulaIfPaused),_useState2=_slicedToArray(_useState,2),timerStamp=_useState2[0],setTimerStamp=_useState2[1];(0,_react.useEffect)(function(){var interval=setInterval(function(){if(activatedTime){var currentServerTime=Date.now()-deltaTimeMs;var elapsedMs=currentServerTime-activatedTime;var timerStateFormulaMs=value*1000+elapsedMs*(counterClockWise?-1:1);setTimerStamp(timerStateFormulaMs>=0?timerStateFormulaMs:timerStamp);}else{setTimerStamp(value*1000);}},500);return function(){clearInterval(interval);};},[activatedTime,value,counterClockWise,deltaTimeMs]);var st=useStyles();var timerValueS=Math.floor(timerStamp/1000);var minutes=Math.floor(timerValueS/60);var seconds=timerValueS-minutes*60;var time=(minutes<10?'0'+minutes:minutes)+':'+(seconds<10?'0'+seconds:seconds);// const time = `${minutes < 10 ? `0${minutes}` : minutes}:00`;
return _react2.default.createElement('div',{className:st.timerContainer},_react2.default.createElement('div',{className:''+st.mainTimer},_react2.default.createElement('div',{className:''+(stateTimer!==1?st.blink:'')},time.startsWith('0-')?'':time)));};exports.default=Timer;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MatchesListBase=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _Tool=__webpack_require__(440);var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _Championships=__webpack_require__(441);var _ListenersManager=__webpack_require__(442);var _Matches=__webpack_require__(450);var _Sports=__webpack_require__(451);var _Outcomes=__webpack_require__(452);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** Т.к результаты singleton, используем константный ID */var subscriptionID=0;var MatchesListBase=exports.MatchesListBase=function(_Subscribtion){_inherits(MatchesListBase,_Subscribtion);function MatchesListBase(cfg){_classCallCheck(this,MatchesListBase);var _this=_possibleConstructorReturn(this,(MatchesListBase.__proto__||Object.getPrototypeOf(MatchesListBase)).call(this));_this.subscribedIDs=new Set();_this.championships=new _Championships.ChampionshipsStates();_this.matches=new _Matches.MatchesStates();_this.sports=new _Sports.SportsStates();_this.isLoading=false;_this.isLoadingListeners=[];_this.width=cfg.width||_base.COLUMN_WIDTH.MEDIUM;_this.update=_this.update.bind(_this);_this.listenersManager=new _ListenersManager.ListenersManager(cfg);_this.outcomes=new(cfg.isMobile?_Outcomes.OutcomesMobile:_Outcomes.OutcomesDesktop)(cfg);_this.outcomesLine=new _Outcomes.OutcomesMobileLine(cfg);return _this;}_createClass(MatchesListBase,[{key:'setIsLoadingListener',value:function setIsLoadingListener(cb){this.isLoadingListeners.push(cb);}},{key:'removeIsLoadingListener',value:function removeIsLoadingListener(cb){this.isLoadingListeners=this.isLoadingListeners.filter(function(_cb){return _cb!==cb;});}},{key:'notifyIsLoadingListeners',value:function notifyIsLoadingListeners(state){this.isLoadingListeners.forEach(function(cb){return cb(state);});}},{key:'setIsLoading',value:function setIsLoading(state){this.isLoading=state;try{this.notifyIsLoadingListeners(state);}catch(_a){// ignore errors
}}},{key:'getData',value:function getData(filter){var _sports$getData=this.sports.getData(),sortedSportIds=_sports$getData.sortedSportIds,sports=_sports$getData.sports;if(sports&&Object.keys(sports).length===0){return null;}var matches=this.matches.getData(filter);if(Object.keys(matches).length===0){return null;}return{sortedSportIds:sortedSportIds,championships:this.championships.getData(filter),diff:false,matches:matches,sports:sports};}},{key:'toggleChampionships',value:function toggleChampionships(){this.championships.isAllUnfolded()?this.championships.foldAll():this.championships.unfoldAll();this.notify();}},{key:'setToggleChampionships',value:function setToggleChampionships(state){if(state){this.championships.unfoldAll();}else{this.championships.foldAll();}this.notify();}//#region WS
},{key:'reinit',value:function reinit(cfg){this.listenersManager=new _ListenersManager.ListenersManager(cfg);this.outcomes=new(cfg.isMobile?_Outcomes.OutcomesMobile:_Outcomes.OutcomesDesktop)(cfg);this.outcomesLine=new _Outcomes.OutcomesMobileLine(cfg);if(this.isSubscribed()&&this.lastQuery){this.stopListenWS();this.listenWS(this.lastQuery);}}/**
     * Подписка на обновления таблицы live доп.исходов через WS
     */},{key:'listenWS',value:function listenWS(cfg){var _this2=this;this.lastQuery=cfg;this.setIsLoading(true);var logger=_logger2.default.getInstance();return new Promise(function(resolve,reject){var onerror=function onerror(e){logger.error(e);_this2.stopListenWS();reject(e);};var onopen=function onopen(){_this2.subscribedIDs.add(subscriptionID);_this2.setIsLoading(false);// logger.log('[MatchesListBase: Список Live матчей] Соединение открыто');
resolve();};var config=Object.assign(Object.assign({},cfg),{subscriptionID:subscriptionID,onmessage:_this2.update,onerror:onerror,onopen:onopen});_this2.listenersManager.subscribe(config);});}},{key:'stopListenWS',value:function stopListenWS(){this.setIsLoading(false);if(this.isLoading){this.notify();}if(!this.isSubscribed){return;}this.subscribedIDs.delete(subscriptionID);// this.listenersManager.unsubscribe({ subscriptionID });
}},{key:'clear',value:function clear(){this.sports.clear();this.championships.clear();this.matches.clear();this.outcomes.clear();this.outcomesLine.clear();this.notify();}},{key:'isSubscribed',value:function isSubscribed(){return this.subscribedIDs.has(subscriptionID);}//#endregion
},{key:'setWidth',value:function setWidth(width){if(this.width===width){return;}this.width=width;this.outcomes.setWidth(width);this.outcomesLine.setWidth(width);this.notify();}},{key:'update',value:function update(data){if('diff'in data){this.matches.update(data.matches,data===null||data===void 0?void 0:data.headTables);this.championships.update(data.championships);this.sports.setData(data.sports,data.sortedSportIds);this.setIsLoading(false);this.notify();return;}if(data.matches){this.matches.update(data.matches);}if(data.championships){this.championships.update(data.championships);}if(data.sports){this.sports.update(data.sports);}if(data.sortedSportIds){this.sports.updateSortedIDs(data.sortedSportIds);}this.setIsLoading(false);this.notify();}}],[{key:'getSportURL',value:function getSportURL(mode,sport){return'/'+mode+'/'+(sport.enSport?(0,_Tool.toURL)(sport.enSport):sport.sportID);}},{key:'getChampionshipURL',value:function getChampionshipURL(mode,sport,championship){return this.getSportURL(mode,sport)+'/'+(0,_Tool.toURL)(''+championship.championshipID+(championship.enChampionship&&'_'+championship.enChampionship||''));}},{key:'getMatchURL',value:function getMatchURL(mode,sport,championship,match){return this.getChampionshipURL(mode,sport,championship)+'/'+(!match.teams.enTeam1?match.matchID:(0,_Tool.toURL)(''+match.matchID+(match.teams.enTeam1&&'_'+match.teams.enTeam1+' '+match.teams.enTeam2||'')));}}]);return MatchesListBase;}(_Subscribtion3.default);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var toURL=exports.toURL=function toURL(s){return!s?'':s.toLowerCase().replace(/\s+/g,'-')// Replace spaces with -
.replace(/--+/g,'-')// Replace multiple — with single -
.replace(/[^\w-]+/g,'')// Remove all non-word characters such as spaces or tabs
.trim();};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChampionshipsStates=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _LocalStorage=__webpack_require__(170);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LS_KEY='~/web-frontend-core/store/line/matchesList/Championships';/** Состояния чемпионатов */var ChampionshipsStates=exports.ChampionshipsStates=function(_Subscribtion){_inherits(ChampionshipsStates,_Subscribtion);function ChampionshipsStates(){_classCallCheck(this,ChampionshipsStates);var _this=_possibleConstructorReturn(this,(ChampionshipsStates.__proto__||Object.getPrototypeOf(ChampionshipsStates)).apply(this,arguments));_this.foldedChampionships=new Set();_this.favoriteChampionships=new Set(_LocalStorage.LocalStorage.restore(LS_KEY)||[]);_this.data={};_this._onFavorite=function(){return void 0;};//#region fold
_this.isFoldedChampionship=function(championchipID){return _this.foldedChampionships.has(championchipID);};_this.foldChampionship=function(championchipID,isFolded){isFolded?_this.foldedChampionships.add(championchipID):_this.foldedChampionships.delete(championchipID);_this.notify(championchipID);};//#endregion
//#region favorite
_this.isFavoriteChampionship=function(championshipID){return _this.favoriteChampionships.has(championshipID);};_this.favoriteChampionship=function(championshipID,isFavorite){isFavorite?_this.favoriteChampionships.add(championshipID):_this.favoriteChampionships.delete(championshipID);_this.store();_this._onFavorite(championshipID,_this.data[championshipID].sortedMatchIds,isFavorite);_this.notify();};return _this;}_createClass(ChampionshipsStates,[{key:'getData',value:function getData(filter){var _this2=this;if(filter&&filter.isFavorite){var favoriteChampIDs=Array.from(this.favoriteChampionships.values());return(0,_lib.objectFromEntries)(favoriteChampIDs.map(function(champID){return[champID,_this2.data[champID]];}));}return this.data;}},{key:'update',value:function update(data){var _this3=this;(0,_lib.objectEntries)(data).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),championchipID=_ref2[0],championship=_ref2[1];_this3.data[championchipID]=Object.assign(_this3.data[championchipID]||{},championship);if(championship.sortedMatchIds){_this3.data[championchipID].sortedMatchIds=championship.sortedMatchIds;}});}},{key:'clear',value:function clear(){this.data={};this.foldedChampionships.clear();this.favoriteChampionships.clear();this.store();}},{key:'isAllUnfolded',value:function isAllUnfolded(){return this.foldedChampionships.size===0;}},{key:'unfoldAll',value:function unfoldAll(){this.foldedChampionships.clear();}},{key:'foldAll',value:function foldAll(){this.foldedChampionships=new Set(Object.keys(this.data).map(Number));}},{key:'setFavorite',value:function setFavorite(championchipIDs){this.favoriteChampionships=new Set(championchipIDs);}},{key:'onFavorite',value:function onFavorite(callback){this._onFavorite=callback;}//#endregion
},{key:'store',value:function store(){_LocalStorage.LocalStorage.store(LS_KEY,Array.from(this.favoriteChampionships.values()));}}]);return ChampionshipsStates;}(_Subscribtion3.default);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListenersManager=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _All=__webpack_require__(443);var _Championship=__webpack_require__(444);var _Favorite=__webpack_require__(445);var _Sport=__webpack_require__(446);var _Top=__webpack_require__(447);var _Video=__webpack_require__(448);var _SingleMatch=__webpack_require__(449);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// import LiveOutcomesTableMobileConnector from "~/web-frontend-core/api/connector/outcomes/live/TableMobile";
// import LiveOutcomesTableConnector from "~/web-frontend-core/api/connector/outcomes/live/Table";
var ListenersManager=exports.ListenersManager=function(){function ListenersManager(cfg){_classCallCheck(this,ListenersManager);this.cfg=cfg;}_createClass(ListenersManager,[{key:'subscribe',value:function subscribe(query){var _a,_b;this.unsubscribe(query);var Listener=ListenersManager.getConnector(query,!!this.cfg.isMobile);if(this.instance instanceof Listener){(_a=this.instance)===null||_a===void 0?void 0:_a.subscribe(query);return;}this.instance=new Listener(this.cfg);(_b=this.instance)===null||_b===void 0?void 0:_b.subscribe(query);}},{key:'unsubscribe',value:function unsubscribe(cfg){if(!this.instance){return;}_logger2.default.getInstance().log(this.instance+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439] \u041E\u0442\u043F\u0438\u0441\u043A\u0430');this.instance.unsubscribe(cfg,'component');}}],[{key:'getConnector',value:function getConnector(query,isMobile){// if (query.matchIds) {
//    const Connector = isMobile ? LiveOutcomesTableMobileConnector : LiveOutcomesTableConnector;
//    Logger.getInstance().log(`${Connector.name}: Табличная роспись Live матча - Подписка`);
//    return Connector;
// }
if(query.singleMatch){_logger2.default.getInstance().log(_SingleMatch.SingleMatchLiveConnector.name+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439 \u0421\u043F\u043E\u0440\u0442\u0430 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');// return false ? LiveOutcomesTableMobileConnector : SingleMatchLiveConnector
return _SingleMatch.SingleMatchLiveConnector;}if(query.video){var Connector=isMobile?_Video.VideoLiveMatchesMobileListener:_Video.VideoLiveMatchesListener;_logger2.default.getInstance().log(Connector.name+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439 \u0441 \u0412\u0438\u0434\u0435\u043E - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return Connector;}if(query.favorites){var _Connector=isMobile?_Favorite.FavoriteLiveMatchesMobileListener:_Favorite.FavoriteLiveMatchesListener;_logger2.default.getInstance().log(_Connector.name+': \u0421\u043F\u0438\u0441\u043E\u043A \u0418\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0445 Live \u043C\u0430\u0442\u0447\u0435\u0439 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _Connector;}if(query.top){var _Connector2=isMobile?_Top.TopLiveMatchesMobileConnector:_Top.TopLiveMatchesConnector;_logger2.default.getInstance().log(_Connector2.name+': \u0421\u043F\u0438\u0441\u043E\u043A Top Live \u043C\u0430\u0442\u0447\u0435\u0439 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _Connector2;}if(query.championshipId){_logger2.default.getInstance().log(_Championship.ChampionshipLiveMatchesListener.name+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439 \u0427\u0435\u043C\u043F\u0438\u043E\u043D\u0430\u0442\u0430 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _Championship.ChampionshipLiveMatchesListener;}if(query.sportId){var _Connector3=isMobile?_Sport.SportLiveMatchesMobileListener:_Sport.SportLiveMatchesListener;_logger2.default.getInstance().log(_Connector3.name+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439 \u0421\u043F\u043E\u0440\u0442\u0430 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _Connector3;}if(query.sportId){var _Connector4=isMobile?_Sport.SportLiveMatchesMobileListener:_Sport.SportLiveMatchesListener;_logger2.default.getInstance().log(_Connector4.name+': \u0421\u043F\u0438\u0441\u043E\u043A Live \u043C\u0430\u0442\u0447\u0435\u0439 \u0421\u043F\u043E\u0440\u0442\u0430 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _Connector4;}_logger2.default.getInstance().log(_All.AllLiveMatchesConnector.name+': \u0421\u043F\u0438\u0441\u043E\u043A \u0412\u0441\u0435\u0445 Live \u043C\u0430\u0442\u0447\u0435\u0439 - \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430');return _All.AllLiveMatchesConnector;}}]);return ListenersManager;}();

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AllLiveMatchesConnector=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllLiveMatchesConnector=exports.AllLiveMatchesConnector=function(_BaseSocketConnector){_inherits(AllLiveMatchesConnector,_BaseSocketConnector);function AllLiveMatchesConnector(){_classCallCheck(this,AllLiveMatchesConnector);var _this=_possibleConstructorReturn(this,(AllLiveMatchesConnector.__proto__||Object.getPrototypeOf(AllLiveMatchesConnector)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_ALL;return _this;}_createClass(AllLiveMatchesConnector,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return AllLiveMatchesConnector;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChampionshipLiveMatchesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChampionshipLiveMatchesListener=exports.ChampionshipLiveMatchesListener=function(_BaseSocketConnector){_inherits(ChampionshipLiveMatchesListener,_BaseSocketConnector);function ChampionshipLiveMatchesListener(){_classCallCheck(this,ChampionshipLiveMatchesListener);var _this=_possibleConstructorReturn(this,(ChampionshipLiveMatchesListener.__proto__||Object.getPrototypeOf(ChampionshipLiveMatchesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_CHAMPIONSHIP;return _this;}_createClass(ChampionshipLiveMatchesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return ChampionshipLiveMatchesListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FavoriteLiveMatchesMobileListener=exports.FavoriteLiveMatchesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector3=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FavoriteLiveMatchesListener=exports.FavoriteLiveMatchesListener=function(_BaseSocketConnector){_inherits(FavoriteLiveMatchesListener,_BaseSocketConnector);function FavoriteLiveMatchesListener(){_classCallCheck(this,FavoriteLiveMatchesListener);var _this=_possibleConstructorReturn(this,(FavoriteLiveMatchesListener.__proto__||Object.getPrototypeOf(FavoriteLiveMatchesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES;return _this;}_createClass(FavoriteLiveMatchesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return FavoriteLiveMatchesListener;}(_BaseSocketConnector3.BaseSocketConnector);var FavoriteLiveMatchesMobileListener=exports.FavoriteLiveMatchesMobileListener=function(_BaseSocketConnector2){_inherits(FavoriteLiveMatchesMobileListener,_BaseSocketConnector2);function FavoriteLiveMatchesMobileListener(){_classCallCheck(this,FavoriteLiveMatchesMobileListener);var _this2=_possibleConstructorReturn(this,(FavoriteLiveMatchesMobileListener.__proto__||Object.getPrototypeOf(FavoriteLiveMatchesMobileListener)).apply(this,arguments));_this2.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES_MOBILE;return _this2;}_createClass(FavoriteLiveMatchesMobileListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return FavoriteLiveMatchesMobileListener;}(_BaseSocketConnector3.BaseSocketConnector);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SportLiveMatchesMobileListener=exports.SportLiveMatchesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector3=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SportLiveMatchesListener=exports.SportLiveMatchesListener=function(_BaseSocketConnector){_inherits(SportLiveMatchesListener,_BaseSocketConnector);function SportLiveMatchesListener(){_classCallCheck(this,SportLiveMatchesListener);var _this=_possibleConstructorReturn(this,(SportLiveMatchesListener.__proto__||Object.getPrototypeOf(SportLiveMatchesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT;return _this;}_createClass(SportLiveMatchesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return SportLiveMatchesListener;}(_BaseSocketConnector3.BaseSocketConnector);var SportLiveMatchesMobileListener=exports.SportLiveMatchesMobileListener=function(_BaseSocketConnector2){_inherits(SportLiveMatchesMobileListener,_BaseSocketConnector2);function SportLiveMatchesMobileListener(){_classCallCheck(this,SportLiveMatchesMobileListener);var _this2=_possibleConstructorReturn(this,(SportLiveMatchesMobileListener.__proto__||Object.getPrototypeOf(SportLiveMatchesMobileListener)).apply(this,arguments));_this2.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT_MOBILE;return _this2;}_createClass(SportLiveMatchesMobileListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return SportLiveMatchesMobileListener;}(_BaseSocketConnector3.BaseSocketConnector);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TopLiveMatchesMobileConnector=exports.TopLiveMatchesConnector=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector3=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopLiveMatchesConnector=exports.TopLiveMatchesConnector=function(_BaseSocketConnector){_inherits(TopLiveMatchesConnector,_BaseSocketConnector);function TopLiveMatchesConnector(){_classCallCheck(this,TopLiveMatchesConnector);var _this=_possibleConstructorReturn(this,(TopLiveMatchesConnector.__proto__||Object.getPrototypeOf(TopLiveMatchesConnector)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP;return _this;}_createClass(TopLiveMatchesConnector,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return TopLiveMatchesConnector;}(_BaseSocketConnector3.BaseSocketConnector);var TopLiveMatchesMobileConnector=exports.TopLiveMatchesMobileConnector=function(_BaseSocketConnector2){_inherits(TopLiveMatchesMobileConnector,_BaseSocketConnector2);function TopLiveMatchesMobileConnector(){_classCallCheck(this,TopLiveMatchesMobileConnector);var _this2=_possibleConstructorReturn(this,(TopLiveMatchesMobileConnector.__proto__||Object.getPrototypeOf(TopLiveMatchesMobileConnector)).apply(this,arguments));_this2.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP_MOBILE;return _this2;}_createClass(TopLiveMatchesMobileConnector,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return TopLiveMatchesMobileConnector;}(_BaseSocketConnector3.BaseSocketConnector);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.VideoLiveMatchesMobileListener=exports.VideoLiveMatchesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector3=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoLiveMatchesListener=exports.VideoLiveMatchesListener=function(_BaseSocketConnector){_inherits(VideoLiveMatchesListener,_BaseSocketConnector);function VideoLiveMatchesListener(){_classCallCheck(this,VideoLiveMatchesListener);var _this=_possibleConstructorReturn(this,(VideoLiveMatchesListener.__proto__||Object.getPrototypeOf(VideoLiveMatchesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO;return _this;}_createClass(VideoLiveMatchesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return VideoLiveMatchesListener;}(_BaseSocketConnector3.BaseSocketConnector);var VideoLiveMatchesMobileListener=exports.VideoLiveMatchesMobileListener=function(_BaseSocketConnector2){_inherits(VideoLiveMatchesMobileListener,_BaseSocketConnector2);function VideoLiveMatchesMobileListener(){_classCallCheck(this,VideoLiveMatchesMobileListener);var _this2=_possibleConstructorReturn(this,(VideoLiveMatchesMobileListener.__proto__||Object.getPrototypeOf(VideoLiveMatchesMobileListener)).apply(this,arguments));_this2.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO_MOBILE;return _this2;}_createClass(VideoLiveMatchesMobileListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return VideoLiveMatchesMobileListener;}(_BaseSocketConnector3.BaseSocketConnector);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SingleMatchLiveConnector=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SingleMatchLiveConnector=exports.SingleMatchLiveConnector=function(_BaseSocketConnector){_inherits(SingleMatchLiveConnector,_BaseSocketConnector);function SingleMatchLiveConnector(){_classCallCheck(this,SingleMatchLiveConnector);var _this=_possibleConstructorReturn(this,(SingleMatchLiveConnector.__proto__||Object.getPrototypeOf(SingleMatchLiveConnector)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_SINGLE_MATCH;return _this;}_createClass(SingleMatchLiveConnector,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,site:this.siteType,lng:this.language},cfg);}}]);return SingleMatchLiveConnector;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MatchesStates=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _LocalStorage=__webpack_require__(170);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LS_KEY='~/web-frontend-core/store/line/matchesList/Matches';/** Состояния матчей */var MatchesStates=exports.MatchesStates=function(_Subscribtion){_inherits(MatchesStates,_Subscribtion);function MatchesStates(){_classCallCheck(this,MatchesStates);var _this=_possibleConstructorReturn(this,(MatchesStates.__proto__||Object.getPrototypeOf(MatchesStates)).apply(this,arguments));_this.unfoldedMatches=new Set();_this.favoriteMatches=new Set((_LocalStorage.LocalStorage.restore(LS_KEY)||[]).map(Number));_this.small_display_invisible={};_this.data={};_this._onFavorite=function(){return void 0;};//#region fold
_this.isUnfoldedMatch=function(matchID){return _this.unfoldedMatches.has(matchID);};_this.foldMatch=function(matchID,isFolded){isFolded?_this.unfoldedMatches.delete(matchID):_this.unfoldedMatches.add(matchID);_this.notify(matchID);};//#endregion
//#region favorite
_this.isFavoriteMatch=function(matchID){return _this.favoriteMatches.has(matchID);};_this.favoriteMatch=function(matchID){var isFavorite=arguments.length>1&&arguments[1]!==undefined?arguments[1]:!_this.favoriteMatches.has(matchID);isFavorite?_this.favoriteMatches.add(matchID):_this.favoriteMatches.delete(matchID);_this.store();_this._onFavorite(matchID,isFavorite);_this.notify(matchID);};return _this;}_createClass(MatchesStates,[{key:'getData',value:function getData(filter){var _this2=this;if(filter&&filter.isFavorite){var favoriteMatchIDs=Array.from(this.favoriteMatches.values());return(0,_lib.objectFromEntries)(favoriteMatchIDs.map(function(matchID){return[matchID,_this2.data[matchID]];}));}return this.data;}},{key:'update',value:function update(data,headTables){var _this3=this;(0,_lib.objectEntries)(data).map(function(_ref){var _ref2=_slicedToArray(_ref,2),matchID=_ref2[0],match=_ref2[1];return[Number(matchID),match];}).forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),matchID=_ref4[0],match=_ref4[1];var _a;_this3.data[matchID]=Object.assign(_this3.data[matchID]||{},match);if('mainLineColsVis'in match){_this3.small_display_invisible[matchID]=(match.mainLineColsVis||[]).map(function(vis){return vis.i;});}if('htId'in match){_this3.small_display_invisible[matchID]=(((_a=headTables===null||headTables===void 0?void 0:headTables[match===null||match===void 0?void 0:match.htId])===null||_a===void 0?void 0:_a.mainLineColsVis)||[]).map(function(vis){return vis.i;});}if('mainLine'in match){_this3.small_display_invisible[matchID].forEach(function(i){match.mainLine[i].additionalClassName='small_display_invisible';});}});this.notify();}},{key:'clear',value:function clear(){this.favoriteMatches.clear();this.unfoldedMatches.clear();this.data={};this.store();}},{key:'hasFavorite',value:function hasFavorite(){return this.favoriteMatches.size>0;}},{key:'setFavorite',value:function setFavorite(matchIDs){this.favoriteMatches=new Set(matchIDs);}},{key:'onFavorite',value:function onFavorite(callback){this._onFavorite=callback;}//#endregion
},{key:'store',value:function store(){_LocalStorage.LocalStorage.store(LS_KEY,Array.from(this.favoriteMatches.values()));}}]);return MatchesStates;}(_Subscribtion3.default);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SportsStates=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** Состояния видов спорта */var SportsStates=exports.SportsStates=function(_Subscribtion){_inherits(SportsStates,_Subscribtion);function SportsStates(){_classCallCheck(this,SportsStates);var _this=_possibleConstructorReturn(this,(SportsStates.__proto__||Object.getPrototypeOf(SportsStates)).apply(this,arguments));_this.sports={};_this.sortedSportIds=[];return _this;}_createClass(SportsStates,[{key:'getData',value:function getData(){return{sports:this.sports,sortedSportIds:this.sortedSportIds};}},{key:'setData',value:function setData(sports,sortedSportIds){this.sortedSportIds=sortedSportIds;this.sports=sports;}},{key:'clear',value:function clear(){this.sports={};this.sortedSportIds=[];}},{key:'update',value:function update(data){var _this2=this;(0,_lib.objectEntries)(data).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),sportID=_ref2[0],sport=_ref2[1];_this2.sports[sportID]=Object.assign(_this2.sports[sportID]||{},sport);});}},{key:'updateSortedIDs',value:function updateSortedIDs(sortedSportIds){this.sortedSportIds=sortedSportIds;}}]);return SportsStates;}(_Subscribtion3.default);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.OutcomesMobileLine=exports.OutcomesMobile=exports.OutcomesDesktop=exports.OutcomesBase=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Table=__webpack_require__(453);var _Table2=_interopRequireDefault(_Table);var _TableMobile=__webpack_require__(455);var _TableMobile2=_interopRequireDefault(_TableMobile);var _base=__webpack_require__(4);var _lib=__webpack_require__(12);var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _All=__webpack_require__(60);var _Types=__webpack_require__(167);var _Favorite=__webpack_require__(456);var _Favorite2=_interopRequireDefault(_Favorite);var _Tables=__webpack_require__(458);var _Tables2=_interopRequireDefault(_Tables);var _HeadTable=__webpack_require__(459);var _HeadTable2=_interopRequireDefault(_HeadTable);var _TableMobileLine=__webpack_require__(460);var _TableMobileLine2=_interopRequireDefault(_TableMobileLine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var OutcomesBase=exports.OutcomesBase=function(){function OutcomesBase(cfg){_classCallCheck(this,OutcomesBase);this.subscribedIDs=new Set();this.update=this.update.bind(this);this.listenWS=this.listenWS.bind(this);this.stopListenWS=this.stopListenWS.bind(this);this.onmessage=this.onmessage.bind(this);this.width=cfg.width||_base.COLUMN_WIDTH.MEDIUM;this.tables=new _Tables2.default(this.width);this.statistical_tables=new _Tables2.default(this.width);this.statistic_types=new _Types.CategoriesTypes();this.headTable=new _HeadTable2.default(this.width);this.statistical_categories=new _All.AllMobileCategories(this.width,this.statistical_tables.select);this.categories=new _All.AllMobileCategories(this.width,this.tables.select);}_createClass(OutcomesBase,[{key:'setWidth',value:function setWidth(width){this.width=width;this.tables.setWidth(width);this.headTable.width=width;this.categories.width=width;}//#region wss
/**
     * Подписка на обновления таблицы live доп.исходов через WS
     */},{key:'listenWS',value:function listenWS(subscriptionID){var _this=this;if(this.isSubscribed(subscriptionID)){return Promise.resolve(subscriptionID);}var logger=_logger2.default.getInstance();return new Promise(function(resolve,reject){_this.wsListener.subscribe({onopen:function onopen(){resolve(subscriptionID);},onerror:function onerror(e){reject(e);},id:subscriptionID,subscriptionID:subscriptionID,onmessage:_this.onmessage});}).then(function(subscriptionID){logger.log('[WebSocket: \u0414\u043E\u043F\u0440\u043E\u0441\u043F\u0438\u0441\u044C '+subscriptionID+'] \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u043E');_this.subscribedIDs.add(subscriptionID);return subscriptionID;}).catch(function(e){logger.error(e);_this.stopListenWS(subscriptionID);_this.deleteGame(subscriptionID);throw e;});}},{key:'onmessage',value:function onmessage(data){if('notExists'in data){this.stopListenWS(data.id);/**
             * Событие завершилось, не удаляем, только чистим данные,
             * чтобы скрыть и не грузить по XHR
             */this.clearGame(data.id);_logger2.default.getInstance().error(new Error('[OutcomesBase] \u0421\u043E\u0431\u044B\u0442\u0438\u0435 '+data.id+' \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442!'));return;}_logger2.default.getInstance().log('[OutcomesBase: \u0414\u043E\u043F\u0440\u043E\u0441\u043F\u0438\u0441\u044C '+data.id+'] \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430');this.update(data.id,data);}},{key:'isSubscribed',value:function isSubscribed(subscriptionID){return this.subscribedIDs.has(subscriptionID);}},{key:'stopListenWS',value:function stopListenWS(subscriptionID){if(!this.subscribedIDs.delete(subscriptionID)){return Promise.resolve();}_logger2.default.getInstance().log('[WebSocket] \u041E\u0442\u043F\u0438\u0441\u043A\u0430 \u043E\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439 '+subscriptionID+' \u0434\u043E\u043F\u0440\u043E\u0441\u043F\u0438\u0441\u0438');this.wsListener.unsubscribe({subscriptionID:subscriptionID});return Promise.resolve();}},{key:'stopListenAllWS',value:function stopListenAllWS(){_logger2.default.getInstance().log('[WebSocket] Отписка от всех обновлений допросписи');this.subscribedIDs.forEach(this.stopListenWS);}//#endregion
/**
     * Возвращает `true`, если есть игра
     * @param matchID
     */},{key:'hasGame',value:function hasGame(matchID){return this.tables.getData(matchID)!==null;}/**
     * Возвращает `true`, если есть игра и данные по ней
     * @param matchID
     */},{key:'hasGameData',value:function hasGameData(matchID){if(!this.hasGame(matchID)){return false;}var data=this.tables.getData(matchID);return!!data&&Object.keys(data.coefs||{}).length!==0;}/**
     * true, если есть статистический матч
     * @param matchID
     */},{key:'hasGameStatisctic',value:function hasGameStatisctic(matchID){return this.statistical_tables.getData(matchID)!==null;}/**
     * `true`, если есть стат. матч и данные по нему
     * @param matchID
     */},{key:'hasGameDataStatisctic',value:function hasGameDataStatisctic(matchID){if(!this.hasGameStatisctic(matchID)){return false;}var data=this.statistical_tables.getData(matchID);return!!data&&Object.keys(data.coefs||{}).length!==0;}},{key:'clear',value:function clear(){this.categories.clear();// this.statistical_categories.clear();
this.headTable.clear();this.tables.clear();// this.statistical_tables.clear();
}/**
     * Очистить данные по событию
     * Т.е в случае, если событие завершилось,
     * данные очищаются, id остается, отображение скрывается
     * @param matchID
     */},{key:'clearGame',value:function clearGame(matchID){// this.description.clearGame(matchID);
this.categories.clearGame(matchID);// this.statistical_categories.clearGame(matchID);
this.headTable.clearGame(matchID);this.tables.clearGame(matchID);// this.statistical_tables.clearGame(matchID);
}/**
     * Удалить событие: данные + id
     * Обновлением и отображением события больше не занимаемся
     * @param {string} matchID
     */},{key:'deleteGame',value:function deleteGame(matchID){// this.description.deleteGame(matchID);
this.categories.deleteGame(matchID);// this.statistical_categories.deleteGame(matchID);
this.headTable.deleteGame(matchID);this.tables.deleteGame(matchID);// this.statistical_tables.deleteGame(matchID);
}},{key:'updateStatistic',value:function updateStatistic(matchID,sportID,data){var _this2=this;this.statistic_types.update(matchID,data.statsTypes||[]);var statTypeBlStates=(0,_lib.objectFromEntries)((0,_lib.objectEntries)(data.statsMatches||{}).filter(function(_ref){var _ref2=_slicedToArray(_ref,2),state=_ref2[1];return'bl'in state;}).map(function(_ref3){var _ref4=_slicedToArray(_ref3,2),matchID=_ref4[0],state=_ref4[1];return[matchID,state.bl===_base.LOCK_STATE.BLOCKED||state.additionalOdds===null&&state.categories===null];}));this.statistic_types.disable(matchID,statTypeBlStates);(0,_lib.objectEntries)(data.statsMatches||{}).forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),matchID=_ref6[0],state=_ref6[1];_this2.statistical_tables.update(Number(matchID),sportID,'bl'in state?{isDisabled:state.bl===_base.LOCK_STATE.BLOCKED}:{},state.tables,(state.tablesData||{}).tables,state.odds);_this2.statistical_categories.update(Number(matchID),sportID,{},//{ isDisabled: state.bl === LOCK_STATE.BLOCKED },
state.categories,(state.tablesData||{}).categories,[]);});}}]);return OutcomesBase;}();var OutcomesDesktop=exports.OutcomesDesktop=function(_OutcomesBase){_inherits(OutcomesDesktop,_OutcomesBase);function OutcomesDesktop(cfg){_classCallCheck(this,OutcomesDesktop);var _this3=_possibleConstructorReturn(this,(OutcomesDesktop.__proto__||Object.getPrototypeOf(OutcomesDesktop)).call(this,cfg));_this3.wsListener=new _Table2.default({site:cfg.siteType||_base.SITE_TYPE.COM,timezone:cfg.timezone,lng:cfg.lng});_this3.statistical_categories=new _Favorite2.default(_this3.width,_this3.statistical_tables.select,_this3.statistical_tables.favorite,_this3.statistical_tables.getFavoriteTables);_this3.categories=new _Favorite2.default(_this3.width,_this3.tables.select,_this3.tables.favorite,_this3.tables.getFavoriteTables);return _this3;}_createClass(OutcomesDesktop,[{key:'update',value:function update(matchID,data){var config='bl'in data?{isDisabled:data.bl===_base.LOCK_STATE.BLOCKED}:{};/**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */this.tables.update(matchID,data.sportId,config,data.bodyTables,(data.tablesData||{}).tables,data.odds);this.headTable.update(matchID,config,data);this.updateStatistic(matchID,data.sportId,data);this.categories.update(matchID,data.sportId,{},data.categories,(data.tablesData||{}).categories,data.defaultCategories);}}]);return OutcomesDesktop;}(OutcomesBase);var OutcomesMobile=exports.OutcomesMobile=function(_OutcomesBase2){_inherits(OutcomesMobile,_OutcomesBase2);function OutcomesMobile(cfg){_classCallCheck(this,OutcomesMobile);var _this4=_possibleConstructorReturn(this,(OutcomesMobile.__proto__||Object.getPrototypeOf(OutcomesMobile)).call(this,cfg));_this4.wsListener=new _TableMobile2.default({site:cfg.siteType||_base.SITE_TYPE.COM,timezone:cfg.timezone,lng:cfg.lng});return _this4;}_createClass(OutcomesMobile,[{key:'update',value:function update(matchID,data){var config='bl'in data?{isDisabled:data.bl===_base.LOCK_STATE.BLOCKED}:{};/**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */this.tables.update(matchID,data.sportId,config,data.tables,(data.tablesData||{}).tables,data.odds,data.additionalOdds,data.expandedTables);this.updateStatistic(matchID,data.sportId,data);this.categories.update(matchID,data.sportId,{},data.categories,(data.tablesData||{}).categories,data.defaultCategories);}}]);return OutcomesMobile;}(OutcomesBase);var OutcomesMobileLine=exports.OutcomesMobileLine=function(_OutcomesBase3){_inherits(OutcomesMobileLine,_OutcomesBase3);function OutcomesMobileLine(cfg){_classCallCheck(this,OutcomesMobileLine);var _this5=_possibleConstructorReturn(this,(OutcomesMobileLine.__proto__||Object.getPrototypeOf(OutcomesMobileLine)).call(this,cfg));_this5.wsListener=new _TableMobileLine2.default({site:cfg.siteType||_base.SITE_TYPE.COM,timezone:cfg.timezone,lng:cfg.lng});return _this5;}_createClass(OutcomesMobileLine,[{key:'update',value:function update(matchID,data){var config='bl'in data?{isDisabled:data.bl===_base.LOCK_STATE.BLOCKED}:{};/**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */this.tables.update(matchID,data.sportId,config,data.tables,(data.tablesData||{}).tables,data.odds,data.additionalOdds,data.expandedTables);this.updateStatistic(matchID,data.sportId,data);this.categories.update(matchID,data.sportId,{},data.categories,(data.tablesData||{}).categories,data.defaultCategories);}}]);return OutcomesMobileLine;}(OutcomesBase);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _base=__webpack_require__(4);var _Base=__webpack_require__(454);var _Base2=_interopRequireDefault(_Base);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveOutcomesTable=function(_LiveOutcomes){_inherits(LiveOutcomesTable,_LiveOutcomes);function LiveOutcomesTable(){_classCallCheck(this,LiveOutcomesTable);var _this=_possibleConstructorReturn(this,(LiveOutcomesTable.__proto__||Object.getPrototypeOf(LiveOutcomesTable)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE;return _this;}return LiveOutcomesTable;}(_Base2.default);exports.default=LiveOutcomesTable;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveOutcomes=function(_BaseSocketConnector){_inherits(LiveOutcomes,_BaseSocketConnector);function LiveOutcomes(){_classCallCheck(this,LiveOutcomes);var _this=_possibleConstructorReturn(this,(LiveOutcomes.__proto__||Object.getPrototypeOf(LiveOutcomes)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE;return _this;}_createClass(LiveOutcomes,[{key:'getOutcomeData',value:function getOutcomeData(cfg){var _a,_b;return{site:this.siteType,lng:this.language,timezone:this.timezone,id:((_b=(_a=cfg)===null||_a===void 0?void 0:_a.matchIds)===null||_b===void 0?void 0:_b[0])||cfg.id};}}]);return LiveOutcomes;}(_BaseSocketConnector2.BaseSocketConnector);exports.default=LiveOutcomes;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveOutcomesTableMobile=function(_BaseSocketConnector){_inherits(LiveOutcomesTableMobile,_BaseSocketConnector);function LiveOutcomesTableMobile(){_classCallCheck(this,LiveOutcomesTableMobile);var _this=_possibleConstructorReturn(this,(LiveOutcomesTableMobile.__proto__||Object.getPrototypeOf(LiveOutcomesTableMobile)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE_MOBILE;return _this;}_createClass(LiveOutcomesTableMobile,[{key:'getOutcomeData',value:function getOutcomeData(_ref){var id=_ref.id;return{site:this.siteType,lng:this.language,id:id,timezone:this.timezone};}}]);return LiveOutcomesTableMobile;}(_BaseSocketConnector2.BaseSocketConnector);exports.default=LiveOutcomesTableMobile;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _lib=__webpack_require__(12);var _All=__webpack_require__(60);var _AllMultiSelect=__webpack_require__(457);var _base=__webpack_require__(4);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FAVORITE_CATEGORY_ID='FAVOURITES';var FavoriteCategories=function(_AllMultiSelectCatego){_inherits(FavoriteCategories,_AllMultiSelectCatego);function FavoriteCategories(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_base.COLUMN_WIDTH.MEDIUM;var onTablesSelect=arguments[1];var onTablesFavorite=arguments[2];var getFavoriteTables=arguments[3];_classCallCheck(this,FavoriteCategories);var _this=_possibleConstructorReturn(this,(FavoriteCategories.__proto__||Object.getPrototypeOf(FavoriteCategories)).call(this,width,onTablesSelect));_this.onTablesFavorite=onTablesFavorite;_this.getFavoriteTables=getFavoriteTables;/** Категории, добавленные пользователем в избранное, общие среди матчей */_this.favoriteCategories=new Map();return _this;}/**
     * Добавить категорию в избранное
     * @param matchID
     * @param categoryIDs
     * @param isFavorite
     */_createClass(FavoriteCategories,[{key:'favorite',value:function favorite(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var isFavorite=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!this.getData(matchID)){return;}if(categoryIDs.indexOf(FAVORITE_CATEGORY_ID)!==-1){this.clearFavorite(matchID);return;}this.addFavoriteCategories(matchID,categoryIDs,isFavorite);var states=(0,_lib.objectFromEntries)(categoryIDs.map(function(categoryID){return[categoryID,{isFavorite:isFavorite}];}));var tables=this.getFavoriteTables(this.sportID[matchID],matchID);var noFavoriteTables=tables.length===0;if(noFavoriteTables){this.clearFavorite(matchID);return;}states[FAVORITE_CATEGORY_ID]={// [this.width]: this.getFavoriteCoefCount(matchID),
isDisabled:noFavoriteTables,isFavorite:!noFavoriteTables,tables:tables};this.assignStates(matchID,states);this.select(matchID);}},{key:'select',value:function select(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.has(matchID)&&this.selectedCategories.get(matchID).values()||[]);var isSelected=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!this.selectedCategories.has(matchID)){return;}if(categoryIDs.indexOf(_All.ALL_CATEGORY_ID)!==-1){this.unselectCategories(matchID);return;}if(!isSelected){this.unselectCategories(matchID,categoryIDs);return;}var favoriteTables=this.getFavoriteTables(this.sportID[matchID],matchID);if(categoryIDs.indexOf(FAVORITE_CATEGORY_ID)!==-1&&favoriteTables.length!==0){var _newStates;this.unselectCategories(matchID);var newStates=(_newStates={},_defineProperty(_newStates,_All.ALL_CATEGORY_ID,{isSelected:false}),_defineProperty(_newStates,FAVORITE_CATEGORY_ID,{isSelected:true,tables:favoriteTables}),_newStates);this.assignStates(matchID,newStates);this.selectedCategories.set(matchID,new Set([FAVORITE_CATEGORY_ID]));this.selectTables(matchID);return;}this.selectCategories(matchID,categoryIDs);}},{key:'selectCategories',value:function selectCategories(matchID,categoryIDs){var _Object$assign;var selectedCategories=this.selectedCategories.get(matchID);if(!selectedCategories){return;}categoryIDs.forEach(function(categoryID){selectedCategories.add(categoryID);});selectedCategories.delete(FAVORITE_CATEGORY_ID);this.selectTables(matchID);var states=(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:true}];}));var newStates=Object.assign((_Object$assign={},_defineProperty(_Object$assign,_All.ALL_CATEGORY_ID,{isSelected:selectedCategories.size===0}),_defineProperty(_Object$assign,FAVORITE_CATEGORY_ID,{isSelected:false}),_Object$assign),states);this.assignStates(matchID,newStates);}},{key:'deleteCategories',value:function deleteCategories(matchID,categoryIDs){var categories=categoryIDs.filter(function(c){return c!==FAVORITE_CATEGORY_ID;});_get(FavoriteCategories.prototype.__proto__||Object.getPrototypeOf(FavoriteCategories.prototype),'deleteCategories',this).call(this,matchID,categories);this.addFavoriteCategories(matchID,categories,false);}},{key:'createNewCategories',value:function createNewCategories(matchID,sportID,config,newStates,categoriesLabels,selected){_get(FavoriteCategories.prototype.__proto__||Object.getPrototypeOf(FavoriteCategories.prototype),'createNewCategories',this).call(this,matchID,sportID,config,newStates,categoriesLabels,selected);this.select(matchID,selected||void 0,true);if(!this.favoriteCategories.has(sportID)){this.favoriteCategories.set(sportID,new Set());}var favoriteCategories=this.favoriteCategories.get(sportID);this.favorite(matchID,Array.from(favoriteCategories&&favoriteCategories.values()||[]));}},{key:'createNewCategoriesStates',value:function createNewCategoriesStates(matchID,sportID,config,newStates,selected){var tables=this.getFavoriteTables(sportID,matchID);var states=_get(FavoriteCategories.prototype.__proto__||Object.getPrototypeOf(FavoriteCategories.prototype),'createNewCategoriesStates',this).call(this,matchID,sportID,config,newStates,selected);states[FAVORITE_CATEGORY_ID]=FavoriteCategories.createFavoriteCategoryState(tables);return states;}},{key:'setCategoriesLabels',value:function setCategoriesLabels(matchID,categoriesLabels,prevStates){categoriesLabels.forEach(function(_ref){var id=_ref.id,txt=_ref.txt;prevStates[id].label=txt;});this.order.set(matchID,[_All.ALL_CATEGORY_ID].concat(categoriesLabels.map(function(_ref2){var id=_ref2.id;return id;}),FAVORITE_CATEGORY_ID));}/**
     * Очистить все избранные категории
     */},{key:'clearFavorite',value:function clearFavorite(matchID){var favoriteCategories=this.favoriteCategories.get(this.sportID[matchID]);var states=(0,_lib.objectFromEntries)(Array.from(favoriteCategories.values()).map(function(categoryID){return[categoryID,{isFavorite:false}];}));states[FAVORITE_CATEGORY_ID]={// [this.width]: this.getFavoriteCoefCount(matchID),
isDisabled:true,isFavorite:false,tables:[]};favoriteCategories.clear();this.addFavoriteTables(matchID,[_All.ALL_CATEGORY_ID],false);this.assignStates(matchID,states);this.select(matchID);}},{key:'addFavoriteCategories',value:function addFavoriteCategories(matchID,categoryIDs,isFavorite){if(categoryIDs.length===0){return;}var sportID=this.sportID[matchID];var favoriteCategories=this.favoriteCategories.get(sportID);var action=isFavorite?function(c){favoriteCategories.add(c);}:function(c){favoriteCategories.delete(c);};categoryIDs.forEach(action);var states=(0,_lib.objectFromEntries)(categoryIDs.map(function(categoryID){return[categoryID,{isFavorite:isFavorite}];}));this.assignStates(matchID,states);this.addFavoriteTables(matchID,categoryIDs,isFavorite);}/** Добавляет в избранное все таблицы избранных категорий */},{key:'addFavoriteTables',value:function addFavoriteTables(matchID,categoryIDs,isFavorite){var categories=this.getData(matchID);if(!categories){return;}var favoriteTables=categoryIDs.filter(function(categoryID){return categoryID in categories;}).map(function(categoryID){var _a;return((_a=categories[categoryID])===null||_a===void 0?void 0:_a.tables)||[];}).reduce(function(allTables,tables){return allTables.concat(tables);},[]);if(favoriteTables.length===0){return;}this.onTablesFavorite(matchID,favoriteTables,isFavorite);}/** Возвращает общее число избранных коэф */// TODO поправить баг кол-во коэф. при добавление в избранное таблицы
// private getFavoriteCoefCount(matchID: GameID): number {
//    const categories = this.getData(matchID);
//    if (!categories) {
//       throw new Error('Попытка обратиться к несуществующей категории!');
//    }
//    return Array
//       .from(this.favoriteCategories.values())
//       .map((categoryID) => categories[categoryID][this.width])
//       .filter((count): count is number => typeof count !== 'undefined')
//       .reduce((acc, count) => acc + count, 0);
// }
}],[{key:'createFavoriteCategoryState',value:function createFavoriteCategoryState(tables){return{tables:tables,isDisabled:tables.length===0};}}]);return FavoriteCategories;}(_AllMultiSelect.AllMultiSelectCategories);exports.default=FavoriteCategories;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AllMultiSelectCategories=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _All=__webpack_require__(60);var _base=__webpack_require__(4);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllMultiSelectCategories=exports.AllMultiSelectCategories=function(_AllMobileCategories){_inherits(AllMultiSelectCategories,_AllMobileCategories);function AllMultiSelectCategories(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_base.COLUMN_WIDTH.MEDIUM;var onTablesSelect=arguments[1];_classCallCheck(this,AllMultiSelectCategories);var _this=_possibleConstructorReturn(this,(AllMultiSelectCategories.__proto__||Object.getPrototypeOf(AllMultiSelectCategories)).call(this,width,onTablesSelect));_this.width=width;_this.select=_this.select.bind(_this);return _this;}_createClass(AllMultiSelectCategories,[{key:'deleteCategories',value:function deleteCategories(matchID,categoryIDs){if(categoryIDs.length===0){return;}var selectedCategories=this.selectedCategories.get(matchID);if(!selectedCategories){return;}var data=this.getData(matchID);if(!data){throw new Error('No data for '+matchID);}categoryIDs.forEach(function(categoryID){selectedCategories.delete(categoryID);delete data[categoryID];});this.select(matchID);}/**
     * Обновление фильтра таблицы доп.росписи
     * приходит полностью новое состояние, отсутсвующие категории удаляются
     * @example
     * ```
     *    categories.update(matchID, {
     *       [categoryID]: { isSelected: !categoryTab.isSelected }
     *    });
     * ```
     */},{key:'update',value:function update(matchID){var sportID=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.sportID[matchID];var config=arguments[2];var categoriesLabels=arguments[3];var newStates=arguments[4];var selected=arguments[5];if(!newStates){return;}var prevStates=this.getData(matchID);if(!prevStates){this.createNewCategories(matchID,sportID,config,newStates,categoriesLabels,selected);return;}// обновляем существующие категории
(0,_lib.objectEntries)(newStates).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),categoryID=_ref2[0],newState=_ref2[1];prevStates[categoryID]=Object.assign(prevStates[categoryID]||{},newState,config);});prevStates[_All.ALL_CATEGORY_ID]=(0,_All.createAllCategoryState)(newStates,prevStates[_All.ALL_CATEGORY_ID]&&prevStates[_All.ALL_CATEGORY_ID].isSelected);if(categoriesLabels){this.setCategoriesLabels(matchID,categoriesLabels,prevStates);}var updatedCategories=Object.keys(newStates).concat(_All.ALL_CATEGORY_ID);var toDelete=Object.keys(prevStates).filter(function(categoryID){return updatedCategories.indexOf(categoryID)===-1;});this.deleteCategories(matchID,toDelete);}},{key:'setCategoriesLabels',value:function setCategoriesLabels(matchID,categoriesLabels,prevStates){categoriesLabels.forEach(function(_ref3){var id=_ref3.id,txt=_ref3.txt;prevStates[id].label=txt;});this.order.set(matchID,[_All.ALL_CATEGORY_ID].concat(categoriesLabels.map(function(_ref4){var id=_ref4.id;return id;})));}/**
     * Выбрать категорию
     * @param matchID
     * @param categoryIDs
     * @param isSelected
     */},{key:'select',value:function select(matchID){var categoryIDs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Array.from(// @ts-ignore
this.selectedCategories.get(matchID)&&this.selectedCategories.get(matchID).values()||[]);var isSelected=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!this.selectedCategories.has(matchID)){return;}if(categoryIDs.indexOf(_All.ALL_CATEGORY_ID)!==-1){this.unselectCategories(matchID);return;}if(!isSelected){this.unselectCategories(matchID,categoryIDs);return;}this.selectCategories(matchID,categoryIDs);}},{key:'selectCategories',value:function selectCategories(matchID,categoryIDs){var selectedCategories=this.selectedCategories.get(matchID);if(!selectedCategories){return;}categoryIDs.forEach(function(categoryID){selectedCategories.add(categoryID);});this.selectTables(matchID);var states=(0,_lib.objectFromEntries)(Array.from(selectedCategories.values()||[]).map(function(categoryID){return[categoryID,{isSelected:true}];}));var newStates=Object.assign(_defineProperty({},_All.ALL_CATEGORY_ID,{isSelected:selectedCategories.size===0}),states);this.assignStates(matchID,newStates);}},{key:'createNewCategories',value:function createNewCategories(matchID,sportID,config,newStates,categoriesLabels,selected){var categories=this.createNewCategoriesStates(matchID,sportID,config,newStates,selected);if(categoriesLabels){this.setCategoriesLabels(matchID,categoriesLabels,categories);}this.sportID[matchID]=sportID;this.data.set(matchID,categories);this.selectedCategories.set(matchID,new Set());}},{key:'createNewCategoriesStates',value:function createNewCategoriesStates(_gameID,_sportID,config,newStates,selected){var categoryAllState=(0,_All.createAllCategoryState)(newStates,!selected||selected.length===0);var states=_defineProperty({},_All.ALL_CATEGORY_ID,categoryAllState);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(newStates)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var categoryID=_step.value;states[categoryID]=Object.assign(Object.assign({},newStates[categoryID]),config);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return states;}}]);return AllMultiSelectCategories;}(_All.AllMobileCategories);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lib=__webpack_require__(12);var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OutcomesTables=function(_Subscribtion){_inherits(OutcomesTables,_Subscribtion);function OutcomesTables(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_base.COLUMN_WIDTH.MEDIUM;_classCallCheck(this,OutcomesTables);var _this=_possibleConstructorReturn(this,(OutcomesTables.__proto__||Object.getPrototypeOf(OutcomesTables)).call(this));_this.width=width;_this.data=new Map();/** Избранные таблицы общие между матчами */_this.favoriteTables=new Map();_this.sportID={};_this.select=_this.select.bind(_this);_this.favorite=_this.favorite.bind(_this);_this.getFavoriteTables=_this.getFavoriteTables.bind(_this);return _this;}_createClass(OutcomesTables,[{key:'getData',value:function getData(matchID){return this.data.get(Number(matchID))||null;}/**
     * Обновление таблицы доп.росписи
     * @example
     * ```
     *    tables.update(matchID, {
     *       [categoryID]: [[{ "txt": "Двойной шанс", "st": "h" }]],
     *    });
     * ```
     */},{key:'update',value:function update(matchID){var sportID=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.sportID[matchID];var _ref=arguments[2];var isDisabled=_ref.isDisabled;var newData=arguments[3];var style=arguments[4];var coefs=arguments[5];var _this2=this;var additionalOdds=arguments[6];var expandedTables=arguments[7];if((newData===null||style===null||typeof coefs!=='undefined')&&Object.keys(coefs).length===0){this.clearGame(matchID);this.notify(matchID);return;}var data=this.data.get(matchID);if(!data){var favoriteTables=this.favoriteTables.get(sportID);var foldedTables=[];var tables=(newData||[]).reduce(function(d,_ref2,order){var id=_ref2.id,rows=_ref2.rows;var visibleOnWidth=style&&style[id].vis;var isVisible=visibleOnWidth?visibleOnWidth===_this2.width:true;var columnWidths=style&&style[id].colWidths||[];var isFolded=expandedTables&&expandedTables.expand.length!==0&&expandedTables.expand.indexOf(id)===-1||false;if(isFolded){foldedTables.push(id);}d[id]={isFavorite:favoriteTables&&favoriteTables.has(id),isSelected:!!style&&style[id].isSelected,visibleOnWidth:visibleOnWidth,columnWidths:columnWidths,isVisible:isVisible,isFolded:isFolded,// order,
rows:rows};return d;},{});while((newData||[]).length-foldedTables.length<(expandedTables&&expandedTables.minCount||1)&&foldedTables.length!==0){tables[foldedTables.shift()].isFolded=false;}this.sportID[matchID]=sportID;if(!favoriteTables){this.favoriteTables.set(sportID,new Set());}this.data.set(matchID,{additionalOdds:additionalOdds||[],isDisabled:!!isDisabled,foldedTables:new Set(),coefs:coefs||{},tables:tables});this.notify(matchID);return;}this.updateTables(data,newData,style);Object.assign(data.coefs,coefs);data.additionalOdds=additionalOdds||data.additionalOdds;if(typeof isDisabled!=='undefined'){data.isDisabled=isDisabled;}this.notify(matchID);}},{key:'updateTables',value:function updateTables(data){var _this3=this;var newData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var style=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!(newData===null||newData===void 0?void 0:newData.length))return;// чтобы предотвратить скрытие таблицы если обновлений нет
var updated={};(newData||[]).forEach(function(_ref3){var id=_ref3.id,rows=_ref3.rows;updated[id]=true;var visibleOnWidth=style[id].vis;var isVisible=visibleOnWidth?visibleOnWidth===_this3.width:true;if(data.tables[id]){data.tables[id].rows=rows;data.tables[id].isVisible=isVisible;return;}var columnWidths=style[id].colWidths||[];data.tables[id]={isSelected:!!style[id].isSelected,isFavorite:false,visibleOnWidth:visibleOnWidth,columnWidths:columnWidths,isVisible:isVisible,rows:rows};});var disabledTables=Object.keys(data.tables).filter(function(id){return!updated[id];});disabledTables.forEach(function(id){data.tables[id].isVisible=false;});}},{key:'restyle',value:function restyle(matchID){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var data=this.data.get(matchID);if(!data){return;}(0,_lib.objectEntries)(style).forEach(function(_ref4){var _ref5=_slicedToArray(_ref4,2),id=_ref5[0],_ref5$=_ref5[1],colWidths=_ref5$.colWidths,isSelected=_ref5$.isSelected,isFavorite=_ref5$.isFavorite,isFolded=_ref5$.isFolded,isVisible=_ref5$.isVisible;if(!data.tables[id]){return;}if(typeof isVisible!=='undefined'){data.tables[id].isVisible=isVisible;}if(!data.tables[id].isVisible){return;}if(typeof colWidths!=='undefined'){data.tables[id].columnWidths=colWidths;}if(typeof isSelected!=='undefined'){data.tables[id].isSelected=isSelected;}if(typeof isFavorite!=='undefined'){data.tables[id].isFavorite=isFavorite;}if(typeof isFolded!=='undefined'){data.tables[id].isFolded=isFolded;}});this.notify(matchID);}},{key:'setWidth',value:function setWidth(width){if(this.width===width){return;}this.width=width;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Array.from(this.data.entries())[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _step$value=_slicedToArray(_step.value,2),matchID=_step$value[0],data=_step$value[1];var states=(0,_lib.objectFromEntries)((0,_lib.objectEntries)(data.tables).filter(function(_ref6){var _ref7=_slicedToArray(_ref6,2),visibleOnWidth=_ref7[1].visibleOnWidth;return!!visibleOnWidth;}).map(function(_ref8){var _ref9=_slicedToArray(_ref8,2),tableID=_ref9[0],visibleOnWidth=_ref9[1].visibleOnWidth;return[tableID,{isVisible:visibleOnWidth===width,isSelected:visibleOnWidth===width}];}));this.restyle(matchID,states);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}//#region select
},{key:'select',value:function select(matchID,tablesIDs,isSelected){var tables=tablesIDs.length!==0?tablesIDs:Object.keys((this.getData(matchID)||{}).tables||{});var state=(0,_lib.objectFromEntries)(tables.map(function(tableID){return[tableID,{isSelected:isSelected}];}));this.restyle(matchID,state);}//#endregion select
//#region favorite
},{key:'favorite',value:function favorite(matchID,tablesIDs,isFavorite){if(!this.getData(matchID)){return;}var sportID=this.sportID[matchID];var favoriteTables=this.favoriteTables.get(sportID);var action=isFavorite?function(tableID){return favoriteTables.add(tableID);}:function(tableID){return favoriteTables.delete(tableID);};tablesIDs.forEach(action);var state=(0,_lib.objectFromEntries)(tablesIDs.map(function(tableID){return[tableID,{isFavorite:isFavorite}];}));this.restyle(matchID,state);}},{key:'getFavoriteTables',value:function getFavoriteTables(sportID,matchID){var tables=(this.getData(matchID)||{}).tables||{};var favoriteTables=this.favoriteTables.get(sportID);return Array.from(favoriteTables&&favoriteTables.values()||[]).filter(function(tableID){return tableID in tables;});}//#endregion favorite
//#region fold
},{key:'fold',value:function fold(matchID,tableIDs){var isFolded=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var data=this.getData(matchID);if(!data){throw new Error('No data to fold tables');}var tables=tableIDs||Object.keys(data.tables);var action=isFolded?function(tableID){return data.foldedTables.add(tableID);}:function(tableID){return data.foldedTables.delete(tableID);};tables.forEach(action);var style=(0,_lib.objectFromEntries)(tables.map(function(tableID){return[tableID,{isFolded:isFolded}];}));this.restyle(matchID,style);}},{key:'isAllUnfolded',value:function isAllUnfolded(matchID){var data=this.getData(matchID);return!data||data.foldedTables.size===0;}//#endregion fold
//#region clean
},{key:'clear',value:function clear(){this.sportID={};this.data.clear();this.notify();}},{key:'clearGame',value:function clearGame(matchID){this.data.set(matchID,{foldedTables:new Set(),isDisabled:false,additionalOdds:[],tables:{},coefs:{}});this.notify(matchID);}},{key:'deleteGame',value:function deleteGame(matchID){this.data.delete(matchID);this.notify(matchID);}}]);return OutcomesTables;}(_Subscribtion3.default);exports.default=OutcomesTables;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _base=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeadTable=function(_Subscribtion){_inherits(HeadTable,_Subscribtion);function HeadTable(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_base.COLUMN_WIDTH.MEDIUM;_classCallCheck(this,HeadTable);var _this=_possibleConstructorReturn(this,(HeadTable.__proto__||Object.getPrototypeOf(HeadTable)).call(this));_this.width=width;_this.data=new Map();return _this;}_createClass(HeadTable,[{key:'getData',value:function getData(matchID){return this.data.get(matchID)||null;}},{key:'update',value:function update(matchID,config,data){var prevData=this.getData(matchID);var isDisabled=typeof config.isDisabled!=='undefined'?config.isDisabled:typeof data.bl!=='undefined'?data.bl===_base.LOCK_STATE.BLOCKED:!!prevData&&prevData.isDisabled;/**
         * обновление headTable содержит только свойства ячеек, которые редко меняются
         * значения же коэф. берутся из outcomes.table,
         * которые обновляются вместе outcomes.headData в родителе Outcomes
         * Т.е необходимо перерисовавыться при каждом обновлении.
         */if((data.headTable||[]).length===0&&(data.header||[]).length===0&&prevData){prevData.isDisabled=isDisabled;this.notify(matchID);return;}((data.tablesData||{}).headerTableColsVis||[]).forEach(function(_ref){var i=_ref.i;data.headTable&&data.headTable.forEach(function(row){row[i].additionalClassName=(row[i].st||'')+' small_display_invisible';});});this.data.set(matchID,{headTable:(data.headTable||[]).map(function(row){return row.slice(1).concat(row[0]);}),isDisabled:isDisabled});this.notify(matchID);}},{key:'clear',value:function clear(){this.data.clear();this.notify();}},{key:'clearGame',value:function clearGame(matchID){this.data.set(matchID,{headTable:[],isDisabled:false});this.notify();}},{key:'deleteGame',value:function deleteGame(matchID){this.data.delete(matchID);this.notify();}}]);return HeadTable;}(_Subscribtion3.default);exports.default=HeadTable;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineOutcomesTableMobile=function(_BaseSocketConnector){_inherits(LineOutcomesTableMobile,_BaseSocketConnector);function LineOutcomesTableMobile(){_classCallCheck(this,LineOutcomesTableMobile);var _this=_possibleConstructorReturn(this,(LineOutcomesTableMobile.__proto__||Object.getPrototypeOf(LineOutcomesTableMobile)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LINE_OUTCOMES_TABLE_MOBILE;return _this;}_createClass(LineOutcomesTableMobile,[{key:'getOutcomeData',value:function getOutcomeData(_ref){var id=_ref.id;return{site:this.siteType,lng:this.language,id:id,timezone:this.timezone};}}]);return LineOutcomesTableMobile;}(_BaseSocketConnector2.BaseSocketConnector);exports.default=LineOutcomesTableMobile;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(462);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(_ref){var title=_ref.title,text=_ref.text;return _react2.default.createElement('div',{className:'message-line'},_react2.default.createElement('div',{className:'message-line__inner'},_react2.default.createElement('div',{className:'message-line__icon'}),title?_react2.default.createElement('div',{className:'message-line__title',dangerouslySetInnerHTML:{__html:title||''}}):null,text?_react2.default.createElement('div',{className:'message-line__text',dangerouslySetInnerHTML:{__html:text||''}}):null));};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _mobxReact=__webpack_require__(1);var _common=__webpack_require__(6);var _message=__webpack_require__(464);var _message2=_interopRequireDefault(_message);var _win=__webpack_require__(465);var _win2=_interopRequireDefault(_win);var _systems=__webpack_require__(467);var _systems2=_interopRequireDefault(_systems);var _selector=__webpack_require__(468);var _selector2=_interopRequireDefault(_selector);var _items=__webpack_require__(469);var _items2=_interopRequireDefault(_items);var _settings=__webpack_require__(470);var _settings2=_interopRequireDefault(_settings);var _fastAmount=__webpack_require__(471);var _fastAmount2=_interopRequireDefault(_fastAmount);var _oneClick=__webpack_require__(472);var _oneClick2=_interopRequireDefault(_oneClick);var _reactOnclickoutside=__webpack_require__(82);var _reactOnclickoutside2=_interopRequireDefault(_reactOnclickoutside);var _lodash=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Label=(_dec=(0,_mobxReact.inject)('dictStore','lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Label,_Component);function Label(){_classCallCheck(this,Label);return _possibleConstructorReturn(this,(Label.__proto__||Object.getPrototypeOf(Label)).apply(this,arguments));}_createClass(Label,[{key:'render',value:function render(){var basketData=this.props.lineStore.basket.basketData;var odds=(0,_lodash.get)(basketData,'odds',{});var oddsLength=Object.keys(odds).length;return _react2.default.createElement('div',{className:'basket-header-label-new'},_react2.default.createElement('div',{className:'basket-bets-count-item basket-bets-count-item-border'},_react2.default.createElement('span',{className:'fl_l'},this.props.dictStore.getLang('BASKET')),oddsLength>0?_react2.default.createElement('span',{className:'fl_r basket-count-bet'},oddsLength):''),_react2.default.createElement('div',{className:'basket-bets-count-item b-b-c-i'},_react2.default.createElement('span',{className:'fl_l'},this.props.dictStore.getLang('BETS'))));}}]);return Label;}(_react.Component))||_class)||_class);var Switcher=(_dec2=(0,_mobxReact.inject)('lineStore','dictStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(Switcher,_Component2);function Switcher(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,Switcher);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=Switcher.__proto__||Object.getPrototypeOf(Switcher)).call.apply(_ref,[this].concat(args))),_this2),_this2.handleOneClick=function(){var basketData=_this2.props.lineStore.basket.basketData;var isBetOneClick=(0,_lodash.get)(basketData,'isBetOneClick');_this2.props.lineStore.basket.newSetIsBetOneClick(!isBetOneClick);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(Switcher,[{key:'render',value:function render(){var basketData=this.props.lineStore.basket.basketData;var isBetOneClick=(0,_lodash.get)(basketData,'isBetOneClick');var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'basket-row'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'checkbox fl_l '+(isBetOneClick?'on':''),onClick:this.handleOneClick},_react2.default.createElement('span',null),_react2.default.createElement('label',{className:''},getLang('BASKET_ONE_CLICK_BET'))))),_react2.default.createElement('div',{className:'basket-circles'}));}}]);return Switcher;}(_react.Component))||_class2)||_class2);var Basket=(_dec3=(0,_mobxReact.inject)('lineStore','dictStore','appStore','accountStore'),_dec3(_class4=(0,_reactOnclickoutside2.default)(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Basket,_Component3);function Basket(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,Basket);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=Basket.__proto__||Object.getPrototypeOf(Basket)).call.apply(_ref2,[this].concat(args))),_this3),_this3.headRef=_react2.default.createRef(),_this3.footerRef=_react2.default.createRef(),_this3.handleDoBetEnter=function(e){if(e.keyCode==13){_this3.props.lineStore.basket.newBasketDoBetRequest();}},_this3.handleClear=function(){_this3.props.lineStore.basket.newClearBasketAfterBet();},_this3.handleDoBet=function(){var basketData=_this3.props.lineStore.basket.basketData;var isBetRequestLoading=(0,_lodash.get)(basketData,'isBetRequestLoading');var disableDoBetButton=(0,_lodash.get)(basketData,'disableDoBetButton');if(isBetRequestLoading||disableDoBetButton){return null;}_this3.props.lineStore.basket.newBasketDoBetRequest();},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(Basket,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keyup',this.handleDoBetEnter,false);}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keyup',this.handleDoBetEnter,false);}},{key:'handleClickOutside',value:function handleClickOutside(evt){// refactc
if(evt.path&&evt.path[0].className&&!(evt.path[0].className.trim()=='g-b'||evt.path[0].className.trim()=='basket-bets-lurk'||evt.path[0].className.trim()=='f-s-ico-arrow_buttom_1'||/ui-keyboard/.test(evt.path[0].className.trim())))this.props.lineStore.basket.hideBasket();}},{key:'render',value:function render(){var _props$lineStore$bask=this.props.lineStore.basket,type=_props$lineStore$bask.type,error=_props$lineStore$bask.error,mode=_props$lineStore$bask.mode,oneClick=_props$lineStore$bask.oneClick,isLocked=_props$lineStore$bask.isLocked,success=_props$lineStore$bask.success,toogleBasket=_props$lineStore$bask.toogleBasket,maxHeight=_props$lineStore$bask.maxHeight,basketData=_props$lineStore$bask.basketData;if(!basketData){return null;}var disableDoBetButton=(0,_lodash.get)(basketData,'disableDoBetButton');var isBetOneClick=(0,_lodash.get)(basketData,'isBetOneClick');var isBetRequestLoading=(0,_lodash.get)(basketData,'isBetRequestLoading');var oddsIds=(0,_lodash.get)(basketData,'oddsIds',new Set());var betType=(0,_lodash.get)(basketData,'betType',1);var odds=(0,_lodash.get)(basketData,'odds',{});var succesExpressAndSystemMessage=(0,_lodash.get)(basketData,'succesExpressAndSystemMessage');var globalError=(0,_lodash.get)(basketData,'globalError');var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'line-right-column-basket-cont b-l'+(!toogleBasket.showBasket?' hidden':''),id:'basket-container'},_react2.default.createElement('div',{className:'basket basket-right'},_react2.default.createElement('div',{className:'basket-header',id:'basket-header',ref:this.headRef},mode=='live'?_react2.default.createElement(Switcher,null):'',isBetOneClick?_react2.default.createElement(_oneClick2.default,null):_react2.default.createElement(_selector2.default,null),_react2.default.createElement('div',{className:'basket-circles'}),basketData.globalError?_react2.default.createElement(_message2.default,null):'',_react2.default.createElement('div',{className:'basket-circles'})),_react2.default.createElement('div',{className:'basket-content',style:{maxHeight:maxHeight+'px'}},oddsIds.size&&!isBetOneClick?_react2.default.createElement(_items2.default,{odds:odds,oddsIds:oddsIds}):'',basketData.succesExpressAndSystemMessage&&betType!==1?_react2.default.createElement('div',{className:'basket-dobet-success'},getLang(basketData.succesExpressAndSystemMessage)):''),_react2.default.createElement('div',{className:'basket-footer',id:'basket-footer',ref:this.footerRef},!isBetOneClick?_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'basket-circles'}),oddsIds.size?_react2.default.createElement('div',{className:'basket-bets-icon-delete',onClick:this.handleClear},_react2.default.createElement('div',{className:'sport_i delete_icon'},_react2.default.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 191 224'},_react2.default.createElement('polygon',{points:'112 15 112 0 80 0 80 15 0 15 0 48 191 48 191 15 112 15'}),_react2.default.createElement('polygon',{points:'143 191 48 191 48 64 15 64 15 224 16 224 48 224 143 224 176 224 176 191 176 64 143 64 143 191'}))),_react2.default.createElement('div',{className:'basket-bets-delete-text'},getLang('CLEAR_BASKET'))):'',_react2.default.createElement('div',{className:'basket-circles'}),oddsIds.size>0?_react2.default.createElement(_win2.default,null):'',oddsIds.size?_react2.default.createElement(_fastAmount2.default,null):'',_react2.default.createElement('div',{className:'basket-circles'}),_react2.default.createElement('div',{className:'basket-row basket-make-bet'},_react2.default.createElement('div',{className:'basket-buttons'},_react2.default.createElement('button',{type:'button',tabIndex:'2',className:'flat_button basket-dobet basket-make-bet-button '+(isBetRequestLoading?'wait':''),onClick:this.handleDoBet,disabled:disableDoBetButton||isBetRequestLoading},getLang('MAKE_BET')))),_react2.default.createElement('div',{className:'basket-circles'}),betType==3?_react2.default.createElement(_systems2.default,null):''):'',_react2.default.createElement(_settings2.default,null)))),_react2.default.createElement('div',{className:'line-bets-done'}));}}]);return Basket;}(_react.Component))||_class4)||_class4)||_class4);exports.default=Basket;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Message=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Message,_Component);function Message(){_classCallCheck(this,Message);return _possibleConstructorReturn(this,(Message.__proto__||Object.getPrototypeOf(Message)).apply(this,arguments));}_createClass(Message,[{key:'render',value:function render(){var globalError=this.props.lineStore.basket.basketData.globalError;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'basket-result-cont'},_react2.default.createElement('div',{className:'basket-error basket-error-red-new'},_react2.default.createElement('div',{className:'basket-error-red-info-ico-new'},'!'),_react2.default.createElement('div',{className:'basket-error-red-info-text-new',dangerouslySetInnerHTML:{__html:getLang(globalError)}})));}}]);return Message;}(_react.Component))||_class)||_class);exports.default=Message;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactTooltip=__webpack_require__(87);var _reactTooltip2=_interopRequireDefault(_reactTooltip);var _common=__webpack_require__(6);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);var _vipBox=__webpack_require__(466);var _vipBox2=_interopRequireDefault(_vipBox);var _lodash=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Win=(_dec=(0,_mobxReact.inject)('lineStore','dictStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Win,_Component);function Win(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Win);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Win.__proto__||Object.getPrototypeOf(Win)).call.apply(_ref,[this].concat(args))),_this),_this.vipTooltipRef=null,_this.handleSelect=function(type){_this.props.lineStore.basket.setType(type);},_this.handleChange=function(e){_this.props.lineStore.basket.newOnExpressOrSystemAmountInput(e);},_this.handleVip=function(isVip){_this.props.lineStore.basket.newSetIsVipBet(isVip);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Win,[{key:'render',value:function render(){var _this2=this;var mode=this.props.lineStore.basket.mode;var basketData=this.props.lineStore.basket.basketData;var betType=(0,_lodash.get)(basketData,'betType');var amount=(0,_lodash.get)(basketData,'amount');var possibleWin=(0,_lodash.get)(basketData,'possibleWin');var expressCoef=(0,_lodash.get)(basketData,'expressCoef');var isVipBet=(0,_lodash.get)(basketData,'isVipBet');var isAllOddsLine=(0,_lodash.get)(basketData,'isAllOddsLine');var maxExpress=(0,_lodash.get)(basketData,'maxExpress');var minVipExpress=(0,_lodash.get)(basketData,'minVipExpress');var getLang=this.props.dictStore.getLang;var basketPosition=this.props.accountStore.accountSettings.basketPosition;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'basket-express-coefficient'},_react2.default.createElement('div',{className:'basket-possible-win-cont fl_l',title:getLang('POSSIBLE_WIN')},_react2.default.createElement('span',null,'\u0412\u044B\u0438\u0433\u0440\u044B\u0448 '),_react2.default.createElement('span',{className:'basket-possible-win'},possibleWin?(0,_common.numberFormat)(possibleWin,2,',',' '):' ~')),betType==2&&expressCoef?_react2.default.createElement('div',{className:'basket-express-cont fl_r'},_react2.default.createElement('span',{title:'\u041A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442'},getLang('CF'),' '),_react2.default.createElement('span',{className:'basket-express-cf'},expressCoef)):'',_react2.default.createElement('div',{className:'clearfix'})),_react2.default.createElement('div',{className:'basket-row basket-amount-row'},_react2.default.createElement('div',{className:'clearfix'},betType!=1?_react2.default.createElement('div',{className:'fl_r basket-amount-cont'},_react2.default.createElement(_keyboardInput2.default,{id:'amount',type:'text',className:'input',placeholder:'1000',onChange:this.handleChange,value:amount,tabIndex:'1',autoComplete:'off',size:'10',positionX:basketPosition=="left"?'right':'left',positionY:'bottom',maxLength:'8'})):'',maxExpress&&!isVipBet&&betType!==1?_react2.default.createElement('div',{className:'basket-amount-max-cont'},_react2.default.createElement('span',{title:'\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430'},getLang('MAX'),' '),_react2.default.createElement('span',{className:'basket-amount-max'},(0,_common.numberFormat)(maxExpress,2,',',' '))):'',isVipBet&&isAllOddsLine&&betType!==1?_react2.default.createElement('div',{className:'basket-amount-vip-min-cont'},_react2.default.createElement('span',{title:'\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430'},getLang('MIN'),' '),_react2.default.createElement('span',{className:'basket-amount-vip-min'},(0,_common.numberFormat)(minVipExpress,2,',',' '))):'',_react2.default.createElement(_reactTooltip2.default,null),_react2.default.createElement('div',{className:'basket-vip-bet-cont','data-tip':!isAllOddsLine?getLang('VIP_BET_NOT_ALLOWED_FOR_THIS_EVENT'):'',ref:function ref(_ref2){return _this2.vipTooltipRef=_ref2;},'data-multiline':'true','data-place':'left','data-type':'light','data-border-color':'black','data-effect':'solid'},_react2.default.createElement('div',{className:'checkbox fl_l '+(isVipBet&&isAllOddsLine?'on':''),onClick:function onClick(){isAllOddsLine&&_this2.handleVip(!isVipBet);}/** принудительно показываю подсказку, т.к при изменении data-tip сама не появляется */,onMouseOver:function onMouseOver(){!isAllOddsLine&&_reactTooltip2.default.show(_this2.vipTooltipRef);},onMouseOut:function onMouseOut(){!isAllOddsLine&&_reactTooltip2.default.hide(_this2.vipTooltipRef);}},_react2.default.createElement('span',null),_react2.default.createElement('label',{className:'basket-vip-bet_text'},getLang('VIP_BET'))),_react2.default.createElement(_vipBox2.default,null)),_react2.default.createElement('div',{className:'hidden'},'\u0421\u043E\u0431\u044B\u0442\u0438\u0439:',_react2.default.createElement('span',null)))),_react2.default.createElement('div',{className:'basket-circles'}));}}]);return Win;}(_react.Component))||_class)||_class);exports.default=Win;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Box=function Box(){return _react2.default.createElement('div',{className:'box-vip-bet-description-cont'},_react2.default.createElement('p',null,'VIP-\u0441\u0442\u0430\u0432\u043A\u0430 \u2013 \u0441\u0442\u0430\u0432\u043A\u0430 \u043D\u0430 \u043B\u044E\u0431\u0443\u044E \u0441\u0443\u043C\u043C\u0443, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u0445\u043E\u0434\u0430.'),_react2.default.createElement('br',null),_react2.default.createElement('p',null,'\u041F\u043E\u0440\u044F\u0434\u043E\u043A \u043F\u0440\u0438\u0435\u043C\u0430 VIP-\u0441\u0442\u0430\u0432\u043A\u0438:'),_react2.default.createElement('ul',{className:'ul'},_react2.default.createElement('li',null,'\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0433\u0430\u043B\u043E\u0447\u043A\u0443 VIP-\u0441\u0442\u0430\u0432\u043A\u0430.'),_react2.default.createElement('li',null,'\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u0441\u0442\u0430\u0432\u043A\u0438.'),_react2.default.createElement('li',null,'\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0441\u0442\u0430\u0432\u043A\u0438. \u0412 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \xAB\u0412\u0430\u0448\u0438 \u0441\u0442\u0430\u0432\u043A\u0438\xBB \u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043E \u043A\u0430\u043A \xAB\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043F\u0440\u0438\u0435\u043C\u0430\xBB.'),_react2.default.createElement('li',null,'\u041D\u0435 \u0431\u043E\u043B\u0435\u0435 \u0447\u0435\u043C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 8 \u043C\u0438\u043D\u0443\u0442, \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u041A\u043B\u0438\u0435\u043D\u0442\u0430, \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0443 \u0438\u043B\u0438 \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C.'),_react2.default.createElement('li',null,'\u0412 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u0441\u0442\u0430\u0432\u043A\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u044F\u0435\u0442\u0441\u044F, \u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u043E\u043C\u0435\u0447\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \xAB\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430\xBB \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u0432 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0441\u0447\u0451\u0442\u0430 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 24 \u0447\u0430\u0441\u043E\u0432, \u043F\u043E\u0441\u043B\u0435 \u0447\u0435\u0433\u043E \u0431\u043E\u043B\u0435\u0435 \u043D\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F.')),_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'box-vip-bet-guide-gif'})));};var VipBox=function(_PureComponent){_inherits(VipBox,_PureComponent);function VipBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VipBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VipBox.__proto__||Object.getPrototypeOf(VipBox)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handleClick=function(){_this.setState({open:!_this.state.open});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VipBox,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'fl_l basket-help'},_react2.default.createElement('div',{className:'basket-help-ico-new',onClick:this.handleClick},'?'),this.state.open?_react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{styleModal:{width:'600px'},show:this.state.open,onCloseModal:this.handleClick,title:'VIP-\u0441\u0442\u0430\u0432\u043A\u0430'},_react2.default.createElement(Box,null))):'');}}]);return VipBox;}(_react.PureComponent);exports.default=VipBox;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Systems=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Systems,_Component);function Systems(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Systems);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Systems.__proto__||Object.getPrototypeOf(Systems)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(e){_this.props.lineStore.basket.newSetSystemType(e.target.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Systems,[{key:'render',value:function render(){var basketData=this.props.lineStore.basket.basketData;return basketData.systemTypeAvailable.length>0?_react2.default.createElement('div',{className:'basket-row basket-type-data-cont'},_react2.default.createElement('div',{className:'basket-system-cont clearfix'},_react2.default.createElement('div',{className:'basket-system-select-cont'},_react2.default.createElement('select',{onChange:this.handleSelect},basketData.systemTypeAvailable.map(function(el){return _react2.default.createElement('option',{value:el.type,key:el.type,selected:basketData.systemType===el.type},el.name);}))),_react2.default.createElement('div',{className:'basket-label'}))):'';}}]);return Systems;}(_react.Component))||_class)||_class);exports.default=Systems;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Selecter=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Selecter,_Component);function Selecter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Selecter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Selecter.__proto__||Object.getPrototypeOf(Selecter)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(type){_this.props.lineStore.basket.setBetType(type);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Selecter,[{key:'render',value:function render(){var _this2=this;var betType=this.props.lineStore.basket.basketData.betType;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'basket-bet-type-cont'},_react2.default.createElement('ul',{className:'basket-bet-type clearfix'},_react2.default.createElement('li',{className:'basket-bet-type-item '+(betType==1?"basket-bet-type-item-selected":""),onClick:function onClick(){return _this2.handleSelect(1);}},getLang('BET_SINGLE')),_react2.default.createElement('li',{className:'basket-bet-type-item basket-bet-type-item-border '+(betType==2?"basket-bet-type-item-selected":""),onClick:function onClick(){return _this2.handleSelect(2);}},getLang('BET_EXPRESS')),_react2.default.createElement('li',{className:'basket-bet-type-item '+(betType==3?"basket-bet-type-item-selected":""),onClick:function onClick(){return _this2.handleSelect(3);}},getLang('BET_SYSTEM'))));}}]);return Selecter;}(_react.Component))||_class)||_class);exports.default=Selecter;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _dec,_class2;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=Odds;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);var _lodash=__webpack_require__(10);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Coeff=function(_Component){_inherits(Coeff,_Component);function Coeff(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Coeff);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Coeff.__proto__||Object.getPrototypeOf(Coeff)).call.apply(_ref,[this].concat(args))),_this),_this.cfDiv=_react2.default.createRef(),_this.animate=function(a){if(_this.cfDiv.current){_this.cfDiv.current.classList.add(a);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Coeff,[{key:'componentDidUpdate',value:function componentDidUpdate(nextProps){this.cfDiv.current.classList.remove('b_u','b_d');if(nextProps.id===this.props.id){if(nextProps.cf!=this.props.cf){nextProps.cf>this.props.cf?this.animate('b_d'):this.animate('b_u');}}}},{key:'render',value:function render(){return _react2.default.createElement('div',{ref:this.cfDiv,className:'basket-item-cf basket-item-coefficient'},(0,_common.numberFormat)(this.props.cf,2,',',' '));}}]);return Coeff;}(_react.Component);var Odd=(_dec=(0,_mobxReact.inject)('lineStore','dictStore','accountStore'),(0,_reactRouterDom.withRouter)(_class2=_dec(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(Odd,_Component2);function Odd(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,Odd);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=Odd.__proto__||Object.getPrototypeOf(Odd)).call.apply(_ref2,[this].concat(args))),_this2),_this2.handleRemove=function(){_this2.props.lineStore.basket.newDeleteOdd(_this2.props.id);},_this2.handleChange=function(e){_this2.props.lineStore.basket.newOnOrdinarAmountInput(e,_this2.props.id);},_this2.route=function(){_this2.props.history.push('/'+_this2.props.lineStore.basket.mode+'/'+_this2.props.lineStore.basket.basketData.odds[_this2.props.id].sportId+'/'+_this2.props.lineStore.basket.basketData.odds[_this2.props.id].championshipId+'/'+_this2.props.lineStore.basket.basketData.odds[_this2.props.id].matchId);},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(Odd,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if((0,_lodash.get)(this.basketItem,'classList')){this.basketItem.classList.remove('animate');if(nextProps.odd!=this.props.odd||nextProps.cf!=this.props.cf){this.basketItem.classList.add('animate');}}}},{key:'render',value:function render(){var _this3=this;var basketPosition=this.props.accountStore.accountSettings.basketPosition;var _props$lineStore$bask=this.props.lineStore.basket,type=_props$lineStore$bask.type,oneClick=_props$lineStore$bask.oneClick,successBet=_props$lineStore$bask.successBet;// const { status } = this.props.lineStore.basket.odds.get(this.props.id);
var basketData=this.props.lineStore.basket.basketData;var odds=(0,_lodash.get)(basketData,['odds',this.props.id]);var team1=(0,_lodash.get)(odds,'team1');var team2=(0,_lodash.get)(odds,'team2');var cf=(0,_lodash.get)(odds,'cf');var txt=(0,_lodash.get)(odds,'txt');var name=(0,_lodash.get)(odds,'name');var amount=(0,_lodash.get)(odds,'amount');var championship=(0,_lodash.get)(odds,'championship');var sportId=(0,_lodash.get)(odds,'sportId');var url=(0,_lodash.get)(odds,'url');var bet=(0,_lodash.get)(odds,'bet');var matchId=(0,_lodash.get)(odds,'matchId');var minBetSum=(0,_lodash.get)(basketData,'min');var maxBetSum=(0,_lodash.get)(odds,'max');var minVip=(0,_lodash.get)(odds,'minVip');var isVipBet=(0,_lodash.get)(basketData,'isVipBet');if(!cf){return null;}var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'basket-item animate',ref:function ref(el){_this3.basketItem=el;}},_react2.default.createElement('div',{className:'basket-item-p1'},_react2.default.createElement('div',{className:'basket-item-remove'},_react2.default.createElement('div',{className:'basket-item-remove_icon',onClick:this.handleRemove},'\xD7')),_react2.default.createElement('div',{className:'fl_r basket-item-coef'},_react2.default.createElement(Coeff,{cf:cf,id:this.props.id,gid:matchId})),_react2.default.createElement('div',{onClick:this.route,className:'basket-item-event',title:''+team1+(team2?' - '+team2:'')},''+team1+(team2?' - '+team2:''))),_react2.default.createElement('div',{className:'basket-item-p2 clearfix'},_react2.default.createElement('div',{className:'basket-item-name fl_l',title:txt},txt),basketData.betType===1&&!oneClick.st?_react2.default.createElement('div',{className:'basket-item-sum fl_r'},_react2.default.createElement(_keyboardInput2.default,{id:'bet_'+this.props.id,type:'text',className:'fl_r',placeholder:isVipBet?getLang('MIN')+' '+minVip:minBetSum+' - '+maxBetSum,maxLength:10,onChange:this.handleChange,value:amount?amount:'',autoComplete:'off',positionX:basketPosition=="left"?'right':'left',positionY:'bottom'})):''),_react2.default.createElement('div',{className:'clearfix'}),_react2.default.createElement('div',{className:'basket-item-p3'},basketData.odds[this.props.id].text&&basketData.odds[this.props.id].isOddSuccessRequest?_react2.default.createElement('div',{id:'bet_result_'+this.props.id,className:'basket-item-result'},getLang(basketData.odds[this.props.id].text)):_react2.default.createElement('div',{id:'bet_error_'+this.props.id,className:'basket-item-error',dangerouslySetInnerHTML:{__html:getLang(basketData.odds[this.props.id].text)}})));}}]);return Odd;}(_react.Component))||_class2)||_class2)||_class2);function Odds(_ref3){var _ref3$odds=_ref3.odds,odds=_ref3$odds===undefined?{}:_ref3$odds,_ref3$oddsIds=_ref3.oddsIds,oddsIds=_ref3$oddsIds===undefined?new Set():_ref3$oddsIds;var orderedOdds=[];oddsIds.forEach(function(oddId){if(!(0,_lodash.get)(odds[oddId],'cf')){return;}orderedOdds=[].concat(_toConsumableArray(orderedOdds),[_react2.default.createElement(Odd,{key:'basket_item_'+oddId,id:oddId,odd:odds[oddId],cf:odds[oddId].cf})]);});return _react2.default.createElement(_react.Fragment,null,orderedOdds.length?_react2.default.createElement('div',{className:'basket-bets'},orderedOdds):'');}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Settings=(_dec=(0,_mobxReact.inject)('lineStore','dictStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Settings,_Component);function Settings(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Settings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Settings.__proto__||Object.getPrototypeOf(Settings)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:0},_this.handleOpen=function(){_this.setState({isOpen:!_this.state.isOpen});},_this.handleAgree=function(agree){_this.props.lineStore.basket.setAgreeWithCoefChanging(agree);_this.props.accountStore.toggleAccountSettings('basketAgreeCf',agree);},_this.handleClearAfterBet=function(){_this.props.lineStore.basket.newBasketSetIsClearBasketAfterBet();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Settings,[{key:'render',value:function render(){var _this2=this;var _props$lineStore$bask=this.props.lineStore.basket,mode=_props$lineStore$bask.mode,basketData=_props$lineStore$bask.basketData;var agreeWithCoefChange=(0,_lodash.get)(basketData,'agreeWithCoefChange');var isClearBasketAfterBet=(0,_lodash.get)(basketData,'isClearBasketAfterBet');var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'basket-row basket-dropdown'},_react2.default.createElement('button',{className:'basket-tuning-dropdown',onClick:this.handleOpen},getLang('SETTINGS_BASKET')),this.state.isOpen?_react2.default.createElement('div',{className:'basket-tuning-dropdown__items'},_react2.default.createElement('div',{className:'basket-tuning-dropdown__item'},_react2.default.createElement('div',{className:'basket-dropdown-checkbox clearfix'},_react2.default.createElement('div',{className:'basket-clear-after-bet-cont'},_react2.default.createElement('div',{className:'checkbox '+(isClearBasketAfterBet?'on':''),onClick:this.handleClearAfterBet},_react2.default.createElement('span',null),_react2.default.createElement('label',{htmlFor:'',className:'basket-dropdown_text'},getLang('CLEAR_BASKET_AFTER_BET')))))),_react2.default.createElement('div',{className:'basket-tuning-dropdown-coefficient'},_react2.default.createElement('div',{className:'basket-tuning-dropdown_hr'},_react2.default.createElement('span',{className:'basket-tuning-dropdown_hr-title'},getLang('BASKET_AGREE_CF'))),_react2.default.createElement('div',{className:'basket-tuning-dropdown__item'},_react2.default.createElement('div',{className:'radio basket-agree-cf-radio basket-dropdown-checkbox '+(agreeWithCoefChange==0?'on':''),onClick:function onClick(){return _this2.handleAgree(0);}},_react2.default.createElement('span',null),_react2.default.createElement('label',{htmlFor:'',className:'basket-dropdown_text'},getLang('BASKET_AGREE_CF_0')))),_react2.default.createElement('div',{className:'basket-tuning-dropdown__item'},_react2.default.createElement('div',{className:'radio basket-agree-cf-radio basket-dropdown-checkbox '+(agreeWithCoefChange==1?'on':''),onClick:function onClick(){return _this2.handleAgree(1);}},_react2.default.createElement('span',null),_react2.default.createElement('label',{htmlFor:'',className:'basket-dropdown_text'},getLang('BASKET_AGREE_CF_1')))),_react2.default.createElement('div',{className:'basket-tuning-dropdown__item'},_react2.default.createElement('div',{className:'radio basket-agree-cf-radio basket-dropdown-checkbox '+(agreeWithCoefChange==2?'on':''),onClick:function onClick(){return _this2.handleAgree(2);}},_react2.default.createElement('span',null),_react2.default.createElement('label',{htmlFor:'',className:'basket-dropdown_text'},getLang('BASKET_AGREE_CF_2')))))):'');}}]);return Settings;}(_react.Component))||_class)||_class);exports.default=Settings;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_class4,_temp3;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _mobx=__webpack_require__(5);var mobx=_interopRequireWildcard(_mobx);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _modal=__webpack_require__(27);var _modal2=_interopRequireDefault(_modal);var _keyboard=__webpack_require__(138);var _keyboard2=_interopRequireDefault(_keyboard);var _lodash=__webpack_require__(10);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FastAmount=(_dec=(0,_mobxReact.inject)('lineStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(FastAmount,_Component);function FastAmount(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FastAmount);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FastAmount.__proto__||Object.getPrototypeOf(FastAmount)).call.apply(_ref,[this].concat(args))),_this),_this.state={showBox:false},_this.handleSelect=function(amount){var basketData=_this.props.lineStore.basket.basketData;var betType=(0,_lodash.get)(basketData,'betType',1);if(betType===1){var oddsIds=[].concat(_toConsumableArray((0,_lodash.get)(basketData,'oddsIds',new Set())));var odds=(0,_lodash.get)(basketData,'odds',{});oddsIds.forEach(function(id){_this.props.lineStore.basket.newOnOrdinarAmountInput(String(amount),id);});}else{_this.props.lineStore.basket.newOnExpressOrSystemAmountInput(String(amount));}},_this.toggleBox=function(){_this.setState({showBox:!_this.state.showBox});_this.props.lineStore.basket.account.clearResult();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FastAmount,[{key:'render',value:function render(){var _this2=this;var fastAmounts=this.props.lineStore.basket.account.fastAmounts;var fastAmount=this.props.lineStore.basket.fastAmount;return _react2.default.createElement('div',{className:'basket-row'},_react2.default.createElement('div',{className:'basket-fast-amount clearfix'},_react2.default.createElement('div',{className:'basket-fast-amount__buttons fl_l'},fastAmounts.amounts.map(function(amount){return _react2.default.createElement('button',{key:amount,className:'flat_button basket-fast-amount__button '+(fastAmount.amount==amount?'active':''),onClick:function onClick(){return _this2.handleSelect(amount);}},amount);})),_react2.default.createElement('div',{className:'basket-fast-amount__config fl_r',onClick:this.toggleBox},_react2.default.createElement('span',{className:'f-s-ico-settings'}))),this.state.showBox?_react2.default.createElement(_modal.ModalContainer,null,_react2.default.createElement(_modal2.default,{styleModal:{width:'500px'},show:this.state.showBox,onCloseModal:this.toggleBox,title:'\u0411\u044B\u0441\u0442\u0440\u044B\u0435 \u0441\u0443\u043C\u043C\u044B'},_react2.default.createElement(SettingFastAmount,{amounts:fastAmounts.amounts,onCloseModal:this.toggleBox}))):'');}}]);return FastAmount;}(_react.Component))||_class)||_class);exports.default=FastAmount;var SettingFastAmount=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=(_temp3=_class4=function(_Component2){_inherits(SettingFastAmount,_Component2);function SettingFastAmount(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,SettingFastAmount);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=SettingFastAmount.__proto__||Object.getPrototypeOf(SettingFastAmount)).call.apply(_ref2,[this].concat(args))),_this3),_this3.state={amounts:mobx.toJS(_this3.props.amounts),error:'',diff:''},_this3.inputEl=null,_this3.status=null,_this3.handleFocus=function(type,st){if(st){_this3.status=null;_this3.inputEl=null;}else{_this3.status=type;_this3.inputEl=_this3['input_'+type];}},_this3.handleKeyboard=function(val){if(!_this3.inputEl)return false;_this3.inputEl.focus();if(val=='b'){_this3.inputEl.value=_this3.inputEl.value.slice(0,-1);_this3.setAmount(_this3.status,_this3.inputEl.value);}else{if(_this3.inputEl.maxLength>_this3.inputEl.value.length){_this3.inputEl.value=_this3.inputEl.value+String(val);_this3.setAmount(_this3.status,_this3.inputEl.value);}}},_this3.setAmount=function(idx,e){var number=e.replace(/\D+/g,"");var _tmp=_this3.state.amounts;if(number.toString().length>0){_tmp[idx]=number;}else{_tmp[idx]='';}_this3.setState({amounts:_tmp});},_this3.save=function(){_this3.handleFocus(null,1);for(var idx in _this3.state.amounts){if(!_this3.state.amounts[idx]){_this3.props.accountStore.setResult('INCORRECT_FAST_SUM');_this3['input_'+idx].focus();return false;}}_this3.props.accountStore.setFastAmount(_this3.state.amounts,_this3.props.onCloseModal);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(SettingFastAmount,[{key:'componentDidMount',value:function componentDidMount(){this.input_0.focus();}},{key:'componentWillMount',value:function componentWillMount(){// this.setState({amounts: mobx.toJS(this.props.amounts)})
}},{key:'render',value:function render(){var _this4=this;var getLang=this.props.dictStore.getLang;var _props$accountStore=this.props.accountStore,result=_props$accountStore.result,waitFastForm=_props$accountStore.waitFastForm;return _react2.default.createElement('div',{className:'fast-amount-set'},this.state.amounts.map(function(amount,idx){return _react2.default.createElement('div',{className:'row',key:idx},_react2.default.createElement('div',{className:'row-label'},_react2.default.createElement('label',{htmlFor:'basket-fast-amount'},getLang('AMOUNT'),' ',idx+1)),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement('input',{ref:function ref(el){_this4['input_'+idx]=el;},className:'form-control',type:'text',maxLength:'6',value:amount,onChange:function onChange(e){return _this4.setAmount(idx,e.target.value);},onFocus:function onFocus(){return _this4.handleFocus(idx);}})));}),_react2.default.createElement(_keyboard2.default,{onChange:this.handleKeyboard}),_react2.default.createElement('div',{className:'fast-amount-set__buttons clearfix '+(result.status?'fast-amount-set_result':'')},_react2.default.createElement('button',{className:'flat_button fl_l',onClick:function onClick(){return _this4.context.closeBox();}},getLang('CANCEL')),_react2.default.createElement('button',{className:'flat_button fl_r '+(waitFastForm?'wait':''),onClick:this.save},getLang('SAVE'))),result.status?_react2.default.createElement('div',{className:'fast-amount-set__message'},getLang(result.text)):'');}}]);return SettingFastAmount;}(_react.Component),_class4.contextTypes={closeBox:_propTypes2.default.func},_temp3))||_class3)||_class3);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);var _lodash=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OneClick=(_dec=(0,_mobxReact.inject)('lineStore','dictStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(OneClick,_Component);function OneClick(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OneClick);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OneClick.__proto__||Object.getPrototypeOf(OneClick)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(e){_this.props.lineStore.basket.newSetIsBetOneClickSum(e);_this.props.lineStore.basket.newSetIsBetOneClick(true);},_this.handleSubmit=function(e){e.preventDefault();_this.props.lineStore.basket.applyOneClickAmount();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OneClick,[{key:'render',value:function render(){var basketData=this.props.lineStore.basket.basketData;var oneClickBetAmount=(0,_lodash.get)(basketData,'oneClickBetAmount');var isBetRequestLoading=(0,_lodash.get)(basketData,'isBetRequestLoading');var isLocked=this.props.lineStore.basket.isLocked;var getLang=this.props.dictStore.getLang;var basketPosition=this.props.accountStore.accountSettings.basketPosition;return _react2.default.createElement('div',{className:'basket-row'},_react2.default.createElement('div',{className:'basket-one-click clearfix'},_react2.default.createElement('form',{onSubmit:this.handleSubmit},_react2.default.createElement('div',{className:'fl_l basket-one-click__amount'},_react2.default.createElement(_keyboardInput2.default,{className:'form-control',value:String(oneClickBetAmount),type:'text',maxLength:'6',onChange:this.handleChange,autoComplete:'off',positionX:basketPosition=="left"?'right':'left',positionY:'bottom'})),_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('button',{disabled:isBetRequestLoading,className:'flat_button basket-one-click__button '+(isBetRequestLoading?'wait':'')},getLang('APPLY'))))));}}]);return OneClick;}(_react.Component))||_class)||_class);exports.default=OneClick;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DayPicker = __webpack_require__(474);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DayPicker).default;
  }
});

var _DateUtils = __webpack_require__(42);

Object.defineProperty(exports, 'DateUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DateUtils).default;
  }
});

var _LocaleUtils = __webpack_require__(61);

Object.defineProperty(exports, 'LocaleUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleUtils).default;
  }
});

var _ModifiersUtils = __webpack_require__(98);

Object.defineProperty(exports, 'ModifiersUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModifiersUtils).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(475);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(476);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(477);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(480);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(64);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(42);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(61);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(98);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(63);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.UP:
          _this.showPreviousYear();
          Helpers.cancelEvent(e);
          break;
        case _keys.DOWN:
          _this.showNextYear();
          Helpers.cancelEvent(e);
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }
  }, {
    key: 'getCurrentMonthFromProps',


    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth || new Date());
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.propTypes = {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.VERSION = '7.4.8';


DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(61);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

Caption.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
};
Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(63);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.propTypes = {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired,
    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
};
Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(478);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(479);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(62);

var _ModifiersUtils = __webpack_require__(98);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(64);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(42);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

Month.propTypes = {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired,
    weekNumber: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
};
exports.default = Month;
//# sourceMappingURL=Month.js.map

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

Weekdays.propTypes = {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
};
exports.default = Weekdays;
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(42);

var _Helpers = __webpack_require__(64);

var _classNames = __webpack_require__(63);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.propTypes = {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};
Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
//# sourceMappingURL=Day.js.map

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

Weekday.propTypes = {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = Weekday;
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(482);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
exports.formatDate = formatDate;
exports.parseDate = parseDate;

var _moment = __webpack_require__(34);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDay(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
} /* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */

function formatMonthTitle(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
}

function formatWeekdayShort(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _moment2.default.localeData(locale).weekdaysMin()[day];
}

function formatWeekdayLong(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _moment2.default.localeData(locale).weekdays()[day];
}

function getFirstDayOfWeek() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _moment2.default.localeData(locale).firstDayOfWeek();
}

function getMonths() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _moment2.default.localeData(locale).months();
}

function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

  return (0, _moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
}

function parseDate(str) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

  var m = (0, _moment2.default)(str, format, locale, true);
  if (m.isValid()) {
    return m.toDate();
  }
  return undefined;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths,
  formatDate: formatDate,
  parseDate: parseDate
};
//# sourceMappingURL=MomentLocaleUtils.js.map

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(34)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _liveMenu=__webpack_require__(86);var _liveMenu2=_interopRequireDefault(_liveMenu);var _line=__webpack_require__(89);var _line2=_interopRequireDefault(_line);var _basket=__webpack_require__(171);var _basket2=_interopRequireDefault(_basket);var _settingsLine=__webpack_require__(172);var _settingsLine2=_interopRequireDefault(_settingsLine);var _scrollTopButton=__webpack_require__(175);var _scrollTopButton2=_interopRequireDefault(_scrollTopButton);var _schedule=__webpack_require__(486);var _schedule2=_interopRequireDefault(_schedule);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _searchBox=__webpack_require__(176);var _searchBox2=_interopRequireDefault(_searchBox);var _movingStatistics=__webpack_require__(153);var _movingStatistics2=_interopRequireDefault(_movingStatistics);var _ig=__webpack_require__(489);var _ig2=_interopRequireDefault(_ig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Line=(_dec=(0,_mobxReact.inject)('accountStore','lineStore','igStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Line,_Component);function Line(){_classCallCheck(this,Line);return _possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments));}_createClass(Line,[{key:'componentDidMount',value:function componentDidMount(){this.props.lineStore.init('live');this.props.lineStore.init2();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.lineStore.route.setUrl(this.props.match.params);// console.log(this.props.match);
}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.lineStore.clearnterval();this.props.igStore.close();}},{key:'render',value:function render(){var basketPosition=this.props.accountStore.accountSettings.basketPosition;var _props$lineStore=this.props.lineStore,isLoading=_props$lineStore.isLoading,shortMenu=_props$lineStore.shortMenu,scheduleActive=_props$lineStore.scheduleActive,toogleBasket=_props$lineStore.basket.toogleBasket;var game=this.props.igStore.game;var showIg={left:false,right:false};if(game){if(toogleBasket.showArrow&&basketPosition=='right'){showIg.right=false;showIg.left=true;}else{showIg.right=true;showIg.left=false;}if(basketPosition=='left'){showIg.right=false;showIg.left=true;}}return _react2.default.createElement('div',{className:'live live-view'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u041B\u0430\u0439\u0432')),isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_settingsLine2.default,null),_react2.default.createElement(_searchBox2.default,null),_react2.default.createElement('div',{className:'line-left-column '+(shortMenu&&basketPosition==='right'?'line-left-column-short':'')+(basketPosition==='left'?' line-left-column_scroll':''),id:'line-left-column'},basketPosition=='left'||showIg.left?_react2.default.createElement('div',{className:'line-left-column-basket-cont'},showIg.left?_react2.default.createElement(_ig2.default,null):'',showIg.right||basketPosition=='left'?_react2.default.createElement(_basket2.default,{position:'left'}):''):'',(toogleBasket.showArrow||basketPosition=='left')&&!shortMenu&&_react2.default.createElement(_movingStatistics2.default,null),_react2.default.createElement(_liveMenu2.default,null),_react2.default.createElement(_scrollTopButton2.default,null)),scheduleActive?_react2.default.createElement(_schedule2.default,null):_react2.default.createElement(_line2.default,{key:''}),basketPosition==='right'||showIg.right?_react2.default.createElement('div',{className:'line-right-column line-right-column-border'+(toogleBasket.showBasket?' open':'')},showIg.right?_react2.default.createElement(_ig2.default,null):'',_react2.default.createElement(_basket2.default,{position:'right'}),!toogleBasket.showArrow&&_react2.default.createElement(_movingStatistics2.default,null)):''));}}]);return Line;}(_react.Component))||_class)||_class)||_class);exports.default=Line;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _list=__webpack_require__(487);var _list2=_interopRequireDefault(_list);var _filter=__webpack_require__(488);var _filter2=_interopRequireDefault(_filter);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScheduleContainer=(_dec=(0,_mobxReact.inject)('lineStore','accountStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ScheduleContainer,_Component);function ScheduleContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScheduleContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScheduleContainer.__proto__||Object.getPrototypeOf(ScheduleContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handlerClose=function(){_this.props.lineStore.schedule.clearResult();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ScheduleContainer,[{key:'render',value:function render(){if(!this.props.lineStore.line.mode)return false;var _props$lineStore$sche=this.props.lineStore.schedule,isLoading=_props$lineStore$sche.isLoading,result=_props$lineStore$sche.result;var basketPosition=this.props.accountStore.accountSettings.basketPosition;var shortMenu=this.props.lineStore.shortMenu;return _react2.default.createElement('div',{ref:this.lineContainer,className:'line-central-column l-c-c-c-s '+(basketPosition=='right'?'line-central-column-short-right':'')+' '+(shortMenu&&basketPosition=='right'?'line-central-column-short-left':''),id:'line-central-column'},isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement('div',{className:'schedule-index'},_react2.default.createElement(_filter2.default,null),result.status?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handlerClose}):'',_react2.default.createElement(_list2.default,null)));}}]);return ScheduleContainer;}(_react.Component))||_class)||_class);exports.default=ScheduleContainer;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var List=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(List,_Component);function List(){_classCallCheck(this,List);return _possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).apply(this,arguments));}_createClass(List,[{key:'render',value:function render(){var _props$lineStore$sche=this.props.lineStore.schedule,order=_props$lineStore$sche.order,schedule=_props$lineStore$sche.schedule,dict=_props$lineStore$sche.dict;var getLang=this.props.dictStore.getLang;if(!order.length){return _react2.default.createElement('div',{className:'result-no-events'},getLang('NO_EVENTS'));}var sidAk=void 0;var lidAk=void 0;var list=[];order.map(function(id){var sch=schedule[id];if(sidAk!=sch.sid){sidAk=sch.sid;list.push(_react2.default.createElement(Sport,{id:sch.sid,key:id+dict.sport[sch.sid],name:dict.sport[sch.sid]}));}if(lidAk!=sch.lid){lidAk=sch.lid;list.push(_react2.default.createElement(League,{id:sch.lid,name:dict.league[sch.lid]}));}list.push(_react2.default.createElement(Game,{lineId:sch.line_id,id:id,sid:sch.sid,lid:sch.lid}));});return _react2.default.createElement('div',null,list);}}]);return List;}(_react.Component))||_class)||_class);// @inject('lineStore')
// @observer
// class Shedule extends Component{
//
//   render() {
//
//     const {c1_id} = this.props.lineStore.schedule.schedule[this.props.id];
//
//     return(
//       <div>{c1_id}</div>
//     )
//   }
// }
exports.default=List;var Sport=function(_Component2){_inherits(Sport,_Component2);function Sport(){_classCallCheck(this,Sport);return _possibleConstructorReturn(this,(Sport.__proto__||Object.getPrototypeOf(Sport)).apply(this,arguments));}_createClass(Sport,[{key:'render',value:function render(){var _props=this.props,id=_props.id,name=_props.name;return _react2.default.createElement('div',{className:'l-s-c clearfix'},_react2.default.createElement('div',{className:'l-s-r l-s-r-'+id}),_react2.default.createElement('div',{className:'l-s-l-c'},_react2.default.createElement('div',{className:'l-s-c-i  f-s-ico-'+id}),_react2.default.createElement('div',{className:'l-s-l'},name)));}}]);return Sport;}(_react.Component);var League=function(_PureComponent){_inherits(League,_PureComponent);function League(){_classCallCheck(this,League);return _possibleConstructorReturn(this,(League.__proto__||Object.getPrototypeOf(League)).apply(this,arguments));}_createClass(League,[{key:'render',value:function render(){var name=this.props.name;return _react2.default.createElement('table',{className:'l-t'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{className:'l-td',colSpan:'3'},_react2.default.createElement('div',{className:'l-d'},name)))));}}]);return League;}(_react.PureComponent);var Game=(_dec2=(0,_mobxReact.inject)('lineStore','dictStore'),(0,_reactRouterDom.withRouter)(_class2=_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component3){_inherits(Game,_Component3);function Game(){var _ref;var _temp,_this4,_ret;_classCallCheck(this,Game);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this4=_possibleConstructorReturn(this,(_ref=Game.__proto__||Object.getPrototypeOf(Game)).call.apply(_ref,[this].concat(args))),_this4),_this4.route=function(){if(_this4.props.lineId)_this4.props.history.push('/line/'+_this4.props.sid+'/'+_this4.props.lid+'/'+_this4.props.lineId);},_temp),_possibleConstructorReturn(_this4,_ret);}_createClass(Game,[{key:'render',value:function render(){var _props$lineStore$sche2=this.props.lineStore.schedule.schedule[this.props.id],c1_id=_props$lineStore$sche2.c1_id,c2_id=_props$lineStore$sche2.c2_id,date=_props$lineStore$sche2.date,tv=_props$lineStore$sche2.tv,is_cupis_video=_props$lineStore$sche2.is_cupis_video;var dict=this.props.lineStore.schedule.dict;var getLang=this.props.dictStore.getLang;var name=dict.cmd[c1_id]+' '+(c2_id?' - '+dict.cmd[c2_id]:'');return _react2.default.createElement('table',{className:'l-t'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',{className:'g-tr'},_react2.default.createElement('td',{className:'g-d-date'},_react2.default.createElement('div',{className:'g-date'},date)),_react2.default.createElement('td',{className:'results-index-game-cmd g-d-players'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('b',{className:'g-d g-b_link',onClick:this.route},name),is_cupis_video?_react2.default.createElement('span',{className:'item-ico-video f-s-ico-icon_live_tv',title:getLang('VIDEO_WILL_BE_AVAILABLE_ON_OUR_SITE')}):'',tv?_react2.default.createElement('div',{className:'schedule-item-tv'},tv):'')))));}}]);return Game;}(_react.Component))||_class2)||_class2)||_class2);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import moment from 'moment';
var Sport=(_dec=(0,_mobxReact.inject)('lineStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Sport,_Component);function Sport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sport.__proto__||Object.getPrototypeOf(Sport)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(type,id){_this.props.lineStore.schedule.selectSport(type,id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sport,[{key:'render',value:function render(){var _this2=this;var getLang=this.props.dictStore.getLang;var _props$lineStore$sche=this.props.lineStore.schedule,select=_props$lineStore$sche.select,dict=_props$lineStore$sche.dict,menu=_props$lineStore$sche.menu;var id=this.props.id;if(!menu.current)return null;var name='';if(id==='other'){name=getLang('OTHER');}else{name=dict.sport[id];}var selectId=select.sport.find(function(item){return item==id;});if(menu.current.indexOf(id)!=-1||id=='other'){return _react2.default.createElement('li',null,_react2.default.createElement('button',{className:'checkbox '+(selectId?'on':''),onClick:function onClick(){return _this2.handleSelect(2,id);}},_react2.default.createElement('span',null),name));}return null;}}]);return Sport;}(_react.Component))||_class)||_class);var SelectSport=(_dec2=(0,_mobxReact.inject)('lineStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(SelectSport,_Component2);function SelectSport(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,SelectSport);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=SelectSport.__proto__||Object.getPrototypeOf(SelectSport)).call.apply(_ref2,[this].concat(args))),_this3),_this3.handleSelect=function(id,type){_this3.props.lineStore.schedule.selectSport(type,id);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(SelectSport,[{key:'render',value:function render(){var _this4=this;var getLang=this.props.dictStore.getLang;var allSport=this.props.lineStore.schedule.select.allSport;var order=this.props.order;return _react2.default.createElement('div',{className:'results-sport clearfix'},_react2.default.createElement('ul',{className:'sport-list clearfix'},_react2.default.createElement('li',null,_react2.default.createElement('button',{className:'results-index-sport_item checkbox '+(allSport?'on':''),onClick:function onClick(){return _this4.handleSelect('all',1);}},_react2.default.createElement('span',null),getLang('ALL_EVENTS'))),order.map(function(id){return _react2.default.createElement(Sport,{id:id,key:id});})));}}]);return SelectSport;}(_react.Component))||_class3)||_class3);var Filter=(_dec3=(0,_mobxReact.inject)('lineStore','dictStore'),_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(Filter,_Component3);function Filter(){var _ref3;var _temp3,_this5,_ret3;_classCallCheck(this,Filter);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this5=_possibleConstructorReturn(this,(_ref3=Filter.__proto__||Object.getPrototypeOf(Filter)).call.apply(_ref3,[this].concat(args))),_this5),_this5.handleSelectTime=function(time){_this5.props.lineStore.schedule.setTime(time);},_this5.handleSelectSort=function(sort){_this5.props.lineStore.schedule.setSort(sort);},_temp3),_possibleConstructorReturn(_this5,_ret3);}_createClass(Filter,[{key:'render',value:function render(){var _this6=this;var _props$lineStore$sche2=this.props.lineStore.schedule,timeline=_props$lineStore$sche2.timeline,select=_props$lineStore$sche2.select,menu=_props$lineStore$sche2.menu;var getLang=this.props.dictStore.getLang;if(!menu.comparison&&!menu.order&&!menu.current&&!timeline.length)return null;return _react2.default.createElement('div',{className:'schedule-menu'},_react2.default.createElement('div',{className:'results-index-info clearfix'},_react2.default.createElement('div',{className:'results-date-info fl_l'},_react2.default.createElement('div',{className:'results-index-menu-item '},timeline.map(function(el){return _react2.default.createElement('button',{key:el.id,className:'results-index-type '+(select.time==el.id?'on':''),onClick:function onClick(){return _this6.handleSelectTime(el.id);}},getLang(el.name));})),_react2.default.createElement('div',{className:'results-index-menu-item'})),_react2.default.createElement('div',{className:'results-date-info fl_r'},_react2.default.createElement('div',{className:'results-index-menu-item '},_react2.default.createElement('button',{className:'results-index-type '+(select.sort=='time'?'on':''),onClick:function onClick(){return _this6.handleSelectSort('time');}},getLang('BY_TIME')),_react2.default.createElement('button',{className:'results-index-type '+(select.sort=='abc'?'on':''),onClick:function onClick(){return _this6.handleSelectSort('abc');}},getLang('ALPHABETICALLY'))),_react2.default.createElement('div',{className:'results-index-menu-item'}))),_react2.default.createElement(SelectSport,{order:menu.order}));}}]);return Filter;}(_react.Component))||_class5)||_class5);exports.default=Filter;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(490);var _eventHeader=__webpack_require__(491);var _eventHeader2=_interopRequireDefault(_eventHeader);var _list=__webpack_require__(492);var _list2=_interopRequireDefault(_list);var _videoplayer=__webpack_require__(574);var _videoplayer2=_interopRequireDefault(_videoplayer);var _events=__webpack_require__(591);var _events2=_interopRequireDefault(_events);var _progress=__webpack_require__(597);var _progress2=_interopRequireDefault(_progress);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ig=(_dec=(0,_mobxReact.inject)('igStore','appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Ig,_Component);function Ig(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Ig);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Ig.__proto__||Object.getPrototypeOf(Ig)).call.apply(_ref,[this].concat(args))),_this),_this.selectTab=function(t){_this.props.igStore.setTab(t);},_temp),_possibleConstructorReturn(_this,_ret);}// componentWillUnmount() {
//   this.props.igStore.close();
// }
_createClass(Ig,[{key:'render',value:function render(){var _this2=this;var _props$igStore=this.props.igStore,tab=_props$igStore.tab,tabs=_props$igStore.tabs;var showList=this.props.igStore.video.showList;var sid=this.props.igStore.game.sid;return _react2.default.createElement('div',{className:'ig'},tabs.length>1?_react2.default.createElement('div',{className:'ig-tabs'},tabs.map(function(t){return t.show?_react2.default.createElement('button',{className:'ig-tabs__tab '+(tab===t.name?'active':''),onClick:function onClick(){return _this2.selectTab(t.name);},key:t.name},_react2.default.createElement('i',{className:t.ico})):null;})):null,_react2.default.createElement('div',{className:'ig-tab-content s-c-'+sid},this.renderTabContent()));}},{key:'renderTabContent',value:function renderTabContent(){var tab=this.props.igStore.tab;switch(tab){case'video':return _react2.default.createElement(_videoplayer2.default,null);case'events':return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_eventHeader2.default,null),_react2.default.createElement(_events2.default,null));case'stats':return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_eventHeader2.default,null),_react2.default.createElement(_progress2.default,this.props));}}}]);return Ig;}(_react.Component))||_class)||_class);var IgWrapper=(_dec2=(0,_mobxReact.inject)('igStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(IgWrapper,_Component2);function IgWrapper(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,IgWrapper);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=IgWrapper.__proto__||Object.getPrototypeOf(IgWrapper)).call.apply(_ref2,[this].concat(args))),_this3),_this3.onClose=function(){_this3.props.igStore.close();},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(IgWrapper,[{key:'render',value:function render(){var _props$igStore2=this.props.igStore,video=_props$igStore2.video,game=_props$igStore2.game,tab=_props$igStore2.tab,toggleVideoList=_props$igStore2.toggleVideoList;if(!game)return null;return _react2.default.createElement('div',{className:'ig-wrapper'},_react2.default.createElement('div',{className:'ig-wrapper__header'// onDrag={ this.onDrag }
// onDragEnd={ this.onDragEnd }
// onDragStart={ this.onDragStart }
// onTouchStart={ this.onDragStart }
// onTouchMove={ this.onDrag }
// onTouchEnd={ this.onDragEnd }
// draggable
},_react2.default.createElement('span',{className:'ig-wrapper__header_title'},window.getLang('BROADCAST')),_react2.default.createElement('div',{className:'ig-wrapper__header_action ig-wrapper__header_action--close',onClick:this.onClose},'\xD7')),_react2.default.createElement(Ig,null));}}]);return IgWrapper;}(_react.Component))||_class3)||_class3);exports.default=IgWrapper;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventHeader=(_dec=(0,_mobxReact.inject)('igStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(EventHeader,_Component);function EventHeader(){_classCallCheck(this,EventHeader);return _possibleConstructorReturn(this,(EventHeader.__proto__||Object.getPrototypeOf(EventHeader)).apply(this,arguments));}_createClass(EventHeader,[{key:'render',value:function render(){if(this.props.igStore.error)return null;var _props$igStore$game=this.props.igStore.game,sid=_props$igStore$game.sid,c1=_props$igStore$game.c1,c2=_props$igStore$game.c2,score=_props$igStore$game.score;return _react2.default.createElement('div',{className:'ig-event-header s-c-'+sid},_react2.default.createElement('div',{className:'ig-teams'},_react2.default.createElement('div',{className:'ig-team',title:c1},_react2.default.createElement('div',{className:'ig-team-text'},c1)),_react2.default.createElement('div',{className:'ig-team',title:c1},_react2.default.createElement('div',{className:'ig-team-text'},c2))),_react2.default.createElement('div',{className:'ig-score'},score));}}]);return EventHeader;}(_react.Component))||_class)||_class);exports.default=EventHeader;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _groupBy=__webpack_require__(493);var _groupBy2=_interopRequireDefault(_groupBy);var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var List=(0,_mobxReact.inject)('lineStore','igStore')((0,_mobxReact.observer)(function(_ref){var lineStore=_ref.lineStore,igStore=_ref.igStore;var video=lineStore.menu.video;var toggleVideoList=igStore.toggleVideoList;var games=video.games.filter(function(g){return g.gid!==igStore.video.gid;});var grouped=(0,_groupBy2.default)(games,function(g){return g.sid;});return _react2.default.createElement('div',{className:'videoplayer-list'},igStore.video.title?_react2.default.createElement('div',{className:'videoplayer-list__item videoplayer-list__item--active',onClick:toggleVideoList},igStore.video.title):null,Object.keys(grouped).map(function(sid){return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'videoplayer-list__item videoplayer-list__item--sport'},video.dict.sport[sid],_react2.default.createElement('span',{className:'f-s-ico-'+sid})),grouped[sid].map(function(v){return _react2.default.createElement('div',{className:'videoplayer-list__item',onClick:function onClick(){toggleVideoList();igStore.setGame({id:v.gid,stats:v.stats,video:true,video_type:[v.type],sid:sid,c1:null,c2:null,score:null});}},v.name);}));}));}));exports.default=List;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(494),
    createAggregator = __webpack_require__(501);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(177);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(178),
    isMasked = __webpack_require__(498),
    isObject = __webpack_require__(99),
    toSource = __webpack_require__(180);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(499);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(502),
    baseAggregator = __webpack_require__(503),
    baseIteratee = __webpack_require__(519),
    isArray = __webpack_require__(21);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(504);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(505),
    createBaseEach = __webpack_require__(518);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(506),
    keys = __webpack_require__(100);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(507);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(509),
    isArguments = __webpack_require__(101),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(181),
    isIndex = __webpack_require__(182),
    isTypedArray = __webpack_require__(183);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    isObjectLike = __webpack_require__(43);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    isLength = __webpack_require__(102),
    isObjectLike = __webpack_require__(43);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(179);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)(module)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(515),
    nativeKeys = __webpack_require__(516);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(517);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 517 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(103);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(520),
    baseMatchesProperty = __webpack_require__(561),
    identity = __webpack_require__(109),
    isArray = __webpack_require__(21),
    property = __webpack_require__(571);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(521),
    getMatchData = __webpack_require__(560),
    matchesStrictComparable = __webpack_require__(192);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(184),
    baseIsEqual = __webpack_require__(186);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 528 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66),
    Map = __webpack_require__(104),
    MapCache = __webpack_require__(105);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(533),
    ListCache = __webpack_require__(66),
    Map = __webpack_require__(104);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(534),
    hashDelete = __webpack_require__(535),
    hashGet = __webpack_require__(536),
    hashHas = __webpack_require__(537),
    hashSet = __webpack_require__(538);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(68);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(68);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(68);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(68);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(69);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(69);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(69);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(69);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(184),
    equalArrays = __webpack_require__(187),
    equalByTag = __webpack_require__(548),
    equalObjects = __webpack_require__(551),
    getTag = __webpack_require__(556),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(181),
    isTypedArray = __webpack_require__(183);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    Uint8Array = __webpack_require__(549),
    eq = __webpack_require__(185),
    equalArrays = __webpack_require__(187),
    mapToArray = __webpack_require__(550),
    setToArray = __webpack_require__(106);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(552);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(553),
    getSymbols = __webpack_require__(554),
    keys = __webpack_require__(100);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(188),
    isArray = __webpack_require__(21);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(189),
    stubArray = __webpack_require__(555);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(557),
    Map = __webpack_require__(104),
    Promise = __webpack_require__(558),
    Set = __webpack_require__(190),
    WeakMap = __webpack_require__(559),
    baseGetTag = __webpack_require__(49),
    toSource = __webpack_require__(180);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(191),
    keys = __webpack_require__(100);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(186),
    get = __webpack_require__(562),
    hasIn = __webpack_require__(568),
    isKey = __webpack_require__(107),
    isStrictComparable = __webpack_require__(191),
    matchesStrictComparable = __webpack_require__(192),
    toKey = __webpack_require__(72);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(193);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(564);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(565);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(567);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    arrayMap = __webpack_require__(44),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(108);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(569),
    hasPath = __webpack_require__(570);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(194),
    isArguments = __webpack_require__(101),
    isArray = __webpack_require__(21),
    isIndex = __webpack_require__(182),
    isLength = __webpack_require__(102),
    toKey = __webpack_require__(72);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(572),
    basePropertyDeep = __webpack_require__(573),
    isKey = __webpack_require__(107),
    toKey = __webpack_require__(72);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(193);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=exports.openWindow=exports.canPlay=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactDom=__webpack_require__(18);var _reactDom2=_interopRequireDefault(_reactDom);var _reactRouterDom=__webpack_require__(2);var _classnames=__webpack_require__(15);var _classnames2=_interopRequireDefault(_classnames);var _ReactPlayer=__webpack_require__(575);var _ReactPlayer2=_interopRequireDefault(_ReactPlayer);var _reactPlayerControls=__webpack_require__(581);var _play=__webpack_require__(587);var _play2=_interopRequireDefault(_play);var _loading=__webpack_require__(588);var _loading2=_interopRequireDefault(_loading);__webpack_require__(590);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var videoplayer_instance_id=0;var containerStyle={paddingTop:'56.25%',position:'relative'};var VideoPlayer=(_dec=(0,_mobxReact.inject)('igStore'),_dec(_class=function(_Component){_inherits(VideoPlayer,_Component);function VideoPlayer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoPlayer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoPlayer.__proto__||Object.getPrototypeOf(VideoPlayer)).call.apply(_ref,[this].concat(args))),_this),_this.state={height:159,source:'',orientation:null,fullScreened:false,buttonFS:false,videoError:false},_this.videoContainer=_react2.default.createRef(),_this.player=_react2.default.createRef(),_this.setHeight=function(){if(_this.videoContainer.current){var height=_this.videoContainer.current.clientHeight;_this.setState(function(prevState){return height!==prevState.height?{height:height}:null;});}},_this.toggleFullScreen=function(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},autoFullScreen=_ref2.autoFullScreen;if(document.fullscreenElement){_this.setState({buttonFS:false});document.webkitExitFullscreen();}else{_this.setState({buttonFS:!autoFullScreen});document.getElementById('videoplayer').webkitRequestFullscreen();}},_this.overlay=_react2.default.createRef(),_this.onReady=function(playerRef){if(/twitch/.test(_this.props.source)){playerRef.getInternalPlayer().showPlayerControls(false);}else if(/youtu(\.be|be)/.test(_this.props.source)){setTimeout(function(){var player=playerRef.getInternalPlayer();if(player){player.addEventListener('onError',function(){if(_this.overlay.current){_this.overlay.current.classList.add('hidden');}});}},0);}else if(/vimeo/.test(_this.props.source)){// To show custom play icon
_this.props.onChange('started',true);}else{// To show custom play icon
_this.props.onChange('started',true);}_this.props.onChange('ready',true);},_this.onStart=function(){if(/twitch/.test(_this.props.source)){_this.props.onChange('started',false);}else{_this.props.onChange('started',true);}if(_this.player.current.player.player.hls&&_this.props.silent){_this.player.current.player.seekTo(_this.player.current.player.getSecondsLoaded());_this.props.onChange('silent',false);}},_this.handleError=function(err){var _this$props=_this.props,ready=_this$props.ready,gid=_this$props.gid;if(videoplayer_instance_id!==_this.videoplayer_instance_id)return;_this.setState({videoError:true});console.log('An error occurred while attempting to play video',err);if(!ready&&gid){if(_this.retryTimeout){clearTimeout(_this.retryTimeout);}_this.retryTimeout=setTimeout(function(){console.log('A new request to obtain video is sent',gid);_this.props.igStore.getVideo({gid:gid,silent:true,retry:true});},1000);}},_temp),_possibleConstructorReturn(_this,_ret);}// handleOrientationChange = () => {
//
//   const {playing} = this.props.igStore.video;
//   if (window.screen && window.screen.orientation) {
//     if (window.screen.orientation.type.startsWith('landscape')) {
//       playing &&
//       !this.state.fullScreened &&
//       document.getElementById('videoplayer').webkitRequestFullscreen();
//       this.setState({
//         orientation: 'landscape',
//       });
//     } else {
//       playing && !this.state.buttonFS && this.state.fullScreened && document.webkitExitFullscreen();
//       this.setState({
//         orientation: 'portrait',
//       });
//     }
//   }
//   this.setHeight();
// };
_createClass(VideoPlayer,[{key:'componentDidMount',// handleFullScreenChange = () => {
//   debugger;
//   this.setState({
//     fullScreened: !this.state.fullScreened
//   });
// };
value:function componentDidMount(){videoplayer_instance_id+=1;this.videoplayer_instance_id=videoplayer_instance_id;// if ((window.screen && window.screen.orientation)) {
//   window.screen.orientation.onchange = this.handleOrientationChange;
//   if (window.screen.orientation.type.startsWith('landscape')) {
//     this.setState({
//       orientation: 'landscape',
//     });
//   } else {
//     this.setState({
//       orientation: 'portrait',
//     });
//   }
//   this.setHeight();
//   document.addEventListener('fullscreenchange', this.handleFullScreenChange, false);
//   document.addEventListener('mozfullscreenchange', this.handleFullScreenChange, false);
//   document.addEventListener('MSFullscreenChange', this.handleFullScreenChange, false);
//   document.addEventListener('webkitfullscreenchange', this.handleFullScreenChange, false);
//
// }
}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setHeight();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onChange('started',false);if(this.retryTimeout){clearTimeout(this.retryTimeout);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,playing=_props.playing,volume=_props.volume,title=_props.title,detached=_props.detached,handleDetach=_props.handleDetach,toggleList=_props.toggleList,started=_props.started,ready=_props.ready,isLoading=_props.isLoading,source=_props.source;var _state=this.state,height=_state.height,videoError=_state.videoError;if(this.state.fullScreened&&this.state.orientation==='landscape'){var _window=window,innerHeight=_window.innerHeight,innerWidth=_window.innerWidth;containerStyle.paddingTop=(innerHeight>innerWidth?innerWidth/innerHeight:innerHeight/innerWidth)*100+'%';}if(this.state.fullScreened&&this.state.orientation==='portrait'){containerStyle.top='50%';containerStyle.transform='translateY(-50%)';}var CONFIG={youtube:{playerVars:{showinfo:0,autoplay:1}},vimeo:{playerOptions:{controls:0,showinfo:0,autoplay:1}},twitch:{options:{autoplay:1,showinfo:0}}};return _react2.default.createElement('div',{className:'videoplayer',ref:this.videoContainer,id:'videoplayer'},_react2.default.createElement('div',{className:'relative'},!ready&&_react2.default.createElement('div',{className:'absolute videoplayer-hider',style:{height:height}},_react2.default.createElement(_loading2.default,{videoError:videoError}))),_react2.default.createElement('div',{style:containerStyle},_react2.default.createElement('div',{className:'videoplayer__container',style:{zIndex:0}},!isLoading&&_react2.default.createElement(_ReactPlayer2.default,{url:source,onReady:this.onReady,onPlay:function onPlay(){_this2.props.onChange('playing',true);// if (this.state.orientation === 'landscape' && !this.state.fullScreened) {
//   this.toggleFullScreen({autoFullScreen: true});
// }
},onPause:function onPause(){return _this2.props.onChange('playing',false);},onStart:this.onStart,ref:this.player,onError:this.handleError,playing:playing,volume:volume,controls:false,width:'100%',height:'100%',config:CONFIG,style:{position:'absolute',top:0,left:0},playsinline:true,pip:detached}),ready&&_react2.default.createElement('div',{className:'videoplayer__overlay',style:{zIndex:2},ref:this.overlay},_react2.default.createElement('div',{className:'videoplayer__title',onClick:toggleList},_react2.default.createElement('i',{className:'videoplayer__title__icon'}),_react2.default.createElement('div',{className:'videoplayer__title__desc'},title)),_react2.default.createElement('div',{className:'videoplayer__toggle-play',onClick:function onClick(){return _this2.props.onChange('playing',!playing);}},started&&!playing&&_react2.default.createElement('img',{src:_play2.default,alt:''})),_react2.default.createElement(Controls,{volume:volume,playing:playing,setPlaying:function setPlaying(value){return _this2.props.onChange('playing',value);},setVolume:function setVolume(value){return _this2.props.onChange('volume',value);},handleFullScreen:this.toggleFullScreen,handleDetach:handleDetach,detached:detached// supportPip={ window.document.pictureInPictureEnabled && this.player.current && this.player.current.player.player.hls }
,fullScreened:this.state.fullScreened})))));}}]);return VideoPlayer;}(_react.Component))||_class);var Controls=function Controls(_ref3){var volume=_ref3.volume,playing=_ref3.playing,detached=_ref3.detached,fullScreened=_ref3.fullScreened,setPlaying=_ref3.setPlaying,setVolume=_ref3.setVolume,handleDetach=_ref3.handleDetach,handleFullScreen=_ref3.handleFullScreen,supportPip=_ref3.supportPip;var iconStyle={width:15,fill:'#fff'};return _react2.default.createElement('div',{className:(0,_classnames2.default)('videoplayer__controls',{videoplayer__controls__mobile:false,videoplayer__controls__mobile__fullscreen:fullScreened})},playing?_react2.default.createElement(_reactPlayerControls.PlayerIcon.Pause,{style:iconStyle,onClick:function onClick(){return setPlaying(false);}}):_react2.default.createElement(_reactPlayerControls.PlayerIcon.Play,{style:iconStyle,onClick:function onClick(){return setPlaying(true);}}),volume?_react2.default.createElement(_reactPlayerControls.PlayerIcon.SoundOn,{style:iconStyle,onClick:function onClick(){return setVolume(0);}}):null,!volume?_react2.default.createElement(_reactPlayerControls.PlayerIcon.SoundOff,{style:iconStyle,onClick:function onClick(){return setVolume(0.5);}}):null,_react2.default.createElement(_reactPlayerControls.Slider,{style:{width:50,height:4,borderRadius:2,background:'rgba(255,255,255,0.5)',transition:'width 0.1s',cursor:'pointer',opacity:1.0},direction:_reactPlayerControls.Direction.HORIZONTAL,isEnabled:true,onChange:function onChange(val){return setVolume(val);},onChangeStart:function onChangeStart(val){return setVolume(val);},onChangeEnd:function onChangeEnd(val){return val!==null&&setVolume(val);}},_react2.default.createElement(SliderBar,{value:volume}),_react2.default.createElement(SliderHandle,{value:volume})),supportPip?_react2.default.createElement(DetachIcon,{style:_extends({},iconStyle,{marginLeft:'auto'}),onClick:handleDetach,detached:detached}):null);};var SliderBar=function SliderBar(_ref4){var value=_ref4.value;return _react2.default.createElement('div',{style:{position:'absolute',borderRadius:2,top:0,bottom:0,left:0,width:value*100+'%',background:'#fff'}});};var SliderHandle=function SliderHandle(_ref5){var value=_ref5.value;return _react2.default.createElement('div',{style:{position:'absolute',width:8,height:8,background:'#fff',borderRadius:'100%',transform:'scale(1)',transition:'transform 0.2s','&:hover':{transform:'scale(1.3)'},top:0,left:value*100+'%',marginTop:-2,marginLeft:-4}});};var DetachIcon=function DetachIcon(_ref6){var detached=_ref6.detached,rest=_objectWithoutProperties(_ref6,['detached']);return _react2.default.createElement('svg',_extends({},rest,{viewBox:'0 0 21 17'}),detached?_react2.default.createElement('path',{fillRule:'evenodd',clipRule:'evenodd',d:'M3.52686 2.0105H17.406C17.9583 2.0105 18.406 2.45822 18.406 3.0105V13.8852C18.406 14.4375 17.9583 14.8852 17.406 14.8852H3.52686C2.97461 14.8852 2.52686 14.4375 2.52686 13.8852V3.0105C2.52686 2.45822 2.97461 2.0105 3.52686 2.0105ZM0.526855 3.0105C0.526855 1.35364 1.87 0.010498 3.52686 0.010498H17.406C19.0629 0.010498 20.406 1.35364 20.406 3.0105V13.8852C20.406 15.5421 19.0629 16.8852 17.406 16.8852H3.52686C1.87 16.8852 0.526855 15.5421 0.526855 13.8852V3.0105ZM13.0435 4.01843C12.4912 4.01843 12.0435 4.46616 12.0435 5.01843V11.9484C12.0435 12.5007 12.4912 12.9484 13.0435 12.9484H15.4131C15.9655 12.9484 16.4131 12.5007 16.4131 11.9484V5.01843C16.4131 4.46616 15.9655 4.01843 15.4131 4.01843H13.0435Z'}):_react2.default.createElement('path',{fillRule:'evenodd',clipRule:'evenodd',d:'M3.29395 2.09668H17.1731C17.7253 2.09668 18.1731 2.5444 18.1731 3.09668V13.9714C18.1731 14.5237 17.7253 14.9714 17.1731 14.9714H3.29395C2.7417 14.9714 2.29395 14.5237 2.29395 13.9714V3.09668C2.29395 2.5444 2.7417 2.09668 3.29395 2.09668ZM0.293945 3.09668C0.293945 1.43982 1.63708 0.0966797 3.29395 0.0966797H17.1731C18.83 0.0966797 20.1731 1.43982 20.1731 3.09668V13.9714C20.1731 15.6282 18.83 16.9714 17.1731 16.9714H3.29395C1.63708 16.9714 0.293945 15.6282 0.293945 13.9714V3.09668ZM9.37109 7.53638C8.81885 7.53638 8.37109 7.9841 8.37109 8.53638V12.0347C8.37109 12.5869 8.81885 13.0347 9.37109 13.0347H15.1803C15.7325 13.0347 16.1803 12.5869 16.1803 12.0347V8.53638C16.1803 7.9841 15.7325 7.53638 15.1803 7.53638H9.37109Z'}));};//
// const FullScreenIcon = ({fullScreened, ...rest}) => {
//   return fullScreened ? (
//     <svg
//       { ...rest }
//       width="14"
//       height="14"
//       viewBox="0 0 14 14"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <line
//         x1="1"
//         y1="5"
//         x2="5"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="5"
//         y1="1"
//         x2="5"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="9"
//         y1="1"
//         x2="9"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="13"
//         y1="5"
//         x2="9"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="13"
//         y1="9"
//         x2="9"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="9"
//         y1="13"
//         x2="9"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="5"
//         y1="13"
//         x2="5"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="1"
//         y1="9"
//         x2="5"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       { ...rest }
//       width="19"
//       height="14"
//       viewBox="0 0 19 14"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M17.593 13.198H1.63296C1.20736 13.198 0.834961 12.8256 0.834961 12.4V0.90884C0.834961 0.48324 1.20736 0.11084 1.63296 0.11084H17.593C18.0186 0.11084 18.391 0.48324 18.391 0.90884V12.4C18.391 12.8256 18.0186 13.198 17.593 13.198ZM2.37776 11.602H16.7418V1.70684H2.37776V11.602Z"
//         fill="white"
//       />
//     </svg>
//   );
// };
var NewWindowIcon=function NewWindowIcon(props){return _react2.default.createElement('svg',_extends({viewBox:'0 0 13 10',fill:'#687a94',style:{width:50,cursor:'pointer'}},props),_react2.default.createElement('rect',{x:'2.5',y:'0.5',width:'10',height:'7',stroke:'#687a94',fill:'none'}),_react2.default.createElement('rect',{y:'2',width:'1',height:'8'}),_react2.default.createElement('rect',{y:'9',width:'11',height:'1'}),_react2.default.createElement('rect',{x:'1',y:'2',width:'1',height:'1'}),_react2.default.createElement('rect',{x:'10',y:'8',width:'1',height:'1'}));};var canPlay=exports.canPlay=function canPlay(src){return _ReactPlayer2.default.canPlay(src);};var openWindow=exports.openWindow=function openWindow(src){var windowWidth=660;var windowHeight=460;window.open(src,'video '+src,'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=no,width='+windowWidth+',height='+windowHeight+',left=-'+(window.screen.width-windowWidth-100)+',top=10,resizable=no');};var VideoPlayerWrapper=(_dec2=(0,_mobxReact.inject)('igStore','accountStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(VideoPlayerWrapper,_Component2);function VideoPlayerWrapper(){var _ref7;var _temp2,_this3,_ret2;_classCallCheck(this,VideoPlayerWrapper);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref7=VideoPlayerWrapper.__proto__||Object.getPrototypeOf(VideoPlayerWrapper)).call.apply(_ref7,[this].concat(args))),_this3),_this3.state={initialX:0,initialY:0},_this3.el=_react2.default.createRef(),_this3.createFrame=function(url){var frame='<iframe src=\'//uma.media/play/embed/'+url+'\' frameborder=\'0\' class="video-frame-i"></iframe>';return _react2.default.createElement('div',{style:containerStyle,dangerouslySetInnerHTML:{__html:frame}});},_this3.onDrag=function(e){var _ref8=e.type==='touchmove'?e.touches[0]:e,pageX=_ref8.pageX,pageY=_ref8.pageY;if(!pageY||!pageY)return;var rect=_this3.el.current.getBoundingClientRect();var deltaX=pageX-window.innerWidth+rect.width-_this3.state.initialX;var deltaY=pageY-window.innerHeight+rect.height-_this3.state.initialY;if(deltaX>0||deltaX-rect.width<-window.innerWidth)return;if(deltaY>0||deltaY-rect.height<-window.innerHeight)return;_this3.props.igStore.setVideoPosition(deltaX,deltaY);},_this3.onDragEnd=function(){_this3.el.current.classList.remove('dragging');},_this3.onDragStart=function(e){_this3.el.current.classList.add('dragging');var rect=_this3.el.current.getBoundingClientRect();var _ref9=e.type==='touchmove'?e.touches[0]:e,pageX=_ref9.pageX,pageY=_ref9.pageY;if(e.type==='drag'){e.dataTransfer.effectAllowed='move';e.dataTransfer.setDragImage(new Image(),0,0);}_this3.setState({initialX:pageX-rect.left,initialY:pageY-rect.top});},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(VideoPlayerWrapper,[{key:'render',value:function render(){var content=null;var error=void 0;var _props2=this.props,igStore=_props2.igStore,games=_props2.games,force=_props2.force,accountStore=_props2.accountStore;var video=igStore.video;if(!force){if(video.error){if(video.error===3){content=_react2.default.createElement('div',{className:'videoplayer-error'},_react2.default.createElement('div',{className:'videoplayer-error__text'},window.getLang('TOP_UP_BALANCE_TO_VIEW')),_react2.default.createElement(_reactRouterDom.Link,{className:'flat_button',to:'/finance/deposit'},window.getLang('TO_DEPOSIT')));}else if(video.error===2){content=_react2.default.createElement('div',{className:'videoplayer-error'},_react2.default.createElement('div',{className:'videoplayer-error__text'},window.getLang('PLEASE_AUTH_TO_VIEW_THE_BROADCAST')),_react2.default.createElement('button',{className:'flat_button',onClick:function onClick(){return accountStore.toggleLoginForm();}},window.getLang('SIGN_IN')));}else{content=_react2.default.createElement('div',{className:'videoplayer-error'},_react2.default.createElement('div',{className:'videoplayer-error__text'},window.getLang(video.error)));}error=true;}else if(!video.src){return false;}else if(video.type===4){// FIXME продумать более универсальное решение
error=true;content=this.createFrame(video.src);}else if(!canPlay(video.src)&&video.type!==4){error=true;content=_react2.default.createElement('div',{className:'videoplayer-error'},_react2.default.createElement(NewWindowIcon,{onClick:function onClick(){return openWindow(video.src);}}));}}if(!error){content=_react2.default.createElement(VideoPlayer,{games:games,playing:video.playing,volume:video.volume,source:video.src,title:video.title,started:video.started,ready:video.ready,gid:video.gid,onChange:igStore.setVideoParam,handleDetach:igStore.toggleDetachVideo,toggleList:igStore.toggleVideoList,detached:video.detached,handleFullScreen:igStore.toggleFullScreenVideo,fullScreened:video.fullScreened});}console.log(content);var wrapper=_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:(0,_classnames2.default)('videoplayer-wrapper',{'videoplayer-wrapper-hidden':false}),ref:this.el},content));if(video.detached){return _react2.default.createElement(DetachedPortal,null,_react2.default.createElement('div',{style:{transform:'translate('+video.left+'px, '+video.top+'px)'},className:'video-container'},wrapper));}return wrapper;}}]);return VideoPlayerWrapper;}(_react.Component))||_class3)||_class3);exports.default=VideoPlayerWrapper;var DetachedPortal=function DetachedPortal(_ref10){var children=_ref10.children;return _reactDom2.default.createPortal(children,document.getElementById('video-container'));};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FilePlayer", {
  enumerable: true,
  get: function get() {
    return _FilePlayer["default"];
  }
});
Object.defineProperty(exports, "YouTube", {
  enumerable: true,
  get: function get() {
    return _YouTube["default"];
  }
});
Object.defineProperty(exports, "SoundCloud", {
  enumerable: true,
  get: function get() {
    return _SoundCloud["default"];
  }
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _Vimeo["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "Streamable", {
  enumerable: true,
  get: function get() {
    return _Streamable["default"];
  }
});
Object.defineProperty(exports, "Wistia", {
  enumerable: true,
  get: function get() {
    return _Wistia["default"];
  }
});
Object.defineProperty(exports, "Twitch", {
  enumerable: true,
  get: function get() {
    return _Twitch["default"];
  }
});
Object.defineProperty(exports, "DailyMotion", {
  enumerable: true,
  get: function get() {
    return _DailyMotion["default"];
  }
});
Object.defineProperty(exports, "Mixcloud", {
  enumerable: true,
  get: function get() {
    return _Mixcloud["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(73);

var _utils = __webpack_require__(14);

var _players = _interopRequireDefault(__webpack_require__(578));

var _Player4 = _interopRequireDefault(__webpack_require__(111));

var _Preview = _interopRequireDefault(__webpack_require__(579));

var _FilePlayer = _interopRequireWildcard(__webpack_require__(200));

var _preload = _interopRequireDefault(__webpack_require__(580));

var _YouTube = _interopRequireDefault(__webpack_require__(110));

var _SoundCloud = _interopRequireDefault(__webpack_require__(112));

var _Vimeo = _interopRequireDefault(__webpack_require__(113));

var _Facebook = _interopRequireDefault(__webpack_require__(195));

var _Streamable = _interopRequireDefault(__webpack_require__(196));

var _Wistia = _interopRequireDefault(__webpack_require__(197));

var _Twitch = _interopRequireDefault(__webpack_require__(198));

var _DailyMotion = _interopRequireDefault(__webpack_require__(114));

var _Mixcloud = _interopRequireDefault(__webpack_require__(199));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);
var customPlayers = [];

var ReactPlayer = /*#__PURE__*/function (_Component) {
  _inherits(ReactPlayer, _Component);

  var _super = _createSuper(ReactPlayer);

  function ReactPlayer() {
    var _this;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPreview: !!_this.props.light
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function () {
      _this.setState({
        showPreview: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
      _this.setState({
        showPreview: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    });

    _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    });

    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
      if (!_this.player) return null;

      _this.player.seekTo(fraction, type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      _this.props.onReady(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
      _this.wrapper = wrapper;
    });

    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
      _this.player = player;
    });

    return _this;
  }

  _createClass(ReactPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var light = this.props.light;
      this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);

      if (!prevProps.light && light) {
        this.setState({
          showPreview: true
        });
      }

      if (prevProps.light && !light) {
        this.setState({
          showPreview: false
        });
      }
    }
  }, {
    key: "getActivePlayer",
    value: function getActivePlayer(url) {
      for (var _i = 0, _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i < _arr.length; _i++) {
        var _Player = _arr[_i];

        if (_Player.canPlay(url)) {
          return _Player;
        }
      } // Fall back to FilePlayer if nothing else can play the URL


      return _FilePlayer.FilePlayer;
    }
  }, {
    key: "renderActivePlayer",
    value: function renderActivePlayer(url, activePlayer) {
      if (!url) return null;
      return /*#__PURE__*/_react["default"].createElement(_Player4["default"], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.handleReady
      }));
    }
  }, {
    key: "sortPlayers",
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          controls = _this$props.controls,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height,
          light = _this$props.light,
          playIcon = _this$props.playIcon,
          Wrapper = _this$props.wrapper;
      var showPreview = this.state.showPreview && url;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.getActivePlayer(url);
      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
      var preloadPlayers = (0, _preload["default"])(url, controls, this.config);
      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);

      var preview = /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
        url: url,
        light: light,
        playIcon: playIcon,
        onClick: this.handleClickPreview
      });

      return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
        ref: this.wrapperRef,
        style: _objectSpread({}, style, {
          width: width,
          height: height
        })
      }, otherProps), showPreview ? preview : players);
    }
  }]);

  return ReactPlayer;
}(_react.Component);

exports["default"] = ReactPlayer;

_defineProperty(ReactPlayer, "addCustomPlayer", function (player) {
  customPlayers.push(player);
});

_defineProperty(ReactPlayer, "removeCustomPlayers", function () {
  customPlayers = [];
});

_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');

_defineProperty(ReactPlayer, "propTypes", _props.propTypes);

_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);

_defineProperty(ReactPlayer, "canPlay", function (url) {
  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];

    if (_Player2.canPlay(url)) {
      return true;
    }
  }

  return false;
});

_defineProperty(ReactPlayer, "canEnablePIP", function (url) {
  for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];

    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }

  return false;
});

/***/ }),
/* 576 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _YouTube = __webpack_require__(110);

var _SoundCloud = __webpack_require__(112);

var _Vimeo = __webpack_require__(113);

var _Facebook = __webpack_require__(195);

var _Streamable = __webpack_require__(196);

var _Wistia = __webpack_require__(197);

var _Twitch = __webpack_require__(198);

var _DailyMotion = __webpack_require__(114);

var _Mixcloud = __webpack_require__(199);

var _FilePlayer = __webpack_require__(200);

var _default = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];
exports["default"] = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderPreloadPlayers;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Player = _interopRequireDefault(__webpack_require__(111));

var _YouTube = __webpack_require__(110);

var _SoundCloud = __webpack_require__(112);

var _Vimeo = __webpack_require__(113);

var _DailyMotion = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, controls, config) {
  var players = [];

  var _iterator = _createForOfIteratorHelper(PRELOAD_PLAYERS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push( /*#__PURE__*/_react["default"].createElement(_Player["default"], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          controls: controls,
          playing: true,
          muted: true,
          display: "none"
        }));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return players;
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "FormattedTime", {
  enumerable: true,
  get: function get() {
    return _FormattedTime.default;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "Direction", {
  enumerable: true,
  get: function get() {
    return _constants.Direction;
  }
});
exports.PlayerIcon = void 0;

var _Button = _interopRequireDefault(__webpack_require__(582));

var _FormattedTime = _interopRequireDefault(__webpack_require__(583));

var PlayerIcon = _interopRequireWildcard(__webpack_require__(584));

exports.PlayerIcon = PlayerIcon;

var _Slider = _interopRequireDefault(__webpack_require__(585));

var _constants = __webpack_require__(116);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _autobindDecorator = _interopRequireDefault(__webpack_require__(115));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

/**
 * Base button component
 */
var Button = (_class =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "handleClick",
    value: function handleClick(event) {
      if (this.props.isEnabled) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isEnabled = _this$props.isEnabled,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children;
      return _react.default.createElement("button", {
        className: className,
        style: style,
        disabled: !isEnabled,
        onClick: this.handleClick
      }, children);
    }
  }]);

  return Button;
}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, "handleClick", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
Button.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  isEnabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  children: _propTypes.default.node
};
Button.defaultProps = {
  isEnabled: true,
  className: null,
  style: {},
  children: null
};
var _default = Button;
exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var number = _propTypes.default.number,
    object = _propTypes.default.object,
    string = _propTypes.default.string;

var padZero = function padZero(digit) {
  return "".concat(digit < 10 ? '0' : '').concat(digit);
};
/**
 * Time formatter that turns seconds into h:mm:ss
 */


var FormattedTime =
/*#__PURE__*/
function (_Component) {
  _inherits(FormattedTime, _Component);

  function FormattedTime() {
    _classCallCheck(this, FormattedTime);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormattedTime).apply(this, arguments));
  }

  _createClass(FormattedTime, [{
    key: "getFormattedTime",
    value: function getFormattedTime() {
      var numSeconds = this.props.numSeconds;
      var prefix = numSeconds < 0 ? '-' : '';
      var absNumSeconds = Math.abs(numSeconds);
      var hours = Math.floor(absNumSeconds / 3600);
      var minutes = Math.floor(absNumSeconds % 3600 / 60);
      var seconds = Math.floor(absNumSeconds) % 60;
      return hours > 0 ? "".concat(prefix).concat(hours, ":").concat(padZero(minutes), ":").concat(padZero(seconds)) : "".concat(prefix).concat(minutes, ":").concat(padZero(seconds));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className;
      return _react.default.createElement("span", {
        className: className,
        style: style
      }, this.getFormattedTime());
    }
  }]);

  return FormattedTime;
}(_react.Component);

FormattedTime.propTypes = {
  numSeconds: number,
  className: string,
  style: object
};
FormattedTime.defaultProps = {
  numSeconds: 0,
  className: null,
  style: {}
};
var _default = FormattedTime;
exports.default = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundOff = exports.SoundOn = exports.Next = exports.Previous = exports.Pause = exports.Play = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Play
 */
var Play = function Play(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("polygon", {
    points: "24 92 24 7 100 49.4955227"
  }));
};
/**
 * Pause
 */


exports.Play = Play;

var Pause = function Pause(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: "58",
    y: "11",
    width: "21",
    height: "78"
  }), _react.default.createElement("rect", {
    x: "22",
    y: "11",
    width: "21",
    height: "78"
  })));
};
/**
 * Previous
 */


exports.Pause = Pause;

var Previous = function Previous(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("polygon", {
    points: "85 12.6092632 27.3529412 44.5358947 27.3529412 11 15 11 15 89 27.3529412 89 27.3529412 54.368 85 86.3028421"
  }));
};
/**
 * Next
 */


exports.Previous = Previous;

var Next = function Next(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("polygon", {
    points: "72.6470588 11 72.6470588 44.1141176 15 12.0911765 15 85.9988235 72.6470588 53.9717647 72.6470588 89.2352941 85 89.2352941 85 11"
  }));
};
/**
 * Sound on
 */


exports.Next = Next;

var SoundOn = function SoundOn(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M28.0748663,36.3636364 L0,36.3636364 L0,65.9090909 L30.4812834,65.9090909 L54.5454545,88.6363636 L54.5454545,11.3636364 L28.0748663,36.3636364 Z"
  }), _react.default.createElement("path", {
    d: "M84.6032335,82.4592965 C94.5340754,74.7600841 100.468182,62.9599381 100.468182,50.1791986 C100.468182,38.1777252 95.2347685,27.0146095 86.3177905,19.2913999 L80.3660059,26.1631456 C87.313543,32.1805749 91.3772727,40.8487007 91.3772727,50.1791986 C91.3772727,60.1143215 86.7696647,69.2766862 79.0331302,75.2746895 L84.6032335,82.4592965 L84.6032335,82.4592965 Z"
  }), _react.default.createElement("path", {
    d: "M68.6941426,71.5946428 C75.48494,66.3298533 79.5454545,58.2554001 79.5454545,49.5119787 C79.5454545,41.3018627 75.9644339,33.663378 69.8670756,28.382309 L63.9152911,35.2540546 C68.0432084,38.8293434 70.4545455,43.9728382 70.4545455,49.5119787 C70.4545455,55.4097835 67.7205293,60.8464555 63.1240393,64.4100358 L68.6941426,71.5946428 L68.6941426,71.5946428 Z"
  })));
};
/**
 * Sound off
 */


exports.SoundOn = SoundOn;

var SoundOff = function SoundOff(props) {
  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M28.0748663,36.3636364 L0,36.3636364 L0,65.9090909 L30.4812834,65.9090909 L54.5454545,88.6363636 L54.5454545,11.3636364 L28.0748663,36.3636364 Z"
  }), _react.default.createElement("polygon", {
    points: "69.513151 44.1232126 87.6949692 62.3050308 90.9090909 65.5191526 97.3373344 59.0909091 94.1232126 55.8767874 75.9413945 37.6949692 72.7272727 34.4808474 66.2990293 40.9090909"
  }), _react.default.createElement("polygon", {
    points: "75.9413945 62.3050308 94.1232126 44.1232126 97.3373344 40.9090909 90.9090909 34.4808474 87.6949692 37.6949692 69.513151 55.8767874 66.2990293 59.0909091 72.7272727 65.5191526"
  })));
};

exports.SoundOff = SoundOff;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _autobindDecorator = _interopRequireDefault(__webpack_require__(115));

var _constants = __webpack_require__(116);

var _utils = __webpack_require__(201);

var _RangeControlOverlay = _interopRequireDefault(__webpack_require__(586));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

/**
 * Slider
 *
 * A wrapper around <RangeControlOverlay /> that may be used to
 * compose slider controls such as volume sliders or progress bars.
 */
var Slider = (_class =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Slider)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.$el = null, _temp));
  }

  _createClass(Slider, [{
    key: "storeRef",
    value: function storeRef($el) {
      this.$el = $el;
    }
  }, {
    key: "handleIntent",
    value: function handleIntent(intent) {
      if (this.props.isEnabled) {
        this.props.onIntent(intent);
      }
    }
  }, {
    key: "handleIntentStart",
    value: function handleIntentStart(intent) {
      if (this.props.isEnabled) {
        this.props.onIntentStart(intent);
      }
    }
  }, {
    key: "handleIntentEnd",
    value: function handleIntentEnd() {
      if (this.props.isEnabled) {
        this.props.onIntentEnd();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      if (this.props.isEnabled) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "handleChangeStart",
    value: function handleChangeStart(value) {
      if (this.props.isEnabled) {
        this.props.onChangeStart(value);
      }
    }
  }, {
    key: "handleChangeEnd",
    value: function handleChangeEnd(value) {
      if (this.props.isEnabled) {
        this.props.onChangeEnd(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          direction = _this$props.direction,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          overlayZIndex = _this$props.overlayZIndex;
      return _react.default.createElement("div", {
        ref: this.storeRef,
        className: className,
        style: _objectSpread({
          position: 'relative'
        }, style)
      }, children, _react.default.createElement(_RangeControlOverlay.default, {
        direction: direction,
        bounds: function bounds() {
          return _this2.$el.getBoundingClientRect();
        },
        onIntent: this.handleIntent,
        onIntentStart: this.handleIntentStart,
        onIntentEnd: this.handleIntentEnd,
        onChange: this.handleChange,
        onChangeStart: this.handleChangeStart,
        onChangeEnd: this.handleChangeEnd,
        style: {
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: overlayZIndex
        }
      }));
    }
  }]);

  return Slider;
}(_react.PureComponent), (_applyDecoratedDescriptor(_class.prototype, "storeRef", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "storeRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntent", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentStart", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentEnd", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChangeStart", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChangeStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChangeEnd", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChangeEnd"), _class.prototype)), _class);
Slider.propTypes = {
  direction: _propTypes.default.oneOf([_constants.Direction.HORIZONTAL, _constants.Direction.VERTICAL]),
  isEnabled: _propTypes.default.bool,
  onIntent: _propTypes.default.func,
  onIntentStart: _propTypes.default.func,
  onIntentEnd: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeStart: _propTypes.default.func,
  onChangeEnd: _propTypes.default.func,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  overlayZIndex: _propTypes.default.number
};
Slider.defaultProps = {
  direction: _constants.Direction.HORIZONTAL,
  isEnabled: true,
  onIntent: _utils.noop,
  onIntentStart: _utils.noop,
  onIntentEnd: _utils.noop,
  onChange: _utils.noop,
  onChangeStart: _utils.noop,
  onChangeEnd: _utils.noop,
  children: null,
  className: null,
  style: {},
  overlayZIndex: 10
};
var _default = Slider;
exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _autobindDecorator = _interopRequireDefault(__webpack_require__(115));

var _constants = __webpack_require__(116);

var _utils = __webpack_require__(201);

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

var oneOfType = _propTypes.default.oneOfType,
    shape = _propTypes.default.shape,
    func = _propTypes.default.func,
    number = _propTypes.default.number,
    oneOf = _propTypes.default.oneOf,
    object = _propTypes.default.object,
    string = _propTypes.default.string;
/**
 * An invisible overlay that acts as a range mouse control
 * within a specified bounds.
 */

var RangeControlOverlay = (_class =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeControlOverlay, _Component);

  function RangeControlOverlay(props) {
    var _this;

    _classCallCheck(this, RangeControlOverlay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeControlOverlay).call(this, props));
    _this.state = {
      isDragging: false
    };
    return _this;
  }

  _createClass(RangeControlOverlay, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.endDrag();
    }
  }, {
    key: "startDrag",
    value: function startDrag(evt) {
      this.setState({
        isDragging: true
      });
      window.addEventListener('mousemove', this.triggerRangeChange);
      window.addEventListener('mouseup', this.endDrag);
      this.toggleSelection('none');
      var startValue = evt ? this.getValueFromMouseEvent(evt) : null;
      this.props.onChangeStart(startValue);
    }
  }, {
    key: "endDrag",
    value: function endDrag(evt) {
      if (evt) {
        this.triggerRangeChange(evt);
      }

      this.setState({
        isDragging: false
      });
      window.removeEventListener('mousemove', this.triggerRangeChange);
      window.removeEventListener('mouseup', this.endDrag);
      this.toggleSelection('');
      var endValue = evt ? this.getValueFromMouseEvent(evt) : null;
      this.props.onChangeEnd(endValue);
    }
  }, {
    key: "toggleSelection",
    value: function toggleSelection(value) {
      var body = document.getElementsByTagName('body')[0];
      body.style['user-select'] = value;
      body.style['-webkit-user-select'] = value;
      body.style['-moz-user-select'] = value;
      body.style['-ms-user-select'] = value;
    }
  }, {
    key: "getValueFromMouseEvent",
    value: function getValueFromMouseEvent(mouseEvent) {
      return this.props.direction === _constants.Direction.VERTICAL ? this.getVerticalValue(mouseEvent.pageY) : this.getHorizontalValue(mouseEvent.pageX);
    }
  }, {
    key: "triggerRangeChange",
    value: function triggerRangeChange(mouseEvent) {
      this.props.onChange(this.getValueFromMouseEvent(mouseEvent));
    }
  }, {
    key: "handleIntentStart",
    value: function handleIntentStart(evt) {
      var _this$props = this.props,
          direction = _this$props.direction,
          onIntentStart = _this$props.onIntentStart;

      if (!this.state.isDragging) {
        var value = direction === _constants.Direction.VERTICAL ? this.getVerticalValue(evt.pageY) : this.getHorizontalValue(evt.pageX);
        onIntentStart(value);
      }
    }
  }, {
    key: "handleIntentMove",
    value: function handleIntentMove(evt) {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          onIntent = _this$props2.onIntent;

      if (!this.state.isDragging) {
        var value = direction === _constants.Direction.VERTICAL ? this.getVerticalValue(evt.pageY) : this.getHorizontalValue(evt.pageX);
        onIntent(value);
      }
    }
  }, {
    key: "handleIntentEnd",
    value: function handleIntentEnd(evt) {
      var onIntentEnd = this.props.onIntentEnd;

      if (!this.state.isDragging) {
        onIntentEnd();
      }
    }
  }, {
    key: "getRectFromBounds",
    value: function getRectFromBounds() {
      var bounds = this.props.bounds;
      return typeof bounds === 'function' ? bounds() : bounds;
    }
  }, {
    key: "getHorizontalValue",
    value: function getHorizontalValue(mouseX) {
      var rect = this.getRectFromBounds();
      var scrollX = window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
      var dLeft = mouseX - (rect.left + scrollX);
      dLeft = Math.max(dLeft, 0);
      dLeft = Math.min(dLeft, rect.width);
      return dLeft / rect.width;
    }
  }, {
    key: "getVerticalValue",
    value: function getVerticalValue(mouseY) {
      var rect = this.getRectFromBounds();
      var scrollY = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var dTop = mouseY - (rect.top + scrollY);
      dTop = Math.max(dTop, 0);
      dTop = Math.min(dTop, rect.height);
      return 1 - dTop / rect.height;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style;
      return _react.default.createElement("div", {
        className: className,
        style: style,
        onMouseDown: this.startDrag,
        onMouseEnter: this.handleIntentStart,
        onMouseMove: this.handleIntentMove,
        onMouseLeave: this.handleIntentEnd
      });
    }
  }]);

  return RangeControlOverlay;
}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, "startDrag", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "startDrag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "endDrag", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "endDrag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerRangeChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "triggerRangeChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentStart", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentMove", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentEnd", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentEnd"), _class.prototype)), _class);
RangeControlOverlay.propTypes = {
  bounds: oneOfType([func, shape({
    width: number.isRequired,
    left: number.isRequired
  }), shape({
    height: number.isRequired,
    top: number.isRequired
  })]).isRequired,
  onChange: func.isRequired,
  onChangeStart: func,
  onChangeEnd: func,
  onIntent: func,
  onIntentStart: func,
  onIntentEnd: func,
  direction: oneOf([_constants.Direction.HORIZONTAL, _constants.Direction.VERTICAL]),
  className: string,
  style: object
};
RangeControlOverlay.defaultProps = {
  onChangeStart: _utils.noop,
  onChangeEnd: _utils.noop,
  onIntent: _utils.noop,
  onIntentStart: _utils.noop,
  onIntentEnd: _utils.noop,
  direction: _constants.Direction.HORIZONTAL,
  className: null,
  style: {}
};
var _default = RangeControlOverlay;
exports.default = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play.3fd9881a.svg";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _loading=__webpack_require__(589);var _loading2=_interopRequireDefault(_loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
TODO изменить строку на локале, коггда будет готов перевод
 */exports.default=(0,_mobxReact.inject)('dictStore')((0,_mobxReact.observer)(function(_ref){var dictStore=_ref.dictStore,videoError=_ref.videoError;return _react2.default.createElement('div',{className:'loading-spinner-video'},!videoError?_react2.default.createElement('img',{src:_loading2.default,className:'loading-spinner-video-spinner',alt:'loading'}):"",_react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'absolute loading-spinner-video-text'},dictStore.getLang(videoError?'SORRY_VIDEO_IS_NOT_AVAILABLE':'VIDEO_LOADING_PLEASE_WAIT'))));}));

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading.4b85ddbe.gif";

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactResizeDetector=__webpack_require__(202);var _reactResizeDetector2=_interopRequireDefault(_reactResizeDetector);var _revealBtn=__webpack_require__(203);var _revealBtn2=_interopRequireDefault(_revealBtn);var _icon=__webpack_require__(596);var _icon2=_interopRequireDefault(_icon);var _error=__webpack_require__(204);var _error2=_interopRequireDefault(_error);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Events=(_dec=(0,_mobxReact.inject)('igStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Events,_Component);function Events(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Events);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Events.__proto__||Object.getPrototypeOf(Events)).call.apply(_ref,[this].concat(args))),_this),_this.state={height:0,width:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Events,[{key:'render',value:function render(){var _this2=this;var _props$igStore=this.props.igStore,events=_props$igStore.events,game=_props$igStore.game,reveal=_props$igStore.reveal,error=_props$igStore.error;var height=this.state.height;var hasTime=events.find(function(e){return e.time;});var sid=game.sid;if(error)return _react2.default.createElement(_error2.default,null);if(!events.length)return null;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'ig-item-wrapper'+(reveal?' ig-item-wrapper--open':'')},_react2.default.createElement('div',{className:'ig-log'},events.map(function(evt){return evt.type===1?_react2.default.createElement(Head,evt):_react2.default.createElement(Body,_extends({},evt,{sid:sid,hasTime:hasTime}));}),_react2.default.createElement(_reactResizeDetector2.default,{handleHeight:true,handleWidth:true,onResize:function onResize(width,height){return _this2.setState({width:width,height:height});}}))),_react2.default.createElement(_revealBtn2.default,{height:height}));}}]);return Events;}(_react.Component))||_class)||_class);function Head(_ref2){var text=_ref2.text,score=_ref2.score,time=_ref2.time;return _react2.default.createElement('div',{className:'ig-log__head'},_react2.default.createElement('div',{className:'ig-log-score'}),_react2.default.createElement('div',{className:'ig-log-event'},''+text+(time?' '+time:'')),_react2.default.createElement('div',{className:'ig-log-score'}));}function Body(_ref3){var team=_ref3.team,text=_ref3.text,score=_ref3.score,sid=_ref3.sid,type=_ref3.type,time=_ref3.time,hasTime=_ref3.hasTime;var event=_react2.default.createElement(_react.Fragment,null,_react2.default.createElement(_icon2.default,{id:type,sid:sid}),_react2.default.createElement('span',null,text,score?_react2.default.createElement('span',{style:{fontWeight:'normal'}},' '+score.t1+':'+score.t2):''));return _react2.default.createElement('div',{className:'ig-log__body'},_react2.default.createElement('div',{className:'ig-log-event ig-log-event--type-'+type},team===1?event:null),_react2.default.createElement('div',{className:'ig-log-time'+(!hasTime?' ig-log-time--squashed':'')},time),_react2.default.createElement('div',{className:'ig-log-event ig-log-event--type-'+type},team===2?event:null));}exports.default=Events;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(593);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _lodash = __webpack_require__(594);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(595);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };

var styles = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  display: 'none'
};

var ResizeDetector = function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));

    _this.createResizeObserver = function (entries) {
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight,
          onResize = _this$props.onResize;

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;

        var notifyWidth = handleWidth && _this.width !== width;
        var notifyHeight = handleHeight && _this.height !== height;
        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
          onResize(width, height);
        }
        _this.width = width;
        _this.height = height;
        _this.skipOnMount = false;
      });
    };

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate;


    _this.width = undefined;
    _this.height = undefined;
    _this.skipOnMount = skipOnMount;

    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;

    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.observe(resizableElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.unobserve(resizableElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        style: styles,
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }]);

  return ResizeDetector;
}(_react.PureComponent);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  skipOnMount: _propTypes2.default.bool,
  refreshRate: _propTypes2.default.number,
  refreshMode: _propTypes2.default.string,
  resizableElementId: _propTypes2.default.string,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  resizableElementId: '',
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Icon=function Icon(_ref){var id=_ref.id,sid=_ref.sid,props=_objectWithoutProperties(_ref,['id','sid']);var map={2:sid,3:'feed_transit',// 4: 'innings',
5:sid,6:'orner',7:'yellowcrd',8:'foul',9:'offside',10:'throw_in',11:'goal_kick',12:'barbell',13:sid,14:'throw_in'};if(!map[id])return null;return _react2.default.createElement('span',{className:'ig-icon'},_react2.default.createElement('i',{className:'f-s-ico-'+map[id],style:{fontSize:16}}));};exports.default=Icon;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _mobxReact=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactResizeDetector=__webpack_require__(202);var _reactResizeDetector2=_interopRequireDefault(_reactResizeDetector);var _error=__webpack_require__(204);var _error2=_interopRequireDefault(_error);var _revealBtn=__webpack_require__(203);var _revealBtn2=_interopRequireDefault(_revealBtn);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Progress=(_dec=(0,_mobxReact.inject)('igStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Progress,_Component);function Progress(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Progress);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Progress.__proto__||Object.getPrototypeOf(Progress)).call.apply(_ref,[this].concat(args))),_this),_this.state={height:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Progress,[{key:'render',value:function render(){var _this2=this;var _props$igStore=this.props.igStore,statsByTeamTexts=_props$igStore.statsByTeamTexts,statsByTeam=_props$igStore.statsByTeam,reveal=_props$igStore.reveal,game=_props$igStore.game,error=_props$igStore.error;var height=this.state.height;if(error)return _react2.default.createElement(_error2.default,null);if(!Object.keys(statsByTeam).length)return null;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'ig-item-wrapper'+(reveal?' ig-item-wrapper--open':'')},_react2.default.createElement('div',{className:'ig-progress-wrapper'},statsByTeamTexts.map(function(_ref2){var type=_ref2.type,text=_ref2.text;return _react2.default.createElement(Item,{text:text,stat:statsByTeam[type],sid:game.sid});}),_react2.default.createElement(_reactResizeDetector2.default,{handleHeight:true,onResize:function onResize(width,height){return _this2.setState({height:height});}}))),_react2.default.createElement(_revealBtn2.default,{height:height}));}}]);return Progress;}(_react.Component))||_class)||_class);function Item(_ref3){var text=_ref3.text,stat=_ref3.stat,sid=_ref3.sid;var _ref4=[getWidth(stat,'t1'),getWidth(stat,'t2')],t1Width=_ref4[0],t2Width=_ref4[1];return _react2.default.createElement('div',{className:'ig-progress'},_react2.default.createElement('div',{className:'ig-progress__head'},_react2.default.createElement('span',{className:'ig-progress__score'},stat.t1),_react2.default.createElement('span',null,text),_react2.default.createElement('span',{className:'ig-progress__score'},stat.t2)),_react2.default.createElement('div',{className:'ig-progress__bar'},t1Width?_react2.default.createElement('div',{style:{flexGrow:t1Width},className:'s-c-'+sid}):'',t2Width?_react2.default.createElement('div',{style:{flexGrow:t2Width},className:'ig-indicator-t2'}):'',!t1Width&&!t2Width?_react2.default.createElement('div',null):''));}function getWidth(stats,team){if(stats[team]===0)return 0;return stats[team]/(stats.t1+stats.t2)*100;}exports.default=Progress;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _liveMenu=__webpack_require__(86);var _liveMenu2=_interopRequireDefault(_liveMenu);var _line=__webpack_require__(89);var _line2=_interopRequireDefault(_line);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { inject, observer } from 'mobx-react';
// import './style.scss';
// import LoadingSpinner from '../../components/loadingSpinner/';
// @inject('lineStore')
// @observer
var Line=function(_Component){_inherits(Line,_Component);function Line(){_classCallCheck(this,Line);return _possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments));}_createClass(Line,[{key:'componentWillMount',value:function componentWillMount(){// this.props.lineStore.loadLine();
}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'stats-index'},_react2.default.createElement('div',{className:'blue_line'},_react2.default.createElement(_underHeader2.default,{type:2})),_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430')),_react2.default.createElement('h1',null,'\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430'),_react2.default.createElement('iframe',{className:'stats-iframe',name:'stat',src:'https://zenitbet.sportstats.pro/soccer/?ref=54321'}));}}]);return Line;}(_react.Component);exports.default=Line;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _toto=__webpack_require__(600);var _toto2=_interopRequireDefault(_toto);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @observer
var TotoPage=function(_Component){_inherits(TotoPage,_Component);function TotoPage(){_classCallCheck(this,TotoPage);return _possibleConstructorReturn(this,(TotoPage.__proto__||Object.getPrototypeOf(TotoPage)).apply(this,arguments));}_createClass(TotoPage,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'toto-page'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0422\u043E\u0442\u043E')),_react2.default.createElement('div',{className:'toto-page__body'},_react2.default.createElement(_toto2.default,null)));}}]);return TotoPage;}(_react.Component);exports.default=TotoPage;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _toto=__webpack_require__(601);var _toto2=_interopRequireDefault(_toto);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TotoContainer=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(TotoContainer,_Component);function TotoContainer(){_classCallCheck(this,TotoContainer);return _possibleConstructorReturn(this,(TotoContainer.__proto__||Object.getPrototypeOf(TotoContainer)).apply(this,arguments));}_createClass(TotoContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Toto.init();}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Toto=_props$totoStore.Toto;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'blue_line'},_react2.default.createElement(_underHeader2.default,{type:2})),!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Toto.data?_react2.default.createElement(_toto2.default,null):_react2.default.createElement('div',{className:'toto-index-no'},getLang('NO_ACTIVE_DRAWS_AT_THE_MOMENT'))));}}]);return TotoContainer;}(_react.Component))||_class)||_class);exports.default=TotoContainer;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5,_dec4,_class7;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _sprintfJs=__webpack_require__(205);var _common=__webpack_require__(6);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=(_dec=(0,_mobxReact.inject)('totoStore','dictStore','appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.selectCurrency=function(e){_this.props.totoStore.Toto.selectCurrency(e.target.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:'render',value:function render(){var _props$totoStore$Toto=this.props.totoStore.Toto,data=_props$totoStore$Toto.data,currencyId=_props$totoStore$Toto.currencyId,currency=_props$totoStore$Toto.currency,showWarning=_props$totoStore$Toto.showWarning;var cashboxMode=this.props.appStore.cashboxMode;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'toto-index-top-data'},_react2.default.createElement('div',{className:'toto-index-row'},cashboxMode===2?_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement(_reactRouterDom.Link,{to:'/rules#r3'},getLang('RULES'))):null,_react2.default.createElement('div',null,_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/previous'},getLang('PREVIOUS_DRAWS')))),_react2.default.createElement('div',{className:'toto-index-row clearfix'},_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},Object.keys(data.currency).map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);}))),showWarning?_react2.default.createElement('div',{className:'toto-index-currency-warning'},getLang('MAKE_BET_POSSIBLE_ONLY_IN_ACCOUNT_CURRENCY')):'')),_react2.default.createElement('div',{className:'toto-index-row'},_react2.default.createElement('div',{className:'toto-index-current-text'},_react2.default.createElement('div',{className:'fl_r'},getLang('DEADLINE_FOR_BETS_LC'),': ',_react2.default.createElement('span',null,data.date.close)),_react2.default.createElement('div',{className:'toto-index-current'},getLang("DRAW"),' #R-',data.number,', ',data.date.start,' - ',data.date.end)),_react2.default.createElement('div',{className:'toto-index-jackpot'},_react2.default.createElement('span',{className:'toto-index-jackpot-text'},getLang('JACKPOT')),data.jackpot[currencyId]?_react2.default.createElement('span',null,' ',data.jackpot[currencyId],' ',currency.name):_react2.default.createElement('span',null,' ',getLang('BET_RESULT_EXPECTED'))),_react2.default.createElement('div',{className:'toto-index-current-data clearfix'},_react2.default.createElement('div',{className:'fl_r'},getLang('AS_OF_LC'),': ',data.date.now,' '),_react2.default.createElement('div',{className:'toto-index-pool fl_l'},_react2.default.createElement('span',{className:'toto-index-pool-text'},getLang('POOL')),' ',_react2.default.createElement('span',null,data.pool[currencyId],' ',currency.name)),_react2.default.createElement('div',{className:'toto-index-bet-count fl_l'},_react2.default.createElement('span',{className:'toto-index-bet-count-text'},getLang('BETS_OF')),' ',_react2.default.createElement('span',{id:'toto-bet-count'},data.bets_count)),_react2.default.createElement('div',{className:'toto-index-option-count fl_l'},_react2.default.createElement('span',{className:'toto-index-option-count-text'},getLang('OPTIONS_OF'),':'),' ',_react2.default.createElement('span',null,data.cards_count)))),_react2.default.createElement('div',{className:'toto-index-row clearfix'},_react2.default.createElement('div',{className:'toto-index-row toto-index-row-previous clearfix'},_react2.default.createElement('div',{style:{marginTop:'4px'}},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/result/'+data.previous.id},' ',getLang('PREVIOUS_DRAW'),'  \u2116',data.previous.number),' - ',getLang('MAXIMUM_GUESSED_RESULTS'),' - ',data.previous.guessed,' '))));}}]);return Header;}(_react.Component))||_class)||_class);var Footer=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Footer,_Component2);function Footer(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,Footer);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=Footer.__proto__||Object.getPrototypeOf(Footer)).call.apply(_ref2,[this].concat(args))),_this2),_this2.state={isDisabledBetButton:false},_this2.clear=function(){_this2.props.totoStore.Toto.clearAll();},_this2.random=function(){_this2.props.totoStore.Toto.random(1);},_this2.random2=function(){_this2.props.totoStore.Toto.random();},_this2.handleChange=function(val){_this2.props.totoStore.Toto.inputAmount(val);},_this2.copy=function(){_this2.props.totoStore.Toto.copy();},_this2.dobet=function(){_this2.setState({isDisabledBetButton:true});_this2.props.totoStore.Toto.dobet().then(function(){_this2.setState({isDisabledBetButton:false});});},_this2.hideResult=function(){_this2.props.totoStore.clearResult();},_this2.hideSuccess=function(){_this2.props.totoStore.Toto.hideSuccess();},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(Footer,[{key:'render',value:function render(){var result=this.props.totoStore.result;var _props$totoStore$Toto2=this.props.totoStore.Toto,data=_props$totoStore$Toto2.data,currencyId=_props$totoStore$Toto2.currencyId,currency=_props$totoStore$Toto2.currency,amount=_props$totoStore$Toto2.amount,count=_props$totoStore$Toto2.count,success=_props$totoStore$Toto2.success,minAmount=_props$totoStore$Toto2.minAmount;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'toto-index-controls clearfix'},_react2.default.createElement('div',{className:'toto-index-controls-item'},_react2.default.createElement('div',{className:'fl_r buttons'},_react2.default.createElement('button',{type:'button',id:'toto-clear',className:'flat_button button_fixed_width',onClick:this.clear},getLang('CLEAR'))),_react2.default.createElement('div',{className:'toto-index-controls-label fl_l'},getLang('SELECTION_OF_OUTCOMES'),':'),_react2.default.createElement('div',{className:'toto-index-controls-data toto-index-controls-button'},_react2.default.createElement('button',{type:'button',className:'flat_button button_fixed_width',onClick:this.random},getLang('ALL')),_react2.default.createElement('button',{type:'button',className:'flat_button button_fixed_width',onClick:this.random2},getLang('UNSELECTED')))),_react2.default.createElement('div',{className:'toto-index-dobet-cont fl_r'},_react2.default.createElement('button',{type:'button',className:'flat_button button_fixed_width',onClick:this.dobet,disabled:this.state.isDisabledBetButton},getLang('MAKE_BET'))),_react2.default.createElement('div',{className:'toto-index-controls-item toto-index-controls-item-1 fl_l'},_react2.default.createElement('div',{className:'toto-index-controls-label fl_l'},getLang('OPTIONS_SELECTED'),':'),_react2.default.createElement('div',{className:'toto-index-controls-data toto-index-controls-text'},_react2.default.createElement('span',null,count))),_react2.default.createElement('div',{className:'toto-index-controls-item toto-index-controls-item-2 fl_l'},_react2.default.createElement('div',{className:'toto-index-controls-label fl_l'},getLang('AMOUNT_FOR_1_OPTION'),':'),_react2.default.createElement('div',{className:'toto-index-controls-data toto-index-controls-text'},_react2.default.createElement('div',{className:'fl_l toto-amount-per-option'},(0,_common.numberFormat)(amount.per_option,2,',',' ')),_react2.default.createElement('div',{className:'fl_l'},currency.name))),_react2.default.createElement('div',{className:'toto-index-controls-item toto-index-controls-item-1 fl_l'},_react2.default.createElement('div',{className:'toto-index-controls-label fl_l'},getLang('MINIMUM_AMOUNT'),':'),_react2.default.createElement('div',{className:'toto-index-controls-data toto-index-controls-text'},_react2.default.createElement('a',{onClick:this.copy},(0,_common.numberFormat)(amount.min,2,',',' ')),_react2.default.createElement('span',null,' ',currency.name))),_react2.default.createElement('div',{className:'toto-index-controls-item toto-index-controls-item-2 fl_l'},_react2.default.createElement('div',{className:'toto-index-controls-label fl_l'},getLang('BET_AMOUNT'),':'),_react2.default.createElement('div',{className:'toto-index-controls-data toto-index-controls-input'},_react2.default.createElement('label',null,_react2.default.createElement(_keyboardInput2.default,{id:'toto-amount',type:'text',className:'input toto-index-amount',maxLength:6,onChange:this.handleChange,value:amount.current?amount.current:'',autoComplete:'off',positionX:'right',positionY:'top'})),_react2.default.createElement('span',null,' ',currency.name)))),result.status?_react2.default.createElement(_message2.default,{text:result.text,onClose:this.hideResult}):'',success?_react2.default.createElement('div',{'class':'result-container'},_react2.default.createElement('div',{'class':'result-close right',onClick:this.hideSuccess}),_react2.default.createElement('div',{'class':'result-text'},getLang('BET'),' ',_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/bet/'+success.id},success.number),' ',(0,_sprintfJs.sprintf)(getLang('IRM_TOTO_DOBET_SUCCESS_1'),success.count,success.amount))):'',_react2.default.createElement('div',{className:'toto-course-cont clearfix'},_react2.default.createElement('div',{className:'fl_l toto-course-text'},getLang('MINIMUM_RATES_FOR_CURRENT_TOTO'),':'),_react2.default.createElement('div',{className:'fl_l'},_react2.default.createElement('ul',{className:'toto-course-list'},Object.keys(data.currency).map(function(id){return _react2.default.createElement('li',{key:'cur_'+id,className:'fl_l'},data.currency[id].min_str,' ',data.currency[id].name);})))));}}]);return Footer;}(_react.Component))||_class3)||_class3);var List=(_dec3=(0,_mobxReact.inject)('totoStore','dictStore'),_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(List,_Component3);function List(){var _ref3;var _temp3,_this3,_ret3;_classCallCheck(this,List);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this3=_possibleConstructorReturn(this,(_ref3=List.__proto__||Object.getPrototypeOf(List)).call.apply(_ref3,[this].concat(args))),_this3),_this3.checkOdd=function(id,el,indx){var v=el?0:1;_this3.props.totoStore.Toto.checkOdd(id,v,indx,1);},_temp3),_possibleConstructorReturn(_this3,_ret3);}_createClass(List,[{key:'render',value:function render(){var _this4=this;var _props$totoStore$Toto3=this.props.totoStore.Toto,data=_props$totoStore$Toto3.data,list=_props$totoStore$Toto3.list;var getLang=this.props.dictStore.getLang;var number=0;return _react2.default.createElement('div',{className:'toto-table-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{rowSpan:'2'},'#'),_react2.default.createElement('th',{rowSpan:'2'},getLang('DATE')),_react2.default.createElement('th',{rowSpan:'2',colSpan:'2'},getLang('EVENT')),_react2.default.createElement('th',{colSpan:'3'},getLang('OUTCOME')),_react2.default.createElement('th',{colSpan:'3'},getLang('POOL_DISTRIBUTION'))),_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'1'),_react2.default.createElement('th',null,'X'),_react2.default.createElement('th',null,'2'),_react2.default.createElement('th',null,'1'),_react2.default.createElement('th',null,'X'),_react2.default.createElement('th',null,'2'))),_react2.default.createElement('tbody',null,Object.keys(data.sport).map(function(sid){var league=data.sport[sid].league;return league.map(function(lid){return _react2.default.createElement(_react.Fragment,{key:'tr_'+lid},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-table-league-name',colSpan:'10'},data.dict.sport[sid],'. ',data.dict.league[lid])),data.league[lid].games.map(function(gid,idx){++number;return _react2.default.createElement('tr',{className:'toto-index-game',key:'td_'+gid},_react2.default.createElement('td',{className:'toto-table-id'},number),_react2.default.createElement('td',{className:'toto-table-date'},data.games[gid].date),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c1_id]),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c2_id]),list.get(gid).o.map(function(el,indx){return _react2.default.createElement('td',{key:'check_'+indx,className:'toto-table-checkbox'},_react2.default.createElement('div',{className:'toto-index-checkbox checkbox'+(el?' on':''),onClick:function onClick(){return _this4.checkOdd(gid,el,indx);}},_react2.default.createElement('span',null)));}),_react2.default.createElement('td',{className:'toto-table-pool-d'+(list.get(gid).o[0]?' toto-index-table-pool-d-selected':'')},data.games[gid].percent_1,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'+(list.get(gid).o[1]?' toto-index-table-pool-d-selected':'')},data.games[gid].percent_X,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'+(list.get(gid).o[2]?' toto-index-table-pool-d-selected':'')},data.games[gid].percent_2,'%'));}));});}))));}}]);return List;}(_react.Component))||_class5)||_class5);var TotoContainer=(_dec4=(0,_mobxReact.inject)('totoStore','dictStore'),_dec4(_class7=(0,_mobxReact.observer)(_class7=function(_Component4){_inherits(TotoContainer,_Component4);function TotoContainer(){_classCallCheck(this,TotoContainer);return _possibleConstructorReturn(this,(TotoContainer.__proto__||Object.getPrototypeOf(TotoContainer)).apply(this,arguments));}_createClass(TotoContainer,[{key:'render',value:function render(){var _props$totoStore$Toto4=this.props.totoStore.Toto,data=_props$totoStore$Toto4.data,list=_props$totoStore$Toto4.list;var getLang=this.props.dictStore.getLang;var number=0;return _react2.default.createElement('div',{className:'toto-index'},_react2.default.createElement(Header,null),_react2.default.createElement(List,null),_react2.default.createElement(Footer,null));}}]);return TotoContainer;}(_react.Component))||_class7)||_class7);exports.default=TotoContainer;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _bet=__webpack_require__(603);var _bet2=_interopRequireDefault(_bet);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @withRouter
var BetPage=function(_Component){_inherits(BetPage,_Component);function BetPage(){_classCallCheck(this,BetPage);return _possibleConstructorReturn(this,(BetPage.__proto__||Object.getPrototypeOf(BetPage)).apply(this,arguments));}_createClass(BetPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"toto-page"},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement("title",null,"\u0418\u0420\u041C - \u041A\u0430\u0440\u0442\u043E\u0447\u043A\u0430 \u0442\u043E\u0442\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440\u0430")),_react2.default.createElement("div",{className:"toto-page__body"},_react2.default.createElement(_bet2.default,null)));}}]);return BetPage;}(_react.Component);exports.default=BetPage;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetContainer=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(BetContainer,_Component);function BetContainer(){_classCallCheck(this,BetContainer);return _possibleConstructorReturn(this,(BetContainer.__proto__||Object.getPrototypeOf(BetContainer)).apply(this,arguments));}_createClass(BetContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Bet.init(this.props.match.params.betId);}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Bet=_props$totoStore.Bet;var getLang=this.props.dictStore.getLang;return!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Bet.data?_react2.default.createElement(TotoBet,null):_react2.default.createElement('div',{className:'toto-index-no'},getLang('INVALID_CARD_ID')));}}]);return BetContainer;}(_react.Component))||_class)||_class)||_class);exports.default=BetContainer;var TotoBet=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore','appStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(TotoBet,_Component2);function TotoBet(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,TotoBet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=TotoBet.__proto__||Object.getPrototypeOf(TotoBet)).call.apply(_ref,[this].concat(args))),_this2),_this2.selectCurrency=function(e){_this2.props.totoStore.selectCurrency(e.target.value);},_this2.goBack=function(){_this2.props.appStore.history.goBack();},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(TotoBet,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$totoStore2=this.props.totoStore,currency=_props$totoStore2.currency,currencyId=_props$totoStore2.currencyId,current=_props$totoStore2.current;var data=this.props.totoStore.Bet.data;var cashboxMode=this.props.appStore.cashboxMode;var number=0;var options=['1','X','2'];return _react2.default.createElement('div',{className:'toto-bet'},_react2.default.createElement('h1',{className:'hidden'},getLang('TOTO_CARD')),_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},Object.keys(data.currency).map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);}))),_react2.default.createElement('div',{className:'toto-bet-back'},_react2.default.createElement('a',{className:'back',onClick:this.goBack},'\u041D\u0430\u0437\u0430\u0434'))),_react2.default.createElement('div',{className:'toto-bet-header clearfix'},data.pool.length?_react2.default.createElement('div',{className:'toto-bet-pool-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,getLang('GUESSED_RESULT')),_react2.default.createElement('th',null,getLang('BET_COUNT')),_react2.default.createElement('th',null,getLang('AMOUNT')))),_react2.default.createElement('tbody',null,data.pool.map(function(el){return _react2.default.createElement('tr',{key:el.guessed},_react2.default.createElement('td',{className:'toto-table-guessed'},el.guessed),_react2.default.createElement('td',{className:'toto-table-count'},el.count),_react2.default.createElement('td',{className:'toto-bet-table-amount'},_react2.default.createElement('span',null,(0,_common.numberFormat)(el.amount[currencyId],2,',',' '))));})))):'',_react2.default.createElement('div',{className:'toto-bet-data'},_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},cashboxMode===2?getLang('COUPON_FOR_SUPER_EXPRESS'):getLang('COUPON_FOR_TOTO'),' \u2116'),_react2.default.createElement('div',{className:'toto-bet-row-data'},data.code)),_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},getLang('RECEPTION_TIME')),_react2.default.createElement('div',{className:'toto-bet-row-data'},data.date)),_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},getLang('BET_COUNT')),_react2.default.createElement('div',{className:'toto-bet-row-data'},data.bet_count)),data.status!=1?_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},getLang('MAX_GUESSED_RESULTS')),_react2.default.createElement('div',{className:'toto-bet-row-data'},data.option_guessed)):'',_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},getLang('AMOUNT')),_react2.default.createElement('div',{className:'toto-bet-row-data'},_react2.default.createElement('span',null,(0,_common.numberFormat)(data.amount.set[currencyId],2,',',' '),' ',current.name))),data.status==1?_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'}),_react2.default.createElement('div',{className:'toto-bet-row-data'},getLang('RESULT_EXPECTED'))):_react2.default.createElement('div',{className:'toto-bet-row clearfix'},_react2.default.createElement('div',{className:'toto-bet-row-label fl_l'},getLang('PAYOUT')),_react2.default.createElement('div',{className:'toto-bet-row-data'},_react2.default.createElement('span',null,(0,_common.numberFormat)(data.amount.win[currencyId],2,',',' '),' ',current.name))))),_react2.default.createElement('div',{className:'toto-bet-table-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'\u2116'),_react2.default.createElement('th',null,getLang('DATE')),_react2.default.createElement('th',{colSpan:'2'},getLang('EVENT')),_react2.default.createElement('th',{colSpan:'3'},getLang('OUTCOME')),_react2.default.createElement('th',null,getLang('RESULT')))),_react2.default.createElement('tbody',null,Object.keys(data.sport).map(function(sid){var league=data.sport[sid].league;return league.map(function(lid){return _react2.default.createElement(_react.Fragment,{key:'tr_'+lid},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-table-league-name',colSpan:'10'},data.dict.sport[sid],'. ',data.dict.league[lid])),data.league[lid].games.map(function(gid,idx){++number;return _react2.default.createElement('tr',{className:'toto-index-game',key:'td_'+gid},_react2.default.createElement('td',{className:'toto-table-id'},number),_react2.default.createElement('td',{className:'toto-table-date'},data.games[gid].date),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c1_id]),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c2_id]),options.map(function(el){return _react2.default.createElement('td',{key:el,className:'toto-table-option'+(data.status!=1&&data.games[gid].option[el].b?data.games[gid].option[el].g?' toto-table-option-guessed':' toto-table-option-not-guessed':'')},data.games[gid].option[el].b?el:'');}),_react2.default.createElement('td',{className:'toto-table-score'},data.games[gid].status===2?getLang('CALCELLED'):data.games[gid].status===1?data.games[gid].score!='{{ NO }}'?data.games[gid].score:'':getLang('NO')));}));});})))));}}]);return TotoBet;}(_react.Component))||_class2)||_class2);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _result=__webpack_require__(605);var _result2=_interopRequireDefault(_result);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @withRouter
var ResultPage=function(_Component){_inherits(ResultPage,_Component);function ResultPage(){_classCallCheck(this,ResultPage);return _possibleConstructorReturn(this,(ResultPage.__proto__||Object.getPrototypeOf(ResultPage)).apply(this,arguments));}_createClass(ResultPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"toto-page"},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement("title",null,"\u0418\u0420\u041C - \u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u043E\u0437\u0438\u0433\u0440\u044B\u0448")),_react2.default.createElement("div",{className:"toto-page__body"},_react2.default.createElement(_result2.default,null)));}}]);return ResultPage;}(_react.Component);exports.default=ResultPage;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Result=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Result,_Component);function Result(){_classCallCheck(this,Result);return _possibleConstructorReturn(this,(Result.__proto__||Object.getPrototypeOf(Result)).apply(this,arguments));}_createClass(Result,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Result.init(this.props.match.params.resultId);}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Result=_props$totoStore.Result;var getLang=this.props.dictStore.getLang;return!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Result.data?_react2.default.createElement(TotoResult,null):_react2.default.createElement('div',{className:'toto-index-no'},getLang('INVALID_RESULT_ID')));}}]);return Result;}(_react.Component))||_class)||_class)||_class);exports.default=Result;var TotoResult=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore','appStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(TotoResult,_Component2);function TotoResult(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,TotoResult);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=TotoResult.__proto__||Object.getPrototypeOf(TotoResult)).call.apply(_ref,[this].concat(args))),_this2),_this2.selectCurrency=function(e){_this2.props.totoStore.selectCurrency(e.target.value);},_this2.goBack=function(){_this2.props.appStore.history.goBack();},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(TotoResult,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$totoStore2=this.props.totoStore,currency=_props$totoStore2.currency,currencyId=_props$totoStore2.currencyId,current=_props$totoStore2.current;var data=this.props.totoStore.Result.data;var number=0;var keysAllloc=Object.keys(data.prize_alloc);return _react2.default.createElement('div',{className:'toto-result'},_react2.default.createElement('div',{className:'toto-result-currency clearfix'},_react2.default.createElement('a',{className:'back',onClick:this.goBack,href:'#'},getLang('BACK')),_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},Object.keys(data.currency).map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);})))),_react2.default.createElement('div',{className:'toto-result-draw-data'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{colSpan:'2'},getLang("DRAW"),' #R-',data.number,', ',data.date.start,' - ',data.date.end))),_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-result-draw-table-label'},getLang('POOL')),_react2.default.createElement('td',{className:'toto-result-draw-table-data'},_react2.default.createElement('span',{id:'toto-result-pool'},(0,_common.numberFormat)(data.pool[currencyId],2,',',' '),' ',current.name))),_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-result-draw-table-label'},getLang('PRIZE_FUND')),_react2.default.createElement('td',{className:'toto-result-draw-table-data'},_react2.default.createElement('span',{id:'toto-result-prize'},(0,_common.numberFormat)(data.prize[currencyId],2,',',' '),' ',current.name))),_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-result-draw-table-label'},getLang('BET_COUNT')),_react2.default.createElement('td',{className:'toto-result-draw-table-data'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cardsall/'+data.id},data.cards_count))),keysAllloc.length?_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-result-draw-table-label'},getLang('HAS_WON_OPTIONS')),_react2.default.createElement('td',{className:'toto-result-draw-table-data'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cards/'+data.id},data.cards_win))):'',_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-result-draw-table-label'},getLang('JACKPOT')),_react2.default.createElement('td',{className:'toto-result-draw-table-data'},_react2.default.createElement('span',{id:'toto-result-jackpot'},(0,_common.numberFormat)(data.jackpot[currencyId],2,',',' '),' ',current.name)))))),keysAllloc.length?_react2.default.createElement('div',{className:'toto-result-prize-allocation-cont clearfix'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{colSpan:'4'},getLang('PRIZE_FUND_DISTRIBUTION'))),_react2.default.createElement('tr',null,_react2.default.createElement('th',null,getLang('GUESSED_RESULT')),_react2.default.createElement('th',null,getLang('OPTIONS_OF')),_react2.default.createElement('th',null,getLang('AMOUNT')),_react2.default.createElement('th',null,getLang('COMMENT')))),_react2.default.createElement('tbody',null,Object.keys(data.prize_alloc).map(function(el){return _react2.default.createElement('tr',{key:el},_react2.default.createElement('td',{className:'toto-result-table-guessed'},data.prize_alloc[el].guessed),_react2.default.createElement('td',{className:'toto-result-table-option'},data.prize_alloc[el].cards_win>0?_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cards/'+data.id+'/'+data.prize_alloc[el].guessed},data.prize_alloc[el].cards_win):getLang('NO')),_react2.default.createElement('td',{className:'toto-result-table-amount'},_react2.default.createElement('span',null,(0,_common.numberFormat)(data.prize_alloc[el].amount[currencyId],2,',',' '),' ',current.name)),_react2.default.createElement('td',{className:'toto-result-table-comment'},data.prize_alloc[el].win==0?getLang('TO_JACKPOT'):''));})))):'',_react2.default.createElement('div',{className:'toto-result-games-cont'},_react2.default.createElement('table',{className:'toto-table',border:'1'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{rowSpan:'2'},'\u2116'),_react2.default.createElement('th',{rowSpan:'2'},getLang('DATE')),_react2.default.createElement('th',{rowSpan:'2',colSpan:'2'},getLang('EVENT')),_react2.default.createElement('th',{colSpan:'3'},getLang('POOL_DISTRIBUTION')),_react2.default.createElement('th',{rowSpan:'2'},getLang('RESULT'))),_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'1'),_react2.default.createElement('th',null,'X'),_react2.default.createElement('th',null,'2'))),_react2.default.createElement('tbody',null,Object.keys(data.sport).map(function(sid){var league=data.sport[sid].league;return league.map(function(lid){return _react2.default.createElement(_react.Fragment,{key:'tr_'+lid},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-table-league-name',colSpan:'10'},data.dict.sport[sid],'. ',data.dict.league[lid])),data.league[lid].games.map(function(gid,idx){++number;return _react2.default.createElement('tr',{className:'toto-index-game',key:'td_'+gid},_react2.default.createElement('td',{className:'toto-table-id'},number),_react2.default.createElement('td',{className:'toto-table-date'},data.games[gid].date),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c1_id]),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c2_id]),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_1,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_X,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_2,'%'),_react2.default.createElement('td',{className:'toto-table-score'},data.games[gid].score&&data.games[gid].score!='{{ NO }}'?getLang(data.games[gid].score):getLang('NO')));}));});})))),_react2.default.createElement('div',{className:'toto-course-cont clearfix'},_react2.default.createElement('div',{className:'fl_l toto-course-text'},getLang('MINIMUM_RATES_FOR_CURRENT_TOTO'),':'),_react2.default.createElement('div',{className:'fl_l'},_react2.default.createElement('ul',{className:'toto-course-list'},Object.keys(data.currency).map(function(id){return _react2.default.createElement('li',{key:'cur_'+id,className:'fl_l'},data.currency[id].min,' ',data.currency[id].name);})))));}}]);return TotoResult;}(_react.Component))||_class2)||_class2);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _cards=__webpack_require__(607);var _cards2=_interopRequireDefault(_cards);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @withRouter
var CardsPage=function(_Component){_inherits(CardsPage,_Component);function CardsPage(){_classCallCheck(this,CardsPage);return _possibleConstructorReturn(this,(CardsPage.__proto__||Object.getPrototypeOf(CardsPage)).apply(this,arguments));}_createClass(CardsPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"toto-page"},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement("title",null,"\u0418\u0420\u041C - \u041A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u0442\u043E\u0442\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440\u0430")),_react2.default.createElement("div",{className:"toto-page__body"},_react2.default.createElement(_cards2.default,null)));}}]);return CardsPage;}(_react.Component);exports.default=CardsPage;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cards=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Cards,_Component);function Cards(){_classCallCheck(this,Cards);return _possibleConstructorReturn(this,(Cards.__proto__||Object.getPrototypeOf(Cards)).apply(this,arguments));}_createClass(Cards,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Cards.init(this.props.match.params);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.totoStore.Cards.dispose();}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Cards=_props$totoStore.Cards;var getLang=this.props.dictStore.getLang;return!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Cards.data?_react2.default.createElement(TotoCards,null):_react2.default.createElement('div',{className:'toto-index-no'},getLang('INVALID_RESULT_ID')));}}]);return Cards;}(_react.Component))||_class)||_class)||_class);exports.default=Cards;var TotoCards=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore','appStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(TotoCards,_Component2);function TotoCards(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,TotoCards);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=TotoCards.__proto__||Object.getPrototypeOf(TotoCards)).call.apply(_ref,[this].concat(args))),_this2),_this2.selectCurrency=function(e){_this2.props.totoStore.selectCurrency(e.target.value);},_this2.selectPage=function(page){_this2.props.totoStore.Cards.selectPage(page);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(TotoCards,[{key:'render',value:function render(){var _this3=this;var getLang=this.props.dictStore.getLang;var _props$totoStore2=this.props.totoStore,currency=_props$totoStore2.currency,currencyId=_props$totoStore2.currencyId,current=_props$totoStore2.current;var _props$totoStore$Card=this.props.totoStore.Cards,data=_props$totoStore$Card.data,vc=_props$totoStore$Card.vc,page=_props$totoStore$Card.page,pages=_props$totoStore$Card.pages,count=_props$totoStore$Card.count,cards=_props$totoStore$Card.cards,isLoading=_props$totoStore$Card.isLoading;var min=count*page+1;var max=(page+1)*count;var arrCurrency=data.currency?Object.keys(data.currency):[this.props.appStore.financeData[currencyId]];return _react2.default.createElement('div',{className:'toto-cards'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},data.currency?arrCurrency.map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);}):arrCurrency.map(function(el){return _react2.default.createElement('option',{key:el.id,value:el.id,selected:el.id==currencyId},el.full_name);}))),_react2.default.createElement('div',{className:'toto-cards-back'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/result/'+data.id},getLang('DETAILED_RESULTS_OF_DRAW')))),_react2.default.createElement('div',null,_react2.default.createElement('div',null,getLang("DRAW"),' #R-',data.number,', ',data.date.start,' - ',data.date.end),vc>=9?getLang('BETS_CONTAINING_OPTIONS_WITH_GUESSED_RESULTS_1')+vc+getLang('BETS_CONTAINING_OPTIONS_WITH_GUESSED_RESULTS_2'):getLang('BETS_CONTAINING_WINNING_OPTIONS')),_react2.default.createElement('div',{className:'toto-cards-nav-cont clearfix'},pages.map(function(el){return _react2.default.createElement('div',{key:'nav_'+el.i},_react2.default.createElement('a',{className:'toto-cards-nav-page-a fl_l'+(page==el.i?' toto-cards-nav-page-a-selected':''),onClick:function onClick(){return _this3.selectPage(el.i);}},el.i+1));})),_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'fl_r'},getLang('BETS'),' ',_react2.default.createElement('span',null,min),' - ',_react2.default.createElement('span',null,max>data.count?data.count:max))),_react2.default.createElement('div',{className:'toto-cards-table-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,getLang('CARD')),_react2.default.createElement('th',null,getLang('AMOUNT')),_react2.default.createElement('th',null,getLang('OPTIONS')),_react2.default.createElement('th',null,getLang('AMOUNT_FOR_1_OPTION')),_react2.default.createElement('th',null,getLang('MAX_GUESSED')),_react2.default.createElement('th',null,getLang('PAYOUT')))),_react2.default.createElement('tbody',null,isLoading?_react2.default.createElement('tr',null,_react2.default.createElement('td',{colspan:'6',className:'toto-cards-loading'},getLang('LOADING'),'...')):Object.keys(cards[page]).map(function(i){return _react2.default.createElement('tr',{key:cards[page][i].id},_react2.default.createElement('td',{className:'toto-cards-table-number'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/bet/'+cards[page][i].id},cards[page][i].code)),_react2.default.createElement('td',{className:'toto-cards-table-set'},(0,_common.numberFormat)(cards[page][i].set[currencyId],2,',',' '),' ',current.name),_react2.default.createElement('td',{className:'toto-cards-table-option'},cards[page][i].option_count),_react2.default.createElement('td',{className:'toto-cards-table-option-set'},(0,_common.numberFormat)(cards[page][i].set_per_bet[currencyId],2,',',' '),' ',current.name),_react2.default.createElement('td',{className:'toto-cards-table-option-guessed'},cards[page][i].guessed),_react2.default.createElement('td',{className:'toto-cards-table-win'},(0,_common.numberFormat)(cards[page][i].win[currencyId],2,',',' '),' ',current.name));})))));}}]);return TotoCards;}(_react.Component))||_class2)||_class2);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _previous=__webpack_require__(609);var _previous2=_interopRequireDefault(_previous);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @withRouter
var PreviousPage=function(_Component){_inherits(PreviousPage,_Component);function PreviousPage(){_classCallCheck(this,PreviousPage);return _possibleConstructorReturn(this,(PreviousPage.__proto__||Object.getPrototypeOf(PreviousPage)).apply(this,arguments));}_createClass(PreviousPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"toto-page"},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement("title",null,"\u0418\u0420\u041C - \u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 \u0440\u043E\u0437\u044B\u0433\u0440\u044B\u0448\u0438")),_react2.default.createElement("div",{className:"toto-page__body"},_react2.default.createElement(_previous2.default,null)));}}]);return PreviousPage;}(_react.Component);exports.default=PreviousPage;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Previous=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Previous,_Component);function Previous(){_classCallCheck(this,Previous);return _possibleConstructorReturn(this,(Previous.__proto__||Object.getPrototypeOf(Previous)).apply(this,arguments));}_createClass(Previous,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Previous.init();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.totoStore.Previous.dispose();}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Previous=_props$totoStore.Previous;var getLang=this.props.dictStore.getLang;return!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Previous.data?_react2.default.createElement(TotoPrevious,null):_react2.default.createElement(_message2.default,{text:result.text}));}}]);return Previous;}(_react.Component))||_class)||_class)||_class);exports.default=Previous;var TotoPrevious=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(TotoPrevious,_Component2);function TotoPrevious(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,TotoPrevious);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=TotoPrevious.__proto__||Object.getPrototypeOf(TotoPrevious)).call.apply(_ref,[this].concat(args))),_this2),_this2.selectCurrency=function(e){_this2.props.totoStore.selectCurrency(e.target.value);},_this2.selectYear=function(v){_this2.props.totoStore.Previous.selectYear(v);},_this2.selectMonth=function(v){_this2.props.totoStore.Previous.selectMonth(v);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(TotoPrevious,[{key:'render',value:function render(){var _this3=this;var getLang=this.props.dictStore.getLang;var _props$totoStore2=this.props.totoStore,currency=_props$totoStore2.currency,currencyId=_props$totoStore2.currencyId,current=_props$totoStore2.current;var _props$totoStore$Prev=this.props.totoStore.Previous,data=_props$totoStore$Prev.data,selected=_props$totoStore$Prev.selected,draw=_props$totoStore$Prev.draw;return _react2.default.createElement('div',{className:'toto-previous'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},Object.keys(data.currency).map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);}))),_react2.default.createElement('nav',null,_react2.default.createElement('ul',{className:'toto-previous-year-list clearfix'},Object.keys(data.date_menu).reverse().map(function(item){return _react2.default.createElement('li',{key:item,className:'toto-previous-year fl_l'+(selected.year==item?' toto-previous-year-selected':'')},_react2.default.createElement('a',{className:'toto-previous-year-a',href:'#',onClick:function onClick(){return _this3.selectYear(item);}},item));})),_react2.default.createElement('ul',{className:'toto-previous-month-list clearfix'},Object.keys(data.date_menu[selected.year]).map(function(item){return _react2.default.createElement('li',{key:item,className:'toto-previous-month fl_l'+(item==selected.month?' toto-previous-month-selected':'')},_react2.default.createElement('a',{className:'toto-previous-month-a',href:'#',onClick:function onClick(){return _this3.selectMonth(item);}},getLang('MONTH'+item)));})))),_react2.default.createElement('div',{className:'toto-previous-table-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'\u2116'),_react2.default.createElement('th',null,getLang('START_DATE')),_react2.default.createElement('th',null,getLang('JACKPOT')),_react2.default.createElement('th',null,getLang('POOL')),_react2.default.createElement('th',null,getLang('BETS')),_react2.default.createElement('th',null,getLang('OPTIONS')),_react2.default.createElement('th',null,getLang('HAS_WON')),_react2.default.createElement('th',null,getLang('MAX_GUESSED')),_react2.default.createElement('th',null,getLang('NOTE')))),_react2.default.createElement('tbody',{className:'toto-previous-no-draws'},_react2.default.createElement(Rows,null)))));}}]);return TotoPrevious;}(_react.Component))||_class2)||_class2);var Rows=(_dec3=(0,_mobxReact.inject)('totoStore','dictStore'),_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Rows,_Component3);function Rows(){_classCallCheck(this,Rows);return _possibleConstructorReturn(this,(Rows.__proto__||Object.getPrototypeOf(Rows)).apply(this,arguments));}_createClass(Rows,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$totoStore3=this.props.totoStore,currencyId=_props$totoStore3.currencyId,current=_props$totoStore3.current;var _props$totoStore$Prev2=this.props.totoStore.Previous,draw=_props$totoStore$Prev2.draw,data=_props$totoStore$Prev2.data;return _react2.default.createElement(_react.Fragment,null,!draw?_react2.default.createElement('tr',null,_react2.default.createElement('td',{colSpan:'9'},getLang('NO_DRAWS_FOR_CURRENT_PERIOD'))):draw.map(function(item){var el=data.draws[item];return _react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-previous-table-id'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/result/'+el.id},el.number)),_react2.default.createElement('td',{className:'toto-table-date'},el.date),_react2.default.createElement('td',{className:'toto-previous-table-jackpot'},(0,_common.numberFormat)(el.jackpot[currencyId],2,',',' '),' ',current.name),_react2.default.createElement('td',{className:'toto-previous-table-pool'},(0,_common.numberFormat)(el.pool[currencyId],2,',',' '),' ',current.name),_react2.default.createElement('td',{className:'toto-previous-table-count-set'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cardsall/'+el.id},el.cards_count.set)),_react2.default.createElement('td',{className:'toto-previous-table-option-count'},el.bets_count.total),_react2.default.createElement('td',{className:'toto-previous-table-count-win'},el.cards_count.win?_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cards/'+el.id},el.cards_count.win):el.cards_count.win),_react2.default.createElement('td',{className:'toto-previous-table-option-guessed'},el.bets_count.guessed?_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/cards/'+el.id+'/'+el.bets_count.guessed},el.bets_count.guessed):el.bets_count.guessed),_react2.default.createElement('td',{className:'toto-previous-table-table-comment'},el.comment_id>0?getLang('TOTO_PREVIOUS_COMMENT_'+el.comment_id):' '));}));}}]);return Rows;}(_react.Component))||_class4)||_class4);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _cardsall=__webpack_require__(611);var _cardsall2=_interopRequireDefault(_cardsall);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @inject('lineStore')
// @withRouter
var CardsallPage=function(_Component){_inherits(CardsallPage,_Component);function CardsallPage(){_classCallCheck(this,CardsallPage);return _possibleConstructorReturn(this,(CardsallPage.__proto__||Object.getPrototypeOf(CardsallPage)).apply(this,arguments));}_createClass(CardsallPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"toto-page"},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement("title",null,"\u0418\u0420\u041C - \u0421\u043F\u0438\u0441\u043E\u043A \u043A\u0430\u0440\u0442\u043E\u0447\u0435\u043A \u0442\u043E\u0442\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440\u0430")),_react2.default.createElement("div",{className:"toto-page__body"},_react2.default.createElement(_cardsall2.default,null)));}}]);return CardsallPage;}(_react.Component);exports.default=CardsallPage;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class4,_dec4,_class6;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cardsall=(_dec=(0,_mobxReact.inject)('totoStore','dictStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Cardsall,_Component);function Cardsall(){_classCallCheck(this,Cardsall);return _possibleConstructorReturn(this,(Cardsall.__proto__||Object.getPrototypeOf(Cardsall)).apply(this,arguments));}_createClass(Cardsall,[{key:'componentDidMount',value:function componentDidMount(){this.props.totoStore.Cardsall.init(this.props.match.params);}},{key:'render',value:function render(){var _props$totoStore=this.props.totoStore,isLoading=_props$totoStore.isLoading,result=_props$totoStore.result,Cardsall=_props$totoStore.Cardsall;var getLang=this.props.dictStore.getLang;return!isLoading?_react2.default.createElement('div',{className:'toto-index-loading'},_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,Cardsall.data?_react2.default.createElement(TotoCards,null):_react2.default.createElement('div',{className:'toto-index-no'},getLang('INVALID_RESULT_ID')));}}]);return Cardsall;}(_react.Component))||_class)||_class)||_class);exports.default=Cardsall;var TotoCards=(_dec2=(0,_mobxReact.inject)('totoStore','dictStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(TotoCards,_Component2);function TotoCards(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,TotoCards);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=TotoCards.__proto__||Object.getPrototypeOf(TotoCards)).call.apply(_ref,[this].concat(args))),_this2),_this2.selectCurrency=function(e){_this2.props.totoStore.selectCurrency(e.target.value);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(TotoCards,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$totoStore2=this.props.totoStore,currency=_props$totoStore2.currency,currencyId=_props$totoStore2.currencyId,current=_props$totoStore2.current;var _props$totoStore$Card=this.props.totoStore.Cardsall,data=_props$totoStore$Card.data,page=_props$totoStore$Card.page;var number=0;return _react2.default.createElement('div',{className:'toto-cardsall'},_react2.default.createElement('div',{className:'clearfix'},_react2.default.createElement('div',{className:'fl_r'},_react2.default.createElement('label',{htmlFor:'toto-currency'},getLang('SHOW_IN_CURRENCY'),' '),_react2.default.createElement('select',{className:'toto-index-currency',onChange:this.selectCurrency},Object.keys(data.currency).map(function(id){return _react2.default.createElement('option',{key:id,value:data.currency[id].id,selected:data.currency[id].id==currencyId},data.currency[id].full_name);}))),_react2.default.createElement('div',null,_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/result/'+data.id},getLang('DETAILED_RESULTS_OF_DRAW')))),_react2.default.createElement('div',{className:'toto-cardsall-data'},_react2.default.createElement('div',null,getLang("DRAW"),' #R-',data.number,', ',data.date.start,' - ',data.date.end),_react2.default.createElement('div',{className:'toto-cardsall-row clearfix'},_react2.default.createElement('div',{className:'toto-cardsall-row-label fl_l'},getLang('TOTAL_BETS')),_react2.default.createElement('div',{className:'toto-cardsall-row-data'},data.cards_count)),_react2.default.createElement('div',{className:'toto-cardsall-row clearfix'},_react2.default.createElement('div',{className:'toto-cardsall-row-label fl_l'},getLang('TOTAL_OPTIONS')),_react2.default.createElement('div',{className:'toto-cardsall-row-data'},data.bets_count)),_react2.default.createElement('div',{className:'toto-cardsall-row clearfix'},_react2.default.createElement('div',{className:'toto-cardsall-row-label fl_l'},getLang('POOL')),_react2.default.createElement('div',{className:'toto-cardsall-row-data'},(0,_common.numberFormat)(data.pool[currencyId],2,',',' '),' ',current.name))),_react2.default.createElement('div',{className:'toto-cardsall-games-table-cont'},_react2.default.createElement('table',{className:'toto-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',{rowSpan:'2'},'\u2116'),_react2.default.createElement('th',{rowSpan:'2'},getLang('DATE')),_react2.default.createElement('th',{rowSpan:'2',colSpan:'2'},getLang('EVENT')),_react2.default.createElement('th',{colSpan:'3'},getLang('POOL_DISTRIBUTION')),_react2.default.createElement('th',{rowSpan:'2'},getLang('RESULT'))),_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'1'),_react2.default.createElement('th',null,'X'),_react2.default.createElement('th',null,'2'))),_react2.default.createElement('tbody',null,Object.keys(data.sport).map(function(sid){var league=data.sport[sid].league;return league.map(function(lid){return _react2.default.createElement(_react.Fragment,{key:'tr_'+lid},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-table-league-name',colSpan:'8'},data.dict.sport[sid],'. ',data.dict.league[lid])),data.league[lid].games.map(function(gid,idx){++number;return _react2.default.createElement('tr',{className:'toto-index-game',key:'td_'+gid},_react2.default.createElement('td',{className:'toto-table-id'},number),_react2.default.createElement('td',{className:'toto-table-date'},data.games[gid].date),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c1_id]),_react2.default.createElement('td',{className:'toto-table-cmd'},data.dict.cmd[data.games[gid].c2_id]),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_1,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_X,'%'),_react2.default.createElement('td',{className:'toto-table-pool-d'},data.games[gid].percent_2,'%'),_react2.default.createElement('td',{className:'toto-table-score'},data.games[gid].score!='{{ NO }}'?getLang(data.games[gid].score):getLang('NO')));}));});})))),_react2.default.createElement(Pages,null));}}]);return TotoCards;}(_react.Component))||_class2)||_class2);var Pages=(_dec3=(0,_mobxReact.inject)('totoStore','dictStore'),_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Pages,_Component3);function Pages(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,Pages);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=Pages.__proto__||Object.getPrototypeOf(Pages)).call.apply(_ref2,[this].concat(args))),_this3),_this3.selectPage=function(v){_this3.props.totoStore.Cardsall.selectPage(v);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(Pages,[{key:'render',value:function render(){var _this4=this;var getLang=this.props.dictStore.getLang;var _props$totoStore3=this.props.totoStore,currency=_props$totoStore3.currency,currencyId=_props$totoStore3.currencyId;var _props$totoStore$Card2=this.props.totoStore.Cardsall,data=_props$totoStore$Card2.data,pages=_props$totoStore$Card2.pages,page=_props$totoStore$Card2.page;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'toto-cardsall-page-list-cont clearfix'},_react2.default.createElement('nav',null,_react2.default.createElement('ul',{className:'toto-cardsall-page-list clearfix'},pages.map(function(el){return _react2.default.createElement('li',{className:'fl_l',key:el},_react2.default.createElement('a',{className:'toto-cardsall-page-a'+(el==page?' toto-cardsall-page-a-selected':''),onClick:function onClick(){return _this4.selectPage(el);}},el));})))),_react2.default.createElement(Table,null));}}]);return Pages;}(_react.Component))||_class4)||_class4);var Table=(_dec4=(0,_mobxReact.inject)('totoStore','dictStore'),_dec4(_class6=(0,_mobxReact.observer)(_class6=function(_Component4){_inherits(Table,_Component4);function Table(){_classCallCheck(this,Table);return _possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).apply(this,arguments));}_createClass(Table,[{key:'render',value:function render(){var getLang=this.props.dictStore.getLang;var _props$totoStore4=this.props.totoStore,current=_props$totoStore4.current,currencyId=_props$totoStore4.currencyId;var _props$totoStore$Card3=this.props.totoStore.Cardsall,data=_props$totoStore$Card3.data,pages=_props$totoStore$Card3.pages,page=_props$totoStore$Card3.page,isLoading=_props$totoStore$Card3.isLoading,pageData=_props$totoStore$Card3.pageData;var head=[];for(var i=1;i<=15;i++){head.push(_react2.default.createElement('th',null,i));}if(!pageData)return false;return _react2.default.createElement('div',{className:'toto-cardsall-bet-table-cont'},_react2.default.createElement('table',{className:'toto-table toto-cardsall-bet-table'},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,getLang('CARD')),_react2.default.createElement('th',null,getLang('AMOUNT')),head)),_react2.default.createElement('tbody',null,Object.keys(pageData.cards).map(function(id){var item=pageData.cards[id];return _react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'toto-cardsall-bet-table-number'},_react2.default.createElement(_reactRouterDom.Link,{to:'/toto/bet/'+item.id},item.code)),_react2.default.createElement('td',{className:'toto-cardsall-bet-table-amount'},(0,_common.numberFormat)(item.amount[currencyId],2,',',' '),' ',current.name),item.option.map(function(x){return _react2.default.createElement('td',{className:'t-c-b-t-o'},x);}));}))));}}]);return Table;}(_react.Component))||_class6)||_class6);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _account=__webpack_require__(613);var _account2=_interopRequireDefault(_account);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// @inject('lineStore')
// @observer
var AccountPage=function AccountPage(){return _react2.default.createElement('div',{className:'account-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0412\u0430\u0448\u0438 \u0434\u0430\u043D\u043D\u044B\u0435')),_react2.default.createElement(_account2.default,null));};exports.default=AccountPage;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class3,_dec4,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Line from './line';
// const getLeagueKeys = memoizee((league) => _.keysIn(league));
var Account=(_dec=(0,_mobxReact.inject)('accountStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Account,_Component);function Account(){_classCallCheck(this,Account);return _possibleConstructorReturn(this,(Account.__proto__||Object.getPrototypeOf(Account)).apply(this,arguments));}_createClass(Account,[{key:'componentDidMount',value:function componentDidMount(){this.props.accountStore.initPage('account');}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.clear('AccountPage');}},{key:'handleCloseError',value:function handleCloseError(){this.props.accountStore.AccountPage.clearError();}},{key:'render',value:function render(){if(!this.props.accountStore.AccountPage)return false;var _props$accountStore$A=this.props.accountStore.AccountPage,isLoading=_props$accountStore$A.isLoading,error=_props$accountStore$A.error;var getLang=this.props.dictStore.getLang;return isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):error.status?_react2.default.createElement(_message2.default,{text:error.text,onClose:this.handleCloseError}):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('h1',null,getLang('YOUR_DATA')),_react2.default.createElement(AccountData,null),_react2.default.createElement(ChangePass,null));}}]);return Account;}(_react.Component))||_class)||_class);exports.default=Account;var AccountData=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore','appStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(AccountData,_Component2);function AccountData(){_classCallCheck(this,AccountData);return _possibleConstructorReturn(this,(AccountData.__proto__||Object.getPrototypeOf(AccountData)).apply(this,arguments));}_createClass(AccountData,[{key:'render',value:function render(){if(!this.props.accountStore.AccountPage.data)return false;var _props$accountStore$A2=this.props.accountStore.AccountPage.data,name=_props$accountStore$A2.name,balance=_props$accountStore$A2.balance,login=_props$accountStore$A2.login,phone_converted=_props$accountStore$A2.phone_converted,email=_props$accountStore$A2.email;var getLang=this.props.dictStore.getLang;var currency=this.props.appStore.currency&&this.props.appStore.currency.name?this.props.appStore.currency.name:'';return _react2.default.createElement('div',{className:'account-main-data'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},getLang('ACCOUNT_NUMBER'),':'),_react2.default.createElement('div',{className:'row-data row-data-text'},_react2.default.createElement('strong',null,login))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},getLang('ACCOUNT_OWNER'),':'),_react2.default.createElement('div',{className:'row-data row-data-text'},_react2.default.createElement('strong',null,name),'\xA0')),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},getLang('BALANCE'),':'),_react2.default.createElement('div',{className:'row-data row-data-text'},_react2.default.createElement('strong',null,balance,' ',currency))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},getLang('CONTACT_PHONE'),':'),_react2.default.createElement('div',{className:'row-data row-data-text'},_react2.default.createElement('strong',null,phone_converted))),email?_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},'Email:'),_react2.default.createElement('div',{className:'row-data row-data-text'},_react2.default.createElement('strong',null,email))):'');}}]);return AccountData;}(_react.Component))||_class2)||_class2);var PASSWORD=[1,2,3];var LABELS={1:'CURRENT_PASSWORD',2:'NEW_PASSWORD',3:'REPEAT_NEW_PASSWORD'};var ChangePass=(_dec3=(0,_mobxReact.inject)('accountStore','dictStore'),_dec3(_class3=(0,_mobxReact.observer)(_class3=function(_Component3){_inherits(ChangePass,_Component3);function ChangePass(){var _ref;var _temp,_this3,_ret;_classCallCheck(this,ChangePass);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref=ChangePass.__proto__||Object.getPrototypeOf(ChangePass)).call.apply(_ref,[this].concat(args))),_this3),_this3.handleSubmit=function(e){e.preventDefault();if(_this3.props.accountStore.AccountPage.password.pass1.toString().length<3){_this3.props.accountStore.AccountPage.setError('INCORRECT_CURRENT_PASSWORD');document.getElementById('inputPassword1').focus();}else if(_this3.props.accountStore.AccountPage.password.pass2.toString().length<3){_this3.props.accountStore.AccountPage.setError('INCORRECT_NEW_PASSWORD');document.getElementById('inputPassword2').focus();}else if(_this3.props.accountStore.AccountPage.password.pass2!=_this3.props.accountStore.AccountPage.password.pass3){_this3.props.accountStore.AccountPage.setError('NEW_PASSWORDS_NOT_MATCH');document.getElementById('inputPassword3').focus();}else{_this3.props.accountStore.AccountPage.savePass();}},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(ChangePass,[{key:'render',// inputPassword = (e, type) => {
// 	this.props.accountStore.AccountPage.inputPass(e.target.value, type);
// }
value:function render(){var _props$accountStore$A3=this.props.accountStore.AccountPage,password=_props$accountStore$A3.password,result=_props$accountStore$A3.result;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('hr',{className:'account-row-separator'}),_react2.default.createElement('h2',null,getLang('CHANGE_PASSWORD')),_react2.default.createElement('div',{className:'account-security-data'},_react2.default.createElement('form',{role:'form',onSubmit:this.handleSubmit},PASSWORD.map(function(id){return _react2.default.createElement(InputPass,{id:id,key:id,password:password['pass'+id]});}),_react2.default.createElement('div',{className:'row row-h-space clearfix'},_react2.default.createElement('div',{className:'row-label'},' '),_react2.default.createElement('div',{className:'row-data row-data-button'},result.error?_react2.default.createElement('span',{className:'change-pass change-pass_error fl_l'},getLang(result.error)):_react2.default.createElement('span',{className:'change-pass change-pass_success fl_l'},getLang(result.success)),_react2.default.createElement('button',{type:'submit',className:'flat_button fl_r'},getLang('SAVE')))),_react2.default.createElement('div',{className:'row row-h-space'},_react2.default.createElement('div',{className:'row-label'},' '),_react2.default.createElement('div',{className:'row-data'},_react2.default.createElement('div',{className:'note',dangerouslySetInnerHTML:{__html:getLang('IRM_PASSWORD_DESCRIPTION')}}))))));}}]);return ChangePass;}(_react.Component))||_class3)||_class3);var InputPass=(_dec4=(0,_mobxReact.inject)('accountStore','dictStore'),_dec4(_class5=(0,_mobxReact.observer)(_class5=function(_Component4){_inherits(InputPass,_Component4);function InputPass(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,InputPass);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=InputPass.__proto__||Object.getPrototypeOf(InputPass)).call.apply(_ref2,[this].concat(args))),_this4),_this4.inputPassword=function(value){_this4.props.accountStore.AccountPage.inputPass(value,_this4.props.id);},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(InputPass,[{key:'render',value:function render(){var _props=this.props,id=_props.id,password=_props.password;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-label'},_react2.default.createElement('label',{htmlFor:'inputPassword'+id},getLang(LABELS[id]),':')),_react2.default.createElement('div',{className:'row-data row-data-input'},_react2.default.createElement(_keyboardInput2.default,{onChange:this.inputPassword,value:password,type:'password',className:'form-control',maxLength:'6',id:'inputPassword'+id,autoComplete:'off',positionX:'right',positionY:'bottom'})));}}]);return InputPass;}(_react.Component))||_class5)||_class5);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _betsPeriod=__webpack_require__(173);var _betsPeriod2=_interopRequireDefault(_betsPeriod);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetsPage=function(_Component){_inherits(BetsPage,_Component);function BetsPage(){_classCallCheck(this,BetsPage);return _possibleConstructorReturn(this,(BetsPage.__proto__||Object.getPrototypeOf(BetsPage)).apply(this,arguments));}_createClass(BetsPage,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'account-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0412\u0430\u0448\u0438 \u0441\u0442\u0430\u0432\u043A\u0438')),_react2.default.createElement(_betsPeriod2.default,null));}}]);return BetsPage;}(_react.Component);exports.default=BetsPage;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _history=__webpack_require__(616);var _history2=_interopRequireDefault(_history);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HistoryPage=function HistoryPage(){return _react2.default.createElement('div',{className:'account-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0447\u0435\u0442\u0430')),_react2.default.createElement(_history2.default,null));};// import { inject, observer } from 'mobx-react';
exports.default=HistoryPage;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class2,_dec3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _common=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Line from './line';
// const getLeagueKeys = memoizee((league) => _.keysIn(league));
var History=(_dec=(0,_mobxReact.inject)('accountStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(History,_Component);function History(){_classCallCheck(this,History);return _possibleConstructorReturn(this,(History.__proto__||Object.getPrototypeOf(History)).apply(this,arguments));}_createClass(History,[{key:'componentDidMount',value:function componentDidMount(){this.props.accountStore.initPage('history');}},{key:'handleCloseError',value:function handleCloseError(){this.props.accountStore.HistoryPage.clearResult();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.clear('HistoryPage');}},{key:'render',value:function render(){if(!this.props.accountStore.HistoryPage)return false;var _props$accountStore$H=this.props.accountStore.HistoryPage,isLoading=_props$accountStore$H.isLoading,result=_props$accountStore$H.result;var getLang=this.props.dictStore.getLang;return isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('h1',null,getLang('ACCOUNT_HISTORY')),_react2.default.createElement(Filter,null),result.status?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handleCloseError}):'',_react2.default.createElement(List,null));}}]);return History;}(_react.Component))||_class)||_class);exports.default=History;var Filter=(_dec2=(0,_mobxReact.inject)('accountStore','dictStore'),_dec2(_class2=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(Filter,_Component2);function Filter(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,Filter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=Filter.__proto__||Object.getPrototypeOf(Filter)).call.apply(_ref,[this].concat(args))),_this2),_this2.handleClick=function(){_this2.props.accountStore.HistoryPage.loadData();},_this2.selectDate=function(e){_this2.props.accountStore.HistoryPage.selectDate(e.target.value);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(Filter,[{key:'render',value:function render(){var _props$accountStore$H2=this.props.accountStore.HistoryPage,filter=_props$accountStore$H2.filter,wait=_props$accountStore$H2.wait,date=_props$accountStore$H2.date;var getLang=this.props.dictStore.getLang;if(!filter)return false;return _react2.default.createElement('div',{className:'account-history-menu clearfix'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'row-item'},_react2.default.createElement('label',null,_react2.default.createElement('select',{onChange:this.selectDate},filter.date.map(function(value){return _react2.default.createElement('option',{key:value,value:value,selected:value==date},getLang('ACCOUNT_HISTORY_DATE_'+value));})))),_react2.default.createElement('div',{className:'row-item buttons'},_react2.default.createElement('button',{type:'button',className:'flat_button '+(wait?'wait':''),disabled:wait,onClick:this.handleClick},getLang('SHOW')))));}}]);return Filter;}(_react.Component))||_class2)||_class2);var List=(_dec3=(0,_mobxReact.inject)('accountStore','dictStore'),_dec3(_class4=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(List,_Component3);function List(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,List);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=List.__proto__||Object.getPrototypeOf(List)).call.apply(_ref2,[this].concat(args))),_this3),_this3.handleCancel=function(id){_this3.props.accountStore.HistoryPage.cancel(id);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(List,[{key:'render',value:function render(){var _this4=this;var _props$accountStore$H3=this.props.accountStore.HistoryPage,data=_props$accountStore$H3.data,error=_props$accountStore$H3.error,result=_props$accountStore$H3.result;var getLang=this.props.dictStore.getLang;if(!data||data.length===0)return _react2.default.createElement('div',{className:'account-history-no'},getLang('NO_HISTORY'));return _react2.default.createElement('div',null,data.map(function(el){return _react2.default.createElement('div',{key:el.id,className:'account-history-item clearfix'},_react2.default.createElement('div',{className:'account-history-item-status fl_r '+(el.status==1||el.status==2?'account-history-item-status-success':'')},el.status>=0?getLang('ACCOUNT_HISTORY_STATUS_'+el.status):'',el.cancel_reason),_react2.default.createElement('div',{className:'account-history-item-date',title:getLang('DATE')+': '+el.date},(0,_common.dateTextFormat)(el.date)),_react2.default.createElement('div',{className:'account-history-item-line clearfix'},el.allow_cancel==1?_react2.default.createElement('div',{className:'account-history-item-cancel fl_r'},_react2.default.createElement('a',{className:'account-history-item-cancel-link',onClick:function onClick(){_this4.handleCancel(el.id);}})):'',el.text));}));}}]);return List;}(_react.Component))||_class4)||_class4);

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _payout=__webpack_require__(618);var _payout2=_interopRequireDefault(_payout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PayoutPage=function PayoutPage(){return _react2.default.createElement('div',{className:'payout-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0412\u044B\u043F\u043B\u0430\u0442\u0430')),_react2.default.createElement(_payout2.default,null));};exports.default=PayoutPage;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_dec2,_class3,_dec3,_class5;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PayoutPage=(_dec=(0,_mobxReact.inject)('financeStore','dictStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PayoutPage,_Component);function PayoutPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PayoutPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PayoutPage.__proto__||Object.getPrototypeOf(PayoutPage)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseError=function(){_this.props.financeStore.payout.clear();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PayoutPage,[{key:'componentWillMount',value:function componentWillMount(){this.props.financeStore.init('payout');}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.financeStore.clear('payout');}},{key:'render',value:function render(){if(!this.props.financeStore.payout)return false;var _props$financeStore$p=this.props.financeStore.payout,isLoading=_props$financeStore$p.isLoading,result=_props$financeStore$p.result;var getLang=this.props.dictStore.getLang;return isLoading?_react2.default.createElement('div',null,_react2.default.createElement(_loadingSpinner2.default,null)):_react2.default.createElement(_react.Fragment,null,_react2.default.createElement('h1',null,getLang('PAYOUT')),result.status?_react2.default.createElement(_message2.default,{text:result.text,type:result.type,onClose:this.handleCloseError}):'',_react2.default.createElement(Payout,null));}}]);return PayoutPage;}(_react.Component))||_class)||_class);exports.default=PayoutPage;var Payout=(_dec2=(0,_mobxReact.inject)('financeStore','appStore','dictStore'),_dec2(_class3=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Payout,_Component2);function Payout(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,Payout);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=Payout.__proto__||Object.getPrototypeOf(Payout)).call.apply(_ref2,[this].concat(args))),_this2),_this2.handleEdit=function(){_this2.props.financeStore.payout.edit();},_this2.handleCancel=function(){_this2.props.financeStore.payout.cancel();},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(Payout,[{key:'render',value:function render(){var _props$financeStore$p2=this.props.financeStore.payout,data=_props$financeStore$p2.data,editStatus=_props$financeStore$p2.editStatus,noty=_props$financeStore$p2.noty;var name=this.props.appStore.currency.name;var getLang=this.props.dictStore.getLang;if(noty){return _react2.default.createElement(Noty,null);}return _react2.default.createElement('div',{className:'payout'},data?_react2.default.createElement('div',{className:'payout-item clearfix'},_react2.default.createElement('div',{className:'fl_l payout-date'},data.date),_react2.default.createElement('div',{className:'fl_r payout-control'},_react2.default.createElement('button',{className:'flat_button',onClick:this.handleEdit},getLang('EDIT2')),_react2.default.createElement('button',{className:'flat_button',onClick:this.handleCancel},getLang('CANCEL2'))),_react2.default.createElement('div',{className:'payout-label'},getLang('ACTIVE_PAYMENT'),' '+getLang('FOR_AMOUNT')+' '+data.amount+' '+name)):_react2.default.createElement('div',{className:'payout-no'},getLang('NO_ACTIVE_PAYMENT')),!data||editStatus?_react2.default.createElement(Form,null):'');}}]);return Payout;}(_react.Component))||_class3)||_class3);var Form=(_dec3=(0,_mobxReact.inject)('financeStore','appStore','dictStore'),_dec3(_class5=(0,_mobxReact.observer)(_class5=function(_Component3){_inherits(Form,_Component3);function Form(){var _ref3;var _temp3,_this3,_ret3;_classCallCheck(this,Form);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this3=_possibleConstructorReturn(this,(_ref3=Form.__proto__||Object.getPrototypeOf(Form)).call.apply(_ref3,[this].concat(args))),_this3),_this3.handleInput=function(e){_this3.props.financeStore.payout.inputAmount(e);},_this3.handleOrder=function(e){if(_this3.props.financeStore.payout.amount<=0){_this3.props.financeStore.payout.setResult('AMOUNT_IS_ZERO');document.getElementById('payout-amount').focus();return false;}_this3.props.financeStore.payout.create();},_this3.handleCancel=function(){_this3.props.financeStore.payout.cancel();},_temp3),_possibleConstructorReturn(_this3,_ret3);}_createClass(Form,[{key:'render',value:function render(){var _this4=this;var _props$financeStore$p3=this.props.financeStore.payout,isLoading=_props$financeStore$p3.isLoading,editStatus=_props$financeStore$p3.editStatus,amount=_props$financeStore$p3.amount,wait=_props$financeStore$p3.wait;var name=this.props.appStore.currency.name;var getLang=this.props.dictStore.getLang;return _react2.default.createElement('div',{className:'payout-form'},_react2.default.createElement('div',{className:'payout-form-input'},getLang('AMOUNT'),_react2.default.createElement(_keyboardInput2.default,{mode:'mask',mask:[/[1-9]/,/\d||\./,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/],id:'payout-amount',type:'text',maxLength:'10',ref:function ref(el){_this4.input=el;},onChange:this.handleInput,className:'form-control',placeholder:'1000',value:amount,positionX:'right',positionY:'bottom'}),_react2.default.createElement('span',null,name)),_react2.default.createElement('div',{className:'payout-form-control'},editStatus?_react2.default.createElement('button',{className:'flat_button flat_button_inf',onClick:this.handleCancel},getLang('CANCEL')):'',_react2.default.createElement('button',{className:'flat_button '+(wait?'wait':''),disabled:wait,type:'submit',onClick:this.handleOrder},getLang('ORDER'))));}}]);return Form;}(_react.Component))||_class5)||_class5);var Noty=function Noty(){return _react2.default.createElement('div',{className:'payout-note'},'\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441 \u0438 \u0437\u0430\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u0432 \u0434\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0433\u0438\u043E\u043D\u0435, \u0442.\u043A. \u043E\u043D \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0434\u043E\u043C\u0430\u0448\u043D\u0438\u043C \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430.',_react2.default.createElement('br',null),'\u0414\u043E\u043C\u0430\u0448\u043D\u0438\u043C \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0435\u0442\u0441\u044F \u0442\u043E\u0442 \u0440\u0435\u0433\u0438\u043E\u043D, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0431\u044B\u043B\u043E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u043E \u043F\u0435\u0440\u0432\u043E\u0435 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0431\u0430\u043B\u0430\u043D\u0441\u0430.',_react2.default.createElement('br',null),'\u0427\u0442\u043E\u0431\u044B \u043E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043E\u0442 \u0434\u043E\u043C\u0430\u0448\u043D\u0435\u0433\u043E \u0440\u0435\u0433\u0438\u043E\u043D\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u043A\u0430\u0441\u0441\u0438\u0440\u0443 \u0438\u043B\u0438 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u041F\u041F\u0421 \u0437\u0430 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0438\u043C\u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C\u0438.',_react2.default.createElement('br',null),'\u041F\u043E\u0441\u043B\u0435 \u0441\u043D\u044F\u0442\u0438\u044F \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438 \u0434\u043E\u043C\u0430\u0448\u043D\u0438\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D \u0442\u043E\u0442 \u0440\u0435\u0433\u0438\u043E\u043D, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0432\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0438\u0442\u0435 \u043F\u0435\u0440\u0432\u043E\u0435 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0431\u0430\u043B\u0430\u043D\u0441\u0430.');};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _login=__webpack_require__(620);var _login2=_interopRequireDefault(_login);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginPage=function LoginPage(){return _react2.default.createElement('div',{className:'login-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u043E \u043A\u0430\u0440\u0442\u0435')),_react2.default.createElement(_login2.default,null));};exports.default=LoginPage;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);var _keyboardInput=__webpack_require__(28);var _keyboardInput2=_interopRequireDefault(_keyboardInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=(_dec=(0,_mobxReact.inject)('accountStore','dictStore','appStore'),(0,_reactRouterDom.withRouter)(_class=_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Login,_Component);function Login(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(e){e.preventDefault();if(_this.props.accountStore.auth.cardID.toString().length<0){_this.props.accountStore.setAuthError('Нет карты');return false;}else if(_this.props.accountStore.auth.password.toString().length<4){_this.props.accountStore.setAuthError('Длина пароля должна содержать не менее 4 символов');document.getElementById('password-card').focus();return false;}_this.props.accountStore.cardLogin();},_this.handleChange=function(e){_this.props.accountStore.inputAuth(e,'password');},_this.handleCloseMessage=function(){_this.props.accountStore.clearAuthError();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){this.props.accountStore.logout(1);// if (this.props.accountStore.access) {
//   this.props.history.goBack();
// }
this.props.accountStore.setCardId((0,_common.getQueryVariable)('card_id'));this.props.appStore.toggleShowTopMenu(false);document.getElementById('password-card').focus();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.accountStore.closeForm();this.props.appStore.toggleShowTopMenu(true);}},{key:'render',value:function render(){var _props$accountStore=this.props.accountStore,cardId=_props$accountStore.cardId,statusdAuthForm=_props$accountStore.statusdAuthForm,auth=_props$accountStore.auth;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('h1',null,getLang('ENTRANCE')),_react2.default.createElement('div',{className:'login-form-card'},_react2.default.createElement('form',{onSubmit:this.handleSubmit},_react2.default.createElement('div',{className:'row clearfix'},_react2.default.createElement('div',{className:'input-group'},_react2.default.createElement(_keyboardInput2.default,{type:'password',name:'password',className:'form-control login-form-card__pass',pattern:'[0-9]{0,6}',maxLength:'6',placeholder:'\u041F\u0430\u0440\u043E\u043B\u044C',tabIndex:'0',id:'password-card',value:auth.password,onChange:this.handleChange,disabled:statusdAuthForm.disabled,positionX:'right',positionY:'bottom',forceShowIcon:true}),_react2.default.createElement('span',{className:'input-group-addon login-form_attemp',title:'\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A'},statusdAuthForm.attempts))),_react2.default.createElement('div',{className:'login-form-button-wrp'},_react2.default.createElement('button',{className:'flat_button login-form_login '+(statusdAuthForm.wait?'wait':''),tabIndex:'4',disabled:statusdAuthForm.wait},'\u0412\u041E\u0419\u0422\u0418')),statusdAuthForm.status?_react2.default.createElement(_message2.default,{text:statusdAuthForm.text,onClose:this.handleCloseMessage}):'')));}}]);return Login;}(_react.Component))||_class)||_class)||_class);exports.default=Login;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginPage=function LoginPage(){return _react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});};exports.default=LoginPage;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(9);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _logout=__webpack_require__(623);var _logout2=_interopRequireDefault(_logout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LogoutPage=function LogoutPage(){return _react2.default.createElement('div',{className:'logout-delayed-index'},_react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('title',null,'\u0418\u0420\u041C - \u0412\u044B\u0445\u043E\u0434')),_react2.default.createElement(_logout2.default,null));};exports.default=LogoutPage;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _loadingSpinner=__webpack_require__(7);var _loadingSpinner2=_interopRequireDefault(_loadingSpinner);var _common=__webpack_require__(6);var _message=__webpack_require__(13);var _message2=_interopRequireDefault(_message);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logout=(_dec=(0,_mobxReact.inject)('accountStore','dictStore','appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Logout,_Component);function Logout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Logout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Logout.__proto__||Object.getPrototypeOf(Logout)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentCount:10},_this.intervalId=null,_this.timer=function(){var newCount=_this.state.currentCount-1;if(newCount>=0){_this.setState({currentCount:newCount});}else{_this.logout();}},_this.logout=function(){_this.props.accountStore.logout();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Logout,[{key:'componentDidMount',value:function componentDidMount(){this.props.appStore.toggleShowTopMenu(false);this.intervalId=setInterval(this.timer,1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.appStore.toggleShowTopMenu(true);clearInterval(this.countdown);}},{key:'render',value:function render(){var logout_hash=this.props.accountStore.logout_hash;var getLang=this.props.dictStore.getLang;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'logout-delayed'},_react2.default.createElement('div',{className:'logout-delayed-img-cont'},_react2.default.createElement(_loadingSpinner2.default,null)),_react2.default.createElement('div',{className:'logout-delayed-text-cont'},_react2.default.createElement('p',null,getLang('LOGIN_DELAYED_TEXT_1')),_react2.default.createElement('p',null,getLang('LOGIN_DELAYED_TEXT_2')),_react2.default.createElement('p',null,getLang('VIA'),' ',_react2.default.createElement('span',null,this.state.currentCount),' ',getLang('LOGIN_DELAYED_TEXT_3'))),_react2.default.createElement('div',{className:'logout-delayed-button-cont'},_react2.default.createElement('button',{onClick:this.logout,type:'button',className:'flat_button flat_button_big'},getLang('EXIT')))));}}]);return Logout;}(_react.Component))||_class)||_class);exports.default=Logout;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(1);var _reactRouterDom=__webpack_require__(2);var _underHeader=__webpack_require__(40);var _underHeader2=_interopRequireDefault(_underHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rules=(_dec=(0,_mobxReact.inject)('appStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Rules,_Component);function Rules(){_classCallCheck(this,Rules);return _possibleConstructorReturn(this,(Rules.__proto__||Object.getPrototypeOf(Rules)).apply(this,arguments));}_createClass(Rules,[{key:'componentDidMount',value:function componentDidMount(){this.props.appStore.getRules();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.appStore.clearRules();}},{key:'render',value:function render(){var _props$appStore=this.props.appStore,cashboxRules=_props$appStore.cashboxRules,cashboxMode=_props$appStore.cashboxMode;if(cashboxMode!=2)return _react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'blue_line'},_react2.default.createElement(_underHeader2.default,{type:2})),_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:cashboxRules}}));}}]);return Rules;}(_react.Component))||_class)||_class);exports.default=Rules;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorPage=function(_Component){_inherits(ErrorPage,_Component);function ErrorPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ErrorPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ErrorPage.__proto__||Object.getPrototypeOf(ErrorPage)).call.apply(_ref,[this].concat(args))),_this),_this.reload=function(){window.location.reload(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ErrorPage,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"main"},_react2.default.createElement("div",{className:"error-page"},_react2.default.createElement("p",null,"\u0427\u0442\u043E \u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A"),_react2.default.createElement("p",null,"\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"),_react2.default.createElement("br",null),_react2.default.createElement("button",{className:"flat_button",onClick:this.reload}," \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"),_react2.default.createElement("br",null),_react2.default.createElement("br",null),_react2.default.createElement("a",{href:"/"},"\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430")));}}]);return ErrorPage;}(_react.Component);exports.default=ErrorPage;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"sport":[{"league":[246432,246433,253670,283492,252564,248663,354958,358680,252382,304400,359166,303873,253367,248080,249768,253775,262482,347536,248334,248416,292254,246333,246792],"id":26,"count":35,"games_time":1698399000,"default_categories":[31]},{"league":[270410,305759,326745,306137,260813,319434,261482,262105,261625,260360,260311,263899],"id":28,"count":15,"games_time":1698400800,"default_categories":null},{"league":[257704,265161,265288,308836,262392,261586,260383,262728],"id":41,"count":8,"games_time":1698400500,"default_categories":null},{"league":[264315,266553,266625,279892,281132,264566,261038,247195,264601,264385,260990,281134,265813,318046,265815,264605,358593,358619],"id":33,"count":28,"games_time":1698395700,"default_categories":[31]},{"league":[317641,258499,253049,253711,256535,253764],"id":27,"count":8,"games_time":1698399000,"default_categories":[31]},{"league":[275434,291678,312893,291687,246188,246593],"id":134,"count":16,"games_time":1698405300,"default_categories":null},{"league":[357276,358667,359040,358921],"id":556,"count":4,"games_time":1698402600,"default_categories":null},{"league":[338000,321798],"id":564,"count":3,"games_time":1698405000,"default_categories":null},{"league":[341078,319882,319869,319893,222364,220185],"id":560,"count":10,"games_time":1698405300,"default_categories":[31]},{"league":[320324,332938],"id":562,"count":3,"games_time":1698405000,"default_categories":[31]},{"league":[264544,264546,267793,267819],"id":235,"count":4,"games_time":1698399600,"default_categories":null},{"league":[359118],"id":272,"count":1,"games_time":1698404400,"default_categories":null},{"league":[357336,353071],"id":533,"count":2,"games_time":1698395400,"default_categories":null},{"league":[359038],"id":337,"count":1,"games_time":1698404400,"default_categories":null},{"league":[321909,316981],"id":177,"count":3,"games_time":1698400800,"default_categories":null},{"league":[359100],"id":317,"count":1,"games_time":1698402600,"default_categories":null}],"league":{"220185":{"games":[13159244],"id":220185,"sid":560,"count":1,"date":-1078,"popular":"0","games_time":1698405300},"222364":{"games":[13159274,13159269],"id":222364,"sid":560,"count":2,"date":-418,"popular":"0","games_time":1698405780},"246188":{"games":[13155223,13155215,13155229],"id":246188,"sid":134,"count":3,"date":-1078,"popular":"0","games_time":1698405300},"246333":{"games":[13158592],"id":246333,"sid":26,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"246432":{"games":[13156242],"id":246432,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"246433":{"games":[13159118,13159119],"id":246433,"sid":26,"count":2,"date":-1978,"popular":"0","games_time":1698404400},"246593":{"games":[13155994,13155991,13155992,13155996],"id":246593,"sid":134,"count":4,"date":-178,"popular":"0","games_time":1698406200},"246792":{"games":[13158618,13158617],"id":246792,"sid":26,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"247195":{"games":[13156078,13157564,13157560],"id":247195,"sid":33,"count":3,"date":-10678,"popular":"0","games_time":1698395700},"248080":{"games":[13156235,13156238],"id":248080,"sid":26,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"248334":{"games":[13156231],"id":248334,"sid":26,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"248416":{"games":[13156232],"id":248416,"sid":26,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"248663":{"games":[13158718,13158726,13158723],"id":248663,"sid":26,"count":3,"date":-1978,"popular":"0","games_time":1698404400},"249768":{"games":[13158741,13158933,13159117,13158932],"id":249768,"sid":26,"count":4,"date":-1978,"popular":"0","games_time":1698404400},"252382":{"games":[13158787],"id":252382,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"252564":{"games":[13156247],"id":252564,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"253049":{"games":[13159112],"id":253049,"sid":27,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"253367":{"games":[13158807],"id":253367,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"253670":{"games":[13158645],"id":253670,"sid":26,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"253711":{"games":[13159113,13159114,13159115],"id":253711,"sid":27,"count":3,"date":-1978,"popular":"0","games_time":1698404400},"253764":{"games":[13158275],"id":253764,"sid":27,"count":1,"date":-7378,"popular":"0","games_time":1698399000},"253775":{"games":[13158737],"id":253775,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"256535":{"games":[13159302],"id":256535,"sid":27,"count":1,"date":-178,"popular":"0","games_time":1698406200},"257704":{"games":[13159258],"id":257704,"sid":41,"count":1,"date":-1078,"popular":"0","games_time":1698405300},"258499":{"games":[13158595],"id":258499,"sid":27,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"260311":{"games":[13157452,13158241],"id":260311,"sid":28,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"260360":{"games":[13158238],"id":260360,"sid":28,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"260383":{"games":[13158414],"id":260383,"sid":41,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"260813":{"games":[13156211,13156213],"id":260813,"sid":28,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"260990":{"games":[13156160],"id":260990,"sid":33,"count":1,"date":-4078,"popular":"0","games_time":1698402300},"261038":{"games":[13151078,13151085,13147905,13151084],"id":261038,"sid":33,"count":4,"date":-3478,"popular":"0","games_time":1698402900},"261482":{"games":[13157391],"id":261482,"sid":28,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"261586":{"games":[13157472],"id":261586,"sid":41,"count":1,"date":-2278,"popular":"0","games_time":1698404100},"261625":{"games":[13158228,13158233],"id":261625,"sid":28,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"262105":{"games":[13157465],"id":262105,"sid":28,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"262392":{"games":[13158910],"id":262392,"sid":41,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"262482":{"games":[13156257],"id":262482,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"262728":{"games":[13158495],"id":262728,"sid":41,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"263899":{"games":[13156218],"id":263899,"sid":28,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"264315":{"games":[13157181,13157178],"id":264315,"sid":33,"count":2,"date":-4078,"popular":"0","games_time":1698401100},"264385":{"games":[13157707,13157709],"id":264385,"sid":33,"count":2,"date":-7078,"popular":"0","games_time":1698399300},"264544":{"games":[13159301],"id":264544,"sid":235,"count":1,"date":-178,"popular":"0","games_time":1698406200},"264546":{"games":[13159071],"id":264546,"sid":235,"count":1,"date":-2398,"popular":"0","games_time":1698403980},"264566":{"games":[13156156,13156152],"id":264566,"sid":33,"count":2,"date":-1678,"popular":"0","games_time":1698404400},"264601":{"games":[13157176],"id":264601,"sid":33,"count":1,"date":-3478,"popular":"0","games_time":1698402900},"264605":{"games":[13158626],"id":264605,"sid":33,"count":1,"date":-5278,"popular":"0","games_time":1698401100},"265161":{"games":[13158432],"id":265161,"sid":41,"count":1,"date":-2278,"popular":"0","games_time":1698404100},"265288":{"games":[13157480],"id":265288,"sid":41,"count":1,"date":-2278,"popular":"0","games_time":1698404100},"265813":{"games":[13157312],"id":265813,"sid":33,"count":1,"date":-10078,"popular":"0","games_time":1698396300},"265815":{"games":[13157041],"id":265815,"sid":33,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"266553":{"games":[13156150],"id":266553,"sid":33,"count":1,"date":-3778,"popular":"0","games_time":1698402600},"266625":{"games":[13156144],"id":266625,"sid":33,"count":1,"date":-538,"popular":"0","games_time":1698405840},"267793":{"games":[13159038],"id":267793,"sid":235,"count":1,"date":-2998,"popular":"0","games_time":1698403380},"267819":{"games":[13159261],"id":267819,"sid":235,"count":1,"date":-6778,"popular":"0","games_time":1698399600},"270410":{"games":[13157453],"id":270410,"sid":28,"count":1,"date":-3478,"popular":"0","games_time":1698402900},"275434":{"games":[13155236],"id":275434,"sid":134,"count":1,"date":-178,"popular":"0","games_time":1698406200},"279892":{"games":[13159000],"id":279892,"sid":33,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"281132":{"games":[13157062],"id":281132,"sid":33,"count":1,"date":-4678,"popular":"0","games_time":1698401700},"281134":{"games":[13157064,13157067],"id":281134,"sid":33,"count":2,"date":-3778,"popular":"0","games_time":1698402600},"283492":{"games":[13156233,13158499],"id":283492,"sid":26,"count":2,"date":-5578,"popular":"0","games_time":1698400800},"291678":{"games":[13155617,13155569,13155403,13155427],"id":291678,"sid":134,"count":4,"date":-478,"popular":"0","games_time":1698405300},"291687":{"games":[13156272,13155624,13155631],"id":291687,"sid":134,"count":3,"date":-778,"popular":"0","games_time":1698405300},"292254":{"games":[13158599],"id":292254,"sid":26,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"303873":{"games":[13158976],"id":303873,"sid":26,"count":1,"date":-7378,"popular":"0","games_time":1698399000},"304400":{"games":[13159262,13159291],"id":304400,"sid":26,"count":2,"date":-778,"popular":"0","games_time":1698405600},"305759":{"games":[13158426],"id":305759,"sid":28,"count":1,"date":-1378,"popular":"0","games_time":1698405000},"306137":{"games":[13158911],"id":306137,"sid":28,"count":1,"date":-3478,"popular":"0","games_time":1698402900},"308836":{"games":[13157450],"id":308836,"sid":41,"count":1,"date":-5878,"popular":"0","games_time":1698400500},"312893":{"games":[13158977],"id":312893,"sid":134,"count":1,"date":-478,"popular":"0","games_time":1698405900},"316981":{"games":[13159120,13159153],"id":316981,"sid":177,"count":2,"date":-1978,"popular":"0","games_time":1698404400},"317641":{"games":[13158946],"id":317641,"sid":27,"count":1,"date":-4678,"popular":"0","games_time":1698401700},"318046":{"games":[13158234],"id":318046,"sid":33,"count":1,"date":-3478,"popular":"0","games_time":1698402900},"319434":{"games":[13155639],"id":319434,"sid":28,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"319869":{"games":[13159242,13159264,13159297],"id":319869,"sid":560,"count":3,"date":-598,"popular":"0","games_time":1698405780},"319882":{"games":[13159300,13159299],"id":319882,"sid":560,"count":2,"date":-238,"popular":"0","games_time":1698406140},"319893":{"games":[13159265],"id":319893,"sid":560,"count":1,"date":-178,"popular":"0","games_time":1698406200},"320324":{"games":[13159260,13159308],"id":320324,"sid":562,"count":2,"date":-1258,"popular":"0","games_time":1698405120},"321798":{"games":[13159268],"id":321798,"sid":564,"count":1,"date":-778,"popular":"0","games_time":1698405600},"321909":{"games":[13158634],"id":321909,"sid":177,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"326745":{"games":[13158905],"id":326745,"sid":28,"count":1,"date":-5578,"popular":"0","games_time":1698400800},"332938":{"games":[13159211],"id":332938,"sid":562,"count":1,"date":-1378,"popular":"0","games_time":1698405000},"338000":{"games":[13159200,13159273],"id":338000,"sid":564,"count":2,"date":-1378,"popular":"0","games_time":1698405000},"341078":{"games":[13159292],"id":341078,"sid":560,"count":1,"date":-418,"popular":"0","games_time":1698405960},"347536":{"games":[13158706],"id":347536,"sid":26,"count":1,"date":-3778,"popular":"0","games_time":1698402600},"353071":{"games":[13157615],"id":353071,"sid":533,"count":1,"date":-10978,"popular":"0","games_time":1698395400},"354958":{"games":[13156245,13156258],"id":354958,"sid":26,"count":2,"date":-1978,"popular":"0","games_time":1698404400},"357276":{"games":[13158957],"id":357276,"sid":556,"count":1,"date":-2878,"popular":"0","games_time":1698403500},"357336":{"games":[13158274],"id":357336,"sid":533,"count":1,"date":-7378,"popular":"0","games_time":1698399000},"358593":{"games":[13157722,13157727],"id":358593,"sid":33,"count":2,"date":-5878,"popular":"0","games_time":1698400500},"358619":{"games":[13155867],"id":358619,"sid":33,"count":1,"date":-9178,"popular":"0","games_time":1698397200},"358667":{"games":[13159082],"id":358667,"sid":556,"count":1,"date":-3778,"popular":"0","games_time":1698402600},"358680":{"games":[13158885,13156246],"id":358680,"sid":26,"count":2,"date":-1978,"popular":"0","games_time":1698400800},"358921":{"games":[13159079],"id":358921,"sid":556,"count":1,"date":-1078,"popular":"0","games_time":1698405300},"359038":{"games":[13159097],"id":359038,"sid":337,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"359040":{"games":[13159294],"id":359040,"sid":556,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"359100":{"games":[13159027],"id":359100,"sid":317,"count":1,"date":-3778,"popular":"0","games_time":1698402600},"359118":{"games":[13159048],"id":359118,"sid":272,"count":1,"date":-1978,"popular":"0","games_time":1698404400},"359166":{"games":[13159194],"id":359166,"sid":26,"count":1,"date":-1978,"popular":"0","games_time":1698404400}},"games":{"13147905":{"time":1698402900,"date":"13:35","sid":33,"lid":261038,"id":13147905,"c1_id":1010986,"c2_id":1010399,"prio":null,"number":"652","stats":1,"ross_stats_count":"0","ross_with_stats":72,"ross_count_with_double_chances":72,"bets":[],"score":"1:0 (6:2, 0:0) *30:0","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.05,"id":4247929354,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":7.83,"id":4247929355,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"72"},"13151078":{"time":1698402900,"date":"13:35","sid":33,"lid":261038,"id":13151078,"c1_id":1099547,"c2_id":996773,"prio":null,"number":"987","stats":1,"ross_stats_count":"0","ross_with_stats":66,"ross_count_with_double_chances":66,"bets":[],"score":"0:1 (0:6, 1:2) *40:30","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":7.61,"id":4247937176,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.05,"id":4247937177,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"66"},"13151084":{"time":1698402900,"date":"13:35","sid":33,"lid":261038,"id":13151084,"c1_id":1029252,"c2_id":1002459,"prio":null,"number":"990","stats":1,"ross_stats_count":"0","ross_with_stats":83,"ross_count_with_double_chances":83,"bets":[],"score":"0:0 (1:5) *0:0","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.74,"id":4247937897,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.4,"id":4247937898,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"83"},"13151085":{"time":1698402900,"date":"13:35","sid":33,"lid":261038,"id":13151085,"c1_id":1002467,"c2_id":1050279,"prio":null,"number":"991","stats":1,"ross_stats_count":"0","ross_with_stats":63,"ross_count_with_double_chances":63,"bets":[],"score":"0:0 (3:5) 15:30*","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.46,"id":4247938705,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247938706,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"63"},"13155215":{"time":1698405300,"date":"14:15","sid":134,"lid":246188,"id":13155215,"c1_id":1000519,"c2_id":988679,"prio":null,"number":"284","stats":1,"ross_stats_count":"0","ross_with_stats":54,"ross_count_with_double_chances":54,"bets":[],"score":"*2:1 (8:11, 11:4, 11:7, 0:0)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.15,"id":4248016834,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.7,"id":4248016835,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248052725,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4248052726,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248060001,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":72.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248060002,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"54"},"13155223":{"time":1698405300,"date":"14:15","sid":134,"lid":246188,"id":13155223,"c1_id":996305,"c2_id":988083,"prio":null,"number":"292","stats":1,"ross_stats_count":"0","ross_with_stats":100,"ross_count_with_double_chances":100,"bets":[],"score":"1:1* (8:11, 11:6, 0:1)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248031558,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248031559,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248039269,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248039270,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248054777,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":83.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248054778,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"100","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13155229":{"time":1698406200,"date":"14:30","sid":134,"lid":246188,"id":13155229,"c1_id":1006470,"c2_id":988074,"prio":null,"number":"299","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"0:0* (2:4)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.4,"id":4248054393,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.51,"id":4248054394,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248055365,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4248055366,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248055367,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":74.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248055368,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13155236":{"time":1698406200,"date":"14:30","sid":134,"lid":275434,"id":13155236,"c1_id":988142,"c2_id":994220,"prio":null,"number":"307","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"*0:0 (1:5)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.33,"id":4248052520,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.54,"id":4248052521,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248060139,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4248060140,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248060141,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":74.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248060142,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13155403":{"time":1698405900,"date":"14:25","sid":134,"lid":291678,"id":13155403,"c1_id":1235478,"c2_id":1008824,"prio":null,"number":"369","stats":1,"ross_stats_count":"0","ross_with_stats":34,"ross_count_with_double_chances":34,"bets":[],"score":"*0:1 (10:12, 5:7)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.64,"id":4248041893,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.24,"id":4248041894,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"34"},"13155427":{"time":1698406200,"date":"14:30","sid":134,"lid":291678,"id":13155427,"c1_id":1020838,"c2_id":1020837,"prio":null,"number":"387","stats":1,"ross_stats_count":"0","ross_with_stats":42,"ross_count_with_double_chances":42,"bets":[],"score":"0:0* (5:4)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248054527,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.98,"id":4248054528,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"42"},"13155569":{"time":1698405600,"date":"14:20","sid":134,"lid":291678,"id":13155569,"c1_id":1006756,"c2_id":1007622,"prio":null,"number":"486","stats":1,"ross_stats_count":"0","ross_with_stats":46,"ross_count_with_double_chances":46,"bets":[],"score":"2:1* (11:7, 8:11, 11:5, 0:0)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.26,"id":4248031137,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.44,"id":4248031138,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"46"},"13155617":{"time":1698405300,"date":"14:15","sid":134,"lid":291678,"id":13155617,"c1_id":1077213,"c2_id":1166940,"prio":null,"number":"534","stats":1,"ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"0:3 (9:11, 11:13, 9:11)","color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0"},"13155624":{"time":1698405600,"date":"14:20","sid":134,"lid":291687,"id":13155624,"c1_id":1026029,"c2_id":1157258,"prio":null,"number":"542","stats":1,"ross_stats_count":"0","ross_with_stats":33,"ross_count_with_double_chances":33,"bets":[],"score":"*2:0 (11:9, 11:6, 7:5)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.06,"id":4248040798,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":7.09,"id":4248040799,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"33","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13155631":{"time":1698405900,"date":"14:25","sid":134,"lid":291687,"id":13155631,"c1_id":1164410,"c2_id":1241557,"prio":null,"number":"554","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"1:0* (15:13, 0:0)","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.33,"id":4248046804,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.02,"id":4248046805,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060236,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060237,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248060238,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":84.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248060239,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13155639":{"time":1698400800,"date":"13:00","sid":28,"lid":319434,"id":13155639,"c1_id":554992,"c2_id":442993,"prio":null,"number":"563","stats":1,"ross_stats_count":"0","ross_with_stats":27,"ross_count_with_double_chances":27,"bets":[],"score":"50:42 (20:18, 28:18, 2:6) 8'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247807399,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.94,"id":4247807400,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4247878091,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4247878092,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.92,"id":4247847082,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":161.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.79,"id":4247847083,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"27","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13155867":{"time":1698397200,"date":"12:00","sid":33,"lid":358619,"id":13155867,"c1_id":990948,"c2_id":991811,"prio":null,"number":"657","stats":1,"ross_stats_count":"0","ross_with_stats":65,"ross_count_with_double_chances":65,"bets":[],"score":"1:1 (4:6, 6:3, 4:2) 15:30*","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.11,"id":4247594027,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":6.54,"id":4247594028,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"65","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13155991":{"time":1698406200,"date":"14:30","sid":134,"lid":246593,"id":13155991,"c1_id":1014427,"c2_id":1003921,"prio":null,"number":"766","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"*0:0 (5:5)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2,"id":4248055373,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4248055374,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060435,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060436,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4248060399,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":77.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4248060400,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13155992":{"time":1698406200,"date":"14:30","sid":134,"lid":246593,"id":13155992,"c1_id":1126176,"c2_id":992709,"prio":null,"number":"767","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"*0:0 (3:5)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.08,"id":4248055218,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.66,"id":4248055219,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060069,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060070,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248058520,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":76.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248058521,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13155994":{"time":1698406200,"date":"14:30","sid":134,"lid":246593,"id":13155994,"c1_id":1127230,"c2_id":1114109,"prio":null,"number":"769","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"*0:0 (3:4)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.65,"id":4248056253,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.24,"id":4248056254,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248056255,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248056256,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248060019,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":73.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248060020,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13155996":{"time":1698406200,"date":"14:30","sid":134,"lid":246593,"id":13155996,"c1_id":1257460,"c2_id":1005939,"prio":null,"number":"770","stats":1,"ross_stats_count":"0","ross_with_stats":98,"ross_count_with_double_chances":98,"bets":[],"score":"*0:0 (3:4)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.15,"id":4248054663,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.62,"id":4248054664,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248055154,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248055155,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248059047,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":76.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248059048,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"98"},"13156078":{"time":1698395700,"date":"11:35","sid":33,"lid":247195,"id":13156078,"c1_id":1001691,"c2_id":1009999,"prio":null,"number":"830","stats":1,"ross_stats_count":"0","ross_with_stats":65,"ross_count_with_double_chances":65,"bets":[],"score":"1:1 (7:5, 4:6, 0:3) *40:ADV","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":7.61,"id":4247507466,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.05,"id":4247507467,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"65"},"13156144":{"time":1698405840,"date":"14:24","sid":33,"lid":266625,"id":13156144,"c1_id":1002021,"c2_id":996587,"prio":null,"number":"867","stats":1,"ross_stats_count":"0","ross_with_stats":88,"ross_count_with_double_chances":88,"bets":[],"score":"0:0 (1:0) 0:40*","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.86,"id":4248050975,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4248050976,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-0.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4248055992,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4248055993,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.86,"id":4248050979,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":22.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.84,"id":4248050980,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"88","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156150":{"time":1698402600,"date":"13:30","sid":33,"lid":266553,"id":13156150,"c1_id":969426,"c2_id":835002,"prio":null,"number":"872","stats":1,"ross_stats_count":"0","ross_with_stats":74,"ross_count_with_double_chances":74,"bets":[],"score":"0:1 (2:6, 5:4) 0:0*","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":4.18,"id":4247859635,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.19,"id":4247859636,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"74","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156152":{"time":1698404700,"date":"14:05","sid":33,"lid":264566,"id":13156152,"c1_id":997833,"c2_id":989373,"prio":null,"number":"874","stats":1,"ross_stats_count":"0","ross_with_stats":64,"ross_count_with_double_chances":64,"bets":[],"score":"0:0 (2:3) 30:40*","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4247979650,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247979651,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"64","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156156":{"time":1698404400,"date":"14:00","sid":33,"lid":264566,"id":13156156,"c1_id":1186167,"c2_id":989369,"prio":null,"number":"876","stats":1,"ross_stats_count":"0","ross_with_stats":85,"ross_count_with_double_chances":85,"bets":[],"score":"0:1 (2:6, 0:0) *0:0","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.74,"id":4247943001,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.4,"id":4247943002,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"85","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156160":{"time":1698402300,"date":"13:25","sid":33,"lid":260990,"id":13156160,"c1_id":1000947,"c2_id":1007128,"prio":null,"number":"880","stats":1,"ross_stats_count":"0","ross_with_stats":67,"ross_count_with_double_chances":67,"bets":[],"score":"1:0 (6:4, 1:1) 30:15*","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.01,"id":4247857442,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":11.26,"id":4247857443,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"67"},"13156211":{"time":1698400800,"date":"13:00","sid":28,"lid":260813,"id":13156211,"c1_id":698255,"c2_id":284726,"prio":null,"number":"897","stats":1,"ross_stats_count":"0","ross_with_stats":10,"ross_count_with_double_chances":10,"bets":[],"score":"73:53 (18:14, 26:10, 21:24, 8:5) 7'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":23.75,"id":4247779045,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-17.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247823417,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":17.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247823418,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247783003,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":150.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4247783004,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"10","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156213":{"time":1698400800,"date":"13:00","sid":28,"lid":260813,"id":13156213,"c1_id":500831,"c2_id":282913,"prio":null,"number":"898","stats":1,"ross_stats_count":"0","ross_with_stats":10,"ross_count_with_double_chances":10,"bets":[],"score":"72:61 (28:22, 19:17, 17:17, 8:5) 8'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":14.02,"id":4247768383,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247783301,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4247783302,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4247824100,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":159.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247824101,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"10","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156218":{"time":1698400800,"date":"13:00","sid":28,"lid":263899,"id":13156218,"c1_id":283921,"c2_id":131139,"prio":null,"number":"903","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"73:76 (18:20, 18:24, 21:26, 16:6) 5'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":4.3,"id":4247763568,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.18,"id":4247763569,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4247783705,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247783706,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248045907,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":167.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248045908,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13156231":{"time":1698400800,"date":"13:00","sid":26,"lid":248334,"id":13156231,"c1_id":154858,"c2_id":783794,"prio":null,"number":"911","stats":1,"ross_stats_count":"0","ross_with_stats":109,"ross_count_with_double_chances":114,"bets":[],"score":"3:1 (1:0) 72'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.04,"id":4247761644,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":11.06,"id":4247761645,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":23.18,"id":4247761646,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.01,"id":4247761648,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":8.37,"id":4247761649,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247864611,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.95,"id":4247864612,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.46,"id":4248018167,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4248018168,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"109"},"13156232":{"time":1698400800,"date":"13:00","sid":26,"lid":248416,"id":13156232,"c1_id":68493,"c2_id":133092,"prio":null,"number":"912","stats":1,"statistical_ids":[{"id":"13158599","stat_type":"31","base_stat":1,"name_stas":"Угловые"}],"ross_stats_count":"0","ross_with_stats":100,"ross_count_with_double_chances":105,"bets":[],"score":"1:2 (1:2) 74'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":16.66,"id":4247766123,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.02,"id":4247766124,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.2,"id":4247766125,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":4.04,"id":4247766126,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.13,"id":4247766127,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.25,"id":4247840759,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":3.55,"id":4247840760,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247862441,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247862442,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"100","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156233":{"time":1698400800,"date":"13:00","sid":26,"lid":283492,"id":13156233,"c1_id":175489,"c2_id":849735,"prio":null,"number":"913","stats":1,"ross_stats_count":"0","ross_with_stats":130,"ross_count_with_double_chances":134,"bets":[],"score":"2:0 (2:0) 65'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":24.1,"id":4247791950,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":31.54,"id":4247791951,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":12.33,"id":4247791955,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.15,"id":4247922309,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.62,"id":4247922310,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.25,"id":4247791958,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.57,"id":4247791959,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"130"},"13156235":{"time":1698400800,"date":"13:00","sid":26,"lid":248080,"id":13156235,"c1_id":869643,"c2_id":66797,"prio":null,"number":"915","stats":1,"ross_stats_count":"0","ross_with_stats":167,"ross_count_with_double_chances":173,"bets":[],"score":"1:0 (1:0) 74'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.52,"id":4247768968,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.4,"id":4247768969,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.83,"id":4247768970,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4247768971,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.29,"id":4247768972,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.43,"id":4247768973,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.92,"id":4247897455,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.37,"id":4247897456,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.55,"id":4248034250,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2},{"cls_vis":"","sfs":false,"fbt":false,"h":2.35,"id":4248034251,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"167","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156238":{"time":1698400800,"date":"13:00","sid":26,"lid":248080,"id":13156238,"c1_id":1069072,"c2_id":526488,"prio":null,"number":"918","stats":1,"ross_stats_count":"0","ross_with_stats":125,"ross_count_with_double_chances":130,"bets":[],"score":"2:1 (2:0) 72'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.21,"id":4247770515,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.1,"id":4247770516,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":14.79,"id":4247770517,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.13,"id":4247770519,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":3.93,"id":4247770520,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.63,"id":4247854557,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.43,"id":4247854558,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.48,"id":4247770523,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247770524,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"125"},"13156242":{"time":1698404400,"date":"14:00","sid":26,"lid":246432,"id":13156242,"c1_id":38864,"c2_id":1179436,"prio":null,"number":"922","stats":1,"statistical_ids":[{"id":"13159118","stat_type":"23","base_stat":1,"name_stas":"Желтые карточки"},{"id":"13159119","stat_type":"31","base_stat":1,"name_stas":"Угловые"}],"ross_stats_count":"0","ross_with_stats":374,"ross_count_with_double_chances":381,"bets":[],"score":"1:0 31'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.2,"id":4247953560,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":5.72,"id":4247953561,"o":2,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":15.59,"id":4247953562,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.12,"id":4247953564,"o":5,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":4.23,"id":4247953565,"o":6,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.13,"id":4248019585,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.67,"id":4248019586,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4248019587,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.28,"id":4248019588,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"374","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13156245":{"time":1698404400,"date":"14:00","sid":26,"lid":354958,"id":13156245,"c1_id":547061,"c2_id":71324,"prio":null,"number":"925","stats":1,"ross_stats_count":"0","ross_with_stats":241,"ross_count_with_double_chances":248,"bets":[],"score":"0:1 31'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":14.68,"id":4247955425,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.87,"id":4247955426,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.14,"id":4247955427,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":4.9,"id":4247955428,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.07,"id":4247955429,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.19,"id":4247955431,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.6,"id":4247955432,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.36,"id":4247955433,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.52,"id":4247955434,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"241"},"13156246":{"time":1698404400,"date":"14:00","sid":26,"lid":358680,"id":13156246,"c1_id":70174,"c2_id":69474,"prio":null,"number":"926","stats":1,"ross_stats_count":"0","ross_with_stats":261,"ross_count_with_double_chances":270,"bets":[],"score":"0:0 31'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.41,"id":4247954101,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.11,"id":4247954102,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.03,"id":4247954103,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.07,"id":4247954104,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.19,"id":4247954105,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.69,"id":4247954106,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.22,"id":4247954107,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4247954108,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.66,"id":4247973421,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.09,"id":4247973422,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"261"},"13156247":{"time":1698404400,"date":"14:00","sid":26,"lid":252564,"id":13156247,"c1_id":477190,"c2_id":477192,"prio":null,"number":"927","stats":1,"ross_stats_count":"0","ross_with_stats":226,"ross_count_with_double_chances":234,"bets":[],"score":"1:0 30'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.53,"id":4247954938,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.02,"id":4247954939,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.22,"id":4247954940,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.12,"id":4247954941,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.2,"id":4247954942,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.34,"id":4247954943,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.64,"id":4248009316,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.42,"id":4248009317,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.57,"id":4248009318,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.25,"id":4248009319,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"226"},"13156257":{"time":1698404400,"date":"14:00","sid":26,"lid":262482,"id":13156257,"c1_id":220673,"c2_id":512825,"prio":null,"number":"928","stats":1,"ross_stats_count":"0","ross_with_stats":234,"ross_count_with_double_chances":243,"bets":[],"score":"0:0 32'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.75,"id":4247954448,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5,"id":4247954449,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.04,"id":4247954450,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.33,"id":4247954451,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.47,"id":4247954452,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.39,"id":4247954453,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.76,"id":4247954454,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.95,"id":4247954455,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.66,"id":4247954456,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.09,"id":4247954457,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"234"},"13156258":{"time":1698406200,"date":"14:30","sid":26,"lid":354958,"id":13156258,"c1_id":32531,"c2_id":78355,"prio":null,"number":"929","stats":1,"ross_stats_count":"0","ross_with_stats":279,"ross_count_with_double_chances":288,"bets":[],"color":"e","description":[{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248058115,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":3.44,"id":4248058116,"o":2,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":3.53,"id":4248058117,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.25,"id":4248058118,"o":4,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.27,"id":4248058119,"o":5,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.78,"id":4248058120,"o":6,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.43,"id":4248058121,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.62,"id":4248058122,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.71,"id":4248058123,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.01,"id":4248058124,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"279"},"13156272":{"time":1698405300,"date":"14:15","sid":134,"lid":291687,"id":13156272,"c1_id":1260398,"c2_id":1007627,"prio":null,"number":"940","stats":1,"ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"3:1 (11:9, 7:11, 11:3, 11:8)","video_type":[3],"color":"o","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157041":{"time":1698400800,"date":"13:00","sid":33,"lid":265815,"id":13157041,"c1_id":1240123,"c2_id":1185381,"prio":null,"number":"156","stats":1,"ross_stats_count":"0","ross_with_stats":40,"ross_count_with_double_chances":40,"bets":[],"score":"0:1 (4:6, 3:2) 30:30*","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.65,"id":4247889430,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.24,"id":4247889431,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"40"},"13157062":{"time":1698401700,"date":"13:15","sid":33,"lid":281132,"id":13157062,"c1_id":995743,"c2_id":1060097,"prio":null,"number":"170","stats":1,"ross_stats_count":"0","ross_with_stats":74,"ross_count_with_double_chances":74,"bets":[],"score":"1:0 (7:6, 0:3) *0:15","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.94,"id":4247824466,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247824467,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"74","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157064":{"time":1698402600,"date":"13:30","sid":33,"lid":281134,"id":13157064,"c1_id":999230,"c2_id":1075812,"prio":null,"number":"171","stats":1,"ross_stats_count":"0","ross_with_stats":75,"ross_count_with_double_chances":75,"bets":[],"score":"1:0 (6:1, 2:4) *15:15","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.61,"id":4247879445,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.18,"id":4247879446,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4247936893,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4247936894,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4248021241,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":25.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248021242,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"75","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157067":{"time":1698403800,"date":"13:50","sid":33,"lid":281134,"id":13157067,"c1_id":995157,"c2_id":1089769,"prio":null,"number":"173","stats":1,"ross_stats_count":"0","ross_with_stats":64,"ross_count_with_double_chances":64,"bets":[],"score":"0:1 (0:6, 1:1) *40:0","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.6,"id":4247922804,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.43,"id":4247922805,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4248024492,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248024493,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247938631,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":21.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247938632,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"64","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157176":{"time":1698402900,"date":"13:35","sid":33,"lid":264601,"id":13157176,"c1_id":1002464,"c2_id":996476,"prio":null,"number":"243","stats":1,"ross_stats_count":"0","ross_with_stats":61,"ross_count_with_double_chances":61,"bets":[],"score":"1:0 (6:2, 3:4) *40:30","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.14,"id":4247888544,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.95,"id":4247888545,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"61"},"13157178":{"time":1698402300,"date":"13:25","sid":33,"lid":264315,"id":13157178,"c1_id":1038039,"c2_id":1297129,"prio":null,"number":"245","stats":1,"ross_stats_count":"0","ross_with_stats":12,"ross_count_with_double_chances":12,"bets":[],"score":"1:1 (4:6, 6:3, 0:0) 8:7*","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247787041,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.46,"id":4247787042,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"12","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157181":{"time":1698401100,"date":"13:05","sid":33,"lid":264315,"id":13157181,"c1_id":1296499,"c2_id":1292867,"prio":null,"number":"248","stats":1,"ross_stats_count":"0","ross_with_stats":10,"ross_count_with_double_chances":10,"bets":[],"score":"0:1 (4:6, 6:5) 30:15*","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.91,"id":4247797634,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.21,"id":4247797635,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"10","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157312":{"time":1698396300,"date":"11:45","sid":33,"lid":265813,"id":13157312,"c1_id":1015034,"c2_id":994848,"prio":null,"number":"270","stats":1,"ross_stats_count":"0","ross_with_stats":21,"ross_count_with_double_chances":21,"bets":[],"score":"1:0 (6:2, 6:5) 30:40*","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247738797,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.94,"id":4247738798,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"21"},"13157391":{"time":1698404400,"date":"14:00","sid":28,"lid":261482,"id":13157391,"c1_id":290574,"c2_id":487748,"prio":null,"number":"328","stats":1,"ross_stats_count":"0","ross_with_stats":35,"ross_count_with_double_chances":35,"bets":[],"score":"29:38 (21:24, 8:14) 6'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":6.45,"id":4247959209,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.08,"id":4247959210,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":14.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248008956,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-14.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248008957,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248024785,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":176.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248024786,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"35"},"13157450":{"time":1698400500,"date":"12:55","sid":41,"lid":308836,"id":13157450,"c1_id":573584,"c2_id":573199,"prio":null,"number":"341","stats":1,"ross_stats_count":"0","ross_with_stats":50,"ross_count_with_double_chances":50,"bets":[],"score":"1:2* (21:25, 19:25, 25:16, 1:2)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.46,"id":4247810053,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247810054,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":0.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247837884,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-0.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4247837885,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248038241,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":195.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248038242,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"50"},"13157452":{"time":1698400800,"date":"13:00","sid":28,"lid":260311,"id":13157452,"c1_id":928587,"c2_id":303590,"prio":null,"number":"342","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"50:41 (9:16, 21:14, 20:11) 1'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.1,"id":4247758641,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.68,"id":4247758642,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248039335,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248039336,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248018354,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":135.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248018355,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13157453":{"time":1698402900,"date":"13:35","sid":28,"lid":270410,"id":13157453,"c1_id":486848,"c2_id":486849,"prio":null,"number":"343","stats":1,"ross_stats_count":"0","ross_with_stats":99,"ross_count_with_double_chances":99,"bets":[],"score":"36:42 (9:20, 27:22, 0:0) 10'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.7,"id":4247894737,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.07,"id":4247894738,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-2},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4247912529,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247912530,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4247929266,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":169.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.92,"id":4247929267,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"99","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157465":{"time":1698404400,"date":"14:00","sid":28,"lid":262105,"id":13157465,"c1_id":1021948,"c2_id":587727,"prio":null,"number":"350","stats":1,"ross_stats_count":"0","ross_with_stats":35,"ross_count_with_double_chances":35,"bets":[],"score":"32:27 (19:22, 13:5) 7'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.18,"id":4247961944,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.34,"id":4247961945,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4247965695,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4247965696,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4247975131,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":171.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247975132,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"35","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157472":{"time":1698404100,"date":"13:55","sid":41,"lid":261586,"id":13157472,"c1_id":82893,"c2_id":62691,"prio":null,"number":"354","stats":1,"ross_stats_count":"0","ross_with_stats":89,"ross_count_with_double_chances":89,"score":"0:1* (6:25, 3:13)","color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"89"},"13157480":{"time":1698404100,"date":"13:55","sid":41,"lid":265288,"id":13157480,"c1_id":939528,"c2_id":418497,"prio":null,"number":"358","stats":1,"ross_stats_count":"0","ross_with_stats":105,"ross_count_with_double_chances":105,"bets":[],"score":"*1:0 (25:18, 10:9)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-21.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248033989,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":21.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248033990,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4248059846,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":129.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248059847,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"105"},"13157560":{"time":1698405000,"date":"14:10","sid":33,"lid":247195,"id":13157560,"c1_id":1029896,"c2_id":1118510,"prio":null,"number":"395","stats":1,"ross_stats_count":"0","ross_with_stats":69,"ross_count_with_double_chances":69,"bets":[],"score":"0:0 (3:2) *0:30","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.14,"id":4248001513,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.31,"id":4248001514,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"69"},"13157564":{"time":1698403500,"date":"13:45","sid":33,"lid":247195,"id":13157564,"c1_id":1055829,"c2_id":1297837,"prio":null,"number":"405","stats":1,"ross_stats_count":"0","ross_with_stats":62,"ross_count_with_double_chances":62,"bets":[],"score":"0:0 (5:4) *30:30","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.12,"id":4247926719,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.4,"id":4247926720,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"62"},"13157615":{"time":1698395400,"date":"11:30","sid":533,"lid":353071,"id":13157615,"c1_id":405413,"c2_id":400434,"prio":null,"number":"428","stats":0,"ross_stats_count":"0","ross_with_stats":2,"ross_count_with_double_chances":2,"bets":[],"score":"219/5 - 0/0","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247522986,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247522988,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"2","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157707":{"time":1698399300,"date":"12:35","sid":33,"lid":264385,"id":13157707,"c1_id":1014930,"c2_id":1019266,"prio":null,"number":"463","stats":1,"ross_stats_count":"0","ross_with_stats":48,"ross_count_with_double_chances":48,"bets":[],"score":"1:1 (6:7, 6:3, 0:0) ADV:40*","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.17,"id":4247686099,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.46,"id":4247686100,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"48"},"13157709":{"time":1698399300,"date":"12:35","sid":33,"lid":264385,"id":13157709,"c1_id":1055933,"c2_id":1016825,"prio":null,"number":"465","stats":1,"ross_stats_count":"0","ross_with_stats":70,"ross_count_with_double_chances":70,"bets":[],"score":"1:1 (6:7, 6:2, 1:0) 30:30*","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.19,"id":4247687152,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":4.18,"id":4247687153,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"70"},"13157722":{"time":1698400500,"date":"12:55","sid":33,"lid":358593,"id":13157722,"c1_id":1060713,"c2_id":1028160,"prio":null,"number":"467","stats":1,"ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"1:0 (7:6, 5:3) *30:0","video_type":[3],"color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13157727":{"time":1698406020,"date":"14:27","sid":33,"lid":358593,"id":13157727,"c1_id":1296632,"c2_id":1066629,"prio":null,"number":"468","stats":1,"ross_stats_count":"0","ross_with_stats":46,"ross_count_with_double_chances":46,"bets":[],"score":"0:0 (0:1) 15:0*","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.65,"id":4248049936,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.24,"id":4248049937,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"46","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158228":{"time":1698400800,"date":"13:00","sid":28,"lid":261625,"id":13158228,"c1_id":1289331,"c2_id":1290111,"prio":null,"number":"620","stats":1,"ross_stats_count":"0","ross_with_stats":46,"ross_count_with_double_chances":46,"bets":[],"score":"66:56 (19:19, 24:23, 23:14) П","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.1,"id":4247767671,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":6.24,"id":4247767672,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247787317,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4247787318,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4247820170,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":163.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4247820171,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"46","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158233":{"time":1698400800,"date":"13:00","sid":28,"lid":261625,"id":13158233,"c1_id":1289611,"c2_id":1289332,"prio":null,"number":"621","stats":1,"ross_stats_count":"0","ross_with_stats":46,"ross_count_with_double_chances":46,"bets":[],"score":"64:51 (20:17, 19:17, 21:13, 4:4) 8'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.01,"id":4247764721,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":12.39,"id":4247764722,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247975458,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247975459,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.86,"id":4248018892,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":149.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4248018893,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"46","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158234":{"time":1698402900,"date":"13:35","sid":33,"lid":318046,"id":13158234,"c1_id":1213157,"c2_id":1194213,"prio":null,"number":"622","stats":1,"ross_stats_count":"0","ross_with_stats":36,"ross_count_with_double_chances":36,"bets":[],"score":"1:0 (6:4, 0:0) *40:15","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.02,"id":4247921242,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":10.18,"id":4247921243,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"36"},"13158238":{"time":1698400800,"date":"13:00","sid":28,"lid":260360,"id":13158238,"c1_id":109759,"c2_id":160927,"prio":null,"number":"626","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"61:50 (18:17, 20:12, 18:15, 5:6) 7'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":20.3,"id":4247763482,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-13.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.76,"id":4247765585,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":13.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.94,"id":4247765586,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248049557,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":136.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248049558,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13158241":{"time":1698400800,"date":"13:00","sid":28,"lid":260311,"id":13158241,"c1_id":1158344,"c2_id":594956,"prio":null,"number":"628","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"50:52 (17:19, 14:18, 19:15) П","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.88,"id":4247769994,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.36,"id":4247769995,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247772659,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4247772660,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248021597,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":144.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248021598,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13158274":{"time":1698399000,"date":"12:30","sid":533,"lid":357336,"id":13158274,"c1_id":499055,"c2_id":791418,"prio":null,"number":"653","stats":0,"ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"bets":[],"score":"150/6 - 27/2","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.3,"id":4247664788,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5,"id":4247664790,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158275":{"time":1698399000,"date":"12:30","sid":27,"lid":253764,"id":13158275,"c1_id":157912,"c2_id":349321,"prio":null,"number":"654","stats":0,"ross_stats_count":"0","ross_with_stats":4,"ross_count_with_double_chances":4,"bets":[],"score":"4:6 (2:0, 1:3) 59'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.34,"id":4248021635,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":3.07,"id":4248021636,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.79,"id":4248058578,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248058579,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"4","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158414":{"time":1698404400,"date":"14:00","sid":41,"lid":260383,"id":13158414,"c1_id":608469,"c2_id":135554,"prio":null,"number":"675","stats":1,"ross_stats_count":"0","ross_with_stats":43,"ross_count_with_double_chances":43,"score":"*1:0 (25:15, 12:7)","video_type":[3],"color":"o","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"43","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158426":{"time":1698405000,"date":"14:10","sid":28,"lid":305759,"id":13158426,"c1_id":1143960,"c2_id":1253313,"prio":null,"number":"681","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"17:17 (17:17) 1'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.4,"id":4248006426,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.51,"id":4248006427,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248007277,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248007278,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248007385,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":128.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248007386,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13158432":{"time":1698404100,"date":"13:55","sid":41,"lid":265161,"id":13158432,"c1_id":939528,"c2_id":137951,"prio":null,"number":"688","stats":1,"ross_stats_count":"0","ross_with_stats":108,"ross_count_with_double_chances":108,"bets":[],"score":"*1:0 (25:20, 7:4)","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.02,"id":4247944758,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":11.74,"id":4247944759,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-19.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.75,"id":4247967393,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":19.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.96,"id":4247967394,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4247956990,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":132.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247956991,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"108"},"13158495":{"time":1698400800,"date":"13:00","sid":41,"lid":262728,"id":13158495,"c1_id":935263,"c2_id":61005,"prio":null,"number":"710","stats":1,"ross_stats_count":"0","ross_with_stats":26,"ross_count_with_double_chances":26,"bets":[],"score":"*2:0 (25:21, 25:23, 18:24)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.64,"id":4247763792,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.17,"id":4247763793,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247846379,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4247846380,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248050442,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":206.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248050443,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"26","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158499":{"time":1698400800,"date":"13:00","sid":26,"lid":283492,"id":13158499,"c1_id":511086,"c2_id":142056,"prio":null,"number":"713","stats":1,"ross_stats_count":"0","ross_with_stats":125,"ross_count_with_double_chances":129,"bets":[],"score":"2:0 (2:0) 71'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":24.56,"id":4247783382,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":31.65,"id":4247783383,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":12.33,"id":4247783386,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.41,"id":4247863945,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5,"id":4247863946,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4247783389,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4247783390,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"125","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158592":{"time":1698400800,"date":"13:00","sid":26,"lid":246333,"id":13158592,"c1_id":32772,"c2_id":67713,"prio":null,"number":"749","stats":0,"statistical_ids":[{"id":"13158617","stat_type":"31","base_stat":1,"name_stas":"Угловые"},{"id":"13158618","stat_type":"23","base_stat":1,"name_stas":"Желтые карточки"}],"ross_stats_count":"8","ross_with_stats":67,"ross_count_with_double_chances":59,"bets":[],"score":"1:0 (0:0) 66' 11x10","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.1,"id":4247757764,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":13.63,"id":4247757765,"o":2,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":101.1,"id":4247757766,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"59","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158595":{"time":1698400800,"date":"13:00","sid":27,"lid":258499,"id":13158595,"c1_id":801187,"c2_id":404482,"prio":null,"number":"752","stats":0,"ross_stats_count":"0","ross_with_stats":55,"ross_count_with_double_chances":55,"bets":[],"score":"4:1 (1:1, 3:0) П","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4247758708,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.98,"id":4247758709,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4247758710,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4247758711,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"55","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158599":{"time":1698400800,"date":"13:00","sid":26,"lid":292254,"id":13158599,"c1_id":350276,"c2_id":362074,"prio":null,"number":"772","stats":0,"parent_game_id":"13156232","parent_league_id":"248416","ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"1:2 (0:2) 74'","color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0"},"13158617":{"time":1698400800,"date":"13:00","sid":26,"lid":246792,"id":13158617,"c1_id":327288,"c2_id":237405,"prio":null,"number":"782","stats":0,"parent_game_id":"13158592","parent_league_id":"246333","ross_stats_count":"0","ross_with_stats":4,"ross_count_with_double_chances":4,"score":"5:2 (3:2) 66'","color":"o","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"4"},"13158618":{"time":1698400800,"date":"13:00","sid":26,"lid":246792,"id":13158618,"c1_id":454286,"c2_id":463085,"prio":null,"number":"783","stats":0,"parent_game_id":"13158592","parent_league_id":"246333","ross_stats_count":"0","ross_with_stats":4,"ross_count_with_double_chances":4,"bets":[],"score":"0:0 (0:0) 66'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.67,"id":4247777757,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.32,"id":4247777758,"o":2,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.67,"id":4247777759,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.19,"id":4247899638,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.62,"id":4247899639,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.59,"id":4247909502,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.25,"id":4247909503,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"4"},"13158626":{"time":1698401100,"date":"13:05","sid":33,"lid":264605,"id":13158626,"c1_id":995371,"c2_id":1005206,"prio":null,"number":"790","stats":0,"ross_stats_count":"0","ross_with_stats":89,"ross_count_with_double_chances":89,"bets":[],"score":"1:0 (7:5, 4:3) *0:0","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.03,"id":4247782511,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":10.07,"id":4247782512,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"89"},"13158634":{"time":1698400800,"date":"13:00","sid":177,"lid":321909,"id":13158634,"c1_id":1097279,"c2_id":533009,"prio":null,"number":"792","stats":0,"ross_stats_count":"0","ross_with_stats":2,"ross_count_with_double_chances":2,"bets":[],"score":"3:0 (2:0) 39'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":3.81,"id":4247892410,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.22,"id":4247892411,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.37,"id":4247848798,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.85,"id":4247848799,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"2","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158645":{"time":1698400800,"date":"13:00","sid":26,"lid":253670,"id":13158645,"c1_id":1298850,"c2_id":1103873,"prio":null,"number":"798","stats":1,"ross_stats_count":"0","ross_with_stats":88,"ross_count_with_double_chances":89,"bets":[],"score":"6:0 (4:0) 76'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":32.29,"id":4247802309,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":32.29,"id":4247802310,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":12.33,"id":4247802313,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.67,"id":4247912817,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.08,"id":4247912818,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.71,"id":4247886626,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.4,"id":4247886627,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"88"},"13158706":{"time":1698402600,"date":"13:30","sid":26,"lid":347536,"id":13158706,"c1_id":518569,"c2_id":744519,"prio":null,"number":"807","stats":1,"ross_stats_count":"0","ross_with_stats":208,"ross_count_with_double_chances":214,"bets":[],"score":"0:0 (0:0) П","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.29,"id":4247883583,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.3,"id":4247883584,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.82,"id":4247883585,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.38,"id":4247883586,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.55,"id":4247883587,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.29,"id":4247883588,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.01,"id":4247883589,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4247883590,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247912503,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.46,"id":4247912504,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"208","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158718":{"time":1698404400,"date":"14:00","sid":26,"lid":248663,"id":13158718,"c1_id":320516,"c2_id":852469,"prio":null,"number":"811","stats":1,"ross_stats_count":"0","ross_with_stats":209,"ross_count_with_double_chances":218,"bets":[],"score":"0:0 29'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.12,"id":4247968263,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.48,"id":4247968264,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3,"id":4247968265,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.34,"id":4247968266,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.26,"id":4247968267,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.64,"id":4247968268,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4247968269,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.23,"id":4247968270,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248033059,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248033060,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"209"},"13158723":{"time":1698405300,"date":"14:15","sid":26,"lid":248663,"id":13158723,"c1_id":523081,"c2_id":449616,"prio":null,"number":"814","stats":1,"ross_stats_count":"0","ross_with_stats":251,"ross_count_with_double_chances":260,"bets":[],"score":"0:0 11'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":10.76,"id":4248034998,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.2,"id":4248034999,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.16,"id":4248035000,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":4.57,"id":4248035001,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4248035002,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.01,"id":4248035003,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.69,"id":4248039567,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.04,"id":4248039568,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.09,"id":4248035006,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.66,"id":4248035007,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"251"},"13158726":{"time":1698404400,"date":"14:00","sid":26,"lid":248663,"id":13158726,"c1_id":718782,"c2_id":107603,"prio":null,"number":"815","stats":1,"ross_stats_count":"0","ross_with_stats":22,"ross_count_with_double_chances":22,"bets":[],"score":"3:0 32'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248014238,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4248014239,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248014240,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4248014241,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"22"},"13158737":{"time":1698404400,"date":"14:00","sid":26,"lid":253775,"id":13158737,"c1_id":194139,"c2_id":281392,"prio":null,"number":"817","stats":1,"ross_stats_count":"0","ross_with_stats":220,"ross_count_with_double_chances":227,"bets":[],"score":"0:1 32'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":20.15,"id":4247957230,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":8.25,"id":4247957231,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.08,"id":4247957232,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":6.45,"id":4247957233,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.04,"id":4247957234,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.31,"id":4247957236,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.54,"id":4247957237,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4247957238,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4247957239,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"220"},"13158741":{"time":1698404400,"date":"14:00","sid":26,"lid":249768,"id":13158741,"c1_id":174459,"c2_id":347511,"prio":null,"number":"819","stats":1,"ross_stats_count":"0","ross_with_stats":208,"ross_count_with_double_chances":216,"bets":[],"score":"0:1 30'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.98,"id":4247966280,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.16,"id":4247966281,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247966282,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.8,"id":4247966283,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.31,"id":4247966284,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.21,"id":4247966285,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.87,"id":4247966286,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.37,"id":4247966287,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248008414,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248008415,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"208"},"13158787":{"time":1698404400,"date":"14:00","sid":26,"lid":252382,"id":13158787,"c1_id":362078,"c2_id":1284737,"prio":null,"number":"859","stats":1,"ross_stats_count":"0","ross_with_stats":347,"ross_count_with_double_chances":355,"bets":[],"score":"0:1 31'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":8.68,"id":4247961170,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5,"id":4247961171,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247961172,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":3.04,"id":4247961173,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.18,"id":4247961174,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.05,"id":4247961175,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.17,"id":4248026383,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.64,"id":4248026384,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248036839,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4248036840,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"347"},"13158807":{"time":1698404400,"date":"14:00","sid":26,"lid":253367,"id":13158807,"c1_id":879453,"c2_id":1291211,"prio":null,"number":"884","stats":1,"ross_stats_count":"0","ross_with_stats":229,"ross_count_with_double_chances":238,"bets":[],"score":"1:0 14'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.34,"id":4248025154,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.2,"id":4248025155,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.38,"id":4248025156,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.08,"id":4248025157,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.13,"id":4248025158,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.99,"id":4248025159,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248055815,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248055816,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.56,"id":4248055817,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.27,"id":4248055818,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"229"},"13158885":{"time":1698400800,"date":"13:00","sid":26,"lid":358680,"id":13158885,"c1_id":56711,"c2_id":82318,"prio":null,"number":"959","stats":1,"ross_stats_count":"0","ross_with_stats":61,"ross_count_with_double_chances":62,"bets":[],"score":"5:0 (2:0) 74'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":32.29,"id":4247870378,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":32.29,"id":4247870379,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":12.33,"id":4247870382,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.34,"id":4247870383,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.53,"id":4247870384,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4247870385,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.23,"id":4247870386,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"61"},"13158905":{"time":1698400800,"date":"13:00","sid":28,"lid":326745,"id":13158905,"c1_id":1298862,"c2_id":1298863,"prio":null,"number":"976","stats":1,"ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":14,"bets":[],"score":"31:61 (13:25, 9:20, 9:16, 0:0) 9'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":36.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.79,"id":4247906494,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-36.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4247906495,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248059291,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":121.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248059292,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13158910":{"time":1698404400,"date":"14:00","sid":41,"lid":262392,"id":13158910,"c1_id":200433,"c2_id":83098,"prio":null,"number":"979","stats":1,"ross_stats_count":"0","ross_with_stats":36,"ross_count_with_double_chances":36,"bets":[],"score":"*1:0 (25:18, 12:8)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-26.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4247968007,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":26.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247968008,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4247968023,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":123.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247968024,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"36"},"13158911":{"time":1698402900,"date":"13:35","sid":28,"lid":306137,"id":13158911,"c1_id":1135799,"c2_id":1210438,"prio":null,"number":"980","stats":0,"ross_stats_count":"0","ross_with_stats":47,"ross_count_with_double_chances":47,"bets":[],"score":"66:63 (20:21, 17:25, 29:17) П","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.49,"id":4247867083,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.43,"id":4247867084,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4247914995,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.78,"id":4247914996,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4247949240,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":176.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4247949241,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"47"},"13158932":{"time":1698404400,"date":"14:00","sid":26,"lid":249768,"id":13158932,"c1_id":62268,"c2_id":719097,"prio":null,"number":"981","stats":1,"ross_stats_count":"0","ross_with_stats":223,"ross_count_with_double_chances":232,"bets":[],"score":"0:0 27'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4247983502,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.55,"id":4247983503,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.41,"id":4247983504,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4247983505,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.25,"id":4247983506,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.47,"id":4247983507,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.55,"id":4248002587,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.45,"id":4248002588,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.2,"id":4248032211,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.6,"id":4248032212,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"223"},"13158933":{"time":1698404400,"date":"14:00","sid":26,"lid":249768,"id":13158933,"c1_id":338737,"c2_id":341858,"prio":null,"number":"982","stats":1,"ross_stats_count":"0","ross_with_stats":228,"ross_count_with_double_chances":237,"bets":[],"score":"1:1 33'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.29,"id":4247950938,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":2.6,"id":4247950940,"o":2,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":3.67,"id":4247950942,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.24,"id":4247950944,"o":4,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.44,"id":4247950946,"o":5,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.55,"id":4247950948,"o":6,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5,"id":4247950950,"o":7,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.41,"id":4247950952,"o":8,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248003543,"o":9,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4248003544,"o":10,"t":"cf","st":1}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"228"},"13158946":{"time":1698401700,"date":"13:15","sid":27,"lid":317641,"id":13158946,"c1_id":317320,"c2_id":222948,"prio":null,"number":"993","stats":0,"ross_stats_count":"0","ross_with_stats":75,"ross_count_with_double_chances":80,"bets":[],"score":"4:0 (4:0) 35' 4x5","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.94,"id":4247884021,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.74,"id":4247884022,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.08,"id":4248057065,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.63,"id":4248057066,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"75","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13158957":{"time":1698403500,"date":"13:45","sid":556,"lid":357276,"id":13158957,"c1_id":947395,"c2_id":770872,"prio":null,"number":"103","stats":0,"ross_stats_count":"0","ross_with_stats":10,"ross_count_with_double_chances":10,"bets":[],"score":"0:1 (6:13, 0:0)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":4.19,"id":4247887122,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.19,"id":4247887123,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"10"},"13158976":{"time":1698399000,"date":"12:30","sid":26,"lid":303873,"id":13158976,"c1_id":325333,"c2_id":514649,"prio":null,"number":"115","stats":0,"ross_stats_count":"0","ross_with_stats":198,"ross_count_with_double_chances":204,"bets":[],"score":"1:0 (1:0) 56'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4247899387,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.08,"id":4247899388,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.13,"id":4247899389,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.15,"id":4247902846,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.27,"id":4247902847,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.71,"id":4247902848,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.35,"id":4247902849,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.94,"id":4247902850,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.69,"id":4247902851,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.05,"id":4247902852,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"198"},"13158977":{"time":1698405900,"date":"14:25","sid":134,"lid":312893,"id":13158977,"c1_id":1007561,"c2_id":1189795,"prio":null,"number":"116","stats":1,"ross_stats_count":"0","ross_with_stats":18,"ross_count_with_double_chances":18,"bets":[],"score":"*0:0 (10:4)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.46,"id":4248048290,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.52,"id":4248048291,"o":3,"t":"cf","st":1},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"18","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159000":{"time":1698404400,"date":"14:00","sid":33,"lid":279892,"id":13159000,"c1_id":1011289,"c2_id":1010607,"prio":null,"number":"138","stats":1,"ross_stats_count":"0","ross_with_stats":69,"ross_count_with_double_chances":69,"bets":[],"score":"0:0 (2:3) *0:15","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.91,"id":4247951322,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.21,"id":4247951323,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"69"},"13159027":{"time":1698402600,"date":"13:30","sid":317,"lid":359100,"id":13159027,"c1_id":125265,"c2_id":329611,"prio":null,"number":"148","stats":0,"ross_stats_count":"0","ross_with_stats":30,"ross_count_with_double_chances":30,"bets":[],"score":"1:0 (1:0, 0:0) 32'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4247919595,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.94,"id":4247919596,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.52,"id":4247921003,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.36,"id":4247921004,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"30"},"13159038":{"time":1698403380,"date":"13:43","sid":235,"lid":267793,"id":13159038,"c1_id":1298142,"c2_id":1226125,"prio":null,"number":"159","stats":0,"ross_stats_count":"0","ross_with_stats":6,"ross_count_with_double_chances":6,"bets":[],"score":"1:0* (21:19, 15:16)","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.52,"id":4247915579,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.36,"id":4247915580,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"6","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159048":{"time":1698404400,"date":"14:00","sid":272,"lid":359118,"id":13159048,"c1_id":1062830,"c2_id":1013720,"prio":null,"number":"187","stats":0,"ross_stats_count":"0","ross_with_stats":8,"ross_count_with_double_chances":8,"bets":[],"score":"*0:1 (90:0)","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.24,"id":4247923668,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4247923669,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.67,"id":4247923670,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.07,"id":4247923671,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.25,"id":4248023041,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.57,"id":4248023042,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"8","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159071":{"time":1698403980,"date":"13:53","sid":235,"lid":264546,"id":13159071,"c1_id":410137,"c2_id":1065112,"prio":null,"number":"211","stats":0,"ross_stats_count":"0","ross_with_stats":30,"ross_count_with_double_chances":30,"bets":[],"score":"1:0* (21:15, 7:8)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.12,"id":4247933589,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.3,"id":4247933590,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4247990778,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":8.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2,"id":4247990779,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2,"id":4248015230,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":75.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4248015231,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"30","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159079":{"time":1698405300,"date":"14:15","sid":556,"lid":358921,"id":13159079,"c1_id":1278179,"c2_id":1272746,"prio":null,"number":"220","stats":0,"ross_stats_count":"0","ross_with_stats":38,"ross_count_with_double_chances":38,"bets":[],"score":"0:0 (11:4)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.1,"id":4247941499,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":5.8,"id":4247941500,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.43,"id":4247941501,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.61,"id":4247941502,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.42,"id":4247941503,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.65,"id":4247941504,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"38","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159082":{"time":1698402600,"date":"13:30","sid":556,"lid":358667,"id":13159082,"c1_id":585350,"c2_id":607208,"prio":null,"number":"222","stats":0,"ross_stats_count":"0","ross_with_stats":58,"ross_count_with_double_chances":58,"bets":[],"score":"0:0 (4:2)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.13,"id":4247941330,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.63,"id":4247941331,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.36,"id":4247941332,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.91,"id":4247941333,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.84,"id":4247941334,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.86,"id":4247941335,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"58","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159097":{"time":1698404400,"date":"14:00","sid":337,"lid":359038,"id":13159097,"c1_id":1298548,"c2_id":1213689,"prio":null,"number":"230","stats":0,"ross_stats_count":"0","ross_with_stats":8,"ross_count_with_double_chances":8,"score":"0:1* (10:21, 12:19)","color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"8"},"13159112":{"time":1698404400,"date":"14:00","sid":27,"lid":253049,"id":13159112,"c1_id":68894,"c2_id":103737,"prio":null,"number":"239","stats":0,"statistical_ids":[{"id":"13159113","stat_type":"3","base_stat":0,"name_stas":"Выигранные вбрасывания"},{"id":"13159114","stat_type":"8","base_stat":0,"name_stas":"Голы в большинстве"},{"id":"13159115","stat_type":"54","base_stat":1,"name_stas":"Штрафное время"}],"ross_stats_count":"42","ross_with_stats":212,"ross_count_with_double_chances":179,"bets":[],"score":"1:0 (1:0) П","video_type":[3],"color":"o","description":[{},{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.45,"id":4247954769,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.93,"id":4247954772,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.32,"id":4247954773,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.12,"id":4247954774,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.14,"id":4247954775,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.5,"id":4247954776,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248003917,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.84,"id":4248003918,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.3,"id":4248052498,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4248052499,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"170","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159113":{"time":1698404400,"date":"14:00","sid":27,"lid":253711,"id":13159113,"c1_id":1289967,"c2_id":1291768,"prio":null,"number":"240","stats":0,"parent_game_id":"13159112","parent_league_id":"253049","ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":19,"bets":[],"score":"9:6 (9:6) П","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.39,"id":4247955377,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":13.65,"id":4247955378,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.12,"id":4247955379,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.25,"id":4247955380,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.43,"id":4247955382,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248058715,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248058716,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.75,"id":4247997318,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":53.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.96,"id":4247997319,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13159114":{"time":1698404400,"date":"14:00","sid":27,"lid":253711,"id":13159114,"c1_id":915791,"c2_id":916162,"prio":null,"number":"241","stats":0,"parent_game_id":"13159112","parent_league_id":"253049","ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":19,"bets":[],"score":"1:0 (1:0) П","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.19,"id":4247955761,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.58,"id":4247955762,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":19.48,"id":4247955763,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.11,"id":4247955765,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":3.43,"id":4247955766,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.85,"id":4248006374,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.37,"id":4248006375,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.52,"id":4247955769,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.46,"id":4247955770,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13159115":{"time":1698404400,"date":"14:00","sid":27,"lid":253711,"id":13159115,"c1_id":915780,"c2_id":916164,"prio":null,"number":"242","stats":0,"parent_game_id":"13159112","parent_league_id":"253049","ross_stats_count":"0","ross_with_stats":14,"ross_count_with_double_chances":20,"bets":[],"score":"0:2 (0:2) П","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":4.04,"id":4247955401,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.77,"id":4247955402,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.53,"id":4247955403,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.11,"id":4247955404,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.1,"id":4247955405,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.15,"id":4247955406,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.61,"id":4247955407,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.17,"id":4247955408,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.64,"id":4248034948,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":12.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.12,"id":4248034949,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"14"},"13159117":{"time":1698404400,"date":"14:00","sid":26,"lid":249768,"id":13159117,"c1_id":66466,"c2_id":374794,"prio":null,"number":"246","stats":1,"ross_stats_count":"0","ross_with_stats":284,"ross_count_with_double_chances":292,"bets":[],"score":"1:0 30'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.22,"id":4247964594,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.47,"id":4247964595,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":13.17,"id":4247964596,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.01,"id":4247964597,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.13,"id":4247964598,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":4,"id":4247964599,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.07,"id":4248045233,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.71,"id":4248045234,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.74,"id":4248039739,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.02,"id":4248039740,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"284"},"13159118":{"time":1698404400,"date":"14:00","sid":26,"lid":246433,"id":13159118,"c1_id":1125067,"c2_id":1248559,"prio":null,"number":"247","stats":0,"parent_game_id":"13156242","parent_league_id":"246432","ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"0:1 31'","color":"e","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0"},"13159119":{"time":1698404400,"date":"14:00","sid":26,"lid":246433,"id":13159119,"c1_id":445190,"c2_id":1248560,"prio":null,"number":"250","stats":0,"parent_game_id":"13156242","parent_league_id":"246432","ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"1:0 31'","color":"o","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0"},"13159120":{"time":1698404400,"date":"14:00","sid":177,"lid":316981,"id":13159120,"c1_id":620385,"c2_id":1132560,"prio":null,"number":"252","stats":0,"ross_stats_count":"0","ross_with_stats":19,"ross_count_with_double_chances":19,"bets":[],"score":"3:1 16'","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.11,"id":4247962856,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"19","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159153":{"time":1698404400,"date":"14:00","sid":177,"lid":316981,"id":13159153,"c1_id":519145,"c2_id":1273843,"prio":null,"number":"255","stats":0,"ross_stats_count":"0","ross_with_stats":29,"ross_count_with_double_chances":29,"bets":[],"score":"2:0 17'","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4247979372,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.94,"id":4247979373,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.82,"id":4247970943,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.88,"id":4247970944,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"29","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159194":{"time":1698404400,"date":"14:00","sid":26,"lid":359166,"id":13159194,"c1_id":1270958,"c2_id":148566,"prio":null,"number":"265","stats":0,"ross_stats_count":"0","ross_with_stats":4,"ross_count_with_double_chances":4,"bets":[],"score":"0:0 33'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.3,"id":4247991605,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.55,"id":4247991606,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248003373,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248003374,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"4"},"13159200":{"time":1698405000,"date":"14:10","sid":564,"lid":338000,"id":13159200,"c1_id":1218985,"c2_id":1228630,"prio":null,"number":"266","stats":0,"ross_stats_count":"0","ross_with_stats":2,"ross_count_with_double_chances":2,"bets":[],"score":"43:51 (16:15, 16:25, 11:11) 5'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4248045368,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-10.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2,"id":4248045369,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4248054196,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":146.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2,"id":4248054197,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"2"},"13159211":{"time":1698405000,"date":"14:10","sid":562,"lid":332938,"id":13159211,"c1_id":1247337,"c2_id":1285403,"prio":null,"number":"269","stats":0,"ross_stats_count":"0","ross_with_stats":10,"ross_count_with_double_chances":13,"bets":[],"score":"1:1 (0:0, 1:0) 45'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.64,"id":4248000747,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.83,"id":4248000748,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.15,"id":4248000749,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.59,"id":4248000750,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.35,"id":4248000751,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.23,"id":4248000752,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.47,"id":4248044819,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.48,"id":4248044820,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.14,"id":4248043843,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.63,"id":4248043844,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"10"},"13159242":{"time":1698405780,"date":"14:23","sid":560,"lid":319869,"id":13159242,"c1_id":1139982,"c2_id":1137531,"prio":null,"number":"277","stats":0,"ross_stats_count":"0","ross_with_stats":0,"ross_count_with_double_chances":0,"score":"0:2 (0:2) 86' 10x11","color":"o","bets":[],"description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"0"},"13159244":{"time":1698405300,"date":"14:15","sid":560,"lid":220185,"id":13159244,"c1_id":1130400,"c2_id":1238915,"prio":null,"number":"279","stats":0,"ross_stats_count":"0","ross_with_stats":44,"ross_count_with_double_chances":47,"bets":[],"score":"1:0 35'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.26,"id":4248013609,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.02,"id":4248013610,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":8.37,"id":4248013611,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.03,"id":4248013752,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.12,"id":4248013753,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":3.09,"id":4248013754,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248013755,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248013756,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.7,"id":4248013757,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.03,"id":4248013758,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"44"},"13159258":{"time":1698405300,"date":"14:15","sid":41,"lid":257704,"id":13159258,"c1_id":694501,"c2_id":669822,"prio":null,"number":"283","stats":0,"ross_stats_count":"0","ross_with_stats":117,"ross_count_with_double_chances":117,"bets":[],"score":"0:0* (11:12)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.05,"id":4248021901,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.72,"id":4248021902,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248037976,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248037977,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.87,"id":4248050928,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":182.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.83,"id":4248050929,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"117"},"13159260":{"time":1698405120,"date":"14:12","sid":562,"lid":320324,"id":13159260,"c1_id":1290352,"c2_id":1289969,"prio":null,"number":"285","stats":0,"ross_stats_count":"0","ross_with_stats":8,"ross_count_with_double_chances":11,"bets":[],"score":"1:0 (0:0, 1:0) 45'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.44,"id":4248027021,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.86,"id":4248027022,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.32,"id":4248027023,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4248027024,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.21,"id":4248027025,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.5,"id":4248027026,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":3.45,"id":4248055592,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.26,"id":4248055593,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.6,"id":4248042921,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.19,"id":4248042922,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"8"},"13159261":{"time":1698399600,"date":"12:40","sid":235,"lid":267819,"id":13159261,"c1_id":933630,"c2_id":295169,"prio":null,"number":"286","stats":0,"ross_stats_count":"0","ross_with_stats":30,"ross_count_with_double_chances":30,"bets":[],"score":"*0:0 (13:10)","video_type":[3],"color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.7,"id":4248029401,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.03,"id":4248029402,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248043254,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248043255,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060401,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":98.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248060402,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"30","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159262":{"time":1698405600,"date":"14:20","sid":26,"lid":304400,"id":13159262,"c1_id":1142572,"c2_id":1142577,"prio":null,"number":"287","stats":0,"ross_stats_count":"0","ross_with_stats":18,"ross_count_with_double_chances":24,"bets":[],"score":"0:0 7'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.12,"id":4248029667,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.13,"id":4248029668,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.12,"id":4248029669,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.3,"id":4248031768,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.61,"id":4248031769,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.3,"id":4248031770,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248029670,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248029671,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.7,"id":4248057889,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.41,"id":4248057890,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"18"},"13159264":{"time":1698406080,"date":"14:28","sid":560,"lid":319869,"id":13159264,"c1_id":1162466,"c2_id":1265654,"prio":null,"number":"288","stats":0,"ross_stats_count":"0","ross_with_stats":20,"ross_count_with_double_chances":20,"bets":[],"score":"2:0 37'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.14,"id":4248031668,"o":1,"t":"cf","st":1},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"20"},"13159265":{"time":1698406200,"date":"14:30","sid":560,"lid":319893,"id":13159265,"c1_id":1282897,"c2_id":1282886,"prio":null,"number":"289","stats":0,"ross_stats_count":"0","ross_with_stats":42,"ross_count_with_double_chances":45,"bets":[],"score":"0:1 19'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":6.11,"id":4248032640,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.8,"id":4248032641,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.46,"id":4248032642,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.36,"id":4248032643,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.21,"id":4248032644,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.08,"id":4248032645,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.34,"id":4248060073,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.98,"id":4248060074,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.14,"id":4248032648,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.63,"id":4248032649,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"42"},"13159268":{"time":1698405600,"date":"14:20","sid":564,"lid":321798,"id":13159268,"c1_id":1206941,"c2_id":1208186,"prio":null,"number":"293","stats":0,"ross_stats_count":"0","ross_with_stats":20,"ross_count_with_double_chances":20,"bets":[],"score":"8:17 (8:17) 1'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":19.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248057714,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-19.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248057715,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248045996,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":111.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4248045997,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"20"},"13159269":{"time":1698405960,"date":"14:26","sid":560,"lid":222364,"id":13159269,"c1_id":702220,"c2_id":816014,"prio":null,"number":"294","stats":0,"ross_stats_count":"0","ross_with_stats":20,"ross_count_with_double_chances":23,"bets":[],"score":"0:1 (0:1) 53'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":7.3,"id":4248036381,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.02,"id":4248036382,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.56,"id":4248036383,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.19,"id":4248036384,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.32,"id":4248036385,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4248036386,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.25,"id":4248053701,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":3.55,"id":4248053702,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.65,"id":4248047412,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.1,"id":4248047413,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"20"},"13159273":{"time":1698405720,"date":"14:22","sid":564,"lid":338000,"id":13159273,"c1_id":1215982,"c2_id":1220534,"prio":null,"number":"295","stats":0,"ross_stats_count":"0","ross_with_stats":6,"ross_count_with_double_chances":6,"bets":[],"score":"18:19 (18:19) 1'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.51,"id":4248036876,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":2.38,"id":4248036877,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":-3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248044485,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248044486,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.89,"id":4248049801,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":145.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.81,"id":4248049802,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"6"},"13159274":{"time":1698405780,"date":"14:23","sid":560,"lid":222364,"id":13159274,"c1_id":640185,"c2_id":823854,"prio":null,"number":"296","stats":0,"ross_stats_count":"0","ross_with_stats":22,"ross_count_with_double_chances":25,"bets":[],"score":"1:1 (1:1) 56'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":3.89,"id":4248037173,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.11,"id":4248037174,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.63,"id":4248037175,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.41,"id":4248037176,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.61,"id":4248037177,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.2,"id":4248037178,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.23,"id":4248038577,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4248038578,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.55,"id":4248038579,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":3.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.3,"id":4248038580,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"22"},"13159291":{"time":1698405900,"date":"14:25","sid":26,"lid":304400,"id":13159291,"c1_id":1211605,"c2_id":1211601,"prio":null,"number":"301","stats":0,"ross_stats_count":"0","ross_with_stats":18,"ross_count_with_double_chances":24,"bets":[],"score":"0:0 2'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.49,"id":4248045749,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.92,"id":4248045750,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.73,"id":4248045751,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.38,"id":4248045752,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.34,"id":4248045753,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.45,"id":4248045754,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4248045755,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.94,"id":4248045756,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248045757,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4248045758,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"18"},"13159292":{"time":1698405960,"date":"14:26","sid":560,"lid":341078,"id":13159292,"c1_id":1239084,"c2_id":1234395,"prio":null,"number":"302","stats":0,"ross_stats_count":"0","ross_with_stats":11,"ross_count_with_double_chances":14,"bets":[],"score":"0:0 14'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.69,"id":4248045917,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.65,"id":4248045918,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4248045919,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.76,"id":4248045920,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.15,"id":4248045921,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.39,"id":4248045922,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.66,"id":4248045923,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":2.09,"id":4248045924,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"11"},"13159294":{"time":1698404400,"date":"14:00","sid":556,"lid":359040,"id":13159294,"c1_id":926026,"c2_id":616290,"prio":null,"number":"304","stats":0,"ross_stats_count":"0","ross_with_stats":12,"ross_count_with_double_chances":12,"bets":[],"score":"0:0 (2:1)","video_type":[3],"color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.02,"id":4248047388,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":9.99,"id":4248047389,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"12","is_video":true,"video":[{"type":3,"name":"Video","url":""}]},"13159297":{"time":1698406740,"date":"14:39","sid":560,"lid":319869,"id":13159297,"c1_id":1212689,"c2_id":1137531,"prio":null,"number":"305","stats":0,"ross_stats_count":"0","ross_with_stats":53,"ross_count_with_double_chances":56,"bets":[],"score":"0:0 1'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.13,"id":4248052208,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.12,"id":4248052209,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.51,"id":4248052210,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.43,"id":4248052211,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.18,"id":4248052212,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.59,"id":4248052213,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248052214,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.99,"id":4248052215,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.07,"id":4248052216,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.67,"id":4248052217,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"53"},"13159299":{"time":1698406140,"date":"14:29","sid":560,"lid":319882,"id":13159299,"c1_id":1245598,"c2_id":1220871,"prio":null,"number":"308","stats":0,"ross_stats_count":"0","ross_with_stats":16,"ross_count_with_double_chances":19,"bets":[],"score":"1:0 15'","color":"e","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.43,"id":4248053041,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.43,"id":4248053042,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.44,"id":4248053043,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.16,"id":4248055503,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.11,"id":4248055504,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":2.57,"id":4248055505,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248053044,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":5.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248053045,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"16"},"13159300":{"time":1698406140,"date":"14:29","sid":560,"lid":319882,"id":13159300,"c1_id":1256640,"c2_id":1268822,"prio":null,"number":"309","stats":0,"ross_stats_count":"0","ross_with_stats":18,"ross_count_with_double_chances":21,"bets":[],"score":"0:0 14'","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":2.15,"id":4248053094,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.23,"id":4248053095,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.44,"id":4248053096,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.47,"id":4248055362,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.18,"id":4248055363,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.6,"id":4248055364,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.73,"id":4248053097,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.98,"id":4248053098,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248056208,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4248056209,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"18"},"13159301":{"time":1698406200,"date":"14:30","sid":235,"lid":264544,"id":13159301,"c1_id":527392,"c2_id":1128359,"prio":null,"number":"310","stats":0,"ross_stats_count":"0","ross_with_stats":30,"ross_count_with_double_chances":30,"bets":[],"score":"0:0* (0:0)","color":"o","description":[{},{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":4.9,"id":4248053121,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":1.14,"id":4248053122,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":" col-md","sfs":false,"fbt":false},{"cls_vis":"","sfs":false,"fbt":false,"h":11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248057959,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-11.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248057960,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.93,"id":4248053125,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":73.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.77,"id":4248053126,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"30"},"13159302":{"time":1698406200,"date":"14:30","sid":27,"lid":256535,"id":13159302,"c1_id":290361,"c2_id":282419,"prio":null,"number":"311","stats":0,"ross_stats_count":"0","ross_with_stats":146,"ross_count_with_double_chances":155,"bets":[],"color":"o","description":[{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.23,"id":4248054922,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.26,"id":4248054923,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":7.16,"id":4248054924,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4248054925,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.06,"id":4248054926,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":3.56,"id":4248054927,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":-2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.8,"id":4248054928,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.9,"id":4248054929,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248054930,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":6.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248054931,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"146"},"13159308":{"time":1698405720,"date":"14:22","sid":562,"lid":320324,"id":13159308,"c1_id":1290147,"c2_id":1276054,"prio":null,"number":"313","stats":0,"ross_stats_count":"0","ross_with_stats":60,"ross_count_with_double_chances":63,"bets":[],"color":"o","description":[{},{}],"f_l":[{"cls_vis":"","sfs":false,"fbt":false,"h":1.91,"id":4248059657,"o":1,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.9,"id":4248059658,"o":2,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.74,"id":4248059659,"o":3,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.38,"id":4248059660,"o":4,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.14,"id":4248059661,"o":5,"t":"cf","st":0},{"cls_vis":" col-md","sfs":false,"fbt":false,"h":1.76,"id":4248059662,"o":6,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.58,"id":4248059663,"o":7,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":0},{"cls_vis":"","sfs":false,"fbt":false,"h":2.23,"id":4248059664,"o":8,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248059665,"o":9,"t":"cf","st":0},{"cls_vis":"","sfs":false,"fbt":false,"h":4.5},{"cls_vis":"","sfs":false,"fbt":false,"h":1.85,"id":4248059666,"o":10,"t":"cf","st":0}],"hd":[{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Х","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"1Х","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"12","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Х2","cls_vis":" col-md","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"1","cls_vis":"","sfs":false,"fbt":false},{"n":"Фора","cls_vis":"","sfs":false,"fbt":false},{"n":"2","cls_vis":"","sfs":false,"fbt":false},{"n":"М","cls_vis":"","sfs":false,"fbt":false},{"n":"Тотал","cls_vis":"","sfs":false,"fbt":false},{"n":"Б","cls_vis":"","sfs":false,"fbt":false}],"ross":"60"}},"stats_type":["31"],"dict":{"sport":{"26":"Футбол","27":"Хоккей","28":"Баскетбол","33":"Теннис","41":"Волейбол","134":"Настольный теннис","177":"Футзал","235":"Бадминтон","272":"Бильярд","317":"Хоккей на траве","337":"Пляжный волейбол","533":"Крикет","556":"Киберспорт","560":"Киберфутбол","562":"Киберхоккей","564":"Кибербаскетбол","other":"Остальные"},"league":{"220185":"FIFA. Лига Про","222364":"FIFA. eSports Battle","232024":"FIFA 17. Европейская Суперлига","243965":"FIFA 17. Лига чемпионов. Сезон 19-20","246188":"Россия. Лига Про. Мужчины","246333":"Япония. J1 Лига","246432":"Болгария. 1-я лига","246433":"Болгария. 1-я лига. Статистические данные","246593":"Чехия. Лига Про. Мужчины","246644":"Остальное. Rocket League. 4x12","246792":"Япония. J1 Лига. Статистические данные","247069":"Остальное. Rocket league. Женщины","247195":"ITF. Женщины. Монастир. Хард","247387":"Остальное. Премьер лига","248080":"Россия. Молодежное первенство","248334":"Чехия. Юношеская лига. До 19 лет","248416":"Южная Корея. К-лига 3","248663":"Грузия. Национальная лига 2","249768":"Сирия. Премьер-лига","252382":"Косово. 1-я лига","252564":"Греция. Суперлига. До 19 лет","253049":"Россия. МХЛ. Регулярный сезон","253367":"Россия. ЛФК. Брянск","253670":"Болгария. Юношеская лига. До 19 лет","253711":"Россия. МХЛ. Регулярный сезон. Статистика","253764":"Финляндия. СМ-Серия. До 20 лет","253775":"Турция. 3-й дивизион","256535":"Словакия. Экстралига. До 20 лет","257704":"Беларусь. Лига Про","258499":"Россия. ЖХЛ. Регулярный сезон","260311":"Япония. B3 Лига","260360":"Япония. B2 Лига","260383":"Украина. Суперлига. Женщины","260813":"Украина. Высшая лига","260990":"ITF. Женщины. Шарм-Эль-Шейх. Хард","261038":"ITF. Женщины. Лоле. Хард","261482":"Финляндия. Дивизион I-A","261586":"Румыния. Дивизион A1. Женщины","261625":"Южная Корея. KBL","262105":"Хорватия. Первая лига","262392":"Россия. Высшая лига Б. Женщины","262482":"Уганда. Премьер-лига","262728":"Южная Корея. В-лига. Женщины","263899":"Япония. WJBL. Женщины","264315":"ATP. Пары. Челленджер. Брест. Хард","264385":"ITF. Женщины. Стамбул. Хард","264544":"French Open. Микст","264546":"French Open. Мужчины","264566":"ITF. Женщины. Лес Франкесес Дель Вальес. Хард","264601":"ITF. Женщины. Пуатье. Хард","264605":"ITF. Мужчины. Саргемин. Хард","265161":"Европа. Чемпионат NEVZA. До 19 лет. Женщины. Финляндия","265288":"Европа. Чемпионат NEVZA. До 19 лет. Финляндия","265813":"ITF. Мужчины. Ираклион. Хард","265815":"ITF. Мужчины. Пары. Ираклион. Хард","266553":"ATP. Пары. Челленджер. Ортизеи. Хард","266625":"ATP. Челленджер. Ортизеи. Хард","267793":"Indonesia Masters. Женщины. Пары","267819":"Indonesia Masters. Мужчины","270410":"Австралия. NBL","275434":"Беларусь. Лига Про. Мужчины","279892":"ITF. Женщины. Вильена. Хард","281132":"ITF. Женщины. Глазго. Хард","281134":"ITF. Мужчины. Глазго. Хард","283492":"Вьетнам. V-лига 2","291678":"Европа. Setka Cup. Мужчины","291687":"Европа. TT-Cup. Мужчины","292254":"Южная Корея. К-лига 3. Статистические данные","303873":"Мьянма. Национальная лига","304400":"Лига Про. 3x3. 2 тайма по 10 минут","305759":"Гонконг. Дивизион А. Женщины","306137":"Китай. New Star League. 4x12","308836":"Индонезия. Региональная лига. Женщины","308846":"Остальное. Украина. ЛБЛ","312893":"Европа. TT Elite Series. Мужчины","316981":"Россия. Высшая лига. Конференция \"Восток\"","317641":"Казахстан. Чемпионат. Женщины. Усть-Каменогорск","318046":"ITF. Мужчины. Пары. Аль-Захра. Хард","319434":"Филиппины. MPBL. Плей-офф. 1/4 финала","319869":"FIFA. H2H Liga","319882":"FIFA. GT League","319893":"FIFA. UEL","320324":"NHL 23. H2H Liga","321798":"NBA 2K. Liga Pro. 4х5 мин","321909":"Россия. Высшая лига. Женщины","323593":"Остальное. ACL. 5х5. 2х10 минут","323627":"Остальное. BudnesLiga. 5х5. 2х12 минут","324807":"Остальное. IPBL. Space Division. 2х10. Женщины","324810":"Остальное. IPBL. Pro Division","324833":"Остальное. IPBL. Pro Division. 3x3. Женщины","324835":"Остальное. IPBL. Space Division. 2x10","325551":"Остальное. IPBL. Prime Division. 2x10","326745":"Европа. Европейская молодежная лига. До 20 лет","332938":"NHL 23. UEL","338000":"NBA 2K. H2H. GG League. 4x5 мин","341078":"FIFA. Adriatic League","347536":"Украина. 1-я лига. Группа A","353071":"Мир. Кубок мира 2023. ODI. Индия","354958":"Европа. Лига наций УЕФА. Женщины. Лига С","357276":"CS2. CCT East Europe Series. Матчи из 3-х карт","357336":"Австралия. T20 Big Bash. Женщины","358593":"UTR Pro Tennis Series. Мужчины. Ним. Хард","358619":"WTA. Чжухай. Хард","358667":"CS2. European Pro League. Матчи из 3-х карт","358680":"Европа. ЧЕ-2024. До 19 лет. Женщины. 1-й квалификационный раунд","358921":"CS2. United 21. Матчи из 3-х карт","359038":"Beach Pro Tour. Фьючерс. Мужчины. Испания","359040":"CS2. TP World Championship. Матчи из 3-х карт","359100":"Азия. Asian Champions Trophy-2023. Женщины. Индия","359118":"Northern Ireland Open. Матчи из 9-ти фреймов","359166":"Молдавия. 1-я лига. Группа B"},"cmd":{"29384":"Мемфис","32531":"Латвия","32772":"Нагоя","38864":"Славия София","56711":"Украина (до 19)","61005":"ГС Кальтекс","62268":"Тишрин","62691":"Динамо Бх","66466":"Джебла","66797":"Динамо М (мол)","67713":"Тосу Саган","68493":"Чханвон","68894":"Стальные Лисы","69474":"Греция (до 19)","70174":"Чехия (до 19)","71324":"Косово","78355":"Молдова","82318":"Люксембург (до 19)","82893":"Бакэу","83098":"Воронеж","103737":"Сибирские Снайперы","107603":"Мерани Мартвили","109759":"Фукуока","125265":"Япония","131139":"Фуджитсу Рэд Вэйв","133092":"Пусан Кетонг","135554":"Галичанка-ТНЕУ","137951":"Норвегия (до 19)","142056":"Донгнай","148566":"Реал Сукчес","154858":"Зброёвка Брно (до 19)","157912":"ХПК (мол)","160927":"Нара","174459":"Аль Джаиш Дамаск","175489":"Биньфыок","194139":"Байбурт Груп ОИГС","200433":"Северянка-2","220673":"Марунс","222948":"Торпедо У-К","237405":"Тосу Саган угл","281392":"Кютахьяспор","282419":"Попрад (мол)","282913":"Политехник Харьков","283921":"Ханэда Викис","284726":"Политехник Львов","290361":"Банска Быстрица (мол)","290574":"ХБА-Марскю","295169":"Чжи Хун Чхве","303590":"Кагава","317320":"Айсулу","320516":"ВИТ-Джорджия","325333":"ГФА ФК","327288":"Нагоя угл","329611":"Малайзия","338737":"Аль-Карама","341858":"Хоттаин","347511":"Аль-Ватба Хомс","349321":"Эссят (мол)","350276":"Чханвон угл","362074":"Пусан Кетонг угл","362078":"Дреница","374794":"Аль-Талия","400434":"ЮАР","404482":"СКСО","405413":"Пакистан","410137":"Шифэн Ли","418497":"Фареры (до 19)","442993":"Сан-Хуан Найтс","445190":"Славия София угл","449616":"Колхети Хоби","454286":"Нагоя ж/к","463085":"Тосу Саган ж/к","477190":"Атромитос (до 19)","477192":"Панетоликос (до 19)","486848":"Перт Уайлдкэтс","486849":"Брисбен Буллетс","487748":"Йювяскюля БА","499055":"Брисбен Хит","500831":"Хмельницкий","504853":"Скай","511086":"Лонган","512825":"УРА","514649":"Качин Юнайтед","518569":"Подолье Хмельницкий","519145":"Новая Генерация-д","523081":"Мерани Тбилиси","526488":"Балтика (мол)","527392":"Кусумавати Л А/Кушарджанто Р Н","533009":"Лагуна-УОР","547061":"Северная Македония","547497":"Стормс","554992":"Нуэва-Эсиха Мигард","573199":"ДИ Джокьякарта","573584":"Ява Барат","585350":"GODSENT","587727":"Самобор","594956":"Окаяма Трайхуп","607208":"Pompa Team","608469":"Аланта-ДНУ","616278":"Москва","616290":"Wildcard Gaming","620385":"ВИЗ-Синара (д)","635499":"Боруссия (люб)","635793":"Рейдерс","636274":"Гамбург (люб)","636275":"Бавария (люб)","636277":"Вердер (люб)","636873":"ЦСКА М (к)","636879":"Бавария (к)","637377":"Брюгге (к)","637379":"Галатасарай (к)","640185":"Германия (KRaftVK)","669822":"Империя-Про","694501":"Львы-Про","698255":"Сэлф-Мэйд Киев","702107":"Чили Пепперс","702220":"Англия (FEARGGWP)","718782":"Гареджи","719097":"Аль-Хория","728919":"Гулс","738507":"Акес","744519":"Агробизнес","756693":"Нуггетс","770872":"Looking4org","783794":"Славия (до 19)","791418":"Мельбурн Старс","801187":"Динамо-Нева","801325":"Екатеринбург","802583":"Своллоус","816014":"Аргентина (Flewless_Phoenix)","823854":"Нидерланды (labotryas)","835002":"Полсон Э/Рикл П","849735":"Футхо","852469":"Динамо Тбилиси II","869643":"Академия им. Коноплева (мол)","879453":"Металлург Липецк-М","915780":"Стальные Лисы штр вр","915791":"Стальные Лисы голы в бол","916162":"Сибирские Снайперы голы в бол","916164":"Сибирские Снайперы штр вр","926026":"Monte","928587":"Йокогама Экселенс","933630":"Чхо Геонеоп","935263":"Кванджу АИ Пепперс","939528":"Финляндия (дo 19)","947395":"ECSTATIC","969426":"Бергеви Ф/Вельдхер М","988074":"Андрей Потапков","988083":"Алексей Лобанов","988142":"Андрей Копчинский","988679":"Валерий Кутин","989369":"Далма Галфи","989373":"Сара Эррани","990787":"Ингольштадт 04 (люб)","990948":"Людмила Самсонова","991811":"Вероника Кудерметова","992709":"Иржи Плахи","994220":"Андрей Храмеев","994848":"Олег Приходько","995157":"Пол Джабб","995371":"Дан Адде","995743":"Кайса Риналдо Персон","996305":"Илья Новиков","996476":"Эмелин Дартрон","996587":"Макс Касниковски","996773":"Манон Леонар","997833":"Линда Фрухвиртова","999230":"Антон Матусевич","1000519":"Сергей Кузьмин","1000947":"Линда Климовичова","1001691":"Тамара Чурович","1002021":"Матиас Бург","1002459":"Диана Марцинкевич","1002464":"Леолия Жанжан","1002467":"Изабелла Шиникова","1003921":"Рихард Мацура","1005206":"Хумоюн Султанов","1005939":"Мирослав Сведик","1006470":"Даниил Михеев","1006756":"Назар Данилюк","1007128":"Ясмин Эззат","1007561":"Кристоф Капик","1007622":"Антон Молочко","1007627":"Григорий Мальтизов","1008824":"Артем Трофимчук","1009999":"Эммануэль Жирар","1010399":"Жаклин Кабай Авад","1010607":"Адриана Реами","1010986":"Сильвия Амброзио","1011289":"Элла Хаависто","1013720":"Джек Лисовски","1014427":"Иржи Стах","1014930":"Анастасия Захарова","1015034":"Мэтью Уильям Дональд","1016825":"Елена Милованович","1019266":"Басак Эрайдин","1020837":"Владимир Съедин","1020838":"Богдан Панченко","1021948":"ХАКК Младость","1026029":"Зденек Заградка","1028160":"Джонатан Бэкман","1029252":"Эвелина Ласкевич","1029896":"Лия Фернандес","1038039":"Джонсон Л/Мансури С","1050279":"Сара Илиев","1055829":"Иоана Звонару","1055933":"Мартына Кубка","1060097":"Дарья Снигур","1060713":"Хьюго Пьер","1062830":"Рики Уолден","1064624":"Дип","1065112":"Энтони Гинтин","1066629":"Йорис Морет","1068241":"Аризона Подол","1069072":"Мастер-Сатурн (мол)","1075812":"Кайл Эдмунд","1077213":"Алес Брандтл мл","1089769":"Хамиш Стюарт","1097279":"Кристалл","1099547":"Дарья Хомуцианская","1103873":"УФК Ботев (до 19)","1114109":"Зденек Тртик","1118510":"Росица Денчева","1125067":"Славия София ж/к","1126176":"Лукаш Рыгл","1127230":"Богумил Дубень","1128359":"Вэй Я Синь/Цзян Чжэньбан","1130400":"Ювентус (FASHION JE)","1132560":"Норильский Никель (д)","1135799":"Гуандун Манерс","1137531":"Ливерпуль (AGROROMARIO)","1139982":"Манчестер Сити (DMITRIYXBOOST)","1142572":"Марс-про","1142577":"Плутон-про","1143960":"Кхуань Онь Юнань","1157132":"Бохум (люб)","1157258":"Франтишек Балкар","1158344":"Сёнан Юнайтед","1162466":"Германия (BATUYKA)","1163349":"Санкт- Петербург","1164410":"Ондрей Сварц","1166940":"Томас Подразски","1170073":"Чардж","1179436":"Крумовград","1185381":"Понтьодикромо С/Вискер Н","1186167":"Арантха Рус","1189795":"Мичал Муравски","1194213":"Артнак Б/Димик М","1203559":"Оболонь","1206941":"Новосибирск (Nikitachikishev_)","1208186":"Динамо (TiGeR_IRIs)","1210438":"Ляонин Уориорз","1211601":"Атлант-про","1211605":"Союз-про","1212689":"Реал Мадрид (OG_ROZY)","1213157":"Шелль Н/Вёрнер П","1213689":"Хубер/Фридль","1215982":"Финикс Санз (JABZ)","1218985":"Кливленд Кавальерс (BEARDED D)","1220534":"Голден Стэйт Уорриорз (SKYFOX)","1220871":"Вест Хэм (Seagal)","1226125":"Пуспитасари М Т/Росе Р А","1228630":"Голден Стэйт Уорриорз (TD24)","1234395":"Барселона (Donatello)","1235478":"Владимир Ивасив 1971","1238915":"Интер М (SAD)","1239084":"Реал Мадрид (Panther)","1240123":"Ден Хейер Г/Дондерс Д","1241557":"Степан Коци","1245598":"Манчестер Сити (Punisher)","1247337":"Бостон Брюинз (Shang-Chi)","1248559":"Крумовград ж/к","1248560":"Крумовград угл","1253313":"Велл Борн","1256640":"Арсенал (Aladdin)","1257460":"Ярослав Бжески","1260398":"Март Мартин","1261513":"Найт","1265654":"Италия (KIKILL)","1268822":"Манчестер Юн (Jack)","1270958":"Гагаузия-Огузспорт","1272746":"Los Alpacas","1273843":"Прогресс-БИОНОРД","1276054":"Тампа-Бэй Лайтнинг (SKULL)","1278179":"Anonym","1282886":"Ювентус (bekplay)","1282897":"Барселона (iONE)","1284737":"Сува-Река","1285403":"Торонто Мейпл Лифс (Griezmann)","1289331":"Тандерс Сеул","1289332":"Найтс Сеул","1289611":"Фобус Ульсан","1289967":"Стальные Лисы выиг вбрас","1289969":"Даллас Старз (KULIBANDA)","1290111":"Скайганнерс Коян","1290147":"Аризона Койотс (CHOPPER007)","1290352":"Колорадо Эвеланш (SH0OZY)","1291211":"ФК Калуга 2","1291768":"Сибирские Снайперы выиг вбрас","1292867":"Бхамбри Ю/Кэш Ю","1296499":"Куреши А-У/Циципас П","1296632":"Жан Карим Оливье Де Сардан","1297129":"Арендс С/Рейес-Варела М А","1297837":"Полина Кайбекова","1298142":"Пей Ки Го/Йин Юань Лоу","1298548":"Аба Х/Матос","1298862":"Д-Ланг Лозанна Уайт (до 20)","1298863":"БУБА (до 20)"},"stats_type":[],"odd":{"1":"Победа 1","2":"Ничья","3":"Победа 2","4":"1Х","5":"12","6":"Х2","7":"Фора 1 (%1)","8":"Фора 2 (%1)","9":"Меньше (%1)","10":"Больше (%1)"},"stats_type_full_name":{"3":"Выигранные вбрасывания","8":"Голы в большинстве","23":"Желтые карточки","31":"Угловые","54":"Штрафное время"},"eng":{"sport":{"26":"Football","27":"Ice Hockey","28":"Basketball","33":"Tennis","41":"Volleyball","134":"Table Tennis","177":"Futsal","235":"Badminton","272":"Pool","317":"Field hockey","337":"Beach Volleyball","533":"Cricket","556":"ESports","560":"Cybersoccer","562":"Cyberhockey","564":"Cyberbasketball"},"league":{"220185":"FIFA. League Pro","222364":"FIFA. eSports Battle","232024":"FIFA17. European Superleague","243965":"FIFA17. Champions League. Season 19-20","246188":"Russia. League Pro. Men","246333":"Japan. J1 League","246432":"Bulgaria. League One","246433":"Bulgaria. League One. Statistics","246593":"Czech Republic. League Pro. Men","246644":"Others. Rocket league 4x12","246792":"Japan. J1 League. Statistics","247069":"Others. Rocket League. Women","247195":"ITF. Women. Monastir. Hard","247387":"Others. Premier League","248080":"Russia. Premier Liga. Reserves","248334":"Czech Republic. Youth League. U19","248416":"South Korea. K-League 3","248663":"Georgia. National League 2","249768":"Syria. Premier League","252382":"Kosovo. First League","252564":"Greece. Super League. U19","253049":"Russia. MHL. Regular Season","253367":"Russia. LFK. Bryansk","253670":"Bulgaria. Youth League. U19","253711":"Russia. MHL. Regular Season. Statistics","253764":"Finland. SM-Sarja. U20","253775":"Turkiye. Third division","256535":"Slovakia. Exstrliga. U20","257704":"Belarus. League Pro","258499":"Russia. Women. Regular Season","260311":"Japan. B3 League","260360":"Japan. B2 League","260383":"Ukraine. Superleague. Women","260813":"Ukraine. Men's First League","260990":"ITF. Women. Sharm El Sheikh. Hard","261038":"ITF. Women. Loule. Hard","261482":"Finland. I division A","261586":"Romania. Divizia A1. Women","261625":"South Korea. KBL","262105":"Croatia. First League","262392":"Russia. Top Liga B. Women","262482":"Uganda. Premier League","262728":"South Korea. V-league. Women","263899":"Japan. WJBL League. Women","264315":"ATP. Doubles. Challenger. Brest. Hard","264385":"ITF. Women. Istanbul. Hard","264544":"French Open. Mixed doubles","264546":"French Open. Men","264566":"ITF. Women. Les Franqueses Del Valles. Hard","264601":"ITF. Women. Poitiers. Hard","264605":"ITF. Men. Sarreguemines. Hard","265161":"Europe. NEVZA Championship. U19. Women. Finland","265288":"Sweden. Supercup","265813":"ITF. Men. Heraklion. Hard","265815":"ITF. Men. Doubles. Heraklion. Hard","266553":"ATP. Doubles. Challenger. Ortisei. Hard","266625":"ATP. Challenger. Ortisei. Hard","267793":"Indonesia Masters. Women. Doubles","267819":"Indonesia Masters. Men","270410":"Australia. NBL","275434":"Belarus. League Pro. Men","279892":"ITF. Women. Villena. Hard","281132":"ITF. Women. Glasgow. Indoor Hard","281134":"ITF. Men. Glasgow. Indoor Hard","283492":"Vietnam. V-League 2","291678":"Europe. Setka Cup. Men","291687":"Europe. TT-Cup. Men","292254":"South Korea. K-League 3. Statistics","303873":"Myanmar. National League","304400":"League Pro. 3x3. 2x10 min","305759":"Hong Kong. Division A. Women","306137":"China. New Star League. 4x12","308836":"Indonesia. Regional League. Women","308846":"Others. Ukraine. LBL","312893":"Europe. TT Elite Series. Men","316981":"Russia. Major League. Eastern zone","317641":"Kazakhstan. Championship. Women. Ust-Kamenogorsk","318046":"ITF. Men. Doubles. Al Zahra. Hard","319434":"Philippines. MPBL. Play-off. Quarterfinals","319869":"FIFA. H2H Liga","319882":"FIFA. GT League","319893":"FIFA. UEL","320324":"NHL 23. H2H Liga","321798":"NBA 2K. Liga Pro. 4x5 min","321909":"Russia. Major League. Women","323593":"Other. ACL. 5x5. 2x10 min","323627":"Other. BudnesLiga. 5x5. 2x12 min","324807":"Others. IPBL. Space Division. 2x10. Women","324810":"Others. IPBL. Pro Division","324833":"Others. IPBL. Pro Division. 3x3. Women","324835":"Others. IPBL. Space Division. 2x10","325551":"Others. IPBL. Prime Division. 2x10","326745":"Europe. European Youth League. U20","332938":"NHL 23. UEL","338000":"NBA 2K. H2H. GG League. 4x5","341078":"FIFA. Adriatic League","347536":"Ukraine. First League. Group A","353071":"World. ODI. World Cup 2023. India","354958":"Europe. UEFA Nations League. Women. League C","357276":"CS2. CCT East Europe Series. Best of 3","357336":"Australia. T20 Big Bash. Women","358593":"UTR Pro Tennis Series. Men. Nimes. Hard","358619":"WTA. Zhuhai. Hard","358667":"CS2. European Pro League. Best of 3","358680":"Europe. EURO-2024. U19. Women. 1st qualifying round","358921":"CS2. United 21. Best of 3","359038":"Beach Pro Tour. Futures. Men. Spain","359040":"CS2. TP World Championship. Best of 3","359100":"Champions Trophy Women","359118":"Northern Ireland Open. Best of 9 frames","359166":"Moldova. First League. Group B"},"cmd":{"29384":"Memphis","32531":"Latvia","32772":"Nagoya","38864":"PFC Slavia Sofia","56711":"Ukraine U19","61005":"GS Caltex Seoul KIXX","62268":"Tishreen","62691":"CS Dinamo Bucuresti","66466":"Jableh","66797":"Dynamo M (youth)","67713":"Sagan Tosu","68493":"Changwon","68894":"Stalnie Lisy","69474":"Greece U19","70174":"Czech Republic U19","71324":"Kosovo","78355":"Moldova","82318":"Luxembourg U19","82893":"CS Stiinta Bacau","83098":"VC Voronezh","103737":"Sibirskie Snaipery","107603":"Merani Martvili","109759":"Fukuoka","125265":"Japan","131139":"Chanson V-Magic","133092":"Busan Kyotong","135554":"Galichanka-TNEU","137951":"Norway U19","142056":"Dong Nai","148566":"Real Sucches","154858":"Zbrojovka Brno U19","157912":"HPK (youth)","160927":"Nara","174459":"Al-Jaish Damascus","175489":"Binh Phuoc","194139":"Bayburt Grup OIGS","200433":"Severyanka-2","220673":"Maroons","222948":"Torpedo U-K","237405":"Sagan Tosu corners","281392":"Kutahyaspor","282419":"HK Poprad (youth)","282913":"Kharkiv Polytechnic","283921":"Haneda Vickies","284726":"Polytechnic Lviv","290361":"HC 05 Banska Bystrica (youth)","290574":"HBA-Marsky","295169":"Ji Hoon Choi","303590":"Kagawa Five Arrows","317320":"Aisulu","320516":"Wit Georgia","325333":"GFA FC","327288":"Nagoya corners","329611":"Malaysia","338737":"Al-Karamah","341858":"Hutteen","347511":"Al Wathba Homs","349321":"Assat (youth)","350276":"Changwon corners","362074":"Busan Kyotong corners","362078":"KF Drenica Skenderaj","374794":"Al-Taleiah","400434":"South Africa","404482":"SKSO","405413":"Pakistan","410137":"Shifeng Li","418497":"Faroe Islands U19","442993":"San Juan Knights","445190":"PFC Slavia Sofia corners","449616":"Kolkheti Khobi","454286":"Nagoya yellow cards","463085":"Sagan Tosu yellow cards","477190":"Atromitos U19","477192":"Panetolikos FC U19","486848":"Perth Wildcats","486849":"Brisbane Bullets","487748":"Jyvaskyla BA","499055":"Brisbane Heat","500831":"Khmelnytsky","504853":"Sky","511086":"Long An","512825":"Revenue Authority FC","514649":"Kachin United","518569":"Podolye Khmelnitskiy","519145":"Novaya Generatsiya-d","523081":"Merani Tbilisi","526488":"Baltica (youth)","527392":"Kusumawati L A/Kusharjanto R N","533009":"Laguna-YOR","547061":"North Macedonia","547497":"Storms","554992":"Nueva Ecija MiGuard","573199":"DI Yogyakarta","573584":"Jawa Barat","585350":"GODSENT","587727":"Samobor","594956":"Okayama Tryhoop","607208":"Pompa Team","608469":"Atlanta-DNU","616278":"Moscow","616290":"Wildcard Gaming","620385":"VIZ-Sinara (reserve)","635499":"Borussia (amateur)","635793":"Raders","636274":"Hamburger (amateur)","636275":"Bayern (amateur)","636277":"Werder (amateur)","636873":"CSKA Moscow (c)","636879":"Bayern Munich (c)","637377":"Brugge (c)","637379":"Galatasaray (c)","640185":"Germany (KRaftVK)","669822":"Imperia-Pro","694501":"Lions-Pro","698255":"Self-Made Kyiv","702107":"Chili Peppers","702220":"England (FEARGGWP)","718782":"FC Gareji Sagarejo","719097":"Al-Horiyah","728919":"Gulls","738507":"Aces","744519":"Agrobiznes Volochisk","756693":"Nuggets","770872":"Looking4org","783794":"Slavia Prague U19","791418":"Melbourne Stars","801187":"Dynamo-Neva","801325":"Ekaterinburg","802583":"Swallows","816014":"Argentina (Flewless_phoenix)","823854":"Netherlands (labotryas)","835002":"Paulson A/Rikl P","849735":"FC Phu Tho","852469":"Dinamo Tbilisi II","869643":"Academy Konopleva (youth)","879453":"Metallurg Lipetsk-M","915780":"Stalnie Lisy penalty time","915791":"Stalnie Lisy PP goals","916162":"Sibirskie Snaipery PP goals","916164":"Sibirskie Snaipery penalty time","926026":"Monte","928587":"Yokohama Excellence","933630":"Cho Geonyeop","935263":"Gwangju AI Peppers","939528":"Finland U19","947395":"ECSTATIC","969426":"Bergevi F/Veldheer M","988074":"Andrey Potapkov","988083":"Aleksey Lobanov","988142":"Andrey Kopchinsky","988679":"Valery Kutin","989369":"Dalma Galfi","989373":"Sara Errani","990787":"Ingolstadt 04 (am)","990948":"Liudmila Samsonova","991811":"Veronika Kudermetova","992709":"Jiri Plachy","994220":"Andrey Khrameev","994848":"Oleg Prihodko","995157":"Jubb P","995371":"Dan Added","995743":"Kajsa Rinaldo Persson","996305":"Ilya Novikov","996476":"Emeline Dartron","996587":"Maks Kasnikowski","996773":"Manon Leonard","997833":"Linda Fruhvirtova","999230":"Anton Matusevich","1000519":"Sergey Kuzmin","1000947":"Linda Klimovicova","1001691":"Tamara Curovic","1002021":"Mathias Bourgue","1002459":"Diana Marcinkevica","1002464":"Leolia Jeanjean","1002467":"Isabella Shinikova","1003921":"Richard Macura","1005206":"Khumoyun Sultanov","1005939":"Miroslav Svedik","1006470":"Daniil Mikheev","1006756":"Nazar Danilyuk","1007128":"Yasmin Ezzat","1007561":"Krzysztof Kapik","1007622":"Anton Molochko","1007627":"Grigori Maltizov","1008824":"Artem Trofimchuk","1009999":"Emmanuelle Girard","1010399":"Jacqueline Cabaj Awad","1010607":"Adriana Reami","1010986":"Silvia Ambrosio","1011289":"Ella Haavisto","1013720":"Jack Lisowski","1014427":"Jiri Stach","1014930":"Anastasia Zakharova","1015034":"Matthew William Donald","1016825":"Elena Milovanovic","1019266":"Basak Eraydin","1020837":"Volodymyr Siedin","1020838":"Bohdan Panchenko","1021948":"HAKK Mladost","1026029":"Zdenek Zahradka","1028160":"Jonathan Backman","1029252":"Evilina Lashkevich","1029896":"Lya Fernandez","1038039":"Johnson L/Mansouri S","1050279":"Sarah Iliev","1055829":"Ioana Zvonaru","1055933":"Martyna Kubka","1060097":"Daria Snigur","1060713":"Hugo Pierre","1062830":"Ricky Walden","1064624":"Dyip","1065112":"Anthony Ginting","1066629":"Joris Moret","1068241":"Arizona Podol","1069072":"Master Saturn (Youth)","1075812":"Kyle Edmund","1077213":"Ales Brandtl jr","1089769":"Hamish Stewart","1097279":"Kristall","1099547":"Daria Khomutsianskaya","1103873":"UFC Botev U19","1114109":"Zdenek Trtik","1118510":"Rositsa Dencheva","1125067":"PFC Slavia Sofia yellow cards","1126176":"Lukas Rygl","1127230":"Bohumil Duben","1128359":"Yaxin Wei/Jiang Zhenbang","1130400":"Juventus (FASHION JE)","1132560":"Norilskii Nickel (reserves)","1135799":"GUANGDONG MINERS","1137531":"Liverpool (AGROROMARIO)","1139982":"Manchester City (DMITRIYXBOOST)","1142572":"Mars-pro","1142577":"Pluton-pro","1143960":"Kwan On Junan","1157132":"Bochum (Amateur)","1157258":"Frantisek Balcar","1158344":"Shonan United","1162466":"Germany (BATUYKA)","1163349":"St. Petersburg","1164410":"Ondrej Svarc","1166940":"Tomas Podrazsky","1170073":"Charge","1179436":"PFC Krumovgrad","1185381":"Pontjodikromo S/Visker N","1186167":"Rus Arantxa","1189795":"Michal Murawski","1194213":"Artnak B/Dimic M","1203559":"Obolon","1206941":"Novosibirsk (Nikitachikishev_)","1208186":"Dinamo (TiGeR_IRIs)","1210438":"Liaoning Warriors","1211601":"Atlant-pro","1211605":"Soiuz-pro","1212689":"Real Madrid (OG_ROZY)","1213157":"Schell N/Woerner P","1213689":"Huber/Friedl","1215982":"PHX Suns (JABZ) Esports","1218985":"CLE Cavaliers (BEARDED D)","1220534":"GS Warriors (SKYFOX) Esports","1220871":"West Ham (Seagal) Esports","1226125":"Puspitasari M T/Rose R A","1228630":"GS Warriors (TD24) Esports","1234395":"Barcelona (Donatello) Esports","1235478":"Vladimir Ivasiv 1971","1238915":"Inter Milan (SAD)","1239084":"Real Madrid (Panther) Esports","1240123":"Den Heijer G/Donders D","1241557":"Stepan Koci","1245598":"Man City (Punisher)","1247337":"Boston Bruins (Shang-Chi)","1248559":"PFC Krumovgrad yellow cards","1248560":"PFC Krumovgrad corners","1253313":"Well Born","1256640":"Arsenal (Aladdin)","1257460":"Jarolsav Bresky","1260398":"Mart Martin","1261513":"Knight","1265654":"Italy (KIKILL)","1268822":"Manchester Utd (Jack)","1270958":"Gagauziya-Oguzsport","1272746":"Los Alpacas","1273843":"Progress-BIONORD","1276054":"Tampa Bay Lightning (SKULL)","1278179":"Anonymo","1282886":"Juventus (Bekplay)","1282897":"Barcelona (iONE)","1284737":"Suhareka","1285403":"Toronto Maple Leafs (Griezmann)","1289331":"Seoul Samsung Thunders","1289332":"Seoul SK Knights","1289611":"Ulsan Mobis Phoebus","1289967":"Stalnie Lisy faceoffs won","1289969":"Dallas Stars (KULIBANDA)","1290111":"Goyang Sono Skygunners","1290147":"Arizona Coyotes (CHOPPER007)","1290352":"Colorado Avalanche (SH0OZY)","1291211":"FC Kaluga 2","1291768":"Sibirskie Snaipery faceoffs won","1292867":"Bhambri Y/Cash J","1296499":"Qureshi A-U/Tsitsipas P","1296632":"Jean Karim Olivier De Sardan","1297129":"Arends/Reyes-Varela","1297837":"Polina Kaibekova","1298142":"Pei Kee Go/Yeen Yuan Low","1298548":"Aba J/Matos","1298862":"D-Lang Lausanne White (U20)","1298863":"BUBA (U20)"},"stats_type":[],"odd":{"1":"Win 1","2":"Draw","3":"Win 2","4":"1X","5":"12","6":"X2","7":"Handicap 1 (%1)","8":"Handicap 2 (%1)","9":"Under (%1)","10":"Over (%1)"},"line_game_info":{"36":"{Score:score} ({PeriodsScore:periodsScore}) B","45":"{Score:score} {Minute:int}'","47":"{Serve1:serve}{Score:score}{Serve2:serve} ({PeriodsScore:periodsScore})","48":"{Score:score} ({PeriodsScore:periodsScore}) {Minute:int}'","49":"{Score:score} ({PeriodsScore:periodsScore}) {Minute:int}' {PowerPlay:powerPlay}","50":"{Score:score} ({PeriodsScore:periodsScore}) {Serve1:serve}{TennisGameScore:tennisGameScore}{Serve2:serve}","96":"{RunsTeam1:int}/{WicketsTeam1:int} - {RunsTeam2:int}/{WicketsTeam2:int}"},"stats_type_full_name":{"3":"Faceoffs Won","8":"Power Play Goal Number","23":"Yellow Cards","31":"Corners","54":"Penalty time"}}},"sort":{"sport":[26,28,41,33,27,134,556,564,560,562,235,272,533,337,177,317],"league":[246432,246433,253670,283492,252564,248663,354958,358680,252382,304400,359166,303873,253367,248080,249768,253775,262482,347536,248334,248416,292254,246333,246792,270410,305759,326745,306137,260813,319434,261482,262105,261625,260360,260311,263899,257704,265161,265288,308836,262392,261586,260383,262728,264315,266553,266625,279892,281132,264566,261038,247195,264601,264385,260990,281134,265813,318046,265815,264605,358593,358619,317641,258499,253049,253711,256535,253764,275434,291678,312893,291687,246188,246593,357276,358667,359040,358921,338000,321798,341078,319882,319869,319893,222364,220185,320324,332938,264544,264546,267793,267819,359118,357336,353071,359038,321909,316981,359100]},"filter":{"26":{"31":[2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774,2774]},"560":{"31":[2774,2774,2774,2774,2774,2774,2774,2774]}}}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v1", function() { return __WEBPACK_IMPORTED_MODULE_0__v1_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v3", function() { return __WEBPACK_IMPORTED_MODULE_1__v3_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v4", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v5", function() { return __WEBPACK_IMPORTED_MODULE_3__v5_js__["a"]; });





/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__(117);

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(b);
}

/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(630);


var v3 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v3);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var i;
  var x;
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  var hex;

  for (i = 0; i < length32; i += 8) {
    x = input[i >> 5] >>> i % 32 & 0xff;
    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__(117);



function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(633);


var v5 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v5);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var i = 0; i < N; i++) {
    M[i] = new Array(16);

    for (var j = 0; j < 16; j++) {
      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var i = 0; i < N; i++) {
    var W = new Array(80);

    for (var t = 0; t < 16; t++) {
      W[t] = M[i][t];
    }

    for (var t = 16; t < 80; t++) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var t = 0; t < 80; t++) {
      var s = Math.floor(t / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var AccountPage=(_class=function(){function AccountPage(store,data){_classCallCheck(this,AccountPage);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'wait',_descriptor2,this);_initDefineProp(this,'isLoading',_descriptor3,this);_initDefineProp(this,'password',_descriptor4,this);_initDefineProp(this,'result',_descriptor5,this);_initDefineProp(this,'error',_descriptor6,this);this.store=store;// this.getData();
}_createClass(AccountPage,[{key:'init',value:function init(){this.getData();}},{key:'getData',value:function getData(){var _this=this;return _api2.default.user.getAccountData().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this.data=res.result;}else{_this.setError(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setError('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=false;}));}},{key:'setError',value:function setError(text){this.error.status=1;this.error.text=text;}},{key:'clearError',value:function clearError(){this.error.status=0;this.error.text='';}},{key:'setError',value:function setError(text){this.result.error=text;}},{key:'inputPass',value:function inputPass(val,type){var number=val.replace(/\D+/g,"");this.result.error='';if(number.toString().length>0){this.password['pass'+type]=number;}else{this.password['pass'+type]='';}}},{key:'savePass',value:function savePass(){var _this2=this;this.wait=true;this.result.error='';this.result.success='';var data={'password':this.password.pass1,'new_password':this.password.pass2,'new_password2':this.password.pass3};return _api2.default.user.savePass(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this2.result.success='PASSWORD_CHANGED_SUCCESSFULLY';_this2.password.pass1='';_this2.password.pass2='';_this2.password.pass3='';setTimeout(function(){_this2.result.success='';_this2.store.changePsw=0;},2000);}else{_this2.result.error=res.text?res.text:'SERVER_TEMPORARILY_DOWN';}})).catch((0,_mobx.action)(function(err){_this2.result.error='SERVER_TEMPORARILY_DOWN';})).finally((0,_mobx.action)(function(){_this2.wait=false;}));}}]);return AccountPage;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'wait',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'password',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{pass1:'',pass2:'',pass3:''};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{error:'',success:''};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'error',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:''};}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inputPass',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'inputPass'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'savePass',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'savePass'),_class.prototype)),_class);exports.default=AccountPage;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var HistoryPage=(_class=function(){function HistoryPage(store,data){_classCallCheck(this,HistoryPage);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);_initDefineProp(this,'wait',_descriptor3,this);_initDefineProp(this,'filter',_descriptor4,this);_initDefineProp(this,'date',_descriptor5,this);_initDefineProp(this,'result',_descriptor6,this);this.store=store;this.getData();}_createClass(HistoryPage,[{key:'getData',value:function getData(){var _this=this;return _api2.default.user.getHistoryData().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this.filter=res.result;_this.date=res.result.default.date;_this.loadData(_this.date);}else{_this.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=false;}));}},{key:'selectDate',value:function selectDate(date){this.date=date;}},{key:'setResult',value:function setResult(text){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.result.status=1;this.result.text=text;this.result.type=type;}},{key:'clear',value:function clear(){this.result.status=0;this.result.text='';this.result.type=0;}},{key:'loadData',value:function loadData(date){var _this2=this;this.wait=true;this.clear();var data={date:this.date};return _api2.default.user.getHistory(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this2.data=res.result;}else{_this2.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this2.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this2.wait=false;}));}},{key:'cancel',value:function cancel(id){var _this3=this;this.clear();var data={action:'cancel',id:id};return _api2.default.user.setCancel(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this3.setResult(res.text,1);var indx=_this3.data.findIndex(function(item){return item==id;});_this3.data[indx].allow_cancel=0;_this3.data[indx].status=id;}else{_this3.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this3.setResult('SERVER_TEMPORARILY_DOWN');}));}}]);return HistoryPage;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'wait',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'filter',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 30;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectDate',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectDate'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'cancel',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'cancel'),_class.prototype)),_class);exports.default=HistoryPage;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BetsPage=(_class=function(){function BetsPage(store,data){_classCallCheck(this,BetsPage);this.newDate=new Date();_initDefineProp(this,'dict',_descriptor,this);_initDefineProp(this,'bets',_descriptor2,this);_initDefineProp(this,'isLoading',_descriptor3,this);_initDefineProp(this,'wait',_descriptor4,this);_initDefineProp(this,'filter',_descriptor5,this);_initDefineProp(this,'date',_descriptor6,this);_initDefineProp(this,'regDate',_descriptor7,this);_initDefineProp(this,'status',_descriptor8,this);_initDefineProp(this,'showDop',_descriptor9,this);_initDefineProp(this,'result',_descriptor10,this);this.store=store;// this.getData();
}_createClass(BetsPage,[{key:'despose',value:function despose(){this.status=0;this.bets=null;this.date={from:new Date(),to:new Date()};}},{key:'init',value:function init(){this.getData();}},{key:'getData',value:function getData(){var _this=this;return _api2.default.user.getBetsPeriodData().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this.filter=res.result;_this.loadData();}else{_this.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=false;}));}},{key:'selectDate',value:function selectDate(range){this.date=range;}},{key:'selectStatus',value:function selectStatus(status){this.status=status;}},{key:'setResult',value:function setResult(text){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.result.status=1;this.result.text=text;this.result.type=type;}},{key:'clear',value:function clear(){this.result.status=0;this.result.text='';this.result.type=0;}},{key:'loadData',value:function loadData(from,to){var _this2=this;this.wait=true;this.clear();var data={status:this.status,date_from:this.date.from.getTime(),date_to:this.date.to.getTime()};return _api2.default.user.getBets(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this2.dict=res.result.dict;_this2.addBets(res.result.bets);// if (!this.regDate) {
// 	this.regDate = res.result.reg_date.split('-');
// }
}else{_this2.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}}))// .catch(action(err => {
//      this.setResult('SERVER_TEMPORARILY_DOWN');
//    }))
.finally((0,_mobx.action)(function(){_this2.wait=false;}));}},{key:'addBets',value:function addBets(bets){var _this3=this;this.bets=bets.map(function(item){if(item.games){item.games=item.games.map(function(i){i['sport_name']=_this3.dict.sport[i.sid];i['league_name']=_this3.dict.league[i.lid];i['event']=''+_this3.dict.cmd[i.c1_id]+(i.c2_id?' - '+_this3.dict.cmd[i.c2_id]:'');i['name']=_this3.dict.odd_bet[i.odd_id];return i;});return item;}else{return item;}});}},{key:'cancel',value:function cancel(id){var _this4=this;this.clear();var data={action:'cancel',id:id};return _api2.default.user.setCancel(data).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this4.setResult(res.text,1);var indx=_this4.data.findIndex(function(item){return item==id;});_this4.data[indx].allow_cancel=0;_this4.data[indx].status=id;}else{_this4.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this4.setResult('SERVER_TEMPORARILY_DOWN');}));}},{key:'offset',get:function get(){return new Date(new Date().getFullYear(),new Date().getMonth()-this.filter.month,1);}}]);return BetsPage;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'bets',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'wait',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'filter',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{from:new Date(),to:new Date()};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'regDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'status',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'showDop',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_applyDecoratedDescriptor(_class.prototype,'despose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'despose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offset',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'offset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectDate',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectDate'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectStatus',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectStatus'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addBets'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'cancel',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'cancel'),_class.prototype)),_class);exports.default=BetsPage;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11;var _mobx=__webpack_require__(5);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var WS_KEY='debug:websocket';var Ig=(_class=function(){function Ig(store){// this.store = store;
var _this=this;_classCallCheck(this,Ig);_initDefineProp(this,'events',_descriptor,this);_initDefineProp(this,'statsByTeam',_descriptor2,this);_initDefineProp(this,'statsByTeamTexts',_descriptor3,this);_initDefineProp(this,'notExists',_descriptor4,this);_initDefineProp(this,'game',_descriptor5,this);_initDefineProp(this,'error',_descriptor6,this);_initDefineProp(this,'video',_descriptor7,this);this.attempts=0;this.latestSubData=null;this.ws=null;this.lang={1:1049,// ru
5:1065,// fa
2:2057// en
};this.getSocket=function(){if(!('WebSocket'in window)){return;}if(_this.ws&&_this.ws.readyState!==WebSocket.CLOSED){return _this.ws;}_this.ws=new WebSocket(_this.url);_this.ws.addEventListener('message',_this.onMessage);_this.ws.addEventListener('close',_this.onClose);_this.ws.addEventListener('error',_this.onError);return _this.ws;};this.send=function(data){if(_this.ws.readyState===WebSocket.OPEN){_this.ws.send(JSON.stringify(data));}};this.subscribe=function(id,lang_id){_this.attempts=0;var data={t:4,op:0,d:{id:id,lng:_this.lang[lang_id]}};_this.latestSubData={id:id,lang_id:lang_id};_this.send(data);};this.unSubscribe=function(){if(_this.ws&&_this.ws.readyState===WebSocket.OPEN){_this.send({t:4,op:1});}_this.reset();};this.onMessage=function(e){var data=JSON.parse(e.data);if(data.t===28){_accountStore2.default.updateBets(data.d);}if(data.t===14){_accountStore2.default.updateCountBets(data.d);}if(data.t===13){_accountStore2.default.updateBalance(data.d);}if(data.t!==4){return;}_this.setData(data);};this.onClose=function(evt){_this.ws=null;console.log(evt);if(evt.code===1001){// Going away
_this.reInit();}};_initDefineProp(this,'onError',_descriptor8,this);_initDefineProp(this,'reInit',_descriptor9,this);_initDefineProp(this,'setVideoParam',_descriptor10,this);_initDefineProp(this,'onLoadVideo',_descriptor11,this);}_createClass(Ig,[{key:'init',value:function init(id,lang_id){var _this2=this;if('WebSocket'in window){if(!this.ws||this.ws.readyState===WebSocket.CLOSED){var ws=this.getSocket();ws.onopen=function(){return _this2.subscribe(id,lang_id);};this.latestSubData={id:id,lang_id:lang_id};}else{this.subscribe(id,lang_id);}}}},{key:'setData',value:function setData(data){if(data.d.notExists){this.game.stats=0;this.reset();return false;}if(data.d.diff===false){this.reset();}this.notExists=false;if(data.d.score){this.game.score=data.d.score;}if(data.d.events){var _events;(_events=this.events).unshift.apply(_events,_toConsumableArray(data.d.events));}this.statsByTeam=_extends({},this.statsByTeam,data.d.statsByTeam);if(data.d.statsByTeamTexts){this.statsByTeamTexts=data.d.statsByTeamTexts;}}},{key:'handleLogout',value:function handleLogout(){if(this.video.type===2){// медиасервер
this.setVideoParam('src',null);}}},{key:'getVideo',value:function getVideo(_ref){var _this3=this;var gid=_ref.gid,type=_ref.type,silent=_ref.silent,retry=_ref.retry;this.video.detached=false;if(!retry){this.video.src=null;}this.video.title=null;this.video.isLoading=true;this.video.ready=false;this.video.started=false;this.video.isLoading=false;_api2.default.live.video(gid,type).then(function(res){return _this3.onLoadVideo({gid:gid,silent:silent,res:res});});}},{key:'setGame',value:function setGame(game){if(!(game&&game.video_type||game.stats))return;if(this.game){this.close();}this.game=(0,_mobx.toJS)(game);var id=game.id,video_type=game.video_type;var type=video_type&&video_type[0];if(type){this.getVideo({gid:id,type:type,silent:true});}if(game.stats){this.init(game.id,1);}}},{key:'close',value:function close(){this.unSubscribe();this.game=null;this.video={gid:null,src:null,playing:true,volume:0.5,title:null,detached:false,error:null,type:null,isLoading:false,started:false,ready:false,showList:false};}},{key:'reset',value:function reset(){this.events=[];this.statsByTeam={};this.statsByTeamTexts=[];this.notExists=true;this.error=false;}},{key:'url',get:function get(){// ! Proxy
// return 'ws://pre.almara.org:8084/wss';
return localStorage.getItem(WS_KEY)||(window.location.protocol==='https:'?'wss':'ws')+'://'+window.location.host+'/wss';}}]);return Ig;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'events',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'statsByTeam',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'statsByTeamTexts',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'notExists',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'game',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'error',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'video',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{gid:null,src:null,playing:true,volume:0.5,title:null,detached:false,error:null,type:null,isLoading:false,started:false,ready:false,showList:false};}}),_applyDecoratedDescriptor(_class.prototype,'setData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'onError',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){if(_this4.attempts<1){_this4.attempts++;setTimeout(function(){_this4.reInit();},500);}else{_this4.attempts=0;_this4.error=true;}};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'reInit',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.error=false;if(_this5.latestSubData){_this5.init(_this5.latestSubData.id,_this5.latestSubData.lang_id);}};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'setVideoParam',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(name,val){var video=_extends({},(0,_mobx.toJS)(_this6.video),_defineProperty({},name,val));if(name==='src'&&!val){video.gid=null;}_this6.video=video;};}}),_applyDecoratedDescriptor(_class.prototype,'getVideo',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getVideo'),_class.prototype),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'onLoadVideo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(_ref2){var gid=_ref2.gid,silent=_ref2.silent,res=_ref2.res;if(res.code===0){_this7.video=_extends({},(0,_mobx.toJS)(_this7.video),{playing:!silent,gid:gid,src:res.result[gid].url,title:res.result[gid].name,type:res.result[gid].type,detached:false,error:null,showList:false});}else if(res.code===1){_this7.video.error=res.text||'SERVICE_TEMPORARILY_DOWN';}else{_this7.video.error=res.code;}};}}),_applyDecoratedDescriptor(_class.prototype,'setGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setGame'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'close',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'close'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype)),_class);exports.default=Ig;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * Default configs.
 */
var DEFAULT_DELIMITER = '/'
var DEFAULT_DELIMITERS = './'

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
  // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER
  var delimiters = (options && options.delimiters) || DEFAULT_DELIMITERS
  var pathEscaped = false
  var res

  while ((res = PATH_REGEXP.exec(str)) !== null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      pathEscaped = true
      continue
    }

    var prev = ''
    var next = str[index]
    var name = res[2]
    var capture = res[3]
    var group = res[4]
    var modifier = res[5]

    if (!pathEscaped && path.length) {
      var k = path.length - 1

      if (delimiters.indexOf(path[k]) > -1) {
        prev = path[k]
        path = path.slice(0, k)
      }
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
      pathEscaped = false
    }

    var partial = prev !== '' && next !== undefined && next !== prev
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prev || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prev,
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
    })
  }

  // Push any remaining characters.
  if (path || index < str.length) {
    tokens.push(path + str.substr(index))
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (data, options) {
    var path = ''
    var encode = (options && options.encode) || encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token
        continue
      }

      var value = data ? data[token.name] : undefined
      var segment

      if (Array.isArray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
        }

        if (value.length === 0) {
          if (token.optional) continue

          throw new TypeError('Expected "' + token.name + '" to not be empty')
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j], token)

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        segment = encode(String(value), token)

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
        }

        path += token.prefix + segment
        continue
      }

      if (token.optional) {
        // Prepend partial segment prefixes.
        if (token.partial) path += token.prefix

        continue
      }

      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$/()])/g, '\\$1')
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  if (!keys) return path

  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
      })
    }
  }

  return path
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  options = options || {}

  var strict = options.strict
  var start = options.start !== false
  var end = options.end !== false
  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER)
  var delimiters = options.delimiters || DEFAULT_DELIMITERS
  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|')
  var route = start ? '^' : ''
  var isEndDelimited = tokens.length === 0

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1
    } else {
      var capture = token.repeat
        ? '(?:' + token.pattern + ')(?:' + escapeString(token.delimiter) + '(?:' + token.pattern + '))*'
        : token.pattern

      if (keys) keys.push(token)

      if (token.optional) {
        if (token.partial) {
          route += escapeString(token.prefix) + '(' + capture + ')?'
        } else {
          route += '(?:' + escapeString(token.prefix) + '(' + capture + '))?'
        }
      } else {
        route += escapeString(token.prefix) + '(' + capture + ')'
      }
    }
  }

  if (end) {
    if (!strict) route += '(?:' + delimiter + ')?'

    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')'
  } else {
    if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?'
    if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')'
  }

  return new RegExp(route, flags(options))
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys)
  }

  if (Array.isArray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
  }

  return stringToRegexp(/** @type {string} */ (path), keys, options)
}


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(5));
	else if(typeof define === 'function' && define.amd)
		define("MobxReactRouter", ["mobx"], factory);
	else if(typeof exports === 'object')
		exports["MobxReactRouter"] = factory(require("mobx"));
	else
		root["MobxReactRouter"] = factory(root["Mobx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external {"root":"Mobx","commonjs2":"mobx","commonjs":"mobx","amd":"mobx"}
var external_root_Mobx_commonjs2_mobx_commonjs_mobx_amd_mobx_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/store.js
var _class, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }


var RouterStore = (_class = (_temp =
/*#__PURE__*/
function () {
  function RouterStore() {
    var _this = this;

    _classCallCheck(this, RouterStore);

    _initializerDefineProperty(this, "location", _descriptor, this);

    this.history = null;

    this.push = function (location, state) {
      _this.history.push(location, state);
    };

    this.replace = function (location, state) {
      _this.history.replace(location, state);
    };

    this.go = function (n) {
      _this.history.go(n);
    };

    this.goBack = function () {
      _this.history.goBack();
    };

    this.goForward = function () {
      _this.history.goForward();
    };

    this.push = this.push.bind(this);
    this.replace = this.replace.bind(this);
    this.go = this.go.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goForward = this.goForward.bind(this);
  }

  _createClass(RouterStore, [{
    key: "_updateLocation",
    value: function _updateLocation(newState) {
      this.location = newState;
    }
    /*
     * History methods
     */

  }]);

  return RouterStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "location", [external_root_Mobx_commonjs2_mobx_commonjs_mobx_amd_mobx_["observable"]], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "_updateLocation", [external_root_Mobx_commonjs2_mobx_commonjs_mobx_amd_mobx_["action"]], Object.getOwnPropertyDescriptor(_class.prototype, "_updateLocation"), _class.prototype)), _class);
;
// CONCATENATED MODULE: ./src/sync.js
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var sync_syncHistoryWithStore = function syncHistoryWithStore(history, store) {
  // Initialise store
  store.history = history; // Handle update from history object

  var handleLocationChange = function handleLocationChange(location) {
    store._updateLocation(location);
  };

  var unsubscribeFromHistory = history.listen(handleLocationChange);
  handleLocationChange(history.location);

  var subscribe = function subscribe(listener) {
    var onStoreChange = function onStoreChange() {
      var rawLocation = _objectSpread({}, store.location);

      listener(rawLocation, history.action);
    }; // Listen for changes to location state in store


    var unsubscribeFromStore = Object(external_root_Mobx_commonjs2_mobx_commonjs_mobx_amd_mobx_["observe"])(store, 'location', onStoreChange);
    listener(store.location, history.action);
    return unsubscribeFromStore;
  };

  history.subscribe = subscribe;
  history.unsubscribe = unsubscribeFromHistory;
  return history;
};
// CONCATENATED MODULE: ./index.js
/* concated harmony reexport RouterStore */__webpack_require__.d(__webpack_exports__, "RouterStore", function() { return RouterStore; });
/* concated harmony reexport syncHistoryWithStore */__webpack_require__.d(__webpack_exports__, "syncHistoryWithStore", function() { return sync_syncHistoryWithStore; });



/***/ })
/******/ ]);
});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_class2,_temp;var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);var _mobx=__webpack_require__(5);var _lodash=__webpack_require__(10);var _noty=__webpack_require__(641);var _noty2=_interopRequireDefault(_noty);var _sprintfJs=__webpack_require__(205);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _common=__webpack_require__(6);var _basket=__webpack_require__(642);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var mess={'BASKET_ERROR_SYSTEM_3':'В системе минимум 3 события','SYSTEM_TEMPLATE':'%d по %d (%s %s)',"SYSTEM_V1":"вариант","SYSTEM_V4":"варианта","SYSTEM_V5":"вариантов"};var MIN_WIDTH=1500;var BasketStore=(_class=(_temp=_class2=function(){_createClass(BasketStore,[{key:'no_live_odd',/** КОСТЫЛЬ: словарь live-ставок, чтобы морозить vip-флажок ставки */get:function get(){return this.live_odds.size===0;}}]);function BasketStore(store,accountStore,appStore){var _this=this;_classCallCheck(this,BasketStore);this.basketAPI=new _api2.default.BasketAPI({is_mobile:false});this.store=null;this.MAX_COUNT=29;this.account=null;_initDefineProp(this,'agree_cf',_descriptor,this);_initDefineProp(this,'isLocked',_descriptor2,this);_initDefineProp(this,'betsOrder',_descriptor3,this);_initDefineProp(this,'clearBasketAfterBet',_descriptor4,this);_initDefineProp(this,'isLoading',_descriptor5,this);_initDefineProp(this,'odds',_descriptor6,this);_initDefineProp(this,'mode',_descriptor7,this);_initDefineProp(this,'vip',_descriptor8,this);_initDefineProp(this,'triggerToogle',_descriptor9,this);_initDefineProp(this,'amount',_descriptor10,this);_initDefineProp(this,'dict',_descriptor11,this);_initDefineProp(this,'successBet',_descriptor12,this);_initDefineProp(this,'success',_descriptor13,this);_initDefineProp(this,'oneClick',_descriptor14,this);_initDefineProp(this,'amountMax',_descriptor15,this);_initDefineProp(this,'fastAmount',_descriptor16,this);_initDefineProp(this,'possibleWin',_descriptor17,this);_initDefineProp(this,'expressCf',_descriptor18,this);_initDefineProp(this,'type',_descriptor19,this);_initDefineProp(this,'error',_descriptor20,this);_initDefineProp(this,'systemTypeAvailable',_descriptor21,this);_initDefineProp(this,'toogleBasket',_descriptor22,this);_initDefineProp(this,'basketData',_descriptor23,this);_initDefineProp(this,'maxHeight',_descriptor24,this);_initDefineProp(this,'live_odds',_descriptor25,this);this.store=store;this.account=accountStore;this.appStore=appStore;this.onCoefChoose=this.onCoefChoose.bind(this);/** Чистим корзину, только если был авторизован */accountStore.access&&this.clearLocalStorage();// if (!this.account.fastAmount) this.fastAmount.amounts = this.account.fastAmount;
this.init();(0,_mobx.autorun)(function(){_this.setValue('agree_cf',_this.account.accountSettings.basketAgreeCf);_this.setValue('clearBasketAfterBet',_this.account.accountSettings.clearBasketAfterBet);if(_this.account.accountSettings.basketPosition=='left'){_this.toogleBasket.showBasket=true;_this.getMinHeight();}else if(_this.account.accountSettings.basketPosition=='right'){_this.resizeWindow();_this.getMinHeight();}});this.resizeWindow();var isIrm=true;this.basketBusiness=new _basket.BasketBusiness({timezone:(0,_lodash.get)(this.appStore,'timezoneId')||Number(_jsCookie2.default.get('timezone'))||3,currency:(0,_lodash.get)(this.appStore,'currency.id')||2,jwt:_jsCookie2.default.get('jwt'),terminal:+_jsCookie2.default.get('terminal_id'),// expressMultiplier: false,
// expressInsurance: !getConfig('IS_SERVER') ? JSON.parse(localStorage.getItem('insurance_condition') || 'null') || false : false,
coeffKind:(0,_lodash.get)(this.account,'settings.coef_id')},this.setBasketData.bind(this),_api2.default.basket,'IRM',isIrm);this.newRestoreFromLocalStorage();if(this.account.accountSettings.clearBasketAfterBet){this.newBasketSetIsClearBasketAfterBet();}this.setAgreeWithCoefChanging(this.account.accountSettings.basketAgreeCf);this.newSetIsBetOneClickSum(this.account.accountSettings.oneClickBetAmount||typeof _jsCookie2.default.get('basket_one_click_amount')!=='undefined'?JSON.parse(_jsCookie2.default.get('basket_one_click_amount')):0);if(_jsCookie2.default.get('basket_one_click_toggle')){this.newSetIsBetOneClick(JSON.parse(_jsCookie2.default.get('basket_one_click_toggle')));}window.addEventListener("resize",function(){_this.resizeWindow();});}_createClass(BasketStore,[{key:'setBasketData',value:function setBasketData(data){this.basketData=data;}},{key:'newAddOdd',value:function newAddOdd(oddId,matchId){var _this2=this;if(this.basketBusiness.state.isBetOneClick){this.basketBusiness.addOdd(oddId,matchId).then(function(){// Логирование совершениня ставки wagerDone - ставка в 1 клик
var data=_this2.basketBusiness.doBetRequestData;var result=data.result.code;var cardId=data.result.card_id;var odds=Object.values(data.result.odds);var place='one_click_bet';var type=data.result.type;var detailLog={place:place,type:type};if(result===0){detailLog.result='success';detailLog.cardId=type!==1?cardId:odds.map(function(odd){return odd.card_id;});}else{// Если вернулась ошибка
detailLog.result='error';detailLog.error={code:data.result.code,message:data.result.text};}var kafkaData={topic:"wagers",action:{eventType:"bk",eventCode:"wager_done",detail:detailLog},additional_data:{eventSource:'irm',appId:0,appVer:1,login:_this2.account.login||_this2.account.AccountPage.data.login||''}};return _api2.default.kafka.kafkaLog(kafkaData);});}else{this.basketBusiness.addOdd(oddId,matchId);}var oddCash=JSON.parse(localStorage.getItem('BasketOdds')||'null')||[];if(oddCash.length>29){oddCash.pop();}oddCash=oddCash.filter(function(cash){return+(0,_lodash.get)(cash,'matchId')!==+matchId;});oddCash=oddCash.filter(function(cash){return(0,_lodash.get)(_this2.basketData,['odds',cash.oddId,'cf']);});localStorage.setItem('BasketOdds',JSON.stringify([].concat(_toConsumableArray(oddCash),[{oddId:oddId,matchId:matchId}])));}},{key:'newRestoreFromLocalStorage',value:function newRestoreFromLocalStorage(){var oddCash=JSON.parse(localStorage.getItem('BasketOdds')||'null')||[];this.basketBusiness.addMultiOdds(oddCash.map(function(cash){return(0,_lodash.get)(cash,'oddId');}));}},{key:'newDeleteOdd',value:function newDeleteOdd(oddId){var _this3=this;this.basketBusiness.deleteOdd(oddId);var oddCash=JSON.parse(localStorage.getItem('BasketOdds')||'null')||[];oddCash=oddCash.filter(function(cash){return cash.oddId!==oddId;});oddCash=oddCash.filter(function(cash){return(0,_lodash.get)(_this3.basketData,['odds',cash.oddId,'cf']);});localStorage.setItem('BasketOdds',JSON.stringify([].concat(_toConsumableArray(oddCash))));}},{key:'resizeWindow',value:function resizeWindow(){if(this.account.accountSettings.basketPosition=='right'){if(window.innerWidth>=MIN_WIDTH){this.toogleBasket.showArrow=false;this.toogleBasket.showBasket=true;}else{this.toogleBasket.showArrow=true;}}}},{key:'hideBasket',value:function hideBasket(){if(this.account.accountSettings.basketPosition=='right'){if(window.innerWidth<MIN_WIDTH){this.toogleBasket.showBasket=false;}}}},{key:'setShowBasket',value:function setShowBasket(){this.toogleBasket.showBasket=!this.toogleBasket.showBasket;}},{key:'setValue',value:function setValue(k,v){this[k]=v;}},{key:'getMinHeight',value:function getMinHeight(){if(this.isLoading)return;if(this.account.accountSettings.basketPosition=='right'){this.maxHeight='none';}else{var ih=document.querySelector('basket-item')?document.querySelector('basket-item').offsetHeigth:80;if(this.odds.size>3){this.maxHeight=3*ih;}else{this.maxHeight=this.odds.size*ih;}}}},{key:'checkBasketSettings',value:function checkBasketSettings(){var checkCurrency=this.basketBusiness.state.config.currency!==this.appStore.currency.id||2;var checkTimeZone=this.basketBusiness.state.config.timezone!==this.appStore.timezoneId||Number(_jsCookie2.default.get('timezone'));if(checkCurrency){this.basketBusiness.state.config.currency=this.appStore.currency.id||2;}if(checkTimeZone){this.basketBusiness.state.config.timezone=this.appStore.timezoneId||Number(_jsCookie2.default.get('timezone'));}if(checkCurrency||checkTimeZone){this.basketBusiness.getOddData();}}},{key:'setAgreeWithCoefChanging',value:function setAgreeWithCoefChanging(agreeWithOddChanging){this.basketBusiness.setAgreeWithCoefChanging(agreeWithOddChanging);}},{key:'init',value:function init(){this.mode=this.store.mode;this.agree_cf=this.account.accountSettings.basketAgreeCf;this.clearBasketAfterBet=this.account.accountSettings.clearBasketAfterBet;this.oneClick.amount=this.account.accountSettings.oneClickBetAmount;// this.checkBasketSettings()
this.isLoading=false;}},{key:'setData',value:function setData(k,v){this[k]=v;}},{key:'addOdd',value:function addOdd(odds){if(odds){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(odds)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _step$value=_slicedToArray(_step.value,2),key=_step$value[0],item=_step$value[1];if(this.oneClick.st){item['amount']=this.account.accountSettings.oneClickBetAmount;}else{if(!this.odds.has(item.gid)){item['amount']=this.fastAmount.amount;this.betsOrder.push(item.gid.toString());}else{item['amount']=this.odds.get(item.gid).amount;}}item.c1=this.dict.cmd[item.c1_id];if(item.c2_id)item['c2']=this.dict.cmd[item.c2_id];item['error']='';item['result']='';item['status']=0;// 0 - add, 1 - success and delete,
item.name=this.generateBetName(this.dict.odd[item.odd],item.odd,item.d1,item.d2,item.c1,item.c2);item.type=item.type||this.mode;if(item.type==='live'){this.live_odds.set(''+item.gid,item);}this.odds.set(item.gid,item);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(!this.type.current)this.type.current=1;if(!this.triggerToogle&&this.odds.size>1){this.type.current=2;}if(this.oneClick.st)this.setBet();}else{this.setError('Ставка не найдена');this.oneClick.wait=0;}this.save();}},{key:'onCoefChoose',value:function onCoefChoose(oddID){this.store.sideEffect();return this.doBet(oddID);}},{key:'setBetType',value:function setBetType(typeId){this.basketBusiness.setBetType(typeId);}},{key:'newOnOrdinarAmountInput',value:function newOnOrdinarAmountInput(amount,oddId){this.basketBusiness.onOrdinarAmountInput(amount,oddId);}},{key:'newSetSystemType',value:function newSetSystemType(type){this.basketBusiness.setSystemType(type);}},{key:'newClearBasketAfterBet',value:function newClearBasketAfterBet(){this.basketBusiness.clearBasket();localStorage.setItem('BasketOdds',JSON.stringify([]));}},{key:'newBasketSetIsClearBasketAfterBet',value:function newBasketSetIsClearBasketAfterBet(){this.basketBusiness.setIsClearBasketAfterBet();}},{key:'newBasketDoBetRequest',value:function newBasketDoBetRequest(){var _this4=this;this.basketBusiness.doBetRequest().then(function(){// Логирование совершениня ставки wagerDone
var data=_this4.basketBusiness.doBetRequestData;var result=data.result.code;var cardId=data.result.card_id;var odds=Object.values(data.result.odds);var place='fromBasket';var type=data.result.type;var detailLog={place:place,type:type};if(result===0){detailLog.result='success';detailLog.cardId=type!==1?cardId:odds.map(function(odd){return odd.card_id;});}else{// Если вернулась ошибка
detailLog.result='error';detailLog.error={code:data.result.code,message:data.result.text};}var kafkaData={topic:"wagers",action:{eventType:"bk",eventCode:"wager_done",detail:detailLog},additional_data:{eventSource:'irm',appId:0,appVer:1,login:_this4.account.login||_this4.account.AccountPage.data.login||''}};return _api2.default.kafka.kafkaLog(kafkaData);});if(this.basketData.isRequestSuccess&&this.basketData.isClearBasketAfterBet){localStorage.setItem('BasketOdds',JSON.stringify([]));}}},{key:'newSetIsVipBet',value:function newSetIsVipBet(isVipBet){this.basketBusiness.setIsVipBet(isVipBet);}},{key:'newSetIsBetOneClick',value:function newSetIsBetOneClick(isOneClick){_jsCookie2.default.set('basket_one_click_toggle',isOneClick);this.basketBusiness.setIsBetOneClick(isOneClick);}},{key:'newSetIsBetOneClickSum',value:function newSetIsBetOneClickSum(amount){_jsCookie2.default.set('basket_one_click_amount',amount);this.basketBusiness.setIsBetOneClickSum(amount);}},{key:'newOnExpressOrSystemAmountInput',value:function newOnExpressOrSystemAmountInput(amount){this.basketBusiness.onExpressOrSystemAmountInput(amount);}},{key:'newSetError',value:function newSetError(errorText){this.basketBusiness.setGlobalError(errorText);}},{key:'applyOneClickAmount',value:function applyOneClickAmount(){var _this5=this;if(this.basketData.oneClickBetAmount){if(!this.account.access){this.account.showLoginForm=true;return false;}this.oneClick.wait=1;_api2.default.basket.setOneClickAmount(this.basketData.oneClickBetAmount).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this5.newSetError('Изменения сохранены');_this5.account.toggleAccountSettings('oneClickBetAmount',_this5.basketData.oneClickBetAmount);}else{_this5.newSetError(data.text);}})).catch((0,_mobx.action)(function(err){_this5.newSetError('Ошибка сервера');})).finally((0,_mobx.action)(function(){_this5.oneClick.wait=0;_this5.basketBusiness.notify();}));}else{this.newSetError('Укажите сумму');this.basketBusiness.notify();}}}]);return BasketStore;}(),_class2.LOCAL_STORAGE_KEY='lineStore_basket',_temp),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'agree_cf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLocked',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'betsOrder',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'clearBasketAfterBet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'odds',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'mode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'vip',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'triggerToogle',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'amount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{cmd:{},odd:{}};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'successBet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'success',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:0};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'oneClick',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{st:0,wait:0,amount:0,type:1,showOdd:0};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'amountMax',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{max:0,minVip:0,html:''};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'fastAmount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{// amounts: [100, 500, 1000],
error:'',amount:0};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'possibleWin',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'expressCf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{cf:0,html:''};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'type',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{sys_type:'',current:0};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'error',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'systemTypeAvailable',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'toogleBasket',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{showArrow:false,showBasket:true};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'basketData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'maxHeight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'none';}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'live_odds',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_applyDecoratedDescriptor(_class.prototype,'no_live_odd',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'no_live_odd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setBasketData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setBasketData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newAddOdd',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newAddOdd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newDeleteOdd',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newDeleteOdd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'resizeWindow',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'resizeWindow'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hideBasket',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'hideBasket'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setShowBasket',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setShowBasket'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setValue',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setValue'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getMinHeight',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getMinHeight'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkBasketSettings',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkBasketSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setAgreeWithCoefChanging',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setAgreeWithCoefChanging'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addOdd',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addOdd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setBetType',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setBetType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newOnOrdinarAmountInput',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newOnOrdinarAmountInput'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newSetSystemType',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newSetSystemType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newClearBasketAfterBet',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newClearBasketAfterBet'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newBasketSetIsClearBasketAfterBet',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newBasketSetIsClearBasketAfterBet'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newBasketDoBetRequest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newBasketDoBetRequest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newSetIsVipBet',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newSetIsVipBet'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newSetIsBetOneClick',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newSetIsBetOneClick'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newSetIsBetOneClickSum',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newSetIsBetOneClickSum'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newOnExpressOrSystemAmountInput',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newOnExpressOrSystemAmountInput'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'newSetError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'newSetError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'applyOneClickAmount',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'applyOneClickAmount'),_class.prototype)),_class);exports.default=BasketStore;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

/* 
  @package NOTY - Dependency-free notification library 
  @version version: 3.2.0-beta 
  @contributors https://github.com/needim/noty/graphs/contributors 
  @documentation Examples and Documentation - https://ned.im/noty 
  @license Licensed under the MIT licenses: http://www.opensource.org/licenses/mit-license.php 
*/

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Noty", [], factory);
	else if(typeof exports === 'object')
		exports["Noty"] = factory();
	else
		root["Noty"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = exports.deepExtend = exports.animationEndEvents = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.inArray = inArray;
exports.stopPropagation = stopPropagation;
exports.generateID = generateID;
exports.outerHeight = outerHeight;
exports.addListener = addListener;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.remove = remove;
exports.classList = classList;
exports.visibilityChangeFlow = visibilityChangeFlow;
exports.createAudioElements = createAudioElements;

var _api = __webpack_require__(1);

var API = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var animationEndEvents = exports.animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

function inArray(needle, haystack, argStrict) {
  var key = void 0;
  var strict = !!argStrict;

  if (strict) {
    for (key in haystack) {
      if (haystack.hasOwnProperty(key) && haystack[key] === needle) {
        return true;
      }
    }
  } else {
    for (key in haystack) {
      if (haystack.hasOwnProperty(key) && haystack[key] === needle) {
        return true;
      }
    }
  }
  return false;
}

function stopPropagation(evt) {
  evt = evt || window.event;

  if (typeof evt.stopPropagation !== 'undefined') {
    evt.stopPropagation();
  } else {
    evt.cancelBubble = true;
  }
}

var deepExtend = exports.deepExtend = function deepExtend(out) {
  out = out || {};

  for (var i = 1; i < arguments.length; i++) {
    var obj = arguments[i];

    if (!obj) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          out[key] = obj[key];
        } else if (_typeof(obj[key]) === 'object' && obj[key] !== null) {
          out[key] = deepExtend(out[key], obj[key]);
        } else {
          out[key] = obj[key];
        }
      }
    }
  }

  return out;
};

function generateID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var id = 'noty_' + prefix + '_';

  id += 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });

  return id;
}

function outerHeight(el) {
  var height = el.offsetHeight;
  var style = window.getComputedStyle(el);

  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}

var css = exports.css = function () {
  var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
  var cssProps = {};

  function camelCase(string) {
    return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
      return letter.toUpperCase();
    });
  }

  function getVendorProp(name) {
    var style = document.body.style;
    if (name in style) return name;

    var i = cssPrefixes.length;
    var capName = name.charAt(0).toUpperCase() + name.slice(1);
    var vendorName = void 0;

    while (i--) {
      vendorName = cssPrefixes[i] + capName;
      if (vendorName in style) return vendorName;
    }

    return name;
  }

  function getStyleProp(name) {
    name = camelCase(name);
    return cssProps[name] || (cssProps[name] = getVendorProp(name));
  }

  function applyCss(element, prop, value) {
    prop = getStyleProp(prop);
    element.style[prop] = value;
  }

  return function (element, properties) {
    var args = arguments;
    var prop = void 0;
    var value = void 0;

    if (args.length === 2) {
      for (prop in properties) {
        if (properties.hasOwnProperty(prop)) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) {
            applyCss(element, prop, value);
          }
        }
      }
    } else {
      applyCss(element, args[1], args[2]);
    }
  };
}();

function addListener(el, events, cb) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  events = events.split(' ');
  for (var i = 0; i < events.length; i++) {
    if (document.addEventListener) {
      el.addEventListener(events[i], cb, useCapture);
    } else if (document.attachEvent) {
      el.attachEvent('on' + events[i], cb);
    }
  }
}

function hasClass(element, name) {
  var list = typeof element === 'string' ? element : classList(element);
  return list.indexOf(' ' + name + ' ') >= 0;
}

function addClass(element, name) {
  var oldList = classList(element);
  var newList = oldList + name;

  if (hasClass(oldList, name)) return;

  // Trim the opening space.
  element.className = newList.substring(1);
}

function removeClass(element, name) {
  var oldList = classList(element);
  var newList = void 0;

  if (!hasClass(element, name)) return;

  // Replace the class name.
  newList = oldList.replace(' ' + name + ' ', ' ');

  // Trim the opening and closing spaces.
  element.className = newList.substring(1, newList.length - 1);
}

function remove(element) {
  if (element.parentNode) {
    element.parentNode.removeChild(element);
  }
}

function classList(element) {
  return (' ' + (element && element.className || '') + ' ').replace(/\s+/gi, ' ');
}

function visibilityChangeFlow() {
  var hidden = void 0;
  var visibilityChange = void 0;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  function onVisibilityChange() {
    API.PageHidden = document[hidden];
    handleVisibilityChange();
  }

  function onBlur() {
    API.PageHidden = true;
    handleVisibilityChange();
  }

  function onFocus() {
    API.PageHidden = false;
    handleVisibilityChange();
  }

  function handleVisibilityChange() {
    if (API.PageHidden) stopAll();else resumeAll();
  }

  function stopAll() {
    setTimeout(function () {
      Object.keys(API.Store).forEach(function (id) {
        if (API.Store.hasOwnProperty(id)) {
          if (API.Store[id].options.visibilityControl) {
            API.Store[id].stop();
          }
        }
      });
    }, 100);
  }

  function resumeAll() {
    setTimeout(function () {
      Object.keys(API.Store).forEach(function (id) {
        if (API.Store.hasOwnProperty(id)) {
          if (API.Store[id].options.visibilityControl) {
            API.Store[id].resume();
          }
        }
      });
      API.queueRenderAll();
    }, 100);
  }

  if (visibilityChange) {
    addListener(document, visibilityChange, onVisibilityChange);
  }

  addListener(window, 'blur', onBlur);
  addListener(window, 'focus', onFocus);
}

function createAudioElements(ref) {
  if (ref.hasSound) {
    var audioElement = document.createElement('audio');

    ref.options.sounds.sources.forEach(function (s) {
      var source = document.createElement('source');
      source.src = s;
      source.type = 'audio/' + getExtension(s);
      audioElement.appendChild(source);
    });

    if (ref.barDom) {
      ref.barDom.appendChild(audioElement);
    } else {
      document.querySelector('body').appendChild(audioElement);
    }

    audioElement.volume = ref.options.sounds.volume;

    if (!ref.soundPlayed) {
      audioElement.play();
      ref.soundPlayed = true;
    }

    audioElement.onended = function () {
      remove(audioElement);
    };
  }
}

function getExtension(fileName) {
  return fileName.match(/\.([^.]+)$/)[1];
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Defaults = exports.Store = exports.Queues = exports.DefaultMaxVisible = exports.docTitle = exports.DocModalCount = exports.PageHidden = undefined;
exports.getQueueCounts = getQueueCounts;
exports.addToQueue = addToQueue;
exports.removeFromQueue = removeFromQueue;
exports.queueRender = queueRender;
exports.queueRenderAll = queueRenderAll;
exports.ghostFix = ghostFix;
exports.build = build;
exports.hasButtons = hasButtons;
exports.handleModal = handleModal;
exports.handleModalClose = handleModalClose;
exports.queueClose = queueClose;
exports.dequeueClose = dequeueClose;
exports.fire = fire;
exports.openFlow = openFlow;
exports.closeFlow = closeFlow;

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PageHidden = exports.PageHidden = false;
var DocModalCount = exports.DocModalCount = 0;

var DocTitleProps = {
  originalTitle: null,
  count: 0,
  changed: false,
  timer: -1
};

var docTitle = exports.docTitle = {
  increment: function increment() {
    DocTitleProps.count++;

    docTitle._update();
  },

  decrement: function decrement() {
    DocTitleProps.count--;

    if (DocTitleProps.count <= 0) {
      docTitle._clear();
      return;
    }

    docTitle._update();
  },

  _update: function _update() {
    var title = document.title;

    if (!DocTitleProps.changed) {
      DocTitleProps.originalTitle = title;
      document.title = '(' + DocTitleProps.count + ') ' + title;
      DocTitleProps.changed = true;
    } else {
      document.title = '(' + DocTitleProps.count + ') ' + DocTitleProps.originalTitle;
    }
  },

  _clear: function _clear() {
    if (DocTitleProps.changed) {
      DocTitleProps.count = 0;
      document.title = DocTitleProps.originalTitle;
      DocTitleProps.changed = false;
    }
  }
};

var DefaultMaxVisible = exports.DefaultMaxVisible = 5;

var Queues = exports.Queues = {
  global: {
    maxVisible: DefaultMaxVisible,
    queue: []
  }
};

var Store = exports.Store = {};

var Defaults = exports.Defaults = {
  type: 'alert',
  layout: 'topRight',
  theme: 'mint',
  text: '',
  timeout: false,
  progressBar: true,
  closeWith: ['click'],
  animation: {
    open: 'noty_effects_open',
    close: 'noty_effects_close'
  },
  id: false,
  force: false,
  killer: false,
  queue: 'global',
  container: false,
  buttons: [],
  callbacks: {
    beforeShow: null,
    onShow: null,
    afterShow: null,
    onClose: null,
    afterClose: null,
    onClick: null,
    onHover: null,
    onTemplate: null
  },
  sounds: {
    sources: [],
    volume: 1,
    conditions: []
  },
  titleCount: {
    conditions: []
  },
  modal: false,
  visibilityControl: false

  /**
   * @param {string} queueName
   * @return {object}
   */
};function getQueueCounts() {
  var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';

  var count = 0;
  var max = DefaultMaxVisible;

  if (Queues.hasOwnProperty(queueName)) {
    max = Queues[queueName].maxVisible;
    Object.keys(Store).forEach(function (i) {
      if (Store[i].options.queue === queueName && !Store[i].closed) count++;
    });
  }

  return {
    current: count,
    maxVisible: max
  };
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function addToQueue(ref) {
  if (!Queues.hasOwnProperty(ref.options.queue)) {
    Queues[ref.options.queue] = { maxVisible: DefaultMaxVisible, queue: [] };
  }

  Queues[ref.options.queue].queue.push(ref);
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function removeFromQueue(ref) {
  if (Queues.hasOwnProperty(ref.options.queue)) {
    var queue = [];
    Object.keys(Queues[ref.options.queue].queue).forEach(function (i) {
      if (Queues[ref.options.queue].queue[i].id !== ref.id) {
        queue.push(Queues[ref.options.queue].queue[i]);
      }
    });
    Queues[ref.options.queue].queue = queue;
  }
}

/**
 * @param {string} queueName
 * @return {void}
 */
function queueRender() {
  var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';

  if (Queues.hasOwnProperty(queueName)) {
    var noty = Queues[queueName].queue.shift();

    if (noty) noty.show();
  }
}

/**
 * @return {void}
 */
function queueRenderAll() {
  Object.keys(Queues).forEach(function (queueName) {
    queueRender(queueName);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function ghostFix(ref) {
  var ghostID = Utils.generateID('ghost');
  var ghost = document.createElement('div');
  ghost.setAttribute('id', ghostID);
  Utils.css(ghost, {
    height: Utils.outerHeight(ref.barDom) + 'px'
  });

  ref.barDom.insertAdjacentHTML('afterend', ghost.outerHTML);

  Utils.remove(ref.barDom);
  ghost = document.getElementById(ghostID);
  Utils.addClass(ghost, 'noty_fix_effects_height');
  Utils.addListener(ghost, Utils.animationEndEvents, function () {
    Utils.remove(ghost);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function build(ref) {
  findOrCreateContainer(ref);

  var markup = '<div class="noty_body">' + ref.options.text + '</div>' + buildButtons(ref) + '<div class="noty_progressbar"></div>';

  ref.barDom = document.createElement('div');
  ref.barDom.setAttribute('id', ref.id);
  Utils.addClass(ref.barDom, 'noty_bar noty_type__' + ref.options.type + ' noty_theme__' + ref.options.theme);

  ref.barDom.innerHTML = markup;

  fire(ref, 'onTemplate');
}

/**
 * @param {Noty} ref
 * @return {boolean}
 */
function hasButtons(ref) {
  return !!(ref.options.buttons && Object.keys(ref.options.buttons).length);
}

/**
 * @param {Noty} ref
 * @return {string}
 */
function buildButtons(ref) {
  if (hasButtons(ref)) {
    var buttons = document.createElement('div');
    Utils.addClass(buttons, 'noty_buttons');

    Object.keys(ref.options.buttons).forEach(function (key) {
      buttons.appendChild(ref.options.buttons[key].dom);
    });

    ref.options.buttons.forEach(function (btn) {
      buttons.appendChild(btn.dom);
    });
    return buttons.outerHTML;
  }
  return '';
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function handleModal(ref) {
  if (ref.options.modal) {
    if (DocModalCount === 0) {
      createModal(ref);
    }

    exports.DocModalCount = DocModalCount += 1;
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function handleModalClose(ref) {
  if (ref.options.modal && DocModalCount > 0) {
    exports.DocModalCount = DocModalCount -= 1;

    if (DocModalCount <= 0) {
      var modal = document.querySelector('.noty_modal');

      if (modal) {
        Utils.removeClass(modal, 'noty_modal_open');
        Utils.addClass(modal, 'noty_modal_close');
        Utils.addListener(modal, Utils.animationEndEvents, function () {
          Utils.remove(modal);
        });
      }
    }
  }
}

/**
 * @return {void}
 */
function createModal() {
  var body = document.querySelector('body');
  var modal = document.createElement('div');
  Utils.addClass(modal, 'noty_modal');
  body.insertBefore(modal, body.firstChild);
  Utils.addClass(modal, 'noty_modal_open');

  Utils.addListener(modal, Utils.animationEndEvents, function () {
    Utils.removeClass(modal, 'noty_modal_open');
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function findOrCreateContainer(ref) {
  if (ref.options.container) {
    ref.layoutDom = document.querySelector(ref.options.container);
    return;
  }

  var layoutID = 'noty_layout__' + ref.options.layout;
  ref.layoutDom = document.querySelector('div#' + layoutID);

  if (!ref.layoutDom) {
    ref.layoutDom = document.createElement('div');
    ref.layoutDom.setAttribute('id', layoutID);
    ref.layoutDom.setAttribute('role', 'alert');
    ref.layoutDom.setAttribute('aria-live', 'polite');
    Utils.addClass(ref.layoutDom, 'noty_layout');
    document.querySelector('body').appendChild(ref.layoutDom);
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function queueClose(ref) {
  if (ref.options.timeout) {
    if (ref.options.progressBar && ref.progressDom) {
      Utils.css(ref.progressDom, {
        transition: 'width ' + ref.options.timeout + 'ms linear',
        width: '0%'
      });
    }

    clearTimeout(ref.closeTimer);

    ref.closeTimer = setTimeout(function () {
      ref.close();
    }, ref.options.timeout);
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function dequeueClose(ref) {
  if (ref.options.timeout && ref.closeTimer) {
    clearTimeout(ref.closeTimer);
    ref.closeTimer = -1;

    if (ref.options.progressBar && ref.progressDom) {
      Utils.css(ref.progressDom, {
        transition: 'width 0ms linear',
        width: '100%'
      });
    }
  }
}

/**
 * @param {Noty} ref
 * @param {string} eventName
 * @return {void}
 */
function fire(ref, eventName) {
  if (ref.listeners.hasOwnProperty(eventName)) {
    ref.listeners[eventName].forEach(function (cb) {
      if (typeof cb === 'function') {
        cb.apply(ref);
      }
    });
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function openFlow(ref) {
  fire(ref, 'afterShow');
  queueClose(ref);

  Utils.addListener(ref.barDom, 'mouseenter', function () {
    dequeueClose(ref);
  });

  Utils.addListener(ref.barDom, 'mouseleave', function () {
    queueClose(ref);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function closeFlow(ref) {
  delete Store[ref.id];
  ref.closing = false;
  fire(ref, 'afterClose');

  Utils.remove(ref.barDom);

  if (ref.layoutDom.querySelectorAll('.noty_bar').length === 0 && !ref.options.container) {
    Utils.remove(ref.layoutDom);
  }

  if (Utils.inArray('docVisible', ref.options.titleCount.conditions) || Utils.inArray('docHidden', ref.options.titleCount.conditions)) {
    docTitle.decrement();
  }

  queueRender(ref.options.queue);
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotyButton = undefined;

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotyButton = exports.NotyButton = function NotyButton(html, classes, cb) {
  var _this = this;

  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _classCallCheck(this, NotyButton);

  this.dom = document.createElement('button');
  this.dom.innerHTML = html;
  this.id = attributes.id = attributes.id || Utils.generateID('button');
  this.cb = cb;
  Object.keys(attributes).forEach(function (propertyName) {
    _this.dom.setAttribute(propertyName, attributes[propertyName]);
  });
  Utils.addClass(this.dom, classes || 'noty_btn');

  return this;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Push = exports.Push = function () {
  function Push() {
    var workerPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/service-worker.js';

    _classCallCheck(this, Push);

    this.subData = {};
    this.workerPath = workerPath;
    this.listeners = {
      onPermissionGranted: [],
      onPermissionDenied: [],
      onSubscriptionSuccess: [],
      onSubscriptionCancel: [],
      onWorkerError: [],
      onWorkerSuccess: [],
      onWorkerNotSupported: []
    };
    return this;
  }

  /**
   * @param {string} eventName
   * @param {function} cb
   * @return {Push}
   */


  _createClass(Push, [{
    key: 'on',
    value: function on(eventName) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (typeof cb === 'function' && this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].push(cb);
      }

      return this;
    }
  }, {
    key: 'fire',
    value: function fire(eventName) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].forEach(function (cb) {
          if (typeof cb === 'function') {
            cb.apply(_this, params);
          }
        });
      }
    }
  }, {
    key: 'create',
    value: function create() {
      console.log('NOT IMPLEMENTED YET');
    }

    /**
     * @return {boolean}
     */

  }, {
    key: 'isSupported',
    value: function isSupported() {
      var result = false;

      try {
        result = window.Notification || window.webkitNotifications || navigator.mozNotification || window.external && window.external.msIsSiteMode() !== undefined;
      } catch (e) {}

      return result;
    }

    /**
     * @return {string}
     */

  }, {
    key: 'getPermissionStatus',
    value: function getPermissionStatus() {
      var perm = 'default';

      if (window.Notification && window.Notification.permissionLevel) {
        perm = window.Notification.permissionLevel;
      } else if (window.webkitNotifications && window.webkitNotifications.checkPermission) {
        switch (window.webkitNotifications.checkPermission()) {
          case 1:
            perm = 'default';
            break;
          case 0:
            perm = 'granted';
            break;
          default:
            perm = 'denied';
        }
      } else if (window.Notification && window.Notification.permission) {
        perm = window.Notification.permission;
      } else if (navigator.mozNotification) {
        perm = 'granted';
      } else if (window.external && window.external.msIsSiteMode() !== undefined) {
        perm = window.external.msIsSiteMode() ? 'granted' : 'default';
      }

      return perm.toString().toLowerCase();
    }

    /**
     * @return {string}
     */

  }, {
    key: 'getEndpoint',
    value: function getEndpoint(subscription) {
      var endpoint = subscription.endpoint;
      var subscriptionId = subscription.subscriptionId;

      // fix for Chrome < 45
      if (subscriptionId && endpoint.indexOf(subscriptionId) === -1) {
        endpoint += '/' + subscriptionId;
      }

      return endpoint;
    }

    /**
     * @return {boolean}
     */

  }, {
    key: 'isSWRegistered',
    value: function isSWRegistered() {
      try {
        return navigator.serviceWorker.controller.state === 'activated';
      } catch (e) {
        return false;
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'unregisterWorker',
    value: function unregisterWorker() {
      var self = this;
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var registration = _step.value;

              registration.unregister();
              self.fire('onSubscriptionCancel');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'requestSubscription',
    value: function requestSubscription() {
      var _this2 = this;

      var userVisibleOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var self = this;
      var current = this.getPermissionStatus();
      var cb = function cb(result) {
        if (result === 'granted') {
          _this2.fire('onPermissionGranted');

          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(_this2.workerPath).then(function () {
              navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
                self.fire('onWorkerSuccess');
                serviceWorkerRegistration.pushManager.subscribe({
                  userVisibleOnly: userVisibleOnly
                }).then(function (subscription) {
                  var key = subscription.getKey('p256dh');
                  var token = subscription.getKey('auth');

                  self.subData = {
                    endpoint: self.getEndpoint(subscription),
                    p256dh: key ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                    auth: token ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
                  };

                  self.fire('onSubscriptionSuccess', [self.subData]);
                }).catch(function (err) {
                  self.fire('onWorkerError', [err]);
                });
              });
            });
          } else {
            self.fire('onWorkerNotSupported');
          }
        } else if (result === 'denied') {
          _this2.fire('onPermissionDenied');
          _this2.unregisterWorker();
        }
      };

      if (current === 'default') {
        if (window.Notification && window.Notification.requestPermission) {
          window.Notification.requestPermission(cb);
        } else if (window.webkitNotifications && window.webkitNotifications.checkPermission) {
          window.webkitNotifications.requestPermission(cb);
        }
      } else {
        cb(current);
      }
    }
  }]);

  return Push;
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(9);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global VERSION */

__webpack_require__(5);

var _es6Promise = __webpack_require__(4);

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

var _api = __webpack_require__(1);

var API = _interopRequireWildcard(_api);

var _button = __webpack_require__(2);

var _push = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Noty = function () {
  /**
   * @param {object} options
   * @return {Noty}
   */
  function Noty() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Noty);

    this.options = Utils.deepExtend({}, API.Defaults, options);

    if (API.Store[this.options.id]) {
      return API.Store[this.options.id];
    }

    this.id = this.options.id || Utils.generateID('bar');
    this.closeTimer = -1;
    this.barDom = null;
    this.layoutDom = null;
    this.progressDom = null;
    this.showing = false;
    this.shown = false;
    this.closed = false;
    this.closing = false;
    this.killable = this.options.timeout || this.options.closeWith.length > 0;
    this.hasSound = this.options.sounds.sources.length > 0;
    this.soundPlayed = false;
    this.listeners = {
      beforeShow: [],
      onShow: [],
      afterShow: [],
      onClose: [],
      afterClose: [],
      onClick: [],
      onHover: [],
      onTemplate: []
    };
    this.promises = {
      show: null,
      close: null
    };
    this.on('beforeShow', this.options.callbacks.beforeShow);
    this.on('onShow', this.options.callbacks.onShow);
    this.on('afterShow', this.options.callbacks.afterShow);
    this.on('onClose', this.options.callbacks.onClose);
    this.on('afterClose', this.options.callbacks.afterClose);
    this.on('onClick', this.options.callbacks.onClick);
    this.on('onHover', this.options.callbacks.onHover);
    this.on('onTemplate', this.options.callbacks.onTemplate);

    return this;
  }

  /**
   * @param {string} eventName
   * @param {function} cb
   * @return {Noty}
   */


  _createClass(Noty, [{
    key: 'on',
    value: function on(eventName) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (typeof cb === 'function' && this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].push(cb);
      }

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'show',
    value: function show() {
      var _this = this;

      if (this.showing || this.shown) {
        return this; // preventing multiple show
      }

      if (this.options.killer === true) {
        Noty.closeAll();
      } else if (typeof this.options.killer === 'string') {
        Noty.closeAll(this.options.killer);
      }

      var queueCounts = API.getQueueCounts(this.options.queue);

      if (queueCounts.current >= queueCounts.maxVisible || API.PageHidden && this.options.visibilityControl) {
        API.addToQueue(this);

        if (API.PageHidden && this.hasSound && Utils.inArray('docHidden', this.options.sounds.conditions)) {
          Utils.createAudioElements(this);
        }

        if (API.PageHidden && Utils.inArray('docHidden', this.options.titleCount.conditions)) {
          API.docTitle.increment();
        }

        return this;
      }

      API.Store[this.id] = this;

      API.fire(this, 'beforeShow');

      this.showing = true;

      if (this.closing) {
        this.showing = false;
        return this;
      }

      API.build(this);
      API.handleModal(this);

      if (this.options.force) {
        this.layoutDom.insertBefore(this.barDom, this.layoutDom.firstChild);
      } else {
        this.layoutDom.appendChild(this.barDom);
      }

      if (this.hasSound && !this.soundPlayed && Utils.inArray('docVisible', this.options.sounds.conditions)) {
        Utils.createAudioElements(this);
      }

      if (Utils.inArray('docVisible', this.options.titleCount.conditions)) {
        API.docTitle.increment();
      }

      this.shown = true;
      this.closed = false;

      // bind button events if any
      if (API.hasButtons(this)) {
        Object.keys(this.options.buttons).forEach(function (key) {
          var btn = _this.barDom.querySelector('#' + _this.options.buttons[key].id);
          Utils.addListener(btn, 'click', function (e) {
            Utils.stopPropagation(e);
            _this.options.buttons[key].cb(_this);
          });
        });
      }

      this.progressDom = this.barDom.querySelector('.noty_progressbar');

      if (Utils.inArray('click', this.options.closeWith)) {
        Utils.addClass(this.barDom, 'noty_close_with_click');
        Utils.addListener(this.barDom, 'click', function (e) {
          Utils.stopPropagation(e);
          API.fire(_this, 'onClick');
          _this.close();
        }, false);
      }

      Utils.addListener(this.barDom, 'mouseenter', function () {
        API.fire(_this, 'onHover');
      }, false);

      if (this.options.timeout) Utils.addClass(this.barDom, 'noty_has_timeout');
      if (this.options.progressBar) {
        Utils.addClass(this.barDom, 'noty_has_progressbar');
      }

      if (Utils.inArray('button', this.options.closeWith)) {
        Utils.addClass(this.barDom, 'noty_close_with_button');

        var closeButton = document.createElement('div');
        Utils.addClass(closeButton, 'noty_close_button');
        closeButton.innerHTML = '×';
        this.barDom.appendChild(closeButton);

        Utils.addListener(closeButton, 'click', function (e) {
          Utils.stopPropagation(e);
          _this.close();
        }, false);
      }

      API.fire(this, 'onShow');

      if (this.options.animation.open === null) {
        this.promises.show = new _es6Promise2.default(function (resolve) {
          resolve();
        });
      } else if (typeof this.options.animation.open === 'function') {
        this.promises.show = new _es6Promise2.default(this.options.animation.open.bind(this));
      } else {
        Utils.addClass(this.barDom, this.options.animation.open);
        this.promises.show = new _es6Promise2.default(function (resolve) {
          Utils.addListener(_this.barDom, Utils.animationEndEvents, function () {
            Utils.removeClass(_this.barDom, _this.options.animation.open);
            resolve();
          });
        });
      }

      this.promises.show.then(function () {
        var _t = _this;
        setTimeout(function () {
          API.openFlow(_t);
        }, 100);
      });

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'stop',
    value: function stop() {
      API.dequeueClose(this);
      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'resume',
    value: function resume() {
      API.queueClose(this);
      return this;
    }

    /**
     * @param {int|boolean} ms
     * @return {Noty}
     */

  }, {
    key: 'setTimeout',
    value: function (_setTimeout) {
      function setTimeout(_x) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (ms) {
      this.stop();
      this.options.timeout = ms;

      if (this.barDom) {
        if (this.options.timeout) {
          Utils.addClass(this.barDom, 'noty_has_timeout');
        } else {
          Utils.removeClass(this.barDom, 'noty_has_timeout');
        }

        var _t = this;
        setTimeout(function () {
          // ugly fix for progressbar display bug
          _t.resume();
        }, 100);
      }

      return this;
    })

    /**
     * @param {string} html
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setText',
    value: function setText(html) {
      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        this.barDom.querySelector('.noty_body').innerHTML = html;
      }

      if (optionsOverride) this.options.text = html;

      return this;
    }

    /**
     * @param {string} type
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setType',
    value: function setType(type) {
      var _this2 = this;

      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        var classList = Utils.classList(this.barDom).split(' ');

        classList.forEach(function (c) {
          if (c.substring(0, 11) === 'noty_type__') {
            Utils.removeClass(_this2.barDom, c);
          }
        });

        Utils.addClass(this.barDom, 'noty_type__' + type);
      }

      if (optionsOverride) this.options.type = type;

      return this;
    }

    /**
     * @param {string} theme
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setTheme',
    value: function setTheme(theme) {
      var _this3 = this;

      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        var classList = Utils.classList(this.barDom).split(' ');

        classList.forEach(function (c) {
          if (c.substring(0, 12) === 'noty_theme__') {
            Utils.removeClass(_this3.barDom, c);
          }
        });

        Utils.addClass(this.barDom, 'noty_theme__' + theme);
      }

      if (optionsOverride) this.options.theme = theme;

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'close',
    value: function close() {
      var _this4 = this;

      if (this.closed) return this;

      if (!this.shown) {
        // it's in the queue
        API.removeFromQueue(this);
        return this;
      }

      API.fire(this, 'onClose');

      this.closing = true;

      if (this.options.animation.close === null || this.options.animation.close === false) {
        this.promises.close = new _es6Promise2.default(function (resolve) {
          resolve();
        });
      } else if (typeof this.options.animation.close === 'function') {
        this.promises.close = new _es6Promise2.default(this.options.animation.close.bind(this));
      } else {
        Utils.addClass(this.barDom, this.options.animation.close);
        this.promises.close = new _es6Promise2.default(function (resolve) {
          Utils.addListener(_this4.barDom, Utils.animationEndEvents, function () {
            if (_this4.options.force) {
              Utils.remove(_this4.barDom);
            } else {
              API.ghostFix(_this4);
            }
            resolve();
          });
        });
      }

      this.promises.close.then(function () {
        API.closeFlow(_this4);
        API.handleModalClose(_this4);
      });

      this.closed = true;

      return this;
    }

    // API functions

    /**
     * @param {boolean|string} queueName
     * @return {Noty}
     */

  }], [{
    key: 'closeAll',
    value: function closeAll() {
      var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      Object.keys(API.Store).forEach(function (id) {
        if (queueName) {
          if (API.Store[id].options.queue === queueName && API.Store[id].killable) {
            API.Store[id].close();
          }
        } else if (API.Store[id].killable) {
          API.Store[id].close();
        }
      });
      return this;
    }

    /**
     * @param {string} queueName
     * @return {Noty}
     */

  }, {
    key: 'clearQueue',
    value: function clearQueue() {
      var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';

      if (API.Queues.hasOwnProperty(queueName)) {
        API.Queues[queueName].queue = [];
      }
      return this;
    }

    /**
     * @return {API.Queues}
     */

  }, {
    key: 'overrideDefaults',


    /**
     * @param {Object} obj
     * @return {Noty}
     */
    value: function overrideDefaults(obj) {
      API.Defaults = Utils.deepExtend({}, API.Defaults, obj);
      return this;
    }

    /**
     * @param {int} amount
     * @param {string} queueName
     * @return {Noty}
     */

  }, {
    key: 'setMaxVisible',
    value: function setMaxVisible() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : API.DefaultMaxVisible;
      var queueName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'global';

      if (!API.Queues.hasOwnProperty(queueName)) {
        API.Queues[queueName] = { maxVisible: amount, queue: [] };
      }

      API.Queues[queueName].maxVisible = amount;
      return this;
    }

    /**
     * @param {string} innerHtml
     * @param {String} classes
     * @param {Function} cb
     * @param {Object} attributes
     * @return {NotyButton}
     */

  }, {
    key: 'button',
    value: function button(innerHtml) {
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments[2];
      var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return new _button.NotyButton(innerHtml, classes, cb, attributes);
    }

    /**
     * @return {string}
     */

  }, {
    key: 'version',
    value: function version() {
      return "3.2.0-beta";
    }

    /**
     * @param {String} workerPath
     * @return {Push}
     */

  }, {
    key: 'Push',
    value: function Push(workerPath) {
      return new _push.Push(workerPath);
    }
  }, {
    key: 'Queues',
    get: function get() {
      return API.Queues;
    }

    /**
     * @return {API.PageHidden}
     */

  }, {
    key: 'PageHidden',
    get: function get() {
      return API.PageHidden;
    }
  }]);

  return Noty;
}();

// Document visibility change controller


exports.default = Noty;
if (typeof window !== 'undefined') {
  Utils.visibilityChangeFlow();
}
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
});
//# sourceMappingURL=noty.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _BasketBusiness=__webpack_require__(643);Object.defineProperty(exports,'BasketBusiness',{enumerable:true,get:function get(){return _BasketBusiness.BasketBusiness;}});

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BasketBusiness=undefined;var _regenerator=__webpack_require__(59);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _tslib=__webpack_require__(95);var _basket=__webpack_require__(644);var _BetCartFeatures=__webpack_require__(650);var _typeGuards=__webpack_require__(651);var _helpers=__webpack_require__(652);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);var _config=__webpack_require__(48);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var betType;(function(betType){betType[betType["ordinar"]=1]="ordinar";betType[betType["express"]=2]="express";betType[betType["system"]=3]="system";})(betType||(betType={}));var agreeWithCoefChange;(function(agreeWithCoefChange){agreeWithCoefChange[agreeWithCoefChange["settingForBannedUsers"]=-1]="settingForBannedUsers";agreeWithCoefChange[agreeWithCoefChange["never"]=0]="never";agreeWithCoefChange[agreeWithCoefChange["everything"]=1]="everything";agreeWithCoefChange[agreeWithCoefChange["ifRise"]=2]="ifRise";})(agreeWithCoefChange||(agreeWithCoefChange={}));var BasketBusiness=exports.BasketBusiness=function(){function BasketBusiness(config,subscriberFn,basketApi,appName,isIrm){_classCallCheck(this,BasketBusiness);this.subscribers=new Set();this.appName='';this.state={oddsIds:new Set(),odds:{},max:0,maxExpress:0,maxSystem:0,config:{},betType:betType.ordinar,isVipBet:0,isClearBasketAfterBet:false,agreeWithCoefChange:agreeWithCoefChange.never,activeBet:'',amount:null,isAllOddsLine:false,systemType:'',basketApi:{set:function set(betData){return new Promise(function(data){return data;});}},isBetRequestLoading:false,isBetOneClick:false,globalError:'',expressCoef:1,oneClickBetAmount:0,minVipExpress:0,minVipSystem:0,possibleWin:0,systemTypeAvailable:[],succesExpressAndSystemMessage:'',isRequestSuccess:null,promoId:0,expressMultiplierPercents:[],expressInsuranceData:{success:false,message:''},successExpressMultiplierData:{coeffWithMultiplier:null,message:'',multiplierPercent:null},failedExpressMultiplierData:{message:'',oddWithLowCoeffIds:[]},isFreeBet:false,disableDoBetButton:false,min:null,betsCartFeatures:{expressInsurance:{minOddsCount:null,minCoeff:null,minBetSum:null}}};this.appName=appName;this.isIrm=isIrm;this.state.config=config;this.subscribe(subscriberFn);this.state.basketApi=basketApi;}_createClass(BasketBusiness,[{key:"initBetsCartFeaturesListener",value:function initBetsCartFeaturesListener(currency){var _this=this;var betsCartFeaturesListener=new _BetCartFeatures.BetsCartFeaturesListener();betsCartFeaturesListener.subscribe({currency:currency,onmessage:function onmessage(data){_this.state.betsCartFeatures=data;_this.notify();}});}},{key:"setSettings",value:function setSettings(settings){this.setAgreeWithCoefChanging(settings.agreeWithCoefChange?settings.agreeWithCoefChange:agreeWithCoefChange.never);this.state.isClearBasketAfterBet=settings.isClearBasketAfterBet?settings.isClearBasketAfterBet:false;// this.state.oneClickBetAmount = settings.oneClickBetAmount ? settings.oneClickBetAmount : 0;
this.notify();}},{key:"setIsBetOneClick",value:function setIsBetOneClick(isOneClick){this.state.isBetOneClick=isOneClick;isOneClick&&this.setBetType(betType.ordinar);this.notify();}},{key:"setIsBetOneClickSum",value:function setIsBetOneClickSum(amount){this.state.oneClickBetAmount=amount;}},{key:"setCoeffId",value:function setCoeffId(coeffId){if(this.state.config.coeffKind===coeffId)return;this.state.config.coeffKind=coeffId;this.getOddData();}},{key:"setIsFreeBet",value:function setIsFreeBet(isFreeBet){this.state.isFreeBet=isFreeBet;this.notify();}},{key:"getOddData",value:function getOddData(){var _this2=this;var oddIds=[].concat(_toConsumableArray(this.state.oddsIds)).filter(function(oddId){return typeof oddId==='string';});if(!oddIds.length){return null;}var sendConfig=Object.assign(Object.assign({},this.state.config),{jwt:_jsCookie2.default.get('jwt'),odds:oddIds});return new Promise(function(resolve){_this2.basketUnit=new _basket.BasketCore(sendConfig,_this2.isIrm);_this2.basketUnit.subscribe(function(data){_this2.prepareData.bind(_this2)(data);resolve(data);});});}},{key:"subscribe",value:function subscribe(fn){this.subscribers.add(fn);}},{key:"notify",value:function notify(){var _this3=this;this.subscribers.forEach(function(fn){return fn(_this3.state);});}},{key:"unsubscribe",value:function unsubscribe(fn){this.subscribers.delete(fn);}},{key:"addOdd",value:function addOdd(oddId,matchId){var _this4=this;if(this.state.isBetOneClick){this.state.oddsIds.clear();this.state.oddsIds.add(oddId);if((0,_config.getConfig)('IS_MOBILE')){this.setActiveBet(oddId,true);}return this.getOddData().then(function(){_this4.state.odds[oddId].amount=_this4.state.oneClickBetAmount;return _this4.doBetRequest().then(function(){return _this4.state.oddsIds.clear();});});}if(this.state.oddsIds.has(oddId)&&this.state.activeBet!==oddId)return;var maxOddsInBasket=29;if(this.state.oddsIds.size>maxOddsInBasket){// @ts-ignore
this.setGlobalError(window.getLang('BASKET_MAX_BETS',{count:30}));this.notify();return;}this.state.oddsIds.forEach(function(oddIdInSet){var _a;if(((_a=_this4.state.odds[oddIdInSet])===null||_a===void 0?void 0:_a.matchId)===matchId){_this4.state.oddsIds.delete(oddIdInSet);}});this.state.oddsIds.add(oddId);this.getOddData();this.validateBetType();this.notify();}/** Используется для добавления событий из локалСторедж*/},{key:"addMultiOdds",value:function addMultiOdds(oddsIds){var _this5=this;if(!oddsIds.length)return;oddsIds.forEach(function(oddId){if(typeof oddId==='string'){_this5.state.oddsIds.add(oddId);}});this.getOddData().then(function(){_this5.state.oddsIds.forEach(function(oddId){var _a;if(!((_a=_this5.state.odds[oddId])===null||_a===void 0?void 0:_a.cf)){_this5.state.oddsIds.delete(oddId);delete _this5.state.odds[oddId];}});_this5.getOddData();}).then(function(){_this5.validateBetType();_this5.notify();});}},{key:"clearBasket",value:function clearBasket(){this.state={oddsIds:new Set(),odds:{},max:0,maxExpress:0,maxSystem:0,config:this.state.config,betType:this.state.betType,isClearBasketAfterBet:this.state.isClearBasketAfterBet,agreeWithCoefChange:this.state.agreeWithCoefChange,isVipBet:this.state.isVipBet,isAllOddsLine:false,activeBet:'',amount:0,systemType:'',basketApi:this.state.basketApi,isBetRequestLoading:this.state.isBetRequestLoading,isBetOneClick:this.state.isBetOneClick,globalError:'',expressCoef:1,oneClickBetAmount:this.state.oneClickBetAmount,minVipExpress:0,minVipSystem:0,possibleWin:0,systemTypeAvailable:[],succesExpressAndSystemMessage:'',isRequestSuccess:null,promoId:this.state.promoId,isFreeBet:this.state.isFreeBet,disableDoBetButton:false,min:null,betsCartFeatures:this.state.betsCartFeatures};this.notify();}},{key:"clearRequestResult",value:function clearRequestResult(){this.state.isRequestSuccess=null;this.notify();}},{key:"deleteOdd",value:function deleteOdd(id){this.state.oddsIds.delete(id);this.getOddData();this.validateBetType();this.notify();}/** В целях экономии времени не рефакторил механизм валидации и скопировал его со старого проекта */},{key:"onOrdinarAmountInput",value:function onOrdinarAmountInput(amount,oddId){var number=amount.replace(/[^.\d]+/g,'').replace(/^([^\.]*\.)|\./g,'$1');var match=number.toString().match(/(\d+\.\d{1,2})/);number=match?match[0]:number;// this.error.status = 0;
if(number.length>0){// @ts-ignore потому что конструктор Number() не считает точку за число
this.state.odds[oddId].amount=number;}else{this.state.odds[oddId].amount=null;}this.calculatePossibleWin();this.notify();}},{key:"onExpressOrSystemAmountInput",value:function onExpressOrSystemAmountInput(amount){var number=amount.replace(/[^.\d]+/g,'').replace(/^([^\.]*\.)|\./g,'$1');var match=number.toString().match(/(\d+\.\d{1,2})/);number=match?match[0]:number;// this.error.status = 0;
if(number.length>0){// @ts-ignore потому что конструктор Number() не считает точку за число
this.state.amount=number;}else{this.state.amount=null;}this.calculatePossibleWin();this.notify();}},{key:"clearOddAmountValue",value:function clearOddAmountValue(){if(this.state.betType===1){var _state=this.state,odds=_state.odds,activeBet=_state.activeBet;odds[activeBet].amount=null;}else{this.state.amount=null;}this.notify();}},{key:"setBetType",value:function setBetType(typeId){if(this.state.betType===typeId)return;this.state.betType=typeId;this.getOddData();this.validateBetType();this.notify();}/** Используется для вывода ошибок о нехватке событий в экспрессе и системе */},{key:"validateBetType",value:function validateBetType(){this.setGlobalError();var validateExpress=this.state.betType===betType.express&&this.state.oddsIds.size<2;var validateSystem=this.state.betType===betType.system&&(this.state.oddsIds.size<3||this.state.oddsIds.size>20);if(validateExpress){this.setGlobalError('ERROR_COUNT_EXPRESS');}if(validateSystem){this.setGlobalError("BASKET_ERROR_SYSTEM_"+(this.state.oddsIds.size<3?3:20));}}},{key:"setGlobalError",value:function setGlobalError(){var error=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';this.state.globalError=error;}},{key:"setIsVipBet",value:function setIsVipBet(isVipBet){if(isVipBet===undefined)return;this.state.isVipBet=isVipBet?1:0;this.notify();}},{key:"setAgreeWithCoefChanging",value:function setAgreeWithCoefChanging(agreeWithCoefChange){this.state.agreeWithCoefChange=agreeWithCoefChange;this.notify();}},{key:"setIsClearBasketAfterBet",value:function setIsClearBasketAfterBet(){this.state.isClearBasketAfterBet=!this.state.isClearBasketAfterBet;this.notify();}},{key:"setActiveBet",value:function setActiveBet(betId,dontUseRequest){if(this.state.activeBet===betId)return;this.state.activeBet=betId;if(!dontUseRequest){this.getOddData();}this.notify();}},{key:"setPromoId",value:function setPromoId(promoId){this.state.promoId=promoId;}},{key:"setMultiplierCondition",value:function setMultiplierCondition(isMultiplierCondition){if(this.state.config.expressMultiplier===isMultiplierCondition)return;// this.state.config.expressMultiplier = isMultiplierCondition
// this.getOddData()
}},{key:"setInsuranceCondition",value:function setInsuranceCondition(isInsuranceCondition){if(this.state.config.expressInsurance===isInsuranceCondition)return;this.state.config.expressInsurance=isInsuranceCondition;this.getOddData();}},{key:"setFreeBetAmount",value:function setFreeBetAmount(amount){if(this.state.betType===betType.ordinar&&!this.state.isBetOneClick&&this.state.isFreeBet&&this.state.oddsIds.size>1&&!this.state.activeBet){this.setGlobalError('IF_FREE_BET_ACTIVE_ONLY_ONE_BET_ACCEPTED');this.notify();return;}this.state.odds[[].concat(_toConsumableArray(this.state.oddsIds))[0]].amount=amount;this.state.amount=amount;this.notify();}},{key:"doBetRequest",value:function doBetRequest(){var _a,_b;return(0,_tslib.__awaiter)(this,void 0,void 0,/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this6=this;var bets,order,gid,oddData,isVipBet,betData;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(this.state.oddsIds.size){_context2.next=4;break;}this.setGlobalError('EMPTY_INPUT');this.notify();return _context2.abrupt("return");case 4:this.setGlobalError();bets={};order=[];if(this.state.activeBet&&this.state.betType===betType.ordinar){gid=this.state.activeBet;oddData=this.state.odds[gid];if((0,_typeGuards.isNumber)(oddData===null||oddData===void 0?void 0:oddData.matchId)&&oddData){order=[oddData===null||oddData===void 0?void 0:oddData.matchId];bets[oddData.matchId]={gid:oddData===null||oddData===void 0?void 0:oddData.matchId,oddKey:gid,odd:oddData===null||oddData===void 0?void 0:oddData.bet,cf:oddData===null||oddData===void 0?void 0:oddData.cf,d1:(oddData===null||oddData===void 0?void 0:oddData.d1)?oddData===null||oddData===void 0?void 0:oddData.d1:oddData===null||oddData===void 0?void 0:oddData.a1,d2:(oddData===null||oddData===void 0?void 0:oddData.d2)?oddData===null||oddData===void 0?void 0:oddData.d2:oddData===null||oddData===void 0?void 0:oddData.a2,amount:oddData===null||oddData===void 0?void 0:oddData.amount};}}else{this.state.oddsIds.forEach(function(item){var oddData=_this6.state.odds[item];if((0,_typeGuards.isNumber)(oddData===null||oddData===void 0?void 0:oddData.matchId)&&oddData){order=[].concat(_toConsumableArray(order),[oddData===null||oddData===void 0?void 0:oddData.matchId]);bets[oddData.matchId]={gid:oddData===null||oddData===void 0?void 0:oddData.matchId,oddKey:item,odd:oddData===null||oddData===void 0?void 0:oddData.bet,cf:oddData===null||oddData===void 0?void 0:oddData.cf,d1:(oddData===null||oddData===void 0?void 0:oddData.d1)?oddData===null||oddData===void 0?void 0:oddData.d1:oddData===null||oddData===void 0?void 0:oddData.a1,d2:(oddData===null||oddData===void 0?void 0:oddData.d2)?oddData===null||oddData===void 0?void 0:oddData.d2:oddData===null||oddData===void 0?void 0:oddData.a2,amount:oddData===null||oddData===void 0?void 0:oddData.amount};}});}isVipBet=this.state.betType===betType.ordinar&&(0,_config.getConfig)('IS_MOBILE')?this.state.isVipBet&&!this.state.isFreeBet&&((_b=(_a=this.state.odds)===null||_a===void 0?void 0:_a[this.state.activeBet])===null||_b===void 0?void 0:_b.minVip):this.state.isVipBet&&!this.state.isFreeBet&&this.state.isAllOddsLine;betData={type:this.state.betType,amount:this.state.amount,odds:bets,// принимает только 0 | 1
vip:Number(!!isVipBet),odds_order:order,live:this.state.isAllOddsLine?0:1,agree_cf:this.state.agreeWithCoefChange===agreeWithCoefChange.settingForBannedUsers?agreeWithCoefChange.never:this.state.agreeWithCoefChange,system_type:this.state.systemType,promo_id:this.state.isFreeBet?this.state.promoId:0,is_accumulator_multiplier:this.state.config.expressMultiplier&&this.state.betType===betType.express&&!this.state.isFreeBet&&!this.state.isBetOneClick?1:0,is_accumulator_insurance:this.state.config.expressInsurance&&this.state.betType===betType.express&&!this.state.isFreeBet&&!this.state.isBetOneClick?1:0};this.setIsLoading(true);this.state.isRequestSuccess=null;_context2.next=14;return this.state.basketApi.set(betData).then(function(data){return(0,_tslib.__awaiter)(_this6,void 0,void 0,/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.isBetOneClick){_context.next=3;break;}_context.next=3;return this.getOddData();case 3:return _context.abrupt("return",data);case 4:case"end":return _context.stop();}}},_callee,this);}));}).then(function(data){var _a,_b;_this6.doBetRequestData=data;_this6.setIsLoading(false);_this6.state.isRequestSuccess=((_a=data===null||data===void 0?void 0:data.result)===null||_a===void 0?void 0:_a.code)===0;if(_this6.state.isRequestSuccess){if(_this6.state.isClearBasketAfterBet){_this6.clearBasket();}if(_this6.state.isFreeBet){_this6.setIsFreeBet(false);}}_this6.state.isRequestSuccess=((_b=data===null||data===void 0?void 0:data.result)===null||_b===void 0?void 0:_b.code)===0;_this6.setAfterBetNotification(data);_this6.notify();});case 14:case"end":return _context2.stop();}}},_callee2,this);}));}},{key:"setAfterBetNotification",value:function setAfterBetNotification(data){var _this7=this;this.state.oddsIds.forEach(function(oddId){var _a,_b,_c,_d,_e,_f,_g,_h,_j,_k,_l,_m,_o,_p,_q,_r;if(!((_b=(_a=_this7.state.odds)===null||_a===void 0?void 0:_a[oddId])===null||_b===void 0?void 0:_b.matchId))return;_this7.state.odds[oddId].text=((_g=(_d=(_c=data===null||data===void 0?void 0:data.result)===null||_c===void 0?void 0:_c.odds)===null||_d===void 0?void 0:_d[(_f=(_e=_this7.state.odds)===null||_e===void 0?void 0:_e[oddId])===null||_f===void 0?void 0:_f.matchId])===null||_g===void 0?void 0:_g.text)||'';_this7.state.odds[oddId].isOddSuccessRequest=((_m=(_j=(_h=data===null||data===void 0?void 0:data.result)===null||_h===void 0?void 0:_h.odds)===null||_j===void 0?void 0:_j[(_l=(_k=_this7.state.odds)===null||_k===void 0?void 0:_k[oddId])===null||_l===void 0?void 0:_l.matchId])===null||_m===void 0?void 0:_m.code)===0;_this7.state.succesExpressAndSystemMessage=((_o=data===null||data===void 0?void 0:data.result)===null||_o===void 0?void 0:_o.code)===0?(_p=data===null||data===void 0?void 0:data.result)===null||_p===void 0?void 0:_p.text:'';((_q=data===null||data===void 0?void 0:data.result)===null||_q===void 0?void 0:_q.code)!==0&&_this7.setGlobalError(((_r=data===null||data===void 0?void 0:data.result)===null||_r===void 0?void 0:_r.text)||(data===null||data===void 0?void 0:data.text));});}},{key:"setIsLoading",value:function setIsLoading(flag){this.state.isBetRequestLoading=flag;this.notify();}},{key:"calculateExpressCoef",value:function calculateExpressCoef(){var _this8=this;if(this.state.betType===betType.express){if(this.state.oddsIds.size<2){this.state.disableDoBetButton=true;}var expressCoef=1;this.state.oddsIds.forEach(function(oddId){var _a,_b,_c,_d;if(!((_b=(_a=_this8.state.odds)===null||_a===void 0?void 0:_a[oddId])===null||_b===void 0?void 0:_b.cf))return;expressCoef*=(_d=(_c=_this8.state.odds)===null||_c===void 0?void 0:_c[oddId])===null||_d===void 0?void 0:_d.cf;});this.state.expressCoef=+expressCoef.toFixed(2);}}},{key:"setSystemType",value:function setSystemType(type){if(this.state.oddsIds.size>2){this.state.systemType=type;this.notify();}}},{key:"checkSystem",value:function checkSystem(n,k){var cmax={};// if (!this.cmax) {
//     this.cmax = [];
// }
if(!cmax[k]){cmax[k]=[];}if(!cmax[k][n]){cmax[k][n]=Math.round(this.factorial(n)/(this.factorial(n-k)*this.factorial(k)));}return parseInt(cmax[k][n],10);}},{key:"factorial",value:function factorial(n){return n?n*this.factorial(n-1):1;}},{key:"calcSystem",value:function calcSystem(){var _this9=this;if(this.state.betType!==betType.system)return;if(this.state.oddsIds.size<3){this.state.disableDoBetButton=true;}var count=this.state.oddsIds.size;// system_type_available = [],
var options_label='';var i=void 0;var sys_type='';var sys_name='';this.state.systemTypeAvailable=[];// this.system_type_available = {};
if(count<3){this.setGlobalError('BASKET_ERROR_SYSTEM_3');}else if(count>20){this.setGlobalError('BASKET_ERROR_SYSTEM_20');}else{for(i=2;i<count;i++){var combs=this.checkSystem(count,i);if(combs>1000){continue;}if(combs>10&&combs<20){options_label='SYSTEM_V5';}else{switch(combs%10){case 1:{options_label='SYSTEM_V1';break;}case 2:case 3:case 4:{options_label='SYSTEM_V4';break;}default:{options_label='SYSTEM_V5';}}}sys_type="S"+i+"n"+count;// @ts-ignore
sys_name=count+" "+window.getLang('SYSTEM_TEMPLATE').slice(3,5)+" "+i+" ("+combs+" "+window.getLang(options_label)+")";this.state.systemTypeAvailable.push({type:sys_type,name:sys_name});}if(!this.state.systemTypeAvailable.some(function(el){return el.type==_this9.state.systemType;})){this.setSystemType(this.state.systemTypeAvailable[0].type);}}}},{key:"calculatePossibleWin",value:function calculatePossibleWin(){var _this10=this;var _a,_b;var calculatedPossibleWin=0;if(this.state.betType===betType.ordinar){this.state.oddsIds.forEach(function(oddId){var _a,_b,_c;if(!((_a=_this10.state.odds[oddId])===null||_a===void 0?void 0:_a.amount))return;calculatedPossibleWin+=((_b=_this10.state.odds[oddId])===null||_b===void 0?void 0:_b.amount)*((_c=_this10.state.odds[oddId])===null||_c===void 0?void 0:_c.cf);});}if(this.state.betType===betType.express){var coef=0;this.state.expressCoef>1000?coef=1000:coef=this.state.expressCoef;calculatedPossibleWin=this.state.amount*coef;if((_b=(_a=this.state)===null||_a===void 0?void 0:_a.successExpressMultiplierData)===null||_b===void 0?void 0:_b.coeffWithMultiplier){this.state.successExpressMultiplierData.coeffWithMultiplier>1000?coef=1000:coef=this.state.successExpressMultiplierData.coeffWithMultiplier;calculatedPossibleWin=this.state.amount*coef;}}this.state.possibleWin=calculatedPossibleWin;}/** Эта функция мутирует получаемый объект, если понадобится иммутабельность - доработать */},{key:"saveOrdinarAmountBeforeRequest",value:function saveOrdinarAmountBeforeRequest(newOddsData){var _this11=this;this.state.oddsIds.forEach(function(oddId){var _a,_b;if(!((_a=newOddsData[oddId])===null||_a===void 0?void 0:_a.cf))return;newOddsData[oddId].amount=(_b=_this11.state.odds[oddId])===null||_b===void 0?void 0:_b.amount;});}///////////////////////////////////////////////
},{key:"ifOddIdFromWssNull",value:function ifOddIdFromWssNull(odds){var _this12=this;this.state.oddsIds.forEach(function(oddId){var _a,_b,_c;if(!((_a=odds[oddId])===null||_a===void 0?void 0:_a.cf)&&((_c=(_b=_this12.state.odds)===null||_b===void 0?void 0:_b[oddId])===null||_c===void 0?void 0:_c.cf)){_this12.state.odds[oddId].text='BETTING_IS_SUSPENDED';_this12.state.odds[oddId].isOddSuccessRequest=false;odds[oddId]=_this12.state.odds[oddId];}});this.notify();}},{key:"getOddUrl",value:function getOddUrl(enSport,championshipId,matchId,enChampionship,enTeam1,enTeam2){var mode=arguments.length>6&&arguments[6]!==undefined?arguments[6]:'live';var isLine=mode==='line';var isSeoUrl=!!/(zenitbet|cupis|mobile_com|desktop|mobile_new)$/.test(this.appName);var url="/"+mode;if(enSport){url+="/"+(0,_helpers.slugify)(isSeoUrl&&enSport);}var getGamePart=function getGamePart(gameId){var cmd=isSeoUrl&&""+enTeam1+(enTeam2?" - "+enTeam2:'');return"/"+(isLine?'g_':'')+(0,_helpers.urlSlug)(gameId,cmd);};if(championshipId){url+="/"+(isLine?'l_':'')+(0,_helpers.urlSlug)(championshipId,isSeoUrl&&enChampionship);}if(matchId){url+=getGamePart(matchId);}return url;}},{key:"createOddUrl",value:function createOddUrl(odds){var _this13=this;this.state.oddsIds.forEach(function(oddId){var oddData=odds[oddId];if(!oddData)return;// @ts-ignore потому что подсвечивает что minVip нет в лайв событиях и проверки не срабатывают
var type=(oddData===null||oddData===void 0?void 0:oddData.minVip)?'line':'live';var enSport=oddData===null||oddData===void 0?void 0:oddData.enSport;var championshipId=oddData===null||oddData===void 0?void 0:oddData.championshipId;var matchId=oddData===null||oddData===void 0?void 0:oddData.matchId;var enChampionship=oddData===null||oddData===void 0?void 0:oddData.enChampionship;var enTeam1=oddData===null||oddData===void 0?void 0:oddData.enTeam1;var enTeam2=oddData===null||oddData===void 0?void 0:oddData.enTeam2;oddData.url=_this13.getOddUrl(enSport,championshipId,matchId,enChampionship,enTeam1,enTeam2,type);});}},{key:"prepareData",value:function prepareData(data){var odds=data.odds,maxExpress=data.maxExpress,maxSystem=data.maxSystem,max=data.max,min=data.min,minVipExpress=data.minVipExpress,minVipSystem=data.minVipSystem,expressInsuranceData=data.expressInsuranceData,expressMultiplierPercents=data.expressMultiplierPercents,successExpressMultiplierData=data.successExpressMultiplierData,failedExpressMultiplierData=data.failedExpressMultiplierData;if(this.state.succesExpressAndSystemMessage){this.state.succesExpressAndSystemMessage='';}this.state.disableDoBetButton=false;this.ifOddIdFromWssNull(odds);this.saveOrdinarAmountBeforeRequest(odds);this.createOddUrl(odds);this.state.odds=odds;this.state.maxExpress=maxExpress;this.state.maxSystem=maxSystem;this.state.minVipExpress=minVipExpress;this.state.minVipSystem=minVipSystem;this.state.min=min;this.state.max=max;this.state.expressInsuranceData=expressInsuranceData;this.state.expressMultiplierPercents=expressMultiplierPercents;this.state.successExpressMultiplierData=successExpressMultiplierData;this.state.failedExpressMultiplierData=failedExpressMultiplierData;this.state.isAllOddsLine=Object.keys(odds).every(function(odd){var _a;return(_a=odds===null||odds===void 0?void 0:odds[odd])===null||_a===void 0?void 0:_a.minVip;});// это почему-то нужно php
this.calculateExpressCoef();this.calcSystem();this.calculatePossibleWin();if(this.state.isFreeBet){this.setFreeBetAmount(this.state.amount);}this.notify();}}]);return BasketBusiness;}();

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BasketCore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _BetCart=__webpack_require__(645);var _BetCartIrm=__webpack_require__(646);var _Base2=__webpack_require__(647);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// interface with metods
var BasketCore=exports.BasketCore=function(_Base){_inherits(BasketCore,_Base);function BasketCore(config){var isIrm=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;_classCallCheck(this,BasketCore);var _this=_possibleConstructorReturn(this,(BasketCore.__proto__||Object.getPrototypeOf(BasketCore)).call(this));_this.listenerClass=_BetCart.BetsCartListener;if(isIrm){_this.listenerClass=_BetCartIrm.BetsCartIrmListener;}_this.init(config);return _this;}_createClass(BasketCore,[{key:'adapter',value:function adapter(data){return data;}}]);return BasketCore;}(_Base2.Base);

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BetsCartListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetsCartListener=exports.BetsCartListener=function(_BaseSocketConnector){_inherits(BetsCartListener,_BaseSocketConnector);function BetsCartListener(){_classCallCheck(this,BetsCartListener);var _this=_possibleConstructorReturn(this,(BetsCartListener.__proto__||Object.getPrototypeOf(BetsCartListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.BET_CART;_this.isConnectionSelfClosable=true;return _this;}_createClass(BetsCartListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,lng:this.language},cfg);}}]);return BetsCartListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BetsCartIrmListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetsCartIrmListener=exports.BetsCartIrmListener=function(_BaseSocketConnector){_inherits(BetsCartIrmListener,_BaseSocketConnector);function BetsCartIrmListener(){_classCallCheck(this,BetsCartIrmListener);var _this=_possibleConstructorReturn(this,(BetsCartIrmListener.__proto__||Object.getPrototypeOf(BetsCartIrmListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.BET_CART_IRM;_this.isConnectionSelfClosable=true;return _this;}_createClass(BetsCartIrmListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign({timezone:this.timezone,lng:this.language},cfg);}}]);return BetsCartIrmListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Base=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _isDiff=__webpack_require__(648);var _objectMerger=__webpack_require__(649);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Base=exports.Base=function(){function Base(){_classCallCheck(this,Base);this.subscribers=[];}_createClass(Base,[{key:'init',value:function init(config){this.config=config;this.listener=new this.listenerClass(this.config);this.connect();}},{key:'reInit',value:function reInit(config){this.init(config);this.connect();}},{key:'connect',value:function connect(){this.listener.subscribe(Object.assign(Object.assign({},this.config),{onmessage:this.save.bind(this)}));}},{key:'save',value:function save(data){if((0,_isDiff.isDiff)(data)){this.data=this.adapter((0,_objectMerger.objectMerger)(this.data,data));this.update();}else{this.data=this.adapter(data);this.update();}}},{key:'update',value:function update(){var _this=this;this.subscribers.forEach(function(fn){return fn(_this.data);});}},{key:'subscribe',value:function subscribe(fn){this.subscribers.push(fn);}},{key:'unsubscribe',value:function unsubscribe(fn){this.listener.unsubscribe(fn);this.subscribers=this.subscribers.filter(function(sub){return sub!==fn;});}}]);return Base;}();

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var isDiff=exports.isDiff=function isDiff(wsMessage){if(wsMessage.diff===undefined||wsMessage.diff===true){return true;}else{return false;}};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var objectMerger=exports.objectMerger=function objectMerger(full,diff){var saveDataObj=objectСopier(full)||{};for(var key in diff){if(_typeof(diff[key])==='object'&&!Array.isArray(diff[key])){saveDataObj[key]=objectMerger(saveDataObj[key],diff[key]);}else{saveDataObj[key]=diff[key];}}return saveDataObj;};var objectСopier=function objectСopier(obj){if(!obj)return obj;return JSON.parse(JSON.stringify(obj));};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BetsCartFeaturesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BetsCartFeaturesListener=exports.BetsCartFeaturesListener=function(_BaseSocketConnector){_inherits(BetsCartFeaturesListener,_BaseSocketConnector);function BetsCartFeaturesListener(){_classCallCheck(this,BetsCartFeaturesListener);var _this=_possibleConstructorReturn(this,(BetsCartFeaturesListener.__proto__||Object.getPrototypeOf(BetsCartFeaturesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.BET_CART_FEATURES;_this.isConnectionSelfClosable=true;return _this;}_createClass(BetsCartFeaturesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){// @ts-ignore
return cfg.currency;}}]);return BetsCartFeaturesListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var isNumber=exports.isNumber=function isNumber(value){return typeof value==='number';};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var slugify=exports.slugify=function slugify(string){var a='àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';var b='aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';var p=new RegExp(a.split('').join('|'),'g');return string.toString().toLowerCase().replace(/\s+/g,'-')// Replace spaces with -
.replace(p,function(c){return b.charAt(a.indexOf(c));})// Replace special characters in a with b
.replace(/&/g,'-and-')// Replace & with ‘and’
.replace(/[^\w-]+/g,'')// Remove all non-word characters such as spaces or tabs
.replace(/--+/g,'-')// Replace multiple — with single -
.replace(/^-+/,'')// Trim — from start of text
.replace(/-+$/,'');// Trim — from end of text
};var urlSlug=exports.urlSlug=function urlSlug(id){var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if(!title){title='';}return''+id+(title&&'_'+slugify(title));};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _regenerator=__webpack_require__(59);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35;var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _intersection=__webpack_require__(210);var _intersection2=_interopRequireDefault(_intersection);var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _common=__webpack_require__(6);var _base=__webpack_require__(214);var _reactRouterDom=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var LineStore=(_class=function(){/** @type {0|1} загружать ли допроспись при раскрытии */function LineStore(store,accountStore,appStore){var _this=this;_classCallCheck(this,LineStore);_initDefineProp(this,'status',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);_initDefineProp(this,'loadingRoss',_descriptor3,this);_initDefineProp(this,'trigger',_descriptor4,this);_initDefineProp(this,'mode',_descriptor5,this);_initDefineProp(this,'lineSport',_descriptor6,this);_initDefineProp(this,'lineLeague',_descriptor7,this);_initDefineProp(this,'lineGames',_descriptor8,this);_initDefineProp(this,'lineGamesDetails',_descriptor9,this);_initDefineProp(this,'lineGamesOther',_descriptor10,this);_initDefineProp(this,'result',_descriptor11,this);_initDefineProp(this,'lineMessage',_descriptor12,this);_initDefineProp(this,'showTableItems',_descriptor13,this);_initDefineProp(this,'showTableItemsAll',_descriptor14,this);_initDefineProp(this,'showTableDopItems',_descriptor15,this);_initDefineProp(this,'showTableDopBets',_descriptor16,this);_initDefineProp(this,'filterTables',_descriptor17,this);_initDefineProp(this,'firstLine',_descriptor18,this);this.refreshTimer=null;this.loadTimer=null;_initDefineProp(this,'all',_descriptor19,this);_initDefineProp(this,'ross',_descriptor20,this);_initDefineProp(this,'finishLoad',_descriptor21,this);_initDefineProp(this,'userToggleRoss',_descriptor22,this);_initDefineProp(this,'dict',_descriptor23,this);_initDefineProp(this,'offset',_descriptor24,this);_initDefineProp(this,'hasMore',_descriptor25,this);_initDefineProp(this,'length',_descriptor26,this);_initDefineProp(this,'pagination',_descriptor27,this);_initDefineProp(this,'colCount',_descriptor28,this);_initDefineProp(this,'selected',_descriptor29,this);_initDefineProp(this,'timeLineFilter',_descriptor30,this);_initDefineProp(this,'timeLine',_descriptor31,this);_initDefineProp(this,'toggleRossGames',_descriptor32,this);_initDefineProp(this,'statisticalCategories',_descriptor33,this);_initDefineProp(this,'statisticalCategoriesLoading',_descriptor34,this);_initDefineProp(this,'isShowTooltip',_descriptor35,this);this.defaultMainTab=new Map();this.store=null;this.account=null;this.appStore=null;this.loadLine=(0,_mobx.action)(function(){var attempt=0;_this.clearResult();_this.clearLineMessage();clearTimeout(_this.loadTimer);return _api2.default[_this.mode].get(_this.ross,_this.all,_mobx2.default.toJS(_this.selected),_this.getRossGamesLoad(),_this.offset,_this.length,_this.timeLine,_this.appStore.cashboxMode).then((0,_mobx.action)(function(data){if((0,_common.isObject)(data)){if(data.sport){_this.dict=data.dict;_this.addSport(data.sport);_this.addLeague(data.league);_this.addGame(data.games);_this.addGameDetails(data.t_b);if(_this.mode=='line'){if(data.pagination.slice==0)_this.hasMore=false;}}else{if(_this.mode=='line'){// if (this.store.menu.sport.size > 0) {
// 	this.selectItem({sport: this.store.menu.sport.keys(), league: [], games: []}, 1);
// } else {
_this.lineSport=[];if(_this.timeLine!=0){// this.setResult('За выбранный период событий нет. Пожалуйста сбросте фильтр или выберите другой период');
_this.setLineMessage('За выбранный период событий нет','Пожалуйста выберите другой период');}else{_this.setResult('Событие не найдено. Пожалуйста, выберите интересующее событие в левом меню');}// this.errorLine.text = 'Нет выбранных событий';
// }
}}// this.setDivmainScroll();
if(_this.mode==='live'){_this.subscribeListMatchesWS().catch((0,_mobx.action)(function(){_this.isLoading=false;_this.refreshLine();}));return;}_this.isLoading=false;_this.refreshLine();// if (this.mode == 'live') {
// 	const time = this.countSelectGames == 1 ? this.store.liveRefreshOne : this.store.liveRefreshInterval;
// 	this.refreshTimer = setTimeout(() => this.loadLine(), this.mode == 'live' ? time : 10000000);
// }
}else if(data==null){_this.isLoading=false;if(_this.mode=='line'){_this.lineSport=[];if(_this.timeLine!=0){// this.setResult('За выбранный период событий нет. Пожалуйста сбросте фильтр или выберите другой период');
_this.setLineMessage('За выбранный период событий нет','Пожалуйста выберите другой период');}else{_this.setResult('Событие не найдено. Пожалуйста, выберите интересующее событие в левом меню');}}}else{if(attempt<5){attempt++;_this.loadTimer=setTimeout(function(){return _this.loadLine();},3000);}else{_this.setResult('SERVER_TEMPORARILY_DOWN');}}})).catch((0,_mobx.action)(function(err){_this.setResult('SERVER_TEMPORARILY_DOWN');}));});this.refreshLine=(0,_mobx.action)(function(){if(!_this.mode||_this.mode!=='live')return false;_this.refreshRossStatisticalTables();return _api2.default[_this.mode].get(_this.ross,_this.all,_mobx2.default.toJS(_this.selected),_this.getRossGamesLoad(),_this.offset,_this.length,_this.timeLine,_this.appStore.cashboxMode).then((0,_mobx.action)(function(data){if(data&&data.sport){_this.dict=data.dict;_this.addSport(data.sport);_this.addLeague(data.league);_this.addGame(data.games);_this.addGameDetails(data.t_b);// this.checkGamesUpdate();
// } else {
// this.selectItem({sport: [], league: [], games: []}, 1);
}// this.setDivmainScroll();
var time=_this.countSelectGames==1?_this.store.liveRefreshOne:_this.store.liveRefreshInterval;_this.refreshTimer=setTimeout(function(){return _this.refreshLine();},_this.mode=='live'?time:10000000);}));// .catch(action(err => {
// 	this.setResult('SERVER_TEMPORARILY_DOWN');
// }))
});this.HIDE_WIDTH=300;this.getActiveStatisticalCategoryID=function(gameID){var activePrimaryStatisticalCategory=(_this.statisticalCategories.get(gameID)||[]).find(function(_ref){var isActive=_ref.isActive;return isActive;})||{};if(typeof activePrimaryStatisticalCategory.categories!=='undefined'){var id=activePrimaryStatisticalCategory.categories.find(function(_ref2){var isActive=_ref2.isActive;return isActive;}).id;return Number(id);}return Number(activePrimaryStatisticalCategory.id||gameID);};this.getSecondaryStatisticalCategories=function(){var statisticalCategories=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var secondaryStatisticalCategories=statisticalCategories.find(function(_ref3){var categories=_ref3.categories;return typeof categories!=='undefined';})||{};return secondaryStatisticalCategories.categories||[];};this.refreshRossStatisticalTables=function(){var rossGameIDs=[];if(_this.userToggleRoss.length>0){rossGameIDs=_this.userToggleRoss;}else if(_this.selected.games.length===1){rossGameIDs=_this.selected.games;}rossGameIDs.forEach(function(id){if(_this.store.matchesList.outcomes.isSubscribed(id)){return;}var statisticalCategories=_this.statisticalCategories.get(id);if(typeof statisticalCategories!=='undefined'){var activePrimaryStatisticalCategory=statisticalCategories.find(function(_ref4){var isActive=_ref4.isActive;return isActive;});_this.loadRossByPrimaryStatisticalCategory(id,activePrimaryStatisticalCategory.id,{isRefresh:true});}});};this.store=store;this.account=accountStore;this.appStore=appStore;}/**
   * Подсвечивать ли изменения live-коэф.
   */_createClass(LineStore,[{key:'setShowRoss',value:function setShowRoss(ross){var _this2=this;if(this.mode==='live'){this.ross=ross?1:0;var games=[];if(this.selected.games.length){games=this.selected.games;}else{games=this.lineGames.keys().map(function(v){return Number(v);});}games.forEach(function(id){if(_this2.lineGames.has(id))_this2.lineGames.get(id).sr=_this2.ross;if(_this2.ross)_this2.setToggleGames(id,_this2.lineGames.get(id).sid);});if(this.ross){this.userToggleRoss=games;}else{this.userToggleRoss=[];this.removeToggleGames(null,null,1);}}}},{key:'setResult',value:function setResult(text,type){this.result.status=1,this.result.text=text,this.result.type=type?type:0;}},{key:'clearResult',value:function clearResult(){this.result.status=0,this.result.text='',this.result.type=0;}},{key:'init',value:function init(){var _this3=this;// if (!this.status) {
this.mode=this.store.mode;this.ross=this.account.accountSettings.loadRossLive&&this.mode=='live'?1:0;// this.getData();
this.status=true;this.colCount=this.mode=='live'?2:3;// }
(0,_mobx.autorun)(function(){_this3.setShowRoss(_this3.account.accountSettings.loadRossLive);});}},{key:'despose',value:function despose(){clearInterval(this.refreshTimer);this.status=false;this.mode='';this.isLoading=true;this.lineSport=[];this.lineLeague.clear();this.lineGames.clear();this.lineGamesDetails.clear();this.lineGamesOther.clear();this.showTableItems=[];this.showTableItemsAll=false;this.showTableDopItems=[];this.showTableDopBets=[];this.filterTables.clear();this.userToggleRoss=[];this.toggleRossGames.clear();this.ross=0;this.all=0;this.hasMore=true;this.selected={sport:[],league:[],games:[],type:'',popular:0,video:0};this.offset=0;this.length=50;this.refreshTimer=null;this.colCount=2;this.clearResult();this.clearLineMessage();this.statisticalCategories.clear();this.statisticalCategoriesLoading=[];}},{key:'getData',value:function getData(){var _this4=this;return _api2.default[this.mode].getData().then((0,_mobx.action)(function(data){if(data.result){_this4.selected.sport=data.result.sport;_this4.selected.league=data.result.league;_this4.selected.games=data.result.games;_this4.selected.games=data.result.games;_this4.all=parseFloat(data.result.all);_this4.onlyview=parseFloat(data.result.onlyview);_this4.loadLine();}else{_this4.setResult(data.text?data.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this4.setResult('SERVER_TEMPORARILY_DOWN');}));}},{key:'setLineMessage',value:function setLineMessage(title,text){this.lineMessage.title=title;this.lineMessage.text=text;}},{key:'clearLineMessage',value:function clearLineMessage(){this.lineMessage.title='';this.lineMessage.text='';}},{key:'loadMore',value:function loadMore(){var _this5=this;this.offset+=this.length;return _api2.default[this.mode].get(this.ross,this.all,_mobx2.default.toJS(this.selected),this.getRossGamesLoad(),this.offset,this.length,this.timeLine,this.appStore.cashboxMode).then((0,_mobx.action)(function(data){if(data.sport){_this5.gluing(data);// this.checkGamesUpdate();
}else{_this5.hasMore=false;}// this.setDivmainScroll();
}));// .catch(action(err => {
// 	this.setResult('SERVER_TEMPORARILY_DOWN');
// }))
}},{key:'gluing',value:function gluing(data){var _this6=this;if(data.pagination&&data.pagination.slice==0)this.hasMore=false;this.dict=_extends({},this.dict,{sport:data.dict.sport,league:data.dict.league,cmd:data.dict.cmd});data.sport.forEach(function(item){var s=_this6.lineSport.findIndex(function(el,index){return el.id==item.id;});if(s!=-1){// this.lineSport[s].league = this.lineSport[s].league.concat(item.league];
_this6.lineSport[s].league=_lodash2.default.union(_this6.lineSport[s].league,item.league);}else{item.name=_this6.dict.sport[item.id];_this6.lineSport.push(item);}});this.addLeague(data.league,1);this.addGame(data.games);this.addGameDetails(data.t_b);}},{key:'setData',value:function setData(){var _this7=this;var data={};var selected=_mobx2.default.toJS(this.selected);if(this.mode=='live'){data={all:this.all,ross:this.ross,onlyview:0};if(selected.type==1)data['sport']=selected.sport;data['games']=selected.games;}else if(this.mode=='line'){data={all:this.all,onlyview:0,ross:this.ross,popular:this.selected.popular,timeline:this.timeLine,count:0};switch(this.selected.type){case 0:data.sport=selected.sport;data.league=selected.league;data.games=selected.games;break;case 1:data.sport=selected.sport;break;case 2:data.sport=selected.sport;data.league=selected.league;data.count=selected.games.length;break;case 3:data.sport=selected.sport;data.league=selected.league;data.games=selected.games;data.count=1;break;case 4:data.sport=selected.sport;data.league=selected.league;break;case 5:data.sport=selected.sport;data.league=selected.league;break;}}try{return _api2.default[this.mode].setData(data).then((0,_mobx.action)(function(data){if(data.code=='OK'){}})).catch((0,_mobx.action)(function(err){_this7.setResult('SERVER_TEMPORARILY_DOWN');}));}catch(e){console.log(this.mode);}}/**
   * @param {number[]} gamesID
   */},{key:'loadLineRoss',value:function loadLineRoss(){var gamesID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(gamesID.length===0){return;}this.loadingRoss=gamesID;// обновление допросписи по websocket доступно только для 1 раскрытого события
this.requestOutcomesData(gamesID);}/**
  * Подписка на список live матчей по wss
  */},{key:'subscribeListMatchesWS',value:function subscribeListMatchesWS(){var _ref5=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{top:false},top=_ref5.top;// const isFavPage = document.location.pathname.includes('favourites')
// const selected = toJS(this.selected);
// const matchIds = selected.games.length > 0 && selected.games;
// const championshipsIds = matchIds.length === 0 && selected.league;
// const sportIds = championshipsIds.length === 0 && selected.sport;
// const favorites = (sportIds || championshipsIds || matchIds) && { sportIds, championshipsIds, matchIds };
// const championshipId = !favorites && selected.league.length === 1 && selected.league[0];
// const sportId = !favorites && !championshipId && selected.sport.length === 1 && selected.sport[0];
var isFavPage=document.location.pathname.includes('favourites');var selected=(0,_mobx.toJS)(this.selected);var matchIds=selected.games.length>0&&selected.games;var championshipsIds=matchIds.length===0&&selected.league;var sportIds=championshipsIds.length===0&&selected.sport;var favorites=(sportIds||championshipsIds||matchIds)&&{sportIds:sportIds,championshipsIds:championshipsIds,matchIds:matchIds};var championshipId=selected.league.length===1&&selected.league[0];var sportId=!championshipId&&selected.sport.length===1&&selected.sport[0];// const video = selected.video;
// const selectedParams = Object.assign(
//   { sort: this.store.schedule.select.sort === 'abc' ? SORT_BY.ALPHABET : SORT_BY.PRIORITY },
//   championshipId && { championshipId },
//   favorites && isFavPage && {
//     championshipsIds: championshipsIds || [],
//     sportIds: sportIds || [],
//     matchIds: matchIds || [],
//     favorites: true,
//   },
//   favorites && !isFavPage && {
//     singleMatch: true,
//     id: matchIds[0],
//   },
//   sportId && { sportId },
//   video && { video },
//   top && { top },
// );
var video=selected.video;var selectedParams=Object.assign({sort:this.store.schedule.select.sort==='abc'?_base.SORT_BY.ALPHABET:_base.SORT_BY.PRIORITY},championshipId&&{championshipId:championshipId},favorites&&isFavPage&&{championshipsIds:championshipsIds||[],sportIds:sportIds||[],matchIds:matchIds||[],favorites:true},favorites&&!isFavPage&&matchIds.length===1&&{singleMatch:true,id:matchIds[0]},sportId&&{sportId:sportId},video&&{video:video},top&&{top:top});/** Костыль, потому что метод постоянно вызывается из разных мест даже с одинаковыми params */if(JSON.stringify(selectedParams)===this.lastSelectedParams){return Promise.resolve();}this.lastSelectedParams=JSON.stringify(selectedParams);return this.store.matchesList.listenWS(selectedParams);}/**
   * Подгрузка доп.росписи по xhr
   * @param {number[]} gameIDs
   */},{key:'requestOutcomesData',value:function requestOutcomesData(){var _this8=this;var gameIDs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];_api2.default[this.mode].getRoss(gameIDs).then(function(response){_this8.onOutcomesLoaded(response.result||response);}).catch((0,_mobx.action)(function(){_this8.onGameOutcomesLoaded(gameIDs);gameIDs.forEach(function(gameID){var endedGame=_this8.lineGames.get(gameID);endedGame.ross=false;endedGame.sr=false;var index=_this8.userToggleRoss.indexOf(gameID);if(index===-1){return;}_this8.userToggleRoss.splice(index,1);_this8.removeToggleGames(gameID,endedGame.sid);});}));}},{key:'onOutcomesLoaded',value:function onOutcomesLoaded(data){if(!data.t_b){throw new Error('No Response Data!');}var loadedGamesID=Object.keys(data.t_b).map(Number);this.onGameOutcomesLoaded(loadedGamesID);this.addGameDetails(data.t_b);}},{key:'onGameOutcomesLoaded',value:function onGameOutcomesLoaded(){var gamesID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(gamesID.length===0){return;}this.loadingRoss=this.loadingRoss.filter(function(gameID){return!gamesID.includes(gameID);});}},{key:'addSport',value:function addSport(sport){var _this9=this;var s=void 0,d=void 0;// const lineSport = mobx.toJS(this.lineSport)
if(sport&&sport.length>0){_lodash2.default.pullAllWith(this.lineSport,sport,function(x,y){return x.id!=y.id;});sport.forEach(function(item){if(item.league.length===0)return false;if(_this9.selected.sport.indexOf(item.id)!=-1||_this9.all||_this9.selected.popular_group&&_this9.selected.popular_group.length){s=_this9.lineSport.findIndex(function(el,index){return el.id==item.id;});if(s!=-1){_this9.lineSport[s].league=item.league;}else{if(item.league)item.name=_this9.dict.sport[item.id];_this9.lineSport.push(item);}}});}else{this.lineSport=[];}this.setDefaultMainTab(sport);}},{key:'setDefaultMainTab',value:function setDefaultMainTab(sport){var _this10=this;if(!sport)return;Object.values(sport).forEach(function(item){var tabs_ids=item.default_categories;if(tabs_ids&&Array.isArray(tabs_ids))_this10.defaultMainTab.set(item.id,tabs_ids);});}},{key:'addLeague',value:function addLeague(league,more){var l=void 0;if(league){for(var item in league){if(this.lineLeague.has(item)){if(more){this.lineLeague.get(item).games=_lodash2.default.uniq(this.lineLeague.get(item).games.concat(league[item].games));}else{l=_lodash2.default.xor(_mobx2.default.toJS(this.lineLeague.get(item).games),league[item].games);if(l.length>0){// this.lineLeague.set(item, league[item]);
this.lineLeague.get(item).games=league[item].games;}}}else{league[item]['show']=this.showTableItemsAll;league[item]['name']=this.dict.league[item];this.lineLeague.set(item,league[item]);}}}}},{key:'addGame',value:function addGame(games){if(games){var _g=[];for(var item in games){if(this.lineGames.has(item)){this.copyGame(item,games[item]);}else{games[item]['sr']=this.ross;games[item]['c1']=this.dict.cmd[games[item].c1_id];if(this.account.access&&games[item].statistical_ids&&this.account.accountSettings.tooltip_union_stat_match===0&&this.isShowTooltip){games[item]['showTooltip']=true;this.isShowTooltip=false;}if(games[item].c2_id)games[item]['c2']=this.dict.cmd[games[item].c2_id];this.lineGames.set(item,games[item]);if(Array.isArray(games[item].statistical_ids)){this.addStatisticalCategories(games[item].id,games[item].statistical_ids);}}if(this.mode==='line'&&this.lineGames.get(item).sr&&Number(this.lineGames.get(item).ross_count))_g.push(Number(item));}if(this.mode==='line')this.loadLineRoss(_g);}}},{key:'addGameDetails',value:function addGameDetails(tables){var _ref6=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref6$withoutExtraFil=_ref6.withoutExtraFilters,withoutExtraFilters=_ref6$withoutExtraFil===undefined?[]:_ref6$withoutExtraFil;var g=void 0;if(tables&&!Array.isArray(tables.order)){for(var item in tables){item=Number(item);if(this.userToggleRoss.indexOf(item)!==-1||this.userToggleRoss.indexOf(Number((this.lineGames.get(item)||{}).parent_game_id))!==-1||this.selected.games.length===1){if(tables[item].data)this.copyGameTables(item,tables[item].data);if(tables[item].other)this.copyGameOther(item,tables[item].other);if(tables[item].filter)this.setTableFilters(item,tables[item].filter,{withoutExtraFilters:withoutExtraFilters});if(tables[item].f_l)this.setFirstLine(item,tables[item].f_l);}}}else{this.lineGamesDetails.clear();this.lineGamesOther.clear();this.firstLine.clear();this.filterTables.clear();}}},{key:'checkGamesUpdate',value:function checkGamesUpdate(){var i=void 0,j=void 0;if(this.selected.type==1){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.selected.sport[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){i=_step.value;j=this.lineSport.filter(function(item){return item.id==i;});if(j){}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}},{key:'getVisibleTableIDs',value:function getVisibleTableIDs(){var order=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _this11=this;var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var gameID=arguments[2];if(!order&&!order.length){return[];}// sfs - флаг необходимости отображения таблицы внутри основного
var visibleTableIDs=order.filter(function(order){return data[order].data.sfs;});if(visibleTableIDs.length>0){return visibleTableIDs;}// if (this.allOpenedStatisticalRossIDs.includes(`${gameID}`)) {
//   return order.filter(order => data[order].data.sfs);
// }
var width=window.innerWidth;return order.filter(function(order){var _ref7=data[order].data||{},_ref7$cls_vis=_ref7.cls_vis,cls_vis=_ref7$cls_vis===undefined?'':_ref7$cls_vis,fbt=_ref7.fbt;return!(width>_this11.HIDE_WIDTH&&cls_vis.indexOf('col-sm')!==-1)&&fbt;});}},{key:'copyGameTables',value:function copyGameTables(item,tables){var _this12=this;var order=[];var tablesOdred=this.getVisibleTableIDs(tables.order,tables.data,item);if(this.lineGamesDetails.has(item)&&this.lineGamesDetails.get(item).order.length==this.colCount){var _o=_mobx2.default.toJS(this.lineGamesDetails.get(item).order);var _s=_lodash2.default.pullAll(tablesOdred,_lodash2.default.flattenDeep(_o));if(_s.length){if(_s.length==1){_o[0].push(_s[0]);}else{_o=_o.map(function(arr,i){var _d=arr;_s.forEach(function(x,indx){if(indx%_this12.colCount==i){_d.push(x);}});return _d;});}}order=_o;}else{if(tablesOdred.length==1){order.push([tablesOdred[0]]);}else{var _loop=function _loop(i){var _t=[];tablesOdred.forEach(function(x,indx){var _d=tablesOdred[_this12.colCount*indx-i];if(_d)_t.push(_d);});order.push(_t);};for(var i=this.colCount;i>0;i--){_loop(i);}}}this.lineGamesDetails.set(item,{order:order,originalOrder:tables.order,data:tables.data});}},{key:'placeForColTables',value:function placeForColTables(arr){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=arr[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var i=_step2.value;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}},{key:'copyGameOther',value:function copyGameOther(item,other){this.lineGamesOther.set(item,other);}},{key:'setFirstLine',value:function setFirstLine(item,firstLine){var _this13=this;if(this.firstLine.has(item)){if(!firstLine){this.firstLine.delete(item);return;}var f=_mobx2.default.toJS(this.firstLine.get(item));if(f.length>0){f.filter(function(_,lineIndex){return!!firstLine[lineIndex];}).forEach(function(line,lineIndex){line.filter(function(coef,coefIndex){return!_lodash2.default.isEqual(coef,firstLine[lineIndex][coefIndex]);}).forEach(function(_,coefIndex){_this13.firstLine.get(item)[lineIndex][coefIndex]=firstLine[lineIndex][coefIndex];});});}}else{this.firstLine.set(item,firstLine);}}},{key:'setTableFilters',value:function setTableFilters(item,filters){var _this14=this;var _ref8=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},_ref8$withoutExtraFil=_ref8.withoutExtraFilters,withoutExtraFilters=_ref8$withoutExtraFil===undefined?[]:_ref8$withoutExtraFil;var isWithoutExtraFilters=withoutExtraFilters.includes(''+item);if(this.filterTables.has(item)){var f=this.filterTables.get(item);filters.order.map(function(i){if(f.filter[i]){if(f.filter[i].count!=filters.data[i].count){_this14.filterTables.get(item).filter[i].count=filters.data[i].count;}if(_lodash2.default.xor(filters.data[i].tids,f.filter[i].tids).length){_this14.filterTables.get(item).filter[i].tids=filters.data[i].tids;}}else{_this14.filterTables.get(item).filter[i]={name:filters.data[i].n,count:filters.data[i].count,select:Number(isWithoutExtraFilters),tids:filters.data[i].tids};}});if(!isWithoutExtraFilters){filters.order.unshift(0);}this.filterTables.get(item).order=filters.order;}else{var _ref9=this.lineGames.has(item)?this.lineGames.get(item):{sid:0},sid=_ref9.sid;var selectedFilter=this.defaultMainTab&&this.defaultMainTab.has(sid)&&filters.order.filter(function(id){return _this14.defaultMainTab.get(sid).includes(id);});var filter={};if(!isWithoutExtraFilters){filter[0]={name:'Все',select:+(!selectedFilter||!selectedFilter.length),count:0};}filters.order.forEach(function(i){filter[i]={};filter[i].name=filters.data[i].n;filter[i].count=filters.data[i].count;filter[i].select=isWithoutExtraFilters?1:+(selectedFilter&&selectedFilter.includes(i));filter[i].tids=filters.data[i].tids;});if(!isWithoutExtraFilters){filters.order.unshift(0);}var data={filter:filter,order:filters.order};this.filterTables.set(item,data);}}},{key:'copyGame',value:function copyGame(item,game){var _this15=this;var lineGame=_mobx2.default.toJS(this.lineGames.get(item));lineGame.f_l.map(function(x,idx){if(!_lodash2.default.isEqual(x,game.f_l[idx])){_this15.lineGames.get(item).f_l[idx]=game.f_l[idx];}});['ross','score','st','date','hd','tv','video_type','video','is_video','stats'].forEach(function(f){if(lineGame[f]!==game[f]){_this15.lineGames.get(item)[f]=game[f];}});// if (lineGame.ross != game.ross) {
//   this.lineGames.get(item).ross = game.ross;
// }
//
// if (lineGame.score != game.score) {
//   this.lineGames.get(item).score = game.score;
// }
//
// if (lineGame.st != game.st) {
//   this.lineGames.get(item).st = game.st;
// }
//
// if (game['hd']) {
//   this.lineGames.get(item)['hd'] = game['hd'];
// }
if(this.lineGames.get(item).ross==0){this.firstLine.delete(item);this.filterTables.delete(item);this.lineGamesDetails.delete(item);this.lineGamesOther.delete(item);}// if ( lineGame.ross != game.ross) {
// 	this.lineGames.get(item).ross = game.ross;
// }
// this.lineGames.get(item).sr = this.ross;
var statisticalCategories=this.statisticalCategories.get(item);if(statisticalCategories||game.statistical_ids){var hasSomeDifferentStatisticalCategory=typeof statisticalCategories==='undefined'?false:statisticalCategories.some(function(_ref10,index){var id=_ref10.id;var statisticalIDs=game.statistical_ids||[];var foundMatchID=(statisticalIDs[index]||{}).id;return id===''+foundMatchID;});if((statisticalCategories||[]).length!==(game.statistical_ids||[]).length||hasSomeDifferentStatisticalCategory){this.addStatisticalCategories(item,game.statistical_ids);}}}},{key:'toogleShowTableItems',value:function toogleShowTableItems(id){this.lineLeague.get(id).show=!this.lineLeague.get(id).show;}},{key:'toggleAllLeagueShow',value:function toggleAllLeagueShow(){var _this16=this;this.showTableItemsAll=!this.showTableItemsAll;this.lineLeague.keys().forEach(function(i){_this16.lineLeague.get(i).show=_this16.showTableItemsAll;});if(this.showTableItemsAll){this.loadMore();}// this.lineLeague.get(id).show = !this.lineLeague.get(id).show;
}},{key:'setToggleGames',value:function setToggleGames(gid,sid){if(this.toggleRossGames.has(sid)){var arr=(0,_mobx.toJS)(this.toggleRossGames.get(sid));this.toggleRossGames.set(sid,Array.isArray(gid)?[].concat(_toConsumableArray(arr),_toConsumableArray(gid)):[].concat(_toConsumableArray(arr),[gid]));}else{this.toggleRossGames.set(sid,Array.isArray(gid)?gid:[gid]);}}},{key:'removeToggleGames',value:function removeToggleGames(gid,sid,clear){if(clear){this.toggleRossGames.clear();return null;}if(!this.toggleRossGames.has(sid))return null;this.toggleRossGames.set(sid,_lodash2.default.pullAll(Array.isArray(gid)?gid:(0,_mobx.toJS)(this.toggleRossGames.get(sid)),[gid]));return true;}},{key:'getToggleGames',value:function getToggleGames(sid){return this.toggleRossGames.has(sid)?this.toggleRossGames.get(sid):null;}},{key:'toogleShowDop',value:function toogleShowDop(id,type){var _this17=this;switch(type){case 0:var _lineLeague$get=this.lineLeague.get(id),games=_lineLeague$get.games;if(!games.some(function(gameID){return _this17.lineGames.get(gameID).sr;})){var gameIDs=[];games.forEach(function(gameID){var game=_this17.lineGames.get(gameID);if(game.ross){game.sr=1;_this17.userToggleRoss.push(gameID);_this17.setToggleGames(gameID,game.sid);gameIDs.push(gameID);}});this.loadLineRoss(gameIDs);break;}else{games.map(function(gameID){var game=_this17.lineGames.get(gameID);if(game.ross){game.sr=0;_this17.removeToggleGames(gameID,game.sid);}});}break;case 1:var game=this.lineGames.get(id);game.sr=!game.sr;if((game.statistical_ids||[]).length>0){this.setDefaultActiveStatisticalCategory(id);}if(this.ross&&game.sr){this.loadLineRoss([id]);return;}if(this.ross){return;}var index=this.userToggleRoss.indexOf(id);if(index==-1){this.userToggleRoss.push(id);this.setToggleGames(id,game.sid);this.loadLineRoss([id]);return;}this.userToggleRoss.splice(index,1);this.removeToggleGames(id,game.sid);break;}}},{key:'getHeadTable',value:function getHeadTable(id){return this.lineGames.get(this.lineLeague.get(id).games[0]).hd;}},{key:'isDopBets',value:function isDopBets(id){// return this.lineLeague[id].games.map((item) => (this.lineLeague))
}},{key:'setfilterTable',value:function setfilterTable(gameID,categoryID){var filterTable=this.filterTables.get(gameID);if(categoryID==0){for(var i in filterTable.filter){filterTable.filter[i].select=0;}filterTable.filter[0].select=1;}else{var check=0;filterTable.filter[categoryID].select=!filterTable.filter[categoryID].select;for(var _i in filterTable.filter){if(_i!=0&&filterTable.filter[_i].select!=0){check=1;break;}}filterTable.filter[0].select=!check?1:0;}this.rePrintTable(gameID);}},{key:'rePrintTable',value:function rePrintTable(gameID){var _this18=this;var lineGamesDetails=this.lineGamesDetails.get(gameID);var orderTableIDs=this.getVisibleTableIDs((0,_mobx.toJS)(lineGamesDetails.originalOrder),(0,_mobx.toJS)(lineGamesDetails.data),gameID);if(this.filterTables.has(gameID)){var filter=this.filterTables.get(gameID);if((filter.filter[0]||{}).select!==1){var filtersData=(0,_mobx.toJS)(filter.filter);var filterTableIDs=[];Object.values(filtersData).forEach(function(filterData){if(filterData.select&&(filterData.tids||[]).length>0&&Array.isArray(filterData.tids)){filterTableIDs=filterTableIDs.concat(filterData.tids);}});orderTableIDs=(0,_intersection2.default)(orderTableIDs,filterTableIDs);}}var order=[];lineGamesDetails.order=[];var _loop2=function _loop2(i){var groupTableIDs=[];orderTableIDs.forEach(function(tableID,index){var tableOnColumn=orderTableIDs[_this18.colCount*index-i];if(tableOnColumn){groupTableIDs.push(tableOnColumn);}});order.push(groupTableIDs);};for(var i=this.colCount;i>0;i--){_loop2(i);}if(orderTableIDs.length===1){order[0][0]=orderTableIDs[0];}lineGamesDetails.order=order;}},{key:'getShowTable',value:function getShowTable(cat_id,id){if(this.filterTables.get(id).filter[0].select==1)return 1;}},{key:'selectGame',value:function selectGame(id){this.store.menu.setSelect(id);this.selectItem({sport:[this.lineGames.get(id).sid],league:[this.lineGames.get(id).lid],games:[id]},3);}},{key:'selectItem',value:function selectItem(data,type){var _this19=this;this.all=this.mode=='live'?data.sport.length>0?0:1:0;this.selected.sport=data.sport;this.selected.league=data.league;this.selected.games=data.games;this.selected.popular_group=data.popular_group;this.selected.type=type;this.selected.video=data.video;if(this.selected.video){this.lineLeague.clear();this.lineGames.clear();}if(data.games.length==1){this.ross=1;if(this.lineGames.get(data.games[0]))this.lineGames.get(data.games[0]).sr=1;}else{this.ross=this.mode=='live'?Number(this.account.accountSettings.loadRossLive):0;data.games.forEach(function(el){if(_this19.lineGames.get(el)&&_this19.userToggleRoss.indexOf(el)==-1)_this19.lineGames.get(el)['sr']=0;});}this.scrollTop();this.resetLoad();}},{key:'scrollTop',value:function scrollTop(){var div=document.getElementById('divmain');if(div)div.scrollTop=0;}},{key:'resetLoad',value:function resetLoad(){var _this20=this;var clear=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;clearInterval(this.refreshTimer);this.isLoading=true;this.lineSport=[];this.refreshTimer=null;this.offset=0;this.hasMore=true;this.loadLine().then(function(){return _this20.mode==='live'&&_this20.subscribeListMatchesWS();}).then((0,_mobx.action)(function(){_this20.isLoading=!_this20.store.matchesList.isSubscribed;})).catch(console.error).then(function(){_this20.setData();});;}},{key:'setDivmainScroll',value:function setDivmainScroll(){if(_common.browser.mobile||_common.browser.mac){return;}var d=document.getElementById('divmain');if(d){var ss=d.scrollHeight==d.offsetHeight;if(ss){d.scrollTop=0;(0,_common.setStyle)('divmain-head','right','0');}else{(0,_common.setStyle)('divmain-head','right','10px');}}}},{key:'refreshSelected',value:function refreshSelected(){var _this21=this;var league=[];var games=[];if(this.selected.type==1){this.selected.sport.forEach(function(item){league=_this21.store.menu.sport.get(item).league;league.forEach(function(item){games=games.concat(_this21.store.menu.league.get(item).games.peek());});});this.selected.league=league;this.selected.games=games;}if(this.selected.type==2){this.selected.legue.forEach(function(item){games=games.concat(_this21.store.menu.league.get(item).games.peek());});this.selected.games=games;}}},{key:'filterLine',value:function filterLine(value){this.timeLine=value;this.resetLoad();}},{key:'getRossGamesLoad',value:function getRossGamesLoad(){var _this22=this;var _gids=[];if(this.mode==='live'&&this.all){_gids=(0,_mobx.toJS)(this.userToggleRoss);}else{this.selected.sport.forEach(function(sid){if(_this22.toggleRossGames.has(sid)){_gids=_gids.concat((0,_mobx.toJS)(_this22.toggleRossGames.get(sid)));}});if(this.selected.games.length>0)_gids=_lodash2.default.intersectionWith(this.selected.games,_gids,function(x,y){return x==y;});_gids=_lodash2.default.intersectionWith(this.userToggleRoss,_gids,function(x,y){return x==y;});}return _gids;}},{key:'addStatisticalCategories',value:function addStatisticalCategories(gameID,newStatisticalCategories){var statisticalCategories=newStatisticalCategories.sort(function(a,b){if(Number(a.stat_type)<Number(b.stat_type)){return-1;}if(Number(a.stat_type)>Number(b.stat_type)){return 1;}return 0;}).map(function(_ref11){var id=_ref11.id,base_stat=_ref11.base_stat,name_stas=_ref11.name_stas,ross_count=_ref11.ross_count;return _extends({id:''+id,name:name_stas,count:Number(ross_count),isActive:false},base_stat===1&&{isPrimary:true});});var primaryStatisticalCategories=statisticalCategories.filter(function(_ref12){var isPrimary=_ref12.isPrimary;return isPrimary;});var secondaryStatisticalCategories=statisticalCategories.filter(function(_ref13){var isPrimary=_ref13.isPrimary;return!isPrimary;});primaryStatisticalCategories.unshift({id:''+gameID,name:'MATCH',isActive:false,isLocaleKey:true});if(secondaryStatisticalCategories.length>0){primaryStatisticalCategories.push({id:secondaryStatisticalCategories.map(function(_ref14){var id=_ref14.id;return id;}).join('-'),name:'STATISTICS',count:secondaryStatisticalCategories.reduce(function(memo,_ref15){var count=_ref15.count;return memo+(count||0);},0),isActive:false,isLocaleKey:true,categories:secondaryStatisticalCategories});}var currentStatisticalCategory=this.statisticalCategories.get(gameID);if(currentStatisticalCategory){var currentPrimaryStatisticalCategoryID=(currentStatisticalCategory.find(function(_ref16){var isActive=_ref16.isActive;return isActive;})||{}).id;primaryStatisticalCategories.find(function(_ref17){var id=_ref17.id;return id===''+(currentPrimaryStatisticalCategoryID||gameID);}).isActive=true;var currentSecondaryStatisticalCategories=this.getSecondaryStatisticalCategories(currentStatisticalCategory);if(currentSecondaryStatisticalCategories.length>0){var currentSecondaryStatisticalCategoryID=(currentSecondaryStatisticalCategories.find(function(_ref18){var isActive=_ref18.isActive;return isActive;})||{}).id;var _secondaryStatisticalCategories=this.getSecondaryStatisticalCategories(primaryStatisticalCategories);var secondaryStatisticalCategory=_secondaryStatisticalCategories.find(function(_ref19){var id=_ref19.id;return id===currentSecondaryStatisticalCategoryID;});(secondaryStatisticalCategory||_secondaryStatisticalCategories[0]).isActive=true;}}this.statisticalCategories.set(gameID,primaryStatisticalCategories);if(typeof currentStatisticalCategory==='undefined'){this.setDefaultActiveStatisticalCategory(gameID);}}},{key:'setDefaultActiveStatisticalCategory',value:function setDefaultActiveStatisticalCategory(gameID){var statisticalCategories=this.statisticalCategories.get(gameID)||[];if(statisticalCategories.length>0){statisticalCategories.forEach(function(category){return category.isActive=false;});statisticalCategories[0].isActive=true;var secondaryStatisticalCategories=this.getSecondaryStatisticalCategories(statisticalCategories);if(secondaryStatisticalCategories.length>0){secondaryStatisticalCategories.forEach(function(category){return category.isActive=false;});secondaryStatisticalCategories[0].isActive=true;}}}},{key:'selectPrimaryStatisticalCategory',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(gameID,categoryID){var statisticalCategories,prevStatisticalCategoryID,isSameID;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:statisticalCategories=this.statisticalCategories.get(gameID);prevStatisticalCategoryID=statisticalCategories.find(function(_ref21){var isActive=_ref21.isActive;return isActive;}).id;isSameID=prevStatisticalCategoryID===categoryID;if(!isSameID){_context.next=5;break;}return _context.abrupt('return',null);case 5:if(this.store.matchesList.outcomes.isSubscribed(gameID)){_context.next=8;break;}_context.next=8;return this.loadRossByPrimaryStatisticalCategory(gameID,categoryID);case 8:(0,_mobx.runInAction)(function(){statisticalCategories.forEach(function(category){return category.isActive=category.id===categoryID;});});case 9:case'end':return _context.stop();}}},_callee,this);}));function selectPrimaryStatisticalCategory(_x11,_x12){return _ref20.apply(this,arguments);}return selectPrimaryStatisticalCategory;}()},{key:'loadRossByPrimaryStatisticalCategory',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(gameID,ids){var _this23=this;var _ref23=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},_ref23$isRefresh=_ref23.isRefresh,isRefresh=_ref23$isRefresh===undefined?false:_ref23$isRefresh;var normalizedIDs,response,isStatisticGame;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:normalizedIDs=ids.split('-');if(!(normalizedIDs.length===0)){_context2.next=3;break;}return _context2.abrupt('return',null);case 3:if(!isRefresh){this.statisticalCategoriesLoading.push(gameID);}response={};isStatisticGame=normalizedIDs.length>1||this.allOpenedStatisticalRossIDs.includes(''+normalizedIDs[0]);_context2.next=8;return _api2.default[this.mode].getRoss(normalizedIDs,Number(isStatisticGame));case 8:response=_context2.sent;(0,_mobx.runInAction)(function(){var tables=(response||{}).t_b;if(tables){var tableIDs=Object.keys(tables);var secondaryStatisticalCategories=(_this23.statisticalCategories.get(gameID)||[]).find(function(_ref24){var categories=_ref24.categories;return typeof categories!=='undefined';});var withoutExtraFilters=secondaryStatisticalCategories?secondaryStatisticalCategories.id.split('-'):[];tableIDs.forEach(function(id){var numberID=Number(id);if(!_this23.lineGames.has(numberID)){_this23.lineGames.set(numberID,{sid:_this23.lineGames.get(gameID).sid,parent_game_id:gameID});}});_this23.addGameDetails(tables,{withoutExtraFilters:withoutExtraFilters});}if(!isRefresh){_this23.statisticalCategoriesLoading=_this23.statisticalCategoriesLoading.filter(function(id){return id!==gameID;});}});case 10:case'end':return _context2.stop();}}},_callee2,this);}));function loadRossByPrimaryStatisticalCategory(_x13,_x14){return _ref22.apply(this,arguments);}return loadRossByPrimaryStatisticalCategory;}()},{key:'selectSecondaryStatisticalCategory',value:function selectSecondaryStatisticalCategory(gameID,categoryID){var statisticalCategories=this.statisticalCategories.get(gameID);var secondaryStatisticalCategories=this.getSecondaryStatisticalCategories(statisticalCategories);var prevStatisticalCategoryID=secondaryStatisticalCategories.find(function(_ref25){var isActive=_ref25.isActive;return isActive;}).id;if(prevStatisticalCategoryID===categoryID){return null;}secondaryStatisticalCategories.forEach(function(category){return category.isActive=category.id===categoryID;});}},{key:'highlightChanges',get:function get(){return this.account.accountSettings.highlightChangesLive===1&&this.mode=='live';}},{key:'countSelectGames',get:function get(){return this.selected.games.length;}},{key:'allOpenedStatisticalRossIDs',get:function get(){var _this24=this;var openedRossIDs=[];this.lineGames.forEach(function(_ref26,id){var sr=_ref26.sr;if(sr){openedRossIDs.push(id);}});var allOpenedStatisticalRossIDs=[];openedRossIDs.forEach(function(rossID){(_this24.statisticalCategories.get(rossID)||[]).forEach(function(_ref27,index){var id=_ref27.id,categories=_ref27.categories;if(index>0){typeof categories==='undefined'?allOpenedStatisticalRossIDs.push(id):allOpenedStatisticalRossIDs.push.apply(allOpenedStatisticalRossIDs,_toConsumableArray(categories.map(function(_ref28){var id=_ref28.id;return id;})));}});});return allOpenedStatisticalRossIDs;}}]);return LineStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'status',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loadingRoss',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'trigger',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'mode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'lineSport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'lineLeague',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'lineGames',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'lineGamesDetails',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'lineGamesOther',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'lineMessage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:'',text:''};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'showTableItems',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'showTableItemsAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'showTableDopItems',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'showTableDopBets',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'filterTables',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'firstLine',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'all',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'ross',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'finishLoad',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'userToggleRoss',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'offset',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'hasMore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'length',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 50;}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'pagination',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'colCount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 2;}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'selected',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{sport:[],league:[],games:[],type:'',popular:0,popular_group:[],video:0};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'timeLineFilter',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[{val:0,label:'IRM_TIMELINE_0'},{val:3600,label:'IRM_TIMELINE_3600'},{val:7200,label:'IRM_TIMELINE_7200'},{val:21600,label:'IRM_TIMELINE_21600'},{val:32400,label:'IRM_TIMELINE_32400'},{val:43200,label:'IRM_TIMELINE_43200'},{val:86400,label:'IRM_TIMELINE_86400'}];}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'timeLine',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'toggleRossGames',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'statisticalCategories',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'statisticalCategoriesLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'isShowTooltip',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_applyDecoratedDescriptor(_class.prototype,'setShowRoss',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setShowRoss'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'despose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'despose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setLineMessage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setLineMessage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearLineMessage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearLineMessage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadMore',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadMore'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadLineRoss',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadLineRoss'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onGameOutcomesLoaded',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'onGameOutcomesLoaded'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addSport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDefaultMainTab',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDefaultMainTab'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addLeague',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addLeague'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addGame'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addGameDetails',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addGameDetails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkGamesUpdate',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkGamesUpdate'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getVisibleTableIDs',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getVisibleTableIDs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'copyGameTables',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'copyGameTables'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'placeForColTables',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'placeForColTables'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'copyGameOther',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'copyGameOther'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setFirstLine',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setFirstLine'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTableFilters',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setTableFilters'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'copyGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'copyGame'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'toogleShowTableItems',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'toogleShowTableItems'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'toggleAllLeagueShow',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'toggleAllLeagueShow'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'toogleShowDop',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'toogleShowDop'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getHeadTable',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getHeadTable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isDopBets',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'isDopBets'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setfilterTable',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setfilterTable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rePrintTable',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'rePrintTable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getShowTable',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getShowTable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectGame'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectItem',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectItem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'countSelectGames',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'countSelectGames'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'resetLoad',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'resetLoad'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDivmainScroll',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDivmainScroll'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refreshSelected',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'refreshSelected'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filterLine',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filterLine'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addStatisticalCategories',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addStatisticalCategories'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDefaultActiveStatisticalCategory',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDefaultActiveStatisticalCategory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectPrimaryStatisticalCategory',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectPrimaryStatisticalCategory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadRossByPrimaryStatisticalCategory',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadRossByPrimaryStatisticalCategory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'allOpenedStatisticalRossIDs',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'allOpenedStatisticalRossIDs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectSecondaryStatisticalCategory',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectSecondaryStatisticalCategory'),_class.prototype)),_class);exports.default=LineStore;

/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(658);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(660),
    shortOut = __webpack_require__(662);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(661),
    defineProperty = __webpack_require__(177),
    identity = __webpack_require__(109);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _intersectionWith=__webpack_require__(664);var _intersectionWith2=_interopRequireDefault(_intersectionWith);var _intersection=__webpack_require__(210);var _intersection2=_interopRequireDefault(_intersection);var _unionWith=__webpack_require__(665);var _unionWith2=_interopRequireDefault(_unionWith);var _pullAll=__webpack_require__(216);var _pullAll2=_interopRequireDefault(_pullAll);var _union=__webpack_require__(672);var _union2=_interopRequireDefault(_union);var _pull=__webpack_require__(673);var _pull2=_interopRequireDefault(_pull);var _uniq=__webpack_require__(674);var _uniq2=_interopRequireDefault(_uniq);var _xor=__webpack_require__(675);var _xor2=_interopRequireDefault(_xor);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var LineMenuStore=(_class=function(){function LineMenuStore(store){var _this=this;_classCallCheck(this,LineMenuStore);this.store=null;this.status=0;_initDefineProp(this,'isLoadMenu',_descriptor,this);_initDefineProp(this,'sport',_descriptor2,this);_initDefineProp(this,'league',_descriptor3,this);_initDefineProp(this,'games',_descriptor4,this);_initDefineProp(this,'mode',_descriptor5,this);_initDefineProp(this,'other',_descriptor6,this);_initDefineProp(this,'sportOrder',_descriptor7,this);_initDefineProp(this,'selected',_descriptor8,this);_initDefineProp(this,'type',_descriptor9,this);_initDefineProp(this,'dict',_descriptor10,this);_initDefineProp(this,'isOpen',_descriptor11,this);_initDefineProp(this,'favourites',_descriptor12,this);this.refreshTimer=null;this.refreshVideoTimer=null;_initDefineProp(this,'popular',_descriptor13,this);_initDefineProp(this,'video',_descriptor14,this);this.favoriteMatch=(0,_mobx.action)(function(matchID,isFavourite){var id=Number(matchID);if(isFavourite&&_this.favourites.games.includes(id)){return;}isFavourite?_this.favourites.games.push(id):_this.favourites.games.splice(_this.favourites.games.indexOf(id),1);_this.saveFav();});this.favoriteChampionship=(0,_mobx.action)(function(championshipID,isFavourite){if(isFavourite&&_this.favourites.league.includes(championshipID)){return;}isFavourite?_this.favourites.league.push(championshipID):_this.favourites.league.splice(_this.favourites.league.indexOf(championshipID),1);_this.saveFav();});this.store=store;}_createClass(LineMenuStore,[{key:'init',value:function init(){this.mode=this.store.mode;this.loadMenu();// запрос ajax/video/get_list скрыт WEBDEV-16872
// if (this.mode === 'live') {
//   this.loadVideo();
//   this.refreshVideoTimer = setInterval(() => this.loadVideo(), 60000);
// }
}},{key:'despose',value:function despose(){clearInterval(this.refreshTimer);clearInterval(this.refreshVideoTimer);this.isLoadMenu=true;this.status=0;this.sport.clear();this.league.clear();this.games.clear();this.mode='';this.other=[];this.sportOrder=[];this.selected={games:[],sport:[],league:[],fav:false,popular:false,video:false};this.isOpen={favourites:false,popular:false,other:true,sport:[],league:[],video:false};this.favourites={games:[],sport:[],league:[],popular:{pop:[]}};this.popular={items:{},order:[],count:0};this.video={games:[],count:0};}},{key:'clearSelected',value:function clearSelected(){this.selected={games:[],sport:[],league:[],fav:false,popular:false,video:false};}},{key:'toggleOpenItem',value:function toggleOpenItem(id,type,lid){var _this2=this;switch(type){case 0:this.isOpen.favourites=!this.isOpen.favourites;break;case 1:if(this.isOpen.sport.indexOf(id)===-1){this.isOpen.sport.push(id);}else{(0,_pull2.default)(this.isOpen.sport,id);}break;case 2:if(Array.isArray(id)){if(this.mode==='line'){this.isOpen.sport=id.map(function(i){return _this2.league.get(i).sid;});}else{this.isOpen.sport=this.isOpen.sport.concat(id.map(function(i){return _this2.league.get(i).sid;}));}this.isOpen.league=id;}else{if(this.isOpen.league.indexOf(id)===-1){this.isOpen.league.push(id);}else{(0,_pull2.default)(this.isOpen.league,id);}}break;case 3:if(Array.isArray(id)){if(this.mode==='line'){this.isOpen.sport=id.map(function(i){return _this2.games.get(i).sid;});this.isOpen.league=id.map(function(i){return _this2.games.get(i).lid;});}else{this.isOpen.sport=this.isOpen.sport.concat(id.map(function(i){return _this2.games.get(i).sid;}));this.isOpen.league=this.isOpen.league.concat(id.map(function(i){return _this2.games.get(i).lid;}));}this.isOpen.games=id;}else{if(this.isOpen.sport.indexOf(id)===-1){this.isOpen.sport.push(id);}if(this.isOpen.league.indexOf(lid)===-1){this.isOpen.league.push(lid);}}break;case 4:this.isOpen.popular=!this.isOpen.popular;break;case 5:this.isOpen.other=id!==null?true:!this.isOpen.other;break;case 6:this.isOpen.video=!this.isOpen.video;break;default:this.isOpen={favourites:false,popular:false,other:true,video:false,sport:[],league:[]};break;}}},{key:'setSelect',value:function setSelect(id){if(this.games.get(id)){this.selected.games.push(id);this.toggleOpenItem(this.games.get(id).sid,3,this.games.get(id).lid);}}},{key:'selectOther',value:function selectOther(){this.toggleOpenItem(true,5);this.selectItem({sport:_mobx2.default.toJS(this.other)},1);}},{key:'handleSelect',value:function handleSelect(ids,type){switch(type){case 0:this.selected=_extends({},this.selected,{video:false,fav:ids,pop:false,sport:[],league:[],games:[]});this.toggleOpenItem(null,type);break;case 1:this.selected=_extends({},this.selected,{video:false,fav:false,pop:false,sport:ids,league:[],games:[]});this.toggleOpenItem(ids,type);break;case 2:this.selected=_extends({},this.selected,{video:false,fav:false,pop:false,sport:[],league:ids,games:[]});this.toggleOpenItem(ids,type);break;case 3:this.selected=_extends({},this.selected,{video:false,fav:false,pop:false,sport:[],league:[],games:ids});this.toggleOpenItem(ids,type);break;case 4:this.selected=_extends({},this.selected,{video:false,fav:false,pop:ids,sport:[],league:[],games:[]});this.toggleOpenItem(null,type);break;case 6:this.selected=_extends({},this.selected,{video:true,fav:false,pop:false,sport:[],league:[],games:[]});this.toggleOpenItem(null,6);break;}}},{key:'selectItem',value:function selectItem(id,type){var _this3=this;this.store.toggleSchedule(false);this.type=type?type:null;var sport=[];var league=[];var games=[];var popular_group=[];var video=false;switch(type){case 0:sport=_mobx2.default.toJS(this.favourites.sport);league=_mobx2.default.toJS(this.favourites.league);games=_mobx2.default.toJS(this.favourites.games);popular_group=_mobx2.default.toJS(this.favourites.popular.pop);this.handleSelect(true,type);break;case 1:if(Array.isArray(id.sport)){sport=id.sport;}else{sport.push(id);}this.handleSelect(sport,type);sport.forEach(function(el){if(_this3.sport.get(el)){league=league.concat(_mobx2.default.toJS(_this3.sport.get(el).league));}});league.forEach(function(el){games=games.concat(_mobx2.default.toJS(_this3.league.get(el).games));});break;case 2:if(Array.isArray(id.league)){league=id.league;}else{league.push(id);}this.handleSelect(league,type);league.forEach(function(el){if(_this3.league.get(el)){games=games.concat(_mobx2.default.toJS(_this3.league.get(el).games));sport.push(_this3.league.get(el).sid);}});break;case 3:if(Array.isArray(id.games)){games=id.games;}else{games.push(id);}this.handleSelect(games,type);games.forEach(function(el){if(_this3.games.get(el)){league.push(_this3.games.get(el).lid);sport.push(_this3.games.get(el).sid);}});break;case 4:Object.keys(this.popular.items).forEach(function(id){popular_group.push(id);_this3.handleSelect(true,type);});break;case 5:popular_group=[id];break;case 6:video=true;this.handleSelect(true,type);break;}this.store.line.selectItem({sport:(0,_uniq2.default)(sport),league:league,games:games,popular_group:popular_group,video:video},type);}},{key:'toggleFav',value:function toggleFav(id,type){var _this4=this;id=parseInt(id);switch(type){case 0:this.favourites.sport=[];this.favourites.league=[];this.favourites.games=[];this.favourites.popular={pop:[]};this.isOpen.favourites=false;break;case 1:if(this.favourites.sport.indexOf(id)!==-1){(0,_pull2.default)(this.favourites.sport,id);(0,_pullAll2.default)(this.favourites.league,this.sport.get(id).league);this.sport.get(id).league.forEach(function(i){return(0,_pullAll2.default)(_this4.favourites.games,_this4.league.get(i).games);});}else{this.favourites.sport.push(id);this.favourites.league=this.favourites.league.concat(this.sport.get(id).league);this.sport.get(id).league.forEach(function(i){return _this4.favourites.games=(0,_union2.default)(_this4.favourites.games,_this4.league.get(i).games);});}break;case 2:// чемпионат
if(this.favourites.league.indexOf(id)!==-1){(0,_pull2.default)(this.favourites.league,id);(0,_pullAll2.default)(this.favourites.games,this.league.get(id).games);}else{this.favourites.sport.push(this.league.get(id).sid);this.favourites.league.push(id);this.favourites.games=(0,_unionWith2.default)(this.favourites.games,this.league.get(id).games);}break;case 3:// матч
if(this.favourites.games.indexOf(id)!==-1){(0,_pull2.default)(this.favourites.sport,this.games.get(id).sid);(0,_pull2.default)(this.favourites.league,this.games.get(id).lid);(0,_pull2.default)(this.favourites.games,id);}else{this.favourites.games.push(id);}break;case 4:if(this.favourites.popular.pop.indexOf(id)!==-1){(0,_pull2.default)(this.favourites.popular.pop,id);}else{this.favourites.popular.pop.push(id);}break;default:break;}if(this.favourites.games.length===0&&this.favourites.popular.pop.length===0){this.selected.fav=false;_appStore2.default.history.push('/'+this.mode);}this.saveFav();}},{key:'getFav',value:function getFav(){var ls=JSON.parse(localStorage.getItem('favourites_'+this.mode));if(ls){var lineGames=this.games.keys();var lineLeague=this.league.keys();var lineSport=this.sport.keys();var games=(0,_intersectionWith2.default)(ls.games,lineGames,function(x,y){return x==y;});var league=(0,_intersectionWith2.default)(ls.league,lineLeague,function(x,y){return x==y;});var sport=(0,_intersectionWith2.default)(ls.sport,lineSport,function(x,y){return x==y;});var pop=(0,_intersectionWith2.default)(ls.popular.pop,this.popular.order,function(x,y){return x==y;});if(games.length){this.favourites.games=games;}if(league.length){this.favourites.league=league;}if(sport.length){this.favourites.sport=sport;}if(pop.length){this.favourites.popular.pop=pop;}}}},{key:'saveFav',value:function saveFav(){localStorage.setItem('favourites_'+this.mode,JSON.stringify(this.favourites));}},{key:'loadMenu',value:function loadMenu(){var _this5=this;_api2.default[this.mode+'Menu'].get({cashboxMode:_appStore2.default.cashboxMode}).then((0,_mobx.action)(function(data){if(data.result){_this5.dict=data.result.dict;_this5.addSport(data.result.sport);_this5.addLeague(data.result.league);_this5.addGame(data.result.games);if(_this5.mode==='line'){_this5.other=(0,_intersection2.default)(data.result.sort.sport,data.result.menu.other);var mainSports=data.result.sort.sport.filter(function(sport){return!data.result.menu.other.includes(sport);});if(data.result.order.length>0&&!!data.result.order.find(function(sport){return typeof sport==='string';})){mainSports.push(data.result.order[data.result.order.length-1]);}_this5.addOrder([].concat(_toConsumableArray(mainSports)));}else{_this5.addOrder(data.result.sort.sport);}_this5.refreshTimer=setInterval(function(){return _this5.refreshMenu();},_this5.mode==='live'?3000:60000000);if(_this5.mode==='line'&&data.result.popular)_this5.addPopular(data.result.popular);_this5.getFav();_this5.store.init2();_this5.status=1;}})).catch((0,_mobx.action)(function(err){// this.liveError = err.response && err.response.body && err.response.body.errors;
// throw err;
})).finally((0,_mobx.action)(function(){_this5.isLoadMenu=false;}));}},{key:'refreshMenu',value:function refreshMenu(){var _this6=this;_api2.default[this.mode+'Menu'].get({cashboxMode:_appStore2.default.cashboxMode}).then((0,_mobx.action)(function(data){if(data.result){_this6.dict=data.result.dict;_this6.addSport(data.result.sport);_this6.addLeague(data.result.league);_this6.addGame(data.result.games);if(_this6.mode==='line'){_this6.other=(0,_intersection2.default)(data.result.sort.sport,data.result.menu.other);var mainSports=data.result.sort.sport.filter(function(sport){return!data.result.menu.other.includes(sport);});if(data.result.order.length>0&&!!data.result.order.find(function(sport){return typeof sport==='string';})){mainSports.push(data.result.order[data.result.order.length-1]);}_this6.addOrder([].concat(_toConsumableArray(mainSports)));}else{_this6.addOrder(data.result.sort.sport);}if(_this6.mode==='line'&&data.result.popular)_this6.addPopular(data.result.popular);_this6.store.line.refreshSelected();}})).catch((0,_mobx.action)(function(err){// this.liveError = err.response && err.response.body && err.response.body.errors;
// throw err;
}));}},{key:'addSport',value:function addSport(sport){var s=void 0;if(sport){for(var item in sport){if(this.sport.has(item)){s=(0,_xor2.default)(_mobx2.default.toJS(this.sport.get(item).league),sport[item].league);if(s.length>0){this.sport.get(item).league=sport[item].league;}}else{sport[item]['name']=this.dict.sport[item];this.sport.set(item,sport[item]);}}}else{this.sportOrder=[];this.sport.clear();}}},{key:'addLeague',value:function addLeague(league){var l=void 0;if(league){for(var item in league){if(this.league.has(item)){l=(0,_xor2.default)(_mobx2.default.toJS(this.league.get(item).games),league[item].games);if(l.length>0){this.league.get(item).games=league[item].games;}}else{league[item]['name']=this.dict.league[item];this.league.set(item,league[item]);}}}}},{key:'addGame',value:function addGame(games){// let idx;
if(games){for(var item in games){if(!this.games.has(item)){games[item]['c1']=this.dict.cmd[games[item].c1_id];if(games[item].c2_id)games[item]['c2']=this.dict.cmd[games[item].c2_id];this.games.set(item,games[item]);}}}else{this.games.clear();}}},{key:'refreshFavoriteGames',value:function refreshFavoriteGames(){var _this7=this;this.favourites.games=this.favourites.games.map(function(item){if(_this7.games.has(item))return item;});}},{key:'addOrder',value:function addOrder(order){if((0,_xor2.default)(order,_mobx2.default.toJS(this.sportOrder)).length>0){this.sportOrder=order;}}},{key:'addPopular',value:function addPopular(popular){var count=0;for(var i in popular.data){count+=popular.data[i].games_count;}this.popular.items=popular.data;this.popular.order=popular.order;this.popular.count=count;this.dict['popular']=popular.dict.popular;}},{key:'loadVideo',value:function loadVideo(){var _this8=this;_api2.default.liveMenu.getVideo().then((0,_mobx.action)(function(data){if(data.result){_this8.video.games=data.result.games;_this8.video.dict=data.result.dict;_this8.video.count=data.result.count;}}));}},{key:'countFav',get:function get(){var _this9=this;var count=0;this.favourites.popular.pop.forEach(function(i){count+=_this9.popular.items[i].games_count;});return this.favourites.games.length+count;}},{key:'countOther',get:function get(){this.other();}}]);return LineMenuStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isLoadMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'sport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'league',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'games',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'mode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'other',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'sportOrder',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'selected',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{sport:[],league:[],gmaes:[],fav:false,popular:false,video:false};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'type',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'isOpen',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{favourites:false,popular:false,other:true,video:false,sport:[],league:[]};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'favourites',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{games:[],sport:[],league:[],popular:{pop:[]}};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'popular',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{items:{},order:[],count:0};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'video',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{games:[],count:0};}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'toggleOpenItem',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'toggleOpenItem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setSelect',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setSelect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectOther',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectOther'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectItem',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectItem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'toggleFav',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'toggleFav'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'countFav',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'countFav'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getFav',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getFav'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saveFav',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'saveFav'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadMenu',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refreshMenu',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'refreshMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addSport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addLeague',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addLeague'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addGame',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addGame'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refreshFavoriteGames',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'refreshFavoriteGames'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addOrder',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addOrder'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addPopular',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addPopular'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'countOther',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'countOther'),_class.prototype)),_class);exports.default=LineMenuStore;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(44),
    baseIntersection = __webpack_require__(211),
    baseRest = __webpack_require__(46),
    castArrayLikeObject = __webpack_require__(213),
    last = __webpack_require__(215);

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

module.exports = intersectionWith;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(121),
    baseRest = __webpack_require__(46),
    baseUniq = __webpack_require__(75),
    isArrayLikeObject = __webpack_require__(74),
    last = __webpack_require__(215);

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    isArguments = __webpack_require__(101),
    isArray = __webpack_require__(21);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(190),
    noop = __webpack_require__(668),
    setToArray = __webpack_require__(106);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(44),
    baseIndexOf = __webpack_require__(212),
    baseIndexOfWith = __webpack_require__(670),
    baseUnary = __webpack_require__(65),
    copyArray = __webpack_require__(671);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(121),
    baseRest = __webpack_require__(46),
    baseUniq = __webpack_require__(75),
    isArrayLikeObject = __webpack_require__(74);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(46),
    pullAll = __webpack_require__(216);

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(75);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(189),
    baseRest = __webpack_require__(46),
    baseXor = __webpack_require__(676),
    isArrayLikeObject = __webpack_require__(74);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(677),
    baseFlatten = __webpack_require__(121),
    baseUniq = __webpack_require__(75);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(70),
    arrayIncludes = __webpack_require__(119),
    arrayIncludesWith = __webpack_require__(120),
    arrayMap = __webpack_require__(44),
    baseUnary = __webpack_require__(65),
    cacheHas = __webpack_require__(71);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import lineStore from './line';
var Schedule=(_class=function(){function Schedule(store){_classCallCheck(this,Schedule);this.store=null;this.LS_KEY='live_schedule_menu';_initDefineProp(this,'status',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);_initDefineProp(this,'dict',_descriptor3,this);_initDefineProp(this,'league',_descriptor4,this);_initDefineProp(this,'menu',_descriptor5,this);_initDefineProp(this,'schedule',_descriptor6,this);_initDefineProp(this,'sort',_descriptor7,this);_initDefineProp(this,'sport',_descriptor8,this);_initDefineProp(this,'timeline',_descriptor9,this);_initDefineProp(this,'order',_descriptor10,this);_initDefineProp(this,'select',_descriptor11,this);_initDefineProp(this,'result',_descriptor12,this);this.store=store;}_createClass(Schedule,[{key:'despose',value:function despose(){this.status=false;this.isLoading=true;this.dict={};this.league={};this.menu={};this.schedule={};this.sort={};this.sport={};this.timeline=[];this.clearResult();}},{key:'init',value:function init(){this.status=true;if(!Object.keys(this.schedule).length){this.getData();}var ls=JSON.parse(localStorage.getItem(this.LS_KEY));if(ls){this.select=_extends({},this.select,{sort:ls.sort,time:ls.time,sport:ls.sport,allSport:ls.allSport});}}},{key:'setResult',value:function setResult(text,type){this.result.status=1,this.result.text=text,this.result.type=type?type:0;}},{key:'clearResult',value:function clearResult(){this.result.status=0,this.result.text='',this.result.type=0;}},{key:'getData',value:function getData(){var _this=this;return _api2.default[this.store.mode].getSchedule().then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.dict=data.result.dict?data.result.dict:{};_this.league=data.result.league?data.result.league:{};_this.menu=data.result.menu?data.result.menu:{};_this.schedule=data.result.schedule?data.result.schedule:{};_this.sort=data.result.sort?data.result.sort:{};_this.sport=data.result.sport?data.result.sport:{};_this.timeline=data.result.timeline?data.result.timeline:[];if(!_this.select.sport.length){_this.selectSport(1);}else{_this.print();}}else{_this.setResult(data.text?data.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=false;}));}},{key:'safeLs',value:function safeLs(){localStorage.setItem(this.LS_KEY,JSON.stringify(this.select));}},{key:'selectSport',value:function selectSport(type,id){switch(type){case 1:this.select.allSport=!this.select.allSport;if(this.select.allSport&&this.menu.order){this.select.sport=_mobx2.default.toJS(this.menu.order);}else{this.select.sport=[];}break;case 2:var idx=this.select.sport.indexOf(id);if(idx==-1){this.select.sport.push(id);_lodash2.default.xor(this.select.sport.peek(),_mobx2.default.toJS(this.menu.order)).length==0?this.select.allSport=1:null;}else{this.select.sport.splice(idx,1);this.select.allSport=0;}break;}this.print();this.safeLs();}},{key:'setTime',value:function setTime(time){if(this.select.time!==time){this.select.time=time;}this.print();this.safeLs();}},{key:'setSort',value:function setSort(sort){this.select.sort=sort;this.print();this.safeLs();}},{key:'checkTime',value:function checkTime(time){var date=void 0,days_between=void 0,time_date=void 0,cur_date=new Date(),cur_time=cur_date.getTime(),check=1,timeline=this.select.time;time=parseInt(time);date=new Date(time);if(time<cur_time){check=0;}if(timeline>=86400){days_between=timeline/86400-1;time_date=new Date(cur_time+86400000*days_between);if(date.getMonth()!=time_date.getMonth()){check=0;}if(date.getDate()!=time_date.getDate()){check=0;}}else if(timeline>0&&(time-cur_time)/1000>timeline){check=0;}return check;}},{key:'print',value:function print(){var i=void 0,time=void 0,sid=void 0,lid=void 0,sch_id=void 0,sid_lid=void 0,game=void 0;this.order=[];if(!Object.keys(this.schedule).length){return;}if(this.select.sort=='time'){for(time in this.sort.time){time=parseInt(time);if(this.checkTime(time*1000)==0){continue;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.sort.time[time][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){sch_id=_step.value;game=this.schedule[sch_id];if(!game){continue;}sid=game.sid;if(this.checkSport(sid)==0){continue;}this.order.push(sch_id);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}else if(this.select.sort=='abc'){var j=void 0,k=void 0;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=this.sort.alphabet.sport[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){sid=_step2.value;if(this.checkSport(sid)==0){continue;}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=this.sort.alphabet.league[sid][Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){lid=_step3.value;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=this.sort.alphabet.schedule[sid][lid][Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){sch_id=_step4.value;time=this.schedule[sch_id].time;time=parseInt(time);if(this.checkTime(time*1000)==0){continue;}this.order.push(sch_id);}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}// return order;
// this.show();
// this.saveToLs();
}},{key:'checkSport',value:function checkSport(sid){sid=parseInt(sid);var is_other=this.menu.other.indexOf(sid)!=-1&&this.select.sport.indexOf('other')!=-1;var is_main=this.select.sport.indexOf(sid)!=-1;return is_main||is_other;}}]);return Schedule;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'status',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'league',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'menu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'schedule',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'sort',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'sport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'timeline',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'order',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'select',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{sort:'time',// сортировка по времени 'time' или алфавиту 'abc' 
time:0,// сортировка по времени 7200 - показываь за 2 часа
sport:[],//выбранные виды спорта, по умолчанию все,
allSport:0};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_applyDecoratedDescriptor(_class.prototype,'despose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'despose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectSport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTime',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setTime'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setSort',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setSort'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkTime',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkTime'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkSport'),_class.prototype)),_class);exports.default=Schedule;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultStore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _results=__webpack_require__(680);var _results2=_interopRequireDefault(_results);var _menu=__webpack_require__(681);var _menu2=_interopRequireDefault(_menu);var _store=__webpack_require__(118);var _store2=_interopRequireDefault(_store);var _ResultsLive=__webpack_require__(682);var _config=__webpack_require__(217);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ResultStore=exports.ResultStore=(_class=function(){function ResultStore(){_classCallCheck(this,ResultStore);_initDefineProp(this,'isLoading',_descriptor,this);_initDefineProp(this,'menu',_descriptor2,this);_initDefineProp(this,'results',_descriptor3,this);_initDefineProp(this,'mode',_descriptor4,this);_initDefineProp(this,'cashboxId',_descriptor5,this);_initDefineProp(this,'result',_descriptor6,this);this.initResultsLiveWSS();}_createClass(ResultStore,[{key:'initResultsLiveWSS',value:function initResultsLiveWSS(){var siteType=_config.SITE_TYPE.IRM_CUPIS;var webSocketURL=_store2.default.url,getSocket=_store2.default.getSocket;this.liveResults=new _ResultsLive.ResultsLive({webSocketURL:webSocketURL,getSocket:getSocket,siteType:siteType,lng:1049});}},{key:'setError',value:function setError(text,type){this.result.status=1;this.result.text=text;this.result.type=type?type:0;}},{key:'clearError',value:function clearError(){this.result.status=0;this.result.text='';this.result.type=0;}},{key:'init',value:function init(mode){this.reset();this.mode=mode;this.getData();}},{key:'reset',value:function reset(){this.isLoading=0;this.mode='';// this.menu = '';
// this.results = '';
this.clearError();}},{key:'setCashboxModeId',value:function setCashboxModeId(id){if(!id||this.cashboxId==id){return;}this.cashboxId=id;this.initResultsLiveWSS();}},{key:'getData',value:function getData(){var _this=this;_api2.default[this.mode+'Results'].getFilter().then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.menu=new _menu2.default(_this,data.result);_this.results=new _results2.default(_this);}else{_this.setError(data.text?data.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setError('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=1;}));}}]);return ResultStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'menu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'results',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'mode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'cashboxId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 2;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_applyDecoratedDescriptor(_class.prototype,'setError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearError',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setCashboxModeId',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setCashboxModeId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype)),_class);exports.default=new ResultStore();

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _dictStore=__webpack_require__(54);var _dictStore2=_interopRequireDefault(_dictStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Results=(_class=function(){function Results(store,data){_classCallCheck(this,Results);_initDefineProp(this,'isLoading',_descriptor,this);_initDefineProp(this,'sport',_descriptor2,this);_initDefineProp(this,'league',_descriptor3,this);_initDefineProp(this,'games',_descriptor4,this);_initDefineProp(this,'noResultSport',_descriptor5,this);_initDefineProp(this,'order',_descriptor6,this);_initDefineProp(this,'dict',_descriptor7,this);_initDefineProp(this,'cancel',_descriptor8,this);this.store=null;this.store=store;}_createClass(Results,[{key:'loadResult',value:function loadResult(data){var _this=this;this.store.clearError();if(data){this.isLoading=1;this.clear();_api2.default[this.store.mode+'Results'].getResults(data).then((0,_mobx.action)(function(data){if(Object.keys(data.result.league).length===0){return _this.store.setError('NO_RESULTS',1);}if(data.code==0&&data.result){if(data.result.games.length!=0){if(data.result.cancel)_this.cancel=data.result.cancel;_this.dict=data.result.dict||{};_this.addSport(data.result.sport);_this.addLeague(data.result.league);_this.addGames(data.result.games,data.result.ross,data.result.refund);}else{_this.store.setError('NO_RESULTS',1);}}else{_this.store.setError(data.text?data.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.store.setError('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=0;}));}}},{key:'addSport',value:function addSport(sport){var _this2=this;Object.values(sport).forEach(function(sid){if(_this2.dict.sport){sid.sport_name=_this2.dict.sport[sid.id];}_this2.sport.set(sid.id,sid);});}},{key:'addLeague',value:function addLeague(league){var _this3=this;Object.values(league).forEach(function(lid){if(_this3.dict.league){lid.league_name=_this3.dict.league[lid.id];}lid.sid=lid.sport_id;delete lid.sport_id;_this3.league.set(lid.id,lid);});}},{key:'addGames',value:function addGames(games,ross,refund){var _this4=this;Object.values(games).forEach(function(gid){if(_this4.dict.cmd){gid.name=(_this4.dict.cmd[gid.c1_id]?_this4.dict.cmd[gid.c1_id]:'')+' '+(!_this4.dict.cmd[gid.c1_id]||!_this4.dict.cmd[gid.c2_id]?'':'-')+' '+(_this4.dict.cmd[gid.c2_id]?_this4.dict.cmd[gid.c2_id]:'');}else{gid.name=(gid.team_1_name?gid.team_1_name:'')+' '+(!gid.team_1_name||!gid.team_2_name?'':'-')+' '+(gid.team_2_name?gid.team_2_name:'');}if(ross&&ross[gid.id]){gid.dopBets=ross[gid.id];}if(refund&&refund[gid.id]){gid.refund=refund[gid.id];}gid.sid=gid.sport_id;delete gid.sport_id;_this4.games.set(gid.id,gid);});}},{key:'clear',value:function clear(){this.sport.clear();this.league.clear();this.games.clear();}},{key:'printNoResults',value:function printNoResults(other){var _this5=this;this.noResultSport=[];this.store.menu.selectedSports.forEach(function(item){if(!_this5.sport.has(item)){_this5.noResultSport.push(_this5.store.menu.dict.sport[item]);}if(other.length!==0&&item=='other'){_this5.noResultSport.push(_dictStore2.default.getLang('OTHER'));}});}}]);return Results;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'sport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'league',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'games',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'noResultSport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'order',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'cancel',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'loadResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addSport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addLeague',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addLeague'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addGames',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addGames'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype)),_class);exports.default=Results;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _lodash=__webpack_require__(10);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(34);var _moment2=_interopRequireDefault(_moment);var _jsCookie=__webpack_require__(32);var _jsCookie2=_interopRequireDefault(_jsCookie);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _common=__webpack_require__(6);var _dictStore=__webpack_require__(54);var _dictStore2=_interopRequireDefault(_dictStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TODAY_ID=0;var YESTERDAY_ID=1;var TWO_DAYS=2;var ANY_DATE=3;var SEC=1000;var MIN=60*SEC;var HOUR=60*MIN;var DAY=24*HOUR;var Menu=(_class=function(){function Menu(store,data){_classCallCheck(this,Menu);_initDefineProp(this,'dict',_descriptor,this);_initDefineProp(this,'filter',_descriptor2,this);_initDefineProp(this,'type',_descriptor3,this);_initDefineProp(this,'resultDate',_descriptor4,this);_initDefineProp(this,'mainScore',_descriptor5,this);_initDefineProp(this,'selectedSports',_descriptor6,this);_initDefineProp(this,'selectedAll',_descriptor7,this);_initDefineProp(this,'menu',_descriptor8,this);_initDefineProp(this,'date_3',_descriptor9,this);this.date=null;_initDefineProp(this,'label',_descriptor10,this);this.store=store;this.dict=data.dict;this.menu=data.menu;if(this.store.mode=='line'){this.filter=data.filter;this.getDate(this.resultDate);this.setLabel(this.filter.date[0]);}}_createClass(Menu,[{key:'setType',value:function setType(type){if(this.type!=type){this.type=type;this.loadResult();}}},{key:'setLabel',value:function setLabel(label){this.label=label;}},{key:'setDate',value:function setDate(id,date){if(this.resultDate!=id||id==3){this.resultDate=id;this.getDate(id,date);this.loadResult();}}},{key:'setMainScore',value:function setMainScore(){this.mainScore=this.mainScore?0:1;this.loadResult();}},{key:'getDisabled',value:function getDisabled(id){if(this.store.mode=='live'){if(id!=='other'&&this.menu.current.indexOf(parseInt(id))===-1)return true;if(id=='other'&&this.menu.other.length===0)return true;}return false;}},{key:'getDict',value:function getDict(id){if(id=='other'){return _dictStore2.default.getLang('OTHER');}return this.dict.sport[id];}},{key:'selectAll',value:function selectAll(){this.selectedAll=!this.selectedAll;this.selectedSports=[];this.loadResult();}},{key:'selectSport',value:function selectSport(id){this.selectedAll=false;var idx=this.selectedSports.indexOf(id);idx===-1?this.selectedSports.push(id):this.selectedSports.splice(idx,1);this.loadResult();}},{key:'getDate',value:function getDate(date_id,date){var today=new Date(),date_from='',date_to='';if(date_id===TODAY_ID){date_from=today.getFullYear()+'-'+(today.getMonth()+1).toString()+'-'+today.getDate();date_to=date_from;this.setLabel(this.filter.date[date_id]);}else if(date_id===YESTERDAY_ID){var yesterday=new Date(today.getTime()-DAY);date_from=yesterday.getFullYear()+'-'+(yesterday.getMonth()+1).toString()+'-'+yesterday.getDate();date_to=date_from;this.setLabel(this.filter.date[date_id]);}else if(date_id===TWO_DAYS){var yesterday2=new Date(today.getTime()-DAY);date_from=yesterday2.getFullYear()+'-'+(yesterday2.getMonth()+1).toString()+'-'+yesterday2.getDate();date_to=today.getFullYear()+'-'+(today.getMonth()+1).toString()+'-'+today.getDate();this.setLabel(this.filter.date[date_id]);}else if(date_id===ANY_DATE){date_from=(0,_moment2.default)(date).format('YYYY-MM-DD');date_to=date_from;this.setLabel((0,_common.dateTextFormat2)(date));}this.date={from:date_from,to:date_to};}},{key:'clear',value:function clear(){this.selectedSports=[];this.selectedAll=0;}},{key:'loadResult',value:function loadResult(){var _this=this;if(this.selectedSports.length===0&&!this.selectedAll){this.store.setError('SELECT_SPORT');this.store.results.clear();return false;}var data={};var sport=[];if(this.store.mode=='live'){this.selectedSports.forEach(function(item){if(!_this.getDisabled(item)){if(item=='other'){sport=sport.concat(_this.menu.other.peek());}else{sport.push(item);}}});if(sport.length===0){this.store.setError('SELECT_SPORT');this.store.results.clear();return false;}}if(this.store.mode=='line'){data.timezone_id=+_jsCookie2.default.get('timezone')||3;data.is_live=this.type;data.main_score=this.mainScore;data.date_from=(0,_mobx.toJS)(this.date.from);data.date_to=(0,_mobx.toJS)(this.date.to);data.site_type=this.store.cashboxId==2?1:0;data.language_id=1049;if(this.type===1){if(this.selectedAll){data.sports=Object.keys(this.menu.comparison);}else{data.sports=(0,_mobx.toJS)(this.selectedSports);}}else if(this.selectedAll){data.sports=(0,_mobx.toJS)(this.menu.order);}else{data.sports=this.selectedSports.peek();}}else if(this.store.mode=='live'){data.sports=sport;}if((0,_mobx.toJS)(this.selectedSports).includes('other')){data.include_other=1;}else data.include_other=0;data.sports=data.sports.filter(function(item){return item!=='other';});this.store.results.loadResult(data);}}]);return Menu;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'filter',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'type',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'resultDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'mainScore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'selectedSports',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'selectedAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'menu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'date_3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'label',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'setType',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setLabel',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setLabel'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDate',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDate'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setMainScore',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setMainScore'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getDisabled',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getDisabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getDict',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getDict'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectAll',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectAll'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectSport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectSport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'loadResult'),_class.prototype)),_class);exports.default=Menu;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsLive=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Menu=__webpack_require__(143);var _Tables=__webpack_require__(683);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ResultsLive=exports.ResultsLive=function(){function ResultsLive(cfg){_classCallCheck(this,ResultsLive);this.tables=new _Tables.ResultsTables(cfg);this.menu=new _Menu.ResultsMenu(cfg);}_createClass(ResultsLive,[{key:'clear',value:function clear(){this.menu.clear();this.tables.clear();}/**
     * Подписка на обновления таблицы live доп.исходов через WS
     */},{key:'listenWS',value:function listenWS(){var cfg=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.menu.listenWS(cfg);}},{key:'stopListenWS',value:function stopListenWS(){this.menu.stopListenWS();this.tables.stopListenWS();}}],[{key:'getInstance',value:function getInstance(cfg){if(this.instance){return this.instance;}this.instance=new ResultsLive(cfg);return this.instance;}}]);return ResultsLive;}();

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsTables=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Subscribtion2=__webpack_require__(20);var _Subscribtion3=_interopRequireDefault(_Subscribtion2);var _logger=__webpack_require__(33);var _logger2=_interopRequireDefault(_logger);var _base=__webpack_require__(4);var _Tables=__webpack_require__(684);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** Т.к результаты singleton, используем константный ID */var subscriptionID=0;var ResultsTables=exports.ResultsTables=function(_Subscribtion){_inherits(ResultsTables,_Subscribtion);function ResultsTables(_ref){var siteType=_ref.siteType,lng=_ref.lng;_classCallCheck(this,ResultsTables);var _this=_possibleConstructorReturn(this,(ResultsTables.__proto__||Object.getPrototypeOf(ResultsTables)).call(this));_this.sports=[];_this.update=_this.update.bind(_this);_this.wsListener=new _Tables.ResultsLiveTablesListener({site:siteType||_base.SITE_TYPE.COM,lng:lng});return _this;}_createClass(ResultsTables,[{key:'getData',value:function getData(){if(this.sports.length===0){return null;}return this.sports;}},{key:'clear',value:function clear(){this.sports=[];}//#region WS
/**
    * Подписка на обновления таблицы live доп.исходов через WS
    */},{key:'listenWS',value:function listenWS(cfg){if(cfg.language){this.wsListener.setLanguage(cfg.language);}var logger=_logger2.default.getInstance();var onerror=function onerror(e){logger.error(e);// this.stopListenWS();
};var onopen=function onopen(){// logger.log('[WResultsTables] Соединение открыто');
};var onmessage=this.update;this.wsListener.subscribe(Object.assign(Object.assign({},cfg),{subscriptionID:subscriptionID,onmessage:onmessage,onerror:onerror,onopen:onopen}));}},{key:'update',value:function update(data){if('changedScores'in data){this.updateScore(data);return;}this.sports=data.sports;this.notify();}},{key:'updateScore',value:function updateScore(_ref2){var changedScores=_ref2.changedScores;this.sports.forEach(function(_ref3){var championships=_ref3.championships;championships.forEach(function(_ref4){var matches=_ref4.matches;matches.filter(function(_ref5){var id=_ref5.id;return id in changedScores;}).forEach(function(match){match.score=changedScores[match.id];});});});this.notify();}},{key:'stopListenWS',value:function stopListenWS(){this.wsListener.unsubscribe({subscriptionID:subscriptionID});}}]);return ResultsTables;}(_Subscribtion3.default);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResultsLiveTablesListener=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _base=__webpack_require__(4);var _BaseSocketConnector2=__webpack_require__(11);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResultsLiveTablesListener=exports.ResultsLiveTablesListener=function(_BaseSocketConnector){_inherits(ResultsLiveTablesListener,_BaseSocketConnector);function ResultsLiveTablesListener(){_classCallCheck(this,ResultsLiveTablesListener);var _this=_possibleConstructorReturn(this,(ResultsLiveTablesListener.__proto__||Object.getPrototypeOf(ResultsLiveTablesListener)).apply(this,arguments));_this.dataTypeCode=_base.DATA_TYPE_CODE.LIVE_RESULTS;return _this;}_createClass(ResultsLiveTablesListener,[{key:'getOutcomeData',value:function getOutcomeData(cfg){return Object.assign(Object.assign({},cfg),{timezone:this.timezone,site:this.siteType,lng:this.language});}}]);return ResultsLiveTablesListener;}(_BaseSocketConnector2.BaseSocketConnector);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.financeStore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_desc2,_value2,_class3,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;// import _ from 'lodash';
var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var financeStore=exports.financeStore=(_class=function(){function financeStore(){_classCallCheck(this,financeStore);_initDefineProp(this,'payout',_descriptor,this);_initDefineProp(this,'deposit',_descriptor2,this);}_createClass(financeStore,[{key:'init',value:function init(type){if(type=='payout'){this.payout=new payout(this);}else if(type=='deposit'){this.deposit=new deposit(this);}}},{key:'clear',value:function clear(type){if(type){this[type]=null;}else{this.payout=null;this.deposit=null;}}}]);return financeStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'payout',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'deposit',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype)),_class);exports.default=new financeStore();var payout=(_class3=function(){function payout(store){_classCallCheck(this,payout);_initDefineProp(this,'store',_descriptor3,this);_initDefineProp(this,'isLoading',_descriptor4,this);_initDefineProp(this,'data',_descriptor5,this);_initDefineProp(this,'amount',_descriptor6,this);_initDefineProp(this,'noty',_descriptor7,this);_initDefineProp(this,'editStatus',_descriptor8,this);_initDefineProp(this,'wait',_descriptor9,this);_initDefineProp(this,'result',_descriptor10,this);this.store=store;this.getData();}_createClass(payout,[{key:'setResult',value:function setResult(text){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.result.status=1;this.result.text=text;this.result.type=type;}},{key:'clear',value:function clear(){this.result.status=0;this.result.text='';this.result.type=0;}},{key:'inputAmount',value:function inputAmount(val){console.log(val.replace(/[^\,\d]+/g,""));var number=val.replace(/[^\.\d]+/g,"").replace(/^([^\.]*\.)|\./g,'$1');this.clear();if(number.toString().length>0){this.amount=number;}else{this.amount='';}}},{key:'getData',value:function getData(){var _this=this;return _api2.default.finance.getPayout().then((0,_mobx.action)(function(res){if(typeof res.result!=='undefined'){if(res.result==4){_this.noty=1;}else{_this.data=res.result;}}else{_this.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.isLoading=false;}));}},{key:'create',value:function create(){var _this2=this;this.wait=true;this.clear();return _api2.default.finance.createPayout({amount:this.amount}).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this2.editStatus=false;if(res.result==4){_this2.noty=1;_this2.data='';}else{_this2.data=res.result;_this2.setResult(res.text,1);}}else{_this2.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this2.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this2.wait=false;}));}},{key:'cancel',value:function cancel(){var _this3=this;this.clear();return _api2.default.finance.cancelPayout({payment_id:this.data.id}).then((0,_mobx.action)(function(res){if(res.code=='OK'){_this3.setResult(res.text,1);_this3.amount='';_this3.editStatus=false;_this3.data='';}else{_this3.setResult(res.text?res.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this3.setResult('SERVER_TEMPORARILY_DOWN');}));}},{key:'edit',value:function edit(){var _this4=this;return _api2.default.finance.checkPayout().then((0,_mobx.action)(function(res){if(res.code=='OK'){_this4.editStatus=true;_this4.amount=_this4.data.amount;}else{_this4.setResult('CANCEL_PAYMENT_ERROR_1');_this4.amount='';_this4.editStatus=false;_this4.data='';}})).catch((0,_mobx.action)(function(err){_this4.setResult('SERVER_TEMPORARILY_DOWN');}));}}]);return payout;}(),(_descriptor3=_applyDecoratedDescriptor(_class3.prototype,'store',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class3.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class3.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class3.prototype,'amount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor7=_applyDecoratedDescriptor(_class3.prototype,'noty',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class3.prototype,'editStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class3.prototype,'wait',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class3.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_applyDecoratedDescriptor(_class3.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'setResult'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'clear',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'clear'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'inputAmount',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'inputAmount'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'getData'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'create',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'create'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'cancel',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'cancel'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'edit',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'edit'),_class3.prototype)),_class3);var deposit=function deposit(){_classCallCheck(this,deposit);};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchBox=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;var _mobx=__webpack_require__(5);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SearchBox=exports.SearchBox=(_class=function(){function SearchBox(){_classCallCheck(this,SearchBox);this.DELAY=200;this.CURSE=['хуй','бля','пидор'];_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'result',_descriptor2,this);_initDefineProp(this,'more',_descriptor3,this);_initDefineProp(this,'str',_descriptor4,this);_initDefineProp(this,'resultShow',_descriptor5,this);_initDefineProp(this,'loading',_descriptor6,this);_initDefineProp(this,'showClear',_descriptor7,this);_initDefineProp(this,'showCurse',_descriptor8,this);this.delayTimeout=null;_initDefineProp(this,'keyIndex',_descriptor9,this);}_createClass(SearchBox,[{key:'changeInput',// constructor() {
//  autorun(() => {
//   })
// }
value:function changeInput(str){var _this=this;var v=str;if(this.str===v)return;this.str=v;clearTimeout(this.delayTimeout);if(v.length&&v.length>=2){this.delayTimeout=setTimeout(function(){_this.load();},this.DELAY);}else if(!v.length||v.length&&v.length<2){this.data=[];this.changeResultShowState(false);}this.checkCurse();this._changeFillTypeState(!!v.length);}},{key:'_changeFillTypeState',value:function _changeFillTypeState(state){if(this.showClear===state)return;this.showClear=state;}},{key:'checkCurse',value:function checkCurse(){if(this.data.length===0&&this.CURSE.indexOf(this.str.toLowerCase())!==-1){this.showCurse=true;this.changeResultShowState(true);}else if(!this.more){// this.changeResultShowState(false);
this.showCurse=false;}}},{key:'changeResultShowState',value:function changeResultShowState(state){if(this.resultShow===state)return;if(!state){this.keyIndex=0;}this.resultShow=state;}},{key:'changeKeyIndex',value:function changeKeyIndex(index){this.keyIndex=index;}},{key:'load',value:function load(){var _this2=this;this.loading=true;return _api2.default.search.get(this.str).then((0,_mobx.action)(function(data){_this2.data=data.result;_this2.more=data.more;_this2.printResult();})).catch((0,_mobx.action)(function(err){})).finally((0,_mobx.action)(function(){_this2.loading=false;}));}},{key:'printResult',value:function printResult(){if(this.data.length>0){this.changeResultShowState(true);}// data = data ? data : this.data;
// more = more ? more : this.more;
// var html = '';
// var classExtend;
// var counter = 0;
// this.keyIndex = 0;
// for (var i in data) {
//     classExtend = '';
//     if (data[i].cursor.begin !== false) {
//         data[i].name = data[i].name.substr(0, data[i].cursor.begin)
//                 + '<span class="cursor">'
//                 + data[i].name.substr(data[i].cursor.begin, data[i].cursor.length)
//                 + '</span>'
//                 + data[i].name.substr(data[i].cursor.end, data[i].name.length - data[i].cursor.end);
//     }
//     if (i == this.keyIndex) {
//         classExtend += ' selected';
//     }
//     if (data[i].type == 4) {
//         classExtend += ' game';
//     }
//     var pre_name = '';
//     var icon = '';
//     if (data[i].live && data[i].type === 4) {
//         pre_name = '<span class="live f-s-ico-live"></span>';
//     } else if (data[i].date && data[i].type === 4) {
//         pre_name = '<span class="date">' + data[i].date + '</span>';
//     }
//     if (!data[i].live) {
//         icon = '<span class="icon-sport f-s-ico-' + data[i].sid + '"></span>';
//     }
//     html += '<a href="' + data[i].url + '" class="item' + classExtend + '">' + icon + pre_name + '<span class="name">' + data[i].name + '</span>' + '</a>';
//     counter++;
// }
// if (more) {
//     removeClass(this.Dom.loadMore, 'hidden');
//     this.Dom.loadMore.innerHTML = '<span>Найдено ещё ' + more + ' ' + this.declOfNum(more, ['событие', 'события', 'событий']) + '. Уточните поиск</span>';
// } else {
//     addClass(this.Dom.loadMore, 'hidden');
// }
// var showCurse = false;
// if (counter === 0 && this.curse.indexOf(this.value.toLowerCase()) !== -1) {
//     removeClass(this.Dom.loadMore, 'hidden');
//     this.Dom.loadMore.innerHTML = '<span>Мы вас любим. Уточните поиск</span>';
//     showCurse = true;
// } else if (!more) {
//     addClass(this.Dom.loadMore, 'hidden');
// }
// this.Dom.wrapperResultInner.innerHTML = html;
// this._changeRes
}}]);return SearchBox;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'more',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'str',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'resultShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'showClear',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'showCurse',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'keyIndex',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'changeInput',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'changeInput'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeResultShowState',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'changeResultShowState'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeKeyIndex',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'changeKeyIndex'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'load',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'load'),_class.prototype)),_class);exports.default=new SearchBox();

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TotoStore=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);var _toto=__webpack_require__(688);var _toto2=_interopRequireDefault(_toto);var _bet=__webpack_require__(689);var _bet2=_interopRequireDefault(_bet);var _result=__webpack_require__(690);var _result2=_interopRequireDefault(_result);var _cards=__webpack_require__(691);var _cards2=_interopRequireDefault(_cards);var _previous=__webpack_require__(692);var _previous2=_interopRequireDefault(_previous);var _cardsall=__webpack_require__(693);var _cardsall2=_interopRequireDefault(_cardsall);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TotoStore=exports.TotoStore=(_class=function(){function TotoStore(){var _this=this;_classCallCheck(this,TotoStore);_initDefineProp(this,'isLoading',_descriptor,this);_initDefineProp(this,'currencyId',_descriptor2,this);_initDefineProp(this,'currency',_descriptor3,this);_initDefineProp(this,'result',_descriptor4,this);_initDefineProp(this,'Toto',_descriptor5,this);_initDefineProp(this,'Bet',_descriptor6,this);_initDefineProp(this,'Result',_descriptor7,this);_initDefineProp(this,'Cards',_descriptor8,this);_initDefineProp(this,'Previous',_descriptor9,this);_initDefineProp(this,'Cardsall',_descriptor10,this);this.Toto=new _toto2.default(this,_accountStore2.default,_appStore2.default);this.Bet=new _bet2.default(this);this.Result=new _result2.default(this);this.Cards=new _cards2.default(this);this.Previous=new _previous2.default(this);this.Cardsall=new _cardsall2.default(this);(0,_mobx.autorun)(function(){_this.currency=_appStore2.default.financeData;_this.currencyId=_appStore2.default.currency_id;});}_createClass(TotoStore,[{key:'selectCurrency',value:function selectCurrency(v){this.currencyId=v;}},{key:'setResult',value:function setResult(text,type){this.result.status=1;this.result.text=text;this.result.type=type?type:0;}},{key:'clearResult',value:function clearResult(){this.result.status=0;this.result.text='';this.result.type=0;}// @action initPage(route) {
// 	this.isLoading = 0;
// 	switch(route) {
// 		case 'toto':
// 			this.Toto.init();
// 			break;
// 		case 'bet':
// 			this.Bet.init();
// 			break;
// 	}
// }
},{key:'current',get:function get(){return this.currency[this.currencyId];}}]);return TotoStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'currencyId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'currency',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{status:0,text:'',type:0};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'Toto',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'Bet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'Result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'Cards',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'Previous',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'Cardsall',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'selectCurrency',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectCurrency'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'current',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'current'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setResult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearResult',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearResult'),_class.prototype)),_class);exports.default=new TotoStore();

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _accountStore=__webpack_require__(45);var _accountStore2=_interopRequireDefault(_accountStore);var _appStore=__webpack_require__(37);var _appStore2=_interopRequireDefault(_appStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TotoStore=(_class=function(){function TotoStore(store,account,app){var _this=this;_classCallCheck(this,TotoStore);_initDefineProp(this,'isLoading',_descriptor,this);_initDefineProp(this,'dict',_descriptor2,this);_initDefineProp(this,'data',_descriptor3,this);_initDefineProp(this,'currencyId',_descriptor4,this);_initDefineProp(this,'success',_descriptor5,this);_initDefineProp(this,'dataBet',_descriptor6,this);_initDefineProp(this,'showWarning',_descriptor7,this);_initDefineProp(this,'amount',_descriptor8,this);this.count=0;_initDefineProp(this,'list',_descriptor9,this);this.store=null;this.account=null;this.app=null;this.isValidBet=function(){var isValid=true;if(_this.account.access==0){_this.store.setResult('AUTH_ERROR');isValid=false;}else if(_this.count==0){_this.store.setResult('TOTO_ERROR_COUNT');isValid=false;}else if(_this.currencyId!=_this.app.currency_id){_this.store.setResult('TOTO_ERROR_CURRENCY');isValid=false;}else if(_this.amount.current==0||_this.amount.current.length===0){_this.store.setResult('EMPTY_AMOUNT');document.getElementById('toto-amount').focus();isValid=false;}else if(_this.amount.current<_this.amount.min){_this.store.setResult('LOW_AMOUNT');isValid=false;}return isValid;};this.store=store;this.account=account;this.app=app;}_createClass(TotoStore,[{key:'init',value:function init(){this.store.isLoading=0;this.reset();this.getData();}},{key:'reset',value:function reset(){this.data='';this.success='';this.clearAll();this.store.clearResult();}},{key:'selectCurrency',value:function selectCurrency(v){this.currencyId=v;this.showWarning=this.app.currency_id!=this.currencyId;this.calc();}},{key:'clearOdds',value:function clearOdds(){var _this2=this;var manual=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;this.list.keys().forEach(function(k){if(_this2.list.get(k).manual<=manual){_this2.list.get(k).manual=0;_this2.list.get(k).o.fill(0);}});}},{key:'clearAll',value:function clearAll(){this.clearOdds(1);this.amount.current='';this.amount.per_option='',this.amount.min=0;this.count=0;}},{key:'hideSuccess',value:function hideSuccess(){this.success='';}},{key:'checkOdd',value:function checkOdd(id,el,indx){var manual=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;if(manual>=this.list.get(id).manual){this.list.get(id).manual=el?manual:0;this.list.get(id).o[indx]=el;}this.calc();}},{key:'random',value:function random(){var _this3=this;var manual=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;this.clearOdds(manual);this.list.keys().forEach(function(i){_this3.checkOdd(i,1,Math.floor(Math.random()*3),manual);});}},{key:'generateCheck',value:function generateCheck(){var _this4=this;Object.keys(this.data.games).forEach(function(id){var i={};i['manual']=0;i['o']=[];for(var j=1;j<4;j++){i.o.push(0);}_this4.list.set(id,i);});}},{key:'getData',value:function getData(){var _this5=this;_api2.default.toto.getData().then((0,_mobx.action)(function(data){if(data.code=="OK"){_this5.data=data.result;_this5.currencyId=String(data.result.currency_id);_this5.generateCheck();_this5.amount.min=_this5.currency.min;}})).catch((0,_mobx.action)(function(err){_this5.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this5.store.isLoading=1;}));}},{key:'calc',value:function calc(){var _this6=this;var cnt=void 0;var count=1;this.list.keys().forEach(function(i){cnt=0;_this6.list.get(i).o.forEach(function(v){cnt+=v;});count*=cnt;});this.count=count;if(count>0){this.calcHTML();}else{this.amount.min=this.currency.min;}}},{key:'inputAmount',value:function inputAmount(val){var number=val.replace(/[^.\d]+/g,"").replace(/^([^\.]*\.)|\./g,'$1');if(number.toString().length>0){this.amount.current=number;}else{this.amount.current='';}this.calc();}},{key:'copy',value:function copy(){this.amount.current=this.amount.min;this.calc();}},{key:'calcHTML',value:function calcHTML(){this.amount.min=this.currency.min*this.count;this.amount.per_option=Math.round(this.amount.current/this.count*100)/100;}},{key:'dobet',value:function dobet(){var _this7=this;this.store.clearResult();if(!this.isValidBet()){return Promise.resolve();}var bet={};var data={action:'dobet',count:this.count,amount:this.amount.current,cid:this.currencyId,id:this.data.id};var outcome=['1','X','2'];Object.keys(this.data.games).forEach(function(i){bet[_this7.data.games[i].line_id]={};for(var j=0;j<3;j++){bet[_this7.data.games[i].line_id][outcome[j]]=_this7.list.get(i).o[j];}});data['bet']=bet;return _api2.default.toto.doBet(data).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this7.success=data.result;}else{_this7.store.setResult(data.text?data.text:'SERVER_TEMPORARILY_DOWN');}})).catch((0,_mobx.action)(function(err){_this7.store.setResult('SERVER_TEMPORARILY_DOWN');}));}},{key:'currency',get:function get(){return this.data.currency[this.currencyId];}}]);return TotoStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'dict',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'currencyId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'success',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dataBet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'showWarning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'amount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{current:0,min:0,per_option:''};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'list',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Map();}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectCurrency',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectCurrency'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currency',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'currency'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearOdds',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearOdds'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearAll',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'clearAll'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hideSuccess',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'hideSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkOdd',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkOdd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'random',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'random'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'generateCheck',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'generateCheck'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'calc',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'calc'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inputAmount',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'inputAmount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'copy',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'copy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'calcHTML',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'calcHTML'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dobet',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'dobet'),_class.prototype)),_class);exports.default=TotoStore;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import accountStore from '../accountStore';
// import appStore from '../appStore';
var Bet=(_class=function(){function Bet(store){_classCallCheck(this,Bet);this.store=null;_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);this.store=store;}_createClass(Bet,[{key:'init',value:function init(id){this.store.isLoading=0;this.getData(id);}},{key:'getData',value:function getData(id){var _this=this;_api2.default.toto.getBet(id).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.data=data.result;}})).catch((0,_mobx.action)(function(err){_this.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.store.isLoading=1;}));}}]);return Bet;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype)),_class);exports.default=Bet;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import accountStore from '../accountStore';
// import appStore from '../appStore';
var Result=(_class=function(){function Result(store){_classCallCheck(this,Result);this.store=null;_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);this.store=store;}_createClass(Result,[{key:'init',value:function init(id){this.store.isLoading=0;this.getData(id);}},{key:'getData',value:function getData(id){var _this=this;_api2.default.toto.getResult(id).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.data=data.result;}})).catch((0,_mobx.action)(function(err){_this.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.store.isLoading=1;}));}}]);return Result;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype)),_class);exports.default=Result;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import accountStore from '../accountStore';
// import appStore from '../appStore';
var Cards=(_class=function(){function Cards(store){_classCallCheck(this,Cards);this.store=null;_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);_initDefineProp(this,'count',_descriptor3,this);_initDefineProp(this,'page',_descriptor4,this);_initDefineProp(this,'pages',_descriptor5,this);_initDefineProp(this,'cards',_descriptor6,this);_initDefineProp(this,'vc',_descriptor7,this);_initDefineProp(this,'id',_descriptor8,this);this.store=store;}_createClass(Cards,[{key:'init',value:function init(params){this.store.isLoading=0;this.vc=params.vc?params.vc:0;this.id=params.cardId?params.cardId:0;this.getData();}},{key:'dispose',value:function dispose(){this.id=0;this.pages=[];this.page=0;this.vc=0;}},{key:'getData',value:function getData(more){var _this=this;if(more)this.isLoading=1;_api2.default.toto.getCards({id:this.id,vc:this.vc,page:this.page,count:this.count}).then((0,_mobx.action)(function(data){if(data.code=="OK"){if(more){_this.cards[_this.page]=data.result.cards;}else{_this.data=data.result;_this.cards[_this.page]=data.result.cards;_this.generatePage();}}})).catch((0,_mobx.action)(function(err){_this.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){if(more){_this.isLoading=0;}else{_this.store.isLoading=1;}}));}},{key:'generatePage',value:function generatePage(){var maxPage=Math.ceil(this.data.count/this.count);for(var i=0;i<maxPage;i++){this.pages.push({i:i,load:i==0?1:0});}}},{key:'selectPage',value:function selectPage(page){if(this.page!=page){this.page=page;var i=this.pages.findIndex(function(item){return item.i==page;});if(!this.pages[i].load){this.pages[i].load=1;this.getData(1);}}}}]);return Cards;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'count',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 100;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'page',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'pages',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'cards',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'vc',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'id',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dispose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'dispose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'generatePage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'generatePage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectPage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectPage'),_class.prototype)),_class);exports.default=Cards;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);var _moment=__webpack_require__(34);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import accountStore from '../accountStore';
// import appStore from '../appStore';
var Previous=(_class=function(){function Previous(store){_classCallCheck(this,Previous);this.store=null;_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'isLoading',_descriptor2,this);_initDefineProp(this,'selected',_descriptor3,this);this.store=store;}_createClass(Previous,[{key:'init',value:function init(params){this.store.isLoading=0;this.getData();}},{key:'dispose',value:function dispose(){}},{key:'selectYear',value:function selectYear(v){if(this.selected.year!=v){this.selected.year=v;if(v==2008)this.selected.month=12;if(!this.data.date_menu[v][this.selected.month]){var arr=Object.keys(this.data.date_menu[v]);this.selected.month=arr[arr.length-1];}}}},{key:'selectMonth',value:function selectMonth(v){if(this.selected.year!=v){this.selected.month=v;}}},{key:'getData',value:function getData(more){var _this=this;_api2.default.toto.getPrevious().then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.data=data.result;_this.selected.month=data.result.month?data.result.month:(0,_moment2.default)().month()+1;_this.selected.year=data.result.year?data.result.year:(0,_moment2.default)().year();}})).catch((0,_mobx.action)(function(err){_this.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.store.isLoading=1;}));}},{key:'draw',get:function get(){return this.data.date_menu[this.selected.year][this.selected.month];}}]);return Previous;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'selected',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{month:(0,_moment2.default)().month()+1,year:(0,_moment2.default)().year()};}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dispose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'dispose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectYear',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectYear'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'draw',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'draw'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectMonth',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectMonth'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype)),_class);exports.default=Previous;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(5);var _mobx2=_interopRequireDefault(_mobx);var _api=__webpack_require__(8);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import accountStore from '../accountStore';
// import appStore from '../appStore';
var Cardsall=(_class=function(){function Cardsall(store){_classCallCheck(this,Cardsall);this.store=null;_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'pageData',_descriptor2,this);_initDefineProp(this,'isLoading',_descriptor3,this);_initDefineProp(this,'page',_descriptor4,this);_initDefineProp(this,'id',_descriptor5,this);_initDefineProp(this,'pages',_descriptor6,this);this.store=store;}_createClass(Cardsall,[{key:'init',value:function init(params){this.id=params.cardId||0;this.page=params.page||'';this.store.isLoading=0;this.getData();}},{key:'dispose',value:function dispose(){this.page='';}},{key:'selectPage',value:function selectPage(v){this.getPageData(v);}},{key:'getData',value:function getData(){var _this=this;_api2.default.toto.getCardsAll({id:this.id,page:this.page}).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this.data=data.result;_this.pages=data.result.pages.split('');}})).catch((0,_mobx.action)(function(err){_this.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this.store.isLoading=1;}));}},{key:'getPageData',value:function getPageData(v){var _this2=this;this.isLoading=1;_api2.default.toto.getCardsPage({id:this.id,page:v}).then((0,_mobx.action)(function(data){if(data.code=="OK"){_this2.pageData=data.result;_this2.page=v;}else{_this2.pageData='';}})).catch((0,_mobx.action)(function(err){_this2.store.setResult('SERVER_TEMPORARILY_DOWN');})).finally((0,_mobx.action)(function(){_this2.isLoading=0;}));}}]);return Cardsall;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'pageData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'page',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'id',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'pages',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dispose',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'dispose'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'selectPage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'selectPage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getPageData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getPageData'),_class.prototype)),_class);exports.default=Cardsall;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7866bf0c.js